import { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Int64: any;
};

export type AccessoriesCheck = {
  __typename?: 'AccessoriesCheck';
  accessory?: Maybe<Accessory>;
  id: Scalars['ID'];
  status: AccessoriesStatus;
};

export type AccessoriesCheckAggregateResult = {
  __typename?: 'AccessoriesCheckAggregateResult';
  count?: Maybe<Scalars['Int']>;
};

export type AccessoriesCheckFilter = {
  and?: InputMaybe<Array<InputMaybe<AccessoriesCheckFilter>>>;
  has?: InputMaybe<Array<InputMaybe<AccessoriesCheckHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<AccessoriesCheckFilter>;
  or?: InputMaybe<Array<InputMaybe<AccessoriesCheckFilter>>>;
};

export enum AccessoriesCheckHasFilter {
  Accessory = 'accessory',
  Status = 'status'
}

export type AccessoriesCheckListWithStage = {
  __typename?: 'AccessoriesCheckListWithStage';
  backLeftTyre?: Maybe<AccessoryStatus>;
  backRightTyre?: Maybe<AccessoryStatus>;
  battery?: Maybe<AccessoryStatus>;
  bumper?: Maybe<AccessoryStatus>;
  drawbar?: Maybe<AccessoryStatus>;
  frontLeftTyre?: Maybe<AccessoryStatus>;
  frontRightTyre?: Maybe<AccessoryStatus>;
  hood?: Maybe<AccessoryStatus>;
  id: Scalars['ID'];
  regNo: Scalars['String'];
  stage: ImageStage;
  toplink?: Maybe<AccessoryStatus>;
};

export type AccessoriesCheckListWithStageAggregateResult = {
  __typename?: 'AccessoriesCheckListWithStageAggregateResult';
  count?: Maybe<Scalars['Int']>;
  regNoMax?: Maybe<Scalars['String']>;
  regNoMin?: Maybe<Scalars['String']>;
};

export type AccessoriesCheckListWithStageFilter = {
  and?: InputMaybe<Array<InputMaybe<AccessoriesCheckListWithStageFilter>>>;
  has?: InputMaybe<Array<InputMaybe<AccessoriesCheckListWithStageHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<AccessoriesCheckListWithStageFilter>;
  or?: InputMaybe<Array<InputMaybe<AccessoriesCheckListWithStageFilter>>>;
  regNo?: InputMaybe<StringTermFilter>;
  stage?: InputMaybe<ImageStage_Hash>;
};

export enum AccessoriesCheckListWithStageHasFilter {
  BackLeftTyre = 'backLeftTyre',
  BackRightTyre = 'backRightTyre',
  Battery = 'battery',
  Bumper = 'bumper',
  Drawbar = 'drawbar',
  FrontLeftTyre = 'frontLeftTyre',
  FrontRightTyre = 'frontRightTyre',
  Hood = 'hood',
  RegNo = 'regNo',
  Stage = 'stage',
  Toplink = 'toplink'
}

export type AccessoriesCheckListWithStageOrder = {
  asc?: InputMaybe<AccessoriesCheckListWithStageOrderable>;
  desc?: InputMaybe<AccessoriesCheckListWithStageOrderable>;
  then?: InputMaybe<AccessoriesCheckListWithStageOrder>;
};

export enum AccessoriesCheckListWithStageOrderable {
  RegNo = 'regNo'
}

export type AccessoriesCheckListWithStagePatch = {
  backLeftTyre?: InputMaybe<AccessoryStatus>;
  backRightTyre?: InputMaybe<AccessoryStatus>;
  battery?: InputMaybe<AccessoryStatus>;
  bumper?: InputMaybe<AccessoryStatus>;
  drawbar?: InputMaybe<AccessoryStatus>;
  frontLeftTyre?: InputMaybe<AccessoryStatus>;
  frontRightTyre?: InputMaybe<AccessoryStatus>;
  hood?: InputMaybe<AccessoryStatus>;
  regNo?: InputMaybe<Scalars['String']>;
  stage?: InputMaybe<ImageStage>;
  toplink?: InputMaybe<AccessoryStatus>;
};

export type AccessoriesCheckListWithStageRef = {
  backLeftTyre?: InputMaybe<AccessoryStatus>;
  backRightTyre?: InputMaybe<AccessoryStatus>;
  battery?: InputMaybe<AccessoryStatus>;
  bumper?: InputMaybe<AccessoryStatus>;
  drawbar?: InputMaybe<AccessoryStatus>;
  frontLeftTyre?: InputMaybe<AccessoryStatus>;
  frontRightTyre?: InputMaybe<AccessoryStatus>;
  hood?: InputMaybe<AccessoryStatus>;
  id?: InputMaybe<Scalars['ID']>;
  regNo?: InputMaybe<Scalars['String']>;
  stage?: InputMaybe<ImageStage>;
  toplink?: InputMaybe<AccessoryStatus>;
};

export type AccessoriesCheckPatch = {
  accessory?: InputMaybe<Accessory>;
  status?: InputMaybe<AccessoriesStatus>;
};

export type AccessoriesCheckRef = {
  accessory?: InputMaybe<Accessory>;
  id?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<AccessoriesStatus>;
};

export type AccessoriesChecklist = {
  __typename?: 'AccessoriesChecklist';
  by?: Maybe<User>;
  checks?: Maybe<Array<AccessoriesCheck>>;
  checksAggregate?: Maybe<AccessoriesCheckAggregateResult>;
  id: Scalars['ID'];
  remarks?: Maybe<Scalars['String']>;
  stage?: Maybe<ImageStage>;
};


export type AccessoriesChecklistByArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type AccessoriesChecklistChecksArgs = {
  filter?: InputMaybe<AccessoriesCheckFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type AccessoriesChecklistChecksAggregateArgs = {
  filter?: InputMaybe<AccessoriesCheckFilter>;
};

export type AccessoriesChecklistAggregateResult = {
  __typename?: 'AccessoriesChecklistAggregateResult';
  count?: Maybe<Scalars['Int']>;
  remarksMax?: Maybe<Scalars['String']>;
  remarksMin?: Maybe<Scalars['String']>;
};

export type AccessoriesChecklistFilter = {
  and?: InputMaybe<Array<InputMaybe<AccessoriesChecklistFilter>>>;
  has?: InputMaybe<Array<InputMaybe<AccessoriesChecklistHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<AccessoriesChecklistFilter>;
  or?: InputMaybe<Array<InputMaybe<AccessoriesChecklistFilter>>>;
};

export enum AccessoriesChecklistHasFilter {
  By = 'by',
  Checks = 'checks',
  Remarks = 'remarks',
  Stage = 'stage'
}

export type AccessoriesChecklistOrder = {
  asc?: InputMaybe<AccessoriesChecklistOrderable>;
  desc?: InputMaybe<AccessoriesChecklistOrderable>;
  then?: InputMaybe<AccessoriesChecklistOrder>;
};

export enum AccessoriesChecklistOrderable {
  Remarks = 'remarks'
}

export type AccessoriesChecklistPatch = {
  by?: InputMaybe<UserRef>;
  checks?: InputMaybe<Array<AccessoriesCheckRef>>;
  remarks?: InputMaybe<Scalars['String']>;
  stage?: InputMaybe<ImageStage>;
};

export type AccessoriesChecklistRef = {
  by?: InputMaybe<UserRef>;
  checks?: InputMaybe<Array<AccessoriesCheckRef>>;
  id?: InputMaybe<Scalars['ID']>;
  remarks?: InputMaybe<Scalars['String']>;
  stage?: InputMaybe<ImageStage>;
};

export enum AccessoriesStatus {
  Absent = 'ABSENT',
  NeedsReplacement = 'NEEDS_REPLACEMENT',
  Ok = 'OK'
}

export enum Accessory {
  BackLeftTyre = 'BACK_LEFT_TYRE',
  BackRightTyre = 'BACK_RIGHT_TYRE',
  Battery = 'BATTERY',
  Bumper = 'BUMPER',
  Drawbar = 'DRAWBAR',
  FrontLeftTyre = 'FRONT_LEFT_TYRE',
  FrontRightTyre = 'FRONT_RIGHT_TYRE',
  Hood = 'HOOD',
  Toplink = 'TOPLINK'
}

export enum AccessoryStatus {
  Absent = 'ABSENT',
  NeedsReplacement = 'NEEDS_REPLACEMENT',
  Ok = 'OK'
}

export enum ActionType {
  Create = 'CREATE',
  Delete = 'DELETE',
  Update = 'UPDATE'
}

export type ActiveStateWithGstn = {
  __typename?: 'ActiveStateWithGSTN';
  GSTNumber?: Maybe<Scalars['String']>;
  RTOCode?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  state: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActiveStateWithGstnAggregateResult = {
  __typename?: 'ActiveStateWithGSTNAggregateResult';
  GSTNumberMax?: Maybe<Scalars['String']>;
  GSTNumberMin?: Maybe<Scalars['String']>;
  RTOCodeMax?: Maybe<Scalars['String']>;
  RTOCodeMin?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  createdAtMax?: Maybe<Scalars['DateTime']>;
  createdAtMin?: Maybe<Scalars['DateTime']>;
  stateMax?: Maybe<Scalars['String']>;
  stateMin?: Maybe<Scalars['String']>;
  updatedAtMax?: Maybe<Scalars['DateTime']>;
  updatedAtMin?: Maybe<Scalars['DateTime']>;
};

export type ActiveStateWithGstnFilter = {
  active?: InputMaybe<Scalars['Boolean']>;
  and?: InputMaybe<Array<InputMaybe<ActiveStateWithGstnFilter>>>;
  has?: InputMaybe<Array<InputMaybe<ActiveStateWithGstnHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<ActiveStateWithGstnFilter>;
  or?: InputMaybe<Array<InputMaybe<ActiveStateWithGstnFilter>>>;
  state?: InputMaybe<StringFullTextFilter_StringHashFilter_StringRegExpFilter_StringTermFilter>;
};

export enum ActiveStateWithGstnHasFilter {
  GstNumber = 'GSTNumber',
  RtoCode = 'RTOCode',
  Active = 'active',
  CreatedAt = 'createdAt',
  State = 'state',
  UpdatedAt = 'updatedAt'
}

export type ActiveStateWithGstnOrder = {
  asc?: InputMaybe<ActiveStateWithGstnOrderable>;
  desc?: InputMaybe<ActiveStateWithGstnOrderable>;
  then?: InputMaybe<ActiveStateWithGstnOrder>;
};

export enum ActiveStateWithGstnOrderable {
  GstNumber = 'GSTNumber',
  RtoCode = 'RTOCode',
  CreatedAt = 'createdAt',
  State = 'state',
  UpdatedAt = 'updatedAt'
}

export type ActiveStateWithGstnPatch = {
  GSTNumber?: InputMaybe<Scalars['String']>;
  RTOCode?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ActiveStateWithGstnRef = {
  GSTNumber?: InputMaybe<Scalars['String']>;
  RTOCode?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AddAccessoriesCheckInput = {
  accessory?: InputMaybe<Accessory>;
  status: AccessoriesStatus;
};

export type AddAccessoriesCheckListWithStageInput = {
  backLeftTyre?: InputMaybe<AccessoryStatus>;
  backRightTyre?: InputMaybe<AccessoryStatus>;
  battery?: InputMaybe<AccessoryStatus>;
  bumper?: InputMaybe<AccessoryStatus>;
  drawbar?: InputMaybe<AccessoryStatus>;
  frontLeftTyre?: InputMaybe<AccessoryStatus>;
  frontRightTyre?: InputMaybe<AccessoryStatus>;
  hood?: InputMaybe<AccessoryStatus>;
  regNo: Scalars['String'];
  stage: ImageStage;
  toplink?: InputMaybe<AccessoryStatus>;
};

export type AddAccessoriesCheckListWithStagePayload = {
  __typename?: 'AddAccessoriesCheckListWithStagePayload';
  accessoriesCheckListWithStage?: Maybe<Array<Maybe<AccessoriesCheckListWithStage>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddAccessoriesCheckListWithStagePayloadAccessoriesCheckListWithStageArgs = {
  filter?: InputMaybe<AccessoriesCheckListWithStageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<AccessoriesCheckListWithStageOrder>;
};

export type AddAccessoriesCheckPayload = {
  __typename?: 'AddAccessoriesCheckPayload';
  accessoriesCheck?: Maybe<Array<Maybe<AccessoriesCheck>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddAccessoriesCheckPayloadAccessoriesCheckArgs = {
  filter?: InputMaybe<AccessoriesCheckFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type AddAccessoriesChecklistInput = {
  by?: InputMaybe<UserRef>;
  checks?: InputMaybe<Array<AccessoriesCheckRef>>;
  remarks?: InputMaybe<Scalars['String']>;
  stage?: InputMaybe<ImageStage>;
};

export type AddAccessoriesChecklistPayload = {
  __typename?: 'AddAccessoriesChecklistPayload';
  accessoriesChecklist?: Maybe<Array<Maybe<AccessoriesChecklist>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddAccessoriesChecklistPayloadAccessoriesChecklistArgs = {
  filter?: InputMaybe<AccessoriesChecklistFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<AccessoriesChecklistOrder>;
};

export type AddActiveStateWithGstnInput = {
  GSTNumber?: InputMaybe<Scalars['String']>;
  RTOCode?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  state: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AddActiveStateWithGstnPayload = {
  __typename?: 'AddActiveStateWithGSTNPayload';
  activeStateWithGSTN?: Maybe<Array<Maybe<ActiveStateWithGstn>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddActiveStateWithGstnPayloadActiveStateWithGstnArgs = {
  filter?: InputMaybe<ActiveStateWithGstnFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ActiveStateWithGstnOrder>;
};

export type AddAdminLeadStatusEventInput = {
  createdAt: Scalars['DateTime'];
  createdBy: UserRef;
  lead: LeadRef;
  notification?: InputMaybe<NotificationRef>;
  notifyTo?: InputMaybe<Array<InputMaybe<UserRole>>>;
  status: LeadStatus;
};

export type AddAdminLeadStatusEventPayload = {
  __typename?: 'AddAdminLeadStatusEventPayload';
  adminLeadStatusEvent?: Maybe<Array<Maybe<AdminLeadStatusEvent>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddAdminLeadStatusEventPayloadAdminLeadStatusEventArgs = {
  filter?: InputMaybe<AdminLeadStatusEventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<AdminLeadStatusEventOrder>;
};

export type AddAgencyInput = {
  leads?: InputMaybe<Array<InputMaybe<LeadRef>>>;
  name: Scalars['String'];
  spocNo?: InputMaybe<Scalars['String']>;
};

export type AddAgencyPayload = {
  __typename?: 'AddAgencyPayload';
  agency?: Maybe<Array<Maybe<Agency>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddAgencyPayloadAgencyArgs = {
  filter?: InputMaybe<AgencyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<AgencyOrder>;
};

export type AddAuctionHistoryInput = {
  amount?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AddAuctionHistoryPayload = {
  __typename?: 'AddAuctionHistoryPayload';
  auctionHistory?: Maybe<Array<Maybe<AuctionHistory>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddAuctionHistoryPayloadAuctionHistoryArgs = {
  filter?: InputMaybe<AuctionHistoryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<AuctionHistoryOrder>;
};

export type AddBankAuctionLeadCountByNameInput = {
  approvalRecived?: InputMaybe<Scalars['String']>;
  bankName?: InputMaybe<Scalars['String']>;
  vahanChecked?: InputMaybe<Scalars['String']>;
  vehicleInAuction?: InputMaybe<Scalars['String']>;
  wonInAuction?: InputMaybe<Scalars['String']>;
};

export type AddBankAuctionLeadCountByNamePayload = {
  __typename?: 'AddBankAuctionLeadCountByNamePayload';
  bankAuctionLeadCountByName?: Maybe<Array<Maybe<BankAuctionLeadCountByName>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddBankAuctionLeadCountByNamePayloadBankAuctionLeadCountByNameArgs = {
  filter?: InputMaybe<BankAuctionLeadCountByNameFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<BankAuctionLeadCountByNameOrder>;
};

export type AddBankInput = {
  leads?: InputMaybe<Array<InputMaybe<LeadRef>>>;
  name: Scalars['String'];
  spocNo?: InputMaybe<Scalars['String']>;
};

export type AddBankPayload = {
  __typename?: 'AddBankPayload';
  bank?: Maybe<Array<Maybe<Bank>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddBankPayloadBankArgs = {
  filter?: InputMaybe<BankFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<BankOrder>;
};

export type AddBookingInput = {
  activeLoan?: InputMaybe<LoanRef>;
  archivedLoans?: InputMaybe<Array<InputMaybe<LoanRef>>>;
  bookingPayment?: InputMaybe<BookingPaymentRef>;
  cancellationReason?: InputMaybe<BookingCancellationReason>;
  cancellationRemarks?: InputMaybe<Scalars['String']>;
  cancelledChequeUrl?: InputMaybe<Scalars['String']>;
  cheque?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customer: CustomerRef;
  deliveryForm?: InputMaybe<Scalars['String']>;
  deliveryPhotoUrl?: InputMaybe<Scalars['String']>;
  isInsuranceReq?: InputMaybe<Scalars['Boolean']>;
  isLoanDrop?: InputMaybe<Scalars['Boolean']>;
  isRCTransferReq?: InputMaybe<Scalars['Boolean']>;
  lead?: InputMaybe<LeadRef>;
  leadWithActiveBooking?: InputMaybe<LeadRef>;
  leadWithArchivedBooking?: InputMaybe<LeadRef>;
  loanCancellationReason?: InputMaybe<LoanRejectionReason>;
  payments?: InputMaybe<Array<InputMaybe<PaymentRef>>>;
  searchString?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<BookingStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vehicleTransferFormUrl?: InputMaybe<Scalars['String']>;
};

export type AddBookingPayload = {
  __typename?: 'AddBookingPayload';
  booking?: Maybe<Array<Maybe<Booking>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddBookingPayloadBookingArgs = {
  filter?: InputMaybe<BookingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<BookingOrder>;
};

export type AddBookingPaymentInput = {
  appliedLoanAmount?: InputMaybe<Scalars['Int']>;
  booking: BookingRef;
  bookingPaymentMode?: InputMaybe<BookingType>;
  bookingType?: InputMaybe<BookingType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  insuranceAmount?: InputMaybe<Scalars['Int']>;
  rcTransferAmount?: InputMaybe<Scalars['Int']>;
  saleAmount: Scalars['Int'];
  totalSaleAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AddBookingPaymentPayload = {
  __typename?: 'AddBookingPaymentPayload';
  bookingPayment?: Maybe<Array<Maybe<BookingPayment>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddBookingPaymentPayloadBookingPaymentArgs = {
  filter?: InputMaybe<BookingPaymentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<BookingPaymentOrder>;
};

export type AddBrandInput = {
  brand_id: Scalars['Int'];
  models?: InputMaybe<Array<InputMaybe<ModelRef>>>;
  name: Scalars['String'];
};

export type AddBrandPayload = {
  __typename?: 'AddBrandPayload';
  brand?: Maybe<Array<Maybe<Brand>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddBrandPayloadBrandArgs = {
  filter?: InputMaybe<BrandFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<BrandOrder>;
};

export type AddBulkApprovalResponseInput = {
  bankConfirmationStatus?: InputMaybe<Scalars['String']>;
  bidStatus?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  failureReason?: InputMaybe<Scalars['String']>;
  finalBidAmount?: InputMaybe<Scalars['Int']>;
  processingStatus?: InputMaybe<Scalars['String']>;
  proposedBidAmount?: InputMaybe<Scalars['Int']>;
  regNo?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};

export type AddBulkApprovalResponsePayload = {
  __typename?: 'AddBulkApprovalResponsePayload';
  bulkApprovalResponse?: Maybe<Array<Maybe<BulkApprovalResponse>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddBulkApprovalResponsePayloadBulkApprovalResponseArgs = {
  filter?: InputMaybe<BulkApprovalResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<BulkApprovalResponseOrder>;
};

export type AddCenterlizeLocationDistrcitsResponseInput = {
  data?: InputMaybe<Array<InputMaybe<CenterlizeLocationDistrictRef>>>;
  msg?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type AddCenterlizeLocationDistrcitsResponsePayload = {
  __typename?: 'AddCenterlizeLocationDistrcitsResponsePayload';
  centerlizeLocationDistrcitsResponse?: Maybe<Array<Maybe<CenterlizeLocationDistrcitsResponse>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddCenterlizeLocationDistrcitsResponsePayloadCenterlizeLocationDistrcitsResponseArgs = {
  filter?: InputMaybe<CenterlizeLocationDistrcitsResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CenterlizeLocationDistrcitsResponseOrder>;
};

export type AddCenterlizeLocationDistrictInput = {
  district_id?: InputMaybe<Scalars['Int']>;
  district_name?: InputMaybe<Scalars['String']>;
  state_id?: InputMaybe<Scalars['Int']>;
  state_name?: InputMaybe<Scalars['String']>;
  tr_district_id?: InputMaybe<Scalars['Int']>;
  tr_state_id?: InputMaybe<Scalars['Int']>;
};

export type AddCenterlizeLocationDistrictPayload = {
  __typename?: 'AddCenterlizeLocationDistrictPayload';
  centerlizeLocationDistrict?: Maybe<Array<Maybe<CenterlizeLocationDistrict>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddCenterlizeLocationDistrictPayloadCenterlizeLocationDistrictArgs = {
  filter?: InputMaybe<CenterlizeLocationDistrictFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CenterlizeLocationDistrictOrder>;
};

export type AddCenterlizeLocationStatesInput = {
  GSTNumber?: InputMaybe<Scalars['String']>;
  state_code?: InputMaybe<Scalars['String']>;
  state_id?: InputMaybe<Scalars['Int']>;
  state_name?: InputMaybe<Scalars['String']>;
  tr_state_id?: InputMaybe<Scalars['Int']>;
};

export type AddCenterlizeLocationStatesPayload = {
  __typename?: 'AddCenterlizeLocationStatesPayload';
  centerlizeLocationStates?: Maybe<Array<Maybe<CenterlizeLocationStates>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddCenterlizeLocationStatesPayloadCenterlizeLocationStatesArgs = {
  filter?: InputMaybe<CenterlizeLocationStatesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CenterlizeLocationStatesOrder>;
};

export type AddCenterlizeLocationStatesResponseInput = {
  data?: InputMaybe<Array<InputMaybe<CenterlizeLocationStatesRef>>>;
  msg?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type AddCenterlizeLocationStatesResponsePayload = {
  __typename?: 'AddCenterlizeLocationStatesResponsePayload';
  centerlizeLocationStatesResponse?: Maybe<Array<Maybe<CenterlizeLocationStatesResponse>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddCenterlizeLocationStatesResponsePayloadCenterlizeLocationStatesResponseArgs = {
  filter?: InputMaybe<CenterlizeLocationStatesResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CenterlizeLocationStatesResponseOrder>;
};

export type AddCenterlizeLocationTehsilInput = {
  district_id?: InputMaybe<Scalars['Int']>;
  district_name?: InputMaybe<Scalars['String']>;
  state_id?: InputMaybe<Scalars['Int']>;
  state_name?: InputMaybe<Scalars['String']>;
  tehsil_id?: InputMaybe<Scalars['Int']>;
  tehsil_name?: InputMaybe<Scalars['String']>;
  tr_district_id?: InputMaybe<Scalars['Int']>;
  tr_state_id?: InputMaybe<Scalars['Int']>;
  tr_tehsil_id?: InputMaybe<Scalars['Int']>;
};

export type AddCenterlizeLocationTehsilPayload = {
  __typename?: 'AddCenterlizeLocationTehsilPayload';
  centerlizeLocationTehsil?: Maybe<Array<Maybe<CenterlizeLocationTehsil>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddCenterlizeLocationTehsilPayloadCenterlizeLocationTehsilArgs = {
  filter?: InputMaybe<CenterlizeLocationTehsilFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CenterlizeLocationTehsilOrder>;
};

export type AddCenterlizeLocationTehsilResponseInput = {
  data?: InputMaybe<Array<InputMaybe<CenterlizeLocationTehsilRef>>>;
  msg?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type AddCenterlizeLocationTehsilResponsePayload = {
  __typename?: 'AddCenterlizeLocationTehsilResponsePayload';
  centerlizeLocationTehsilResponse?: Maybe<Array<Maybe<CenterlizeLocationTehsilResponse>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddCenterlizeLocationTehsilResponsePayloadCenterlizeLocationTehsilResponseArgs = {
  filter?: InputMaybe<CenterlizeLocationTehsilResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CenterlizeLocationTehsilResponseOrder>;
};

export type AddCentreAggregatesInput = {
  bookedVehiclesCount?: InputMaybe<Scalars['Int']>;
  centreId?: InputMaybe<Scalars['String']>;
  centreName?: InputMaybe<Scalars['String']>;
  inStockVehiclesCount?: InputMaybe<Scalars['Int']>;
  soldAndDeliveredVehicleCount?: InputMaybe<Scalars['Int']>;
  totalInventory?: InputMaybe<Scalars['Int']>;
};

export type AddCentreAggregatesPayload = {
  __typename?: 'AddCentreAggregatesPayload';
  centreAggregates?: Maybe<Array<Maybe<CentreAggregates>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddCentreAggregatesPayloadCentreAggregatesArgs = {
  filter?: InputMaybe<CentreAggregatesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CentreAggregatesOrder>;
};

export type AddCentreInput = {
  TJCentre?: InputMaybe<TjCentreRef>;
  address?: InputMaybe<Scalars['String']>;
  capacity?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  district?: InputMaybe<Scalars['String']>;
  employees?: InputMaybe<Array<InputMaybe<UserRef>>>;
  incharge?: InputMaybe<UserRef>;
  issues?: InputMaybe<Array<InputMaybe<IssueRef>>>;
  leads?: InputMaybe<Array<InputMaybe<LeadRef>>>;
  location?: InputMaybe<PointRef>;
  managedBy?: InputMaybe<Array<InputMaybe<UserRef>>>;
  name: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  pincode?: InputMaybe<Scalars['Int']>;
  purchases?: InputMaybe<Array<InputMaybe<PurchaseRef>>>;
  regNo?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CenterStatus>;
  tehsil?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AddCentrePayload = {
  __typename?: 'AddCentrePayload';
  centre?: Maybe<Array<Maybe<Centre>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddCentrePayloadCentreArgs = {
  filter?: InputMaybe<CentreFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CentreOrder>;
};

export type AddCityInput = {
  name: Scalars['String'];
};

export type AddCityPayload = {
  __typename?: 'AddCityPayload';
  city?: Maybe<Array<Maybe<City>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddCityPayloadCityArgs = {
  filter?: InputMaybe<CityFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CityOrder>;
};

export type AddCreateBulkLeadResponseInput = {
  auctionByBank?: InputMaybe<Scalars['String']>;
  chassisNumber?: InputMaybe<Scalars['String']>;
  createById?: InputMaybe<Scalars['String']>;
  demandAmount?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  engineNumber?: InputMaybe<Scalars['String']>;
  failureReason?: InputMaybe<Scalars['String']>;
  hoursMeter?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  manufacturingDate?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  ownershipType?: InputMaybe<Scalars['String']>;
  processingStatus?: InputMaybe<Scalars['String']>;
  regNo?: InputMaybe<Scalars['String']>;
  registrationState?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type AddCreateBulkLeadResponsePayload = {
  __typename?: 'AddCreateBulkLeadResponsePayload';
  createBulkLeadResponse?: Maybe<Array<Maybe<CreateBulkLeadResponse>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddCreateBulkLeadResponsePayloadCreateBulkLeadResponseArgs = {
  filter?: InputMaybe<CreateBulkLeadResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CreateBulkLeadResponseOrder>;
};

export type AddCustomerInput = {
  bookings?: InputMaybe<Array<InputMaybe<BookingRef>>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerDistrict?: InputMaybe<DistrictRef>;
  customerId?: InputMaybe<CustomerId>;
  customerState?: InputMaybe<StateCodeWithRegNumberRef>;
  customerTehsil?: InputMaybe<TehsilRef>;
  district?: InputMaybe<Scalars['String']>;
  enquiries?: InputMaybe<Array<InputMaybe<EnquiryRef>>>;
  enquiry?: InputMaybe<EnquiryRef>;
  idNumber?: InputMaybe<Scalars['String']>;
  idProofUrl?: InputMaybe<Scalars['String']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentRef>;
  name?: InputMaybe<Scalars['String']>;
  phoneNo: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
  tehsil?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AddCustomerPayload = {
  __typename?: 'AddCustomerPayload';
  customer?: Maybe<Array<Maybe<Customer>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddCustomerPayloadCustomerArgs = {
  filter?: InputMaybe<CustomerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CustomerOrder>;
};

export type AddDealerInput = {
  leads?: InputMaybe<Array<InputMaybe<LeadRef>>>;
  name?: InputMaybe<Scalars['String']>;
  phoneNo: Scalars['String'];
};

export type AddDealerPayload = {
  __typename?: 'AddDealerPayload';
  dealer?: Maybe<Array<Maybe<Dealer>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddDealerPayloadDealerArgs = {
  filter?: InputMaybe<DealerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DealerOrder>;
};

export type AddDealerStanceInput = {
  clearBlackList?: InputMaybe<Scalars['Boolean']>;
  clearChallan?: InputMaybe<Scalars['Boolean']>;
  clearHSRP?: InputMaybe<Scalars['Boolean']>;
  lead: LeadRef;
};

export type AddDealerStancePayload = {
  __typename?: 'AddDealerStancePayload';
  dealerStance?: Maybe<Array<Maybe<DealerStance>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddDealerStancePayloadDealerStanceArgs = {
  filter?: InputMaybe<DealerStanceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type AddDealershipDocumentInput = {
  approvalMailUrl?: InputMaybe<DocumentRef>;
  bankNOC?: InputMaybe<DocumentRef>;
  blacklist?: InputMaybe<DocumentRef>;
  challanUrl?: InputMaybe<DocumentRef>;
  form26?: InputMaybe<DocumentRef>;
  form28?: InputMaybe<DocumentRef>;
  form29?: InputMaybe<DocumentRef>;
  form30?: InputMaybe<DocumentRef>;
  form35?: InputMaybe<DocumentRef>;
  form36?: InputMaybe<DocumentRef>;
  form60?: InputMaybe<DocumentRef>;
  form60_sellerPan?: InputMaybe<DocumentRef>;
  hsrbProofUrl?: InputMaybe<DocumentRef>;
  hypothecationProofUrl?: InputMaybe<DocumentRef>;
  insuranceCertificate?: InputMaybe<DocumentRef>;
  lead: LeadRef;
  loanForeclosure?: InputMaybe<DocumentRef>;
  ownerAddressProof?: InputMaybe<DocumentRef>;
  regNo: Scalars['String'];
  registrationCertificate?: InputMaybe<DocumentRef>;
  rtoVerificationProofUrl?: InputMaybe<DocumentRef>;
  sellerAadharCard?: InputMaybe<DocumentRef>;
  sellerPAN?: InputMaybe<DocumentRef>;
};

export type AddDealershipDocumentPayload = {
  __typename?: 'AddDealershipDocumentPayload';
  dealershipDocument?: Maybe<Array<Maybe<DealershipDocument>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddDealershipDocumentPayloadDealershipDocumentArgs = {
  filter?: InputMaybe<DealershipDocumentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DealershipDocumentOrder>;
};

export type AddDealershipLeadCountByPeNameInput = {
  dealClosedCount?: InputMaybe<Scalars['String']>;
  leadCreatedCount?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  priceRecivedCount?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type AddDealershipLeadCountByPeNamePayload = {
  __typename?: 'AddDealershipLeadCountByPENamePayload';
  dealershipLeadCountByPEName?: Maybe<Array<Maybe<DealershipLeadCountByPeName>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddDealershipLeadCountByPeNamePayloadDealershipLeadCountByPeNameArgs = {
  filter?: InputMaybe<DealershipLeadCountByPeNameFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DealershipLeadCountByPeNameOrder>;
};

export type AddDistrictInput = {
  code?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  state?: InputMaybe<StateCodeWithRegNumberRef>;
  tehsils?: InputMaybe<Array<InputMaybe<TehsilRef>>>;
};

export type AddDistrictPayload = {
  __typename?: 'AddDistrictPayload';
  district?: Maybe<Array<Maybe<District>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddDistrictPayloadDistrictArgs = {
  filter?: InputMaybe<DistrictFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DistrictOrder>;
};

export type AddDocumentChecklistInput = {
  bankNOC?: InputMaybe<Scalars['Boolean']>;
  form26?: InputMaybe<Scalars['Boolean']>;
  form28?: InputMaybe<Scalars['Boolean']>;
  form29?: InputMaybe<Scalars['Boolean']>;
  form30?: InputMaybe<Scalars['Boolean']>;
  form35?: InputMaybe<Scalars['Boolean']>;
  form36?: InputMaybe<Scalars['Boolean']>;
  form60?: InputMaybe<Scalars['Boolean']>;
  form60_sellerPan?: InputMaybe<Scalars['Boolean']>;
  indemnityBond?: InputMaybe<Scalars['Boolean']>;
  insuranceCertificate?: InputMaybe<Scalars['Boolean']>;
  lead: LeadRef;
  loanForeclosure?: InputMaybe<Scalars['Boolean']>;
  ownerAddressProof?: InputMaybe<Scalars['Boolean']>;
  regNo: Scalars['String'];
  registrationCertificate?: InputMaybe<Scalars['Boolean']>;
  releaseOrder?: InputMaybe<Scalars['Boolean']>;
  sellerAadharCard?: InputMaybe<Scalars['Boolean']>;
  sellerPAN?: InputMaybe<Scalars['Boolean']>;
};

export type AddDocumentChecklistPayload = {
  __typename?: 'AddDocumentChecklistPayload';
  documentChecklist?: Maybe<Array<Maybe<DocumentChecklist>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddDocumentChecklistPayloadDocumentChecklistArgs = {
  filter?: InputMaybe<DocumentChecklistFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DocumentChecklistOrder>;
};

export type AddDocumentInput = {
  expectedDate?: InputMaybe<Scalars['DateTime']>;
  isAvailable?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
};

export type AddDocumentPayload = {
  __typename?: 'AddDocumentPayload';
  document?: Maybe<Array<Maybe<Document>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddDocumentPayloadDocumentArgs = {
  filter?: InputMaybe<DocumentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DocumentOrder>;
};

export type AddDocumentsCountInput = {
  pending?: InputMaybe<Scalars['Int']>;
  received?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Int']>;
};

export type AddDocumentsCountPayload = {
  __typename?: 'AddDocumentsCountPayload';
  documentsCount?: Maybe<Array<Maybe<DocumentsCount>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddDocumentsCountPayloadDocumentsCountArgs = {
  filter?: InputMaybe<DocumentsCountFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DocumentsCountOrder>;
};

export type AddDocumentsFollowupsInput = {
  actionType?: InputMaybe<ActionType>;
  documentName?: InputMaybe<Scalars['String']>;
  followedUpBy: UserRef;
  followupDate?: InputMaybe<Scalars['DateTime']>;
  lead: LeadRef;
  nextFollowupDate?: InputMaybe<Scalars['DateTime']>;
  remarks?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};

export type AddDocumentsFollowupsPayload = {
  __typename?: 'AddDocumentsFollowupsPayload';
  documentsFollowups?: Maybe<Array<Maybe<DocumentsFollowups>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddDocumentsFollowupsPayloadDocumentsFollowupsArgs = {
  filter?: InputMaybe<DocumentsFollowupsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DocumentsFollowupsOrder>;
};

export type AddDriverAggregatesInput = {
  assignedPickupsAcceptedCount?: InputMaybe<Scalars['Int']>;
  assignedPickupsCount?: InputMaybe<Scalars['Int']>;
  assignedPickupsDeliveredCount?: InputMaybe<Scalars['Int']>;
  assignedPickupsInTransitCount?: InputMaybe<Scalars['Int']>;
  assignedPickupsRejectedOrWithdrawnCount?: InputMaybe<Scalars['Int']>;
  driverName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type AddDriverAggregatesPayload = {
  __typename?: 'AddDriverAggregatesPayload';
  driverAggregates?: Maybe<Array<Maybe<DriverAggregates>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddDriverAggregatesPayloadDriverAggregatesArgs = {
  filter?: InputMaybe<DriverAggregatesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DriverAggregatesOrder>;
};

export type AddEnquiryAdherenceInput = {
  AdhirenceRatio?: InputMaybe<Scalars['Int']>;
  AvgAging?: InputMaybe<Scalars['Int']>;
  centre?: InputMaybe<CentreRef>;
  closedFollowups?: InputMaybe<Scalars['Int']>;
  totalClosed?: InputMaybe<Scalars['Int']>;
  totalEnquiry?: InputMaybe<Scalars['Int']>;
  totalFollowups?: InputMaybe<Scalars['Int']>;
  totalOpen?: InputMaybe<Scalars['Int']>;
};

export type AddEnquiryAdherencePayload = {
  __typename?: 'AddEnquiryAdherencePayload';
  enquiryAdherence?: Maybe<Array<Maybe<EnquiryAdherence>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddEnquiryAdherencePayloadEnquiryAdherenceArgs = {
  filter?: InputMaybe<EnquiryAdherenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<EnquiryAdherenceOrder>;
};

export type AddEnquiryAggByCentreInput = {
  centre?: InputMaybe<CentreRef>;
  coldEnquiryCloser?: InputMaybe<EnquiryCloserAggRef>;
  hotEnquiryCloser?: InputMaybe<EnquiryCloserAggRef>;
  totalCold?: InputMaybe<Scalars['Int']>;
  totalHot?: InputMaybe<Scalars['Int']>;
  totalWarm?: InputMaybe<Scalars['Int']>;
  warmEnquiryCloser?: InputMaybe<EnquiryCloserAggRef>;
};

export type AddEnquiryAggByCentrePayload = {
  __typename?: 'AddEnquiryAggByCentrePayload';
  enquiryAggByCentre?: Maybe<Array<Maybe<EnquiryAggByCentre>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddEnquiryAggByCentrePayloadEnquiryAggByCentreArgs = {
  filter?: InputMaybe<EnquiryAggByCentreFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<EnquiryAggByCentreOrder>;
};

export type AddEnquiryCloserAggInput = {
  closed?: InputMaybe<Scalars['Int']>;
  infollowUp?: InputMaybe<Scalars['Int']>;
  notIntrested?: InputMaybe<Scalars['Int']>;
  notResponding?: InputMaybe<Scalars['Int']>;
  purchaseNewTractor?: InputMaybe<Scalars['Int']>;
  purchasedUsedTractor?: InputMaybe<Scalars['Int']>;
  tractorBooked?: InputMaybe<Scalars['Int']>;
};

export type AddEnquiryCloserAggPayload = {
  __typename?: 'AddEnquiryCloserAggPayload';
  enquiryCloserAgg?: Maybe<Array<Maybe<EnquiryCloserAgg>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddEnquiryCloserAggPayloadEnquiryCloserAggArgs = {
  filter?: InputMaybe<EnquiryCloserAggFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<EnquiryCloserAggOrder>;
};

export type AddEnquiryClosureInput = {
  centre?: InputMaybe<CentreRef>;
  enquiryCloseReason?: InputMaybe<CloseEnquiryReason>;
  purchaseFrom?: InputMaybe<PurchaseTractorFrom>;
  purchasePrice?: InputMaybe<Scalars['Int']>;
  purchaseProduct?: InputMaybe<ModelByMakeRef>;
  regNo?: InputMaybe<Scalars['String']>;
  remarks?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

export type AddEnquiryClosurePayload = {
  __typename?: 'AddEnquiryClosurePayload';
  enquiryClosure?: Maybe<Array<Maybe<EnquiryClosure>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddEnquiryClosurePayloadEnquiryClosureArgs = {
  filter?: InputMaybe<EnquiryClosureFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<EnquiryClosureOrder>;
};

export type AddEnquiryInput = {
  budget?: InputMaybe<Scalars['Int']>;
  centre: CentreRef;
  createdAt: Scalars['DateTime'];
  createdBy?: InputMaybe<UserRef>;
  customer: CustomerRef;
  customerPhoneNo: Scalars['String'];
  enquiryClosure?: InputMaybe<EnquiryClosureRef>;
  enquiryType?: InputMaybe<EnquiryType>;
  followups?: InputMaybe<Array<InputMaybe<FollowupRef>>>;
  interestedIn?: InputMaybe<Array<InputMaybe<ModelRef>>>;
  interestedInProducts?: InputMaybe<Array<InputMaybe<ModelByMakeRef>>>;
  isClosed?: InputMaybe<Scalars['Boolean']>;
  lastVisitDate?: InputMaybe<Scalars['DateTime']>;
  searchString?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<EnquiryStatus>;
  tentativePurchaseTime?: InputMaybe<TentativePurchaseTime>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedBy?: InputMaybe<UserRef>;
};

export type AddEnquiryPayload = {
  __typename?: 'AddEnquiryPayload';
  enquiry?: Maybe<Array<Maybe<Enquiry>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddEnquiryPayloadEnquiryArgs = {
  filter?: InputMaybe<EnquiryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<EnquiryOrder>;
};

export type AddFollowupInput = {
  enquiry: EnquiryRef;
  followedUpBy: UserRef;
  followupDate: Scalars['DateTime'];
  /** the date */
  isWalkin?: InputMaybe<Scalars['Boolean']>;
  nextFollowup?: InputMaybe<FollowupRef>;
  previousFollowup?: InputMaybe<FollowupRef>;
  remarks?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<EnquiryStatus>;
};

export type AddFollowupPayload = {
  __typename?: 'AddFollowupPayload';
  followup?: Maybe<Array<Maybe<Followup>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddFollowupPayloadFollowupArgs = {
  filter?: InputMaybe<FollowupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<FollowupOrder>;
};

export type AddIdByNameInput = {
  brand_id?: InputMaybe<Scalars['Int']>;
  district_id?: InputMaybe<Scalars['Int']>;
  engine_capacity?: InputMaybe<Scalars['String']>;
  horse_power?: InputMaybe<Scalars['String']>;
  model_id?: InputMaybe<Scalars['Int']>;
  state_id?: InputMaybe<Scalars['Int']>;
  tahsil_id?: InputMaybe<Scalars['Int']>;
};

export type AddIdByNamePayload = {
  __typename?: 'AddIdByNamePayload';
  idByName?: Maybe<Array<Maybe<IdByName>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddIdByNamePayloadIdByNameArgs = {
  filter?: InputMaybe<IdByNameFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<IdByNameOrder>;
};

export type AddIdentificationDocumentInput = {
  aadhaarBackPhotoUrl?: InputMaybe<Scalars['String']>;
  aadhaarFrontPhotoUrl?: InputMaybe<Scalars['String']>;
  aadhaarNumber?: InputMaybe<Scalars['String']>;
  customer?: InputMaybe<CustomerRef>;
  panNumber?: InputMaybe<Scalars['String']>;
  panPhotoUrl?: InputMaybe<Scalars['String']>;
  voterIdNumber?: InputMaybe<Scalars['String']>;
  voterIdPhotoUrl?: InputMaybe<Scalars['String']>;
};

export type AddIdentificationDocumentPayload = {
  __typename?: 'AddIdentificationDocumentPayload';
  identificationDocument?: Maybe<Array<Maybe<IdentificationDocument>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddIdentificationDocumentPayloadIdentificationDocumentArgs = {
  filter?: InputMaybe<IdentificationDocumentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<IdentificationDocumentOrder>;
};

export type AddIdsByNameForListingReponseInput = {
  data?: InputMaybe<IdByNameRef>;
  message?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type AddIdsByNameForListingReponsePayload = {
  __typename?: 'AddIdsByNameForListingReponsePayload';
  idsByNameForListingReponse?: Maybe<Array<Maybe<IdsByNameForListingReponse>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddIdsByNameForListingReponsePayloadIdsByNameForListingReponseArgs = {
  filter?: InputMaybe<IdsByNameForListingReponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<IdsByNameForListingReponseOrder>;
};

export type AddInventoryDetailsInput = {
  /** This id should be the same as centre id */
  id: Scalars['String'];
  items?: InputMaybe<Array<InputMaybe<ItemInventoryDetailsRef>>>;
};

export type AddInventoryDetailsPayload = {
  __typename?: 'AddInventoryDetailsPayload';
  inventoryDetails?: Maybe<Array<Maybe<InventoryDetails>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddInventoryDetailsPayloadInventoryDetailsArgs = {
  filter?: InputMaybe<InventoryDetailsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<InventoryDetailsOrder>;
};

export type AddIssueInput = {
  approvedBy?: InputMaybe<UserRef>;
  centre: CentreRef;
  createdAt: Scalars['DateTime'];
  items?: InputMaybe<Array<InputMaybe<IssueItemRef>>>;
  madeBy: UserRef;
  refurbishment?: InputMaybe<RefurbishmentRequestRef>;
  regNo?: InputMaybe<Scalars['String']>;
  requestedItemId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<IssueStatus>;
  totalPrice?: InputMaybe<Scalars['Int']>;
};

export type AddIssueItemInput = {
  description?: InputMaybe<Scalars['String']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  issue: IssueRef;
  price?: InputMaybe<Scalars['Int']>;
  product: ProductRef;
  quantity?: InputMaybe<Scalars['Int']>;
  requestedItemId?: InputMaybe<Scalars['String']>;
};

export type AddIssueItemPayload = {
  __typename?: 'AddIssueItemPayload';
  issueItem?: Maybe<Array<Maybe<IssueItem>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddIssueItemPayloadIssueItemArgs = {
  filter?: InputMaybe<IssueItemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<IssueItemOrder>;
};

export type AddIssuePayload = {
  __typename?: 'AddIssuePayload';
  issue?: Maybe<Array<Maybe<Issue>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddIssuePayloadIssueArgs = {
  filter?: InputMaybe<IssueFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<IssueOrder>;
};

export type AddItemInventoryDetailsInput = {
  availableInStock?: InputMaybe<Scalars['Int']>;
  avgUnitPrice?: InputMaybe<Scalars['String']>;
  consumed?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** This id should be the same as product id */
  id: Scalars['String'];
  issueQueue?: InputMaybe<Scalars['Int']>;
  product?: InputMaybe<ProductRef>;
  purchaseQueue?: InputMaybe<Scalars['Int']>;
  totalPrice?: InputMaybe<Scalars['Int']>;
  totalPurchase?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AddItemInventoryDetailsPayload = {
  __typename?: 'AddItemInventoryDetailsPayload';
  itemInventoryDetails?: Maybe<Array<Maybe<ItemInventoryDetails>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddItemInventoryDetailsPayloadItemInventoryDetailsArgs = {
  filter?: InputMaybe<ItemInventoryDetailsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ItemInventoryDetailsOrder>;
};

export type AddLeadCountByStatusInput = {
  count?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<LeadStatus>;
};

export type AddLeadCountByStatusPayload = {
  __typename?: 'AddLeadCountByStatusPayload';
  leadCountByStatus?: Maybe<Array<Maybe<LeadCountByStatus>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddLeadCountByStatusPayloadLeadCountByStatusArgs = {
  filter?: InputMaybe<LeadCountByStatusFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadCountByStatusOrder>;
};

export type AddLeadDocumentsInput = {
  bankAccountProofUrl?: InputMaybe<Scalars['String']>;
  bankNOC?: InputMaybe<Scalars['String']>;
  dealPaymentProofUrl?: InputMaybe<Scalars['String']>;
  form26?: InputMaybe<Scalars['String']>;
  form28?: InputMaybe<Scalars['String']>;
  form29?: InputMaybe<Scalars['String']>;
  form30?: InputMaybe<Scalars['String']>;
  form35?: InputMaybe<Scalars['String']>;
  form36?: InputMaybe<Scalars['String']>;
  form60?: InputMaybe<Scalars['String']>;
  form60_sellerPan?: InputMaybe<Scalars['String']>;
  indemnityBond?: InputMaybe<Scalars['String']>;
  insuranceCertificate?: InputMaybe<Scalars['String']>;
  lead: LeadRef;
  loanForeclosure?: InputMaybe<Scalars['String']>;
  ownerAddressProof?: InputMaybe<Scalars['String']>;
  parkingPaymentProofUrl?: InputMaybe<Scalars['String']>;
  regNo: Scalars['String'];
  registrationCertificate?: InputMaybe<Scalars['String']>;
  releaseOrder?: InputMaybe<Scalars['String']>;
  sellerAadharCard?: InputMaybe<Scalars['String']>;
  sellerPAN?: InputMaybe<Scalars['String']>;
};

export type AddLeadDocumentsPayload = {
  __typename?: 'AddLeadDocumentsPayload';
  leadDocuments?: Maybe<Array<Maybe<LeadDocuments>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddLeadDocumentsPayloadLeadDocumentsArgs = {
  filter?: InputMaybe<LeadDocumentsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadDocumentsOrder>;
};

export type AddLeadExpenseInput = {
  belongsTo?: InputMaybe<TripExpenseRef>;
  category: ExpenseCategory;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserRef>;
  description?: InputMaybe<Scalars['String']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  lead?: InputMaybe<LeadRef>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  receiptUrl?: InputMaybe<Scalars['String']>;
  spentAmount: Scalars['String'];
};

export type AddLeadExpensePayload = {
  __typename?: 'AddLeadExpensePayload';
  leadExpense?: Maybe<Array<Maybe<LeadExpense>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddLeadExpensePayloadLeadExpenseArgs = {
  filter?: InputMaybe<LeadExpenseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadExpenseOrder>;
};

export type AddLeadInput = {
  accessories?: InputMaybe<Array<InputMaybe<AccessoriesCheckListWithStageRef>>>;
  accessoriesChecklist?: InputMaybe<Array<InputMaybe<AccessoriesChecklistRef>>>;
  activeBooking?: InputMaybe<BookingRef>;
  actualParkingCharges?: InputMaybe<Scalars['Int']>;
  actualPickupDate?: InputMaybe<Scalars['DateTime']>;
  approvedDealAmount?: InputMaybe<Scalars['Int']>;
  approvedParkingChargesFor?: InputMaybe<UserRole>;
  archivedBookings?: InputMaybe<Array<InputMaybe<BookingRef>>>;
  auctionByBank?: InputMaybe<BankName>;
  auctionHistory?: InputMaybe<Array<InputMaybe<AuctionHistoryRef>>>;
  auctioningAgency?: InputMaybe<AgencyRef>;
  auctioningBank?: InputMaybe<BankRef>;
  bookings?: InputMaybe<Array<InputMaybe<BookingRef>>>;
  centre?: InputMaybe<CentreRef>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserRef>;
  dealer?: InputMaybe<DealerRef>;
  dealerStance?: InputMaybe<DealerStanceRef>;
  dealershipDocuments?: InputMaybe<DealershipDocumentRef>;
  deliveredSelfieUrl?: InputMaybe<Scalars['String']>;
  deliveryAmount?: InputMaybe<Scalars['Int']>;
  deliveryCentre?: InputMaybe<CentreRef>;
  demandAmount?: InputMaybe<Scalars['Int']>;
  documentCharges?: InputMaybe<Scalars['Int']>;
  documentChecklist?: InputMaybe<DocumentChecklistRef>;
  documents?: InputMaybe<LeadDocumentsRef>;
  documentsFollowups?: InputMaybe<Array<InputMaybe<DocumentsFollowupsRef>>>;
  estimatedParkingCharges?: InputMaybe<Scalars['Float']>;
  expectedPickupDate?: InputMaybe<Scalars['DateTime']>;
  expenses?: InputMaybe<Array<InputMaybe<LeadExpenseRef>>>;
  expensesCoveredIn?: InputMaybe<Array<InputMaybe<TripExpenseRef>>>;
  finalBidAmount?: InputMaybe<Scalars['Int']>;
  finalParkingCharges?: InputMaybe<Scalars['Int']>;
  holdbackAmount?: InputMaybe<Scalars['Int']>;
  internalTransfers?: InputMaybe<Array<InputMaybe<VehicleTransferLogRef>>>;
  listingOnWebUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  listingPrice?: InputMaybe<Scalars['Int']>;
  listingStatus?: InputMaybe<ListingStatus>;
  listingUpdatedBy?: InputMaybe<UserRef>;
  loanAmount?: InputMaybe<Scalars['Int']>;
  loanToBeClosedBy?: InputMaybe<LoanToBeClosedBy>;
  ownershipType?: InputMaybe<Ownership>;
  parkingBeneficiary?: InputMaybe<ParkingBeneficiaryRef>;
  payInParts?: InputMaybe<Scalars['Boolean']>;
  paymentType?: InputMaybe<PaymentType>;
  payments?: InputMaybe<Array<InputMaybe<PaymentRef>>>;
  pickup?: InputMaybe<PickupRef>;
  proposedBidLimitAmount?: InputMaybe<Scalars['Int']>;
  proposedDealAmount?: InputMaybe<Scalars['Int']>;
  refurbishmentDetails?: InputMaybe<RefurbishmentDetailsRef>;
  regNo: Scalars['String'];
  registrationState?: InputMaybe<Scalars['String']>;
  searchString?: InputMaybe<Scalars['String']>;
  sellingPrice?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<LeadSource>;
  status?: InputMaybe<LeadBusinessStatus>;
  statusEvents?: InputMaybe<Array<InputMaybe<LeadStatusEventRef>>>;
  tokenAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedBy?: InputMaybe<UserRef>;
  vehicle: VehicleRef;
  yard?: InputMaybe<YardRef>;
  yardPerDayParkingCharges?: InputMaybe<Scalars['Float']>;
  yardPerDayParkingChargesByDriver?: InputMaybe<Scalars['Float']>;
};

export type AddLeadPayload = {
  __typename?: 'AddLeadPayload';
  lead?: Maybe<Array<Maybe<Lead>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddLeadPayloadLeadArgs = {
  filter?: InputMaybe<LeadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadOrder>;
};

export type AddLeadStatusEventInput = {
  assignTaskTo?: InputMaybe<UserRole>;
  createdAt: Scalars['DateTime'];
  createdBy: UserRef;
  deviceType?: InputMaybe<DeviceType>;
  /** This field tells whether the task is completed or not. Task is usually completed when the next desired status is punched. */
  isTaskCompleted?: InputMaybe<Scalars['Boolean']>;
  lead: LeadRef;
  metadata?: InputMaybe<Scalars['String']>;
  next?: InputMaybe<LeadStatusEventRef>;
  notification?: InputMaybe<NotificationRef>;
  notifyTo?: InputMaybe<Array<InputMaybe<UserRole>>>;
  postTimeline?: InputMaybe<Scalars['String']>;
  preTimeline?: InputMaybe<Scalars['String']>;
  previous?: InputMaybe<LeadStatusEventRef>;
  remarks?: InputMaybe<Scalars['String']>;
  status: LeadStatus;
  task?: InputMaybe<TaskRef>;
  taskButtonTitle?: InputMaybe<Scalars['String']>;
  taskTitle?: InputMaybe<Scalars['String']>;
};

export type AddLeadStatusEventPayload = {
  __typename?: 'AddLeadStatusEventPayload';
  leadStatusEvent?: Maybe<Array<Maybe<LeadStatusEvent>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddLeadStatusEventPayloadLeadStatusEventArgs = {
  filter?: InputMaybe<LeadStatusEventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadStatusEventOrder>;
};

export type AddLeadStatusFlowInput = {
  /** User role that is responsible for the task. Task completion leads to next status */
  assignTaskTo?: InputMaybe<UserRole>;
  /** If the user can go back from this status to previous */
  canGoBack?: InputMaybe<Scalars['Boolean']>;
  /** Flag to take the user directly to the next form */
  canGoForward?: InputMaybe<Scalars['Boolean']>;
  /** New: CTA */
  cta?: InputMaybe<Scalars['String']>;
  /** Current status of the lead */
  current?: InputMaybe<LeadStatus>;
  /** New: Desired Status */
  desired?: InputMaybe<LeadStatus>;
  freshLeadTimelineAction?: InputMaybe<LeadTimelineActionRef>;
  /** New: Hide form */
  hideForm?: InputMaybe<Scalars['Boolean']>;
  /** Flag to not display undesired button - could be temporary */
  hideUndesiredButton?: InputMaybe<Scalars['Boolean']>;
  /** If the current status is a negative action */
  isNegativeCase?: InputMaybe<Scalars['Boolean']>;
  /** Next status of the lead */
  next?: InputMaybe<LeadStatus>;
  /** Notification text. Delimiters are underscores for fields to be filled in */
  notificationTitle?: InputMaybe<Scalars['String']>;
  /** User roles which should be notified at this status */
  notifyTo?: InputMaybe<Array<InputMaybe<UserRole>>>;
  /** New : Popup Description */
  popupDescription?: InputMaybe<Scalars['String']>;
  /** New : Popup Title */
  popupTitle?: InputMaybe<Scalars['String']>;
  /** Previous status of the lead */
  previous?: InputMaybe<LeadStatus>;
  rejectedLeadTimelineAction?: InputMaybe<LeadTimelineActionRef>;
  /** New: Show popup */
  showPopup?: InputMaybe<Scalars['Boolean']>;
  /** New : flag to show Remark input in popup */
  showPopupRemark?: InputMaybe<Scalars['Boolean']>;
  /** Flag to show popup with input fields */
  showPopupWithInputField?: InputMaybe<Scalars['Boolean']>;
  /** Source of this lead */
  source?: InputMaybe<LeadSource>;
  /** Text for action button for the task. Delimiters are underscores for fields to be filled in */
  taskButtonTitle?: InputMaybe<Scalars['String']>;
  /** Title for button for action on form if exists */
  taskFormActionTitle?: InputMaybe<Scalars['String']>;
  /** Title for button for negative action like cancel, reject etc. on form */
  taskFormNegativeActionTitle?: InputMaybe<Scalars['String']>;
  /** New: Task performed by */
  taskPerformedBy?: InputMaybe<UserRole>;
  /** Title for the task that needs to be done next. Delimiters are underscores for fields to be filled in */
  taskTitle?: InputMaybe<Scalars['String']>;
  /** New: task title was */
  taskTitleWas?: InputMaybe<Scalars['String']>;
  /** New: Undesired Status */
  undesired?: InputMaybe<LeadStatus>;
};

export type AddLeadStatusFlowPayload = {
  __typename?: 'AddLeadStatusFlowPayload';
  leadStatusFlow?: Maybe<Array<Maybe<LeadStatusFlow>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddLeadStatusFlowPayloadLeadStatusFlowArgs = {
  filter?: InputMaybe<LeadStatusFlowFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadStatusFlowOrder>;
};

export type AddLeadTimelineActionInput = {
  postAction?: InputMaybe<Scalars['String']>;
  preAction?: InputMaybe<Scalars['String']>;
};

export type AddLeadTimelineActionPayload = {
  __typename?: 'AddLeadTimelineActionPayload';
  leadTimelineAction?: Maybe<Array<Maybe<LeadTimelineAction>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddLeadTimelineActionPayloadLeadTimelineActionArgs = {
  filter?: InputMaybe<LeadTimelineActionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadTimelineActionOrder>;
};

export type AddLoanInput = {
  appliedLoanAmount?: InputMaybe<Scalars['Int']>;
  bankName?: InputMaybe<BankName>;
  booking?: InputMaybe<BookingRef>;
  bookingWithArchivedLoan?: InputMaybe<BookingRef>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deliveryOrderDate?: InputMaybe<Scalars['DateTime']>;
  deliveryOrderDocUrl?: InputMaybe<Scalars['String']>;
  deliveryOrderStatus?: InputMaybe<LoanStatus>;
  deliveryOrderValidity?: InputMaybe<Scalars['Int']>;
  fieldInspectionConfirmedDate?: InputMaybe<Scalars['DateTime']>;
  fieldInspectionDate?: InputMaybe<Scalars['DateTime']>;
  fieldInspectionStatus?: InputMaybe<LoanStatus>;
  loanCancelReason?: InputMaybe<LoanRejectionReason>;
  /** login Details */
  loanStage?: InputMaybe<LoanStage>;
  loanStatus: LoanStatus;
  loginApplicationFormUrl?: InputMaybe<Scalars['String']>;
  loginDate?: InputMaybe<Scalars['DateTime']>;
  loginStatus?: InputMaybe<LoanStatus>;
  rejectedAt?: InputMaybe<LoanStage>;
  rejectionReason?: InputMaybe<LoanRejectionReason>;
  sanctionedLoanAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AddLoanPayload = {
  __typename?: 'AddLoanPayload';
  loan?: Maybe<Array<Maybe<Loan>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddLoanPayloadLoanArgs = {
  filter?: InputMaybe<LoanFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LoanOrder>;
};

export type AddLogTrackingInput = {
  actionType: ActionType;
  createdAt: Scalars['DateTime'];
  module: ModuleType;
  previousValue: Scalars['String'];
  source: DeviceType;
  sourceUpdated: Scalars['String'];
  status?: InputMaybe<TaskStatus>;
  taskPerformedBy: UserRef;
  updatedValue: Scalars['String'];
};

export type AddLogTrackingPayload = {
  __typename?: 'AddLogTrackingPayload';
  logTracking?: Maybe<Array<Maybe<LogTracking>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddLogTrackingPayloadLogTrackingArgs = {
  filter?: InputMaybe<LogTrackingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LogTrackingOrder>;
};

export type AddMarkSoldResponseInput = {
  message?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type AddMarkSoldResponsePayload = {
  __typename?: 'AddMarkSoldResponsePayload';
  markSoldResponse?: Maybe<Array<Maybe<MarkSoldResponse>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddMarkSoldResponsePayloadMarkSoldResponseArgs = {
  filter?: InputMaybe<MarkSoldResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<MarkSoldResponseOrder>;
};

export type AddMessageInput = {
  createdAt: Scalars['DateTime'];
  readBy?: InputMaybe<Array<InputMaybe<UserRef>>>;
  sentBy?: InputMaybe<UserRef>;
  text: Scalars['String'];
};

export type AddMessagePayload = {
  __typename?: 'AddMessagePayload';
  message?: Maybe<Array<Maybe<Message>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddMessagePayloadMessageArgs = {
  filter?: InputMaybe<MessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<MessageOrder>;
};

export type AddModelByMakeInput = {
  id?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
};

export type AddModelByMakePayload = {
  __typename?: 'AddModelByMakePayload';
  modelByMake?: Maybe<Array<Maybe<ModelByMake>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddModelByMakePayloadModelByMakeArgs = {
  filter?: InputMaybe<ModelByMakeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ModelByMakeOrder>;
};

export type AddModelInput = {
  brand: BrandRef;
  model_id: Scalars['Int'];
  name: Scalars['String'];
};

export type AddModelPayload = {
  __typename?: 'AddModelPayload';
  model?: Maybe<Array<Maybe<Model>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddModelPayloadModelArgs = {
  filter?: InputMaybe<ModelFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ModelOrder>;
};

export type AddNotificationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  forUsers?: InputMaybe<Array<InputMaybe<UserRef>>>;
  leadStatusEvent: LeadStatusEventRef;
  remarks?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type AddNotificationPayload = {
  __typename?: 'AddNotificationPayload';
  notification?: Maybe<Array<Maybe<Notification>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AddNotificationPayloadNotificationArgs = {
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<NotificationOrder>;
};

export type AddNumberOfPendingTasksInput = {
  count: Scalars['Int'];
};

export type AddNumberOfPendingTasksPayload = {
  __typename?: 'AddNumberOfPendingTasksPayload';
  numUids?: Maybe<Scalars['Int']>;
  numberOfPendingTasks?: Maybe<Array<Maybe<NumberOfPendingTasks>>>;
};


export type AddNumberOfPendingTasksPayloadNumberOfPendingTasksArgs = {
  filter?: InputMaybe<NumberOfPendingTasksFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<NumberOfPendingTasksOrder>;
};

export type AddParkingBeneficiaryInput = {
  accountHolderName: Scalars['String'];
  accountNumber: Scalars['String'];
  bankName?: InputMaybe<BankName>;
  ifscCode: Scalars['String'];
  leads?: InputMaybe<Array<InputMaybe<LeadRef>>>;
  proofUrl?: InputMaybe<Scalars['String']>;
  upiId?: InputMaybe<Scalars['String']>;
};

export type AddParkingBeneficiaryPayload = {
  __typename?: 'AddParkingBeneficiaryPayload';
  numUids?: Maybe<Scalars['Int']>;
  parkingBeneficiary?: Maybe<Array<Maybe<ParkingBeneficiary>>>;
};


export type AddParkingBeneficiaryPayloadParkingBeneficiaryArgs = {
  filter?: InputMaybe<ParkingBeneficiaryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ParkingBeneficiaryOrder>;
};

export type AddPaymentInput = {
  accountHolderName?: InputMaybe<Scalars['String']>;
  accountNo?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['Int']>;
  bankName?: InputMaybe<BankName>;
  booking?: InputMaybe<BookingRef>;
  by: UserRef;
  confirmedBy?: InputMaybe<UserRef>;
  createdAt: Scalars['DateTime'];
  dealerStance?: InputMaybe<DealerStanceRef>;
  for: PaymentFor;
  ifsc?: InputMaybe<Scalars['String']>;
  invoice?: InputMaybe<PaymentInvoicesRef>;
  lead?: InputMaybe<LeadRef>;
  loanClosedBy?: InputMaybe<LoanToBeClosedBy>;
  mode?: InputMaybe<PaymentMethod>;
  modeFM?: InputMaybe<PaymentMethod>;
  parkingBeneficiary?: InputMaybe<ParkingBeneficiaryRef>;
  paymentProcessedAt?: InputMaybe<Scalars['DateTime']>;
  paymentTo?: InputMaybe<PaymentTo>;
  proofUrl?: InputMaybe<Scalars['String']>;
  purchase?: InputMaybe<PurchaseRef>;
  receiptUrl?: InputMaybe<Scalars['String']>;
  reconciliationStatus?: InputMaybe<PaymentReconciliationStatus>;
  refurbishmentBeneficiary?: InputMaybe<RefurbishmentBeneficiaryRef>;
  source?: InputMaybe<LeadSource>;
  status: PaymentStatus;
  tripExpense?: InputMaybe<TripExpenseRef>;
  type?: InputMaybe<PaymentType>;
  upiId?: InputMaybe<Scalars['String']>;
};

export type AddPaymentInvoicesInput = {
  GSTNumber?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<UserRef>;
  customerName?: InputMaybe<Scalars['String']>;
  customerNumber?: InputMaybe<Scalars['String']>;
  invoiceDate?: InputMaybe<Scalars['DateTime']>;
  invoiceId: Scalars['String'];
  lead: LeadRef;
  payment?: InputMaybe<PaymentRef>;
  serialNo: Scalars['String'];
  smsLogs?: InputMaybe<Array<InputMaybe<SmsLogsRef>>>;
};

export type AddPaymentInvoicesPayload = {
  __typename?: 'AddPaymentInvoicesPayload';
  numUids?: Maybe<Scalars['Int']>;
  paymentInvoices?: Maybe<Array<Maybe<PaymentInvoices>>>;
};


export type AddPaymentInvoicesPayloadPaymentInvoicesArgs = {
  filter?: InputMaybe<PaymentInvoicesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaymentInvoicesOrder>;
};

export type AddPaymentPayload = {
  __typename?: 'AddPaymentPayload';
  numUids?: Maybe<Scalars['Int']>;
  payment?: Maybe<Array<Maybe<Payment>>>;
};


export type AddPaymentPayloadPaymentArgs = {
  filter?: InputMaybe<PaymentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaymentOrder>;
};

export type AddPickupInput = {
  by?: InputMaybe<UserRef>;
  from?: InputMaybe<PointRef>;
  lead?: InputMaybe<LeadRef>;
  pickEndTime?: InputMaybe<Scalars['DateTime']>;
  pickupStartTime?: InputMaybe<Scalars['DateTime']>;
  regNo: Scalars['String'];
  to?: InputMaybe<PointRef>;
};

export type AddPickupPayload = {
  __typename?: 'AddPickupPayload';
  numUids?: Maybe<Scalars['Int']>;
  pickup?: Maybe<Array<Maybe<Pickup>>>;
};


export type AddPickupPayloadPickupArgs = {
  filter?: InputMaybe<PickupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PickupOrder>;
};

export type AddProductInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  variant?: InputMaybe<Scalars['String']>;
};

export type AddProductPayload = {
  __typename?: 'AddProductPayload';
  numUids?: Maybe<Scalars['Int']>;
  product?: Maybe<Array<Maybe<Product>>>;
};


export type AddProductPayloadProductArgs = {
  filter?: InputMaybe<ProductFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ProductOrder>;
};

export type AddPurchaseInput = {
  approvedBy?: InputMaybe<UserRef>;
  centre: CentreRef;
  createdAt: Scalars['DateTime'];
  invoiceUrl?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<InputMaybe<PurchaseItemRef>>>;
  madeBy: UserRef;
  payment?: InputMaybe<PaymentRef>;
  refurbishment?: InputMaybe<RefurbishmentRequestRef>;
  requestedItemId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PurchaseStatus>;
  totalPrice?: InputMaybe<Scalars['Int']>;
};

export type AddPurchaseItemInput = {
  approvedPriceLimit?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  price?: InputMaybe<Scalars['Int']>;
  product: ProductRef;
  purchase: PurchaseRef;
  purchaseProofUrl?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requestedItemId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type AddPurchaseItemPayload = {
  __typename?: 'AddPurchaseItemPayload';
  numUids?: Maybe<Scalars['Int']>;
  purchaseItem?: Maybe<Array<Maybe<PurchaseItem>>>;
};


export type AddPurchaseItemPayloadPurchaseItemArgs = {
  filter?: InputMaybe<PurchaseItemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PurchaseItemOrder>;
};

export type AddPurchasePayload = {
  __typename?: 'AddPurchasePayload';
  numUids?: Maybe<Scalars['Int']>;
  purchase?: Maybe<Array<Maybe<Purchase>>>;
};


export type AddPurchasePayloadPurchaseArgs = {
  filter?: InputMaybe<PurchaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PurchaseOrder>;
};

export type AddRefurbishmentBeneficiaryInput = {
  accountHolderName: Scalars['String'];
  accountNumber: Scalars['String'];
  bankName?: InputMaybe<BankName>;
  ifscCode: Scalars['String'];
  payment?: InputMaybe<Array<InputMaybe<PaymentRef>>>;
  proofUrl?: InputMaybe<Scalars['String']>;
  refurbishmentRequest?: InputMaybe<RefurbishmentRequestRef>;
  upiId?: InputMaybe<Scalars['String']>;
};

export type AddRefurbishmentBeneficiaryPayload = {
  __typename?: 'AddRefurbishmentBeneficiaryPayload';
  numUids?: Maybe<Scalars['Int']>;
  refurbishmentBeneficiary?: Maybe<Array<Maybe<RefurbishmentBeneficiary>>>;
};


export type AddRefurbishmentBeneficiaryPayloadRefurbishmentBeneficiaryArgs = {
  filter?: InputMaybe<RefurbishmentBeneficiaryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<RefurbishmentBeneficiaryOrder>;
};

export type AddRefurbishmentDetailsInput = {
  isRequired?: InputMaybe<Scalars['Boolean']>;
  lead?: InputMaybe<LeadRef>;
  requests?: InputMaybe<Array<InputMaybe<RefurbishmentRequestRef>>>;
};

export type AddRefurbishmentDetailsPayload = {
  __typename?: 'AddRefurbishmentDetailsPayload';
  numUids?: Maybe<Scalars['Int']>;
  refurbishmentDetails?: Maybe<Array<Maybe<RefurbishmentDetails>>>;
};


export type AddRefurbishmentDetailsPayloadRefurbishmentDetailsArgs = {
  filter?: InputMaybe<RefurbishmentDetailsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type AddRefurbishmentItemInput = {
  description?: InputMaybe<Scalars['String']>;
  expectedBuyingPrice?: InputMaybe<Scalars['Int']>;
  installationProofUrl?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  product: ProductRef;
  quantity?: InputMaybe<Scalars['Int']>;
  refurbishmentProofUrl?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<RefurbishmentStatus>;
};

export type AddRefurbishmentItemPayload = {
  __typename?: 'AddRefurbishmentItemPayload';
  numUids?: Maybe<Scalars['Int']>;
  refurbishmentItem?: Maybe<Array<Maybe<RefurbishmentItem>>>;
};


export type AddRefurbishmentItemPayloadRefurbishmentItemArgs = {
  filter?: InputMaybe<RefurbishmentItemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<RefurbishmentItemOrder>;
};

export type AddRefurbishmentRequestInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  hasTransportationCharge?: InputMaybe<Scalars['Boolean']>;
  issue?: InputMaybe<IssueRef>;
  items?: InputMaybe<Array<InputMaybe<RefurbishmentItemRef>>>;
  purchase?: InputMaybe<PurchaseRef>;
  raisedBy?: InputMaybe<UserRef>;
  refurbishmentBeneficiary?: InputMaybe<RefurbishmentBeneficiaryRef>;
  refurbishmentDetails?: InputMaybe<RefurbishmentDetailsRef>;
  requestStatus?: InputMaybe<RefurbishmentStatus>;
  transportationCharge?: InputMaybe<Scalars['Int']>;
};

export type AddRefurbishmentRequestPayload = {
  __typename?: 'AddRefurbishmentRequestPayload';
  numUids?: Maybe<Scalars['Int']>;
  refurbishmentRequest?: Maybe<Array<Maybe<RefurbishmentRequest>>>;
};


export type AddRefurbishmentRequestPayloadRefurbishmentRequestArgs = {
  filter?: InputMaybe<RefurbishmentRequestFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<RefurbishmentRequestOrder>;
};

export type AddSmsLogsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  invoice?: InputMaybe<PaymentInvoicesRef>;
  response?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TaskStatus>;
};

export type AddSmsLogsPayload = {
  __typename?: 'AddSMSLogsPayload';
  numUids?: Maybe<Scalars['Int']>;
  sMSLogs?: Maybe<Array<Maybe<SmsLogs>>>;
};


export type AddSmsLogsPayloadSMsLogsArgs = {
  filter?: InputMaybe<SmsLogsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<SmsLogsOrder>;
};

export type AddSendSmsToCustomerResponseInput = {
  invoice?: InputMaybe<PaymentInvoicesRef>;
  message?: InputMaybe<Scalars['String']>;
  success?: InputMaybe<Scalars['Boolean']>;
};

export type AddSendSmsToCustomerResponsePayload = {
  __typename?: 'AddSendSmsToCustomerResponsePayload';
  numUids?: Maybe<Scalars['Int']>;
  sendSmsToCustomerResponse?: Maybe<Array<Maybe<SendSmsToCustomerResponse>>>;
};


export type AddSendSmsToCustomerResponsePayloadSendSmsToCustomerResponseArgs = {
  filter?: InputMaybe<SendSmsToCustomerResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<SendSmsToCustomerResponseOrder>;
};

export type AddStateCodeWithRegNumberInput = {
  RTOCode?: InputMaybe<Scalars['String']>;
  districts?: InputMaybe<Array<InputMaybe<DistrictRef>>>;
  state: Scalars['String'];
  tehsils?: InputMaybe<Array<InputMaybe<TehsilRef>>>;
};

export type AddStateCodeWithRegNumberPayload = {
  __typename?: 'AddStateCodeWithRegNumberPayload';
  numUids?: Maybe<Scalars['Int']>;
  stateCodeWithRegNumber?: Maybe<Array<Maybe<StateCodeWithRegNumber>>>;
};


export type AddStateCodeWithRegNumberPayloadStateCodeWithRegNumberArgs = {
  filter?: InputMaybe<StateCodeWithRegNumberFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<StateCodeWithRegNumberOrder>;
};

export type AddStatusAggregateInput = {
  count?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<LeadStatus>;
};

export type AddStatusAggregatePayload = {
  __typename?: 'AddStatusAggregatePayload';
  numUids?: Maybe<Scalars['Int']>;
  statusAggregate?: Maybe<Array<Maybe<StatusAggregate>>>;
};


export type AddStatusAggregatePayloadStatusAggregateArgs = {
  filter?: InputMaybe<StatusAggregateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<StatusAggregateOrder>;
};

export type AddTjCentreInput = {
  address?: InputMaybe<Scalars['String']>;
  center_image?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['String']>;
  district_id?: InputMaybe<Scalars['Int']>;
  district_name?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_hi?: InputMaybe<Scalars['String']>;
  name_mr?: InputMaybe<Scalars['String']>;
  name_ta?: InputMaybe<Scalars['String']>;
  name_te?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['Int']>;
  short_address?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  state_id?: InputMaybe<Scalars['Int']>;
  state_name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Int']>;
  tehsil_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['String']>;
};

export type AddTjCentrePayload = {
  __typename?: 'AddTJCentrePayload';
  numUids?: Maybe<Scalars['Int']>;
  tJCentre?: Maybe<Array<Maybe<TjCentre>>>;
};


export type AddTjCentrePayloadTjCentreArgs = {
  filter?: InputMaybe<TjCentreFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<TjCentreOrder>;
};

export type AddTaskInput = {
  assignedTo?: InputMaybe<UserRef>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  leadStatusEvent: LeadStatusEventRef;
  subtitle?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type AddTaskPayload = {
  __typename?: 'AddTaskPayload';
  numUids?: Maybe<Scalars['Int']>;
  task?: Maybe<Array<Maybe<Task>>>;
};


export type AddTaskPayloadTaskArgs = {
  filter?: InputMaybe<TaskFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<TaskOrder>;
};

export type AddTehsilInput = {
  distId?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<DistrictRef>;
  name: Scalars['String'];
  state?: InputMaybe<StateCodeWithRegNumberRef>;
  stateId?: InputMaybe<Scalars['String']>;
};

export type AddTehsilPayload = {
  __typename?: 'AddTehsilPayload';
  numUids?: Maybe<Scalars['Int']>;
  tehsil?: Maybe<Array<Maybe<Tehsil>>>;
};


export type AddTehsilPayloadTehsilArgs = {
  filter?: InputMaybe<TehsilFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<TehsilOrder>;
};

export type AddTripExpenseInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: UserRef;
  expensePayment?: InputMaybe<PaymentRef>;
  expenses?: InputMaybe<Array<InputMaybe<LeadExpenseRef>>>;
  leads?: InputMaybe<Array<InputMaybe<LeadRef>>>;
  remarksByFinance?: InputMaybe<Scalars['String']>;
  remarksByOps?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<LeadExpenseStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedBy?: InputMaybe<UserRef>;
  updatedByFinance?: InputMaybe<UserRef>;
  updatedByFinanceAt?: InputMaybe<Scalars['DateTime']>;
  updatedByOperations?: InputMaybe<UserRef>;
  updatedByOperationsAt?: InputMaybe<Scalars['DateTime']>;
};

export type AddTripExpensePayload = {
  __typename?: 'AddTripExpensePayload';
  numUids?: Maybe<Scalars['Int']>;
  tripExpense?: Maybe<Array<Maybe<TripExpense>>>;
};


export type AddTripExpensePayloadTripExpenseArgs = {
  filter?: InputMaybe<TripExpenseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<TripExpenseOrder>;
};

export type AddUserInput = {
  addedTripExpenses?: InputMaybe<Array<InputMaybe<TripExpenseRef>>>;
  additionalRole?: InputMaybe<Array<InputMaybe<UserRole>>>;
  approvedIssues?: InputMaybe<Array<InputMaybe<IssueRef>>>;
  approvedPurchases?: InputMaybe<Array<InputMaybe<PurchaseRef>>>;
  assignedInternalTransfer?: InputMaybe<Array<InputMaybe<VehicleTransferLogRef>>>;
  assignedTasks?: InputMaybe<Array<InputMaybe<TaskRef>>>;
  avatar?: InputMaybe<Scalars['String']>;
  centre?: InputMaybe<CentreRef>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdLeads?: InputMaybe<Array<InputMaybe<LeadRef>>>;
  email: Scalars['String'];
  /** Expo generated token to send push notifications */
  expoPushNotificationAddress?: InputMaybe<Scalars['String']>;
  hasAdminPanelAccess?: InputMaybe<Scalars['Boolean']>;
  inchargeOfCentres?: InputMaybe<Array<InputMaybe<CentreRef>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isReportingManagerOf?: InputMaybe<Array<InputMaybe<UserRef>>>;
  location?: InputMaybe<PointRef>;
  madeIssues?: InputMaybe<Array<InputMaybe<IssueRef>>>;
  madePurchases?: InputMaybe<Array<InputMaybe<PurchaseRef>>>;
  managingCentres?: InputMaybe<Array<InputMaybe<CentreRef>>>;
  name: Scalars['String'];
  notifications?: InputMaybe<Array<InputMaybe<NotificationRef>>>;
  payments?: InputMaybe<Array<InputMaybe<PaymentRef>>>;
  phoneNo?: InputMaybe<Scalars['String']>;
  pickups?: InputMaybe<Array<InputMaybe<PickupRef>>>;
  punchedEvents?: InputMaybe<Array<InputMaybe<LeadStatusEventRef>>>;
  raisedRefurbishments?: InputMaybe<Array<InputMaybe<RefurbishmentRequestRef>>>;
  readMessages?: InputMaybe<Array<InputMaybe<MessageRef>>>;
  registrationState?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  reportingManager?: InputMaybe<UserRef>;
  role?: InputMaybe<UserRole>;
  sentMessages?: InputMaybe<Array<InputMaybe<MessageRef>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedListings?: InputMaybe<Array<InputMaybe<LeadRef>>>;
  userLogs?: InputMaybe<Array<InputMaybe<LogTrackingRef>>>;
};

export type AddUserPayload = {
  __typename?: 'AddUserPayload';
  numUids?: Maybe<Scalars['Int']>;
  user?: Maybe<Array<Maybe<User>>>;
};


export type AddUserPayloadUserArgs = {
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<UserOrder>;
};

export type AddVehicleDocumentsInput = {
  approvalMailUrl?: InputMaybe<Scalars['String']>;
  blacklistProofUrl?: InputMaybe<Scalars['String']>;
  challanUrl?: InputMaybe<Scalars['String']>;
  fitnessCertificateUrl?: InputMaybe<Scalars['String']>;
  fitnessCertificateValidUpto?: InputMaybe<Scalars['DateTime']>;
  hsrbProofUrl?: InputMaybe<Scalars['String']>;
  hypothecationProofUrl?: InputMaybe<Scalars['String']>;
  regNo: Scalars['String'];
  registrationCertificateUrl?: InputMaybe<Scalars['String']>;
  rtoVerificationProofUrl?: InputMaybe<Scalars['String']>;
  vehicle: VehicleRef;
};

export type AddVehicleDocumentsPayload = {
  __typename?: 'AddVehicleDocumentsPayload';
  numUids?: Maybe<Scalars['Int']>;
  vehicleDocuments?: Maybe<Array<Maybe<VehicleDocuments>>>;
};


export type AddVehicleDocumentsPayloadVehicleDocumentsArgs = {
  filter?: InputMaybe<VehicleDocumentsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleDocumentsOrder>;
};

export type AddVehicleFinancingInput = {
  bankNOCUrl?: InputMaybe<Scalars['String']>;
  financerName?: InputMaybe<Scalars['String']>;
  foreclosureCertificateUrl?: InputMaybe<Scalars['String']>;
  form35Url?: InputMaybe<Scalars['String']>;
  isLoanClosed?: InputMaybe<Scalars['Boolean']>;
  loanToBeClosedBy?: InputMaybe<LoanToBeClosedBy>;
  pendingLoanAmount?: InputMaybe<Scalars['Int']>;
  tempFinancerName?: InputMaybe<Scalars['String']>;
  tempLoanToBeClosedBy?: InputMaybe<LoanToBeClosedBy>;
  vehicle: VehicleRef;
};

export type AddVehicleFinancingPayload = {
  __typename?: 'AddVehicleFinancingPayload';
  numUids?: Maybe<Scalars['Int']>;
  vehicleFinancing?: Maybe<Array<Maybe<VehicleFinancing>>>;
};


export type AddVehicleFinancingPayloadVehicleFinancingArgs = {
  filter?: InputMaybe<VehicleFinancingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleFinancingOrder>;
};

export type AddVehicleImagesInput = {
  backBodySide?: InputMaybe<Scalars['String']>;
  backLeftTyre?: InputMaybe<Scalars['String']>;
  backRightTyre?: InputMaybe<Scalars['String']>;
  chassisNumber?: InputMaybe<Scalars['String']>;
  engineNumber?: InputMaybe<Scalars['String']>;
  frontBodySide?: InputMaybe<Scalars['String']>;
  frontLeftTyre?: InputMaybe<Scalars['String']>;
  frontRightTyre?: InputMaybe<Scalars['String']>;
  fuelInjectionPumpPlate?: InputMaybe<Scalars['String']>;
  imagesTakenAtStage?: InputMaybe<ImageStage>;
  inspectionVideoUrl?: InputMaybe<Scalars['String']>;
  leftBodySide?: InputMaybe<Scalars['String']>;
  odometer?: InputMaybe<Scalars['String']>;
  rightBodySide?: InputMaybe<Scalars['String']>;
  vehicle: VehicleRef;
  /** syntax : regNo_imageStage */
  vehicleImagesId: Scalars['String'];
};

export type AddVehicleImagesPayload = {
  __typename?: 'AddVehicleImagesPayload';
  numUids?: Maybe<Scalars['Int']>;
  vehicleImages?: Maybe<Array<Maybe<VehicleImages>>>;
};


export type AddVehicleImagesPayloadVehicleImagesArgs = {
  filter?: InputMaybe<VehicleImagesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleImagesOrder>;
};

export type AddVehicleInput = {
  challanAmount?: InputMaybe<Scalars['Int']>;
  chassisNumber?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  documents?: InputMaybe<VehicleDocumentsRef>;
  dueTaxesAmount?: InputMaybe<Scalars['Int']>;
  engineCondition?: InputMaybe<Scalars['Int']>;
  engineNumber?: InputMaybe<Scalars['String']>;
  financingDetails?: InputMaybe<VehicleFinancingRef>;
  fitnessValidUpto?: InputMaybe<Scalars['DateTime']>;
  fuelType?: InputMaybe<VehicleFuelType>;
  hasDueTaxes?: InputMaybe<Scalars['Boolean']>;
  horsePower?: InputMaybe<Scalars['Int']>;
  hoursMeter?: InputMaybe<Scalars['Int']>;
  images?: InputMaybe<Array<InputMaybe<VehicleImagesRef>>>;
  insuranceDetails?: InputMaybe<VehicleInsuranceRef>;
  isBlacklisted?: InputMaybe<Scalars['Boolean']>;
  isChallanAvailable?: InputMaybe<Scalars['Boolean']>;
  isHSRPAvailable?: InputMaybe<Scalars['Boolean']>;
  isHypo?: InputMaybe<Scalars['Boolean']>;
  isRcAvailable?: InputMaybe<Scalars['Boolean']>;
  isVehicleFinanced?: InputMaybe<Scalars['Boolean']>;
  isVehicleInsured?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<VehicleKind>;
  make?: InputMaybe<VehicleMake>;
  manufacturingDate?: InputMaybe<Scalars['DateTime']>;
  model?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<VehicleOwnerRef>;
  price?: InputMaybe<Scalars['Int']>;
  purchaseDate?: InputMaybe<Scalars['DateTime']>;
  regNo: Scalars['String'];
  registrationDate?: InputMaybe<Scalars['DateTime']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
  repossessionDate?: InputMaybe<Scalars['DateTime']>;
  tempChassisNumber?: InputMaybe<Scalars['String']>;
  tempEngineNumber?: InputMaybe<Scalars['String']>;
  tempIsVehicleFinanced?: InputMaybe<Scalars['Boolean']>;
  tempMake?: InputMaybe<VehicleMake>;
  tempManufacturingDate?: InputMaybe<Scalars['DateTime']>;
  tempModel?: InputMaybe<Scalars['String']>;
  /** To be put in by the driver */
  tempRepossessionDate?: InputMaybe<Scalars['DateTime']>;
  tempVehicleBrand?: InputMaybe<BrandRef>;
  tempVehicleModel?: InputMaybe<ModelRef>;
  totalHourRun?: InputMaybe<Scalars['Int']>;
  totalKmsRun?: InputMaybe<Scalars['Int']>;
  typeCondition?: InputMaybe<Scalars['Int']>;
  vehicleBrand?: InputMaybe<BrandRef>;
  vehicleModel?: InputMaybe<ModelRef>;
  verificationRemarks?: InputMaybe<Scalars['String']>;
};

export type AddVehicleInsuranceInput = {
  insuraceCertificateUrl?: InputMaybe<Scalars['String']>;
  insuranceType?: InputMaybe<InsuranceType>;
  insurerName?: InputMaybe<InsurerName>;
  policyExpiryDate?: InputMaybe<Scalars['DateTime']>;
  policyNumber?: InputMaybe<Scalars['String']>;
  vehicle: VehicleRef;
};

export type AddVehicleInsurancePayload = {
  __typename?: 'AddVehicleInsurancePayload';
  numUids?: Maybe<Scalars['Int']>;
  vehicleInsurance?: Maybe<Array<Maybe<VehicleInsurance>>>;
};


export type AddVehicleInsurancePayloadVehicleInsuranceArgs = {
  filter?: InputMaybe<VehicleInsuranceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleInsuranceOrder>;
};

export type AddVehicleOwnerInput = {
  address?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  orgName?: InputMaybe<Scalars['String']>;
  phoneNo: Scalars['String'];
  pincode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  tehsil?: InputMaybe<Scalars['String']>;
};

export type AddVehicleOwnerPayload = {
  __typename?: 'AddVehicleOwnerPayload';
  numUids?: Maybe<Scalars['Int']>;
  vehicleOwner?: Maybe<Array<Maybe<VehicleOwner>>>;
};


export type AddVehicleOwnerPayloadVehicleOwnerArgs = {
  filter?: InputMaybe<VehicleOwnerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleOwnerOrder>;
};

export type AddVehiclePayload = {
  __typename?: 'AddVehiclePayload';
  numUids?: Maybe<Scalars['Int']>;
  vehicle?: Maybe<Array<Maybe<Vehicle>>>;
};


export type AddVehiclePayloadVehicleArgs = {
  filter?: InputMaybe<VehicleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleOrder>;
};

export type AddVehicleTransferLogInput = {
  assignedTo?: InputMaybe<UserRef>;
  deliveredOn?: InputMaybe<Scalars['DateTime']>;
  from?: InputMaybe<CentreRef>;
  lead?: InputMaybe<LeadRef>;
  pickupDate?: InputMaybe<Scalars['DateTime']>;
  remarks?: InputMaybe<Scalars['String']>;
  requestedOn?: InputMaybe<Scalars['DateTime']>;
  selfieUrl?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<InternalTransferStatus>;
  to?: InputMaybe<CentreRef>;
};

export type AddVehicleTransferLogPayload = {
  __typename?: 'AddVehicleTransferLogPayload';
  numUids?: Maybe<Scalars['Int']>;
  vehicleTransferLog?: Maybe<Array<Maybe<VehicleTransferLog>>>;
};


export type AddVehicleTransferLogPayloadVehicleTransferLogArgs = {
  filter?: InputMaybe<VehicleTransferLogFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleTransferLogOrder>;
};

export type AddYardInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  leads?: InputMaybe<Array<InputMaybe<LeadRef>>>;
  location?: InputMaybe<PointRef>;
  locationUrl?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  perDayParkingCharge?: InputMaybe<Scalars['Float']>;
  spocName?: InputMaybe<Scalars['String']>;
  spocNo?: InputMaybe<Scalars['String']>;
  tempPerDayParkingCharge?: InputMaybe<Scalars['Float']>;
};

export type AddYardPayload = {
  __typename?: 'AddYardPayload';
  numUids?: Maybe<Scalars['Int']>;
  yard?: Maybe<Array<Maybe<Yard>>>;
};


export type AddYardPayloadYardArgs = {
  filter?: InputMaybe<YardFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<YardOrder>;
};

export type AdddocumentsAggregatesResultInput = {
  documentsCount?: InputMaybe<DocumentsCountRef>;
  leads?: InputMaybe<Array<InputMaybe<LeadRef>>>;
};

export type AdddocumentsAggregatesResultPayload = {
  __typename?: 'AdddocumentsAggregatesResultPayload';
  documentsAggregatesResult?: Maybe<Array<Maybe<DocumentsAggregatesResult>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type AdddocumentsAggregatesResultPayloadDocumentsAggregatesResultArgs = {
  filter?: InputMaybe<DocumentsAggregatesResultFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type AdminLeadStatusEvent = {
  __typename?: 'AdminLeadStatusEvent';
  createdAt: Scalars['DateTime'];
  createdBy: User;
  id: Scalars['ID'];
  lead: Lead;
  notification?: Maybe<Notification>;
  notifyTo?: Maybe<Array<Maybe<UserRole>>>;
  status: LeadStatus;
};


export type AdminLeadStatusEventCreatedByArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type AdminLeadStatusEventLeadArgs = {
  filter?: InputMaybe<LeadFilter>;
};


export type AdminLeadStatusEventNotificationArgs = {
  filter?: InputMaybe<NotificationFilter>;
};

export type AdminLeadStatusEventAggregateResult = {
  __typename?: 'AdminLeadStatusEventAggregateResult';
  count?: Maybe<Scalars['Int']>;
  createdAtMax?: Maybe<Scalars['DateTime']>;
  createdAtMin?: Maybe<Scalars['DateTime']>;
};

export type AdminLeadStatusEventFilter = {
  and?: InputMaybe<Array<InputMaybe<AdminLeadStatusEventFilter>>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  has?: InputMaybe<Array<InputMaybe<AdminLeadStatusEventHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<AdminLeadStatusEventFilter>;
  notifyTo?: InputMaybe<UserRole_Hash>;
  or?: InputMaybe<Array<InputMaybe<AdminLeadStatusEventFilter>>>;
  status?: InputMaybe<LeadStatus_Hash>;
};

export enum AdminLeadStatusEventHasFilter {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  Lead = 'lead',
  Notification = 'notification',
  NotifyTo = 'notifyTo',
  Status = 'status'
}

export type AdminLeadStatusEventOrder = {
  asc?: InputMaybe<AdminLeadStatusEventOrderable>;
  desc?: InputMaybe<AdminLeadStatusEventOrderable>;
  then?: InputMaybe<AdminLeadStatusEventOrder>;
};

export enum AdminLeadStatusEventOrderable {
  CreatedAt = 'createdAt'
}

export type AdminLeadStatusEventPatch = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserRef>;
  lead?: InputMaybe<LeadRef>;
  notification?: InputMaybe<NotificationRef>;
  notifyTo?: InputMaybe<Array<InputMaybe<UserRole>>>;
  status?: InputMaybe<LeadStatus>;
};

export type AdminLeadStatusEventRef = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserRef>;
  id?: InputMaybe<Scalars['ID']>;
  lead?: InputMaybe<LeadRef>;
  notification?: InputMaybe<NotificationRef>;
  notifyTo?: InputMaybe<Array<InputMaybe<UserRole>>>;
  status?: InputMaybe<LeadStatus>;
};

export type Agency = {
  __typename?: 'Agency';
  id: Scalars['ID'];
  leads?: Maybe<Array<Maybe<Lead>>>;
  leadsAggregate?: Maybe<LeadAggregateResult>;
  name: Scalars['String'];
  spocNo?: Maybe<Scalars['String']>;
};


export type AgencyLeadsArgs = {
  filter?: InputMaybe<LeadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadOrder>;
};


export type AgencyLeadsAggregateArgs = {
  filter?: InputMaybe<LeadFilter>;
};

export type AgencyAggregateResult = {
  __typename?: 'AgencyAggregateResult';
  count?: Maybe<Scalars['Int']>;
  nameMax?: Maybe<Scalars['String']>;
  nameMin?: Maybe<Scalars['String']>;
  spocNoMax?: Maybe<Scalars['String']>;
  spocNoMin?: Maybe<Scalars['String']>;
};

export type AgencyFilter = {
  and?: InputMaybe<Array<InputMaybe<AgencyFilter>>>;
  has?: InputMaybe<Array<InputMaybe<AgencyHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<StringFullTextFilter_StringHashFilter>;
  not?: InputMaybe<AgencyFilter>;
  or?: InputMaybe<Array<InputMaybe<AgencyFilter>>>;
};

export enum AgencyHasFilter {
  Leads = 'leads',
  Name = 'name',
  SpocNo = 'spocNo'
}

export type AgencyOrder = {
  asc?: InputMaybe<AgencyOrderable>;
  desc?: InputMaybe<AgencyOrderable>;
  then?: InputMaybe<AgencyOrder>;
};

export enum AgencyOrderable {
  Name = 'name',
  SpocNo = 'spocNo'
}

export type AgencyPatch = {
  leads?: InputMaybe<Array<InputMaybe<LeadRef>>>;
  spocNo?: InputMaybe<Scalars['String']>;
};

export type AgencyRef = {
  id?: InputMaybe<Scalars['ID']>;
  leads?: InputMaybe<Array<InputMaybe<LeadRef>>>;
  name?: InputMaybe<Scalars['String']>;
  spocNo?: InputMaybe<Scalars['String']>;
};

export type AuctionHistory = {
  __typename?: 'AuctionHistory';
  amount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  status?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AuctionHistoryAggregateResult = {
  __typename?: 'AuctionHistoryAggregateResult';
  amountAvg?: Maybe<Scalars['Float']>;
  amountMax?: Maybe<Scalars['Int']>;
  amountMin?: Maybe<Scalars['Int']>;
  amountSum?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  createdAtMax?: Maybe<Scalars['DateTime']>;
  createdAtMin?: Maybe<Scalars['DateTime']>;
  updatedAtMax?: Maybe<Scalars['DateTime']>;
  updatedAtMin?: Maybe<Scalars['DateTime']>;
};

export type AuctionHistoryFilter = {
  and?: InputMaybe<Array<InputMaybe<AuctionHistoryFilter>>>;
  has?: InputMaybe<Array<InputMaybe<AuctionHistoryHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<AuctionHistoryFilter>;
  or?: InputMaybe<Array<InputMaybe<AuctionHistoryFilter>>>;
};

export enum AuctionHistoryHasFilter {
  Amount = 'amount',
  CreatedAt = 'createdAt',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type AuctionHistoryOrder = {
  asc?: InputMaybe<AuctionHistoryOrderable>;
  desc?: InputMaybe<AuctionHistoryOrderable>;
  then?: InputMaybe<AuctionHistoryOrder>;
};

export enum AuctionHistoryOrderable {
  Amount = 'amount',
  CreatedAt = 'createdAt',
  UpdatedAt = 'updatedAt'
}

export type AuctionHistoryPatch = {
  amount?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AuctionHistoryRef = {
  amount?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AuthRule = {
  and?: InputMaybe<Array<InputMaybe<AuthRule>>>;
  not?: InputMaybe<AuthRule>;
  or?: InputMaybe<Array<InputMaybe<AuthRule>>>;
  rule?: InputMaybe<Scalars['String']>;
};

export type Bank = {
  __typename?: 'Bank';
  id: Scalars['ID'];
  leads?: Maybe<Array<Maybe<Lead>>>;
  leadsAggregate?: Maybe<LeadAggregateResult>;
  name: Scalars['String'];
  spocNo?: Maybe<Scalars['String']>;
};


export type BankLeadsArgs = {
  filter?: InputMaybe<LeadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadOrder>;
};


export type BankLeadsAggregateArgs = {
  filter?: InputMaybe<LeadFilter>;
};

export type BankAggregateResult = {
  __typename?: 'BankAggregateResult';
  count?: Maybe<Scalars['Int']>;
  nameMax?: Maybe<Scalars['String']>;
  nameMin?: Maybe<Scalars['String']>;
  spocNoMax?: Maybe<Scalars['String']>;
  spocNoMin?: Maybe<Scalars['String']>;
};

export type BankAuctionLeadCountByName = {
  __typename?: 'BankAuctionLeadCountByName';
  approvalRecived?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  vahanChecked?: Maybe<Scalars['String']>;
  vehicleInAuction?: Maybe<Scalars['String']>;
  wonInAuction?: Maybe<Scalars['String']>;
};

export type BankAuctionLeadCountByNameAggregateResult = {
  __typename?: 'BankAuctionLeadCountByNameAggregateResult';
  approvalRecivedMax?: Maybe<Scalars['String']>;
  approvalRecivedMin?: Maybe<Scalars['String']>;
  bankNameMax?: Maybe<Scalars['String']>;
  bankNameMin?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  vahanCheckedMax?: Maybe<Scalars['String']>;
  vahanCheckedMin?: Maybe<Scalars['String']>;
  vehicleInAuctionMax?: Maybe<Scalars['String']>;
  vehicleInAuctionMin?: Maybe<Scalars['String']>;
  wonInAuctionMax?: Maybe<Scalars['String']>;
  wonInAuctionMin?: Maybe<Scalars['String']>;
};

export type BankAuctionLeadCountByNameFilter = {
  and?: InputMaybe<Array<InputMaybe<BankAuctionLeadCountByNameFilter>>>;
  has?: InputMaybe<Array<InputMaybe<BankAuctionLeadCountByNameHasFilter>>>;
  not?: InputMaybe<BankAuctionLeadCountByNameFilter>;
  or?: InputMaybe<Array<InputMaybe<BankAuctionLeadCountByNameFilter>>>;
};

export enum BankAuctionLeadCountByNameHasFilter {
  ApprovalRecived = 'approvalRecived',
  BankName = 'bankName',
  VahanChecked = 'vahanChecked',
  VehicleInAuction = 'vehicleInAuction',
  WonInAuction = 'wonInAuction'
}

export type BankAuctionLeadCountByNameOrder = {
  asc?: InputMaybe<BankAuctionLeadCountByNameOrderable>;
  desc?: InputMaybe<BankAuctionLeadCountByNameOrderable>;
  then?: InputMaybe<BankAuctionLeadCountByNameOrder>;
};

export enum BankAuctionLeadCountByNameOrderable {
  ApprovalRecived = 'approvalRecived',
  BankName = 'bankName',
  VahanChecked = 'vahanChecked',
  VehicleInAuction = 'vehicleInAuction',
  WonInAuction = 'wonInAuction'
}

export type BankAuctionLeadCountByNamePatch = {
  approvalRecived?: InputMaybe<Scalars['String']>;
  bankName?: InputMaybe<Scalars['String']>;
  vahanChecked?: InputMaybe<Scalars['String']>;
  vehicleInAuction?: InputMaybe<Scalars['String']>;
  wonInAuction?: InputMaybe<Scalars['String']>;
};

export type BankAuctionLeadCountByNameRef = {
  approvalRecived?: InputMaybe<Scalars['String']>;
  bankName?: InputMaybe<Scalars['String']>;
  vahanChecked?: InputMaybe<Scalars['String']>;
  vehicleInAuction?: InputMaybe<Scalars['String']>;
  wonInAuction?: InputMaybe<Scalars['String']>;
};

export enum BankConfirmationStatus {
  NotVerified = 'NOT_VERIFIED',
  Verified = 'VERIFIED'
}

export type BankFilter = {
  and?: InputMaybe<Array<InputMaybe<BankFilter>>>;
  has?: InputMaybe<Array<InputMaybe<BankHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<StringFullTextFilter_StringHashFilter>;
  not?: InputMaybe<BankFilter>;
  or?: InputMaybe<Array<InputMaybe<BankFilter>>>;
};

export enum BankHasFilter {
  Leads = 'leads',
  Name = 'name',
  SpocNo = 'spocNo'
}

export enum BankName {
  AdaniCapital = 'ADANI_CAPITAL',
  AuFinance = 'AU_FINANCE',
  AxisBank = 'AXIS_BANK',
  BaidFinservLtd = 'BAID_FINSERV_LTD',
  BajajFinance = 'BAJAJ_FINANCE',
  BankOfBaroda = 'BANK_OF_BARODA',
  BankOfIndia = 'BANK_OF_INDIA',
  BankOfMaharashtra = 'BANK_OF_MAHARASHTRA',
  BestCapitalServices = 'BEST_CAPITAL_SERVICES',
  CentralBankOfIndia = 'CENTRAL_BANK_OF_INDIA',
  Chola = 'CHOLA',
  CorporationBank = 'CORPORATION_BANK',
  DcbBank = 'DCB_BANK',
  DenaBank = 'DENA_BANK',
  DLL = 'D_L_L',
  Hdb = 'HDB',
  HdfcBank = 'HDFC_BANK',
  HindujaBank = 'HINDUJA_BANK',
  Ibl = 'IBL',
  IciciBank = 'ICICI_BANK',
  IffcoKisanFinanceLtd = 'IFFCO_KISAN_FINANCE_LTD',
  IndianBank = 'INDIAN_BANK',
  IndusindBank = 'INDUSIND_BANK',
  KogtaFinance = 'KOGTA_FINANCE',
  KotakMahindraBank = 'KOTAK_MAHINDRA_BANK',
  LAndT = 'L_AND_T',
  MahindraFinance = 'MAHINDRA_FINANCE',
  Manappuram = 'MANAPPURAM',
  MeghaHoldings = 'MEGHA_HOLDINGS',
  RblBank = 'RBL_BANK',
  ShriramFinance = 'SHRIRAM_FINANCE',
  SkFinance = 'SK_FINANCE',
  StateBankOfIndia = 'STATE_BANK_OF_INDIA',
  SundaramFinance = 'SUNDARAM_FINANCE',
  TvsCredit = 'TVS_CREDIT',
  UnionBankOfIndia = 'UNION_BANK_OF_INDIA',
  VastuFinserve = 'VASTU_FINSERVE',
  YesBank = 'YES_BANK'
}

export type BankName_Hash = {
  eq?: InputMaybe<BankName>;
  in?: InputMaybe<Array<InputMaybe<BankName>>>;
};

export type BankOrder = {
  asc?: InputMaybe<BankOrderable>;
  desc?: InputMaybe<BankOrderable>;
  then?: InputMaybe<BankOrder>;
};

export enum BankOrderable {
  Name = 'name',
  SpocNo = 'spocNo'
}

export type BankPatch = {
  leads?: InputMaybe<Array<InputMaybe<LeadRef>>>;
  spocNo?: InputMaybe<Scalars['String']>;
};

export type BankRef = {
  id?: InputMaybe<Scalars['ID']>;
  leads?: InputMaybe<Array<InputMaybe<LeadRef>>>;
  name?: InputMaybe<Scalars['String']>;
  spocNo?: InputMaybe<Scalars['String']>;
};

export type Booking = {
  __typename?: 'Booking';
  activeLoan?: Maybe<Loan>;
  archivedLoans?: Maybe<Array<Maybe<Loan>>>;
  archivedLoansAggregate?: Maybe<LoanAggregateResult>;
  bookingPayment?: Maybe<BookingPayment>;
  cancellationReason?: Maybe<BookingCancellationReason>;
  cancellationRemarks?: Maybe<Scalars['String']>;
  cancelledChequeUrl?: Maybe<Scalars['String']>;
  cheque?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customer: Customer;
  deliveryForm?: Maybe<Scalars['String']>;
  deliveryPhotoUrl?: Maybe<Scalars['String']>;
  /** auto_generated id */
  id: Scalars['ID'];
  isInsuranceReq?: Maybe<Scalars['Boolean']>;
  isLoanDrop?: Maybe<Scalars['Boolean']>;
  isRCTransferReq?: Maybe<Scalars['Boolean']>;
  lead?: Maybe<Lead>;
  leadWithActiveBooking?: Maybe<Lead>;
  leadWithArchivedBooking?: Maybe<Lead>;
  loanCancellationReason?: Maybe<LoanRejectionReason>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  paymentsAggregate?: Maybe<PaymentAggregateResult>;
  searchString?: Maybe<Scalars['String']>;
  status?: Maybe<BookingStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vehicleTransferFormUrl?: Maybe<Scalars['String']>;
};


export type BookingActiveLoanArgs = {
  filter?: InputMaybe<LoanFilter>;
};


export type BookingArchivedLoansArgs = {
  filter?: InputMaybe<LoanFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LoanOrder>;
};


export type BookingArchivedLoansAggregateArgs = {
  filter?: InputMaybe<LoanFilter>;
};


export type BookingBookingPaymentArgs = {
  filter?: InputMaybe<BookingPaymentFilter>;
};


export type BookingCustomerArgs = {
  filter?: InputMaybe<CustomerFilter>;
};


export type BookingLeadArgs = {
  filter?: InputMaybe<LeadFilter>;
};


export type BookingLeadWithActiveBookingArgs = {
  filter?: InputMaybe<LeadFilter>;
};


export type BookingLeadWithArchivedBookingArgs = {
  filter?: InputMaybe<LeadFilter>;
};


export type BookingPaymentsArgs = {
  filter?: InputMaybe<PaymentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaymentOrder>;
};


export type BookingPaymentsAggregateArgs = {
  filter?: InputMaybe<PaymentFilter>;
};

export type BookingAggregateResult = {
  __typename?: 'BookingAggregateResult';
  cancellationRemarksMax?: Maybe<Scalars['String']>;
  cancellationRemarksMin?: Maybe<Scalars['String']>;
  cancelledChequeUrlMax?: Maybe<Scalars['String']>;
  cancelledChequeUrlMin?: Maybe<Scalars['String']>;
  chequeMax?: Maybe<Scalars['String']>;
  chequeMin?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  createdAtMax?: Maybe<Scalars['DateTime']>;
  createdAtMin?: Maybe<Scalars['DateTime']>;
  deliveryFormMax?: Maybe<Scalars['String']>;
  deliveryFormMin?: Maybe<Scalars['String']>;
  deliveryPhotoUrlMax?: Maybe<Scalars['String']>;
  deliveryPhotoUrlMin?: Maybe<Scalars['String']>;
  searchStringMax?: Maybe<Scalars['String']>;
  searchStringMin?: Maybe<Scalars['String']>;
  updatedAtMax?: Maybe<Scalars['DateTime']>;
  updatedAtMin?: Maybe<Scalars['DateTime']>;
  vehicleTransferFormUrlMax?: Maybe<Scalars['String']>;
  vehicleTransferFormUrlMin?: Maybe<Scalars['String']>;
};

export enum BookingCancellationReason {
  CustomerFoundBetterDeal = 'CUSTOMER_FOUND_BETTER_DEAL',
  CustomerNotResponding = 'CUSTOMER_NOT_RESPONDING',
  FinanceNotAvailable = 'FINANCE_NOT_AVAILABLE',
  FundsNotArranged = 'FUNDS_NOT_ARRANGED',
  Others = 'OTHERS'
}

export type BookingFilter = {
  and?: InputMaybe<Array<InputMaybe<BookingFilter>>>;
  has?: InputMaybe<Array<InputMaybe<BookingHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<BookingFilter>;
  or?: InputMaybe<Array<InputMaybe<BookingFilter>>>;
  searchString?: InputMaybe<StringRegExpFilter_StringTermFilter>;
  status?: InputMaybe<BookingStatus_Hash>;
};

export type BookingFilters = {
  centre?: InputMaybe<Scalars['String']>;
  districts?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  listingPrice?: InputMaybe<PriceRange>;
  makes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  manufacturingDate?: InputMaybe<Scalars['Int']>;
  models?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  purchaseType?: InputMaybe<Scalars['String']>;
  searchString?: InputMaybe<Scalars['String']>;
  sellingPrice?: InputMaybe<PriceRange>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<BookingStatus>;
  vehicleBrand?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  vehicleModel?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export enum BookingHasFilter {
  ActiveLoan = 'activeLoan',
  ArchivedLoans = 'archivedLoans',
  BookingPayment = 'bookingPayment',
  CancellationReason = 'cancellationReason',
  CancellationRemarks = 'cancellationRemarks',
  CancelledChequeUrl = 'cancelledChequeUrl',
  Cheque = 'cheque',
  CreatedAt = 'createdAt',
  Customer = 'customer',
  DeliveryForm = 'deliveryForm',
  DeliveryPhotoUrl = 'deliveryPhotoUrl',
  IsInsuranceReq = 'isInsuranceReq',
  IsLoanDrop = 'isLoanDrop',
  IsRcTransferReq = 'isRCTransferReq',
  Lead = 'lead',
  LeadWithActiveBooking = 'leadWithActiveBooking',
  LeadWithArchivedBooking = 'leadWithArchivedBooking',
  LoanCancellationReason = 'loanCancellationReason',
  Payments = 'payments',
  SearchString = 'searchString',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  VehicleTransferFormUrl = 'vehicleTransferFormUrl'
}

export type BookingOrder = {
  asc?: InputMaybe<BookingOrderable>;
  desc?: InputMaybe<BookingOrderable>;
  then?: InputMaybe<BookingOrder>;
};

export enum BookingOrderable {
  CancellationRemarks = 'cancellationRemarks',
  CancelledChequeUrl = 'cancelledChequeUrl',
  Cheque = 'cheque',
  CreatedAt = 'createdAt',
  DeliveryForm = 'deliveryForm',
  DeliveryPhotoUrl = 'deliveryPhotoUrl',
  SearchString = 'searchString',
  UpdatedAt = 'updatedAt',
  VehicleTransferFormUrl = 'vehicleTransferFormUrl'
}

export type BookingPatch = {
  activeLoan?: InputMaybe<LoanRef>;
  archivedLoans?: InputMaybe<Array<InputMaybe<LoanRef>>>;
  bookingPayment?: InputMaybe<BookingPaymentRef>;
  cancellationReason?: InputMaybe<BookingCancellationReason>;
  cancellationRemarks?: InputMaybe<Scalars['String']>;
  cancelledChequeUrl?: InputMaybe<Scalars['String']>;
  cheque?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customer?: InputMaybe<CustomerRef>;
  deliveryForm?: InputMaybe<Scalars['String']>;
  deliveryPhotoUrl?: InputMaybe<Scalars['String']>;
  isInsuranceReq?: InputMaybe<Scalars['Boolean']>;
  isLoanDrop?: InputMaybe<Scalars['Boolean']>;
  isRCTransferReq?: InputMaybe<Scalars['Boolean']>;
  lead?: InputMaybe<LeadRef>;
  leadWithActiveBooking?: InputMaybe<LeadRef>;
  leadWithArchivedBooking?: InputMaybe<LeadRef>;
  loanCancellationReason?: InputMaybe<LoanRejectionReason>;
  payments?: InputMaybe<Array<InputMaybe<PaymentRef>>>;
  searchString?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<BookingStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vehicleTransferFormUrl?: InputMaybe<Scalars['String']>;
};

export type BookingPayment = {
  __typename?: 'BookingPayment';
  appliedLoanAmount?: Maybe<Scalars['Int']>;
  booking: Booking;
  bookingPaymentMode?: Maybe<BookingType>;
  bookingType?: Maybe<BookingType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** auto_generated id */
  id: Scalars['ID'];
  insuranceAmount?: Maybe<Scalars['Int']>;
  rcTransferAmount?: Maybe<Scalars['Int']>;
  saleAmount: Scalars['Int'];
  totalSaleAmount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type BookingPaymentBookingArgs = {
  filter?: InputMaybe<BookingFilter>;
};

export type BookingPaymentAggregateResult = {
  __typename?: 'BookingPaymentAggregateResult';
  appliedLoanAmountAvg?: Maybe<Scalars['Float']>;
  appliedLoanAmountMax?: Maybe<Scalars['Int']>;
  appliedLoanAmountMin?: Maybe<Scalars['Int']>;
  appliedLoanAmountSum?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  createdAtMax?: Maybe<Scalars['DateTime']>;
  createdAtMin?: Maybe<Scalars['DateTime']>;
  insuranceAmountAvg?: Maybe<Scalars['Float']>;
  insuranceAmountMax?: Maybe<Scalars['Int']>;
  insuranceAmountMin?: Maybe<Scalars['Int']>;
  insuranceAmountSum?: Maybe<Scalars['Int']>;
  rcTransferAmountAvg?: Maybe<Scalars['Float']>;
  rcTransferAmountMax?: Maybe<Scalars['Int']>;
  rcTransferAmountMin?: Maybe<Scalars['Int']>;
  rcTransferAmountSum?: Maybe<Scalars['Int']>;
  saleAmountAvg?: Maybe<Scalars['Float']>;
  saleAmountMax?: Maybe<Scalars['Int']>;
  saleAmountMin?: Maybe<Scalars['Int']>;
  saleAmountSum?: Maybe<Scalars['Int']>;
  totalSaleAmountAvg?: Maybe<Scalars['Float']>;
  totalSaleAmountMax?: Maybe<Scalars['Int']>;
  totalSaleAmountMin?: Maybe<Scalars['Int']>;
  totalSaleAmountSum?: Maybe<Scalars['Int']>;
  updatedAtMax?: Maybe<Scalars['DateTime']>;
  updatedAtMin?: Maybe<Scalars['DateTime']>;
};

export type BookingPaymentFilter = {
  and?: InputMaybe<Array<InputMaybe<BookingPaymentFilter>>>;
  has?: InputMaybe<Array<InputMaybe<BookingPaymentHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<BookingPaymentFilter>;
  or?: InputMaybe<Array<InputMaybe<BookingPaymentFilter>>>;
};

export enum BookingPaymentHasFilter {
  AppliedLoanAmount = 'appliedLoanAmount',
  Booking = 'booking',
  BookingPaymentMode = 'bookingPaymentMode',
  BookingType = 'bookingType',
  CreatedAt = 'createdAt',
  InsuranceAmount = 'insuranceAmount',
  RcTransferAmount = 'rcTransferAmount',
  SaleAmount = 'saleAmount',
  TotalSaleAmount = 'totalSaleAmount',
  UpdatedAt = 'updatedAt'
}

export type BookingPaymentOrder = {
  asc?: InputMaybe<BookingPaymentOrderable>;
  desc?: InputMaybe<BookingPaymentOrderable>;
  then?: InputMaybe<BookingPaymentOrder>;
};

export enum BookingPaymentOrderable {
  AppliedLoanAmount = 'appliedLoanAmount',
  CreatedAt = 'createdAt',
  InsuranceAmount = 'insuranceAmount',
  RcTransferAmount = 'rcTransferAmount',
  SaleAmount = 'saleAmount',
  TotalSaleAmount = 'totalSaleAmount',
  UpdatedAt = 'updatedAt'
}

export type BookingPaymentPatch = {
  appliedLoanAmount?: InputMaybe<Scalars['Int']>;
  booking?: InputMaybe<BookingRef>;
  bookingPaymentMode?: InputMaybe<BookingType>;
  bookingType?: InputMaybe<BookingType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  insuranceAmount?: InputMaybe<Scalars['Int']>;
  rcTransferAmount?: InputMaybe<Scalars['Int']>;
  saleAmount?: InputMaybe<Scalars['Int']>;
  totalSaleAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type BookingPaymentRef = {
  appliedLoanAmount?: InputMaybe<Scalars['Int']>;
  booking?: InputMaybe<BookingRef>;
  bookingPaymentMode?: InputMaybe<BookingType>;
  bookingType?: InputMaybe<BookingType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** auto_generated id */
  id?: InputMaybe<Scalars['ID']>;
  insuranceAmount?: InputMaybe<Scalars['Int']>;
  rcTransferAmount?: InputMaybe<Scalars['Int']>;
  saleAmount?: InputMaybe<Scalars['Int']>;
  totalSaleAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type BookingRef = {
  activeLoan?: InputMaybe<LoanRef>;
  archivedLoans?: InputMaybe<Array<InputMaybe<LoanRef>>>;
  bookingPayment?: InputMaybe<BookingPaymentRef>;
  cancellationReason?: InputMaybe<BookingCancellationReason>;
  cancellationRemarks?: InputMaybe<Scalars['String']>;
  cancelledChequeUrl?: InputMaybe<Scalars['String']>;
  cheque?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customer?: InputMaybe<CustomerRef>;
  deliveryForm?: InputMaybe<Scalars['String']>;
  deliveryPhotoUrl?: InputMaybe<Scalars['String']>;
  /** auto_generated id */
  id?: InputMaybe<Scalars['ID']>;
  isInsuranceReq?: InputMaybe<Scalars['Boolean']>;
  isLoanDrop?: InputMaybe<Scalars['Boolean']>;
  isRCTransferReq?: InputMaybe<Scalars['Boolean']>;
  lead?: InputMaybe<LeadRef>;
  leadWithActiveBooking?: InputMaybe<LeadRef>;
  leadWithArchivedBooking?: InputMaybe<LeadRef>;
  loanCancellationReason?: InputMaybe<LoanRejectionReason>;
  payments?: InputMaybe<Array<InputMaybe<PaymentRef>>>;
  searchString?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<BookingStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vehicleTransferFormUrl?: InputMaybe<Scalars['String']>;
};

export enum BookingStatus {
  Active = 'ACTIVE',
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Update = 'UPDATE'
}

export type BookingStatus_Hash = {
  eq?: InputMaybe<BookingStatus>;
  in?: InputMaybe<Array<InputMaybe<BookingStatus>>>;
};

export enum BookingType {
  /** all booking payment done in cash */
  Cash = 'CASH',
  /** part cash , part loan */
  Finance = 'FINANCE'
}

export type Brand = {
  __typename?: 'Brand';
  brand_id: Scalars['Int'];
  id: Scalars['ID'];
  models?: Maybe<Array<Maybe<Model>>>;
  modelsAggregate?: Maybe<ModelAggregateResult>;
  name: Scalars['String'];
};


export type BrandModelsArgs = {
  filter?: InputMaybe<ModelFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ModelOrder>;
};


export type BrandModelsAggregateArgs = {
  filter?: InputMaybe<ModelFilter>;
};

export type BrandAggregateResult = {
  __typename?: 'BrandAggregateResult';
  brand_idAvg?: Maybe<Scalars['Float']>;
  brand_idMax?: Maybe<Scalars['Int']>;
  brand_idMin?: Maybe<Scalars['Int']>;
  brand_idSum?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  nameMax?: Maybe<Scalars['String']>;
  nameMin?: Maybe<Scalars['String']>;
};

export type BrandFilter = {
  and?: InputMaybe<Array<InputMaybe<BrandFilter>>>;
  brand_id?: InputMaybe<IntFilter>;
  has?: InputMaybe<Array<InputMaybe<BrandHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<StringFullTextFilter>;
  not?: InputMaybe<BrandFilter>;
  or?: InputMaybe<Array<InputMaybe<BrandFilter>>>;
};

export enum BrandHasFilter {
  BrandId = 'brand_id',
  Models = 'models',
  Name = 'name'
}

export type BrandOrder = {
  asc?: InputMaybe<BrandOrderable>;
  desc?: InputMaybe<BrandOrderable>;
  then?: InputMaybe<BrandOrder>;
};

export enum BrandOrderable {
  BrandId = 'brand_id',
  Name = 'name'
}

export type BrandPatch = {
  models?: InputMaybe<Array<InputMaybe<ModelRef>>>;
  name?: InputMaybe<Scalars['String']>;
};

export type BrandRef = {
  brand_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  models?: InputMaybe<Array<InputMaybe<ModelRef>>>;
  name?: InputMaybe<Scalars['String']>;
};

export type BulkApprovalInput = {
  bankConfirmationStatus?: InputMaybe<Scalars['String']>;
  bidStatus?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  finalBidAmount?: InputMaybe<Scalars['Int']>;
  proposedBidAmount?: InputMaybe<Scalars['Int']>;
  regNo?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};

export type BulkApprovalResponse = {
  __typename?: 'BulkApprovalResponse';
  bankConfirmationStatus?: Maybe<Scalars['String']>;
  bidStatus?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  failureReason?: Maybe<Scalars['String']>;
  finalBidAmount?: Maybe<Scalars['Int']>;
  processingStatus?: Maybe<Scalars['String']>;
  proposedBidAmount?: Maybe<Scalars['Int']>;
  regNo?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
};

export type BulkApprovalResponseAggregateResult = {
  __typename?: 'BulkApprovalResponseAggregateResult';
  bankConfirmationStatusMax?: Maybe<Scalars['String']>;
  bankConfirmationStatusMin?: Maybe<Scalars['String']>;
  bidStatusMax?: Maybe<Scalars['String']>;
  bidStatusMin?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  emailMax?: Maybe<Scalars['String']>;
  emailMin?: Maybe<Scalars['String']>;
  failureReasonMax?: Maybe<Scalars['String']>;
  failureReasonMin?: Maybe<Scalars['String']>;
  finalBidAmountAvg?: Maybe<Scalars['Float']>;
  finalBidAmountMax?: Maybe<Scalars['Int']>;
  finalBidAmountMin?: Maybe<Scalars['Int']>;
  finalBidAmountSum?: Maybe<Scalars['Int']>;
  processingStatusMax?: Maybe<Scalars['String']>;
  processingStatusMin?: Maybe<Scalars['String']>;
  proposedBidAmountAvg?: Maybe<Scalars['Float']>;
  proposedBidAmountMax?: Maybe<Scalars['Int']>;
  proposedBidAmountMin?: Maybe<Scalars['Int']>;
  proposedBidAmountSum?: Maybe<Scalars['Int']>;
  regNoMax?: Maybe<Scalars['String']>;
  regNoMin?: Maybe<Scalars['String']>;
  sourceMax?: Maybe<Scalars['String']>;
  sourceMin?: Maybe<Scalars['String']>;
};

export type BulkApprovalResponseFilter = {
  and?: InputMaybe<Array<InputMaybe<BulkApprovalResponseFilter>>>;
  has?: InputMaybe<Array<InputMaybe<BulkApprovalResponseHasFilter>>>;
  not?: InputMaybe<BulkApprovalResponseFilter>;
  or?: InputMaybe<Array<InputMaybe<BulkApprovalResponseFilter>>>;
};

export enum BulkApprovalResponseHasFilter {
  BankConfirmationStatus = 'bankConfirmationStatus',
  BidStatus = 'bidStatus',
  Email = 'email',
  FailureReason = 'failureReason',
  FinalBidAmount = 'finalBidAmount',
  ProcessingStatus = 'processingStatus',
  ProposedBidAmount = 'proposedBidAmount',
  RegNo = 'regNo',
  Source = 'source'
}

export type BulkApprovalResponseOrder = {
  asc?: InputMaybe<BulkApprovalResponseOrderable>;
  desc?: InputMaybe<BulkApprovalResponseOrderable>;
  then?: InputMaybe<BulkApprovalResponseOrder>;
};

export enum BulkApprovalResponseOrderable {
  BankConfirmationStatus = 'bankConfirmationStatus',
  BidStatus = 'bidStatus',
  Email = 'email',
  FailureReason = 'failureReason',
  FinalBidAmount = 'finalBidAmount',
  ProcessingStatus = 'processingStatus',
  ProposedBidAmount = 'proposedBidAmount',
  RegNo = 'regNo',
  Source = 'source'
}

export type BulkApprovalResponsePatch = {
  bankConfirmationStatus?: InputMaybe<Scalars['String']>;
  bidStatus?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  failureReason?: InputMaybe<Scalars['String']>;
  finalBidAmount?: InputMaybe<Scalars['Int']>;
  processingStatus?: InputMaybe<Scalars['String']>;
  proposedBidAmount?: InputMaybe<Scalars['Int']>;
  regNo?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};

export type BulkApprovalResponseRef = {
  bankConfirmationStatus?: InputMaybe<Scalars['String']>;
  bidStatus?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  failureReason?: InputMaybe<Scalars['String']>;
  finalBidAmount?: InputMaybe<Scalars['Int']>;
  processingStatus?: InputMaybe<Scalars['String']>;
  proposedBidAmount?: InputMaybe<Scalars['Int']>;
  regNo?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};

export type BulkLeadInput = {
  auctionByBank?: InputMaybe<Scalars['String']>;
  chassisNumber?: InputMaybe<Scalars['String']>;
  createById?: InputMaybe<Scalars['String']>;
  demandAmount?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  engineNumber?: InputMaybe<Scalars['String']>;
  hoursMeter?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  manufacturingDate?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  ownershipType?: InputMaybe<Scalars['String']>;
  regNo?: InputMaybe<Scalars['String']>;
  registrationState?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export enum CenterStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  Pending = 'PENDING'
}

export type CenterStatus_Hash = {
  eq?: InputMaybe<CenterStatus>;
  in?: InputMaybe<Array<InputMaybe<CenterStatus>>>;
};

export type CenterlizeLocationDistrcitsResponse = {
  __typename?: 'CenterlizeLocationDistrcitsResponse';
  data?: Maybe<Array<Maybe<CenterlizeLocationDistrict>>>;
  dataAggregate?: Maybe<CenterlizeLocationDistrictAggregateResult>;
  msg?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};


export type CenterlizeLocationDistrcitsResponseDataArgs = {
  filter?: InputMaybe<CenterlizeLocationDistrictFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CenterlizeLocationDistrictOrder>;
};


export type CenterlizeLocationDistrcitsResponseDataAggregateArgs = {
  filter?: InputMaybe<CenterlizeLocationDistrictFilter>;
};

export type CenterlizeLocationDistrcitsResponseAggregateResult = {
  __typename?: 'CenterlizeLocationDistrcitsResponseAggregateResult';
  count?: Maybe<Scalars['Int']>;
  msgMax?: Maybe<Scalars['String']>;
  msgMin?: Maybe<Scalars['String']>;
};

export type CenterlizeLocationDistrcitsResponseFilter = {
  and?: InputMaybe<Array<InputMaybe<CenterlizeLocationDistrcitsResponseFilter>>>;
  has?: InputMaybe<Array<InputMaybe<CenterlizeLocationDistrcitsResponseHasFilter>>>;
  not?: InputMaybe<CenterlizeLocationDistrcitsResponseFilter>;
  or?: InputMaybe<Array<InputMaybe<CenterlizeLocationDistrcitsResponseFilter>>>;
};

export enum CenterlizeLocationDistrcitsResponseHasFilter {
  Data = 'data',
  Msg = 'msg',
  Status = 'status'
}

export type CenterlizeLocationDistrcitsResponseOrder = {
  asc?: InputMaybe<CenterlizeLocationDistrcitsResponseOrderable>;
  desc?: InputMaybe<CenterlizeLocationDistrcitsResponseOrderable>;
  then?: InputMaybe<CenterlizeLocationDistrcitsResponseOrder>;
};

export enum CenterlizeLocationDistrcitsResponseOrderable {
  Msg = 'msg'
}

export type CenterlizeLocationDistrcitsResponsePatch = {
  data?: InputMaybe<Array<InputMaybe<CenterlizeLocationDistrictRef>>>;
  msg?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type CenterlizeLocationDistrcitsResponseRef = {
  data?: InputMaybe<Array<InputMaybe<CenterlizeLocationDistrictRef>>>;
  msg?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type CenterlizeLocationDistrict = {
  __typename?: 'CenterlizeLocationDistrict';
  district_id?: Maybe<Scalars['Int']>;
  district_name?: Maybe<Scalars['String']>;
  state_id?: Maybe<Scalars['Int']>;
  state_name?: Maybe<Scalars['String']>;
  tr_district_id?: Maybe<Scalars['Int']>;
  tr_state_id?: Maybe<Scalars['Int']>;
};

export type CenterlizeLocationDistrictAggregateResult = {
  __typename?: 'CenterlizeLocationDistrictAggregateResult';
  count?: Maybe<Scalars['Int']>;
  district_idAvg?: Maybe<Scalars['Float']>;
  district_idMax?: Maybe<Scalars['Int']>;
  district_idMin?: Maybe<Scalars['Int']>;
  district_idSum?: Maybe<Scalars['Int']>;
  district_nameMax?: Maybe<Scalars['String']>;
  district_nameMin?: Maybe<Scalars['String']>;
  state_idAvg?: Maybe<Scalars['Float']>;
  state_idMax?: Maybe<Scalars['Int']>;
  state_idMin?: Maybe<Scalars['Int']>;
  state_idSum?: Maybe<Scalars['Int']>;
  state_nameMax?: Maybe<Scalars['String']>;
  state_nameMin?: Maybe<Scalars['String']>;
  tr_district_idAvg?: Maybe<Scalars['Float']>;
  tr_district_idMax?: Maybe<Scalars['Int']>;
  tr_district_idMin?: Maybe<Scalars['Int']>;
  tr_district_idSum?: Maybe<Scalars['Int']>;
  tr_state_idAvg?: Maybe<Scalars['Float']>;
  tr_state_idMax?: Maybe<Scalars['Int']>;
  tr_state_idMin?: Maybe<Scalars['Int']>;
  tr_state_idSum?: Maybe<Scalars['Int']>;
};

export type CenterlizeLocationDistrictFilter = {
  and?: InputMaybe<Array<InputMaybe<CenterlizeLocationDistrictFilter>>>;
  has?: InputMaybe<Array<InputMaybe<CenterlizeLocationDistrictHasFilter>>>;
  not?: InputMaybe<CenterlizeLocationDistrictFilter>;
  or?: InputMaybe<Array<InputMaybe<CenterlizeLocationDistrictFilter>>>;
};

export enum CenterlizeLocationDistrictHasFilter {
  DistrictId = 'district_id',
  DistrictName = 'district_name',
  StateId = 'state_id',
  StateName = 'state_name',
  TrDistrictId = 'tr_district_id',
  TrStateId = 'tr_state_id'
}

export type CenterlizeLocationDistrictOrder = {
  asc?: InputMaybe<CenterlizeLocationDistrictOrderable>;
  desc?: InputMaybe<CenterlizeLocationDistrictOrderable>;
  then?: InputMaybe<CenterlizeLocationDistrictOrder>;
};

export enum CenterlizeLocationDistrictOrderable {
  DistrictId = 'district_id',
  DistrictName = 'district_name',
  StateId = 'state_id',
  StateName = 'state_name',
  TrDistrictId = 'tr_district_id',
  TrStateId = 'tr_state_id'
}

export type CenterlizeLocationDistrictPatch = {
  district_id?: InputMaybe<Scalars['Int']>;
  district_name?: InputMaybe<Scalars['String']>;
  state_id?: InputMaybe<Scalars['Int']>;
  state_name?: InputMaybe<Scalars['String']>;
  tr_district_id?: InputMaybe<Scalars['Int']>;
  tr_state_id?: InputMaybe<Scalars['Int']>;
};

export type CenterlizeLocationDistrictRef = {
  district_id?: InputMaybe<Scalars['Int']>;
  district_name?: InputMaybe<Scalars['String']>;
  state_id?: InputMaybe<Scalars['Int']>;
  state_name?: InputMaybe<Scalars['String']>;
  tr_district_id?: InputMaybe<Scalars['Int']>;
  tr_state_id?: InputMaybe<Scalars['Int']>;
};

export type CenterlizeLocationStates = {
  __typename?: 'CenterlizeLocationStates';
  GSTNumber?: Maybe<Scalars['String']>;
  state_code?: Maybe<Scalars['String']>;
  state_id?: Maybe<Scalars['Int']>;
  state_name?: Maybe<Scalars['String']>;
  tr_state_id?: Maybe<Scalars['Int']>;
};

export type CenterlizeLocationStatesAggregateResult = {
  __typename?: 'CenterlizeLocationStatesAggregateResult';
  GSTNumberMax?: Maybe<Scalars['String']>;
  GSTNumberMin?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  state_codeMax?: Maybe<Scalars['String']>;
  state_codeMin?: Maybe<Scalars['String']>;
  state_idAvg?: Maybe<Scalars['Float']>;
  state_idMax?: Maybe<Scalars['Int']>;
  state_idMin?: Maybe<Scalars['Int']>;
  state_idSum?: Maybe<Scalars['Int']>;
  state_nameMax?: Maybe<Scalars['String']>;
  state_nameMin?: Maybe<Scalars['String']>;
  tr_state_idAvg?: Maybe<Scalars['Float']>;
  tr_state_idMax?: Maybe<Scalars['Int']>;
  tr_state_idMin?: Maybe<Scalars['Int']>;
  tr_state_idSum?: Maybe<Scalars['Int']>;
};

export type CenterlizeLocationStatesFilter = {
  and?: InputMaybe<Array<InputMaybe<CenterlizeLocationStatesFilter>>>;
  has?: InputMaybe<Array<InputMaybe<CenterlizeLocationStatesHasFilter>>>;
  not?: InputMaybe<CenterlizeLocationStatesFilter>;
  or?: InputMaybe<Array<InputMaybe<CenterlizeLocationStatesFilter>>>;
};

export enum CenterlizeLocationStatesHasFilter {
  GstNumber = 'GSTNumber',
  StateCode = 'state_code',
  StateId = 'state_id',
  StateName = 'state_name',
  TrStateId = 'tr_state_id'
}

export type CenterlizeLocationStatesOrder = {
  asc?: InputMaybe<CenterlizeLocationStatesOrderable>;
  desc?: InputMaybe<CenterlizeLocationStatesOrderable>;
  then?: InputMaybe<CenterlizeLocationStatesOrder>;
};

export enum CenterlizeLocationStatesOrderable {
  GstNumber = 'GSTNumber',
  StateCode = 'state_code',
  StateId = 'state_id',
  StateName = 'state_name',
  TrStateId = 'tr_state_id'
}

export type CenterlizeLocationStatesPatch = {
  GSTNumber?: InputMaybe<Scalars['String']>;
  state_code?: InputMaybe<Scalars['String']>;
  state_id?: InputMaybe<Scalars['Int']>;
  state_name?: InputMaybe<Scalars['String']>;
  tr_state_id?: InputMaybe<Scalars['Int']>;
};

export type CenterlizeLocationStatesRef = {
  GSTNumber?: InputMaybe<Scalars['String']>;
  state_code?: InputMaybe<Scalars['String']>;
  state_id?: InputMaybe<Scalars['Int']>;
  state_name?: InputMaybe<Scalars['String']>;
  tr_state_id?: InputMaybe<Scalars['Int']>;
};

export type CenterlizeLocationStatesResponse = {
  __typename?: 'CenterlizeLocationStatesResponse';
  data?: Maybe<Array<Maybe<CenterlizeLocationStates>>>;
  dataAggregate?: Maybe<CenterlizeLocationStatesAggregateResult>;
  msg?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};


export type CenterlizeLocationStatesResponseDataArgs = {
  filter?: InputMaybe<CenterlizeLocationStatesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CenterlizeLocationStatesOrder>;
};


export type CenterlizeLocationStatesResponseDataAggregateArgs = {
  filter?: InputMaybe<CenterlizeLocationStatesFilter>;
};

export type CenterlizeLocationStatesResponseAggregateResult = {
  __typename?: 'CenterlizeLocationStatesResponseAggregateResult';
  count?: Maybe<Scalars['Int']>;
  msgMax?: Maybe<Scalars['String']>;
  msgMin?: Maybe<Scalars['String']>;
};

export type CenterlizeLocationStatesResponseFilter = {
  and?: InputMaybe<Array<InputMaybe<CenterlizeLocationStatesResponseFilter>>>;
  has?: InputMaybe<Array<InputMaybe<CenterlizeLocationStatesResponseHasFilter>>>;
  not?: InputMaybe<CenterlizeLocationStatesResponseFilter>;
  or?: InputMaybe<Array<InputMaybe<CenterlizeLocationStatesResponseFilter>>>;
};

export enum CenterlizeLocationStatesResponseHasFilter {
  Data = 'data',
  Msg = 'msg',
  Status = 'status'
}

export type CenterlizeLocationStatesResponseOrder = {
  asc?: InputMaybe<CenterlizeLocationStatesResponseOrderable>;
  desc?: InputMaybe<CenterlizeLocationStatesResponseOrderable>;
  then?: InputMaybe<CenterlizeLocationStatesResponseOrder>;
};

export enum CenterlizeLocationStatesResponseOrderable {
  Msg = 'msg'
}

export type CenterlizeLocationStatesResponsePatch = {
  data?: InputMaybe<Array<InputMaybe<CenterlizeLocationStatesRef>>>;
  msg?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type CenterlizeLocationStatesResponseRef = {
  data?: InputMaybe<Array<InputMaybe<CenterlizeLocationStatesRef>>>;
  msg?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type CenterlizeLocationTehsil = {
  __typename?: 'CenterlizeLocationTehsil';
  district_id?: Maybe<Scalars['Int']>;
  district_name?: Maybe<Scalars['String']>;
  state_id?: Maybe<Scalars['Int']>;
  state_name?: Maybe<Scalars['String']>;
  tehsil_id?: Maybe<Scalars['Int']>;
  tehsil_name?: Maybe<Scalars['String']>;
  tr_district_id?: Maybe<Scalars['Int']>;
  tr_state_id?: Maybe<Scalars['Int']>;
  tr_tehsil_id?: Maybe<Scalars['Int']>;
};

export type CenterlizeLocationTehsilAggregateResult = {
  __typename?: 'CenterlizeLocationTehsilAggregateResult';
  count?: Maybe<Scalars['Int']>;
  district_idAvg?: Maybe<Scalars['Float']>;
  district_idMax?: Maybe<Scalars['Int']>;
  district_idMin?: Maybe<Scalars['Int']>;
  district_idSum?: Maybe<Scalars['Int']>;
  district_nameMax?: Maybe<Scalars['String']>;
  district_nameMin?: Maybe<Scalars['String']>;
  state_idAvg?: Maybe<Scalars['Float']>;
  state_idMax?: Maybe<Scalars['Int']>;
  state_idMin?: Maybe<Scalars['Int']>;
  state_idSum?: Maybe<Scalars['Int']>;
  state_nameMax?: Maybe<Scalars['String']>;
  state_nameMin?: Maybe<Scalars['String']>;
  tehsil_idAvg?: Maybe<Scalars['Float']>;
  tehsil_idMax?: Maybe<Scalars['Int']>;
  tehsil_idMin?: Maybe<Scalars['Int']>;
  tehsil_idSum?: Maybe<Scalars['Int']>;
  tehsil_nameMax?: Maybe<Scalars['String']>;
  tehsil_nameMin?: Maybe<Scalars['String']>;
  tr_district_idAvg?: Maybe<Scalars['Float']>;
  tr_district_idMax?: Maybe<Scalars['Int']>;
  tr_district_idMin?: Maybe<Scalars['Int']>;
  tr_district_idSum?: Maybe<Scalars['Int']>;
  tr_state_idAvg?: Maybe<Scalars['Float']>;
  tr_state_idMax?: Maybe<Scalars['Int']>;
  tr_state_idMin?: Maybe<Scalars['Int']>;
  tr_state_idSum?: Maybe<Scalars['Int']>;
  tr_tehsil_idAvg?: Maybe<Scalars['Float']>;
  tr_tehsil_idMax?: Maybe<Scalars['Int']>;
  tr_tehsil_idMin?: Maybe<Scalars['Int']>;
  tr_tehsil_idSum?: Maybe<Scalars['Int']>;
};

export type CenterlizeLocationTehsilFilter = {
  and?: InputMaybe<Array<InputMaybe<CenterlizeLocationTehsilFilter>>>;
  has?: InputMaybe<Array<InputMaybe<CenterlizeLocationTehsilHasFilter>>>;
  not?: InputMaybe<CenterlizeLocationTehsilFilter>;
  or?: InputMaybe<Array<InputMaybe<CenterlizeLocationTehsilFilter>>>;
};

export enum CenterlizeLocationTehsilHasFilter {
  DistrictId = 'district_id',
  DistrictName = 'district_name',
  StateId = 'state_id',
  StateName = 'state_name',
  TehsilId = 'tehsil_id',
  TehsilName = 'tehsil_name',
  TrDistrictId = 'tr_district_id',
  TrStateId = 'tr_state_id',
  TrTehsilId = 'tr_tehsil_id'
}

export type CenterlizeLocationTehsilOrder = {
  asc?: InputMaybe<CenterlizeLocationTehsilOrderable>;
  desc?: InputMaybe<CenterlizeLocationTehsilOrderable>;
  then?: InputMaybe<CenterlizeLocationTehsilOrder>;
};

export enum CenterlizeLocationTehsilOrderable {
  DistrictId = 'district_id',
  DistrictName = 'district_name',
  StateId = 'state_id',
  StateName = 'state_name',
  TehsilId = 'tehsil_id',
  TehsilName = 'tehsil_name',
  TrDistrictId = 'tr_district_id',
  TrStateId = 'tr_state_id',
  TrTehsilId = 'tr_tehsil_id'
}

export type CenterlizeLocationTehsilPatch = {
  district_id?: InputMaybe<Scalars['Int']>;
  district_name?: InputMaybe<Scalars['String']>;
  state_id?: InputMaybe<Scalars['Int']>;
  state_name?: InputMaybe<Scalars['String']>;
  tehsil_id?: InputMaybe<Scalars['Int']>;
  tehsil_name?: InputMaybe<Scalars['String']>;
  tr_district_id?: InputMaybe<Scalars['Int']>;
  tr_state_id?: InputMaybe<Scalars['Int']>;
  tr_tehsil_id?: InputMaybe<Scalars['Int']>;
};

export type CenterlizeLocationTehsilRef = {
  district_id?: InputMaybe<Scalars['Int']>;
  district_name?: InputMaybe<Scalars['String']>;
  state_id?: InputMaybe<Scalars['Int']>;
  state_name?: InputMaybe<Scalars['String']>;
  tehsil_id?: InputMaybe<Scalars['Int']>;
  tehsil_name?: InputMaybe<Scalars['String']>;
  tr_district_id?: InputMaybe<Scalars['Int']>;
  tr_state_id?: InputMaybe<Scalars['Int']>;
  tr_tehsil_id?: InputMaybe<Scalars['Int']>;
};

export type CenterlizeLocationTehsilResponse = {
  __typename?: 'CenterlizeLocationTehsilResponse';
  data?: Maybe<Array<Maybe<CenterlizeLocationTehsil>>>;
  dataAggregate?: Maybe<CenterlizeLocationTehsilAggregateResult>;
  msg?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};


export type CenterlizeLocationTehsilResponseDataArgs = {
  filter?: InputMaybe<CenterlizeLocationTehsilFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CenterlizeLocationTehsilOrder>;
};


export type CenterlizeLocationTehsilResponseDataAggregateArgs = {
  filter?: InputMaybe<CenterlizeLocationTehsilFilter>;
};

export type CenterlizeLocationTehsilResponseAggregateResult = {
  __typename?: 'CenterlizeLocationTehsilResponseAggregateResult';
  count?: Maybe<Scalars['Int']>;
  msgMax?: Maybe<Scalars['String']>;
  msgMin?: Maybe<Scalars['String']>;
};

export type CenterlizeLocationTehsilResponseFilter = {
  and?: InputMaybe<Array<InputMaybe<CenterlizeLocationTehsilResponseFilter>>>;
  has?: InputMaybe<Array<InputMaybe<CenterlizeLocationTehsilResponseHasFilter>>>;
  not?: InputMaybe<CenterlizeLocationTehsilResponseFilter>;
  or?: InputMaybe<Array<InputMaybe<CenterlizeLocationTehsilResponseFilter>>>;
};

export enum CenterlizeLocationTehsilResponseHasFilter {
  Data = 'data',
  Msg = 'msg',
  Status = 'status'
}

export type CenterlizeLocationTehsilResponseOrder = {
  asc?: InputMaybe<CenterlizeLocationTehsilResponseOrderable>;
  desc?: InputMaybe<CenterlizeLocationTehsilResponseOrderable>;
  then?: InputMaybe<CenterlizeLocationTehsilResponseOrder>;
};

export enum CenterlizeLocationTehsilResponseOrderable {
  Msg = 'msg'
}

export type CenterlizeLocationTehsilResponsePatch = {
  data?: InputMaybe<Array<InputMaybe<CenterlizeLocationTehsilRef>>>;
  msg?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type CenterlizeLocationTehsilResponseRef = {
  data?: InputMaybe<Array<InputMaybe<CenterlizeLocationTehsilRef>>>;
  msg?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type Centre = {
  __typename?: 'Centre';
  TJCentre?: Maybe<TjCentre>;
  address?: Maybe<Scalars['String']>;
  capacity?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  district?: Maybe<Scalars['String']>;
  employees?: Maybe<Array<Maybe<User>>>;
  employeesAggregate?: Maybe<UserAggregateResult>;
  id: Scalars['ID'];
  /** to be deprecated */
  incharge?: Maybe<User>;
  issues?: Maybe<Array<Maybe<Issue>>>;
  issuesAggregate?: Maybe<IssueAggregateResult>;
  leads?: Maybe<Array<Maybe<Lead>>>;
  leadsAggregate?: Maybe<LeadAggregateResult>;
  location?: Maybe<Point>;
  managedBy?: Maybe<Array<Maybe<User>>>;
  managedByAggregate?: Maybe<UserAggregateResult>;
  name: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  pincode?: Maybe<Scalars['Int']>;
  /** Assuming there will always be one inventory per centre, we can directly reference */
  purchases?: Maybe<Array<Maybe<Purchase>>>;
  purchasesAggregate?: Maybe<PurchaseAggregateResult>;
  regNo?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<CenterStatus>;
  tehsil?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type CentreTjCentreArgs = {
  filter?: InputMaybe<TjCentreFilter>;
};


export type CentreEmployeesArgs = {
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<UserOrder>;
};


export type CentreEmployeesAggregateArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type CentreInchargeArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type CentreIssuesArgs = {
  filter?: InputMaybe<IssueFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<IssueOrder>;
};


export type CentreIssuesAggregateArgs = {
  filter?: InputMaybe<IssueFilter>;
};


export type CentreLeadsArgs = {
  filter?: InputMaybe<LeadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadOrder>;
};


export type CentreLeadsAggregateArgs = {
  filter?: InputMaybe<LeadFilter>;
};


export type CentreManagedByArgs = {
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<UserOrder>;
};


export type CentreManagedByAggregateArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type CentrePurchasesArgs = {
  filter?: InputMaybe<PurchaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PurchaseOrder>;
};


export type CentrePurchasesAggregateArgs = {
  filter?: InputMaybe<PurchaseFilter>;
};

export type CentreAggregateResult = {
  __typename?: 'CentreAggregateResult';
  addressMax?: Maybe<Scalars['String']>;
  addressMin?: Maybe<Scalars['String']>;
  capacityAvg?: Maybe<Scalars['Float']>;
  capacityMax?: Maybe<Scalars['Int']>;
  capacityMin?: Maybe<Scalars['Int']>;
  capacitySum?: Maybe<Scalars['Int']>;
  cityMax?: Maybe<Scalars['String']>;
  cityMin?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  createdAtMax?: Maybe<Scalars['DateTime']>;
  createdAtMin?: Maybe<Scalars['DateTime']>;
  districtMax?: Maybe<Scalars['String']>;
  districtMin?: Maybe<Scalars['String']>;
  nameMax?: Maybe<Scalars['String']>;
  nameMin?: Maybe<Scalars['String']>;
  phoneNumberMax?: Maybe<Scalars['String']>;
  phoneNumberMin?: Maybe<Scalars['String']>;
  pincodeAvg?: Maybe<Scalars['Float']>;
  pincodeMax?: Maybe<Scalars['Int']>;
  pincodeMin?: Maybe<Scalars['Int']>;
  pincodeSum?: Maybe<Scalars['Int']>;
  regNoMax?: Maybe<Scalars['String']>;
  regNoMin?: Maybe<Scalars['String']>;
  stateMax?: Maybe<Scalars['String']>;
  stateMin?: Maybe<Scalars['String']>;
  tehsilMax?: Maybe<Scalars['String']>;
  tehsilMin?: Maybe<Scalars['String']>;
  updatedAtMax?: Maybe<Scalars['DateTime']>;
  updatedAtMin?: Maybe<Scalars['DateTime']>;
};

export type CentreAggregates = {
  __typename?: 'CentreAggregates';
  bookedVehiclesCount?: Maybe<Scalars['Int']>;
  centreId?: Maybe<Scalars['String']>;
  centreName?: Maybe<Scalars['String']>;
  inStockVehiclesCount?: Maybe<Scalars['Int']>;
  soldAndDeliveredVehicleCount?: Maybe<Scalars['Int']>;
  totalInventory?: Maybe<Scalars['Int']>;
};

export type CentreAggregatesAggregateResult = {
  __typename?: 'CentreAggregatesAggregateResult';
  bookedVehiclesCountAvg?: Maybe<Scalars['Float']>;
  bookedVehiclesCountMax?: Maybe<Scalars['Int']>;
  bookedVehiclesCountMin?: Maybe<Scalars['Int']>;
  bookedVehiclesCountSum?: Maybe<Scalars['Int']>;
  centreIdMax?: Maybe<Scalars['String']>;
  centreIdMin?: Maybe<Scalars['String']>;
  centreNameMax?: Maybe<Scalars['String']>;
  centreNameMin?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  inStockVehiclesCountAvg?: Maybe<Scalars['Float']>;
  inStockVehiclesCountMax?: Maybe<Scalars['Int']>;
  inStockVehiclesCountMin?: Maybe<Scalars['Int']>;
  inStockVehiclesCountSum?: Maybe<Scalars['Int']>;
  soldAndDeliveredVehicleCountAvg?: Maybe<Scalars['Float']>;
  soldAndDeliveredVehicleCountMax?: Maybe<Scalars['Int']>;
  soldAndDeliveredVehicleCountMin?: Maybe<Scalars['Int']>;
  soldAndDeliveredVehicleCountSum?: Maybe<Scalars['Int']>;
  totalInventoryAvg?: Maybe<Scalars['Float']>;
  totalInventoryMax?: Maybe<Scalars['Int']>;
  totalInventoryMin?: Maybe<Scalars['Int']>;
  totalInventorySum?: Maybe<Scalars['Int']>;
};

export type CentreAggregatesFilter = {
  and?: InputMaybe<Array<InputMaybe<CentreAggregatesFilter>>>;
  has?: InputMaybe<Array<InputMaybe<CentreAggregatesHasFilter>>>;
  not?: InputMaybe<CentreAggregatesFilter>;
  or?: InputMaybe<Array<InputMaybe<CentreAggregatesFilter>>>;
};

export enum CentreAggregatesHasFilter {
  BookedVehiclesCount = 'bookedVehiclesCount',
  CentreId = 'centreId',
  CentreName = 'centreName',
  InStockVehiclesCount = 'inStockVehiclesCount',
  SoldAndDeliveredVehicleCount = 'soldAndDeliveredVehicleCount',
  TotalInventory = 'totalInventory'
}

export type CentreAggregatesOrder = {
  asc?: InputMaybe<CentreAggregatesOrderable>;
  desc?: InputMaybe<CentreAggregatesOrderable>;
  then?: InputMaybe<CentreAggregatesOrder>;
};

export enum CentreAggregatesOrderable {
  BookedVehiclesCount = 'bookedVehiclesCount',
  CentreId = 'centreId',
  CentreName = 'centreName',
  InStockVehiclesCount = 'inStockVehiclesCount',
  SoldAndDeliveredVehicleCount = 'soldAndDeliveredVehicleCount',
  TotalInventory = 'totalInventory'
}

export type CentreAggregatesPatch = {
  bookedVehiclesCount?: InputMaybe<Scalars['Int']>;
  centreId?: InputMaybe<Scalars['String']>;
  centreName?: InputMaybe<Scalars['String']>;
  inStockVehiclesCount?: InputMaybe<Scalars['Int']>;
  soldAndDeliveredVehicleCount?: InputMaybe<Scalars['Int']>;
  totalInventory?: InputMaybe<Scalars['Int']>;
};

export type CentreAggregatesRef = {
  bookedVehiclesCount?: InputMaybe<Scalars['Int']>;
  centreId?: InputMaybe<Scalars['String']>;
  centreName?: InputMaybe<Scalars['String']>;
  inStockVehiclesCount?: InputMaybe<Scalars['Int']>;
  soldAndDeliveredVehicleCount?: InputMaybe<Scalars['Int']>;
  totalInventory?: InputMaybe<Scalars['Int']>;
};

export type CentreFilter = {
  and?: InputMaybe<Array<InputMaybe<CentreFilter>>>;
  has?: InputMaybe<Array<InputMaybe<CentreHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  location?: InputMaybe<PointGeoFilter>;
  name?: InputMaybe<StringHashFilter_StringRegExpFilter_StringTermFilter>;
  not?: InputMaybe<CentreFilter>;
  or?: InputMaybe<Array<InputMaybe<CentreFilter>>>;
  state?: InputMaybe<StringTermFilter>;
  status?: InputMaybe<CenterStatus_Hash>;
};

export enum CentreHasFilter {
  TjCentre = 'TJCentre',
  Address = 'address',
  Capacity = 'capacity',
  City = 'city',
  CreatedAt = 'createdAt',
  District = 'district',
  Employees = 'employees',
  Incharge = 'incharge',
  Issues = 'issues',
  Leads = 'leads',
  Location = 'location',
  ManagedBy = 'managedBy',
  Name = 'name',
  PhoneNumber = 'phoneNumber',
  Pincode = 'pincode',
  Purchases = 'purchases',
  RegNo = 'regNo',
  State = 'state',
  Status = 'status',
  Tehsil = 'tehsil',
  UpdatedAt = 'updatedAt'
}

export type CentreOrder = {
  asc?: InputMaybe<CentreOrderable>;
  desc?: InputMaybe<CentreOrderable>;
  then?: InputMaybe<CentreOrder>;
};

export enum CentreOrderable {
  Address = 'address',
  Capacity = 'capacity',
  City = 'city',
  CreatedAt = 'createdAt',
  District = 'district',
  Name = 'name',
  PhoneNumber = 'phoneNumber',
  Pincode = 'pincode',
  RegNo = 'regNo',
  State = 'state',
  Tehsil = 'tehsil',
  UpdatedAt = 'updatedAt'
}

export type CentrePatch = {
  TJCentre?: InputMaybe<TjCentreRef>;
  address?: InputMaybe<Scalars['String']>;
  capacity?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  district?: InputMaybe<Scalars['String']>;
  employees?: InputMaybe<Array<InputMaybe<UserRef>>>;
  incharge?: InputMaybe<UserRef>;
  issues?: InputMaybe<Array<InputMaybe<IssueRef>>>;
  leads?: InputMaybe<Array<InputMaybe<LeadRef>>>;
  location?: InputMaybe<PointRef>;
  managedBy?: InputMaybe<Array<InputMaybe<UserRef>>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pincode?: InputMaybe<Scalars['Int']>;
  purchases?: InputMaybe<Array<InputMaybe<PurchaseRef>>>;
  regNo?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CenterStatus>;
  tehsil?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CentreRef = {
  TJCentre?: InputMaybe<TjCentreRef>;
  address?: InputMaybe<Scalars['String']>;
  capacity?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  district?: InputMaybe<Scalars['String']>;
  employees?: InputMaybe<Array<InputMaybe<UserRef>>>;
  id?: InputMaybe<Scalars['ID']>;
  incharge?: InputMaybe<UserRef>;
  issues?: InputMaybe<Array<InputMaybe<IssueRef>>>;
  leads?: InputMaybe<Array<InputMaybe<LeadRef>>>;
  location?: InputMaybe<PointRef>;
  managedBy?: InputMaybe<Array<InputMaybe<UserRef>>>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pincode?: InputMaybe<Scalars['Int']>;
  purchases?: InputMaybe<Array<InputMaybe<PurchaseRef>>>;
  regNo?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CenterStatus>;
  tehsil?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type City = {
  __typename?: 'City';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CityAggregateResult = {
  __typename?: 'CityAggregateResult';
  count?: Maybe<Scalars['Int']>;
  nameMax?: Maybe<Scalars['String']>;
  nameMin?: Maybe<Scalars['String']>;
};

export type CityFilter = {
  and?: InputMaybe<Array<InputMaybe<CityFilter>>>;
  has?: InputMaybe<Array<InputMaybe<CityHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<StringHashFilter>;
  not?: InputMaybe<CityFilter>;
  or?: InputMaybe<Array<InputMaybe<CityFilter>>>;
};

export enum CityHasFilter {
  Name = 'name'
}

export type CityOrder = {
  asc?: InputMaybe<CityOrderable>;
  desc?: InputMaybe<CityOrderable>;
  then?: InputMaybe<CityOrder>;
};

export enum CityOrderable {
  Name = 'name'
}

export type CityRef = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

export enum CloseEnquiryReason {
  BookTractor = 'BOOK_TRACTOR',
  CustomerNotResponding = 'CUSTOMER_NOT_RESPONDING',
  NotInterested = 'NOT_INTERESTED',
  PurchasedNewTractor = 'PURCHASED_NEW_TRACTOR',
  PurchasedUsedTractor = 'PURCHASED_USED_TRACTOR'
}

export type CommonEnquiryFilter = {
  brandId?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  centre?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateRange?: InputMaybe<EnquiryDateRange>;
  dateType?: InputMaybe<SelectTypeOfDate>;
  district?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enquiryType?: InputMaybe<EnquiryStatus>;
  first?: InputMaybe<Scalars['Int']>;
  modelId?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  searchString?: InputMaybe<Scalars['String']>;
  stateId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<StatusOfEnquiry>;
  tehsil?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  walkingType?: InputMaybe<EnquiryType>;
};

export type ContainsFilter = {
  point?: InputMaybe<PointRef>;
  polygon?: InputMaybe<PolygonRef>;
};

export type CreateBulkLeadResponse = {
  __typename?: 'CreateBulkLeadResponse';
  auctionByBank?: Maybe<Scalars['String']>;
  chassisNumber?: Maybe<Scalars['String']>;
  createById?: Maybe<Scalars['String']>;
  demandAmount?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  engineNumber?: Maybe<Scalars['String']>;
  failureReason?: Maybe<Scalars['String']>;
  hoursMeter?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  manufacturingDate?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  ownershipType?: Maybe<Scalars['String']>;
  processingStatus?: Maybe<Scalars['String']>;
  regNo?: Maybe<Scalars['String']>;
  registrationState?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type CreateBulkLeadResponseAggregateResult = {
  __typename?: 'CreateBulkLeadResponseAggregateResult';
  auctionByBankMax?: Maybe<Scalars['String']>;
  auctionByBankMin?: Maybe<Scalars['String']>;
  chassisNumberMax?: Maybe<Scalars['String']>;
  chassisNumberMin?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  createByIdMax?: Maybe<Scalars['String']>;
  createByIdMin?: Maybe<Scalars['String']>;
  demandAmountMax?: Maybe<Scalars['String']>;
  demandAmountMin?: Maybe<Scalars['String']>;
  emailMax?: Maybe<Scalars['String']>;
  emailMin?: Maybe<Scalars['String']>;
  engineNumberMax?: Maybe<Scalars['String']>;
  engineNumberMin?: Maybe<Scalars['String']>;
  failureReasonMax?: Maybe<Scalars['String']>;
  failureReasonMin?: Maybe<Scalars['String']>;
  hoursMeterMax?: Maybe<Scalars['String']>;
  hoursMeterMin?: Maybe<Scalars['String']>;
  makeMax?: Maybe<Scalars['String']>;
  makeMin?: Maybe<Scalars['String']>;
  manufacturingDateMax?: Maybe<Scalars['String']>;
  manufacturingDateMin?: Maybe<Scalars['String']>;
  modelMax?: Maybe<Scalars['String']>;
  modelMin?: Maybe<Scalars['String']>;
  ownershipTypeMax?: Maybe<Scalars['String']>;
  ownershipTypeMin?: Maybe<Scalars['String']>;
  processingStatusMax?: Maybe<Scalars['String']>;
  processingStatusMin?: Maybe<Scalars['String']>;
  regNoMax?: Maybe<Scalars['String']>;
  regNoMin?: Maybe<Scalars['String']>;
  registrationStateMax?: Maybe<Scalars['String']>;
  registrationStateMin?: Maybe<Scalars['String']>;
  remarkMax?: Maybe<Scalars['String']>;
  remarkMin?: Maybe<Scalars['String']>;
  sourceMax?: Maybe<Scalars['String']>;
  sourceMin?: Maybe<Scalars['String']>;
  statusMax?: Maybe<Scalars['String']>;
  statusMin?: Maybe<Scalars['String']>;
};

export type CreateBulkLeadResponseFilter = {
  and?: InputMaybe<Array<InputMaybe<CreateBulkLeadResponseFilter>>>;
  has?: InputMaybe<Array<InputMaybe<CreateBulkLeadResponseHasFilter>>>;
  not?: InputMaybe<CreateBulkLeadResponseFilter>;
  or?: InputMaybe<Array<InputMaybe<CreateBulkLeadResponseFilter>>>;
};

export enum CreateBulkLeadResponseHasFilter {
  AuctionByBank = 'auctionByBank',
  ChassisNumber = 'chassisNumber',
  CreateById = 'createById',
  DemandAmount = 'demandAmount',
  Email = 'email',
  EngineNumber = 'engineNumber',
  FailureReason = 'failureReason',
  HoursMeter = 'hoursMeter',
  Make = 'make',
  ManufacturingDate = 'manufacturingDate',
  Model = 'model',
  OwnershipType = 'ownershipType',
  ProcessingStatus = 'processingStatus',
  RegNo = 'regNo',
  RegistrationState = 'registrationState',
  Remark = 'remark',
  Source = 'source',
  Status = 'status'
}

export type CreateBulkLeadResponseOrder = {
  asc?: InputMaybe<CreateBulkLeadResponseOrderable>;
  desc?: InputMaybe<CreateBulkLeadResponseOrderable>;
  then?: InputMaybe<CreateBulkLeadResponseOrder>;
};

export enum CreateBulkLeadResponseOrderable {
  AuctionByBank = 'auctionByBank',
  ChassisNumber = 'chassisNumber',
  CreateById = 'createById',
  DemandAmount = 'demandAmount',
  Email = 'email',
  EngineNumber = 'engineNumber',
  FailureReason = 'failureReason',
  HoursMeter = 'hoursMeter',
  Make = 'make',
  ManufacturingDate = 'manufacturingDate',
  Model = 'model',
  OwnershipType = 'ownershipType',
  ProcessingStatus = 'processingStatus',
  RegNo = 'regNo',
  RegistrationState = 'registrationState',
  Remark = 'remark',
  Source = 'source',
  Status = 'status'
}

export type CreateBulkLeadResponsePatch = {
  auctionByBank?: InputMaybe<Scalars['String']>;
  chassisNumber?: InputMaybe<Scalars['String']>;
  createById?: InputMaybe<Scalars['String']>;
  demandAmount?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  engineNumber?: InputMaybe<Scalars['String']>;
  failureReason?: InputMaybe<Scalars['String']>;
  hoursMeter?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  manufacturingDate?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  ownershipType?: InputMaybe<Scalars['String']>;
  processingStatus?: InputMaybe<Scalars['String']>;
  regNo?: InputMaybe<Scalars['String']>;
  registrationState?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type CreateBulkLeadResponseRef = {
  auctionByBank?: InputMaybe<Scalars['String']>;
  chassisNumber?: InputMaybe<Scalars['String']>;
  createById?: InputMaybe<Scalars['String']>;
  demandAmount?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  engineNumber?: InputMaybe<Scalars['String']>;
  failureReason?: InputMaybe<Scalars['String']>;
  hoursMeter?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  manufacturingDate?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  ownershipType?: InputMaybe<Scalars['String']>;
  processingStatus?: InputMaybe<Scalars['String']>;
  regNo?: InputMaybe<Scalars['String']>;
  registrationState?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type CustomHttp = {
  body?: InputMaybe<Scalars['String']>;
  forwardHeaders?: InputMaybe<Array<Scalars['String']>>;
  graphql?: InputMaybe<Scalars['String']>;
  introspectionHeaders?: InputMaybe<Array<Scalars['String']>>;
  method: HttpMethod;
  mode?: InputMaybe<Mode>;
  secretHeaders?: InputMaybe<Array<Scalars['String']>>;
  skipIntrospection?: InputMaybe<Scalars['Boolean']>;
  url: Scalars['String'];
};

export type Customer = {
  __typename?: 'Customer';
  bookings?: Maybe<Array<Maybe<Booking>>>;
  bookingsAggregate?: Maybe<BookingAggregateResult>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerDistrict?: Maybe<District>;
  customerId?: Maybe<CustomerId>;
  customerState?: Maybe<StateCodeWithRegNumber>;
  customerTehsil?: Maybe<Tehsil>;
  district?: Maybe<Scalars['String']>;
  /** enquiries made by the customer */
  enquiries?: Maybe<Array<Maybe<Enquiry>>>;
  enquiriesAggregate?: Maybe<EnquiryAggregateResult>;
  enquiry?: Maybe<Enquiry>;
  /** auto_generated id */
  id: Scalars['ID'];
  idNumber?: Maybe<Scalars['String']>;
  idProofUrl?: Maybe<Scalars['String']>;
  identificationDocuments?: Maybe<IdentificationDocument>;
  name?: Maybe<Scalars['String']>;
  phoneNo: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  tehsil?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type CustomerBookingsArgs = {
  filter?: InputMaybe<BookingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<BookingOrder>;
};


export type CustomerBookingsAggregateArgs = {
  filter?: InputMaybe<BookingFilter>;
};


export type CustomerCustomerDistrictArgs = {
  filter?: InputMaybe<DistrictFilter>;
};


export type CustomerCustomerStateArgs = {
  filter?: InputMaybe<StateCodeWithRegNumberFilter>;
};


export type CustomerCustomerTehsilArgs = {
  filter?: InputMaybe<TehsilFilter>;
};


export type CustomerEnquiriesArgs = {
  filter?: InputMaybe<EnquiryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<EnquiryOrder>;
};


export type CustomerEnquiriesAggregateArgs = {
  filter?: InputMaybe<EnquiryFilter>;
};


export type CustomerEnquiryArgs = {
  filter?: InputMaybe<EnquiryFilter>;
};


export type CustomerIdentificationDocumentsArgs = {
  filter?: InputMaybe<IdentificationDocumentFilter>;
};

export type CustomerAggregateResult = {
  __typename?: 'CustomerAggregateResult';
  count?: Maybe<Scalars['Int']>;
  createdAtMax?: Maybe<Scalars['DateTime']>;
  createdAtMin?: Maybe<Scalars['DateTime']>;
  districtMax?: Maybe<Scalars['String']>;
  districtMin?: Maybe<Scalars['String']>;
  idNumberMax?: Maybe<Scalars['String']>;
  idNumberMin?: Maybe<Scalars['String']>;
  idProofUrlMax?: Maybe<Scalars['String']>;
  idProofUrlMin?: Maybe<Scalars['String']>;
  nameMax?: Maybe<Scalars['String']>;
  nameMin?: Maybe<Scalars['String']>;
  phoneNoMax?: Maybe<Scalars['String']>;
  phoneNoMin?: Maybe<Scalars['String']>;
  stateMax?: Maybe<Scalars['String']>;
  stateMin?: Maybe<Scalars['String']>;
  tehsilMax?: Maybe<Scalars['String']>;
  tehsilMin?: Maybe<Scalars['String']>;
  updatedAtMax?: Maybe<Scalars['DateTime']>;
  updatedAtMin?: Maybe<Scalars['DateTime']>;
};

export type CustomerFilter = {
  and?: InputMaybe<Array<InputMaybe<CustomerFilter>>>;
  has?: InputMaybe<Array<InputMaybe<CustomerHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<StringFullTextFilter_StringRegExpFilter>;
  not?: InputMaybe<CustomerFilter>;
  or?: InputMaybe<Array<InputMaybe<CustomerFilter>>>;
  phoneNo?: InputMaybe<StringFullTextFilter_StringHashFilter_StringRegExpFilter>;
};

export enum CustomerHasFilter {
  Bookings = 'bookings',
  CreatedAt = 'createdAt',
  CustomerDistrict = 'customerDistrict',
  CustomerId = 'customerId',
  CustomerState = 'customerState',
  CustomerTehsil = 'customerTehsil',
  District = 'district',
  Enquiries = 'enquiries',
  Enquiry = 'enquiry',
  IdNumber = 'idNumber',
  IdProofUrl = 'idProofUrl',
  IdentificationDocuments = 'identificationDocuments',
  Name = 'name',
  PhoneNo = 'phoneNo',
  State = 'state',
  Tehsil = 'tehsil',
  UpdatedAt = 'updatedAt'
}

export enum CustomerId {
  Aadhaar = 'AADHAAR',
  Pan = 'PAN'
}

export type CustomerOrder = {
  asc?: InputMaybe<CustomerOrderable>;
  desc?: InputMaybe<CustomerOrderable>;
  then?: InputMaybe<CustomerOrder>;
};

export enum CustomerOrderable {
  CreatedAt = 'createdAt',
  District = 'district',
  IdNumber = 'idNumber',
  IdProofUrl = 'idProofUrl',
  Name = 'name',
  PhoneNo = 'phoneNo',
  State = 'state',
  Tehsil = 'tehsil',
  UpdatedAt = 'updatedAt'
}

export type CustomerPatch = {
  bookings?: InputMaybe<Array<InputMaybe<BookingRef>>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerDistrict?: InputMaybe<DistrictRef>;
  customerId?: InputMaybe<CustomerId>;
  customerState?: InputMaybe<StateCodeWithRegNumberRef>;
  customerTehsil?: InputMaybe<TehsilRef>;
  district?: InputMaybe<Scalars['String']>;
  enquiries?: InputMaybe<Array<InputMaybe<EnquiryRef>>>;
  enquiry?: InputMaybe<EnquiryRef>;
  idNumber?: InputMaybe<Scalars['String']>;
  idProofUrl?: InputMaybe<Scalars['String']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentRef>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  tehsil?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CustomerRef = {
  bookings?: InputMaybe<Array<InputMaybe<BookingRef>>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerDistrict?: InputMaybe<DistrictRef>;
  customerId?: InputMaybe<CustomerId>;
  customerState?: InputMaybe<StateCodeWithRegNumberRef>;
  customerTehsil?: InputMaybe<TehsilRef>;
  district?: InputMaybe<Scalars['String']>;
  enquiries?: InputMaybe<Array<InputMaybe<EnquiryRef>>>;
  enquiry?: InputMaybe<EnquiryRef>;
  /** auto_generated id */
  id?: InputMaybe<Scalars['ID']>;
  idNumber?: InputMaybe<Scalars['String']>;
  idProofUrl?: InputMaybe<Scalars['String']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentRef>;
  name?: InputMaybe<Scalars['String']>;
  phoneNo?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  tehsil?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DateRange = {
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
};

export type DateTimeFilter = {
  between?: InputMaybe<DateTimeRange>;
  eq?: InputMaybe<Scalars['DateTime']>;
  ge?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  le?: InputMaybe<Scalars['DateTime']>;
  lt?: InputMaybe<Scalars['DateTime']>;
};

export type DateTimeRange = {
  max: Scalars['DateTime'];
  min: Scalars['DateTime'];
};

export enum DealStatus {
  Confirmed = 'CONFIRMED',
  NotConfirmed = 'NOT_CONFIRMED'
}

export type Dealer = {
  __typename?: 'Dealer';
  id: Scalars['ID'];
  leads?: Maybe<Array<Maybe<Lead>>>;
  leadsAggregate?: Maybe<LeadAggregateResult>;
  name?: Maybe<Scalars['String']>;
  phoneNo: Scalars['String'];
};


export type DealerLeadsArgs = {
  filter?: InputMaybe<LeadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadOrder>;
};


export type DealerLeadsAggregateArgs = {
  filter?: InputMaybe<LeadFilter>;
};

export type DealerAggregateResult = {
  __typename?: 'DealerAggregateResult';
  count?: Maybe<Scalars['Int']>;
  nameMax?: Maybe<Scalars['String']>;
  nameMin?: Maybe<Scalars['String']>;
  phoneNoMax?: Maybe<Scalars['String']>;
  phoneNoMin?: Maybe<Scalars['String']>;
};

export type DealerFilter = {
  and?: InputMaybe<Array<InputMaybe<DealerFilter>>>;
  has?: InputMaybe<Array<InputMaybe<DealerHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<DealerFilter>;
  or?: InputMaybe<Array<InputMaybe<DealerFilter>>>;
  phoneNo?: InputMaybe<StringHashFilter>;
};

export enum DealerHasFilter {
  Leads = 'leads',
  Name = 'name',
  PhoneNo = 'phoneNo'
}

export type DealerOrder = {
  asc?: InputMaybe<DealerOrderable>;
  desc?: InputMaybe<DealerOrderable>;
  then?: InputMaybe<DealerOrder>;
};

export enum DealerOrderable {
  Name = 'name',
  PhoneNo = 'phoneNo'
}

export type DealerPatch = {
  leads?: InputMaybe<Array<InputMaybe<LeadRef>>>;
  name?: InputMaybe<Scalars['String']>;
};

export type DealerRef = {
  id?: InputMaybe<Scalars['ID']>;
  leads?: InputMaybe<Array<InputMaybe<LeadRef>>>;
  name?: InputMaybe<Scalars['String']>;
  phoneNo?: InputMaybe<Scalars['String']>;
};

export type DealerStance = {
  __typename?: 'DealerStance';
  clearBlackList?: Maybe<Scalars['Boolean']>;
  clearChallan?: Maybe<Scalars['Boolean']>;
  clearHSRP?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  lead: Lead;
};


export type DealerStanceLeadArgs = {
  filter?: InputMaybe<LeadFilter>;
};

export type DealerStanceAggregateResult = {
  __typename?: 'DealerStanceAggregateResult';
  count?: Maybe<Scalars['Int']>;
};

export type DealerStanceFilter = {
  and?: InputMaybe<Array<InputMaybe<DealerStanceFilter>>>;
  has?: InputMaybe<Array<InputMaybe<DealerStanceHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<DealerStanceFilter>;
  or?: InputMaybe<Array<InputMaybe<DealerStanceFilter>>>;
};

export enum DealerStanceHasFilter {
  ClearBlackList = 'clearBlackList',
  ClearChallan = 'clearChallan',
  ClearHsrp = 'clearHSRP',
  Lead = 'lead'
}

export type DealerStancePatch = {
  clearBlackList?: InputMaybe<Scalars['Boolean']>;
  clearChallan?: InputMaybe<Scalars['Boolean']>;
  clearHSRP?: InputMaybe<Scalars['Boolean']>;
  lead?: InputMaybe<LeadRef>;
};

export type DealerStanceRef = {
  clearBlackList?: InputMaybe<Scalars['Boolean']>;
  clearChallan?: InputMaybe<Scalars['Boolean']>;
  clearHSRP?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  lead?: InputMaybe<LeadRef>;
};

export type DealershipDocument = {
  __typename?: 'DealershipDocument';
  approvalMailUrl?: Maybe<Document>;
  bankNOC?: Maybe<Document>;
  blacklist?: Maybe<Document>;
  challanUrl?: Maybe<Document>;
  form26?: Maybe<Document>;
  form28?: Maybe<Document>;
  form29?: Maybe<Document>;
  form30?: Maybe<Document>;
  form35?: Maybe<Document>;
  form36?: Maybe<Document>;
  form60?: Maybe<Document>;
  form60_sellerPan?: Maybe<Document>;
  hsrbProofUrl?: Maybe<Document>;
  hypothecationProofUrl?: Maybe<Document>;
  id: Scalars['ID'];
  insuranceCertificate?: Maybe<Document>;
  lead: Lead;
  loanForeclosure?: Maybe<Document>;
  ownerAddressProof?: Maybe<Document>;
  regNo: Scalars['String'];
  registrationCertificate?: Maybe<Document>;
  rtoVerificationProofUrl?: Maybe<Document>;
  sellerAadharCard?: Maybe<Document>;
  sellerPAN?: Maybe<Document>;
};


export type DealershipDocumentApprovalMailUrlArgs = {
  filter?: InputMaybe<DocumentFilter>;
};


export type DealershipDocumentBankNocArgs = {
  filter?: InputMaybe<DocumentFilter>;
};


export type DealershipDocumentBlacklistArgs = {
  filter?: InputMaybe<DocumentFilter>;
};


export type DealershipDocumentChallanUrlArgs = {
  filter?: InputMaybe<DocumentFilter>;
};


export type DealershipDocumentForm26Args = {
  filter?: InputMaybe<DocumentFilter>;
};


export type DealershipDocumentForm28Args = {
  filter?: InputMaybe<DocumentFilter>;
};


export type DealershipDocumentForm29Args = {
  filter?: InputMaybe<DocumentFilter>;
};


export type DealershipDocumentForm30Args = {
  filter?: InputMaybe<DocumentFilter>;
};


export type DealershipDocumentForm35Args = {
  filter?: InputMaybe<DocumentFilter>;
};


export type DealershipDocumentForm36Args = {
  filter?: InputMaybe<DocumentFilter>;
};


export type DealershipDocumentForm60Args = {
  filter?: InputMaybe<DocumentFilter>;
};


export type DealershipDocumentForm60_SellerPanArgs = {
  filter?: InputMaybe<DocumentFilter>;
};


export type DealershipDocumentHsrbProofUrlArgs = {
  filter?: InputMaybe<DocumentFilter>;
};


export type DealershipDocumentHypothecationProofUrlArgs = {
  filter?: InputMaybe<DocumentFilter>;
};


export type DealershipDocumentInsuranceCertificateArgs = {
  filter?: InputMaybe<DocumentFilter>;
};


export type DealershipDocumentLeadArgs = {
  filter?: InputMaybe<LeadFilter>;
};


export type DealershipDocumentLoanForeclosureArgs = {
  filter?: InputMaybe<DocumentFilter>;
};


export type DealershipDocumentOwnerAddressProofArgs = {
  filter?: InputMaybe<DocumentFilter>;
};


export type DealershipDocumentRegistrationCertificateArgs = {
  filter?: InputMaybe<DocumentFilter>;
};


export type DealershipDocumentRtoVerificationProofUrlArgs = {
  filter?: InputMaybe<DocumentFilter>;
};


export type DealershipDocumentSellerAadharCardArgs = {
  filter?: InputMaybe<DocumentFilter>;
};


export type DealershipDocumentSellerPanArgs = {
  filter?: InputMaybe<DocumentFilter>;
};

export type DealershipDocumentAggregateResult = {
  __typename?: 'DealershipDocumentAggregateResult';
  count?: Maybe<Scalars['Int']>;
  regNoMax?: Maybe<Scalars['String']>;
  regNoMin?: Maybe<Scalars['String']>;
};

export type DealershipDocumentFilter = {
  and?: InputMaybe<Array<InputMaybe<DealershipDocumentFilter>>>;
  has?: InputMaybe<Array<InputMaybe<DealershipDocumentHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<DealershipDocumentFilter>;
  or?: InputMaybe<Array<InputMaybe<DealershipDocumentFilter>>>;
  regNo?: InputMaybe<StringHashFilter>;
};

export enum DealershipDocumentHasFilter {
  ApprovalMailUrl = 'approvalMailUrl',
  BankNoc = 'bankNOC',
  Blacklist = 'blacklist',
  ChallanUrl = 'challanUrl',
  Form26 = 'form26',
  Form28 = 'form28',
  Form29 = 'form29',
  Form30 = 'form30',
  Form35 = 'form35',
  Form36 = 'form36',
  Form60 = 'form60',
  Form60SellerPan = 'form60_sellerPan',
  HsrbProofUrl = 'hsrbProofUrl',
  HypothecationProofUrl = 'hypothecationProofUrl',
  InsuranceCertificate = 'insuranceCertificate',
  Lead = 'lead',
  LoanForeclosure = 'loanForeclosure',
  OwnerAddressProof = 'ownerAddressProof',
  RegNo = 'regNo',
  RegistrationCertificate = 'registrationCertificate',
  RtoVerificationProofUrl = 'rtoVerificationProofUrl',
  SellerAadharCard = 'sellerAadharCard',
  SellerPan = 'sellerPAN'
}

export type DealershipDocumentOrder = {
  asc?: InputMaybe<DealershipDocumentOrderable>;
  desc?: InputMaybe<DealershipDocumentOrderable>;
  then?: InputMaybe<DealershipDocumentOrder>;
};

export enum DealershipDocumentOrderable {
  RegNo = 'regNo'
}

export type DealershipDocumentPatch = {
  approvalMailUrl?: InputMaybe<DocumentRef>;
  bankNOC?: InputMaybe<DocumentRef>;
  blacklist?: InputMaybe<DocumentRef>;
  challanUrl?: InputMaybe<DocumentRef>;
  form26?: InputMaybe<DocumentRef>;
  form28?: InputMaybe<DocumentRef>;
  form29?: InputMaybe<DocumentRef>;
  form30?: InputMaybe<DocumentRef>;
  form35?: InputMaybe<DocumentRef>;
  form36?: InputMaybe<DocumentRef>;
  form60?: InputMaybe<DocumentRef>;
  form60_sellerPan?: InputMaybe<DocumentRef>;
  hsrbProofUrl?: InputMaybe<DocumentRef>;
  hypothecationProofUrl?: InputMaybe<DocumentRef>;
  insuranceCertificate?: InputMaybe<DocumentRef>;
  lead?: InputMaybe<LeadRef>;
  loanForeclosure?: InputMaybe<DocumentRef>;
  ownerAddressProof?: InputMaybe<DocumentRef>;
  registrationCertificate?: InputMaybe<DocumentRef>;
  rtoVerificationProofUrl?: InputMaybe<DocumentRef>;
  sellerAadharCard?: InputMaybe<DocumentRef>;
  sellerPAN?: InputMaybe<DocumentRef>;
};

export type DealershipDocumentRef = {
  approvalMailUrl?: InputMaybe<DocumentRef>;
  bankNOC?: InputMaybe<DocumentRef>;
  blacklist?: InputMaybe<DocumentRef>;
  challanUrl?: InputMaybe<DocumentRef>;
  form26?: InputMaybe<DocumentRef>;
  form28?: InputMaybe<DocumentRef>;
  form29?: InputMaybe<DocumentRef>;
  form30?: InputMaybe<DocumentRef>;
  form35?: InputMaybe<DocumentRef>;
  form36?: InputMaybe<DocumentRef>;
  form60?: InputMaybe<DocumentRef>;
  form60_sellerPan?: InputMaybe<DocumentRef>;
  hsrbProofUrl?: InputMaybe<DocumentRef>;
  hypothecationProofUrl?: InputMaybe<DocumentRef>;
  id?: InputMaybe<Scalars['ID']>;
  insuranceCertificate?: InputMaybe<DocumentRef>;
  lead?: InputMaybe<LeadRef>;
  loanForeclosure?: InputMaybe<DocumentRef>;
  ownerAddressProof?: InputMaybe<DocumentRef>;
  regNo?: InputMaybe<Scalars['String']>;
  registrationCertificate?: InputMaybe<DocumentRef>;
  rtoVerificationProofUrl?: InputMaybe<DocumentRef>;
  sellerAadharCard?: InputMaybe<DocumentRef>;
  sellerPAN?: InputMaybe<DocumentRef>;
};

export type DealershipLeadCountByPeName = {
  __typename?: 'DealershipLeadCountByPEName';
  dealClosedCount?: Maybe<Scalars['String']>;
  leadCreatedCount?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  priceRecivedCount?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type DealershipLeadCountByPeNameAggregateResult = {
  __typename?: 'DealershipLeadCountByPENameAggregateResult';
  count?: Maybe<Scalars['Int']>;
  dealClosedCountMax?: Maybe<Scalars['String']>;
  dealClosedCountMin?: Maybe<Scalars['String']>;
  leadCreatedCountMax?: Maybe<Scalars['String']>;
  leadCreatedCountMin?: Maybe<Scalars['String']>;
  nameMax?: Maybe<Scalars['String']>;
  nameMin?: Maybe<Scalars['String']>;
  priceRecivedCountMax?: Maybe<Scalars['String']>;
  priceRecivedCountMin?: Maybe<Scalars['String']>;
  userIdMax?: Maybe<Scalars['String']>;
  userIdMin?: Maybe<Scalars['String']>;
};

export type DealershipLeadCountByPeNameFilter = {
  and?: InputMaybe<Array<InputMaybe<DealershipLeadCountByPeNameFilter>>>;
  has?: InputMaybe<Array<InputMaybe<DealershipLeadCountByPeNameHasFilter>>>;
  not?: InputMaybe<DealershipLeadCountByPeNameFilter>;
  or?: InputMaybe<Array<InputMaybe<DealershipLeadCountByPeNameFilter>>>;
};

export enum DealershipLeadCountByPeNameHasFilter {
  DealClosedCount = 'dealClosedCount',
  LeadCreatedCount = 'leadCreatedCount',
  Name = 'name',
  PriceRecivedCount = 'priceRecivedCount',
  UserId = 'userId'
}

export type DealershipLeadCountByPeNameOrder = {
  asc?: InputMaybe<DealershipLeadCountByPeNameOrderable>;
  desc?: InputMaybe<DealershipLeadCountByPeNameOrderable>;
  then?: InputMaybe<DealershipLeadCountByPeNameOrder>;
};

export enum DealershipLeadCountByPeNameOrderable {
  DealClosedCount = 'dealClosedCount',
  LeadCreatedCount = 'leadCreatedCount',
  Name = 'name',
  PriceRecivedCount = 'priceRecivedCount',
  UserId = 'userId'
}

export type DealershipLeadCountByPeNamePatch = {
  dealClosedCount?: InputMaybe<Scalars['String']>;
  leadCreatedCount?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  priceRecivedCount?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type DealershipLeadCountByPeNameRef = {
  dealClosedCount?: InputMaybe<Scalars['String']>;
  leadCreatedCount?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  priceRecivedCount?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type DeleteAccessoriesCheckListWithStagePayload = {
  __typename?: 'DeleteAccessoriesCheckListWithStagePayload';
  accessoriesCheckListWithStage?: Maybe<Array<Maybe<AccessoriesCheckListWithStage>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteAccessoriesCheckListWithStagePayloadAccessoriesCheckListWithStageArgs = {
  filter?: InputMaybe<AccessoriesCheckListWithStageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<AccessoriesCheckListWithStageOrder>;
};

export type DeleteAccessoriesCheckPayload = {
  __typename?: 'DeleteAccessoriesCheckPayload';
  accessoriesCheck?: Maybe<Array<Maybe<AccessoriesCheck>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteAccessoriesCheckPayloadAccessoriesCheckArgs = {
  filter?: InputMaybe<AccessoriesCheckFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type DeleteAccessoriesChecklistPayload = {
  __typename?: 'DeleteAccessoriesChecklistPayload';
  accessoriesChecklist?: Maybe<Array<Maybe<AccessoriesChecklist>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteAccessoriesChecklistPayloadAccessoriesChecklistArgs = {
  filter?: InputMaybe<AccessoriesChecklistFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<AccessoriesChecklistOrder>;
};

export type DeleteActiveStateWithGstnPayload = {
  __typename?: 'DeleteActiveStateWithGSTNPayload';
  activeStateWithGSTN?: Maybe<Array<Maybe<ActiveStateWithGstn>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteActiveStateWithGstnPayloadActiveStateWithGstnArgs = {
  filter?: InputMaybe<ActiveStateWithGstnFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ActiveStateWithGstnOrder>;
};

export type DeleteAdminLeadStatusEventPayload = {
  __typename?: 'DeleteAdminLeadStatusEventPayload';
  adminLeadStatusEvent?: Maybe<Array<Maybe<AdminLeadStatusEvent>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteAdminLeadStatusEventPayloadAdminLeadStatusEventArgs = {
  filter?: InputMaybe<AdminLeadStatusEventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<AdminLeadStatusEventOrder>;
};

export type DeleteAgencyPayload = {
  __typename?: 'DeleteAgencyPayload';
  agency?: Maybe<Array<Maybe<Agency>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteAgencyPayloadAgencyArgs = {
  filter?: InputMaybe<AgencyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<AgencyOrder>;
};

export type DeleteAuctionHistoryPayload = {
  __typename?: 'DeleteAuctionHistoryPayload';
  auctionHistory?: Maybe<Array<Maybe<AuctionHistory>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteAuctionHistoryPayloadAuctionHistoryArgs = {
  filter?: InputMaybe<AuctionHistoryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<AuctionHistoryOrder>;
};

export type DeleteBankAuctionLeadCountByNamePayload = {
  __typename?: 'DeleteBankAuctionLeadCountByNamePayload';
  bankAuctionLeadCountByName?: Maybe<Array<Maybe<BankAuctionLeadCountByName>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteBankAuctionLeadCountByNamePayloadBankAuctionLeadCountByNameArgs = {
  filter?: InputMaybe<BankAuctionLeadCountByNameFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<BankAuctionLeadCountByNameOrder>;
};

export type DeleteBankPayload = {
  __typename?: 'DeleteBankPayload';
  bank?: Maybe<Array<Maybe<Bank>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteBankPayloadBankArgs = {
  filter?: InputMaybe<BankFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<BankOrder>;
};

export type DeleteBookingPayload = {
  __typename?: 'DeleteBookingPayload';
  booking?: Maybe<Array<Maybe<Booking>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteBookingPayloadBookingArgs = {
  filter?: InputMaybe<BookingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<BookingOrder>;
};

export type DeleteBookingPaymentPayload = {
  __typename?: 'DeleteBookingPaymentPayload';
  bookingPayment?: Maybe<Array<Maybe<BookingPayment>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteBookingPaymentPayloadBookingPaymentArgs = {
  filter?: InputMaybe<BookingPaymentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<BookingPaymentOrder>;
};

export type DeleteBrandPayload = {
  __typename?: 'DeleteBrandPayload';
  brand?: Maybe<Array<Maybe<Brand>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteBrandPayloadBrandArgs = {
  filter?: InputMaybe<BrandFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<BrandOrder>;
};

export type DeleteBulkApprovalResponsePayload = {
  __typename?: 'DeleteBulkApprovalResponsePayload';
  bulkApprovalResponse?: Maybe<Array<Maybe<BulkApprovalResponse>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteBulkApprovalResponsePayloadBulkApprovalResponseArgs = {
  filter?: InputMaybe<BulkApprovalResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<BulkApprovalResponseOrder>;
};

export type DeleteCenterlizeLocationDistrcitsResponsePayload = {
  __typename?: 'DeleteCenterlizeLocationDistrcitsResponsePayload';
  centerlizeLocationDistrcitsResponse?: Maybe<Array<Maybe<CenterlizeLocationDistrcitsResponse>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteCenterlizeLocationDistrcitsResponsePayloadCenterlizeLocationDistrcitsResponseArgs = {
  filter?: InputMaybe<CenterlizeLocationDistrcitsResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CenterlizeLocationDistrcitsResponseOrder>;
};

export type DeleteCenterlizeLocationDistrictPayload = {
  __typename?: 'DeleteCenterlizeLocationDistrictPayload';
  centerlizeLocationDistrict?: Maybe<Array<Maybe<CenterlizeLocationDistrict>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteCenterlizeLocationDistrictPayloadCenterlizeLocationDistrictArgs = {
  filter?: InputMaybe<CenterlizeLocationDistrictFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CenterlizeLocationDistrictOrder>;
};

export type DeleteCenterlizeLocationStatesPayload = {
  __typename?: 'DeleteCenterlizeLocationStatesPayload';
  centerlizeLocationStates?: Maybe<Array<Maybe<CenterlizeLocationStates>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteCenterlizeLocationStatesPayloadCenterlizeLocationStatesArgs = {
  filter?: InputMaybe<CenterlizeLocationStatesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CenterlizeLocationStatesOrder>;
};

export type DeleteCenterlizeLocationStatesResponsePayload = {
  __typename?: 'DeleteCenterlizeLocationStatesResponsePayload';
  centerlizeLocationStatesResponse?: Maybe<Array<Maybe<CenterlizeLocationStatesResponse>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteCenterlizeLocationStatesResponsePayloadCenterlizeLocationStatesResponseArgs = {
  filter?: InputMaybe<CenterlizeLocationStatesResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CenterlizeLocationStatesResponseOrder>;
};

export type DeleteCenterlizeLocationTehsilPayload = {
  __typename?: 'DeleteCenterlizeLocationTehsilPayload';
  centerlizeLocationTehsil?: Maybe<Array<Maybe<CenterlizeLocationTehsil>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteCenterlizeLocationTehsilPayloadCenterlizeLocationTehsilArgs = {
  filter?: InputMaybe<CenterlizeLocationTehsilFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CenterlizeLocationTehsilOrder>;
};

export type DeleteCenterlizeLocationTehsilResponsePayload = {
  __typename?: 'DeleteCenterlizeLocationTehsilResponsePayload';
  centerlizeLocationTehsilResponse?: Maybe<Array<Maybe<CenterlizeLocationTehsilResponse>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteCenterlizeLocationTehsilResponsePayloadCenterlizeLocationTehsilResponseArgs = {
  filter?: InputMaybe<CenterlizeLocationTehsilResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CenterlizeLocationTehsilResponseOrder>;
};

export type DeleteCentreAggregatesPayload = {
  __typename?: 'DeleteCentreAggregatesPayload';
  centreAggregates?: Maybe<Array<Maybe<CentreAggregates>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteCentreAggregatesPayloadCentreAggregatesArgs = {
  filter?: InputMaybe<CentreAggregatesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CentreAggregatesOrder>;
};

export type DeleteCentrePayload = {
  __typename?: 'DeleteCentrePayload';
  centre?: Maybe<Array<Maybe<Centre>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteCentrePayloadCentreArgs = {
  filter?: InputMaybe<CentreFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CentreOrder>;
};

export type DeleteCityPayload = {
  __typename?: 'DeleteCityPayload';
  city?: Maybe<Array<Maybe<City>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteCityPayloadCityArgs = {
  filter?: InputMaybe<CityFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CityOrder>;
};

export type DeleteCreateBulkLeadResponsePayload = {
  __typename?: 'DeleteCreateBulkLeadResponsePayload';
  createBulkLeadResponse?: Maybe<Array<Maybe<CreateBulkLeadResponse>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteCreateBulkLeadResponsePayloadCreateBulkLeadResponseArgs = {
  filter?: InputMaybe<CreateBulkLeadResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CreateBulkLeadResponseOrder>;
};

export type DeleteCustomerPayload = {
  __typename?: 'DeleteCustomerPayload';
  customer?: Maybe<Array<Maybe<Customer>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteCustomerPayloadCustomerArgs = {
  filter?: InputMaybe<CustomerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CustomerOrder>;
};

export type DeleteDealerPayload = {
  __typename?: 'DeleteDealerPayload';
  dealer?: Maybe<Array<Maybe<Dealer>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteDealerPayloadDealerArgs = {
  filter?: InputMaybe<DealerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DealerOrder>;
};

export type DeleteDealerStancePayload = {
  __typename?: 'DeleteDealerStancePayload';
  dealerStance?: Maybe<Array<Maybe<DealerStance>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteDealerStancePayloadDealerStanceArgs = {
  filter?: InputMaybe<DealerStanceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type DeleteDealershipDocumentPayload = {
  __typename?: 'DeleteDealershipDocumentPayload';
  dealershipDocument?: Maybe<Array<Maybe<DealershipDocument>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteDealershipDocumentPayloadDealershipDocumentArgs = {
  filter?: InputMaybe<DealershipDocumentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DealershipDocumentOrder>;
};

export type DeleteDealershipLeadCountByPeNamePayload = {
  __typename?: 'DeleteDealershipLeadCountByPENamePayload';
  dealershipLeadCountByPEName?: Maybe<Array<Maybe<DealershipLeadCountByPeName>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteDealershipLeadCountByPeNamePayloadDealershipLeadCountByPeNameArgs = {
  filter?: InputMaybe<DealershipLeadCountByPeNameFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DealershipLeadCountByPeNameOrder>;
};

export type DeleteDistrictPayload = {
  __typename?: 'DeleteDistrictPayload';
  district?: Maybe<Array<Maybe<District>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteDistrictPayloadDistrictArgs = {
  filter?: InputMaybe<DistrictFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DistrictOrder>;
};

export type DeleteDocumentChecklistPayload = {
  __typename?: 'DeleteDocumentChecklistPayload';
  documentChecklist?: Maybe<Array<Maybe<DocumentChecklist>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteDocumentChecklistPayloadDocumentChecklistArgs = {
  filter?: InputMaybe<DocumentChecklistFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DocumentChecklistOrder>;
};

export type DeleteDocumentPayload = {
  __typename?: 'DeleteDocumentPayload';
  document?: Maybe<Array<Maybe<Document>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteDocumentPayloadDocumentArgs = {
  filter?: InputMaybe<DocumentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DocumentOrder>;
};

export type DeleteDocumentsCountPayload = {
  __typename?: 'DeleteDocumentsCountPayload';
  documentsCount?: Maybe<Array<Maybe<DocumentsCount>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteDocumentsCountPayloadDocumentsCountArgs = {
  filter?: InputMaybe<DocumentsCountFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DocumentsCountOrder>;
};

export type DeleteDocumentsFollowupsPayload = {
  __typename?: 'DeleteDocumentsFollowupsPayload';
  documentsFollowups?: Maybe<Array<Maybe<DocumentsFollowups>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteDocumentsFollowupsPayloadDocumentsFollowupsArgs = {
  filter?: InputMaybe<DocumentsFollowupsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DocumentsFollowupsOrder>;
};

export type DeleteDriverAggregatesPayload = {
  __typename?: 'DeleteDriverAggregatesPayload';
  driverAggregates?: Maybe<Array<Maybe<DriverAggregates>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteDriverAggregatesPayloadDriverAggregatesArgs = {
  filter?: InputMaybe<DriverAggregatesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DriverAggregatesOrder>;
};

export type DeleteEnquiryAdherencePayload = {
  __typename?: 'DeleteEnquiryAdherencePayload';
  enquiryAdherence?: Maybe<Array<Maybe<EnquiryAdherence>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteEnquiryAdherencePayloadEnquiryAdherenceArgs = {
  filter?: InputMaybe<EnquiryAdherenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<EnquiryAdherenceOrder>;
};

export type DeleteEnquiryAggByCentrePayload = {
  __typename?: 'DeleteEnquiryAggByCentrePayload';
  enquiryAggByCentre?: Maybe<Array<Maybe<EnquiryAggByCentre>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteEnquiryAggByCentrePayloadEnquiryAggByCentreArgs = {
  filter?: InputMaybe<EnquiryAggByCentreFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<EnquiryAggByCentreOrder>;
};

export type DeleteEnquiryCloserAggPayload = {
  __typename?: 'DeleteEnquiryCloserAggPayload';
  enquiryCloserAgg?: Maybe<Array<Maybe<EnquiryCloserAgg>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteEnquiryCloserAggPayloadEnquiryCloserAggArgs = {
  filter?: InputMaybe<EnquiryCloserAggFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<EnquiryCloserAggOrder>;
};

export type DeleteEnquiryClosurePayload = {
  __typename?: 'DeleteEnquiryClosurePayload';
  enquiryClosure?: Maybe<Array<Maybe<EnquiryClosure>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteEnquiryClosurePayloadEnquiryClosureArgs = {
  filter?: InputMaybe<EnquiryClosureFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<EnquiryClosureOrder>;
};

export type DeleteEnquiryPayload = {
  __typename?: 'DeleteEnquiryPayload';
  enquiry?: Maybe<Array<Maybe<Enquiry>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteEnquiryPayloadEnquiryArgs = {
  filter?: InputMaybe<EnquiryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<EnquiryOrder>;
};

export type DeleteFollowupPayload = {
  __typename?: 'DeleteFollowupPayload';
  followup?: Maybe<Array<Maybe<Followup>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteFollowupPayloadFollowupArgs = {
  filter?: InputMaybe<FollowupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<FollowupOrder>;
};

export type DeleteIdByNamePayload = {
  __typename?: 'DeleteIdByNamePayload';
  idByName?: Maybe<Array<Maybe<IdByName>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteIdByNamePayloadIdByNameArgs = {
  filter?: InputMaybe<IdByNameFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<IdByNameOrder>;
};

export type DeleteIdentificationDocumentPayload = {
  __typename?: 'DeleteIdentificationDocumentPayload';
  identificationDocument?: Maybe<Array<Maybe<IdentificationDocument>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteIdentificationDocumentPayloadIdentificationDocumentArgs = {
  filter?: InputMaybe<IdentificationDocumentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<IdentificationDocumentOrder>;
};

export type DeleteIdsByNameForListingReponsePayload = {
  __typename?: 'DeleteIdsByNameForListingReponsePayload';
  idsByNameForListingReponse?: Maybe<Array<Maybe<IdsByNameForListingReponse>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteIdsByNameForListingReponsePayloadIdsByNameForListingReponseArgs = {
  filter?: InputMaybe<IdsByNameForListingReponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<IdsByNameForListingReponseOrder>;
};

export type DeleteInventoryDetailsPayload = {
  __typename?: 'DeleteInventoryDetailsPayload';
  inventoryDetails?: Maybe<Array<Maybe<InventoryDetails>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteInventoryDetailsPayloadInventoryDetailsArgs = {
  filter?: InputMaybe<InventoryDetailsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<InventoryDetailsOrder>;
};

export type DeleteIssueItemPayload = {
  __typename?: 'DeleteIssueItemPayload';
  issueItem?: Maybe<Array<Maybe<IssueItem>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteIssueItemPayloadIssueItemArgs = {
  filter?: InputMaybe<IssueItemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<IssueItemOrder>;
};

export type DeleteIssuePayload = {
  __typename?: 'DeleteIssuePayload';
  issue?: Maybe<Array<Maybe<Issue>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteIssuePayloadIssueArgs = {
  filter?: InputMaybe<IssueFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<IssueOrder>;
};

export type DeleteItemInventoryDetailsPayload = {
  __typename?: 'DeleteItemInventoryDetailsPayload';
  itemInventoryDetails?: Maybe<Array<Maybe<ItemInventoryDetails>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteItemInventoryDetailsPayloadItemInventoryDetailsArgs = {
  filter?: InputMaybe<ItemInventoryDetailsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ItemInventoryDetailsOrder>;
};

export type DeleteLeadCountByStatusPayload = {
  __typename?: 'DeleteLeadCountByStatusPayload';
  leadCountByStatus?: Maybe<Array<Maybe<LeadCountByStatus>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteLeadCountByStatusPayloadLeadCountByStatusArgs = {
  filter?: InputMaybe<LeadCountByStatusFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadCountByStatusOrder>;
};

export type DeleteLeadDocumentsPayload = {
  __typename?: 'DeleteLeadDocumentsPayload';
  leadDocuments?: Maybe<Array<Maybe<LeadDocuments>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteLeadDocumentsPayloadLeadDocumentsArgs = {
  filter?: InputMaybe<LeadDocumentsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadDocumentsOrder>;
};

export type DeleteLeadExpensePayload = {
  __typename?: 'DeleteLeadExpensePayload';
  leadExpense?: Maybe<Array<Maybe<LeadExpense>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteLeadExpensePayloadLeadExpenseArgs = {
  filter?: InputMaybe<LeadExpenseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadExpenseOrder>;
};

export type DeleteLeadPayload = {
  __typename?: 'DeleteLeadPayload';
  lead?: Maybe<Array<Maybe<Lead>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteLeadPayloadLeadArgs = {
  filter?: InputMaybe<LeadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadOrder>;
};

export type DeleteLeadStatusEventPayload = {
  __typename?: 'DeleteLeadStatusEventPayload';
  leadStatusEvent?: Maybe<Array<Maybe<LeadStatusEvent>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteLeadStatusEventPayloadLeadStatusEventArgs = {
  filter?: InputMaybe<LeadStatusEventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadStatusEventOrder>;
};

export type DeleteLeadStatusFlowPayload = {
  __typename?: 'DeleteLeadStatusFlowPayload';
  leadStatusFlow?: Maybe<Array<Maybe<LeadStatusFlow>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteLeadStatusFlowPayloadLeadStatusFlowArgs = {
  filter?: InputMaybe<LeadStatusFlowFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadStatusFlowOrder>;
};

export type DeleteLeadTimelineActionPayload = {
  __typename?: 'DeleteLeadTimelineActionPayload';
  leadTimelineAction?: Maybe<Array<Maybe<LeadTimelineAction>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteLeadTimelineActionPayloadLeadTimelineActionArgs = {
  filter?: InputMaybe<LeadTimelineActionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadTimelineActionOrder>;
};

export type DeleteLeadTimelineStatusPayload = {
  __typename?: 'DeleteLeadTimelineStatusPayload';
  leadTimelineStatus?: Maybe<Array<Maybe<LeadTimelineStatus>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteLeadTimelineStatusPayloadLeadTimelineStatusArgs = {
  filter?: InputMaybe<LeadTimelineStatusFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type DeleteLoanPayload = {
  __typename?: 'DeleteLoanPayload';
  loan?: Maybe<Array<Maybe<Loan>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteLoanPayloadLoanArgs = {
  filter?: InputMaybe<LoanFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LoanOrder>;
};

export type DeleteLogTrackingPayload = {
  __typename?: 'DeleteLogTrackingPayload';
  logTracking?: Maybe<Array<Maybe<LogTracking>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteLogTrackingPayloadLogTrackingArgs = {
  filter?: InputMaybe<LogTrackingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LogTrackingOrder>;
};

export type DeleteMarkSoldResponsePayload = {
  __typename?: 'DeleteMarkSoldResponsePayload';
  markSoldResponse?: Maybe<Array<Maybe<MarkSoldResponse>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteMarkSoldResponsePayloadMarkSoldResponseArgs = {
  filter?: InputMaybe<MarkSoldResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<MarkSoldResponseOrder>;
};

export type DeleteMessagePayload = {
  __typename?: 'DeleteMessagePayload';
  message?: Maybe<Array<Maybe<Message>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteMessagePayloadMessageArgs = {
  filter?: InputMaybe<MessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<MessageOrder>;
};

export type DeleteModelByMakePayload = {
  __typename?: 'DeleteModelByMakePayload';
  modelByMake?: Maybe<Array<Maybe<ModelByMake>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteModelByMakePayloadModelByMakeArgs = {
  filter?: InputMaybe<ModelByMakeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ModelByMakeOrder>;
};

export type DeleteModelPayload = {
  __typename?: 'DeleteModelPayload';
  model?: Maybe<Array<Maybe<Model>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteModelPayloadModelArgs = {
  filter?: InputMaybe<ModelFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ModelOrder>;
};

export type DeleteNotificationPayload = {
  __typename?: 'DeleteNotificationPayload';
  msg?: Maybe<Scalars['String']>;
  notification?: Maybe<Array<Maybe<Notification>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeleteNotificationPayloadNotificationArgs = {
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<NotificationOrder>;
};

export type DeleteNumberOfPendingTasksPayload = {
  __typename?: 'DeleteNumberOfPendingTasksPayload';
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
  numberOfPendingTasks?: Maybe<Array<Maybe<NumberOfPendingTasks>>>;
};


export type DeleteNumberOfPendingTasksPayloadNumberOfPendingTasksArgs = {
  filter?: InputMaybe<NumberOfPendingTasksFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<NumberOfPendingTasksOrder>;
};

export type DeleteParkingBeneficiaryPayload = {
  __typename?: 'DeleteParkingBeneficiaryPayload';
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
  parkingBeneficiary?: Maybe<Array<Maybe<ParkingBeneficiary>>>;
};


export type DeleteParkingBeneficiaryPayloadParkingBeneficiaryArgs = {
  filter?: InputMaybe<ParkingBeneficiaryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ParkingBeneficiaryOrder>;
};

export type DeletePaymentInvoicesPayload = {
  __typename?: 'DeletePaymentInvoicesPayload';
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
  paymentInvoices?: Maybe<Array<Maybe<PaymentInvoices>>>;
};


export type DeletePaymentInvoicesPayloadPaymentInvoicesArgs = {
  filter?: InputMaybe<PaymentInvoicesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaymentInvoicesOrder>;
};

export type DeletePaymentPayload = {
  __typename?: 'DeletePaymentPayload';
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
  payment?: Maybe<Array<Maybe<Payment>>>;
};


export type DeletePaymentPayloadPaymentArgs = {
  filter?: InputMaybe<PaymentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaymentOrder>;
};

export type DeletePickupPayload = {
  __typename?: 'DeletePickupPayload';
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
  pickup?: Maybe<Array<Maybe<Pickup>>>;
};


export type DeletePickupPayloadPickupArgs = {
  filter?: InputMaybe<PickupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PickupOrder>;
};

export type DeleteProductPayload = {
  __typename?: 'DeleteProductPayload';
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
  product?: Maybe<Array<Maybe<Product>>>;
};


export type DeleteProductPayloadProductArgs = {
  filter?: InputMaybe<ProductFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ProductOrder>;
};

export type DeletePurchaseItemPayload = {
  __typename?: 'DeletePurchaseItemPayload';
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
  purchaseItem?: Maybe<Array<Maybe<PurchaseItem>>>;
};


export type DeletePurchaseItemPayloadPurchaseItemArgs = {
  filter?: InputMaybe<PurchaseItemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PurchaseItemOrder>;
};

export type DeletePurchasePayload = {
  __typename?: 'DeletePurchasePayload';
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
  purchase?: Maybe<Array<Maybe<Purchase>>>;
};


export type DeletePurchasePayloadPurchaseArgs = {
  filter?: InputMaybe<PurchaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PurchaseOrder>;
};

export type DeleteRefurbishmentBeneficiaryPayload = {
  __typename?: 'DeleteRefurbishmentBeneficiaryPayload';
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
  refurbishmentBeneficiary?: Maybe<Array<Maybe<RefurbishmentBeneficiary>>>;
};


export type DeleteRefurbishmentBeneficiaryPayloadRefurbishmentBeneficiaryArgs = {
  filter?: InputMaybe<RefurbishmentBeneficiaryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<RefurbishmentBeneficiaryOrder>;
};

export type DeleteRefurbishmentDetailsPayload = {
  __typename?: 'DeleteRefurbishmentDetailsPayload';
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
  refurbishmentDetails?: Maybe<Array<Maybe<RefurbishmentDetails>>>;
};


export type DeleteRefurbishmentDetailsPayloadRefurbishmentDetailsArgs = {
  filter?: InputMaybe<RefurbishmentDetailsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type DeleteRefurbishmentItemPayload = {
  __typename?: 'DeleteRefurbishmentItemPayload';
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
  refurbishmentItem?: Maybe<Array<Maybe<RefurbishmentItem>>>;
};


export type DeleteRefurbishmentItemPayloadRefurbishmentItemArgs = {
  filter?: InputMaybe<RefurbishmentItemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<RefurbishmentItemOrder>;
};

export type DeleteRefurbishmentRequestPayload = {
  __typename?: 'DeleteRefurbishmentRequestPayload';
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
  refurbishmentRequest?: Maybe<Array<Maybe<RefurbishmentRequest>>>;
};


export type DeleteRefurbishmentRequestPayloadRefurbishmentRequestArgs = {
  filter?: InputMaybe<RefurbishmentRequestFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<RefurbishmentRequestOrder>;
};

export type DeleteSmsLogsPayload = {
  __typename?: 'DeleteSMSLogsPayload';
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
  sMSLogs?: Maybe<Array<Maybe<SmsLogs>>>;
};


export type DeleteSmsLogsPayloadSMsLogsArgs = {
  filter?: InputMaybe<SmsLogsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<SmsLogsOrder>;
};

export type DeleteSendSmsToCustomerResponsePayload = {
  __typename?: 'DeleteSendSmsToCustomerResponsePayload';
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
  sendSmsToCustomerResponse?: Maybe<Array<Maybe<SendSmsToCustomerResponse>>>;
};


export type DeleteSendSmsToCustomerResponsePayloadSendSmsToCustomerResponseArgs = {
  filter?: InputMaybe<SendSmsToCustomerResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<SendSmsToCustomerResponseOrder>;
};

export type DeleteStateCodeWithRegNumberPayload = {
  __typename?: 'DeleteStateCodeWithRegNumberPayload';
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
  stateCodeWithRegNumber?: Maybe<Array<Maybe<StateCodeWithRegNumber>>>;
};


export type DeleteStateCodeWithRegNumberPayloadStateCodeWithRegNumberArgs = {
  filter?: InputMaybe<StateCodeWithRegNumberFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<StateCodeWithRegNumberOrder>;
};

export type DeleteStatusAggregatePayload = {
  __typename?: 'DeleteStatusAggregatePayload';
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
  statusAggregate?: Maybe<Array<Maybe<StatusAggregate>>>;
};


export type DeleteStatusAggregatePayloadStatusAggregateArgs = {
  filter?: InputMaybe<StatusAggregateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<StatusAggregateOrder>;
};

export type DeleteTjCentrePayload = {
  __typename?: 'DeleteTJCentrePayload';
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
  tJCentre?: Maybe<Array<Maybe<TjCentre>>>;
};


export type DeleteTjCentrePayloadTjCentreArgs = {
  filter?: InputMaybe<TjCentreFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<TjCentreOrder>;
};

export type DeleteTaskPayload = {
  __typename?: 'DeleteTaskPayload';
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
  task?: Maybe<Array<Maybe<Task>>>;
};


export type DeleteTaskPayloadTaskArgs = {
  filter?: InputMaybe<TaskFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<TaskOrder>;
};

export type DeleteTehsilPayload = {
  __typename?: 'DeleteTehsilPayload';
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
  tehsil?: Maybe<Array<Maybe<Tehsil>>>;
};


export type DeleteTehsilPayloadTehsilArgs = {
  filter?: InputMaybe<TehsilFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<TehsilOrder>;
};

export type DeleteTripExpensePayload = {
  __typename?: 'DeleteTripExpensePayload';
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
  tripExpense?: Maybe<Array<Maybe<TripExpense>>>;
};


export type DeleteTripExpensePayloadTripExpenseArgs = {
  filter?: InputMaybe<TripExpenseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<TripExpenseOrder>;
};

export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
  user?: Maybe<Array<Maybe<User>>>;
};


export type DeleteUserPayloadUserArgs = {
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<UserOrder>;
};

export type DeleteVehicleDocumentsPayload = {
  __typename?: 'DeleteVehicleDocumentsPayload';
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
  vehicleDocuments?: Maybe<Array<Maybe<VehicleDocuments>>>;
};


export type DeleteVehicleDocumentsPayloadVehicleDocumentsArgs = {
  filter?: InputMaybe<VehicleDocumentsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleDocumentsOrder>;
};

export type DeleteVehicleFinancingPayload = {
  __typename?: 'DeleteVehicleFinancingPayload';
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
  vehicleFinancing?: Maybe<Array<Maybe<VehicleFinancing>>>;
};


export type DeleteVehicleFinancingPayloadVehicleFinancingArgs = {
  filter?: InputMaybe<VehicleFinancingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleFinancingOrder>;
};

export type DeleteVehicleImagesPayload = {
  __typename?: 'DeleteVehicleImagesPayload';
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
  vehicleImages?: Maybe<Array<Maybe<VehicleImages>>>;
};


export type DeleteVehicleImagesPayloadVehicleImagesArgs = {
  filter?: InputMaybe<VehicleImagesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleImagesOrder>;
};

export type DeleteVehicleInsurancePayload = {
  __typename?: 'DeleteVehicleInsurancePayload';
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
  vehicleInsurance?: Maybe<Array<Maybe<VehicleInsurance>>>;
};


export type DeleteVehicleInsurancePayloadVehicleInsuranceArgs = {
  filter?: InputMaybe<VehicleInsuranceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleInsuranceOrder>;
};

export type DeleteVehicleOwnerPayload = {
  __typename?: 'DeleteVehicleOwnerPayload';
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
  vehicleOwner?: Maybe<Array<Maybe<VehicleOwner>>>;
};


export type DeleteVehicleOwnerPayloadVehicleOwnerArgs = {
  filter?: InputMaybe<VehicleOwnerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleOwnerOrder>;
};

export type DeleteVehiclePayload = {
  __typename?: 'DeleteVehiclePayload';
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
  vehicle?: Maybe<Array<Maybe<Vehicle>>>;
};


export type DeleteVehiclePayloadVehicleArgs = {
  filter?: InputMaybe<VehicleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleOrder>;
};

export type DeleteVehicleTransferLogPayload = {
  __typename?: 'DeleteVehicleTransferLogPayload';
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
  vehicleTransferLog?: Maybe<Array<Maybe<VehicleTransferLog>>>;
};


export type DeleteVehicleTransferLogPayloadVehicleTransferLogArgs = {
  filter?: InputMaybe<VehicleTransferLogFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleTransferLogOrder>;
};

export type DeleteYardPayload = {
  __typename?: 'DeleteYardPayload';
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
  yard?: Maybe<Array<Maybe<Yard>>>;
};


export type DeleteYardPayloadYardArgs = {
  filter?: InputMaybe<YardFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<YardOrder>;
};

export type DeletedocumentsAggregatesResultPayload = {
  __typename?: 'DeletedocumentsAggregatesResultPayload';
  documentsAggregatesResult?: Maybe<Array<Maybe<DocumentsAggregatesResult>>>;
  msg?: Maybe<Scalars['String']>;
  numUids?: Maybe<Scalars['Int']>;
};


export type DeletedocumentsAggregatesResultPayloadDocumentsAggregatesResultArgs = {
  filter?: InputMaybe<DocumentsAggregatesResultFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export enum DeviceType {
  AdminPanel = 'ADMIN_PANEL',
  App = 'APP'
}

export type DeviceType_Hash = {
  eq?: InputMaybe<DeviceType>;
  in?: InputMaybe<Array<InputMaybe<DeviceType>>>;
};

export enum DgraphIndex {
  Bool = 'bool',
  Day = 'day',
  Exact = 'exact',
  Float = 'float',
  Fulltext = 'fulltext',
  Geo = 'geo',
  Hash = 'hash',
  Hour = 'hour',
  Int = 'int',
  Int64 = 'int64',
  Month = 'month',
  Regexp = 'regexp',
  Term = 'term',
  Trigram = 'trigram',
  Year = 'year'
}

export type District = {
  __typename?: 'District';
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  state?: Maybe<StateCodeWithRegNumber>;
  tehsils?: Maybe<Array<Maybe<Tehsil>>>;
  tehsilsAggregate?: Maybe<TehsilAggregateResult>;
};


export type DistrictStateArgs = {
  filter?: InputMaybe<StateCodeWithRegNumberFilter>;
};


export type DistrictTehsilsArgs = {
  filter?: InputMaybe<TehsilFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<TehsilOrder>;
};


export type DistrictTehsilsAggregateArgs = {
  filter?: InputMaybe<TehsilFilter>;
};

export type DistrictAggregateResult = {
  __typename?: 'DistrictAggregateResult';
  codeMax?: Maybe<Scalars['String']>;
  codeMin?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  nameMax?: Maybe<Scalars['String']>;
  nameMin?: Maybe<Scalars['String']>;
};

export type DistrictFilter = {
  and?: InputMaybe<Array<InputMaybe<DistrictFilter>>>;
  has?: InputMaybe<Array<InputMaybe<DistrictHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<StringFullTextFilter_StringTermFilter>;
  not?: InputMaybe<DistrictFilter>;
  or?: InputMaybe<Array<InputMaybe<DistrictFilter>>>;
};

export enum DistrictHasFilter {
  Code = 'code',
  Name = 'name',
  State = 'state',
  Tehsils = 'tehsils'
}

export type DistrictOrder = {
  asc?: InputMaybe<DistrictOrderable>;
  desc?: InputMaybe<DistrictOrderable>;
  then?: InputMaybe<DistrictOrder>;
};

export enum DistrictOrderable {
  Code = 'code',
  Name = 'name'
}

export type DistrictPatch = {
  code?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<StateCodeWithRegNumberRef>;
  tehsils?: InputMaybe<Array<InputMaybe<TehsilRef>>>;
};

export type DistrictRef = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<StateCodeWithRegNumberRef>;
  tehsils?: InputMaybe<Array<InputMaybe<TehsilRef>>>;
};

export type Document = {
  __typename?: 'Document';
  expectedDate?: Maybe<Scalars['DateTime']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export type DocumentAggregateResult = {
  __typename?: 'DocumentAggregateResult';
  count?: Maybe<Scalars['Int']>;
  expectedDateMax?: Maybe<Scalars['DateTime']>;
  expectedDateMin?: Maybe<Scalars['DateTime']>;
  urlMax?: Maybe<Scalars['String']>;
  urlMin?: Maybe<Scalars['String']>;
};

export type DocumentChecklist = {
  __typename?: 'DocumentChecklist';
  bankNOC?: Maybe<Scalars['Boolean']>;
  form26?: Maybe<Scalars['Boolean']>;
  form28?: Maybe<Scalars['Boolean']>;
  form29?: Maybe<Scalars['Boolean']>;
  form30?: Maybe<Scalars['Boolean']>;
  form35?: Maybe<Scalars['Boolean']>;
  form36?: Maybe<Scalars['Boolean']>;
  form60?: Maybe<Scalars['Boolean']>;
  form60_sellerPan?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  indemnityBond?: Maybe<Scalars['Boolean']>;
  insuranceCertificate?: Maybe<Scalars['Boolean']>;
  lead: Lead;
  loanForeclosure?: Maybe<Scalars['Boolean']>;
  ownerAddressProof?: Maybe<Scalars['Boolean']>;
  regNo: Scalars['String'];
  registrationCertificate?: Maybe<Scalars['Boolean']>;
  releaseOrder?: Maybe<Scalars['Boolean']>;
  sellerAadharCard?: Maybe<Scalars['Boolean']>;
  sellerPAN?: Maybe<Scalars['Boolean']>;
};


export type DocumentChecklistLeadArgs = {
  filter?: InputMaybe<LeadFilter>;
};

export type DocumentChecklistAggregateResult = {
  __typename?: 'DocumentChecklistAggregateResult';
  count?: Maybe<Scalars['Int']>;
  regNoMax?: Maybe<Scalars['String']>;
  regNoMin?: Maybe<Scalars['String']>;
};

export type DocumentChecklistFilter = {
  and?: InputMaybe<Array<InputMaybe<DocumentChecklistFilter>>>;
  has?: InputMaybe<Array<InputMaybe<DocumentChecklistHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<DocumentChecklistFilter>;
  or?: InputMaybe<Array<InputMaybe<DocumentChecklistFilter>>>;
  regNo?: InputMaybe<StringHashFilter>;
};

export enum DocumentChecklistHasFilter {
  BankNoc = 'bankNOC',
  Form26 = 'form26',
  Form28 = 'form28',
  Form29 = 'form29',
  Form30 = 'form30',
  Form35 = 'form35',
  Form36 = 'form36',
  Form60 = 'form60',
  Form60SellerPan = 'form60_sellerPan',
  IndemnityBond = 'indemnityBond',
  InsuranceCertificate = 'insuranceCertificate',
  Lead = 'lead',
  LoanForeclosure = 'loanForeclosure',
  OwnerAddressProof = 'ownerAddressProof',
  RegNo = 'regNo',
  RegistrationCertificate = 'registrationCertificate',
  ReleaseOrder = 'releaseOrder',
  SellerAadharCard = 'sellerAadharCard',
  SellerPan = 'sellerPAN'
}

export type DocumentChecklistOrder = {
  asc?: InputMaybe<DocumentChecklistOrderable>;
  desc?: InputMaybe<DocumentChecklistOrderable>;
  then?: InputMaybe<DocumentChecklistOrder>;
};

export enum DocumentChecklistOrderable {
  RegNo = 'regNo'
}

export type DocumentChecklistPatch = {
  bankNOC?: InputMaybe<Scalars['Boolean']>;
  form26?: InputMaybe<Scalars['Boolean']>;
  form28?: InputMaybe<Scalars['Boolean']>;
  form29?: InputMaybe<Scalars['Boolean']>;
  form30?: InputMaybe<Scalars['Boolean']>;
  form35?: InputMaybe<Scalars['Boolean']>;
  form36?: InputMaybe<Scalars['Boolean']>;
  form60?: InputMaybe<Scalars['Boolean']>;
  form60_sellerPan?: InputMaybe<Scalars['Boolean']>;
  indemnityBond?: InputMaybe<Scalars['Boolean']>;
  insuranceCertificate?: InputMaybe<Scalars['Boolean']>;
  lead?: InputMaybe<LeadRef>;
  loanForeclosure?: InputMaybe<Scalars['Boolean']>;
  ownerAddressProof?: InputMaybe<Scalars['Boolean']>;
  registrationCertificate?: InputMaybe<Scalars['Boolean']>;
  releaseOrder?: InputMaybe<Scalars['Boolean']>;
  sellerAadharCard?: InputMaybe<Scalars['Boolean']>;
  sellerPAN?: InputMaybe<Scalars['Boolean']>;
};

export type DocumentChecklistRef = {
  bankNOC?: InputMaybe<Scalars['Boolean']>;
  form26?: InputMaybe<Scalars['Boolean']>;
  form28?: InputMaybe<Scalars['Boolean']>;
  form29?: InputMaybe<Scalars['Boolean']>;
  form30?: InputMaybe<Scalars['Boolean']>;
  form35?: InputMaybe<Scalars['Boolean']>;
  form36?: InputMaybe<Scalars['Boolean']>;
  form60?: InputMaybe<Scalars['Boolean']>;
  form60_sellerPan?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  indemnityBond?: InputMaybe<Scalars['Boolean']>;
  insuranceCertificate?: InputMaybe<Scalars['Boolean']>;
  lead?: InputMaybe<LeadRef>;
  loanForeclosure?: InputMaybe<Scalars['Boolean']>;
  ownerAddressProof?: InputMaybe<Scalars['Boolean']>;
  regNo?: InputMaybe<Scalars['String']>;
  registrationCertificate?: InputMaybe<Scalars['Boolean']>;
  releaseOrder?: InputMaybe<Scalars['Boolean']>;
  sellerAadharCard?: InputMaybe<Scalars['Boolean']>;
  sellerPAN?: InputMaybe<Scalars['Boolean']>;
};

export type DocumentFilter = {
  and?: InputMaybe<Array<InputMaybe<DocumentFilter>>>;
  has?: InputMaybe<Array<InputMaybe<DocumentHasFilter>>>;
  not?: InputMaybe<DocumentFilter>;
  or?: InputMaybe<Array<InputMaybe<DocumentFilter>>>;
};

export enum DocumentHasFilter {
  ExpectedDate = 'expectedDate',
  IsAvailable = 'isAvailable',
  Url = 'url'
}

export type DocumentOrder = {
  asc?: InputMaybe<DocumentOrderable>;
  desc?: InputMaybe<DocumentOrderable>;
  then?: InputMaybe<DocumentOrder>;
};

export enum DocumentOrderable {
  ExpectedDate = 'expectedDate',
  Url = 'url'
}

export type DocumentPatch = {
  expectedDate?: InputMaybe<Scalars['DateTime']>;
  isAvailable?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
};

export type DocumentRef = {
  expectedDate?: InputMaybe<Scalars['DateTime']>;
  isAvailable?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
};

export enum DocumentStatus {
  Pending = 'PENDING',
  Received = 'RECEIVED'
}

export type DocumentsCount = {
  __typename?: 'DocumentsCount';
  pending?: Maybe<Scalars['Int']>;
  received?: Maybe<Scalars['Int']>;
  required?: Maybe<Scalars['Int']>;
};

export type DocumentsCountAggregateResult = {
  __typename?: 'DocumentsCountAggregateResult';
  count?: Maybe<Scalars['Int']>;
  pendingAvg?: Maybe<Scalars['Float']>;
  pendingMax?: Maybe<Scalars['Int']>;
  pendingMin?: Maybe<Scalars['Int']>;
  pendingSum?: Maybe<Scalars['Int']>;
  receivedAvg?: Maybe<Scalars['Float']>;
  receivedMax?: Maybe<Scalars['Int']>;
  receivedMin?: Maybe<Scalars['Int']>;
  receivedSum?: Maybe<Scalars['Int']>;
  requiredAvg?: Maybe<Scalars['Float']>;
  requiredMax?: Maybe<Scalars['Int']>;
  requiredMin?: Maybe<Scalars['Int']>;
  requiredSum?: Maybe<Scalars['Int']>;
};

export type DocumentsCountFilter = {
  and?: InputMaybe<Array<InputMaybe<DocumentsCountFilter>>>;
  has?: InputMaybe<Array<InputMaybe<DocumentsCountHasFilter>>>;
  not?: InputMaybe<DocumentsCountFilter>;
  or?: InputMaybe<Array<InputMaybe<DocumentsCountFilter>>>;
};

export enum DocumentsCountHasFilter {
  Pending = 'pending',
  Received = 'received',
  Required = 'required'
}

export type DocumentsCountOrder = {
  asc?: InputMaybe<DocumentsCountOrderable>;
  desc?: InputMaybe<DocumentsCountOrderable>;
  then?: InputMaybe<DocumentsCountOrder>;
};

export enum DocumentsCountOrderable {
  Pending = 'pending',
  Received = 'received',
  Required = 'required'
}

export type DocumentsCountPatch = {
  pending?: InputMaybe<Scalars['Int']>;
  received?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Int']>;
};

export type DocumentsCountRef = {
  pending?: InputMaybe<Scalars['Int']>;
  received?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Int']>;
};

export type DocumentsFilters = {
  createdAt?: InputMaybe<DateRange>;
  docStatus?: InputMaybe<DocumentStatus>;
  offset?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  regState?: InputMaybe<Scalars['String']>;
  searchString?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<LeadSource>;
};

export type DocumentsFollowups = {
  __typename?: 'DocumentsFollowups';
  actionType?: Maybe<ActionType>;
  documentName?: Maybe<Scalars['String']>;
  followedUpBy: User;
  followupDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  lead: Lead;
  nextFollowupDate?: Maybe<Scalars['DateTime']>;
  remarks?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
};


export type DocumentsFollowupsFollowedUpByArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type DocumentsFollowupsLeadArgs = {
  filter?: InputMaybe<LeadFilter>;
};

export type DocumentsFollowupsAggregateResult = {
  __typename?: 'DocumentsFollowupsAggregateResult';
  count?: Maybe<Scalars['Int']>;
  documentNameMax?: Maybe<Scalars['String']>;
  documentNameMin?: Maybe<Scalars['String']>;
  followupDateMax?: Maybe<Scalars['DateTime']>;
  followupDateMin?: Maybe<Scalars['DateTime']>;
  nextFollowupDateMax?: Maybe<Scalars['DateTime']>;
  nextFollowupDateMin?: Maybe<Scalars['DateTime']>;
  remarksMax?: Maybe<Scalars['String']>;
  remarksMin?: Maybe<Scalars['String']>;
  sourceMax?: Maybe<Scalars['String']>;
  sourceMin?: Maybe<Scalars['String']>;
};

export type DocumentsFollowupsFilter = {
  and?: InputMaybe<Array<InputMaybe<DocumentsFollowupsFilter>>>;
  followupDate?: InputMaybe<DateTimeFilter>;
  has?: InputMaybe<Array<InputMaybe<DocumentsFollowupsHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<DocumentsFollowupsFilter>;
  or?: InputMaybe<Array<InputMaybe<DocumentsFollowupsFilter>>>;
};

export enum DocumentsFollowupsHasFilter {
  ActionType = 'actionType',
  DocumentName = 'documentName',
  FollowedUpBy = 'followedUpBy',
  FollowupDate = 'followupDate',
  Lead = 'lead',
  NextFollowupDate = 'nextFollowupDate',
  Remarks = 'remarks',
  Source = 'source'
}

export type DocumentsFollowupsOrder = {
  asc?: InputMaybe<DocumentsFollowupsOrderable>;
  desc?: InputMaybe<DocumentsFollowupsOrderable>;
  then?: InputMaybe<DocumentsFollowupsOrder>;
};

export enum DocumentsFollowupsOrderable {
  DocumentName = 'documentName',
  FollowupDate = 'followupDate',
  NextFollowupDate = 'nextFollowupDate',
  Remarks = 'remarks',
  Source = 'source'
}

export type DocumentsFollowupsPatch = {
  actionType?: InputMaybe<ActionType>;
  documentName?: InputMaybe<Scalars['String']>;
  followedUpBy?: InputMaybe<UserRef>;
  followupDate?: InputMaybe<Scalars['DateTime']>;
  lead?: InputMaybe<LeadRef>;
  nextFollowupDate?: InputMaybe<Scalars['DateTime']>;
  remarks?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};

export type DocumentsFollowupsRef = {
  actionType?: InputMaybe<ActionType>;
  documentName?: InputMaybe<Scalars['String']>;
  followedUpBy?: InputMaybe<UserRef>;
  followupDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  lead?: InputMaybe<LeadRef>;
  nextFollowupDate?: InputMaybe<Scalars['DateTime']>;
  remarks?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};

export type DriverAggregates = {
  __typename?: 'DriverAggregates';
  assignedPickupsAcceptedCount?: Maybe<Scalars['Int']>;
  assignedPickupsCount?: Maybe<Scalars['Int']>;
  assignedPickupsDeliveredCount?: Maybe<Scalars['Int']>;
  assignedPickupsInTransitCount?: Maybe<Scalars['Int']>;
  assignedPickupsRejectedOrWithdrawnCount?: Maybe<Scalars['Int']>;
  driverName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type DriverAggregatesAggregateResult = {
  __typename?: 'DriverAggregatesAggregateResult';
  assignedPickupsAcceptedCountAvg?: Maybe<Scalars['Float']>;
  assignedPickupsAcceptedCountMax?: Maybe<Scalars['Int']>;
  assignedPickupsAcceptedCountMin?: Maybe<Scalars['Int']>;
  assignedPickupsAcceptedCountSum?: Maybe<Scalars['Int']>;
  assignedPickupsCountAvg?: Maybe<Scalars['Float']>;
  assignedPickupsCountMax?: Maybe<Scalars['Int']>;
  assignedPickupsCountMin?: Maybe<Scalars['Int']>;
  assignedPickupsCountSum?: Maybe<Scalars['Int']>;
  assignedPickupsDeliveredCountAvg?: Maybe<Scalars['Float']>;
  assignedPickupsDeliveredCountMax?: Maybe<Scalars['Int']>;
  assignedPickupsDeliveredCountMin?: Maybe<Scalars['Int']>;
  assignedPickupsDeliveredCountSum?: Maybe<Scalars['Int']>;
  assignedPickupsInTransitCountAvg?: Maybe<Scalars['Float']>;
  assignedPickupsInTransitCountMax?: Maybe<Scalars['Int']>;
  assignedPickupsInTransitCountMin?: Maybe<Scalars['Int']>;
  assignedPickupsInTransitCountSum?: Maybe<Scalars['Int']>;
  assignedPickupsRejectedOrWithdrawnCountAvg?: Maybe<Scalars['Float']>;
  assignedPickupsRejectedOrWithdrawnCountMax?: Maybe<Scalars['Int']>;
  assignedPickupsRejectedOrWithdrawnCountMin?: Maybe<Scalars['Int']>;
  assignedPickupsRejectedOrWithdrawnCountSum?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  driverNameMax?: Maybe<Scalars['String']>;
  driverNameMin?: Maybe<Scalars['String']>;
  idMax?: Maybe<Scalars['String']>;
  idMin?: Maybe<Scalars['String']>;
};

export type DriverAggregatesFilter = {
  and?: InputMaybe<Array<InputMaybe<DriverAggregatesFilter>>>;
  has?: InputMaybe<Array<InputMaybe<DriverAggregatesHasFilter>>>;
  not?: InputMaybe<DriverAggregatesFilter>;
  or?: InputMaybe<Array<InputMaybe<DriverAggregatesFilter>>>;
};

export enum DriverAggregatesHasFilter {
  AssignedPickupsAcceptedCount = 'assignedPickupsAcceptedCount',
  AssignedPickupsCount = 'assignedPickupsCount',
  AssignedPickupsDeliveredCount = 'assignedPickupsDeliveredCount',
  AssignedPickupsInTransitCount = 'assignedPickupsInTransitCount',
  AssignedPickupsRejectedOrWithdrawnCount = 'assignedPickupsRejectedOrWithdrawnCount',
  DriverName = 'driverName',
  Id = 'id'
}

export type DriverAggregatesOrder = {
  asc?: InputMaybe<DriverAggregatesOrderable>;
  desc?: InputMaybe<DriverAggregatesOrderable>;
  then?: InputMaybe<DriverAggregatesOrder>;
};

export enum DriverAggregatesOrderable {
  AssignedPickupsAcceptedCount = 'assignedPickupsAcceptedCount',
  AssignedPickupsCount = 'assignedPickupsCount',
  AssignedPickupsDeliveredCount = 'assignedPickupsDeliveredCount',
  AssignedPickupsInTransitCount = 'assignedPickupsInTransitCount',
  AssignedPickupsRejectedOrWithdrawnCount = 'assignedPickupsRejectedOrWithdrawnCount',
  DriverName = 'driverName',
  Id = 'id'
}

export type DriverAggregatesPatch = {
  assignedPickupsAcceptedCount?: InputMaybe<Scalars['Int']>;
  assignedPickupsCount?: InputMaybe<Scalars['Int']>;
  assignedPickupsDeliveredCount?: InputMaybe<Scalars['Int']>;
  assignedPickupsInTransitCount?: InputMaybe<Scalars['Int']>;
  assignedPickupsRejectedOrWithdrawnCount?: InputMaybe<Scalars['Int']>;
  driverName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type DriverAggregatesRef = {
  assignedPickupsAcceptedCount?: InputMaybe<Scalars['Int']>;
  assignedPickupsCount?: InputMaybe<Scalars['Int']>;
  assignedPickupsDeliveredCount?: InputMaybe<Scalars['Int']>;
  assignedPickupsInTransitCount?: InputMaybe<Scalars['Int']>;
  assignedPickupsRejectedOrWithdrawnCount?: InputMaybe<Scalars['Int']>;
  driverName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type Enquiry = {
  __typename?: 'Enquiry';
  budget?: Maybe<Scalars['Int']>;
  centre: Centre;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  customer: Customer;
  customerPhoneNo: Scalars['String'];
  enquiryClosure?: Maybe<EnquiryClosure>;
  enquiryType?: Maybe<EnquiryType>;
  followups?: Maybe<Array<Maybe<Followup>>>;
  followupsAggregate?: Maybe<FollowupAggregateResult>;
  id: Scalars['ID'];
  interestedIn?: Maybe<Array<Maybe<Model>>>;
  interestedInAggregate?: Maybe<ModelAggregateResult>;
  /** products here mean make and model of tractors */
  interestedInProducts?: Maybe<Array<Maybe<ModelByMake>>>;
  interestedInProductsAggregate?: Maybe<ModelByMakeAggregateResult>;
  isClosed?: Maybe<Scalars['Boolean']>;
  lastVisitDate?: Maybe<Scalars['DateTime']>;
  searchString?: Maybe<Scalars['String']>;
  status?: Maybe<EnquiryStatus>;
  tentativePurchaseTime?: Maybe<TentativePurchaseTime>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<User>;
};


export type EnquiryCentreArgs = {
  filter?: InputMaybe<CentreFilter>;
};


export type EnquiryCreatedByArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type EnquiryCustomerArgs = {
  filter?: InputMaybe<CustomerFilter>;
};


export type EnquiryEnquiryClosureArgs = {
  filter?: InputMaybe<EnquiryClosureFilter>;
};


export type EnquiryFollowupsArgs = {
  filter?: InputMaybe<FollowupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<FollowupOrder>;
};


export type EnquiryFollowupsAggregateArgs = {
  filter?: InputMaybe<FollowupFilter>;
};


export type EnquiryInterestedInArgs = {
  filter?: InputMaybe<ModelFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ModelOrder>;
};


export type EnquiryInterestedInAggregateArgs = {
  filter?: InputMaybe<ModelFilter>;
};


export type EnquiryInterestedInProductsArgs = {
  filter?: InputMaybe<ModelByMakeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ModelByMakeOrder>;
};


export type EnquiryInterestedInProductsAggregateArgs = {
  filter?: InputMaybe<ModelByMakeFilter>;
};


export type EnquiryUpdatedByArgs = {
  filter?: InputMaybe<UserFilter>;
};

export type EnquiryAdherence = {
  __typename?: 'EnquiryAdherence';
  AdhirenceRatio?: Maybe<Scalars['Int']>;
  AvgAging?: Maybe<Scalars['Int']>;
  centre?: Maybe<Centre>;
  closedFollowups?: Maybe<Scalars['Int']>;
  totalClosed?: Maybe<Scalars['Int']>;
  totalEnquiry?: Maybe<Scalars['Int']>;
  totalFollowups?: Maybe<Scalars['Int']>;
  totalOpen?: Maybe<Scalars['Int']>;
};


export type EnquiryAdherenceCentreArgs = {
  filter?: InputMaybe<CentreFilter>;
};

export type EnquiryAdherenceAggregateResult = {
  __typename?: 'EnquiryAdherenceAggregateResult';
  AdhirenceRatioAvg?: Maybe<Scalars['Float']>;
  AdhirenceRatioMax?: Maybe<Scalars['Int']>;
  AdhirenceRatioMin?: Maybe<Scalars['Int']>;
  AdhirenceRatioSum?: Maybe<Scalars['Int']>;
  AvgAgingAvg?: Maybe<Scalars['Float']>;
  AvgAgingMax?: Maybe<Scalars['Int']>;
  AvgAgingMin?: Maybe<Scalars['Int']>;
  AvgAgingSum?: Maybe<Scalars['Int']>;
  closedFollowupsAvg?: Maybe<Scalars['Float']>;
  closedFollowupsMax?: Maybe<Scalars['Int']>;
  closedFollowupsMin?: Maybe<Scalars['Int']>;
  closedFollowupsSum?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  totalClosedAvg?: Maybe<Scalars['Float']>;
  totalClosedMax?: Maybe<Scalars['Int']>;
  totalClosedMin?: Maybe<Scalars['Int']>;
  totalClosedSum?: Maybe<Scalars['Int']>;
  totalEnquiryAvg?: Maybe<Scalars['Float']>;
  totalEnquiryMax?: Maybe<Scalars['Int']>;
  totalEnquiryMin?: Maybe<Scalars['Int']>;
  totalEnquirySum?: Maybe<Scalars['Int']>;
  totalFollowupsAvg?: Maybe<Scalars['Float']>;
  totalFollowupsMax?: Maybe<Scalars['Int']>;
  totalFollowupsMin?: Maybe<Scalars['Int']>;
  totalFollowupsSum?: Maybe<Scalars['Int']>;
  totalOpenAvg?: Maybe<Scalars['Float']>;
  totalOpenMax?: Maybe<Scalars['Int']>;
  totalOpenMin?: Maybe<Scalars['Int']>;
  totalOpenSum?: Maybe<Scalars['Int']>;
};

export type EnquiryAdherenceFilter = {
  and?: InputMaybe<Array<InputMaybe<EnquiryAdherenceFilter>>>;
  has?: InputMaybe<Array<InputMaybe<EnquiryAdherenceHasFilter>>>;
  not?: InputMaybe<EnquiryAdherenceFilter>;
  or?: InputMaybe<Array<InputMaybe<EnquiryAdherenceFilter>>>;
};

export enum EnquiryAdherenceHasFilter {
  AdhirenceRatio = 'AdhirenceRatio',
  AvgAging = 'AvgAging',
  Centre = 'centre',
  ClosedFollowups = 'closedFollowups',
  TotalClosed = 'totalClosed',
  TotalEnquiry = 'totalEnquiry',
  TotalFollowups = 'totalFollowups',
  TotalOpen = 'totalOpen'
}

export type EnquiryAdherenceOrder = {
  asc?: InputMaybe<EnquiryAdherenceOrderable>;
  desc?: InputMaybe<EnquiryAdherenceOrderable>;
  then?: InputMaybe<EnquiryAdherenceOrder>;
};

export enum EnquiryAdherenceOrderable {
  AdhirenceRatio = 'AdhirenceRatio',
  AvgAging = 'AvgAging',
  ClosedFollowups = 'closedFollowups',
  TotalClosed = 'totalClosed',
  TotalEnquiry = 'totalEnquiry',
  TotalFollowups = 'totalFollowups',
  TotalOpen = 'totalOpen'
}

export type EnquiryAdherencePatch = {
  AdhirenceRatio?: InputMaybe<Scalars['Int']>;
  AvgAging?: InputMaybe<Scalars['Int']>;
  centre?: InputMaybe<CentreRef>;
  closedFollowups?: InputMaybe<Scalars['Int']>;
  totalClosed?: InputMaybe<Scalars['Int']>;
  totalEnquiry?: InputMaybe<Scalars['Int']>;
  totalFollowups?: InputMaybe<Scalars['Int']>;
  totalOpen?: InputMaybe<Scalars['Int']>;
};

export type EnquiryAdherenceRef = {
  AdhirenceRatio?: InputMaybe<Scalars['Int']>;
  AvgAging?: InputMaybe<Scalars['Int']>;
  centre?: InputMaybe<CentreRef>;
  closedFollowups?: InputMaybe<Scalars['Int']>;
  totalClosed?: InputMaybe<Scalars['Int']>;
  totalEnquiry?: InputMaybe<Scalars['Int']>;
  totalFollowups?: InputMaybe<Scalars['Int']>;
  totalOpen?: InputMaybe<Scalars['Int']>;
};

export type EnquiryAggByCentre = {
  __typename?: 'EnquiryAggByCentre';
  centre?: Maybe<Centre>;
  coldEnquiryCloser?: Maybe<EnquiryCloserAgg>;
  hotEnquiryCloser?: Maybe<EnquiryCloserAgg>;
  totalCold?: Maybe<Scalars['Int']>;
  totalHot?: Maybe<Scalars['Int']>;
  totalWarm?: Maybe<Scalars['Int']>;
  warmEnquiryCloser?: Maybe<EnquiryCloserAgg>;
};


export type EnquiryAggByCentreCentreArgs = {
  filter?: InputMaybe<CentreFilter>;
};


export type EnquiryAggByCentreColdEnquiryCloserArgs = {
  filter?: InputMaybe<EnquiryCloserAggFilter>;
};


export type EnquiryAggByCentreHotEnquiryCloserArgs = {
  filter?: InputMaybe<EnquiryCloserAggFilter>;
};


export type EnquiryAggByCentreWarmEnquiryCloserArgs = {
  filter?: InputMaybe<EnquiryCloserAggFilter>;
};

export type EnquiryAggByCentreAggregateResult = {
  __typename?: 'EnquiryAggByCentreAggregateResult';
  count?: Maybe<Scalars['Int']>;
  totalColdAvg?: Maybe<Scalars['Float']>;
  totalColdMax?: Maybe<Scalars['Int']>;
  totalColdMin?: Maybe<Scalars['Int']>;
  totalColdSum?: Maybe<Scalars['Int']>;
  totalHotAvg?: Maybe<Scalars['Float']>;
  totalHotMax?: Maybe<Scalars['Int']>;
  totalHotMin?: Maybe<Scalars['Int']>;
  totalHotSum?: Maybe<Scalars['Int']>;
  totalWarmAvg?: Maybe<Scalars['Float']>;
  totalWarmMax?: Maybe<Scalars['Int']>;
  totalWarmMin?: Maybe<Scalars['Int']>;
  totalWarmSum?: Maybe<Scalars['Int']>;
};

export type EnquiryAggByCentreFilter = {
  and?: InputMaybe<Array<InputMaybe<EnquiryAggByCentreFilter>>>;
  has?: InputMaybe<Array<InputMaybe<EnquiryAggByCentreHasFilter>>>;
  not?: InputMaybe<EnquiryAggByCentreFilter>;
  or?: InputMaybe<Array<InputMaybe<EnquiryAggByCentreFilter>>>;
};

export enum EnquiryAggByCentreHasFilter {
  Centre = 'centre',
  ColdEnquiryCloser = 'coldEnquiryCloser',
  HotEnquiryCloser = 'hotEnquiryCloser',
  TotalCold = 'totalCold',
  TotalHot = 'totalHot',
  TotalWarm = 'totalWarm',
  WarmEnquiryCloser = 'warmEnquiryCloser'
}

export type EnquiryAggByCentreOrder = {
  asc?: InputMaybe<EnquiryAggByCentreOrderable>;
  desc?: InputMaybe<EnquiryAggByCentreOrderable>;
  then?: InputMaybe<EnquiryAggByCentreOrder>;
};

export enum EnquiryAggByCentreOrderable {
  TotalCold = 'totalCold',
  TotalHot = 'totalHot',
  TotalWarm = 'totalWarm'
}

export type EnquiryAggByCentrePatch = {
  centre?: InputMaybe<CentreRef>;
  coldEnquiryCloser?: InputMaybe<EnquiryCloserAggRef>;
  hotEnquiryCloser?: InputMaybe<EnquiryCloserAggRef>;
  totalCold?: InputMaybe<Scalars['Int']>;
  totalHot?: InputMaybe<Scalars['Int']>;
  totalWarm?: InputMaybe<Scalars['Int']>;
  warmEnquiryCloser?: InputMaybe<EnquiryCloserAggRef>;
};

export type EnquiryAggByCentreRef = {
  centre?: InputMaybe<CentreRef>;
  coldEnquiryCloser?: InputMaybe<EnquiryCloserAggRef>;
  hotEnquiryCloser?: InputMaybe<EnquiryCloserAggRef>;
  totalCold?: InputMaybe<Scalars['Int']>;
  totalHot?: InputMaybe<Scalars['Int']>;
  totalWarm?: InputMaybe<Scalars['Int']>;
  warmEnquiryCloser?: InputMaybe<EnquiryCloserAggRef>;
};

export type EnquiryAggregateResult = {
  __typename?: 'EnquiryAggregateResult';
  budgetAvg?: Maybe<Scalars['Float']>;
  budgetMax?: Maybe<Scalars['Int']>;
  budgetMin?: Maybe<Scalars['Int']>;
  budgetSum?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  createdAtMax?: Maybe<Scalars['DateTime']>;
  createdAtMin?: Maybe<Scalars['DateTime']>;
  customerPhoneNoMax?: Maybe<Scalars['String']>;
  customerPhoneNoMin?: Maybe<Scalars['String']>;
  lastVisitDateMax?: Maybe<Scalars['DateTime']>;
  lastVisitDateMin?: Maybe<Scalars['DateTime']>;
  searchStringMax?: Maybe<Scalars['String']>;
  searchStringMin?: Maybe<Scalars['String']>;
  updatedAtMax?: Maybe<Scalars['DateTime']>;
  updatedAtMin?: Maybe<Scalars['DateTime']>;
};

export type EnquiryCloserAgg = {
  __typename?: 'EnquiryCloserAgg';
  closed?: Maybe<Scalars['Int']>;
  infollowUp?: Maybe<Scalars['Int']>;
  notIntrested?: Maybe<Scalars['Int']>;
  notResponding?: Maybe<Scalars['Int']>;
  purchaseNewTractor?: Maybe<Scalars['Int']>;
  purchasedUsedTractor?: Maybe<Scalars['Int']>;
  tractorBooked?: Maybe<Scalars['Int']>;
};

export type EnquiryCloserAggAggregateResult = {
  __typename?: 'EnquiryCloserAggAggregateResult';
  closedAvg?: Maybe<Scalars['Float']>;
  closedMax?: Maybe<Scalars['Int']>;
  closedMin?: Maybe<Scalars['Int']>;
  closedSum?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  infollowUpAvg?: Maybe<Scalars['Float']>;
  infollowUpMax?: Maybe<Scalars['Int']>;
  infollowUpMin?: Maybe<Scalars['Int']>;
  infollowUpSum?: Maybe<Scalars['Int']>;
  notIntrestedAvg?: Maybe<Scalars['Float']>;
  notIntrestedMax?: Maybe<Scalars['Int']>;
  notIntrestedMin?: Maybe<Scalars['Int']>;
  notIntrestedSum?: Maybe<Scalars['Int']>;
  notRespondingAvg?: Maybe<Scalars['Float']>;
  notRespondingMax?: Maybe<Scalars['Int']>;
  notRespondingMin?: Maybe<Scalars['Int']>;
  notRespondingSum?: Maybe<Scalars['Int']>;
  purchaseNewTractorAvg?: Maybe<Scalars['Float']>;
  purchaseNewTractorMax?: Maybe<Scalars['Int']>;
  purchaseNewTractorMin?: Maybe<Scalars['Int']>;
  purchaseNewTractorSum?: Maybe<Scalars['Int']>;
  purchasedUsedTractorAvg?: Maybe<Scalars['Float']>;
  purchasedUsedTractorMax?: Maybe<Scalars['Int']>;
  purchasedUsedTractorMin?: Maybe<Scalars['Int']>;
  purchasedUsedTractorSum?: Maybe<Scalars['Int']>;
  tractorBookedAvg?: Maybe<Scalars['Float']>;
  tractorBookedMax?: Maybe<Scalars['Int']>;
  tractorBookedMin?: Maybe<Scalars['Int']>;
  tractorBookedSum?: Maybe<Scalars['Int']>;
};

export type EnquiryCloserAggFilter = {
  and?: InputMaybe<Array<InputMaybe<EnquiryCloserAggFilter>>>;
  has?: InputMaybe<Array<InputMaybe<EnquiryCloserAggHasFilter>>>;
  not?: InputMaybe<EnquiryCloserAggFilter>;
  or?: InputMaybe<Array<InputMaybe<EnquiryCloserAggFilter>>>;
};

export enum EnquiryCloserAggHasFilter {
  Closed = 'closed',
  InfollowUp = 'infollowUp',
  NotIntrested = 'notIntrested',
  NotResponding = 'notResponding',
  PurchaseNewTractor = 'purchaseNewTractor',
  PurchasedUsedTractor = 'purchasedUsedTractor',
  TractorBooked = 'tractorBooked'
}

export type EnquiryCloserAggOrder = {
  asc?: InputMaybe<EnquiryCloserAggOrderable>;
  desc?: InputMaybe<EnquiryCloserAggOrderable>;
  then?: InputMaybe<EnquiryCloserAggOrder>;
};

export enum EnquiryCloserAggOrderable {
  Closed = 'closed',
  InfollowUp = 'infollowUp',
  NotIntrested = 'notIntrested',
  NotResponding = 'notResponding',
  PurchaseNewTractor = 'purchaseNewTractor',
  PurchasedUsedTractor = 'purchasedUsedTractor',
  TractorBooked = 'tractorBooked'
}

export type EnquiryCloserAggPatch = {
  closed?: InputMaybe<Scalars['Int']>;
  infollowUp?: InputMaybe<Scalars['Int']>;
  notIntrested?: InputMaybe<Scalars['Int']>;
  notResponding?: InputMaybe<Scalars['Int']>;
  purchaseNewTractor?: InputMaybe<Scalars['Int']>;
  purchasedUsedTractor?: InputMaybe<Scalars['Int']>;
  tractorBooked?: InputMaybe<Scalars['Int']>;
};

export type EnquiryCloserAggRef = {
  closed?: InputMaybe<Scalars['Int']>;
  infollowUp?: InputMaybe<Scalars['Int']>;
  notIntrested?: InputMaybe<Scalars['Int']>;
  notResponding?: InputMaybe<Scalars['Int']>;
  purchaseNewTractor?: InputMaybe<Scalars['Int']>;
  purchasedUsedTractor?: InputMaybe<Scalars['Int']>;
  tractorBooked?: InputMaybe<Scalars['Int']>;
};

export type EnquiryClosure = {
  __typename?: 'EnquiryClosure';
  centre?: Maybe<Centre>;
  enquiryCloseReason?: Maybe<CloseEnquiryReason>;
  purchaseFrom?: Maybe<PurchaseTractorFrom>;
  purchasePrice?: Maybe<Scalars['Int']>;
  purchaseProduct?: Maybe<ModelByMake>;
  regNo?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};


export type EnquiryClosureCentreArgs = {
  filter?: InputMaybe<CentreFilter>;
};


export type EnquiryClosurePurchaseProductArgs = {
  filter?: InputMaybe<ModelByMakeFilter>;
};

export type EnquiryClosureAggregateResult = {
  __typename?: 'EnquiryClosureAggregateResult';
  count?: Maybe<Scalars['Int']>;
  purchasePriceAvg?: Maybe<Scalars['Float']>;
  purchasePriceMax?: Maybe<Scalars['Int']>;
  purchasePriceMin?: Maybe<Scalars['Int']>;
  purchasePriceSum?: Maybe<Scalars['Int']>;
  regNoMax?: Maybe<Scalars['String']>;
  regNoMin?: Maybe<Scalars['String']>;
  remarksMax?: Maybe<Scalars['String']>;
  remarksMin?: Maybe<Scalars['String']>;
  yearMax?: Maybe<Scalars['String']>;
  yearMin?: Maybe<Scalars['String']>;
};

export type EnquiryClosureFilter = {
  and?: InputMaybe<Array<InputMaybe<EnquiryClosureFilter>>>;
  has?: InputMaybe<Array<InputMaybe<EnquiryClosureHasFilter>>>;
  not?: InputMaybe<EnquiryClosureFilter>;
  or?: InputMaybe<Array<InputMaybe<EnquiryClosureFilter>>>;
};

export enum EnquiryClosureHasFilter {
  Centre = 'centre',
  EnquiryCloseReason = 'enquiryCloseReason',
  PurchaseFrom = 'purchaseFrom',
  PurchasePrice = 'purchasePrice',
  PurchaseProduct = 'purchaseProduct',
  RegNo = 'regNo',
  Remarks = 'remarks',
  Year = 'year'
}

export type EnquiryClosureOrder = {
  asc?: InputMaybe<EnquiryClosureOrderable>;
  desc?: InputMaybe<EnquiryClosureOrderable>;
  then?: InputMaybe<EnquiryClosureOrder>;
};

export enum EnquiryClosureOrderable {
  PurchasePrice = 'purchasePrice',
  RegNo = 'regNo',
  Remarks = 'remarks',
  Year = 'year'
}

export type EnquiryClosurePatch = {
  centre?: InputMaybe<CentreRef>;
  enquiryCloseReason?: InputMaybe<CloseEnquiryReason>;
  purchaseFrom?: InputMaybe<PurchaseTractorFrom>;
  purchasePrice?: InputMaybe<Scalars['Int']>;
  purchaseProduct?: InputMaybe<ModelByMakeRef>;
  regNo?: InputMaybe<Scalars['String']>;
  remarks?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

export type EnquiryClosureRef = {
  centre?: InputMaybe<CentreRef>;
  enquiryCloseReason?: InputMaybe<CloseEnquiryReason>;
  purchaseFrom?: InputMaybe<PurchaseTractorFrom>;
  purchasePrice?: InputMaybe<Scalars['Int']>;
  purchaseProduct?: InputMaybe<ModelByMakeRef>;
  regNo?: InputMaybe<Scalars['String']>;
  remarks?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

export type EnquiryDateRange = {
  end?: InputMaybe<Scalars['DateTime']>;
  start?: InputMaybe<Scalars['DateTime']>;
};

export type EnquiryFilter = {
  and?: InputMaybe<Array<InputMaybe<EnquiryFilter>>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerPhoneNo?: InputMaybe<StringTermFilter>;
  enquiryType?: InputMaybe<EnquiryType_Hash>;
  has?: InputMaybe<Array<InputMaybe<EnquiryHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  isClosed?: InputMaybe<Scalars['Boolean']>;
  lastVisitDate?: InputMaybe<DateTimeFilter>;
  not?: InputMaybe<EnquiryFilter>;
  or?: InputMaybe<Array<InputMaybe<EnquiryFilter>>>;
  searchString?: InputMaybe<StringRegExpFilter_StringTermFilter>;
  status?: InputMaybe<EnquiryStatus_Hash>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EnquiryFilters = {
  centre?: InputMaybe<Scalars['String']>;
  centreId?: InputMaybe<Scalars['String']>;
  districts?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enquiryStatus?: InputMaybe<EnquiryStatus>;
  enquiryType?: InputMaybe<EnquiryType>;
  from?: InputMaybe<Scalars['DateTime']>;
  interestedInMakes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  intrestedInModels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isClosed?: InputMaybe<Scalars['Boolean']>;
  makes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  models?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  searchString?: InputMaybe<Scalars['String']>;
  selectTypeOfDate?: InputMaybe<SelectTypeOfDate>;
  start?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  tehsils?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  to?: InputMaybe<Scalars['DateTime']>;
  vehicleBrand?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  vehicleModel?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export enum EnquiryHasFilter {
  Budget = 'budget',
  Centre = 'centre',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  Customer = 'customer',
  CustomerPhoneNo = 'customerPhoneNo',
  EnquiryClosure = 'enquiryClosure',
  EnquiryType = 'enquiryType',
  Followups = 'followups',
  InterestedIn = 'interestedIn',
  InterestedInProducts = 'interestedInProducts',
  IsClosed = 'isClosed',
  LastVisitDate = 'lastVisitDate',
  SearchString = 'searchString',
  Status = 'status',
  TentativePurchaseTime = 'tentativePurchaseTime',
  UpdatedAt = 'updatedAt',
  UpdatedBy = 'updatedBy'
}

export type EnquiryOrder = {
  asc?: InputMaybe<EnquiryOrderable>;
  desc?: InputMaybe<EnquiryOrderable>;
  then?: InputMaybe<EnquiryOrder>;
};

export enum EnquiryOrderable {
  Budget = 'budget',
  CreatedAt = 'createdAt',
  CustomerPhoneNo = 'customerPhoneNo',
  LastVisitDate = 'lastVisitDate',
  SearchString = 'searchString',
  UpdatedAt = 'updatedAt'
}

export type EnquiryPatch = {
  budget?: InputMaybe<Scalars['Int']>;
  centre?: InputMaybe<CentreRef>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserRef>;
  customer?: InputMaybe<CustomerRef>;
  enquiryClosure?: InputMaybe<EnquiryClosureRef>;
  enquiryType?: InputMaybe<EnquiryType>;
  followups?: InputMaybe<Array<InputMaybe<FollowupRef>>>;
  interestedIn?: InputMaybe<Array<InputMaybe<ModelRef>>>;
  interestedInProducts?: InputMaybe<Array<InputMaybe<ModelByMakeRef>>>;
  isClosed?: InputMaybe<Scalars['Boolean']>;
  lastVisitDate?: InputMaybe<Scalars['DateTime']>;
  searchString?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<EnquiryStatus>;
  tentativePurchaseTime?: InputMaybe<TentativePurchaseTime>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedBy?: InputMaybe<UserRef>;
};

export type EnquiryRef = {
  budget?: InputMaybe<Scalars['Int']>;
  centre?: InputMaybe<CentreRef>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserRef>;
  customer?: InputMaybe<CustomerRef>;
  customerPhoneNo?: InputMaybe<Scalars['String']>;
  enquiryClosure?: InputMaybe<EnquiryClosureRef>;
  enquiryType?: InputMaybe<EnquiryType>;
  followups?: InputMaybe<Array<InputMaybe<FollowupRef>>>;
  id?: InputMaybe<Scalars['ID']>;
  interestedIn?: InputMaybe<Array<InputMaybe<ModelRef>>>;
  interestedInProducts?: InputMaybe<Array<InputMaybe<ModelByMakeRef>>>;
  isClosed?: InputMaybe<Scalars['Boolean']>;
  lastVisitDate?: InputMaybe<Scalars['DateTime']>;
  searchString?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<EnquiryStatus>;
  tentativePurchaseTime?: InputMaybe<TentativePurchaseTime>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedBy?: InputMaybe<UserRef>;
};

export enum EnquiryStatus {
  Cold = 'COLD',
  Hot = 'HOT',
  Warm = 'WARM'
}

export type EnquiryStatus_Hash = {
  eq?: InputMaybe<EnquiryStatus>;
  in?: InputMaybe<Array<InputMaybe<EnquiryStatus>>>;
};

export enum EnquiryType {
  Field = 'FIELD',
  Online = 'ONLINE',
  Walkin = 'WALKIN'
}

export type EnquiryType_Hash = {
  eq?: InputMaybe<EnquiryType>;
  in?: InputMaybe<Array<InputMaybe<EnquiryType>>>;
};

export enum ExpenseCategory {
  Food = 'FOOD',
  Fuel = 'FUEL',
  Others = 'OTHERS'
}

export type FloatFilter = {
  between?: InputMaybe<FloatRange>;
  eq?: InputMaybe<Scalars['Float']>;
  ge?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  le?: InputMaybe<Scalars['Float']>;
  lt?: InputMaybe<Scalars['Float']>;
};

export type FloatRange = {
  max: Scalars['Float'];
  min: Scalars['Float'];
};

export type Followup = {
  __typename?: 'Followup';
  enquiry: Enquiry;
  followedUpBy: User;
  followupDate: Scalars['DateTime'];
  id: Scalars['ID'];
  /** the date */
  isWalkin?: Maybe<Scalars['Boolean']>;
  nextFollowup?: Maybe<Followup>;
  previousFollowup?: Maybe<Followup>;
  remarks?: Maybe<Scalars['String']>;
  status?: Maybe<EnquiryStatus>;
};


export type FollowupEnquiryArgs = {
  filter?: InputMaybe<EnquiryFilter>;
};


export type FollowupFollowedUpByArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type FollowupNextFollowupArgs = {
  filter?: InputMaybe<FollowupFilter>;
};


export type FollowupPreviousFollowupArgs = {
  filter?: InputMaybe<FollowupFilter>;
};

export type FollowupAggregateResult = {
  __typename?: 'FollowupAggregateResult';
  count?: Maybe<Scalars['Int']>;
  followupDateMax?: Maybe<Scalars['DateTime']>;
  followupDateMin?: Maybe<Scalars['DateTime']>;
  remarksMax?: Maybe<Scalars['String']>;
  remarksMin?: Maybe<Scalars['String']>;
};

export type FollowupFilter = {
  and?: InputMaybe<Array<InputMaybe<FollowupFilter>>>;
  followupDate?: InputMaybe<DateTimeFilter>;
  has?: InputMaybe<Array<InputMaybe<FollowupHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<FollowupFilter>;
  or?: InputMaybe<Array<InputMaybe<FollowupFilter>>>;
};

export enum FollowupHasFilter {
  Enquiry = 'enquiry',
  FollowedUpBy = 'followedUpBy',
  FollowupDate = 'followupDate',
  IsWalkin = 'isWalkin',
  NextFollowup = 'nextFollowup',
  PreviousFollowup = 'previousFollowup',
  Remarks = 'remarks',
  Status = 'status'
}

export type FollowupOrder = {
  asc?: InputMaybe<FollowupOrderable>;
  desc?: InputMaybe<FollowupOrderable>;
  then?: InputMaybe<FollowupOrder>;
};

export enum FollowupOrderable {
  FollowupDate = 'followupDate',
  Remarks = 'remarks'
}

export type FollowupPatch = {
  enquiry?: InputMaybe<EnquiryRef>;
  followedUpBy?: InputMaybe<UserRef>;
  followupDate?: InputMaybe<Scalars['DateTime']>;
  /** the date */
  isWalkin?: InputMaybe<Scalars['Boolean']>;
  nextFollowup?: InputMaybe<FollowupRef>;
  previousFollowup?: InputMaybe<FollowupRef>;
  remarks?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<EnquiryStatus>;
};

export type FollowupRef = {
  enquiry?: InputMaybe<EnquiryRef>;
  followedUpBy?: InputMaybe<UserRef>;
  followupDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  /** the date */
  isWalkin?: InputMaybe<Scalars['Boolean']>;
  nextFollowup?: InputMaybe<FollowupRef>;
  previousFollowup?: InputMaybe<FollowupRef>;
  remarks?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<EnquiryStatus>;
};

export type GenerateMutationParams = {
  add?: InputMaybe<Scalars['Boolean']>;
  delete?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<Scalars['Boolean']>;
};

export type GenerateQueryParams = {
  aggregate?: InputMaybe<Scalars['Boolean']>;
  get?: InputMaybe<Scalars['Boolean']>;
  password?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<Scalars['Boolean']>;
};

export enum HttpMethod {
  Delete = 'DELETE',
  Get = 'GET',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT'
}

export type IdByName = {
  __typename?: 'IdByName';
  brand_id?: Maybe<Scalars['Int']>;
  district_id?: Maybe<Scalars['Int']>;
  engine_capacity?: Maybe<Scalars['String']>;
  horse_power?: Maybe<Scalars['String']>;
  model_id?: Maybe<Scalars['Int']>;
  state_id?: Maybe<Scalars['Int']>;
  tahsil_id?: Maybe<Scalars['Int']>;
};

export type IdByNameAggregateResult = {
  __typename?: 'IdByNameAggregateResult';
  brand_idAvg?: Maybe<Scalars['Float']>;
  brand_idMax?: Maybe<Scalars['Int']>;
  brand_idMin?: Maybe<Scalars['Int']>;
  brand_idSum?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  district_idAvg?: Maybe<Scalars['Float']>;
  district_idMax?: Maybe<Scalars['Int']>;
  district_idMin?: Maybe<Scalars['Int']>;
  district_idSum?: Maybe<Scalars['Int']>;
  engine_capacityMax?: Maybe<Scalars['String']>;
  engine_capacityMin?: Maybe<Scalars['String']>;
  horse_powerMax?: Maybe<Scalars['String']>;
  horse_powerMin?: Maybe<Scalars['String']>;
  model_idAvg?: Maybe<Scalars['Float']>;
  model_idMax?: Maybe<Scalars['Int']>;
  model_idMin?: Maybe<Scalars['Int']>;
  model_idSum?: Maybe<Scalars['Int']>;
  state_idAvg?: Maybe<Scalars['Float']>;
  state_idMax?: Maybe<Scalars['Int']>;
  state_idMin?: Maybe<Scalars['Int']>;
  state_idSum?: Maybe<Scalars['Int']>;
  tahsil_idAvg?: Maybe<Scalars['Float']>;
  tahsil_idMax?: Maybe<Scalars['Int']>;
  tahsil_idMin?: Maybe<Scalars['Int']>;
  tahsil_idSum?: Maybe<Scalars['Int']>;
};

export type IdByNameFilter = {
  and?: InputMaybe<Array<InputMaybe<IdByNameFilter>>>;
  has?: InputMaybe<Array<InputMaybe<IdByNameHasFilter>>>;
  not?: InputMaybe<IdByNameFilter>;
  or?: InputMaybe<Array<InputMaybe<IdByNameFilter>>>;
};

export enum IdByNameHasFilter {
  BrandId = 'brand_id',
  DistrictId = 'district_id',
  EngineCapacity = 'engine_capacity',
  HorsePower = 'horse_power',
  ModelId = 'model_id',
  StateId = 'state_id',
  TahsilId = 'tahsil_id'
}

export type IdByNameOrder = {
  asc?: InputMaybe<IdByNameOrderable>;
  desc?: InputMaybe<IdByNameOrderable>;
  then?: InputMaybe<IdByNameOrder>;
};

export enum IdByNameOrderable {
  BrandId = 'brand_id',
  DistrictId = 'district_id',
  EngineCapacity = 'engine_capacity',
  HorsePower = 'horse_power',
  ModelId = 'model_id',
  StateId = 'state_id',
  TahsilId = 'tahsil_id'
}

export type IdByNamePatch = {
  brand_id?: InputMaybe<Scalars['Int']>;
  district_id?: InputMaybe<Scalars['Int']>;
  engine_capacity?: InputMaybe<Scalars['String']>;
  horse_power?: InputMaybe<Scalars['String']>;
  model_id?: InputMaybe<Scalars['Int']>;
  state_id?: InputMaybe<Scalars['Int']>;
  tahsil_id?: InputMaybe<Scalars['Int']>;
};

export type IdByNameRef = {
  brand_id?: InputMaybe<Scalars['Int']>;
  district_id?: InputMaybe<Scalars['Int']>;
  engine_capacity?: InputMaybe<Scalars['String']>;
  horse_power?: InputMaybe<Scalars['String']>;
  model_id?: InputMaybe<Scalars['Int']>;
  state_id?: InputMaybe<Scalars['Int']>;
  tahsil_id?: InputMaybe<Scalars['Int']>;
};

export type IdentificationDocument = {
  __typename?: 'IdentificationDocument';
  aadhaarBackPhotoUrl?: Maybe<Scalars['String']>;
  aadhaarFrontPhotoUrl?: Maybe<Scalars['String']>;
  aadhaarNumber?: Maybe<Scalars['String']>;
  customer?: Maybe<Customer>;
  id: Scalars['ID'];
  panNumber?: Maybe<Scalars['String']>;
  panPhotoUrl?: Maybe<Scalars['String']>;
  voterIdNumber?: Maybe<Scalars['String']>;
  voterIdPhotoUrl?: Maybe<Scalars['String']>;
};


export type IdentificationDocumentCustomerArgs = {
  filter?: InputMaybe<CustomerFilter>;
};

export type IdentificationDocumentAggregateResult = {
  __typename?: 'IdentificationDocumentAggregateResult';
  aadhaarBackPhotoUrlMax?: Maybe<Scalars['String']>;
  aadhaarBackPhotoUrlMin?: Maybe<Scalars['String']>;
  aadhaarFrontPhotoUrlMax?: Maybe<Scalars['String']>;
  aadhaarFrontPhotoUrlMin?: Maybe<Scalars['String']>;
  aadhaarNumberMax?: Maybe<Scalars['String']>;
  aadhaarNumberMin?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  panNumberMax?: Maybe<Scalars['String']>;
  panNumberMin?: Maybe<Scalars['String']>;
  panPhotoUrlMax?: Maybe<Scalars['String']>;
  panPhotoUrlMin?: Maybe<Scalars['String']>;
  voterIdNumberMax?: Maybe<Scalars['String']>;
  voterIdNumberMin?: Maybe<Scalars['String']>;
  voterIdPhotoUrlMax?: Maybe<Scalars['String']>;
  voterIdPhotoUrlMin?: Maybe<Scalars['String']>;
};

export type IdentificationDocumentFilter = {
  and?: InputMaybe<Array<InputMaybe<IdentificationDocumentFilter>>>;
  has?: InputMaybe<Array<InputMaybe<IdentificationDocumentHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<IdentificationDocumentFilter>;
  or?: InputMaybe<Array<InputMaybe<IdentificationDocumentFilter>>>;
};

export enum IdentificationDocumentHasFilter {
  AadhaarBackPhotoUrl = 'aadhaarBackPhotoUrl',
  AadhaarFrontPhotoUrl = 'aadhaarFrontPhotoUrl',
  AadhaarNumber = 'aadhaarNumber',
  Customer = 'customer',
  PanNumber = 'panNumber',
  PanPhotoUrl = 'panPhotoUrl',
  VoterIdNumber = 'voterIdNumber',
  VoterIdPhotoUrl = 'voterIdPhotoUrl'
}

export type IdentificationDocumentOrder = {
  asc?: InputMaybe<IdentificationDocumentOrderable>;
  desc?: InputMaybe<IdentificationDocumentOrderable>;
  then?: InputMaybe<IdentificationDocumentOrder>;
};

export enum IdentificationDocumentOrderable {
  AadhaarBackPhotoUrl = 'aadhaarBackPhotoUrl',
  AadhaarFrontPhotoUrl = 'aadhaarFrontPhotoUrl',
  AadhaarNumber = 'aadhaarNumber',
  PanNumber = 'panNumber',
  PanPhotoUrl = 'panPhotoUrl',
  VoterIdNumber = 'voterIdNumber',
  VoterIdPhotoUrl = 'voterIdPhotoUrl'
}

export type IdentificationDocumentPatch = {
  aadhaarBackPhotoUrl?: InputMaybe<Scalars['String']>;
  aadhaarFrontPhotoUrl?: InputMaybe<Scalars['String']>;
  aadhaarNumber?: InputMaybe<Scalars['String']>;
  customer?: InputMaybe<CustomerRef>;
  panNumber?: InputMaybe<Scalars['String']>;
  panPhotoUrl?: InputMaybe<Scalars['String']>;
  voterIdNumber?: InputMaybe<Scalars['String']>;
  voterIdPhotoUrl?: InputMaybe<Scalars['String']>;
};

export type IdentificationDocumentRef = {
  aadhaarBackPhotoUrl?: InputMaybe<Scalars['String']>;
  aadhaarFrontPhotoUrl?: InputMaybe<Scalars['String']>;
  aadhaarNumber?: InputMaybe<Scalars['String']>;
  customer?: InputMaybe<CustomerRef>;
  id?: InputMaybe<Scalars['ID']>;
  panNumber?: InputMaybe<Scalars['String']>;
  panPhotoUrl?: InputMaybe<Scalars['String']>;
  voterIdNumber?: InputMaybe<Scalars['String']>;
  voterIdPhotoUrl?: InputMaybe<Scalars['String']>;
};

export type IdsByNameForListingInput = {
  brand?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  engine_hours?: InputMaybe<Scalars['Int']>;
  env?: InputMaybe<Scalars['String']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  manufacture_month?: InputMaybe<Scalars['String']>;
  manufacture_year?: InputMaybe<Scalars['Int']>;
  mobile_number?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['String']>;
  rc_available?: InputMaybe<Scalars['String']>;
  seller_name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  tehsil?: InputMaybe<Scalars['String']>;
  vehicle_registration_no?: InputMaybe<Scalars['String']>;
};

export type IdsByNameForListingReponse = {
  __typename?: 'IdsByNameForListingReponse';
  data?: Maybe<IdByName>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};


export type IdsByNameForListingReponseDataArgs = {
  filter?: InputMaybe<IdByNameFilter>;
};

export type IdsByNameForListingReponseAggregateResult = {
  __typename?: 'IdsByNameForListingReponseAggregateResult';
  count?: Maybe<Scalars['Int']>;
  messageMax?: Maybe<Scalars['String']>;
  messageMin?: Maybe<Scalars['String']>;
};

export type IdsByNameForListingReponseFilter = {
  and?: InputMaybe<Array<InputMaybe<IdsByNameForListingReponseFilter>>>;
  has?: InputMaybe<Array<InputMaybe<IdsByNameForListingReponseHasFilter>>>;
  not?: InputMaybe<IdsByNameForListingReponseFilter>;
  or?: InputMaybe<Array<InputMaybe<IdsByNameForListingReponseFilter>>>;
};

export enum IdsByNameForListingReponseHasFilter {
  Data = 'data',
  Message = 'message',
  Status = 'status'
}

export type IdsByNameForListingReponseOrder = {
  asc?: InputMaybe<IdsByNameForListingReponseOrderable>;
  desc?: InputMaybe<IdsByNameForListingReponseOrderable>;
  then?: InputMaybe<IdsByNameForListingReponseOrder>;
};

export enum IdsByNameForListingReponseOrderable {
  Message = 'message'
}

export type IdsByNameForListingReponsePatch = {
  data?: InputMaybe<IdByNameRef>;
  message?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type IdsByNameForListingReponseRef = {
  data?: InputMaybe<IdByNameRef>;
  message?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export enum ImageStage {
  AfterDelivery = 'AFTER_DELIVERY',
  BeforeDelivery = 'BEFORE_DELIVERY',
  DeliveryImage = 'DELIVERY_IMAGE',
  DeliverySelfie = 'DELIVERY_SELFIE',
  LeadGenerated = 'LEAD_GENERATED',
  Listing = 'LISTING',
  TransferDrop = 'TRANSFER_DROP',
  TransferDropSelfie = 'TRANSFER_DROP_SELFIE',
  TransferPickup = 'TRANSFER_PICKUP'
}

export type ImageStage_Hash = {
  eq?: InputMaybe<ImageStage>;
  in?: InputMaybe<Array<InputMaybe<ImageStage>>>;
};

export enum InsuranceType {
  Comprehensive = 'COMPREHENSIVE',
  ThirdParty = 'THIRD_PARTY'
}

export enum InsurerName {
  BajajAllianz = 'BAJAJ_ALLIANZ',
  Cholamandalam = 'CHOLAMANDALAM',
  Edelweiss = 'EDELWEISS',
  FutureGenerali = 'FUTURE_GENERALI',
  GoDigit = 'GO_DIGIT',
  HdfcErgo = 'HDFC_ERGO',
  IciciBank = 'ICICI_BANK',
  IffcoTokio = 'IFFCO_TOKIO',
  Kotak = 'KOTAK',
  Liberty = 'LIBERTY',
  MagmaHdi = 'MAGMA_HDI',
  NationalInsurance = 'NATIONAL_INSURANCE',
  Navi = 'NAVI',
  NewIndiaAssurance = 'NEW_INDIA_ASSURANCE',
  OrientalInsurance = 'ORIENTAL_INSURANCE',
  Rehaja = 'REHAJA',
  Reliance = 'RELIANCE',
  RoyalSundaram = 'ROYAL_SUNDARAM',
  Sbi = 'SBI',
  Shriram = 'SHRIRAM',
  Tata = 'TATA',
  UnitedIndiaInsurance = 'UNITED_INDIA_INSURANCE',
  UniversalSompo = 'UNIVERSAL_SOMPO'
}

export type Int64Filter = {
  between?: InputMaybe<Int64Range>;
  eq?: InputMaybe<Scalars['Int64']>;
  ge?: InputMaybe<Scalars['Int64']>;
  gt?: InputMaybe<Scalars['Int64']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int64']>>>;
  le?: InputMaybe<Scalars['Int64']>;
  lt?: InputMaybe<Scalars['Int64']>;
};

export type Int64Range = {
  max: Scalars['Int64'];
  min: Scalars['Int64'];
};

export type IntFilter = {
  between?: InputMaybe<IntRange>;
  eq?: InputMaybe<Scalars['Int']>;
  ge?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  le?: InputMaybe<Scalars['Int']>;
  lt?: InputMaybe<Scalars['Int']>;
};

export type IntRange = {
  max: Scalars['Int'];
  min: Scalars['Int'];
};

export enum InternalTransferStatus {
  Aborted = 'ABORTED',
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED',
  Transferred = 'TRANSFERRED'
}

export type InternalTransferStatus_Hash = {
  eq?: InputMaybe<InternalTransferStatus>;
  in?: InputMaybe<Array<InputMaybe<InternalTransferStatus>>>;
};

export type IntersectsFilter = {
  multiPolygon?: InputMaybe<MultiPolygonRef>;
  polygon?: InputMaybe<PolygonRef>;
};

export type InventoryDetails = {
  __typename?: 'InventoryDetails';
  /** This id should be the same as centre id */
  id: Scalars['String'];
  items?: Maybe<Array<Maybe<ItemInventoryDetails>>>;
  itemsAggregate?: Maybe<ItemInventoryDetailsAggregateResult>;
};


export type InventoryDetailsItemsArgs = {
  filter?: InputMaybe<ItemInventoryDetailsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ItemInventoryDetailsOrder>;
};


export type InventoryDetailsItemsAggregateArgs = {
  filter?: InputMaybe<ItemInventoryDetailsFilter>;
};

export type InventoryDetailsAggregateResult = {
  __typename?: 'InventoryDetailsAggregateResult';
  count?: Maybe<Scalars['Int']>;
  idMax?: Maybe<Scalars['String']>;
  idMin?: Maybe<Scalars['String']>;
};

export type InventoryDetailsFilter = {
  and?: InputMaybe<Array<InputMaybe<InventoryDetailsFilter>>>;
  has?: InputMaybe<Array<InputMaybe<InventoryDetailsHasFilter>>>;
  id?: InputMaybe<StringHashFilter>;
  not?: InputMaybe<InventoryDetailsFilter>;
  or?: InputMaybe<Array<InputMaybe<InventoryDetailsFilter>>>;
};

export enum InventoryDetailsHasFilter {
  Id = 'id',
  Items = 'items'
}

export type InventoryDetailsOrder = {
  asc?: InputMaybe<InventoryDetailsOrderable>;
  desc?: InputMaybe<InventoryDetailsOrderable>;
  then?: InputMaybe<InventoryDetailsOrder>;
};

export enum InventoryDetailsOrderable {
  Id = 'id'
}

export type InventoryDetailsPatch = {
  items?: InputMaybe<Array<InputMaybe<ItemInventoryDetailsRef>>>;
};

export type InventoryDetailsRef = {
  /** This id should be the same as centre id */
  id?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<InputMaybe<ItemInventoryDetailsRef>>>;
};

export enum InventoryStatus {
  Purchased = 'PURCHASED',
  PurchaseRejected = 'PURCHASE_REJECTED',
  RequestedPo = 'REQUESTED_PO',
  Sold = 'SOLD'
}

export type Issue = {
  __typename?: 'Issue';
  approvedBy?: Maybe<User>;
  centre: Centre;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  items?: Maybe<Array<Maybe<IssueItem>>>;
  itemsAggregate?: Maybe<IssueItemAggregateResult>;
  madeBy: User;
  refurbishment?: Maybe<RefurbishmentRequest>;
  regNo?: Maybe<Scalars['String']>;
  requestedItemId?: Maybe<Scalars['String']>;
  status?: Maybe<IssueStatus>;
  totalPrice?: Maybe<Scalars['Int']>;
};


export type IssueApprovedByArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type IssueCentreArgs = {
  filter?: InputMaybe<CentreFilter>;
};


export type IssueItemsArgs = {
  filter?: InputMaybe<IssueItemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<IssueItemOrder>;
};


export type IssueItemsAggregateArgs = {
  filter?: InputMaybe<IssueItemFilter>;
};


export type IssueMadeByArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type IssueRefurbishmentArgs = {
  filter?: InputMaybe<RefurbishmentRequestFilter>;
};

export type IssueAggregateResult = {
  __typename?: 'IssueAggregateResult';
  count?: Maybe<Scalars['Int']>;
  createdAtMax?: Maybe<Scalars['DateTime']>;
  createdAtMin?: Maybe<Scalars['DateTime']>;
  regNoMax?: Maybe<Scalars['String']>;
  regNoMin?: Maybe<Scalars['String']>;
  requestedItemIdMax?: Maybe<Scalars['String']>;
  requestedItemIdMin?: Maybe<Scalars['String']>;
  totalPriceAvg?: Maybe<Scalars['Float']>;
  totalPriceMax?: Maybe<Scalars['Int']>;
  totalPriceMin?: Maybe<Scalars['Int']>;
  totalPriceSum?: Maybe<Scalars['Int']>;
};

export type IssueFilter = {
  and?: InputMaybe<Array<InputMaybe<IssueFilter>>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  has?: InputMaybe<Array<InputMaybe<IssueHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<IssueFilter>;
  or?: InputMaybe<Array<InputMaybe<IssueFilter>>>;
  status?: InputMaybe<IssueStatus_Hash>;
};

export enum IssueHasFilter {
  ApprovedBy = 'approvedBy',
  Centre = 'centre',
  CreatedAt = 'createdAt',
  Items = 'items',
  MadeBy = 'madeBy',
  Refurbishment = 'refurbishment',
  RegNo = 'regNo',
  RequestedItemId = 'requestedItemId',
  Status = 'status',
  TotalPrice = 'totalPrice'
}

export type IssueItem = {
  __typename?: 'IssueItem';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isApproved?: Maybe<Scalars['Boolean']>;
  issue: Issue;
  price?: Maybe<Scalars['Int']>;
  product: Product;
  quantity?: Maybe<Scalars['Int']>;
  requestedItemId?: Maybe<Scalars['String']>;
};


export type IssueItemIssueArgs = {
  filter?: InputMaybe<IssueFilter>;
};


export type IssueItemProductArgs = {
  filter?: InputMaybe<ProductFilter>;
};

export type IssueItemAggregateResult = {
  __typename?: 'IssueItemAggregateResult';
  count?: Maybe<Scalars['Int']>;
  descriptionMax?: Maybe<Scalars['String']>;
  descriptionMin?: Maybe<Scalars['String']>;
  priceAvg?: Maybe<Scalars['Float']>;
  priceMax?: Maybe<Scalars['Int']>;
  priceMin?: Maybe<Scalars['Int']>;
  priceSum?: Maybe<Scalars['Int']>;
  quantityAvg?: Maybe<Scalars['Float']>;
  quantityMax?: Maybe<Scalars['Int']>;
  quantityMin?: Maybe<Scalars['Int']>;
  quantitySum?: Maybe<Scalars['Int']>;
  requestedItemIdMax?: Maybe<Scalars['String']>;
  requestedItemIdMin?: Maybe<Scalars['String']>;
};

export type IssueItemFilter = {
  and?: InputMaybe<Array<InputMaybe<IssueItemFilter>>>;
  has?: InputMaybe<Array<InputMaybe<IssueItemHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<IssueItemFilter>;
  or?: InputMaybe<Array<InputMaybe<IssueItemFilter>>>;
  price?: InputMaybe<IntFilter>;
};

export enum IssueItemHasFilter {
  Description = 'description',
  IsApproved = 'isApproved',
  Issue = 'issue',
  Price = 'price',
  Product = 'product',
  Quantity = 'quantity',
  RequestedItemId = 'requestedItemId'
}

export type IssueItemOrder = {
  asc?: InputMaybe<IssueItemOrderable>;
  desc?: InputMaybe<IssueItemOrderable>;
  then?: InputMaybe<IssueItemOrder>;
};

export enum IssueItemOrderable {
  Description = 'description',
  Price = 'price',
  Quantity = 'quantity',
  RequestedItemId = 'requestedItemId'
}

export type IssueItemPatch = {
  description?: InputMaybe<Scalars['String']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  issue?: InputMaybe<IssueRef>;
  price?: InputMaybe<Scalars['Int']>;
  product?: InputMaybe<ProductRef>;
  quantity?: InputMaybe<Scalars['Int']>;
  requestedItemId?: InputMaybe<Scalars['String']>;
};

export type IssueItemRef = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  issue?: InputMaybe<IssueRef>;
  price?: InputMaybe<Scalars['Int']>;
  product?: InputMaybe<ProductRef>;
  quantity?: InputMaybe<Scalars['Int']>;
  requestedItemId?: InputMaybe<Scalars['String']>;
};

export type IssueOrder = {
  asc?: InputMaybe<IssueOrderable>;
  desc?: InputMaybe<IssueOrderable>;
  then?: InputMaybe<IssueOrder>;
};

export enum IssueOrderable {
  CreatedAt = 'createdAt',
  RegNo = 'regNo',
  RequestedItemId = 'requestedItemId',
  TotalPrice = 'totalPrice'
}

export type IssuePatch = {
  approvedBy?: InputMaybe<UserRef>;
  centre?: InputMaybe<CentreRef>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  items?: InputMaybe<Array<InputMaybe<IssueItemRef>>>;
  madeBy?: InputMaybe<UserRef>;
  refurbishment?: InputMaybe<RefurbishmentRequestRef>;
  regNo?: InputMaybe<Scalars['String']>;
  requestedItemId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<IssueStatus>;
  totalPrice?: InputMaybe<Scalars['Int']>;
};

export type IssueRef = {
  approvedBy?: InputMaybe<UserRef>;
  centre?: InputMaybe<CentreRef>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  items?: InputMaybe<Array<InputMaybe<IssueItemRef>>>;
  madeBy?: InputMaybe<UserRef>;
  refurbishment?: InputMaybe<RefurbishmentRequestRef>;
  regNo?: InputMaybe<Scalars['String']>;
  requestedItemId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<IssueStatus>;
  totalPrice?: InputMaybe<Scalars['Int']>;
};

export enum IssueStatus {
  Approved = 'APPROVED',
  IssuanceApproved = 'ISSUANCE_APPROVED',
  Issued = 'ISSUED',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED',
  StockIssued = 'STOCK_ISSUED'
}

export type IssueStatus_Hash = {
  eq?: InputMaybe<IssueStatus>;
  in?: InputMaybe<Array<InputMaybe<IssueStatus>>>;
};

export type ItemInventoryDetails = {
  __typename?: 'ItemInventoryDetails';
  availableInStock?: Maybe<Scalars['Int']>;
  avgUnitPrice?: Maybe<Scalars['String']>;
  consumed?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** This id should be the same as product id */
  id: Scalars['String'];
  issueQueue?: Maybe<Scalars['Int']>;
  product?: Maybe<Product>;
  purchaseQueue?: Maybe<Scalars['Int']>;
  totalPrice?: Maybe<Scalars['Int']>;
  totalPurchase?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type ItemInventoryDetailsProductArgs = {
  filter?: InputMaybe<ProductFilter>;
};

export type ItemInventoryDetailsAggregateResult = {
  __typename?: 'ItemInventoryDetailsAggregateResult';
  availableInStockAvg?: Maybe<Scalars['Float']>;
  availableInStockMax?: Maybe<Scalars['Int']>;
  availableInStockMin?: Maybe<Scalars['Int']>;
  availableInStockSum?: Maybe<Scalars['Int']>;
  avgUnitPriceMax?: Maybe<Scalars['String']>;
  avgUnitPriceMin?: Maybe<Scalars['String']>;
  consumedAvg?: Maybe<Scalars['Float']>;
  consumedMax?: Maybe<Scalars['Int']>;
  consumedMin?: Maybe<Scalars['Int']>;
  consumedSum?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  createdAtMax?: Maybe<Scalars['DateTime']>;
  createdAtMin?: Maybe<Scalars['DateTime']>;
  idMax?: Maybe<Scalars['String']>;
  idMin?: Maybe<Scalars['String']>;
  issueQueueAvg?: Maybe<Scalars['Float']>;
  issueQueueMax?: Maybe<Scalars['Int']>;
  issueQueueMin?: Maybe<Scalars['Int']>;
  issueQueueSum?: Maybe<Scalars['Int']>;
  purchaseQueueAvg?: Maybe<Scalars['Float']>;
  purchaseQueueMax?: Maybe<Scalars['Int']>;
  purchaseQueueMin?: Maybe<Scalars['Int']>;
  purchaseQueueSum?: Maybe<Scalars['Int']>;
  totalPriceAvg?: Maybe<Scalars['Float']>;
  totalPriceMax?: Maybe<Scalars['Int']>;
  totalPriceMin?: Maybe<Scalars['Int']>;
  totalPriceSum?: Maybe<Scalars['Int']>;
  totalPurchaseAvg?: Maybe<Scalars['Float']>;
  totalPurchaseMax?: Maybe<Scalars['Int']>;
  totalPurchaseMin?: Maybe<Scalars['Int']>;
  totalPurchaseSum?: Maybe<Scalars['Int']>;
  updatedAtMax?: Maybe<Scalars['DateTime']>;
  updatedAtMin?: Maybe<Scalars['DateTime']>;
};

export type ItemInventoryDetailsFilter = {
  and?: InputMaybe<Array<InputMaybe<ItemInventoryDetailsFilter>>>;
  has?: InputMaybe<Array<InputMaybe<ItemInventoryDetailsHasFilter>>>;
  id?: InputMaybe<StringHashFilter>;
  not?: InputMaybe<ItemInventoryDetailsFilter>;
  or?: InputMaybe<Array<InputMaybe<ItemInventoryDetailsFilter>>>;
};

export enum ItemInventoryDetailsHasFilter {
  AvailableInStock = 'availableInStock',
  AvgUnitPrice = 'avgUnitPrice',
  Consumed = 'consumed',
  CreatedAt = 'createdAt',
  Id = 'id',
  IssueQueue = 'issueQueue',
  Product = 'product',
  PurchaseQueue = 'purchaseQueue',
  TotalPrice = 'totalPrice',
  TotalPurchase = 'totalPurchase',
  UpdatedAt = 'updatedAt'
}

export type ItemInventoryDetailsOrder = {
  asc?: InputMaybe<ItemInventoryDetailsOrderable>;
  desc?: InputMaybe<ItemInventoryDetailsOrderable>;
  then?: InputMaybe<ItemInventoryDetailsOrder>;
};

export enum ItemInventoryDetailsOrderable {
  AvailableInStock = 'availableInStock',
  AvgUnitPrice = 'avgUnitPrice',
  Consumed = 'consumed',
  CreatedAt = 'createdAt',
  Id = 'id',
  IssueQueue = 'issueQueue',
  PurchaseQueue = 'purchaseQueue',
  TotalPrice = 'totalPrice',
  TotalPurchase = 'totalPurchase',
  UpdatedAt = 'updatedAt'
}

export type ItemInventoryDetailsPatch = {
  availableInStock?: InputMaybe<Scalars['Int']>;
  avgUnitPrice?: InputMaybe<Scalars['String']>;
  consumed?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  issueQueue?: InputMaybe<Scalars['Int']>;
  product?: InputMaybe<ProductRef>;
  purchaseQueue?: InputMaybe<Scalars['Int']>;
  totalPrice?: InputMaybe<Scalars['Int']>;
  totalPurchase?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ItemInventoryDetailsRef = {
  availableInStock?: InputMaybe<Scalars['Int']>;
  avgUnitPrice?: InputMaybe<Scalars['String']>;
  consumed?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** This id should be the same as product id */
  id?: InputMaybe<Scalars['String']>;
  issueQueue?: InputMaybe<Scalars['Int']>;
  product?: InputMaybe<ProductRef>;
  purchaseQueue?: InputMaybe<Scalars['Int']>;
  totalPrice?: InputMaybe<Scalars['Int']>;
  totalPurchase?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type Lead = {
  __typename?: 'Lead';
  accessories?: Maybe<Array<Maybe<AccessoriesCheckListWithStage>>>;
  accessoriesAggregate?: Maybe<AccessoriesCheckListWithStageAggregateResult>;
  accessoriesChecklist?: Maybe<Array<Maybe<AccessoriesChecklist>>>;
  accessoriesChecklistAggregate?: Maybe<AccessoriesChecklistAggregateResult>;
  /** updated new design */
  activeBooking?: Maybe<Booking>;
  actualParkingCharges?: Maybe<Scalars['Int']>;
  actualPickupDate?: Maybe<Scalars['DateTime']>;
  approvedDealAmount?: Maybe<Scalars['Int']>;
  approvedParkingChargesFor?: Maybe<UserRole>;
  archivedBookings?: Maybe<Array<Maybe<Booking>>>;
  archivedBookingsAggregate?: Maybe<BookingAggregateResult>;
  auctionByBank?: Maybe<BankName>;
  auctionHistory?: Maybe<Array<Maybe<AuctionHistory>>>;
  auctionHistoryAggregate?: Maybe<AuctionHistoryAggregateResult>;
  auctioningAgency?: Maybe<Agency>;
  auctioningBank?: Maybe<Bank>;
  /** To be depricated when booking get stable */
  bookings?: Maybe<Array<Maybe<Booking>>>;
  bookingsAggregate?: Maybe<BookingAggregateResult>;
  centre?: Maybe<Centre>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  dealer?: Maybe<Dealer>;
  dealerStance?: Maybe<DealerStance>;
  dealershipDocuments?: Maybe<DealershipDocument>;
  deliveredSelfieUrl?: Maybe<Scalars['String']>;
  deliveryAmount?: Maybe<Scalars['Int']>;
  deliveryCentre?: Maybe<Centre>;
  demandAmount?: Maybe<Scalars['Int']>;
  documentCharges?: Maybe<Scalars['Int']>;
  documentChecklist?: Maybe<DocumentChecklist>;
  documents?: Maybe<LeadDocuments>;
  documentsFollowups?: Maybe<Array<Maybe<DocumentsFollowups>>>;
  documentsFollowupsAggregate?: Maybe<DocumentsFollowupsAggregateResult>;
  estimatedParkingCharges?: Maybe<Scalars['Float']>;
  expectedPickupDate?: Maybe<Scalars['DateTime']>;
  expenses?: Maybe<Array<Maybe<LeadExpense>>>;
  expensesAggregate?: Maybe<LeadExpenseAggregateResult>;
  expensesCoveredIn?: Maybe<Array<Maybe<TripExpense>>>;
  expensesCoveredInAggregate?: Maybe<TripExpenseAggregateResult>;
  finalBidAmount?: Maybe<Scalars['Int']>;
  finalParkingCharges?: Maybe<Scalars['Int']>;
  holdbackAmount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  internalTransfers?: Maybe<Array<Maybe<VehicleTransferLog>>>;
  internalTransfersAggregate?: Maybe<VehicleTransferLogAggregateResult>;
  listingOnWebUpdatedAt?: Maybe<Scalars['DateTime']>;
  listingPrice?: Maybe<Scalars['Int']>;
  listingStatus?: Maybe<ListingStatus>;
  listingUpdatedBy?: Maybe<User>;
  loanAmount?: Maybe<Scalars['Int']>;
  loanToBeClosedBy?: Maybe<LoanToBeClosedBy>;
  ownershipType?: Maybe<Ownership>;
  parkingBeneficiary?: Maybe<ParkingBeneficiary>;
  payInParts?: Maybe<Scalars['Boolean']>;
  paymentType?: Maybe<PaymentType>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  paymentsAggregate?: Maybe<PaymentAggregateResult>;
  pickup?: Maybe<Pickup>;
  proposedBidLimitAmount?: Maybe<Scalars['Int']>;
  proposedDealAmount?: Maybe<Scalars['Int']>;
  refurbishmentDetails?: Maybe<RefurbishmentDetails>;
  regNo: Scalars['String'];
  registrationState?: Maybe<Scalars['String']>;
  searchString?: Maybe<Scalars['String']>;
  sellingPrice?: Maybe<Scalars['Int']>;
  source?: Maybe<LeadSource>;
  status?: Maybe<LeadBusinessStatus>;
  statusEvents?: Maybe<Array<Maybe<LeadStatusEvent>>>;
  statusEventsAggregate?: Maybe<LeadStatusEventAggregateResult>;
  tokenAmount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<User>;
  vehicle: Vehicle;
  yard?: Maybe<Yard>;
  yardPerDayParkingCharges?: Maybe<Scalars['Float']>;
  yardPerDayParkingChargesByDriver?: Maybe<Scalars['Float']>;
};


export type LeadAccessoriesArgs = {
  filter?: InputMaybe<AccessoriesCheckListWithStageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<AccessoriesCheckListWithStageOrder>;
};


export type LeadAccessoriesAggregateArgs = {
  filter?: InputMaybe<AccessoriesCheckListWithStageFilter>;
};


export type LeadAccessoriesChecklistArgs = {
  filter?: InputMaybe<AccessoriesChecklistFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<AccessoriesChecklistOrder>;
};


export type LeadAccessoriesChecklistAggregateArgs = {
  filter?: InputMaybe<AccessoriesChecklistFilter>;
};


export type LeadActiveBookingArgs = {
  filter?: InputMaybe<BookingFilter>;
};


export type LeadArchivedBookingsArgs = {
  filter?: InputMaybe<BookingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<BookingOrder>;
};


export type LeadArchivedBookingsAggregateArgs = {
  filter?: InputMaybe<BookingFilter>;
};


export type LeadAuctionHistoryArgs = {
  filter?: InputMaybe<AuctionHistoryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<AuctionHistoryOrder>;
};


export type LeadAuctionHistoryAggregateArgs = {
  filter?: InputMaybe<AuctionHistoryFilter>;
};


export type LeadAuctioningAgencyArgs = {
  filter?: InputMaybe<AgencyFilter>;
};


export type LeadAuctioningBankArgs = {
  filter?: InputMaybe<BankFilter>;
};


export type LeadBookingsArgs = {
  filter?: InputMaybe<BookingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<BookingOrder>;
};


export type LeadBookingsAggregateArgs = {
  filter?: InputMaybe<BookingFilter>;
};


export type LeadCentreArgs = {
  filter?: InputMaybe<CentreFilter>;
};


export type LeadCreatedByArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type LeadDealerArgs = {
  filter?: InputMaybe<DealerFilter>;
};


export type LeadDealerStanceArgs = {
  filter?: InputMaybe<DealerStanceFilter>;
};


export type LeadDealershipDocumentsArgs = {
  filter?: InputMaybe<DealershipDocumentFilter>;
};


export type LeadDeliveryCentreArgs = {
  filter?: InputMaybe<CentreFilter>;
};


export type LeadDocumentChecklistArgs = {
  filter?: InputMaybe<DocumentChecklistFilter>;
};


export type LeadDocumentsArgs = {
  filter?: InputMaybe<LeadDocumentsFilter>;
};


export type LeadDocumentsFollowupsArgs = {
  filter?: InputMaybe<DocumentsFollowupsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DocumentsFollowupsOrder>;
};


export type LeadDocumentsFollowupsAggregateArgs = {
  filter?: InputMaybe<DocumentsFollowupsFilter>;
};


export type LeadExpensesArgs = {
  filter?: InputMaybe<LeadExpenseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadExpenseOrder>;
};


export type LeadExpensesAggregateArgs = {
  filter?: InputMaybe<LeadExpenseFilter>;
};


export type LeadExpensesCoveredInArgs = {
  filter?: InputMaybe<TripExpenseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<TripExpenseOrder>;
};


export type LeadExpensesCoveredInAggregateArgs = {
  filter?: InputMaybe<TripExpenseFilter>;
};


export type LeadInternalTransfersArgs = {
  filter?: InputMaybe<VehicleTransferLogFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleTransferLogOrder>;
};


export type LeadInternalTransfersAggregateArgs = {
  filter?: InputMaybe<VehicleTransferLogFilter>;
};


export type LeadListingUpdatedByArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type LeadParkingBeneficiaryArgs = {
  filter?: InputMaybe<ParkingBeneficiaryFilter>;
};


export type LeadPaymentsArgs = {
  filter?: InputMaybe<PaymentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaymentOrder>;
};


export type LeadPaymentsAggregateArgs = {
  filter?: InputMaybe<PaymentFilter>;
};


export type LeadPickupArgs = {
  filter?: InputMaybe<PickupFilter>;
};


export type LeadRefurbishmentDetailsArgs = {
  filter?: InputMaybe<RefurbishmentDetailsFilter>;
};


export type LeadStatusEventsArgs = {
  filter?: InputMaybe<LeadStatusEventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadStatusEventOrder>;
};


export type LeadStatusEventsAggregateArgs = {
  filter?: InputMaybe<LeadStatusEventFilter>;
};


export type LeadUpdatedByArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type LeadVehicleArgs = {
  filter?: InputMaybe<VehicleFilter>;
};


export type LeadYardArgs = {
  filter?: InputMaybe<YardFilter>;
};

export type LeadAggregateResult = {
  __typename?: 'LeadAggregateResult';
  actualParkingChargesAvg?: Maybe<Scalars['Float']>;
  actualParkingChargesMax?: Maybe<Scalars['Int']>;
  actualParkingChargesMin?: Maybe<Scalars['Int']>;
  actualParkingChargesSum?: Maybe<Scalars['Int']>;
  actualPickupDateMax?: Maybe<Scalars['DateTime']>;
  actualPickupDateMin?: Maybe<Scalars['DateTime']>;
  approvedDealAmountAvg?: Maybe<Scalars['Float']>;
  approvedDealAmountMax?: Maybe<Scalars['Int']>;
  approvedDealAmountMin?: Maybe<Scalars['Int']>;
  approvedDealAmountSum?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  createdAtMax?: Maybe<Scalars['DateTime']>;
  createdAtMin?: Maybe<Scalars['DateTime']>;
  deliveredSelfieUrlMax?: Maybe<Scalars['String']>;
  deliveredSelfieUrlMin?: Maybe<Scalars['String']>;
  deliveryAmountAvg?: Maybe<Scalars['Float']>;
  deliveryAmountMax?: Maybe<Scalars['Int']>;
  deliveryAmountMin?: Maybe<Scalars['Int']>;
  deliveryAmountSum?: Maybe<Scalars['Int']>;
  demandAmountAvg?: Maybe<Scalars['Float']>;
  demandAmountMax?: Maybe<Scalars['Int']>;
  demandAmountMin?: Maybe<Scalars['Int']>;
  demandAmountSum?: Maybe<Scalars['Int']>;
  documentChargesAvg?: Maybe<Scalars['Float']>;
  documentChargesMax?: Maybe<Scalars['Int']>;
  documentChargesMin?: Maybe<Scalars['Int']>;
  documentChargesSum?: Maybe<Scalars['Int']>;
  estimatedParkingChargesAvg?: Maybe<Scalars['Float']>;
  estimatedParkingChargesMax?: Maybe<Scalars['Float']>;
  estimatedParkingChargesMin?: Maybe<Scalars['Float']>;
  estimatedParkingChargesSum?: Maybe<Scalars['Float']>;
  expectedPickupDateMax?: Maybe<Scalars['DateTime']>;
  expectedPickupDateMin?: Maybe<Scalars['DateTime']>;
  finalBidAmountAvg?: Maybe<Scalars['Float']>;
  finalBidAmountMax?: Maybe<Scalars['Int']>;
  finalBidAmountMin?: Maybe<Scalars['Int']>;
  finalBidAmountSum?: Maybe<Scalars['Int']>;
  finalParkingChargesAvg?: Maybe<Scalars['Float']>;
  finalParkingChargesMax?: Maybe<Scalars['Int']>;
  finalParkingChargesMin?: Maybe<Scalars['Int']>;
  finalParkingChargesSum?: Maybe<Scalars['Int']>;
  holdbackAmountAvg?: Maybe<Scalars['Float']>;
  holdbackAmountMax?: Maybe<Scalars['Int']>;
  holdbackAmountMin?: Maybe<Scalars['Int']>;
  holdbackAmountSum?: Maybe<Scalars['Int']>;
  listingOnWebUpdatedAtMax?: Maybe<Scalars['DateTime']>;
  listingOnWebUpdatedAtMin?: Maybe<Scalars['DateTime']>;
  listingPriceAvg?: Maybe<Scalars['Float']>;
  listingPriceMax?: Maybe<Scalars['Int']>;
  listingPriceMin?: Maybe<Scalars['Int']>;
  listingPriceSum?: Maybe<Scalars['Int']>;
  loanAmountAvg?: Maybe<Scalars['Float']>;
  loanAmountMax?: Maybe<Scalars['Int']>;
  loanAmountMin?: Maybe<Scalars['Int']>;
  loanAmountSum?: Maybe<Scalars['Int']>;
  proposedBidLimitAmountAvg?: Maybe<Scalars['Float']>;
  proposedBidLimitAmountMax?: Maybe<Scalars['Int']>;
  proposedBidLimitAmountMin?: Maybe<Scalars['Int']>;
  proposedBidLimitAmountSum?: Maybe<Scalars['Int']>;
  proposedDealAmountAvg?: Maybe<Scalars['Float']>;
  proposedDealAmountMax?: Maybe<Scalars['Int']>;
  proposedDealAmountMin?: Maybe<Scalars['Int']>;
  proposedDealAmountSum?: Maybe<Scalars['Int']>;
  regNoMax?: Maybe<Scalars['String']>;
  regNoMin?: Maybe<Scalars['String']>;
  registrationStateMax?: Maybe<Scalars['String']>;
  registrationStateMin?: Maybe<Scalars['String']>;
  searchStringMax?: Maybe<Scalars['String']>;
  searchStringMin?: Maybe<Scalars['String']>;
  sellingPriceAvg?: Maybe<Scalars['Float']>;
  sellingPriceMax?: Maybe<Scalars['Int']>;
  sellingPriceMin?: Maybe<Scalars['Int']>;
  sellingPriceSum?: Maybe<Scalars['Int']>;
  tokenAmountAvg?: Maybe<Scalars['Float']>;
  tokenAmountMax?: Maybe<Scalars['Int']>;
  tokenAmountMin?: Maybe<Scalars['Int']>;
  tokenAmountSum?: Maybe<Scalars['Int']>;
  updatedAtMax?: Maybe<Scalars['DateTime']>;
  updatedAtMin?: Maybe<Scalars['DateTime']>;
  yardPerDayParkingChargesAvg?: Maybe<Scalars['Float']>;
  yardPerDayParkingChargesByDriverAvg?: Maybe<Scalars['Float']>;
  yardPerDayParkingChargesByDriverMax?: Maybe<Scalars['Float']>;
  yardPerDayParkingChargesByDriverMin?: Maybe<Scalars['Float']>;
  yardPerDayParkingChargesByDriverSum?: Maybe<Scalars['Float']>;
  yardPerDayParkingChargesMax?: Maybe<Scalars['Float']>;
  yardPerDayParkingChargesMin?: Maybe<Scalars['Float']>;
  yardPerDayParkingChargesSum?: Maybe<Scalars['Float']>;
};

export enum LeadBusinessStatus {
  Cold = 'COLD',
  Hot = 'HOT',
  Warm = 'WARM'
}

export type LeadBusinessStatus_Hash = {
  eq?: InputMaybe<LeadBusinessStatus>;
  in?: InputMaybe<Array<InputMaybe<LeadBusinessStatus>>>;
};

export type LeadCountByStatus = {
  __typename?: 'LeadCountByStatus';
  count?: Maybe<Scalars['Int']>;
  status?: Maybe<LeadStatus>;
};

export type LeadCountByStatusAggregateResult = {
  __typename?: 'LeadCountByStatusAggregateResult';
  count?: Maybe<Scalars['Int']>;
  countAvg?: Maybe<Scalars['Float']>;
  countMax?: Maybe<Scalars['Int']>;
  countMin?: Maybe<Scalars['Int']>;
  countSum?: Maybe<Scalars['Int']>;
};

export type LeadCountByStatusFilter = {
  and?: InputMaybe<Array<InputMaybe<LeadCountByStatusFilter>>>;
  has?: InputMaybe<Array<InputMaybe<LeadCountByStatusHasFilter>>>;
  not?: InputMaybe<LeadCountByStatusFilter>;
  or?: InputMaybe<Array<InputMaybe<LeadCountByStatusFilter>>>;
};

export enum LeadCountByStatusHasFilter {
  Count = 'count',
  Status = 'status'
}

export type LeadCountByStatusOrder = {
  asc?: InputMaybe<LeadCountByStatusOrderable>;
  desc?: InputMaybe<LeadCountByStatusOrderable>;
  then?: InputMaybe<LeadCountByStatusOrder>;
};

export enum LeadCountByStatusOrderable {
  Count = 'count'
}

export type LeadCountByStatusPatch = {
  count?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<LeadStatus>;
};

export type LeadCountByStatusRef = {
  count?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<LeadStatus>;
};

export type LeadDocuments = {
  __typename?: 'LeadDocuments';
  bankAccountProofUrl?: Maybe<Scalars['String']>;
  bankNOC?: Maybe<Scalars['String']>;
  dealPaymentProofUrl?: Maybe<Scalars['String']>;
  form26?: Maybe<Scalars['String']>;
  form28?: Maybe<Scalars['String']>;
  form29?: Maybe<Scalars['String']>;
  form30?: Maybe<Scalars['String']>;
  form35?: Maybe<Scalars['String']>;
  form36?: Maybe<Scalars['String']>;
  form60?: Maybe<Scalars['String']>;
  form60_sellerPan?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  indemnityBond?: Maybe<Scalars['String']>;
  insuranceCertificate?: Maybe<Scalars['String']>;
  lead: Lead;
  loanForeclosure?: Maybe<Scalars['String']>;
  ownerAddressProof?: Maybe<Scalars['String']>;
  parkingPaymentProofUrl?: Maybe<Scalars['String']>;
  regNo: Scalars['String'];
  registrationCertificate?: Maybe<Scalars['String']>;
  releaseOrder?: Maybe<Scalars['String']>;
  sellerAadharCard?: Maybe<Scalars['String']>;
  sellerPAN?: Maybe<Scalars['String']>;
};


export type LeadDocumentsLeadArgs = {
  filter?: InputMaybe<LeadFilter>;
};

export type LeadDocumentsAggregateResult = {
  __typename?: 'LeadDocumentsAggregateResult';
  bankAccountProofUrlMax?: Maybe<Scalars['String']>;
  bankAccountProofUrlMin?: Maybe<Scalars['String']>;
  bankNOCMax?: Maybe<Scalars['String']>;
  bankNOCMin?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  dealPaymentProofUrlMax?: Maybe<Scalars['String']>;
  dealPaymentProofUrlMin?: Maybe<Scalars['String']>;
  form26Max?: Maybe<Scalars['String']>;
  form26Min?: Maybe<Scalars['String']>;
  form28Max?: Maybe<Scalars['String']>;
  form28Min?: Maybe<Scalars['String']>;
  form29Max?: Maybe<Scalars['String']>;
  form29Min?: Maybe<Scalars['String']>;
  form30Max?: Maybe<Scalars['String']>;
  form30Min?: Maybe<Scalars['String']>;
  form35Max?: Maybe<Scalars['String']>;
  form35Min?: Maybe<Scalars['String']>;
  form36Max?: Maybe<Scalars['String']>;
  form36Min?: Maybe<Scalars['String']>;
  form60Max?: Maybe<Scalars['String']>;
  form60Min?: Maybe<Scalars['String']>;
  form60_sellerPanMax?: Maybe<Scalars['String']>;
  form60_sellerPanMin?: Maybe<Scalars['String']>;
  indemnityBondMax?: Maybe<Scalars['String']>;
  indemnityBondMin?: Maybe<Scalars['String']>;
  insuranceCertificateMax?: Maybe<Scalars['String']>;
  insuranceCertificateMin?: Maybe<Scalars['String']>;
  loanForeclosureMax?: Maybe<Scalars['String']>;
  loanForeclosureMin?: Maybe<Scalars['String']>;
  ownerAddressProofMax?: Maybe<Scalars['String']>;
  ownerAddressProofMin?: Maybe<Scalars['String']>;
  parkingPaymentProofUrlMax?: Maybe<Scalars['String']>;
  parkingPaymentProofUrlMin?: Maybe<Scalars['String']>;
  regNoMax?: Maybe<Scalars['String']>;
  regNoMin?: Maybe<Scalars['String']>;
  registrationCertificateMax?: Maybe<Scalars['String']>;
  registrationCertificateMin?: Maybe<Scalars['String']>;
  releaseOrderMax?: Maybe<Scalars['String']>;
  releaseOrderMin?: Maybe<Scalars['String']>;
  sellerAadharCardMax?: Maybe<Scalars['String']>;
  sellerAadharCardMin?: Maybe<Scalars['String']>;
  sellerPANMax?: Maybe<Scalars['String']>;
  sellerPANMin?: Maybe<Scalars['String']>;
};

export type LeadDocumentsFilter = {
  and?: InputMaybe<Array<InputMaybe<LeadDocumentsFilter>>>;
  has?: InputMaybe<Array<InputMaybe<LeadDocumentsHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<LeadDocumentsFilter>;
  or?: InputMaybe<Array<InputMaybe<LeadDocumentsFilter>>>;
  regNo?: InputMaybe<StringHashFilter>;
};

export enum LeadDocumentsHasFilter {
  BankAccountProofUrl = 'bankAccountProofUrl',
  BankNoc = 'bankNOC',
  DealPaymentProofUrl = 'dealPaymentProofUrl',
  Form26 = 'form26',
  Form28 = 'form28',
  Form29 = 'form29',
  Form30 = 'form30',
  Form35 = 'form35',
  Form36 = 'form36',
  Form60 = 'form60',
  Form60SellerPan = 'form60_sellerPan',
  IndemnityBond = 'indemnityBond',
  InsuranceCertificate = 'insuranceCertificate',
  Lead = 'lead',
  LoanForeclosure = 'loanForeclosure',
  OwnerAddressProof = 'ownerAddressProof',
  ParkingPaymentProofUrl = 'parkingPaymentProofUrl',
  RegNo = 'regNo',
  RegistrationCertificate = 'registrationCertificate',
  ReleaseOrder = 'releaseOrder',
  SellerAadharCard = 'sellerAadharCard',
  SellerPan = 'sellerPAN'
}

export type LeadDocumentsOrder = {
  asc?: InputMaybe<LeadDocumentsOrderable>;
  desc?: InputMaybe<LeadDocumentsOrderable>;
  then?: InputMaybe<LeadDocumentsOrder>;
};

export enum LeadDocumentsOrderable {
  BankAccountProofUrl = 'bankAccountProofUrl',
  BankNoc = 'bankNOC',
  DealPaymentProofUrl = 'dealPaymentProofUrl',
  Form26 = 'form26',
  Form28 = 'form28',
  Form29 = 'form29',
  Form30 = 'form30',
  Form35 = 'form35',
  Form36 = 'form36',
  Form60 = 'form60',
  Form60SellerPan = 'form60_sellerPan',
  IndemnityBond = 'indemnityBond',
  InsuranceCertificate = 'insuranceCertificate',
  LoanForeclosure = 'loanForeclosure',
  OwnerAddressProof = 'ownerAddressProof',
  ParkingPaymentProofUrl = 'parkingPaymentProofUrl',
  RegNo = 'regNo',
  RegistrationCertificate = 'registrationCertificate',
  ReleaseOrder = 'releaseOrder',
  SellerAadharCard = 'sellerAadharCard',
  SellerPan = 'sellerPAN'
}

export type LeadDocumentsPatch = {
  bankAccountProofUrl?: InputMaybe<Scalars['String']>;
  bankNOC?: InputMaybe<Scalars['String']>;
  dealPaymentProofUrl?: InputMaybe<Scalars['String']>;
  form26?: InputMaybe<Scalars['String']>;
  form28?: InputMaybe<Scalars['String']>;
  form29?: InputMaybe<Scalars['String']>;
  form30?: InputMaybe<Scalars['String']>;
  form35?: InputMaybe<Scalars['String']>;
  form36?: InputMaybe<Scalars['String']>;
  form60?: InputMaybe<Scalars['String']>;
  form60_sellerPan?: InputMaybe<Scalars['String']>;
  indemnityBond?: InputMaybe<Scalars['String']>;
  insuranceCertificate?: InputMaybe<Scalars['String']>;
  lead?: InputMaybe<LeadRef>;
  loanForeclosure?: InputMaybe<Scalars['String']>;
  ownerAddressProof?: InputMaybe<Scalars['String']>;
  parkingPaymentProofUrl?: InputMaybe<Scalars['String']>;
  registrationCertificate?: InputMaybe<Scalars['String']>;
  releaseOrder?: InputMaybe<Scalars['String']>;
  sellerAadharCard?: InputMaybe<Scalars['String']>;
  sellerPAN?: InputMaybe<Scalars['String']>;
};

export type LeadDocumentsRef = {
  bankAccountProofUrl?: InputMaybe<Scalars['String']>;
  bankNOC?: InputMaybe<Scalars['String']>;
  dealPaymentProofUrl?: InputMaybe<Scalars['String']>;
  form26?: InputMaybe<Scalars['String']>;
  form28?: InputMaybe<Scalars['String']>;
  form29?: InputMaybe<Scalars['String']>;
  form30?: InputMaybe<Scalars['String']>;
  form35?: InputMaybe<Scalars['String']>;
  form36?: InputMaybe<Scalars['String']>;
  form60?: InputMaybe<Scalars['String']>;
  form60_sellerPan?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  indemnityBond?: InputMaybe<Scalars['String']>;
  insuranceCertificate?: InputMaybe<Scalars['String']>;
  lead?: InputMaybe<LeadRef>;
  loanForeclosure?: InputMaybe<Scalars['String']>;
  ownerAddressProof?: InputMaybe<Scalars['String']>;
  parkingPaymentProofUrl?: InputMaybe<Scalars['String']>;
  regNo?: InputMaybe<Scalars['String']>;
  registrationCertificate?: InputMaybe<Scalars['String']>;
  releaseOrder?: InputMaybe<Scalars['String']>;
  sellerAadharCard?: InputMaybe<Scalars['String']>;
  sellerPAN?: InputMaybe<Scalars['String']>;
};

export type LeadExpense = {
  __typename?: 'LeadExpense';
  belongsTo?: Maybe<TripExpense>;
  category: ExpenseCategory;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isApproved?: Maybe<Scalars['Boolean']>;
  lead?: Maybe<Lead>;
  paymentStatus?: Maybe<PaymentStatus>;
  receiptUrl?: Maybe<Scalars['String']>;
  spentAmount: Scalars['String'];
};


export type LeadExpenseBelongsToArgs = {
  filter?: InputMaybe<TripExpenseFilter>;
};


export type LeadExpenseCreatedByArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type LeadExpenseLeadArgs = {
  filter?: InputMaybe<LeadFilter>;
};

export type LeadExpenseAggregateResult = {
  __typename?: 'LeadExpenseAggregateResult';
  count?: Maybe<Scalars['Int']>;
  createdAtMax?: Maybe<Scalars['DateTime']>;
  createdAtMin?: Maybe<Scalars['DateTime']>;
  descriptionMax?: Maybe<Scalars['String']>;
  descriptionMin?: Maybe<Scalars['String']>;
  receiptUrlMax?: Maybe<Scalars['String']>;
  receiptUrlMin?: Maybe<Scalars['String']>;
  spentAmountMax?: Maybe<Scalars['String']>;
  spentAmountMin?: Maybe<Scalars['String']>;
};

export type LeadExpenseFilter = {
  and?: InputMaybe<Array<InputMaybe<LeadExpenseFilter>>>;
  has?: InputMaybe<Array<InputMaybe<LeadExpenseHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<LeadExpenseFilter>;
  or?: InputMaybe<Array<InputMaybe<LeadExpenseFilter>>>;
  paymentStatus?: InputMaybe<PaymentStatus_Hash>;
};

export enum LeadExpenseHasFilter {
  BelongsTo = 'belongsTo',
  Category = 'category',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  Description = 'description',
  IsApproved = 'isApproved',
  Lead = 'lead',
  PaymentStatus = 'paymentStatus',
  ReceiptUrl = 'receiptUrl',
  SpentAmount = 'spentAmount'
}

export type LeadExpenseOrder = {
  asc?: InputMaybe<LeadExpenseOrderable>;
  desc?: InputMaybe<LeadExpenseOrderable>;
  then?: InputMaybe<LeadExpenseOrder>;
};

export enum LeadExpenseOrderable {
  CreatedAt = 'createdAt',
  Description = 'description',
  ReceiptUrl = 'receiptUrl',
  SpentAmount = 'spentAmount'
}

export type LeadExpensePatch = {
  belongsTo?: InputMaybe<TripExpenseRef>;
  category?: InputMaybe<ExpenseCategory>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserRef>;
  description?: InputMaybe<Scalars['String']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  lead?: InputMaybe<LeadRef>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  receiptUrl?: InputMaybe<Scalars['String']>;
  spentAmount?: InputMaybe<Scalars['String']>;
};

export type LeadExpenseRef = {
  belongsTo?: InputMaybe<TripExpenseRef>;
  category?: InputMaybe<ExpenseCategory>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserRef>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  lead?: InputMaybe<LeadRef>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  receiptUrl?: InputMaybe<Scalars['String']>;
  spentAmount?: InputMaybe<Scalars['String']>;
};

export enum LeadExpenseStatus {
  Disbursed = 'DISBURSED',
  PendingForApproval = 'PENDING_FOR_APPROVAL',
  PendingForDisbursement = 'PENDING_FOR_DISBURSEMENT',
  RejectedByFinance = 'REJECTED_BY_FINANCE',
  RejectedByOps = 'REJECTED_BY_OPS'
}

export type LeadExpenseStatus_Hash = {
  eq?: InputMaybe<LeadExpenseStatus>;
  in?: InputMaybe<Array<InputMaybe<LeadExpenseStatus>>>;
};

export type LeadFilter = {
  and?: InputMaybe<Array<InputMaybe<LeadFilter>>>;
  auctionByBank?: InputMaybe<BankName_Hash>;
  createdAt?: InputMaybe<DateTimeFilter>;
  has?: InputMaybe<Array<InputMaybe<LeadHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  listingPrice?: InputMaybe<IntFilter>;
  not?: InputMaybe<LeadFilter>;
  or?: InputMaybe<Array<InputMaybe<LeadFilter>>>;
  payInParts?: InputMaybe<Scalars['Boolean']>;
  regNo?: InputMaybe<StringHashFilter_StringRegExpFilter_StringTermFilter>;
  registrationState?: InputMaybe<StringFullTextFilter_StringHashFilter_StringRegExpFilter_StringTermFilter>;
  searchString?: InputMaybe<StringFullTextFilter_StringRegExpFilter>;
  sellingPrice?: InputMaybe<IntFilter>;
  source?: InputMaybe<LeadSource_Hash>;
  status?: InputMaybe<LeadBusinessStatus_Hash>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type LeadFilters = {
  auctioningAgencyName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bankConfirmationStatus?: InputMaybe<BankConfirmationStatus>;
  centreName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAtDateRange?: InputMaybe<DateRange>;
  createdBy?: InputMaybe<Scalars['String']>;
  dealStatus?: InputMaybe<DealStatus>;
  driverId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  driverName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hasAllStatuses?: InputMaybe<Array<InputMaybe<LeadStatus>>>;
  hasStatus?: InputMaybe<Array<InputMaybe<LeadStatus>>>;
  isRcAvailable?: InputMaybe<Scalars['Boolean']>;
  makes?: InputMaybe<Array<InputMaybe<VehicleMake>>>;
  models?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  paymentStatus?: InputMaybe<Array<InputMaybe<PaymentStatus>>>;
  pickupDateRange?: InputMaybe<DateRange>;
  purchaseYearsRange?: InputMaybe<DateRange>;
  registrationStates?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  repositionDateRange?: InputMaybe<DateRange>;
  searchString?: InputMaybe<Scalars['String']>;
  sortByUpdatedAt?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<LeadSource>;
  sourcedBankName?: InputMaybe<Array<InputMaybe<BankName>>>;
  statuses?: InputMaybe<Array<InputMaybe<LeadStatus>>>;
  vehicleBrand?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  vehicleModel?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export enum LeadHasFilter {
  Accessories = 'accessories',
  AccessoriesChecklist = 'accessoriesChecklist',
  ActiveBooking = 'activeBooking',
  ActualParkingCharges = 'actualParkingCharges',
  ActualPickupDate = 'actualPickupDate',
  ApprovedDealAmount = 'approvedDealAmount',
  ApprovedParkingChargesFor = 'approvedParkingChargesFor',
  ArchivedBookings = 'archivedBookings',
  AuctionByBank = 'auctionByBank',
  AuctionHistory = 'auctionHistory',
  AuctioningAgency = 'auctioningAgency',
  AuctioningBank = 'auctioningBank',
  Bookings = 'bookings',
  Centre = 'centre',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  Dealer = 'dealer',
  DealerStance = 'dealerStance',
  DealershipDocuments = 'dealershipDocuments',
  DeliveredSelfieUrl = 'deliveredSelfieUrl',
  DeliveryAmount = 'deliveryAmount',
  DeliveryCentre = 'deliveryCentre',
  DemandAmount = 'demandAmount',
  DocumentCharges = 'documentCharges',
  DocumentChecklist = 'documentChecklist',
  Documents = 'documents',
  DocumentsFollowups = 'documentsFollowups',
  EstimatedParkingCharges = 'estimatedParkingCharges',
  ExpectedPickupDate = 'expectedPickupDate',
  Expenses = 'expenses',
  ExpensesCoveredIn = 'expensesCoveredIn',
  FinalBidAmount = 'finalBidAmount',
  FinalParkingCharges = 'finalParkingCharges',
  HoldbackAmount = 'holdbackAmount',
  InternalTransfers = 'internalTransfers',
  ListingOnWebUpdatedAt = 'listingOnWebUpdatedAt',
  ListingPrice = 'listingPrice',
  ListingStatus = 'listingStatus',
  ListingUpdatedBy = 'listingUpdatedBy',
  LoanAmount = 'loanAmount',
  LoanToBeClosedBy = 'loanToBeClosedBy',
  OwnershipType = 'ownershipType',
  ParkingBeneficiary = 'parkingBeneficiary',
  PayInParts = 'payInParts',
  PaymentType = 'paymentType',
  Payments = 'payments',
  Pickup = 'pickup',
  ProposedBidLimitAmount = 'proposedBidLimitAmount',
  ProposedDealAmount = 'proposedDealAmount',
  RefurbishmentDetails = 'refurbishmentDetails',
  RegNo = 'regNo',
  RegistrationState = 'registrationState',
  SearchString = 'searchString',
  SellingPrice = 'sellingPrice',
  Source = 'source',
  Status = 'status',
  StatusEvents = 'statusEvents',
  TokenAmount = 'tokenAmount',
  UpdatedAt = 'updatedAt',
  UpdatedBy = 'updatedBy',
  Vehicle = 'vehicle',
  Yard = 'yard',
  YardPerDayParkingCharges = 'yardPerDayParkingCharges',
  YardPerDayParkingChargesByDriver = 'yardPerDayParkingChargesByDriver'
}

export type LeadOrder = {
  asc?: InputMaybe<LeadOrderable>;
  desc?: InputMaybe<LeadOrderable>;
  then?: InputMaybe<LeadOrder>;
};

export enum LeadOrderable {
  ActualParkingCharges = 'actualParkingCharges',
  ActualPickupDate = 'actualPickupDate',
  ApprovedDealAmount = 'approvedDealAmount',
  CreatedAt = 'createdAt',
  DeliveredSelfieUrl = 'deliveredSelfieUrl',
  DeliveryAmount = 'deliveryAmount',
  DemandAmount = 'demandAmount',
  DocumentCharges = 'documentCharges',
  EstimatedParkingCharges = 'estimatedParkingCharges',
  ExpectedPickupDate = 'expectedPickupDate',
  FinalBidAmount = 'finalBidAmount',
  FinalParkingCharges = 'finalParkingCharges',
  HoldbackAmount = 'holdbackAmount',
  ListingOnWebUpdatedAt = 'listingOnWebUpdatedAt',
  ListingPrice = 'listingPrice',
  LoanAmount = 'loanAmount',
  ProposedBidLimitAmount = 'proposedBidLimitAmount',
  ProposedDealAmount = 'proposedDealAmount',
  RegNo = 'regNo',
  RegistrationState = 'registrationState',
  SearchString = 'searchString',
  SellingPrice = 'sellingPrice',
  TokenAmount = 'tokenAmount',
  UpdatedAt = 'updatedAt',
  YardPerDayParkingCharges = 'yardPerDayParkingCharges',
  YardPerDayParkingChargesByDriver = 'yardPerDayParkingChargesByDriver'
}

export type LeadPatch = {
  accessories?: InputMaybe<Array<InputMaybe<AccessoriesCheckListWithStageRef>>>;
  accessoriesChecklist?: InputMaybe<Array<InputMaybe<AccessoriesChecklistRef>>>;
  activeBooking?: InputMaybe<BookingRef>;
  actualParkingCharges?: InputMaybe<Scalars['Int']>;
  actualPickupDate?: InputMaybe<Scalars['DateTime']>;
  approvedDealAmount?: InputMaybe<Scalars['Int']>;
  approvedParkingChargesFor?: InputMaybe<UserRole>;
  archivedBookings?: InputMaybe<Array<InputMaybe<BookingRef>>>;
  auctionByBank?: InputMaybe<BankName>;
  auctionHistory?: InputMaybe<Array<InputMaybe<AuctionHistoryRef>>>;
  auctioningAgency?: InputMaybe<AgencyRef>;
  auctioningBank?: InputMaybe<BankRef>;
  bookings?: InputMaybe<Array<InputMaybe<BookingRef>>>;
  centre?: InputMaybe<CentreRef>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserRef>;
  dealer?: InputMaybe<DealerRef>;
  dealerStance?: InputMaybe<DealerStanceRef>;
  dealershipDocuments?: InputMaybe<DealershipDocumentRef>;
  deliveredSelfieUrl?: InputMaybe<Scalars['String']>;
  deliveryAmount?: InputMaybe<Scalars['Int']>;
  deliveryCentre?: InputMaybe<CentreRef>;
  demandAmount?: InputMaybe<Scalars['Int']>;
  documentCharges?: InputMaybe<Scalars['Int']>;
  documentChecklist?: InputMaybe<DocumentChecklistRef>;
  documents?: InputMaybe<LeadDocumentsRef>;
  documentsFollowups?: InputMaybe<Array<InputMaybe<DocumentsFollowupsRef>>>;
  estimatedParkingCharges?: InputMaybe<Scalars['Float']>;
  expectedPickupDate?: InputMaybe<Scalars['DateTime']>;
  expenses?: InputMaybe<Array<InputMaybe<LeadExpenseRef>>>;
  expensesCoveredIn?: InputMaybe<Array<InputMaybe<TripExpenseRef>>>;
  finalBidAmount?: InputMaybe<Scalars['Int']>;
  finalParkingCharges?: InputMaybe<Scalars['Int']>;
  holdbackAmount?: InputMaybe<Scalars['Int']>;
  internalTransfers?: InputMaybe<Array<InputMaybe<VehicleTransferLogRef>>>;
  listingOnWebUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  listingPrice?: InputMaybe<Scalars['Int']>;
  listingStatus?: InputMaybe<ListingStatus>;
  listingUpdatedBy?: InputMaybe<UserRef>;
  loanAmount?: InputMaybe<Scalars['Int']>;
  loanToBeClosedBy?: InputMaybe<LoanToBeClosedBy>;
  ownershipType?: InputMaybe<Ownership>;
  parkingBeneficiary?: InputMaybe<ParkingBeneficiaryRef>;
  payInParts?: InputMaybe<Scalars['Boolean']>;
  paymentType?: InputMaybe<PaymentType>;
  payments?: InputMaybe<Array<InputMaybe<PaymentRef>>>;
  pickup?: InputMaybe<PickupRef>;
  proposedBidLimitAmount?: InputMaybe<Scalars['Int']>;
  proposedDealAmount?: InputMaybe<Scalars['Int']>;
  refurbishmentDetails?: InputMaybe<RefurbishmentDetailsRef>;
  registrationState?: InputMaybe<Scalars['String']>;
  searchString?: InputMaybe<Scalars['String']>;
  sellingPrice?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<LeadSource>;
  status?: InputMaybe<LeadBusinessStatus>;
  statusEvents?: InputMaybe<Array<InputMaybe<LeadStatusEventRef>>>;
  tokenAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedBy?: InputMaybe<UserRef>;
  vehicle?: InputMaybe<VehicleRef>;
  yard?: InputMaybe<YardRef>;
  yardPerDayParkingCharges?: InputMaybe<Scalars['Float']>;
  yardPerDayParkingChargesByDriver?: InputMaybe<Scalars['Float']>;
};

export type LeadRef = {
  accessories?: InputMaybe<Array<InputMaybe<AccessoriesCheckListWithStageRef>>>;
  accessoriesChecklist?: InputMaybe<Array<InputMaybe<AccessoriesChecklistRef>>>;
  activeBooking?: InputMaybe<BookingRef>;
  actualParkingCharges?: InputMaybe<Scalars['Int']>;
  actualPickupDate?: InputMaybe<Scalars['DateTime']>;
  approvedDealAmount?: InputMaybe<Scalars['Int']>;
  approvedParkingChargesFor?: InputMaybe<UserRole>;
  archivedBookings?: InputMaybe<Array<InputMaybe<BookingRef>>>;
  auctionByBank?: InputMaybe<BankName>;
  auctionHistory?: InputMaybe<Array<InputMaybe<AuctionHistoryRef>>>;
  auctioningAgency?: InputMaybe<AgencyRef>;
  auctioningBank?: InputMaybe<BankRef>;
  bookings?: InputMaybe<Array<InputMaybe<BookingRef>>>;
  centre?: InputMaybe<CentreRef>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserRef>;
  dealer?: InputMaybe<DealerRef>;
  dealerStance?: InputMaybe<DealerStanceRef>;
  dealershipDocuments?: InputMaybe<DealershipDocumentRef>;
  deliveredSelfieUrl?: InputMaybe<Scalars['String']>;
  deliveryAmount?: InputMaybe<Scalars['Int']>;
  deliveryCentre?: InputMaybe<CentreRef>;
  demandAmount?: InputMaybe<Scalars['Int']>;
  documentCharges?: InputMaybe<Scalars['Int']>;
  documentChecklist?: InputMaybe<DocumentChecklistRef>;
  documents?: InputMaybe<LeadDocumentsRef>;
  documentsFollowups?: InputMaybe<Array<InputMaybe<DocumentsFollowupsRef>>>;
  estimatedParkingCharges?: InputMaybe<Scalars['Float']>;
  expectedPickupDate?: InputMaybe<Scalars['DateTime']>;
  expenses?: InputMaybe<Array<InputMaybe<LeadExpenseRef>>>;
  expensesCoveredIn?: InputMaybe<Array<InputMaybe<TripExpenseRef>>>;
  finalBidAmount?: InputMaybe<Scalars['Int']>;
  finalParkingCharges?: InputMaybe<Scalars['Int']>;
  holdbackAmount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  internalTransfers?: InputMaybe<Array<InputMaybe<VehicleTransferLogRef>>>;
  listingOnWebUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  listingPrice?: InputMaybe<Scalars['Int']>;
  listingStatus?: InputMaybe<ListingStatus>;
  listingUpdatedBy?: InputMaybe<UserRef>;
  loanAmount?: InputMaybe<Scalars['Int']>;
  loanToBeClosedBy?: InputMaybe<LoanToBeClosedBy>;
  ownershipType?: InputMaybe<Ownership>;
  parkingBeneficiary?: InputMaybe<ParkingBeneficiaryRef>;
  payInParts?: InputMaybe<Scalars['Boolean']>;
  paymentType?: InputMaybe<PaymentType>;
  payments?: InputMaybe<Array<InputMaybe<PaymentRef>>>;
  pickup?: InputMaybe<PickupRef>;
  proposedBidLimitAmount?: InputMaybe<Scalars['Int']>;
  proposedDealAmount?: InputMaybe<Scalars['Int']>;
  refurbishmentDetails?: InputMaybe<RefurbishmentDetailsRef>;
  regNo?: InputMaybe<Scalars['String']>;
  registrationState?: InputMaybe<Scalars['String']>;
  searchString?: InputMaybe<Scalars['String']>;
  sellingPrice?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<LeadSource>;
  status?: InputMaybe<LeadBusinessStatus>;
  statusEvents?: InputMaybe<Array<InputMaybe<LeadStatusEventRef>>>;
  tokenAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedBy?: InputMaybe<UserRef>;
  vehicle?: InputMaybe<VehicleRef>;
  yard?: InputMaybe<YardRef>;
  yardPerDayParkingCharges?: InputMaybe<Scalars['Float']>;
  yardPerDayParkingChargesByDriver?: InputMaybe<Scalars['Float']>;
};

export enum LeadSource {
  BankAuction = 'BANK_AUCTION',
  DealershipSale = 'DEALERSHIP_SALE'
}

export type LeadSource_Hash = {
  eq?: InputMaybe<LeadSource>;
  in?: InputMaybe<Array<InputMaybe<LeadSource>>>;
};

export enum LeadStatus {
  AccessoriesChecklistAddedAfterDelivery = 'ACCESSORIES_CHECKLIST_ADDED_AFTER_DELIVERY',
  AccessoriesChecklistAddedAfterInternalDelivery = 'ACCESSORIES_CHECKLIST_ADDED_AFTER_INTERNAL_DELIVERY',
  AccessoriesChecklistAddedAtListing = 'ACCESSORIES_CHECKLIST_ADDED_AT_LISTING',
  AccessoriesChecklistAddedBeforeDelivery = 'ACCESSORIES_CHECKLIST_ADDED_BEFORE_DELIVERY',
  AccessoriesChecklistAddedBeforeInternalPickup = 'ACCESSORIES_CHECKLIST_ADDED_BEFORE_INTERNAL_PICKUP',
  AccessoriesChecklistAddedForLeadGenerated = 'ACCESSORIES_CHECKLIST_ADDED_FOR_LEAD_GENERATED',
  /** Acts like a sink for rejects */
  Archive = 'ARCHIVE',
  BidAmountLimitProposed = 'BID_AMOUNT_LIMIT_PROPOSED',
  BidLost = 'BID_LOST',
  BidWon = 'BID_WON',
  BookingCancelled = 'BOOKING_CANCELLED',
  BookingCancelledInitiator = 'BOOKING_CANCELLED_INITIATOR',
  BookingDeliveryAmountAdded = 'BOOKING_DELIVERY_AMOUNT_ADDED',
  BookingDeliveryPaymentReviewApproved = 'BOOKING_DELIVERY_PAYMENT_REVIEW_APPROVED',
  BookingDeliveryPaymentReviewRejected = 'BOOKING_DELIVERY_PAYMENT_REVIEW_REJECTED',
  BookingDeliveryRequested = 'BOOKING_DELIVERY_REQUESTED',
  BookingDetailsAdded = 'BOOKING_DETAILS_ADDED',
  BookingDetailsUpdated = 'BOOKING_DETAILS_UPDATED',
  BookingDetailsUpdateInitiator = 'BOOKING_DETAILS_UPDATE_INITIATOR',
  BookingFinanceCaseDropped = 'BOOKING_FINANCE_CASE_DROPPED',
  BookingFinanceRequested = 'BOOKING_FINANCE_REQUESTED',
  BookingLoanDOApproved = 'BOOKING_LOAN_D_O_APPROVED',
  BookingLoanDORejected = 'BOOKING_LOAN_D_O_REJECTED',
  BookingLoanFileLoggedIn = 'BOOKING_LOAN_FILE_LOGGED_IN',
  BookingLoanFIAdded = 'BOOKING_LOAN_F_I_ADDED',
  BookingLoanFIFailed = 'BOOKING_LOAN_F_I_FAILED',
  BookingLoanFIPassed = 'BOOKING_LOAN_F_I_PASSED',
  BookingLoanPaymentRejected = 'BOOKING_LOAN_PAYMENT_REJECTED',
  BookingLoanPaymentReviewed = 'BOOKING_LOAN_PAYMENT_REVIEWED',
  BookingPartPaymentAdded = 'BOOKING_PART_PAYMENT_ADDED',
  BookingPartPaymentInitiator = 'BOOKING_PART_PAYMENT_INITIATOR',
  BookingPartPaymentReviewApproved = 'BOOKING_PART_PAYMENT_REVIEW_APPROVED',
  BookingPartPaymentReviewRejected = 'BOOKING_PART_PAYMENT_REVIEW_REJECTED',
  BookingPaymentStructureUpdateInitiator = 'BOOKING_PAYMENT_STRUCTURE_UPDATE_INITIATOR',
  BookingTokenAmountAdded = 'BOOKING_TOKEN_AMOUNT_ADDED',
  BookingTokenPaymentReviewApproved = 'BOOKING_TOKEN_PAYMENT_REVIEW_APPROVED',
  BookingTokenPaymentReviewRejected = 'BOOKING_TOKEN_PAYMENT_REVIEW_REJECTED',
  BookingTotalPaymentReviewApproved = 'BOOKING_TOTAL_PAYMENT_REVIEW_APPROVED',
  BookingTotalPaymentReviewRejected = 'BOOKING_TOTAL_PAYMENT_REVIEW_REJECTED',
  DealerPaymentConfirmed = 'DEALER_PAYMENT_CONFIRMED',
  DealerPaymentRejected = 'DEALER_PAYMENT_REJECTED',
  DealerPaymentRequested = 'DEALER_PAYMENT_REQUESTED',
  /** Dealership : Deal Confirm Request sent to PH by PE  */
  DealAmountConfirmed = 'DEAL_AMOUNT_CONFIRMED',
  /** Dealership : Deal Amount Updated by PE */
  DealAmountUpdated = 'DEAL_AMOUNT_UPDATED',
  /** Bank approved the deal we won in the bid */
  DealApproved = 'DEAL_APPROVED',
  DealDeliveryPaymentConfirmed = 'DEAL_DELIVERY_PAYMENT_CONFIRMED',
  DealDeliveryPaymentRejected = 'DEAL_DELIVERY_PAYMENT_REJECTED',
  DealDeliveryPaymentRequested = 'DEAL_DELIVERY_PAYMENT_REQUESTED',
  /** Bank rejected the deal we won in the bid */
  DealRejected = 'DEAL_REJECTED',
  DealTokenPaymentConfirmed = 'DEAL_TOKEN_PAYMENT_CONFIRMED',
  DealTokenPaymentRejected = 'DEAL_TOKEN_PAYMENT_REJECTED',
  DealTokenPaymentRequested = 'DEAL_TOKEN_PAYMENT_REQUESTED',
  /** Tractor delivered at the centre */
  DeliveryCompleted = 'DELIVERY_COMPLETED',
  /** Driver expenses approved */
  DeliveryExpensesApproved = 'DELIVERY_EXPENSES_APPROVED',
  /** Payment is done for expenses and receipts uploaded */
  DeliveryExpensesPaymentReceiptsUploaded = 'DELIVERY_EXPENSES_PAYMENT_RECEIPTS_UPLOADED',
  /** Driver expense rejected */
  DeliveryExpensesRejected = 'DELIVERY_EXPENSES_REJECTED',
  /** Driver added delivery related expenses */
  DeliveryExpensesUploaded = 'DELIVERY_EXPENSES_UPLOADED',
  DeliveryPhotoUploaded = 'DELIVERY_PHOTO_UPLOADED',
  /** Selfie uploaded by the driver at the centre */
  DeliverySelfieUploaded = 'DELIVERY_SELFIE_UPLOADED',
  /** Pick up delivery started. The driver must be on the way */
  DeliveryStarted = 'DELIVERY_STARTED',
  /** Images uploaded at centre, after delivery */
  DeliveryVehicleImagesUploaded = 'DELIVERY_VEHICLE_IMAGES_UPLOADED',
  /** Delivery expenses rejected by finance */
  ExpensesPaymentRejected = 'EXPENSES_PAYMENT_REJECTED',
  HoldbackConfirmedByOh = 'HOLDBACK_CONFIRMED_BY_OH',
  HoldbackConfirmedByOm = 'HOLDBACK_CONFIRMED_BY_OM',
  HoldbackConfirmedByPm = 'HOLDBACK_CONFIRMED_BY_PM',
  HoldbackRejectedByOh = 'HOLDBACK_REJECTED_BY_OH',
  HoldbackRejectedByPm = 'HOLDBACK_REJECTED_BY_PM',
  HoldbackRepaymentConfirmed = 'HOLDBACK_REPAYMENT_CONFIRMED',
  HoldbackRepaymentRejected = 'HOLDBACK_REPAYMENT_REJECTED',
  HoldbackRepaymentRequested = 'HOLDBACK_REPAYMENT_REQUESTED',
  /** Back press on image upload */
  ImageUploadCancelled = 'IMAGE_UPLOAD_CANCELLED',
  InstallationBillsUploaded = 'INSTALLATION_BILLS_UPLOADED',
  InstallationConfirmedImagesUploaded = 'INSTALLATION_CONFIRMED_IMAGES_UPLOADED',
  InstallationPaymentConfirmed = 'INSTALLATION_PAYMENT_CONFIRMED',
  InstallationPaymentRejected = 'INSTALLATION_PAYMENT_REJECTED',
  InstallationPaymentRequestRaised = 'INSTALLATION_PAYMENT_REQUEST_RAISED',
  InstallationPaymentRequestRaisedSkip = 'INSTALLATION_PAYMENT_REQUEST_RAISED_SKIP',
  InternalTransferCompleted = 'INTERNAL_TRANSFER_COMPLETED',
  InternalTransferDropImagesUploaded = 'INTERNAL_TRANSFER_DROP_IMAGES_UPLOADED',
  InternalTransferInternalSelfieUploaded = 'INTERNAL_TRANSFER_INTERNAL_SELFIE_UPLOADED',
  InternalTransferPickupImagesUploaded = 'INTERNAL_TRANSFER_PICKUP_IMAGES_UPLOADED',
  InternalTransferStarted = 'INTERNAL_TRANSFER_STARTED',
  LeadDropped = 'LEAD_DROPPED',
  LeadDropInitiator = 'LEAD_DROP_INITIATOR',
  LeadGenerated = 'LEAD_GENERATED',
  LeadUpdated = 'LEAD_UPDATED',
  LeadUpdateInitiator = 'LEAD_UPDATE_INITIATOR',
  LeadVehicleImagesUploaded = 'LEAD_VEHICLE_IMAGES_UPLOADED',
  ListingImagesUploaded = 'LISTING_IMAGES_UPLOADED',
  ListingOnWebsiteUpdated = 'LISTING_ON_WEBSITE_UPDATED',
  ListingPriceUpdated = 'LISTING_PRICE_UPDATED',
  LoanCancelled = 'LOAN_CANCELLED',
  LoanCancelledInitiator = 'LOAN_CANCELLED_INITIATOR',
  LoanRepaymentConfirmed = 'LOAN_REPAYMENT_CONFIRMED',
  LoanRepaymentRejected = 'LOAN_REPAYMENT_REJECTED',
  LoanRepaymentRequested = 'LOAN_REPAYMENT_REQUESTED',
  /** Dealership : PH Proposes new Deal */
  NewDealProposed = 'NEW_DEAL_PROPOSED',
  /** Dealership : PE requests new Deal */
  NewDealRequested = 'NEW_DEAL_REQUESTED',
  /** Parking payment rejected by finance */
  ParkingPaymentRejected = 'PARKING_PAYMENT_REJECTED',
  /** Parking payment rejected by finance */
  ParkingPaymentRejectedByFinance = 'PARKING_PAYMENT_REJECTED_BY_FINANCE',
  /** Finance team made the payment and confirmed */
  PaymentConfirmed = 'PAYMENT_CONFIRMED',
  PaymentReimbursementApproved = 'PAYMENT_REIMBURSEMENT_APPROVED',
  PaymentReimbursementRejected = 'PAYMENT_REIMBURSEMENT_REJECTED',
  /** Finance team rejected the request */
  PaymentRequestRejected = 'PAYMENT_REQUEST_REJECTED',
  /** Request for payment sent to Finance team */
  PaymentRequestSent = 'PAYMENT_REQUEST_SENT',
  PaymentStructureAdded = 'PAYMENT_STRUCTURE_ADDED',
  PaymentStructureUpdated = 'PAYMENT_STRUCTURE_UPDATED',
  /** Pick up request accepted by the driver */
  PickupAccepted = 'PICKUP_ACCEPTED',
  PickupAcceptedForInternalTransfer = 'PICKUP_ACCEPTED_FOR_INTERNAL_TRANSFER',
  /** Pick up assignment related details added */
  PickupAssignmentDetailsAdded = 'PICKUP_ASSIGNMENT_DETAILS_ADDED',
  /** Documents needed to pick up uploaded, RO and IB */
  PickupDocumentsUploaded = 'PICKUP_DOCUMENTS_UPLOADED',
  /** Pick up initiated by the driver */
  PickupInitiated = 'PICKUP_INITIATED',
  /** Parking charges are reasonable and approved */
  PickupParkingPaymentApproved = 'PICKUP_PARKING_PAYMENT_APPROVED',
  /** Pick up parking estimation details added */
  PickupParkingPaymentDetailsEstimationAdded = 'PICKUP_PARKING_PAYMENT_DETAILS_ESTIMATION_ADDED',
  /** Details related to parking payment added */
  PickupParkingPaymentFinalDetailsAdded = 'PICKUP_PARKING_PAYMENT_FINAL_DETAILS_ADDED',
  /** Parking charges related details uploaded */
  PickupParkingPaymentReceiptsUploaded = 'PICKUP_PARKING_PAYMENT_RECEIPTS_UPLOADED',
  /** Pick up request rejected by the driver */
  PickupRejected = 'PICKUP_REJECTED',
  PickupRejectedForInternalTransfer = 'PICKUP_REJECTED_FOR_INTERNAL_TRANSFER',
  /** Pick up requested from a driver */
  PickupRequested = 'PICKUP_REQUESTED',
  /** Vehicle images uploaded at the time of pick up */
  PickupVehicleImagesUploaded = 'PICKUP_VEHICLE_IMAGES_UPLOADED',
  /** Details added about the yard where we need to pick up */
  PickupYardDetailsAdded = 'PICKUP_YARD_DETAILS_ADDED',
  ProposeNewDeal = 'PROPOSE_NEW_DEAL',
  PurchaseRequestApproved = 'PURCHASE_REQUEST_APPROVED',
  PurchaseRequestRaised = 'PURCHASE_REQUEST_RAISED',
  PurchaseRequestRejected = 'PURCHASE_REQUEST_REJECTED',
  /** Ready for sale! */
  ReadyForSale = 'READY_FOR_SALE',
  RefurbishmentApproved = 'REFURBISHMENT_APPROVED',
  RefurbishmentNotRequired = 'REFURBISHMENT_NOT_REQUIRED',
  RefurbishmentRejected = 'REFURBISHMENT_REJECTED',
  RequestNewDeal = 'REQUEST_NEW_DEAL',
  /** Dealership : RTO Verification */
  RtoConfirmed = 'RTO_CONFIRMED',
  RtoVerificationCompleted = 'RTO_VERIFICATION_COMPLETED',
  RtoVerificationRejected = 'RTO_VERIFICATION_REJECTED',
  SellingPriceUpdated = 'SELLING_PRICE_UPDATED',
  UpdateSellingPriceInitiator = 'UPDATE_SELLING_PRICE_INITIATOR',
  VehicleDetailsUpdated = 'VEHICLE_DETAILS_UPDATED',
  VehicleDocumentsChecked = 'VEHICLE_DOCUMENTS_CHECKED',
  VehicleDocumentsConfirmed = 'VEHICLE_DOCUMENTS_CONFIRMED',
  VehicleInspected = 'VEHICLE_INSPECTED',
  VehicleInternalTransferInitiator = 'VEHICLE_INTERNAL_TRANSFER_INITIATOR',
  /** Vehicle is in the centre, shining ;) */
  VehicleInStock = 'VEHICLE_IN_STOCK',
  VehicleTransferRequestRaised = 'VEHICLE_TRANSFER_REQUEST_RAISED'
}

export type LeadStatusEvent = {
  __typename?: 'LeadStatusEvent';
  assignTaskTo?: Maybe<UserRole>;
  createdAt: Scalars['DateTime'];
  createdBy: User;
  deviceType?: Maybe<DeviceType>;
  id: Scalars['ID'];
  /** This field tells whether the task is completed or not. Task is usually completed when the next desired status is punched. */
  isTaskCompleted?: Maybe<Scalars['Boolean']>;
  lead: Lead;
  metadata?: Maybe<Scalars['String']>;
  next?: Maybe<LeadStatusEvent>;
  notification?: Maybe<Notification>;
  notifyTo?: Maybe<Array<Maybe<UserRole>>>;
  postTimeline?: Maybe<Scalars['String']>;
  preTimeline?: Maybe<Scalars['String']>;
  previous?: Maybe<LeadStatusEvent>;
  remarks?: Maybe<Scalars['String']>;
  status: LeadStatus;
  task?: Maybe<Task>;
  taskButtonTitle?: Maybe<Scalars['String']>;
  taskTitle?: Maybe<Scalars['String']>;
};


export type LeadStatusEventCreatedByArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type LeadStatusEventLeadArgs = {
  filter?: InputMaybe<LeadFilter>;
};


export type LeadStatusEventNextArgs = {
  filter?: InputMaybe<LeadStatusEventFilter>;
};


export type LeadStatusEventNotificationArgs = {
  filter?: InputMaybe<NotificationFilter>;
};


export type LeadStatusEventPreviousArgs = {
  filter?: InputMaybe<LeadStatusEventFilter>;
};


export type LeadStatusEventTaskArgs = {
  filter?: InputMaybe<TaskFilter>;
};

export type LeadStatusEventAggregateResult = {
  __typename?: 'LeadStatusEventAggregateResult';
  count?: Maybe<Scalars['Int']>;
  createdAtMax?: Maybe<Scalars['DateTime']>;
  createdAtMin?: Maybe<Scalars['DateTime']>;
  metadataMax?: Maybe<Scalars['String']>;
  metadataMin?: Maybe<Scalars['String']>;
  postTimelineMax?: Maybe<Scalars['String']>;
  postTimelineMin?: Maybe<Scalars['String']>;
  preTimelineMax?: Maybe<Scalars['String']>;
  preTimelineMin?: Maybe<Scalars['String']>;
  remarksMax?: Maybe<Scalars['String']>;
  remarksMin?: Maybe<Scalars['String']>;
  taskButtonTitleMax?: Maybe<Scalars['String']>;
  taskButtonTitleMin?: Maybe<Scalars['String']>;
  taskTitleMax?: Maybe<Scalars['String']>;
  taskTitleMin?: Maybe<Scalars['String']>;
};

export type LeadStatusEventFilter = {
  and?: InputMaybe<Array<InputMaybe<LeadStatusEventFilter>>>;
  assignTaskTo?: InputMaybe<UserRole_Hash>;
  createdAt?: InputMaybe<DateTimeFilter>;
  has?: InputMaybe<Array<InputMaybe<LeadStatusEventHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  isTaskCompleted?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<StringTermFilter>;
  not?: InputMaybe<LeadStatusEventFilter>;
  notifyTo?: InputMaybe<UserRole_Hash>;
  or?: InputMaybe<Array<InputMaybe<LeadStatusEventFilter>>>;
  status?: InputMaybe<LeadStatus_Hash>;
};

export enum LeadStatusEventHasFilter {
  AssignTaskTo = 'assignTaskTo',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeviceType = 'deviceType',
  IsTaskCompleted = 'isTaskCompleted',
  Lead = 'lead',
  Metadata = 'metadata',
  Next = 'next',
  Notification = 'notification',
  NotifyTo = 'notifyTo',
  PostTimeline = 'postTimeline',
  PreTimeline = 'preTimeline',
  Previous = 'previous',
  Remarks = 'remarks',
  Status = 'status',
  Task = 'task',
  TaskButtonTitle = 'taskButtonTitle',
  TaskTitle = 'taskTitle'
}

export type LeadStatusEventOrder = {
  asc?: InputMaybe<LeadStatusEventOrderable>;
  desc?: InputMaybe<LeadStatusEventOrderable>;
  then?: InputMaybe<LeadStatusEventOrder>;
};

export enum LeadStatusEventOrderable {
  CreatedAt = 'createdAt',
  Metadata = 'metadata',
  PostTimeline = 'postTimeline',
  PreTimeline = 'preTimeline',
  Remarks = 'remarks',
  TaskButtonTitle = 'taskButtonTitle',
  TaskTitle = 'taskTitle'
}

export type LeadStatusEventPatch = {
  assignTaskTo?: InputMaybe<UserRole>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserRef>;
  deviceType?: InputMaybe<DeviceType>;
  /** This field tells whether the task is completed or not. Task is usually completed when the next desired status is punched. */
  isTaskCompleted?: InputMaybe<Scalars['Boolean']>;
  lead?: InputMaybe<LeadRef>;
  metadata?: InputMaybe<Scalars['String']>;
  next?: InputMaybe<LeadStatusEventRef>;
  notification?: InputMaybe<NotificationRef>;
  notifyTo?: InputMaybe<Array<InputMaybe<UserRole>>>;
  postTimeline?: InputMaybe<Scalars['String']>;
  preTimeline?: InputMaybe<Scalars['String']>;
  previous?: InputMaybe<LeadStatusEventRef>;
  remarks?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<LeadStatus>;
  task?: InputMaybe<TaskRef>;
  taskButtonTitle?: InputMaybe<Scalars['String']>;
  taskTitle?: InputMaybe<Scalars['String']>;
};

export type LeadStatusEventRef = {
  assignTaskTo?: InputMaybe<UserRole>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserRef>;
  deviceType?: InputMaybe<DeviceType>;
  id?: InputMaybe<Scalars['ID']>;
  /** This field tells whether the task is completed or not. Task is usually completed when the next desired status is punched. */
  isTaskCompleted?: InputMaybe<Scalars['Boolean']>;
  lead?: InputMaybe<LeadRef>;
  metadata?: InputMaybe<Scalars['String']>;
  next?: InputMaybe<LeadStatusEventRef>;
  notification?: InputMaybe<NotificationRef>;
  notifyTo?: InputMaybe<Array<InputMaybe<UserRole>>>;
  postTimeline?: InputMaybe<Scalars['String']>;
  preTimeline?: InputMaybe<Scalars['String']>;
  previous?: InputMaybe<LeadStatusEventRef>;
  remarks?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<LeadStatus>;
  task?: InputMaybe<TaskRef>;
  taskButtonTitle?: InputMaybe<Scalars['String']>;
  taskTitle?: InputMaybe<Scalars['String']>;
};

export type LeadStatusFlow = LeadTimelineStatus & {
  __typename?: 'LeadStatusFlow';
  /** User role that is responsible for the task. Task completion leads to next status */
  assignTaskTo?: Maybe<UserRole>;
  /** If the user can go back from this status to previous */
  canGoBack?: Maybe<Scalars['Boolean']>;
  /** Flag to take the user directly to the next form */
  canGoForward?: Maybe<Scalars['Boolean']>;
  /** New: CTA */
  cta?: Maybe<Scalars['String']>;
  /** Current status of the lead */
  current?: Maybe<LeadStatus>;
  /** New: Desired Status */
  desired?: Maybe<LeadStatus>;
  freshLeadTimelineAction?: Maybe<LeadTimelineAction>;
  /** New: Hide form */
  hideForm?: Maybe<Scalars['Boolean']>;
  /** Flag to not display undesired button - could be temporary */
  hideUndesiredButton?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  /** If the current status is a negative action */
  isNegativeCase?: Maybe<Scalars['Boolean']>;
  /** Next status of the lead */
  next?: Maybe<LeadStatus>;
  /** Notification text. Delimiters are underscores for fields to be filled in */
  notificationTitle?: Maybe<Scalars['String']>;
  /** User roles which should be notified at this status */
  notifyTo?: Maybe<Array<Maybe<UserRole>>>;
  /** New : Popup Description */
  popupDescription?: Maybe<Scalars['String']>;
  /** New : Popup Title */
  popupTitle?: Maybe<Scalars['String']>;
  /** Previous status of the lead */
  previous?: Maybe<LeadStatus>;
  rejectedLeadTimelineAction?: Maybe<LeadTimelineAction>;
  /** New: Show popup */
  showPopup?: Maybe<Scalars['Boolean']>;
  /** New : flag to show Remark input in popup */
  showPopupRemark?: Maybe<Scalars['Boolean']>;
  /** Flag to show popup with input fields */
  showPopupWithInputField?: Maybe<Scalars['Boolean']>;
  /** Source of this lead */
  source?: Maybe<LeadSource>;
  /** Text for action button for the task. Delimiters are underscores for fields to be filled in */
  taskButtonTitle?: Maybe<Scalars['String']>;
  /** Title for button for action on form if exists */
  taskFormActionTitle?: Maybe<Scalars['String']>;
  /** Title for button for negative action like cancel, reject etc. on form */
  taskFormNegativeActionTitle?: Maybe<Scalars['String']>;
  /** New: Task performed by */
  taskPerformedBy?: Maybe<UserRole>;
  /** Title for the task that needs to be done next. Delimiters are underscores for fields to be filled in */
  taskTitle?: Maybe<Scalars['String']>;
  /** New: task title was */
  taskTitleWas?: Maybe<Scalars['String']>;
  /** New: Undesired Status */
  undesired?: Maybe<LeadStatus>;
};


export type LeadStatusFlowFreshLeadTimelineActionArgs = {
  filter?: InputMaybe<LeadTimelineActionFilter>;
};


export type LeadStatusFlowRejectedLeadTimelineActionArgs = {
  filter?: InputMaybe<LeadTimelineActionFilter>;
};

export type LeadStatusFlowAggregateResult = {
  __typename?: 'LeadStatusFlowAggregateResult';
  count?: Maybe<Scalars['Int']>;
  ctaMax?: Maybe<Scalars['String']>;
  ctaMin?: Maybe<Scalars['String']>;
  notificationTitleMax?: Maybe<Scalars['String']>;
  notificationTitleMin?: Maybe<Scalars['String']>;
  popupDescriptionMax?: Maybe<Scalars['String']>;
  popupDescriptionMin?: Maybe<Scalars['String']>;
  popupTitleMax?: Maybe<Scalars['String']>;
  popupTitleMin?: Maybe<Scalars['String']>;
  taskButtonTitleMax?: Maybe<Scalars['String']>;
  taskButtonTitleMin?: Maybe<Scalars['String']>;
  taskFormActionTitleMax?: Maybe<Scalars['String']>;
  taskFormActionTitleMin?: Maybe<Scalars['String']>;
  taskFormNegativeActionTitleMax?: Maybe<Scalars['String']>;
  taskFormNegativeActionTitleMin?: Maybe<Scalars['String']>;
  taskTitleMax?: Maybe<Scalars['String']>;
  taskTitleMin?: Maybe<Scalars['String']>;
  taskTitleWasMax?: Maybe<Scalars['String']>;
  taskTitleWasMin?: Maybe<Scalars['String']>;
};

export type LeadStatusFlowFilter = {
  and?: InputMaybe<Array<InputMaybe<LeadStatusFlowFilter>>>;
  assignTaskTo?: InputMaybe<UserRole_Hash>;
  current?: InputMaybe<LeadStatus_Hash>;
  desired?: InputMaybe<LeadStatus_Hash>;
  has?: InputMaybe<Array<InputMaybe<LeadStatusFlowHasFilter>>>;
  hideForm?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  next?: InputMaybe<LeadStatus_Hash>;
  not?: InputMaybe<LeadStatusFlowFilter>;
  notifyTo?: InputMaybe<UserRole_Hash>;
  or?: InputMaybe<Array<InputMaybe<LeadStatusFlowFilter>>>;
  previous?: InputMaybe<LeadStatus_Hash>;
  showPopup?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<LeadSource_Hash>;
  taskPerformedBy?: InputMaybe<UserRole_Hash>;
  undesired?: InputMaybe<LeadStatus_Hash>;
};

export enum LeadStatusFlowHasFilter {
  AssignTaskTo = 'assignTaskTo',
  CanGoBack = 'canGoBack',
  CanGoForward = 'canGoForward',
  Cta = 'cta',
  Current = 'current',
  Desired = 'desired',
  FreshLeadTimelineAction = 'freshLeadTimelineAction',
  HideForm = 'hideForm',
  HideUndesiredButton = 'hideUndesiredButton',
  IsNegativeCase = 'isNegativeCase',
  Next = 'next',
  NotificationTitle = 'notificationTitle',
  NotifyTo = 'notifyTo',
  PopupDescription = 'popupDescription',
  PopupTitle = 'popupTitle',
  Previous = 'previous',
  RejectedLeadTimelineAction = 'rejectedLeadTimelineAction',
  ShowPopup = 'showPopup',
  ShowPopupRemark = 'showPopupRemark',
  ShowPopupWithInputField = 'showPopupWithInputField',
  Source = 'source',
  TaskButtonTitle = 'taskButtonTitle',
  TaskFormActionTitle = 'taskFormActionTitle',
  TaskFormNegativeActionTitle = 'taskFormNegativeActionTitle',
  TaskPerformedBy = 'taskPerformedBy',
  TaskTitle = 'taskTitle',
  TaskTitleWas = 'taskTitleWas',
  Undesired = 'undesired'
}

export type LeadStatusFlowOrder = {
  asc?: InputMaybe<LeadStatusFlowOrderable>;
  desc?: InputMaybe<LeadStatusFlowOrderable>;
  then?: InputMaybe<LeadStatusFlowOrder>;
};

export enum LeadStatusFlowOrderable {
  Cta = 'cta',
  NotificationTitle = 'notificationTitle',
  PopupDescription = 'popupDescription',
  PopupTitle = 'popupTitle',
  TaskButtonTitle = 'taskButtonTitle',
  TaskFormActionTitle = 'taskFormActionTitle',
  TaskFormNegativeActionTitle = 'taskFormNegativeActionTitle',
  TaskTitle = 'taskTitle',
  TaskTitleWas = 'taskTitleWas'
}

export type LeadStatusFlowPatch = {
  /** User role that is responsible for the task. Task completion leads to next status */
  assignTaskTo?: InputMaybe<UserRole>;
  /** If the user can go back from this status to previous */
  canGoBack?: InputMaybe<Scalars['Boolean']>;
  /** Flag to take the user directly to the next form */
  canGoForward?: InputMaybe<Scalars['Boolean']>;
  /** New: CTA */
  cta?: InputMaybe<Scalars['String']>;
  /** Current status of the lead */
  current?: InputMaybe<LeadStatus>;
  /** New: Desired Status */
  desired?: InputMaybe<LeadStatus>;
  freshLeadTimelineAction?: InputMaybe<LeadTimelineActionRef>;
  /** New: Hide form */
  hideForm?: InputMaybe<Scalars['Boolean']>;
  /** Flag to not display undesired button - could be temporary */
  hideUndesiredButton?: InputMaybe<Scalars['Boolean']>;
  /** If the current status is a negative action */
  isNegativeCase?: InputMaybe<Scalars['Boolean']>;
  /** Next status of the lead */
  next?: InputMaybe<LeadStatus>;
  /** Notification text. Delimiters are underscores for fields to be filled in */
  notificationTitle?: InputMaybe<Scalars['String']>;
  /** User roles which should be notified at this status */
  notifyTo?: InputMaybe<Array<InputMaybe<UserRole>>>;
  /** New : Popup Description */
  popupDescription?: InputMaybe<Scalars['String']>;
  /** New : Popup Title */
  popupTitle?: InputMaybe<Scalars['String']>;
  /** Previous status of the lead */
  previous?: InputMaybe<LeadStatus>;
  rejectedLeadTimelineAction?: InputMaybe<LeadTimelineActionRef>;
  /** New: Show popup */
  showPopup?: InputMaybe<Scalars['Boolean']>;
  /** New : flag to show Remark input in popup */
  showPopupRemark?: InputMaybe<Scalars['Boolean']>;
  /** Flag to show popup with input fields */
  showPopupWithInputField?: InputMaybe<Scalars['Boolean']>;
  /** Source of this lead */
  source?: InputMaybe<LeadSource>;
  /** Text for action button for the task. Delimiters are underscores for fields to be filled in */
  taskButtonTitle?: InputMaybe<Scalars['String']>;
  /** Title for button for action on form if exists */
  taskFormActionTitle?: InputMaybe<Scalars['String']>;
  /** Title for button for negative action like cancel, reject etc. on form */
  taskFormNegativeActionTitle?: InputMaybe<Scalars['String']>;
  /** New: Task performed by */
  taskPerformedBy?: InputMaybe<UserRole>;
  /** Title for the task that needs to be done next. Delimiters are underscores for fields to be filled in */
  taskTitle?: InputMaybe<Scalars['String']>;
  /** New: task title was */
  taskTitleWas?: InputMaybe<Scalars['String']>;
  /** New: Undesired Status */
  undesired?: InputMaybe<LeadStatus>;
};

export type LeadStatusFlowRef = {
  /** User role that is responsible for the task. Task completion leads to next status */
  assignTaskTo?: InputMaybe<UserRole>;
  /** If the user can go back from this status to previous */
  canGoBack?: InputMaybe<Scalars['Boolean']>;
  /** Flag to take the user directly to the next form */
  canGoForward?: InputMaybe<Scalars['Boolean']>;
  /** New: CTA */
  cta?: InputMaybe<Scalars['String']>;
  /** Current status of the lead */
  current?: InputMaybe<LeadStatus>;
  /** New: Desired Status */
  desired?: InputMaybe<LeadStatus>;
  freshLeadTimelineAction?: InputMaybe<LeadTimelineActionRef>;
  /** New: Hide form */
  hideForm?: InputMaybe<Scalars['Boolean']>;
  /** Flag to not display undesired button - could be temporary */
  hideUndesiredButton?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  /** If the current status is a negative action */
  isNegativeCase?: InputMaybe<Scalars['Boolean']>;
  /** Next status of the lead */
  next?: InputMaybe<LeadStatus>;
  /** Notification text. Delimiters are underscores for fields to be filled in */
  notificationTitle?: InputMaybe<Scalars['String']>;
  /** User roles which should be notified at this status */
  notifyTo?: InputMaybe<Array<InputMaybe<UserRole>>>;
  /** New : Popup Description */
  popupDescription?: InputMaybe<Scalars['String']>;
  /** New : Popup Title */
  popupTitle?: InputMaybe<Scalars['String']>;
  /** Previous status of the lead */
  previous?: InputMaybe<LeadStatus>;
  rejectedLeadTimelineAction?: InputMaybe<LeadTimelineActionRef>;
  /** New: Show popup */
  showPopup?: InputMaybe<Scalars['Boolean']>;
  /** New : flag to show Remark input in popup */
  showPopupRemark?: InputMaybe<Scalars['Boolean']>;
  /** Flag to show popup with input fields */
  showPopupWithInputField?: InputMaybe<Scalars['Boolean']>;
  /** Source of this lead */
  source?: InputMaybe<LeadSource>;
  /** Text for action button for the task. Delimiters are underscores for fields to be filled in */
  taskButtonTitle?: InputMaybe<Scalars['String']>;
  /** Title for button for action on form if exists */
  taskFormActionTitle?: InputMaybe<Scalars['String']>;
  /** Title for button for negative action like cancel, reject etc. on form */
  taskFormNegativeActionTitle?: InputMaybe<Scalars['String']>;
  /** New: Task performed by */
  taskPerformedBy?: InputMaybe<UserRole>;
  /** Title for the task that needs to be done next. Delimiters are underscores for fields to be filled in */
  taskTitle?: InputMaybe<Scalars['String']>;
  /** New: task title was */
  taskTitleWas?: InputMaybe<Scalars['String']>;
  /** New: Undesired Status */
  undesired?: InputMaybe<LeadStatus>;
};

export type LeadStatus_Hash = {
  eq?: InputMaybe<LeadStatus>;
  in?: InputMaybe<Array<InputMaybe<LeadStatus>>>;
};

export type LeadTimelineAction = {
  __typename?: 'LeadTimelineAction';
  id: Scalars['ID'];
  postAction?: Maybe<Scalars['String']>;
  preAction?: Maybe<Scalars['String']>;
};

export type LeadTimelineActionAggregateResult = {
  __typename?: 'LeadTimelineActionAggregateResult';
  count?: Maybe<Scalars['Int']>;
  postActionMax?: Maybe<Scalars['String']>;
  postActionMin?: Maybe<Scalars['String']>;
  preActionMax?: Maybe<Scalars['String']>;
  preActionMin?: Maybe<Scalars['String']>;
};

export type LeadTimelineActionFilter = {
  and?: InputMaybe<Array<InputMaybe<LeadTimelineActionFilter>>>;
  has?: InputMaybe<Array<InputMaybe<LeadTimelineActionHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<LeadTimelineActionFilter>;
  or?: InputMaybe<Array<InputMaybe<LeadTimelineActionFilter>>>;
};

export enum LeadTimelineActionHasFilter {
  PostAction = 'postAction',
  PreAction = 'preAction'
}

export type LeadTimelineActionOrder = {
  asc?: InputMaybe<LeadTimelineActionOrderable>;
  desc?: InputMaybe<LeadTimelineActionOrderable>;
  then?: InputMaybe<LeadTimelineActionOrder>;
};

export enum LeadTimelineActionOrderable {
  PostAction = 'postAction',
  PreAction = 'preAction'
}

export type LeadTimelineActionPatch = {
  postAction?: InputMaybe<Scalars['String']>;
  preAction?: InputMaybe<Scalars['String']>;
};

export type LeadTimelineActionRef = {
  id?: InputMaybe<Scalars['ID']>;
  postAction?: InputMaybe<Scalars['String']>;
  preAction?: InputMaybe<Scalars['String']>;
};

export type LeadTimelineStatus = {
  freshLeadTimelineAction?: Maybe<LeadTimelineAction>;
  id?: Maybe<Scalars['ID']>;
  rejectedLeadTimelineAction?: Maybe<LeadTimelineAction>;
};


export type LeadTimelineStatusFreshLeadTimelineActionArgs = {
  filter?: InputMaybe<LeadTimelineActionFilter>;
};


export type LeadTimelineStatusRejectedLeadTimelineActionArgs = {
  filter?: InputMaybe<LeadTimelineActionFilter>;
};

export type LeadTimelineStatusAggregateResult = {
  __typename?: 'LeadTimelineStatusAggregateResult';
  count?: Maybe<Scalars['Int']>;
};

export type LeadTimelineStatusFilter = {
  and?: InputMaybe<Array<InputMaybe<LeadTimelineStatusFilter>>>;
  has?: InputMaybe<Array<InputMaybe<LeadTimelineStatusHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<LeadTimelineStatusFilter>;
  or?: InputMaybe<Array<InputMaybe<LeadTimelineStatusFilter>>>;
};

export enum LeadTimelineStatusHasFilter {
  FreshLeadTimelineAction = 'freshLeadTimelineAction',
  RejectedLeadTimelineAction = 'rejectedLeadTimelineAction'
}

export type LeadTimelineStatusPatch = {
  freshLeadTimelineAction?: InputMaybe<LeadTimelineActionRef>;
  rejectedLeadTimelineAction?: InputMaybe<LeadTimelineActionRef>;
};

export type LeadTimelineStatusRef = {
  id: Scalars['ID'];
};

export type LeadsForListingFilter = {
  brandId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  centreId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createById?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  driverId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  first?: InputMaybe<Scalars['Int']>;
  listingPrice?: InputMaybe<PriceRange>;
  mfgYear?: InputMaybe<Scalars['String']>;
  modelId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  purchaseType?: InputMaybe<LeadSource>;
  searchString?: InputMaybe<Scalars['String']>;
  sellingPrice?: InputMaybe<PriceRange>;
  state?: InputMaybe<Scalars['String']>;
  statusEvents?: InputMaybe<Array<InputMaybe<LeadStatus>>>;
  userId?: InputMaybe<Scalars['String']>;
  userRole?: InputMaybe<UserRole>;
};

export enum ListingStatus {
  ListedOnWebsite = 'LISTED_ON_WEBSITE',
  PendingOnWebsite = 'PENDING_ON_WEBSITE'
}

export type Loan = {
  __typename?: 'Loan';
  appliedLoanAmount?: Maybe<Scalars['Int']>;
  bankName?: Maybe<BankName>;
  booking?: Maybe<Booking>;
  bookingWithArchivedLoan?: Maybe<Booking>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deliveryOrderDate?: Maybe<Scalars['DateTime']>;
  deliveryOrderDocUrl?: Maybe<Scalars['String']>;
  deliveryOrderStatus?: Maybe<LoanStatus>;
  deliveryOrderValidity?: Maybe<Scalars['Int']>;
  fieldInspectionConfirmedDate?: Maybe<Scalars['DateTime']>;
  fieldInspectionDate?: Maybe<Scalars['DateTime']>;
  fieldInspectionStatus?: Maybe<LoanStatus>;
  /** auto_generated id */
  id: Scalars['ID'];
  loanCancelReason?: Maybe<LoanRejectionReason>;
  /** login Details */
  loanStage?: Maybe<LoanStage>;
  loanStatus: LoanStatus;
  loginApplicationFormUrl?: Maybe<Scalars['String']>;
  loginDate?: Maybe<Scalars['DateTime']>;
  loginStatus?: Maybe<LoanStatus>;
  rejectedAt?: Maybe<LoanStage>;
  rejectionReason?: Maybe<LoanRejectionReason>;
  sanctionedLoanAmount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type LoanBookingArgs = {
  filter?: InputMaybe<BookingFilter>;
};


export type LoanBookingWithArchivedLoanArgs = {
  filter?: InputMaybe<BookingFilter>;
};

export type LoanAggregateResult = {
  __typename?: 'LoanAggregateResult';
  appliedLoanAmountAvg?: Maybe<Scalars['Float']>;
  appliedLoanAmountMax?: Maybe<Scalars['Int']>;
  appliedLoanAmountMin?: Maybe<Scalars['Int']>;
  appliedLoanAmountSum?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  createdAtMax?: Maybe<Scalars['DateTime']>;
  createdAtMin?: Maybe<Scalars['DateTime']>;
  deliveryOrderDateMax?: Maybe<Scalars['DateTime']>;
  deliveryOrderDateMin?: Maybe<Scalars['DateTime']>;
  deliveryOrderDocUrlMax?: Maybe<Scalars['String']>;
  deliveryOrderDocUrlMin?: Maybe<Scalars['String']>;
  deliveryOrderValidityAvg?: Maybe<Scalars['Float']>;
  deliveryOrderValidityMax?: Maybe<Scalars['Int']>;
  deliveryOrderValidityMin?: Maybe<Scalars['Int']>;
  deliveryOrderValiditySum?: Maybe<Scalars['Int']>;
  fieldInspectionConfirmedDateMax?: Maybe<Scalars['DateTime']>;
  fieldInspectionConfirmedDateMin?: Maybe<Scalars['DateTime']>;
  fieldInspectionDateMax?: Maybe<Scalars['DateTime']>;
  fieldInspectionDateMin?: Maybe<Scalars['DateTime']>;
  loginApplicationFormUrlMax?: Maybe<Scalars['String']>;
  loginApplicationFormUrlMin?: Maybe<Scalars['String']>;
  loginDateMax?: Maybe<Scalars['DateTime']>;
  loginDateMin?: Maybe<Scalars['DateTime']>;
  sanctionedLoanAmountAvg?: Maybe<Scalars['Float']>;
  sanctionedLoanAmountMax?: Maybe<Scalars['Int']>;
  sanctionedLoanAmountMin?: Maybe<Scalars['Int']>;
  sanctionedLoanAmountSum?: Maybe<Scalars['Int']>;
  updatedAtMax?: Maybe<Scalars['DateTime']>;
  updatedAtMin?: Maybe<Scalars['DateTime']>;
};

export type LoanFilter = {
  and?: InputMaybe<Array<InputMaybe<LoanFilter>>>;
  has?: InputMaybe<Array<InputMaybe<LoanHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<LoanFilter>;
  or?: InputMaybe<Array<InputMaybe<LoanFilter>>>;
};

export enum LoanHasFilter {
  AppliedLoanAmount = 'appliedLoanAmount',
  BankName = 'bankName',
  Booking = 'booking',
  BookingWithArchivedLoan = 'bookingWithArchivedLoan',
  CreatedAt = 'createdAt',
  DeliveryOrderDate = 'deliveryOrderDate',
  DeliveryOrderDocUrl = 'deliveryOrderDocUrl',
  DeliveryOrderStatus = 'deliveryOrderStatus',
  DeliveryOrderValidity = 'deliveryOrderValidity',
  FieldInspectionConfirmedDate = 'fieldInspectionConfirmedDate',
  FieldInspectionDate = 'fieldInspectionDate',
  FieldInspectionStatus = 'fieldInspectionStatus',
  LoanCancelReason = 'loanCancelReason',
  LoanStage = 'loanStage',
  LoanStatus = 'loanStatus',
  LoginApplicationFormUrl = 'loginApplicationFormUrl',
  LoginDate = 'loginDate',
  LoginStatus = 'loginStatus',
  RejectedAt = 'rejectedAt',
  RejectionReason = 'rejectionReason',
  SanctionedLoanAmount = 'sanctionedLoanAmount',
  UpdatedAt = 'updatedAt'
}

export type LoanOrder = {
  asc?: InputMaybe<LoanOrderable>;
  desc?: InputMaybe<LoanOrderable>;
  then?: InputMaybe<LoanOrder>;
};

export enum LoanOrderable {
  AppliedLoanAmount = 'appliedLoanAmount',
  CreatedAt = 'createdAt',
  DeliveryOrderDate = 'deliveryOrderDate',
  DeliveryOrderDocUrl = 'deliveryOrderDocUrl',
  DeliveryOrderValidity = 'deliveryOrderValidity',
  FieldInspectionConfirmedDate = 'fieldInspectionConfirmedDate',
  FieldInspectionDate = 'fieldInspectionDate',
  LoginApplicationFormUrl = 'loginApplicationFormUrl',
  LoginDate = 'loginDate',
  SanctionedLoanAmount = 'sanctionedLoanAmount',
  UpdatedAt = 'updatedAt'
}

export type LoanPatch = {
  appliedLoanAmount?: InputMaybe<Scalars['Int']>;
  bankName?: InputMaybe<BankName>;
  booking?: InputMaybe<BookingRef>;
  bookingWithArchivedLoan?: InputMaybe<BookingRef>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deliveryOrderDate?: InputMaybe<Scalars['DateTime']>;
  deliveryOrderDocUrl?: InputMaybe<Scalars['String']>;
  deliveryOrderStatus?: InputMaybe<LoanStatus>;
  deliveryOrderValidity?: InputMaybe<Scalars['Int']>;
  fieldInspectionConfirmedDate?: InputMaybe<Scalars['DateTime']>;
  fieldInspectionDate?: InputMaybe<Scalars['DateTime']>;
  fieldInspectionStatus?: InputMaybe<LoanStatus>;
  loanCancelReason?: InputMaybe<LoanRejectionReason>;
  /** login Details */
  loanStage?: InputMaybe<LoanStage>;
  loanStatus?: InputMaybe<LoanStatus>;
  loginApplicationFormUrl?: InputMaybe<Scalars['String']>;
  loginDate?: InputMaybe<Scalars['DateTime']>;
  loginStatus?: InputMaybe<LoanStatus>;
  rejectedAt?: InputMaybe<LoanStage>;
  rejectionReason?: InputMaybe<LoanRejectionReason>;
  sanctionedLoanAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LoanRef = {
  appliedLoanAmount?: InputMaybe<Scalars['Int']>;
  bankName?: InputMaybe<BankName>;
  booking?: InputMaybe<BookingRef>;
  bookingWithArchivedLoan?: InputMaybe<BookingRef>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deliveryOrderDate?: InputMaybe<Scalars['DateTime']>;
  deliveryOrderDocUrl?: InputMaybe<Scalars['String']>;
  deliveryOrderStatus?: InputMaybe<LoanStatus>;
  deliveryOrderValidity?: InputMaybe<Scalars['Int']>;
  fieldInspectionConfirmedDate?: InputMaybe<Scalars['DateTime']>;
  fieldInspectionDate?: InputMaybe<Scalars['DateTime']>;
  fieldInspectionStatus?: InputMaybe<LoanStatus>;
  /** auto_generated id */
  id?: InputMaybe<Scalars['ID']>;
  loanCancelReason?: InputMaybe<LoanRejectionReason>;
  /** login Details */
  loanStage?: InputMaybe<LoanStage>;
  loanStatus?: InputMaybe<LoanStatus>;
  loginApplicationFormUrl?: InputMaybe<Scalars['String']>;
  loginDate?: InputMaybe<Scalars['DateTime']>;
  loginStatus?: InputMaybe<LoanStatus>;
  rejectedAt?: InputMaybe<LoanStage>;
  rejectionReason?: InputMaybe<LoanRejectionReason>;
  sanctionedLoanAmount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export enum LoanRejectionReason {
  AreaNegative = 'AREA_NEGATIVE',
  CustomerNi = 'CUSTOMER_NI',
  InaccurateDetails = 'INACCURATE_DETAILS',
  LowCibil = 'LOW_CIBIL',
  LowIncome = 'LOW_INCOME',
  Others = 'OTHERS',
  ProfileNegative = 'PROFILE_NEGATIVE',
  TooManyPendingLoans = 'TOO_MANY_PENDING_LOANS'
}

export enum LoanStage {
  DeliveryOrder = 'DELIVERY_ORDER',
  FieldInspection = 'FIELD_INSPECTION',
  Login = 'LOGIN'
}

export enum LoanStatus {
  Active = 'ACTIVE',
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  DoUpdated = 'DO_UPDATED',
  FiApproved = 'FI_APPROVED',
  FiUpdated = 'FI_UPDATED',
  LoggedIn = 'LOGGED_IN',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED',
  Update = 'UPDATE',
  Wip = 'WIP'
}

export enum LoanToBeClosedBy {
  Customer = 'CUSTOMER',
  Dealer = 'DEALER',
  TractorJunction = 'TRACTOR_JUNCTION'
}

export type LogTracking = {
  __typename?: 'LogTracking';
  actionType: ActionType;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  module: ModuleType;
  previousValue: Scalars['String'];
  source: DeviceType;
  sourceUpdated: Scalars['String'];
  status?: Maybe<TaskStatus>;
  taskPerformedBy: User;
  updatedValue: Scalars['String'];
};


export type LogTrackingTaskPerformedByArgs = {
  filter?: InputMaybe<UserFilter>;
};

export type LogTrackingAggregateResult = {
  __typename?: 'LogTrackingAggregateResult';
  count?: Maybe<Scalars['Int']>;
  createdAtMax?: Maybe<Scalars['DateTime']>;
  createdAtMin?: Maybe<Scalars['DateTime']>;
  previousValueMax?: Maybe<Scalars['String']>;
  previousValueMin?: Maybe<Scalars['String']>;
  sourceUpdatedMax?: Maybe<Scalars['String']>;
  sourceUpdatedMin?: Maybe<Scalars['String']>;
  updatedValueMax?: Maybe<Scalars['String']>;
  updatedValueMin?: Maybe<Scalars['String']>;
};

export type LogTrackingFilter = {
  and?: InputMaybe<Array<InputMaybe<LogTrackingFilter>>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  has?: InputMaybe<Array<InputMaybe<LogTrackingHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  module?: InputMaybe<ModuleType_Hash>;
  not?: InputMaybe<LogTrackingFilter>;
  or?: InputMaybe<Array<InputMaybe<LogTrackingFilter>>>;
  source?: InputMaybe<DeviceType_Hash>;
  status?: InputMaybe<TaskStatus_Hash>;
};

export enum LogTrackingHasFilter {
  ActionType = 'actionType',
  CreatedAt = 'createdAt',
  Module = 'module',
  PreviousValue = 'previousValue',
  Source = 'source',
  SourceUpdated = 'sourceUpdated',
  Status = 'status',
  TaskPerformedBy = 'taskPerformedBy',
  UpdatedValue = 'updatedValue'
}

export type LogTrackingOrder = {
  asc?: InputMaybe<LogTrackingOrderable>;
  desc?: InputMaybe<LogTrackingOrderable>;
  then?: InputMaybe<LogTrackingOrder>;
};

export enum LogTrackingOrderable {
  CreatedAt = 'createdAt',
  PreviousValue = 'previousValue',
  SourceUpdated = 'sourceUpdated',
  UpdatedValue = 'updatedValue'
}

export type LogTrackingPatch = {
  actionType?: InputMaybe<ActionType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  module?: InputMaybe<ModuleType>;
  previousValue?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<DeviceType>;
  sourceUpdated?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TaskStatus>;
  taskPerformedBy?: InputMaybe<UserRef>;
  updatedValue?: InputMaybe<Scalars['String']>;
};

export type LogTrackingRef = {
  actionType?: InputMaybe<ActionType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  module?: InputMaybe<ModuleType>;
  previousValue?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<DeviceType>;
  sourceUpdated?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TaskStatus>;
  taskPerformedBy?: InputMaybe<UserRef>;
  updatedValue?: InputMaybe<Scalars['String']>;
};

export type MarkSoldInput = {
  env?: InputMaybe<Scalars['String']>;
  regNo?: InputMaybe<Scalars['String']>;
};

export type MarkSoldResponse = {
  __typename?: 'MarkSoldResponse';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type MarkSoldResponseAggregateResult = {
  __typename?: 'MarkSoldResponseAggregateResult';
  count?: Maybe<Scalars['Int']>;
  messageMax?: Maybe<Scalars['String']>;
  messageMin?: Maybe<Scalars['String']>;
};

export type MarkSoldResponseFilter = {
  and?: InputMaybe<Array<InputMaybe<MarkSoldResponseFilter>>>;
  has?: InputMaybe<Array<InputMaybe<MarkSoldResponseHasFilter>>>;
  not?: InputMaybe<MarkSoldResponseFilter>;
  or?: InputMaybe<Array<InputMaybe<MarkSoldResponseFilter>>>;
};

export enum MarkSoldResponseHasFilter {
  Message = 'message',
  Status = 'status'
}

export type MarkSoldResponseOrder = {
  asc?: InputMaybe<MarkSoldResponseOrderable>;
  desc?: InputMaybe<MarkSoldResponseOrderable>;
  then?: InputMaybe<MarkSoldResponseOrder>;
};

export enum MarkSoldResponseOrderable {
  Message = 'message'
}

export type MarkSoldResponsePatch = {
  message?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type MarkSoldResponseRef = {
  message?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type Message = {
  __typename?: 'Message';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  readBy?: Maybe<Array<Maybe<User>>>;
  readByAggregate?: Maybe<UserAggregateResult>;
  sentBy?: Maybe<User>;
  text: Scalars['String'];
};


export type MessageReadByArgs = {
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<UserOrder>;
};


export type MessageReadByAggregateArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type MessageSentByArgs = {
  filter?: InputMaybe<UserFilter>;
};

export type MessageAggregateResult = {
  __typename?: 'MessageAggregateResult';
  count?: Maybe<Scalars['Int']>;
  createdAtMax?: Maybe<Scalars['DateTime']>;
  createdAtMin?: Maybe<Scalars['DateTime']>;
  textMax?: Maybe<Scalars['String']>;
  textMin?: Maybe<Scalars['String']>;
};

export type MessageFilter = {
  and?: InputMaybe<Array<InputMaybe<MessageFilter>>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  has?: InputMaybe<Array<InputMaybe<MessageHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<MessageFilter>;
  or?: InputMaybe<Array<InputMaybe<MessageFilter>>>;
};

export enum MessageHasFilter {
  CreatedAt = 'createdAt',
  ReadBy = 'readBy',
  SentBy = 'sentBy',
  Text = 'text'
}

export type MessageOrder = {
  asc?: InputMaybe<MessageOrderable>;
  desc?: InputMaybe<MessageOrderable>;
  then?: InputMaybe<MessageOrder>;
};

export enum MessageOrderable {
  CreatedAt = 'createdAt',
  Text = 'text'
}

export type MessagePatch = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  readBy?: InputMaybe<Array<InputMaybe<UserRef>>>;
  sentBy?: InputMaybe<UserRef>;
  text?: InputMaybe<Scalars['String']>;
};

export type MessageRef = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  readBy?: InputMaybe<Array<InputMaybe<UserRef>>>;
  sentBy?: InputMaybe<UserRef>;
  text?: InputMaybe<Scalars['String']>;
};

export enum Mode {
  Batch = 'BATCH',
  Single = 'SINGLE'
}

export type Model = {
  __typename?: 'Model';
  brand: Brand;
  id: Scalars['ID'];
  model_id: Scalars['Int'];
  name: Scalars['String'];
};


export type ModelBrandArgs = {
  filter?: InputMaybe<BrandFilter>;
};

export type ModelAggregateResult = {
  __typename?: 'ModelAggregateResult';
  count?: Maybe<Scalars['Int']>;
  model_idAvg?: Maybe<Scalars['Float']>;
  model_idMax?: Maybe<Scalars['Int']>;
  model_idMin?: Maybe<Scalars['Int']>;
  model_idSum?: Maybe<Scalars['Int']>;
  nameMax?: Maybe<Scalars['String']>;
  nameMin?: Maybe<Scalars['String']>;
};

export type ModelByMake = {
  __typename?: 'ModelByMake';
  id?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
};

export type ModelByMakeAggregateResult = {
  __typename?: 'ModelByMakeAggregateResult';
  count?: Maybe<Scalars['Int']>;
  idMax?: Maybe<Scalars['String']>;
  idMin?: Maybe<Scalars['String']>;
  makeMax?: Maybe<Scalars['String']>;
  makeMin?: Maybe<Scalars['String']>;
  modelMax?: Maybe<Scalars['String']>;
  modelMin?: Maybe<Scalars['String']>;
};

export type ModelByMakeFilter = {
  and?: InputMaybe<Array<InputMaybe<ModelByMakeFilter>>>;
  has?: InputMaybe<Array<InputMaybe<ModelByMakeHasFilter>>>;
  make?: InputMaybe<StringFullTextFilter>;
  model?: InputMaybe<StringFullTextFilter>;
  not?: InputMaybe<ModelByMakeFilter>;
  or?: InputMaybe<Array<InputMaybe<ModelByMakeFilter>>>;
};

export enum ModelByMakeHasFilter {
  Id = 'id',
  Make = 'make',
  Model = 'model'
}

export type ModelByMakeOrder = {
  asc?: InputMaybe<ModelByMakeOrderable>;
  desc?: InputMaybe<ModelByMakeOrderable>;
  then?: InputMaybe<ModelByMakeOrder>;
};

export enum ModelByMakeOrderable {
  Id = 'id',
  Make = 'make',
  Model = 'model'
}

export type ModelByMakePatch = {
  id?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
};

export type ModelByMakeRef = {
  id?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
};

export type ModelFilter = {
  and?: InputMaybe<Array<InputMaybe<ModelFilter>>>;
  has?: InputMaybe<Array<InputMaybe<ModelHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  model_id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFullTextFilter>;
  not?: InputMaybe<ModelFilter>;
  or?: InputMaybe<Array<InputMaybe<ModelFilter>>>;
};

export enum ModelHasFilter {
  Brand = 'brand',
  ModelId = 'model_id',
  Name = 'name'
}

export type ModelOrder = {
  asc?: InputMaybe<ModelOrderable>;
  desc?: InputMaybe<ModelOrderable>;
  then?: InputMaybe<ModelOrder>;
};

export enum ModelOrderable {
  ModelId = 'model_id',
  Name = 'name'
}

export type ModelPatch = {
  brand?: InputMaybe<BrandRef>;
  name?: InputMaybe<Scalars['String']>;
};

export type ModelRef = {
  brand?: InputMaybe<BrandRef>;
  id?: InputMaybe<Scalars['ID']>;
  model_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export enum ModuleType {
  Booking = 'BOOKING',
  Centre = 'CENTRE',
  Document = 'DOCUMENT',
  Enquiry = 'ENQUIRY',
  Expense = 'EXPENSE',
  Inventory = 'INVENTORY',
  Listing = 'LISTING',
  ListingPrice = 'LISTING_PRICE',
  Procurement = 'PROCUREMENT',
  Refurbishment = 'REFURBISHMENT',
  SellingPrice = 'SELLING_PRICE',
  User = 'USER',
  Yard = 'YARD'
}

export type ModuleType_Hash = {
  eq?: InputMaybe<ModuleType>;
  in?: InputMaybe<Array<InputMaybe<ModuleType>>>;
};

export type MultiPolygon = {
  __typename?: 'MultiPolygon';
  polygons: Array<Polygon>;
};

export type MultiPolygonRef = {
  polygons: Array<PolygonRef>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addAccessoriesCheck?: Maybe<AddAccessoriesCheckPayload>;
  addAccessoriesCheckListWithStage?: Maybe<AddAccessoriesCheckListWithStagePayload>;
  addAccessoriesChecklist?: Maybe<AddAccessoriesChecklistPayload>;
  addActiveStateWithGSTN?: Maybe<AddActiveStateWithGstnPayload>;
  addAdminLeadStatusEvent?: Maybe<AddAdminLeadStatusEventPayload>;
  addAgency?: Maybe<AddAgencyPayload>;
  addAuctionHistory?: Maybe<AddAuctionHistoryPayload>;
  addBank?: Maybe<AddBankPayload>;
  addBankAuctionLeadCountByName?: Maybe<AddBankAuctionLeadCountByNamePayload>;
  addBooking?: Maybe<AddBookingPayload>;
  addBookingPayment?: Maybe<AddBookingPaymentPayload>;
  addBrand?: Maybe<AddBrandPayload>;
  addBulkApprovalResponse?: Maybe<AddBulkApprovalResponsePayload>;
  addCenterlizeLocationDistrcitsResponse?: Maybe<AddCenterlizeLocationDistrcitsResponsePayload>;
  addCenterlizeLocationDistrict?: Maybe<AddCenterlizeLocationDistrictPayload>;
  addCenterlizeLocationStates?: Maybe<AddCenterlizeLocationStatesPayload>;
  addCenterlizeLocationStatesResponse?: Maybe<AddCenterlizeLocationStatesResponsePayload>;
  addCenterlizeLocationTehsil?: Maybe<AddCenterlizeLocationTehsilPayload>;
  addCenterlizeLocationTehsilResponse?: Maybe<AddCenterlizeLocationTehsilResponsePayload>;
  addCentre?: Maybe<AddCentrePayload>;
  addCentreAggregates?: Maybe<AddCentreAggregatesPayload>;
  addCity?: Maybe<AddCityPayload>;
  addCreateBulkLeadResponse?: Maybe<AddCreateBulkLeadResponsePayload>;
  addCustomer?: Maybe<AddCustomerPayload>;
  addDealer?: Maybe<AddDealerPayload>;
  addDealerStance?: Maybe<AddDealerStancePayload>;
  addDealershipDocument?: Maybe<AddDealershipDocumentPayload>;
  addDealershipLeadCountByPEName?: Maybe<AddDealershipLeadCountByPeNamePayload>;
  addDistrict?: Maybe<AddDistrictPayload>;
  addDocument?: Maybe<AddDocumentPayload>;
  addDocumentChecklist?: Maybe<AddDocumentChecklistPayload>;
  addDocumentsCount?: Maybe<AddDocumentsCountPayload>;
  addDocumentsFollowups?: Maybe<AddDocumentsFollowupsPayload>;
  addDriverAggregates?: Maybe<AddDriverAggregatesPayload>;
  addEnquiry?: Maybe<AddEnquiryPayload>;
  addEnquiryAdherence?: Maybe<AddEnquiryAdherencePayload>;
  addEnquiryAggByCentre?: Maybe<AddEnquiryAggByCentrePayload>;
  addEnquiryCloserAgg?: Maybe<AddEnquiryCloserAggPayload>;
  addEnquiryClosure?: Maybe<AddEnquiryClosurePayload>;
  addFollowup?: Maybe<AddFollowupPayload>;
  addIdByName?: Maybe<AddIdByNamePayload>;
  addIdentificationDocument?: Maybe<AddIdentificationDocumentPayload>;
  addIdsByNameForListingReponse?: Maybe<AddIdsByNameForListingReponsePayload>;
  addInventoryDetails?: Maybe<AddInventoryDetailsPayload>;
  addIssue?: Maybe<AddIssuePayload>;
  addIssueItem?: Maybe<AddIssueItemPayload>;
  addItemInventoryDetails?: Maybe<AddItemInventoryDetailsPayload>;
  addLead?: Maybe<AddLeadPayload>;
  addLeadCountByStatus?: Maybe<AddLeadCountByStatusPayload>;
  addLeadDocuments?: Maybe<AddLeadDocumentsPayload>;
  addLeadExpense?: Maybe<AddLeadExpensePayload>;
  addLeadStatusEvent?: Maybe<AddLeadStatusEventPayload>;
  addLeadStatusFlow?: Maybe<AddLeadStatusFlowPayload>;
  addLeadTimelineAction?: Maybe<AddLeadTimelineActionPayload>;
  addLoan?: Maybe<AddLoanPayload>;
  addLogTracking?: Maybe<AddLogTrackingPayload>;
  addMarkSoldResponse?: Maybe<AddMarkSoldResponsePayload>;
  addMessage?: Maybe<AddMessagePayload>;
  addModel?: Maybe<AddModelPayload>;
  addModelByMake?: Maybe<AddModelByMakePayload>;
  addNotification?: Maybe<AddNotificationPayload>;
  addNumberOfPendingTasks?: Maybe<AddNumberOfPendingTasksPayload>;
  addParkingBeneficiary?: Maybe<AddParkingBeneficiaryPayload>;
  addPayment?: Maybe<AddPaymentPayload>;
  addPaymentInvoices?: Maybe<AddPaymentInvoicesPayload>;
  addPickup?: Maybe<AddPickupPayload>;
  addProduct?: Maybe<AddProductPayload>;
  addPurchase?: Maybe<AddPurchasePayload>;
  addPurchaseItem?: Maybe<AddPurchaseItemPayload>;
  addRefurbishmentBeneficiary?: Maybe<AddRefurbishmentBeneficiaryPayload>;
  addRefurbishmentDetails?: Maybe<AddRefurbishmentDetailsPayload>;
  addRefurbishmentItem?: Maybe<AddRefurbishmentItemPayload>;
  addRefurbishmentRequest?: Maybe<AddRefurbishmentRequestPayload>;
  addSMSLogs?: Maybe<AddSmsLogsPayload>;
  addSendSmsToCustomerResponse?: Maybe<AddSendSmsToCustomerResponsePayload>;
  addStateCodeWithRegNumber?: Maybe<AddStateCodeWithRegNumberPayload>;
  addStatusAggregate?: Maybe<AddStatusAggregatePayload>;
  addTJCentre?: Maybe<AddTjCentrePayload>;
  addTask?: Maybe<AddTaskPayload>;
  addTehsil?: Maybe<AddTehsilPayload>;
  addTripExpense?: Maybe<AddTripExpensePayload>;
  addUser?: Maybe<AddUserPayload>;
  addVehicle?: Maybe<AddVehiclePayload>;
  addVehicleDocuments?: Maybe<AddVehicleDocumentsPayload>;
  addVehicleFinancing?: Maybe<AddVehicleFinancingPayload>;
  addVehicleImages?: Maybe<AddVehicleImagesPayload>;
  addVehicleInsurance?: Maybe<AddVehicleInsurancePayload>;
  addVehicleOwner?: Maybe<AddVehicleOwnerPayload>;
  addVehicleTransferLog?: Maybe<AddVehicleTransferLogPayload>;
  addYard?: Maybe<AddYardPayload>;
  adddocumentsAggregatesResult?: Maybe<AdddocumentsAggregatesResultPayload>;
  deleteAccessoriesCheck?: Maybe<DeleteAccessoriesCheckPayload>;
  deleteAccessoriesCheckListWithStage?: Maybe<DeleteAccessoriesCheckListWithStagePayload>;
  deleteAccessoriesChecklist?: Maybe<DeleteAccessoriesChecklistPayload>;
  deleteActiveStateWithGSTN?: Maybe<DeleteActiveStateWithGstnPayload>;
  deleteAdminLeadStatusEvent?: Maybe<DeleteAdminLeadStatusEventPayload>;
  deleteAgency?: Maybe<DeleteAgencyPayload>;
  deleteAuctionHistory?: Maybe<DeleteAuctionHistoryPayload>;
  deleteBank?: Maybe<DeleteBankPayload>;
  deleteBankAuctionLeadCountByName?: Maybe<DeleteBankAuctionLeadCountByNamePayload>;
  deleteBooking?: Maybe<DeleteBookingPayload>;
  deleteBookingPayment?: Maybe<DeleteBookingPaymentPayload>;
  deleteBrand?: Maybe<DeleteBrandPayload>;
  deleteBulkApprovalResponse?: Maybe<DeleteBulkApprovalResponsePayload>;
  deleteCenterlizeLocationDistrcitsResponse?: Maybe<DeleteCenterlizeLocationDistrcitsResponsePayload>;
  deleteCenterlizeLocationDistrict?: Maybe<DeleteCenterlizeLocationDistrictPayload>;
  deleteCenterlizeLocationStates?: Maybe<DeleteCenterlizeLocationStatesPayload>;
  deleteCenterlizeLocationStatesResponse?: Maybe<DeleteCenterlizeLocationStatesResponsePayload>;
  deleteCenterlizeLocationTehsil?: Maybe<DeleteCenterlizeLocationTehsilPayload>;
  deleteCenterlizeLocationTehsilResponse?: Maybe<DeleteCenterlizeLocationTehsilResponsePayload>;
  deleteCentre?: Maybe<DeleteCentrePayload>;
  deleteCentreAggregates?: Maybe<DeleteCentreAggregatesPayload>;
  deleteCity?: Maybe<DeleteCityPayload>;
  deleteCreateBulkLeadResponse?: Maybe<DeleteCreateBulkLeadResponsePayload>;
  deleteCustomer?: Maybe<DeleteCustomerPayload>;
  deleteDealer?: Maybe<DeleteDealerPayload>;
  deleteDealerStance?: Maybe<DeleteDealerStancePayload>;
  deleteDealershipDocument?: Maybe<DeleteDealershipDocumentPayload>;
  deleteDealershipLeadCountByPEName?: Maybe<DeleteDealershipLeadCountByPeNamePayload>;
  deleteDistrict?: Maybe<DeleteDistrictPayload>;
  deleteDocument?: Maybe<DeleteDocumentPayload>;
  deleteDocumentChecklist?: Maybe<DeleteDocumentChecklistPayload>;
  deleteDocumentsCount?: Maybe<DeleteDocumentsCountPayload>;
  deleteDocumentsFollowups?: Maybe<DeleteDocumentsFollowupsPayload>;
  deleteDriverAggregates?: Maybe<DeleteDriverAggregatesPayload>;
  deleteEnquiry?: Maybe<DeleteEnquiryPayload>;
  deleteEnquiryAdherence?: Maybe<DeleteEnquiryAdherencePayload>;
  deleteEnquiryAggByCentre?: Maybe<DeleteEnquiryAggByCentrePayload>;
  deleteEnquiryCloserAgg?: Maybe<DeleteEnquiryCloserAggPayload>;
  deleteEnquiryClosure?: Maybe<DeleteEnquiryClosurePayload>;
  deleteFollowup?: Maybe<DeleteFollowupPayload>;
  deleteIdByName?: Maybe<DeleteIdByNamePayload>;
  deleteIdentificationDocument?: Maybe<DeleteIdentificationDocumentPayload>;
  deleteIdsByNameForListingReponse?: Maybe<DeleteIdsByNameForListingReponsePayload>;
  deleteInventoryDetails?: Maybe<DeleteInventoryDetailsPayload>;
  deleteIssue?: Maybe<DeleteIssuePayload>;
  deleteIssueItem?: Maybe<DeleteIssueItemPayload>;
  deleteItemInventoryDetails?: Maybe<DeleteItemInventoryDetailsPayload>;
  deleteLead?: Maybe<DeleteLeadPayload>;
  deleteLeadCountByStatus?: Maybe<DeleteLeadCountByStatusPayload>;
  deleteLeadDocuments?: Maybe<DeleteLeadDocumentsPayload>;
  deleteLeadExpense?: Maybe<DeleteLeadExpensePayload>;
  deleteLeadStatusEvent?: Maybe<DeleteLeadStatusEventPayload>;
  deleteLeadStatusFlow?: Maybe<DeleteLeadStatusFlowPayload>;
  deleteLeadTimelineAction?: Maybe<DeleteLeadTimelineActionPayload>;
  deleteLeadTimelineStatus?: Maybe<DeleteLeadTimelineStatusPayload>;
  deleteLoan?: Maybe<DeleteLoanPayload>;
  deleteLogTracking?: Maybe<DeleteLogTrackingPayload>;
  deleteMarkSoldResponse?: Maybe<DeleteMarkSoldResponsePayload>;
  deleteMessage?: Maybe<DeleteMessagePayload>;
  deleteModel?: Maybe<DeleteModelPayload>;
  deleteModelByMake?: Maybe<DeleteModelByMakePayload>;
  deleteNotification?: Maybe<DeleteNotificationPayload>;
  deleteNumberOfPendingTasks?: Maybe<DeleteNumberOfPendingTasksPayload>;
  deleteParkingBeneficiary?: Maybe<DeleteParkingBeneficiaryPayload>;
  deletePayment?: Maybe<DeletePaymentPayload>;
  deletePaymentInvoices?: Maybe<DeletePaymentInvoicesPayload>;
  deletePickup?: Maybe<DeletePickupPayload>;
  deleteProduct?: Maybe<DeleteProductPayload>;
  deletePurchase?: Maybe<DeletePurchasePayload>;
  deletePurchaseItem?: Maybe<DeletePurchaseItemPayload>;
  deleteRefurbishmentBeneficiary?: Maybe<DeleteRefurbishmentBeneficiaryPayload>;
  deleteRefurbishmentDetails?: Maybe<DeleteRefurbishmentDetailsPayload>;
  deleteRefurbishmentItem?: Maybe<DeleteRefurbishmentItemPayload>;
  deleteRefurbishmentRequest?: Maybe<DeleteRefurbishmentRequestPayload>;
  deleteSMSLogs?: Maybe<DeleteSmsLogsPayload>;
  deleteSendSmsToCustomerResponse?: Maybe<DeleteSendSmsToCustomerResponsePayload>;
  deleteStateCodeWithRegNumber?: Maybe<DeleteStateCodeWithRegNumberPayload>;
  deleteStatusAggregate?: Maybe<DeleteStatusAggregatePayload>;
  deleteTJCentre?: Maybe<DeleteTjCentrePayload>;
  deleteTask?: Maybe<DeleteTaskPayload>;
  deleteTehsil?: Maybe<DeleteTehsilPayload>;
  deleteTripExpense?: Maybe<DeleteTripExpensePayload>;
  deleteUser?: Maybe<DeleteUserPayload>;
  deleteVehicle?: Maybe<DeleteVehiclePayload>;
  deleteVehicleDocuments?: Maybe<DeleteVehicleDocumentsPayload>;
  deleteVehicleFinancing?: Maybe<DeleteVehicleFinancingPayload>;
  deleteVehicleImages?: Maybe<DeleteVehicleImagesPayload>;
  deleteVehicleInsurance?: Maybe<DeleteVehicleInsurancePayload>;
  deleteVehicleOwner?: Maybe<DeleteVehicleOwnerPayload>;
  deleteVehicleTransferLog?: Maybe<DeleteVehicleTransferLogPayload>;
  deleteYard?: Maybe<DeleteYardPayload>;
  deletedocumentsAggregatesResult?: Maybe<DeletedocumentsAggregatesResultPayload>;
  updateAccessoriesCheck?: Maybe<UpdateAccessoriesCheckPayload>;
  updateAccessoriesCheckListWithStage?: Maybe<UpdateAccessoriesCheckListWithStagePayload>;
  updateAccessoriesChecklist?: Maybe<UpdateAccessoriesChecklistPayload>;
  updateActiveStateWithGSTN?: Maybe<UpdateActiveStateWithGstnPayload>;
  updateAdminLeadStatusEvent?: Maybe<UpdateAdminLeadStatusEventPayload>;
  updateAgency?: Maybe<UpdateAgencyPayload>;
  updateAuctionHistory?: Maybe<UpdateAuctionHistoryPayload>;
  updateBank?: Maybe<UpdateBankPayload>;
  updateBankAuctionLeadCountByName?: Maybe<UpdateBankAuctionLeadCountByNamePayload>;
  updateBooking?: Maybe<UpdateBookingPayload>;
  updateBookingPayment?: Maybe<UpdateBookingPaymentPayload>;
  updateBrand?: Maybe<UpdateBrandPayload>;
  updateBulkApprovalResponse?: Maybe<UpdateBulkApprovalResponsePayload>;
  updateCenterlizeLocationDistrcitsResponse?: Maybe<UpdateCenterlizeLocationDistrcitsResponsePayload>;
  updateCenterlizeLocationDistrict?: Maybe<UpdateCenterlizeLocationDistrictPayload>;
  updateCenterlizeLocationStates?: Maybe<UpdateCenterlizeLocationStatesPayload>;
  updateCenterlizeLocationStatesResponse?: Maybe<UpdateCenterlizeLocationStatesResponsePayload>;
  updateCenterlizeLocationTehsil?: Maybe<UpdateCenterlizeLocationTehsilPayload>;
  updateCenterlizeLocationTehsilResponse?: Maybe<UpdateCenterlizeLocationTehsilResponsePayload>;
  updateCentre?: Maybe<UpdateCentrePayload>;
  updateCentreAggregates?: Maybe<UpdateCentreAggregatesPayload>;
  updateCreateBulkLeadResponse?: Maybe<UpdateCreateBulkLeadResponsePayload>;
  updateCustomer?: Maybe<UpdateCustomerPayload>;
  updateDealer?: Maybe<UpdateDealerPayload>;
  updateDealerStance?: Maybe<UpdateDealerStancePayload>;
  updateDealershipDocument?: Maybe<UpdateDealershipDocumentPayload>;
  updateDealershipLeadCountByPEName?: Maybe<UpdateDealershipLeadCountByPeNamePayload>;
  updateDistrict?: Maybe<UpdateDistrictPayload>;
  updateDocument?: Maybe<UpdateDocumentPayload>;
  updateDocumentChecklist?: Maybe<UpdateDocumentChecklistPayload>;
  updateDocumentsCount?: Maybe<UpdateDocumentsCountPayload>;
  updateDocumentsFollowups?: Maybe<UpdateDocumentsFollowupsPayload>;
  updateDriverAggregates?: Maybe<UpdateDriverAggregatesPayload>;
  updateEnquiry?: Maybe<UpdateEnquiryPayload>;
  updateEnquiryAdherence?: Maybe<UpdateEnquiryAdherencePayload>;
  updateEnquiryAggByCentre?: Maybe<UpdateEnquiryAggByCentrePayload>;
  updateEnquiryCloserAgg?: Maybe<UpdateEnquiryCloserAggPayload>;
  updateEnquiryClosure?: Maybe<UpdateEnquiryClosurePayload>;
  updateFollowup?: Maybe<UpdateFollowupPayload>;
  updateIdByName?: Maybe<UpdateIdByNamePayload>;
  updateIdentificationDocument?: Maybe<UpdateIdentificationDocumentPayload>;
  updateIdsByNameForListingReponse?: Maybe<UpdateIdsByNameForListingReponsePayload>;
  updateInventoryDetails?: Maybe<UpdateInventoryDetailsPayload>;
  updateIssue?: Maybe<UpdateIssuePayload>;
  updateIssueItem?: Maybe<UpdateIssueItemPayload>;
  updateItemInventoryDetails?: Maybe<UpdateItemInventoryDetailsPayload>;
  updateLead?: Maybe<UpdateLeadPayload>;
  updateLeadCountByStatus?: Maybe<UpdateLeadCountByStatusPayload>;
  updateLeadDocuments?: Maybe<UpdateLeadDocumentsPayload>;
  updateLeadExpense?: Maybe<UpdateLeadExpensePayload>;
  updateLeadStatusEvent?: Maybe<UpdateLeadStatusEventPayload>;
  updateLeadStatusFlow?: Maybe<UpdateLeadStatusFlowPayload>;
  updateLeadTimelineAction?: Maybe<UpdateLeadTimelineActionPayload>;
  updateLeadTimelineStatus?: Maybe<UpdateLeadTimelineStatusPayload>;
  updateLoan?: Maybe<UpdateLoanPayload>;
  updateLogTracking?: Maybe<UpdateLogTrackingPayload>;
  updateMarkSoldResponse?: Maybe<UpdateMarkSoldResponsePayload>;
  updateMessage?: Maybe<UpdateMessagePayload>;
  updateModel?: Maybe<UpdateModelPayload>;
  updateModelByMake?: Maybe<UpdateModelByMakePayload>;
  updateNotification?: Maybe<UpdateNotificationPayload>;
  updateNumberOfPendingTasks?: Maybe<UpdateNumberOfPendingTasksPayload>;
  updateParkingBeneficiary?: Maybe<UpdateParkingBeneficiaryPayload>;
  updatePayment?: Maybe<UpdatePaymentPayload>;
  updatePaymentInvoices?: Maybe<UpdatePaymentInvoicesPayload>;
  updatePickup?: Maybe<UpdatePickupPayload>;
  updateProduct?: Maybe<UpdateProductPayload>;
  updatePurchase?: Maybe<UpdatePurchasePayload>;
  updatePurchaseItem?: Maybe<UpdatePurchaseItemPayload>;
  updateRefurbishmentBeneficiary?: Maybe<UpdateRefurbishmentBeneficiaryPayload>;
  updateRefurbishmentDetails?: Maybe<UpdateRefurbishmentDetailsPayload>;
  updateRefurbishmentItem?: Maybe<UpdateRefurbishmentItemPayload>;
  updateRefurbishmentRequest?: Maybe<UpdateRefurbishmentRequestPayload>;
  updateSMSLogs?: Maybe<UpdateSmsLogsPayload>;
  updateSendSmsToCustomerResponse?: Maybe<UpdateSendSmsToCustomerResponsePayload>;
  updateStateCodeWithRegNumber?: Maybe<UpdateStateCodeWithRegNumberPayload>;
  updateStatusAggregate?: Maybe<UpdateStatusAggregatePayload>;
  updateTJCentre?: Maybe<UpdateTjCentrePayload>;
  updateTask?: Maybe<UpdateTaskPayload>;
  updateTehsil?: Maybe<UpdateTehsilPayload>;
  updateTripExpense?: Maybe<UpdateTripExpensePayload>;
  updateUser?: Maybe<UpdateUserPayload>;
  updateVehicle?: Maybe<UpdateVehiclePayload>;
  updateVehicleDocuments?: Maybe<UpdateVehicleDocumentsPayload>;
  updateVehicleFinancing?: Maybe<UpdateVehicleFinancingPayload>;
  updateVehicleImages?: Maybe<UpdateVehicleImagesPayload>;
  updateVehicleInsurance?: Maybe<UpdateVehicleInsurancePayload>;
  updateVehicleOwner?: Maybe<UpdateVehicleOwnerPayload>;
  updateVehicleTransferLog?: Maybe<UpdateVehicleTransferLogPayload>;
  updateYard?: Maybe<UpdateYardPayload>;
  updatedocumentsAggregatesResult?: Maybe<UpdatedocumentsAggregatesResultPayload>;
};


export type MutationAddAccessoriesCheckArgs = {
  input: Array<AddAccessoriesCheckInput>;
};


export type MutationAddAccessoriesCheckListWithStageArgs = {
  input: Array<AddAccessoriesCheckListWithStageInput>;
};


export type MutationAddAccessoriesChecklistArgs = {
  input: Array<AddAccessoriesChecklistInput>;
};


export type MutationAddActiveStateWithGstnArgs = {
  input: Array<AddActiveStateWithGstnInput>;
  upsert?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddAdminLeadStatusEventArgs = {
  input: Array<AddAdminLeadStatusEventInput>;
};


export type MutationAddAgencyArgs = {
  input: Array<AddAgencyInput>;
  upsert?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddAuctionHistoryArgs = {
  input: Array<AddAuctionHistoryInput>;
};


export type MutationAddBankArgs = {
  input: Array<AddBankInput>;
  upsert?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddBankAuctionLeadCountByNameArgs = {
  input: Array<AddBankAuctionLeadCountByNameInput>;
};


export type MutationAddBookingArgs = {
  input: Array<AddBookingInput>;
};


export type MutationAddBookingPaymentArgs = {
  input: Array<AddBookingPaymentInput>;
};


export type MutationAddBrandArgs = {
  input: Array<AddBrandInput>;
  upsert?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddBulkApprovalResponseArgs = {
  input: Array<AddBulkApprovalResponseInput>;
};


export type MutationAddCenterlizeLocationDistrcitsResponseArgs = {
  input: Array<AddCenterlizeLocationDistrcitsResponseInput>;
};


export type MutationAddCenterlizeLocationDistrictArgs = {
  input: Array<AddCenterlizeLocationDistrictInput>;
};


export type MutationAddCenterlizeLocationStatesArgs = {
  input: Array<AddCenterlizeLocationStatesInput>;
};


export type MutationAddCenterlizeLocationStatesResponseArgs = {
  input: Array<AddCenterlizeLocationStatesResponseInput>;
};


export type MutationAddCenterlizeLocationTehsilArgs = {
  input: Array<AddCenterlizeLocationTehsilInput>;
};


export type MutationAddCenterlizeLocationTehsilResponseArgs = {
  input: Array<AddCenterlizeLocationTehsilResponseInput>;
};


export type MutationAddCentreArgs = {
  input: Array<AddCentreInput>;
  upsert?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddCentreAggregatesArgs = {
  input: Array<AddCentreAggregatesInput>;
};


export type MutationAddCityArgs = {
  input: Array<AddCityInput>;
  upsert?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddCreateBulkLeadResponseArgs = {
  input: Array<AddCreateBulkLeadResponseInput>;
};


export type MutationAddCustomerArgs = {
  input: Array<AddCustomerInput>;
  upsert?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddDealerArgs = {
  input: Array<AddDealerInput>;
  upsert?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddDealerStanceArgs = {
  input: Array<AddDealerStanceInput>;
};


export type MutationAddDealershipDocumentArgs = {
  input: Array<AddDealershipDocumentInput>;
  upsert?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddDealershipLeadCountByPeNameArgs = {
  input: Array<AddDealershipLeadCountByPeNameInput>;
};


export type MutationAddDistrictArgs = {
  input: Array<AddDistrictInput>;
};


export type MutationAddDocumentArgs = {
  input: Array<AddDocumentInput>;
};


export type MutationAddDocumentChecklistArgs = {
  input: Array<AddDocumentChecklistInput>;
  upsert?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddDocumentsCountArgs = {
  input: Array<AddDocumentsCountInput>;
};


export type MutationAddDocumentsFollowupsArgs = {
  input: Array<AddDocumentsFollowupsInput>;
};


export type MutationAddDriverAggregatesArgs = {
  input: Array<AddDriverAggregatesInput>;
};


export type MutationAddEnquiryArgs = {
  input: Array<AddEnquiryInput>;
  upsert?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddEnquiryAdherenceArgs = {
  input: Array<AddEnquiryAdherenceInput>;
};


export type MutationAddEnquiryAggByCentreArgs = {
  input: Array<AddEnquiryAggByCentreInput>;
};


export type MutationAddEnquiryCloserAggArgs = {
  input: Array<AddEnquiryCloserAggInput>;
};


export type MutationAddEnquiryClosureArgs = {
  input: Array<AddEnquiryClosureInput>;
};


export type MutationAddFollowupArgs = {
  input: Array<AddFollowupInput>;
};


export type MutationAddIdByNameArgs = {
  input: Array<AddIdByNameInput>;
};


export type MutationAddIdentificationDocumentArgs = {
  input: Array<AddIdentificationDocumentInput>;
};


export type MutationAddIdsByNameForListingReponseArgs = {
  input: Array<AddIdsByNameForListingReponseInput>;
};


export type MutationAddInventoryDetailsArgs = {
  input: Array<AddInventoryDetailsInput>;
  upsert?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddIssueArgs = {
  input: Array<AddIssueInput>;
};


export type MutationAddIssueItemArgs = {
  input: Array<AddIssueItemInput>;
};


export type MutationAddItemInventoryDetailsArgs = {
  input: Array<AddItemInventoryDetailsInput>;
  upsert?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddLeadArgs = {
  input: Array<AddLeadInput>;
  upsert?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddLeadCountByStatusArgs = {
  input: Array<AddLeadCountByStatusInput>;
};


export type MutationAddLeadDocumentsArgs = {
  input: Array<AddLeadDocumentsInput>;
  upsert?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddLeadExpenseArgs = {
  input: Array<AddLeadExpenseInput>;
};


export type MutationAddLeadStatusEventArgs = {
  input: Array<AddLeadStatusEventInput>;
};


export type MutationAddLeadStatusFlowArgs = {
  input: Array<AddLeadStatusFlowInput>;
};


export type MutationAddLeadTimelineActionArgs = {
  input: Array<AddLeadTimelineActionInput>;
};


export type MutationAddLoanArgs = {
  input: Array<AddLoanInput>;
};


export type MutationAddLogTrackingArgs = {
  input: Array<AddLogTrackingInput>;
};


export type MutationAddMarkSoldResponseArgs = {
  input: Array<AddMarkSoldResponseInput>;
};


export type MutationAddMessageArgs = {
  input: Array<AddMessageInput>;
};


export type MutationAddModelArgs = {
  input: Array<AddModelInput>;
  upsert?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddModelByMakeArgs = {
  input: Array<AddModelByMakeInput>;
};


export type MutationAddNotificationArgs = {
  input: Array<AddNotificationInput>;
};


export type MutationAddNumberOfPendingTasksArgs = {
  input: Array<AddNumberOfPendingTasksInput>;
};


export type MutationAddParkingBeneficiaryArgs = {
  input: Array<AddParkingBeneficiaryInput>;
  upsert?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddPaymentArgs = {
  input: Array<AddPaymentInput>;
};


export type MutationAddPaymentInvoicesArgs = {
  input: Array<AddPaymentInvoicesInput>;
};


export type MutationAddPickupArgs = {
  input: Array<AddPickupInput>;
  upsert?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddProductArgs = {
  input: Array<AddProductInput>;
  upsert?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddPurchaseArgs = {
  input: Array<AddPurchaseInput>;
};


export type MutationAddPurchaseItemArgs = {
  input: Array<AddPurchaseItemInput>;
};


export type MutationAddRefurbishmentBeneficiaryArgs = {
  input: Array<AddRefurbishmentBeneficiaryInput>;
  upsert?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddRefurbishmentDetailsArgs = {
  input: Array<AddRefurbishmentDetailsInput>;
};


export type MutationAddRefurbishmentItemArgs = {
  input: Array<AddRefurbishmentItemInput>;
};


export type MutationAddRefurbishmentRequestArgs = {
  input: Array<AddRefurbishmentRequestInput>;
};


export type MutationAddSmsLogsArgs = {
  input: Array<AddSmsLogsInput>;
};


export type MutationAddSendSmsToCustomerResponseArgs = {
  input: Array<AddSendSmsToCustomerResponseInput>;
};


export type MutationAddStateCodeWithRegNumberArgs = {
  input: Array<AddStateCodeWithRegNumberInput>;
  upsert?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddStatusAggregateArgs = {
  input: Array<AddStatusAggregateInput>;
};


export type MutationAddTjCentreArgs = {
  input: Array<AddTjCentreInput>;
};


export type MutationAddTaskArgs = {
  input: Array<AddTaskInput>;
};


export type MutationAddTehsilArgs = {
  input: Array<AddTehsilInput>;
};


export type MutationAddTripExpenseArgs = {
  input: Array<AddTripExpenseInput>;
};


export type MutationAddUserArgs = {
  input: Array<AddUserInput>;
  upsert?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddVehicleArgs = {
  input: Array<AddVehicleInput>;
  upsert?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddVehicleDocumentsArgs = {
  input: Array<AddVehicleDocumentsInput>;
  upsert?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddVehicleFinancingArgs = {
  input: Array<AddVehicleFinancingInput>;
};


export type MutationAddVehicleImagesArgs = {
  input: Array<AddVehicleImagesInput>;
  upsert?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddVehicleInsuranceArgs = {
  input: Array<AddVehicleInsuranceInput>;
};


export type MutationAddVehicleOwnerArgs = {
  input: Array<AddVehicleOwnerInput>;
};


export type MutationAddVehicleTransferLogArgs = {
  input: Array<AddVehicleTransferLogInput>;
};


export type MutationAddYardArgs = {
  input: Array<AddYardInput>;
  upsert?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAdddocumentsAggregatesResultArgs = {
  input: Array<AdddocumentsAggregatesResultInput>;
};


export type MutationDeleteAccessoriesCheckArgs = {
  filter: AccessoriesCheckFilter;
};


export type MutationDeleteAccessoriesCheckListWithStageArgs = {
  filter: AccessoriesCheckListWithStageFilter;
};


export type MutationDeleteAccessoriesChecklistArgs = {
  filter: AccessoriesChecklistFilter;
};


export type MutationDeleteActiveStateWithGstnArgs = {
  filter: ActiveStateWithGstnFilter;
};


export type MutationDeleteAdminLeadStatusEventArgs = {
  filter: AdminLeadStatusEventFilter;
};


export type MutationDeleteAgencyArgs = {
  filter: AgencyFilter;
};


export type MutationDeleteAuctionHistoryArgs = {
  filter: AuctionHistoryFilter;
};


export type MutationDeleteBankArgs = {
  filter: BankFilter;
};


export type MutationDeleteBankAuctionLeadCountByNameArgs = {
  filter: BankAuctionLeadCountByNameFilter;
};


export type MutationDeleteBookingArgs = {
  filter: BookingFilter;
};


export type MutationDeleteBookingPaymentArgs = {
  filter: BookingPaymentFilter;
};


export type MutationDeleteBrandArgs = {
  filter: BrandFilter;
};


export type MutationDeleteBulkApprovalResponseArgs = {
  filter: BulkApprovalResponseFilter;
};


export type MutationDeleteCenterlizeLocationDistrcitsResponseArgs = {
  filter: CenterlizeLocationDistrcitsResponseFilter;
};


export type MutationDeleteCenterlizeLocationDistrictArgs = {
  filter: CenterlizeLocationDistrictFilter;
};


export type MutationDeleteCenterlizeLocationStatesArgs = {
  filter: CenterlizeLocationStatesFilter;
};


export type MutationDeleteCenterlizeLocationStatesResponseArgs = {
  filter: CenterlizeLocationStatesResponseFilter;
};


export type MutationDeleteCenterlizeLocationTehsilArgs = {
  filter: CenterlizeLocationTehsilFilter;
};


export type MutationDeleteCenterlizeLocationTehsilResponseArgs = {
  filter: CenterlizeLocationTehsilResponseFilter;
};


export type MutationDeleteCentreArgs = {
  filter: CentreFilter;
};


export type MutationDeleteCentreAggregatesArgs = {
  filter: CentreAggregatesFilter;
};


export type MutationDeleteCityArgs = {
  filter: CityFilter;
};


export type MutationDeleteCreateBulkLeadResponseArgs = {
  filter: CreateBulkLeadResponseFilter;
};


export type MutationDeleteCustomerArgs = {
  filter: CustomerFilter;
};


export type MutationDeleteDealerArgs = {
  filter: DealerFilter;
};


export type MutationDeleteDealerStanceArgs = {
  filter: DealerStanceFilter;
};


export type MutationDeleteDealershipDocumentArgs = {
  filter: DealershipDocumentFilter;
};


export type MutationDeleteDealershipLeadCountByPeNameArgs = {
  filter: DealershipLeadCountByPeNameFilter;
};


export type MutationDeleteDistrictArgs = {
  filter: DistrictFilter;
};


export type MutationDeleteDocumentArgs = {
  filter: DocumentFilter;
};


export type MutationDeleteDocumentChecklistArgs = {
  filter: DocumentChecklistFilter;
};


export type MutationDeleteDocumentsCountArgs = {
  filter: DocumentsCountFilter;
};


export type MutationDeleteDocumentsFollowupsArgs = {
  filter: DocumentsFollowupsFilter;
};


export type MutationDeleteDriverAggregatesArgs = {
  filter: DriverAggregatesFilter;
};


export type MutationDeleteEnquiryArgs = {
  filter: EnquiryFilter;
};


export type MutationDeleteEnquiryAdherenceArgs = {
  filter: EnquiryAdherenceFilter;
};


export type MutationDeleteEnquiryAggByCentreArgs = {
  filter: EnquiryAggByCentreFilter;
};


export type MutationDeleteEnquiryCloserAggArgs = {
  filter: EnquiryCloserAggFilter;
};


export type MutationDeleteEnquiryClosureArgs = {
  filter: EnquiryClosureFilter;
};


export type MutationDeleteFollowupArgs = {
  filter: FollowupFilter;
};


export type MutationDeleteIdByNameArgs = {
  filter: IdByNameFilter;
};


export type MutationDeleteIdentificationDocumentArgs = {
  filter: IdentificationDocumentFilter;
};


export type MutationDeleteIdsByNameForListingReponseArgs = {
  filter: IdsByNameForListingReponseFilter;
};


export type MutationDeleteInventoryDetailsArgs = {
  filter: InventoryDetailsFilter;
};


export type MutationDeleteIssueArgs = {
  filter: IssueFilter;
};


export type MutationDeleteIssueItemArgs = {
  filter: IssueItemFilter;
};


export type MutationDeleteItemInventoryDetailsArgs = {
  filter: ItemInventoryDetailsFilter;
};


export type MutationDeleteLeadArgs = {
  filter: LeadFilter;
};


export type MutationDeleteLeadCountByStatusArgs = {
  filter: LeadCountByStatusFilter;
};


export type MutationDeleteLeadDocumentsArgs = {
  filter: LeadDocumentsFilter;
};


export type MutationDeleteLeadExpenseArgs = {
  filter: LeadExpenseFilter;
};


export type MutationDeleteLeadStatusEventArgs = {
  filter: LeadStatusEventFilter;
};


export type MutationDeleteLeadStatusFlowArgs = {
  filter: LeadStatusFlowFilter;
};


export type MutationDeleteLeadTimelineActionArgs = {
  filter: LeadTimelineActionFilter;
};


export type MutationDeleteLeadTimelineStatusArgs = {
  filter: LeadTimelineStatusFilter;
};


export type MutationDeleteLoanArgs = {
  filter: LoanFilter;
};


export type MutationDeleteLogTrackingArgs = {
  filter: LogTrackingFilter;
};


export type MutationDeleteMarkSoldResponseArgs = {
  filter: MarkSoldResponseFilter;
};


export type MutationDeleteMessageArgs = {
  filter: MessageFilter;
};


export type MutationDeleteModelArgs = {
  filter: ModelFilter;
};


export type MutationDeleteModelByMakeArgs = {
  filter: ModelByMakeFilter;
};


export type MutationDeleteNotificationArgs = {
  filter: NotificationFilter;
};


export type MutationDeleteNumberOfPendingTasksArgs = {
  filter: NumberOfPendingTasksFilter;
};


export type MutationDeleteParkingBeneficiaryArgs = {
  filter: ParkingBeneficiaryFilter;
};


export type MutationDeletePaymentArgs = {
  filter: PaymentFilter;
};


export type MutationDeletePaymentInvoicesArgs = {
  filter: PaymentInvoicesFilter;
};


export type MutationDeletePickupArgs = {
  filter: PickupFilter;
};


export type MutationDeleteProductArgs = {
  filter: ProductFilter;
};


export type MutationDeletePurchaseArgs = {
  filter: PurchaseFilter;
};


export type MutationDeletePurchaseItemArgs = {
  filter: PurchaseItemFilter;
};


export type MutationDeleteRefurbishmentBeneficiaryArgs = {
  filter: RefurbishmentBeneficiaryFilter;
};


export type MutationDeleteRefurbishmentDetailsArgs = {
  filter: RefurbishmentDetailsFilter;
};


export type MutationDeleteRefurbishmentItemArgs = {
  filter: RefurbishmentItemFilter;
};


export type MutationDeleteRefurbishmentRequestArgs = {
  filter: RefurbishmentRequestFilter;
};


export type MutationDeleteSmsLogsArgs = {
  filter: SmsLogsFilter;
};


export type MutationDeleteSendSmsToCustomerResponseArgs = {
  filter: SendSmsToCustomerResponseFilter;
};


export type MutationDeleteStateCodeWithRegNumberArgs = {
  filter: StateCodeWithRegNumberFilter;
};


export type MutationDeleteStatusAggregateArgs = {
  filter: StatusAggregateFilter;
};


export type MutationDeleteTjCentreArgs = {
  filter: TjCentreFilter;
};


export type MutationDeleteTaskArgs = {
  filter: TaskFilter;
};


export type MutationDeleteTehsilArgs = {
  filter: TehsilFilter;
};


export type MutationDeleteTripExpenseArgs = {
  filter: TripExpenseFilter;
};


export type MutationDeleteUserArgs = {
  filter: UserFilter;
};


export type MutationDeleteVehicleArgs = {
  filter: VehicleFilter;
};


export type MutationDeleteVehicleDocumentsArgs = {
  filter: VehicleDocumentsFilter;
};


export type MutationDeleteVehicleFinancingArgs = {
  filter: VehicleFinancingFilter;
};


export type MutationDeleteVehicleImagesArgs = {
  filter: VehicleImagesFilter;
};


export type MutationDeleteVehicleInsuranceArgs = {
  filter: VehicleInsuranceFilter;
};


export type MutationDeleteVehicleOwnerArgs = {
  filter: VehicleOwnerFilter;
};


export type MutationDeleteVehicleTransferLogArgs = {
  filter: VehicleTransferLogFilter;
};


export type MutationDeleteYardArgs = {
  filter: YardFilter;
};


export type MutationDeletedocumentsAggregatesResultArgs = {
  filter: DocumentsAggregatesResultFilter;
};


export type MutationUpdateAccessoriesCheckArgs = {
  input: UpdateAccessoriesCheckInput;
};


export type MutationUpdateAccessoriesCheckListWithStageArgs = {
  input: UpdateAccessoriesCheckListWithStageInput;
};


export type MutationUpdateAccessoriesChecklistArgs = {
  input: UpdateAccessoriesChecklistInput;
};


export type MutationUpdateActiveStateWithGstnArgs = {
  input: UpdateActiveStateWithGstnInput;
};


export type MutationUpdateAdminLeadStatusEventArgs = {
  input: UpdateAdminLeadStatusEventInput;
};


export type MutationUpdateAgencyArgs = {
  input: UpdateAgencyInput;
};


export type MutationUpdateAuctionHistoryArgs = {
  input: UpdateAuctionHistoryInput;
};


export type MutationUpdateBankArgs = {
  input: UpdateBankInput;
};


export type MutationUpdateBankAuctionLeadCountByNameArgs = {
  input: UpdateBankAuctionLeadCountByNameInput;
};


export type MutationUpdateBookingArgs = {
  input: UpdateBookingInput;
};


export type MutationUpdateBookingPaymentArgs = {
  input: UpdateBookingPaymentInput;
};


export type MutationUpdateBrandArgs = {
  input: UpdateBrandInput;
};


export type MutationUpdateBulkApprovalResponseArgs = {
  input: UpdateBulkApprovalResponseInput;
};


export type MutationUpdateCenterlizeLocationDistrcitsResponseArgs = {
  input: UpdateCenterlizeLocationDistrcitsResponseInput;
};


export type MutationUpdateCenterlizeLocationDistrictArgs = {
  input: UpdateCenterlizeLocationDistrictInput;
};


export type MutationUpdateCenterlizeLocationStatesArgs = {
  input: UpdateCenterlizeLocationStatesInput;
};


export type MutationUpdateCenterlizeLocationStatesResponseArgs = {
  input: UpdateCenterlizeLocationStatesResponseInput;
};


export type MutationUpdateCenterlizeLocationTehsilArgs = {
  input: UpdateCenterlizeLocationTehsilInput;
};


export type MutationUpdateCenterlizeLocationTehsilResponseArgs = {
  input: UpdateCenterlizeLocationTehsilResponseInput;
};


export type MutationUpdateCentreArgs = {
  input: UpdateCentreInput;
};


export type MutationUpdateCentreAggregatesArgs = {
  input: UpdateCentreAggregatesInput;
};


export type MutationUpdateCreateBulkLeadResponseArgs = {
  input: UpdateCreateBulkLeadResponseInput;
};


export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerInput;
};


export type MutationUpdateDealerArgs = {
  input: UpdateDealerInput;
};


export type MutationUpdateDealerStanceArgs = {
  input: UpdateDealerStanceInput;
};


export type MutationUpdateDealershipDocumentArgs = {
  input: UpdateDealershipDocumentInput;
};


export type MutationUpdateDealershipLeadCountByPeNameArgs = {
  input: UpdateDealershipLeadCountByPeNameInput;
};


export type MutationUpdateDistrictArgs = {
  input: UpdateDistrictInput;
};


export type MutationUpdateDocumentArgs = {
  input: UpdateDocumentInput;
};


export type MutationUpdateDocumentChecklistArgs = {
  input: UpdateDocumentChecklistInput;
};


export type MutationUpdateDocumentsCountArgs = {
  input: UpdateDocumentsCountInput;
};


export type MutationUpdateDocumentsFollowupsArgs = {
  input: UpdateDocumentsFollowupsInput;
};


export type MutationUpdateDriverAggregatesArgs = {
  input: UpdateDriverAggregatesInput;
};


export type MutationUpdateEnquiryArgs = {
  input: UpdateEnquiryInput;
};


export type MutationUpdateEnquiryAdherenceArgs = {
  input: UpdateEnquiryAdherenceInput;
};


export type MutationUpdateEnquiryAggByCentreArgs = {
  input: UpdateEnquiryAggByCentreInput;
};


export type MutationUpdateEnquiryCloserAggArgs = {
  input: UpdateEnquiryCloserAggInput;
};


export type MutationUpdateEnquiryClosureArgs = {
  input: UpdateEnquiryClosureInput;
};


export type MutationUpdateFollowupArgs = {
  input: UpdateFollowupInput;
};


export type MutationUpdateIdByNameArgs = {
  input: UpdateIdByNameInput;
};


export type MutationUpdateIdentificationDocumentArgs = {
  input: UpdateIdentificationDocumentInput;
};


export type MutationUpdateIdsByNameForListingReponseArgs = {
  input: UpdateIdsByNameForListingReponseInput;
};


export type MutationUpdateInventoryDetailsArgs = {
  input: UpdateInventoryDetailsInput;
};


export type MutationUpdateIssueArgs = {
  input: UpdateIssueInput;
};


export type MutationUpdateIssueItemArgs = {
  input: UpdateIssueItemInput;
};


export type MutationUpdateItemInventoryDetailsArgs = {
  input: UpdateItemInventoryDetailsInput;
};


export type MutationUpdateLeadArgs = {
  input: UpdateLeadInput;
};


export type MutationUpdateLeadCountByStatusArgs = {
  input: UpdateLeadCountByStatusInput;
};


export type MutationUpdateLeadDocumentsArgs = {
  input: UpdateLeadDocumentsInput;
};


export type MutationUpdateLeadExpenseArgs = {
  input: UpdateLeadExpenseInput;
};


export type MutationUpdateLeadStatusEventArgs = {
  input: UpdateLeadStatusEventInput;
};


export type MutationUpdateLeadStatusFlowArgs = {
  input: UpdateLeadStatusFlowInput;
};


export type MutationUpdateLeadTimelineActionArgs = {
  input: UpdateLeadTimelineActionInput;
};


export type MutationUpdateLeadTimelineStatusArgs = {
  input: UpdateLeadTimelineStatusInput;
};


export type MutationUpdateLoanArgs = {
  input: UpdateLoanInput;
};


export type MutationUpdateLogTrackingArgs = {
  input: UpdateLogTrackingInput;
};


export type MutationUpdateMarkSoldResponseArgs = {
  input: UpdateMarkSoldResponseInput;
};


export type MutationUpdateMessageArgs = {
  input: UpdateMessageInput;
};


export type MutationUpdateModelArgs = {
  input: UpdateModelInput;
};


export type MutationUpdateModelByMakeArgs = {
  input: UpdateModelByMakeInput;
};


export type MutationUpdateNotificationArgs = {
  input: UpdateNotificationInput;
};


export type MutationUpdateNumberOfPendingTasksArgs = {
  input: UpdateNumberOfPendingTasksInput;
};


export type MutationUpdateParkingBeneficiaryArgs = {
  input: UpdateParkingBeneficiaryInput;
};


export type MutationUpdatePaymentArgs = {
  input: UpdatePaymentInput;
};


export type MutationUpdatePaymentInvoicesArgs = {
  input: UpdatePaymentInvoicesInput;
};


export type MutationUpdatePickupArgs = {
  input: UpdatePickupInput;
};


export type MutationUpdateProductArgs = {
  input: UpdateProductInput;
};


export type MutationUpdatePurchaseArgs = {
  input: UpdatePurchaseInput;
};


export type MutationUpdatePurchaseItemArgs = {
  input: UpdatePurchaseItemInput;
};


export type MutationUpdateRefurbishmentBeneficiaryArgs = {
  input: UpdateRefurbishmentBeneficiaryInput;
};


export type MutationUpdateRefurbishmentDetailsArgs = {
  input: UpdateRefurbishmentDetailsInput;
};


export type MutationUpdateRefurbishmentItemArgs = {
  input: UpdateRefurbishmentItemInput;
};


export type MutationUpdateRefurbishmentRequestArgs = {
  input: UpdateRefurbishmentRequestInput;
};


export type MutationUpdateSmsLogsArgs = {
  input: UpdateSmsLogsInput;
};


export type MutationUpdateSendSmsToCustomerResponseArgs = {
  input: UpdateSendSmsToCustomerResponseInput;
};


export type MutationUpdateStateCodeWithRegNumberArgs = {
  input: UpdateStateCodeWithRegNumberInput;
};


export type MutationUpdateStatusAggregateArgs = {
  input: UpdateStatusAggregateInput;
};


export type MutationUpdateTjCentreArgs = {
  input: UpdateTjCentreInput;
};


export type MutationUpdateTaskArgs = {
  input: UpdateTaskInput;
};


export type MutationUpdateTehsilArgs = {
  input: UpdateTehsilInput;
};


export type MutationUpdateTripExpenseArgs = {
  input: UpdateTripExpenseInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateVehicleArgs = {
  input: UpdateVehicleInput;
};


export type MutationUpdateVehicleDocumentsArgs = {
  input: UpdateVehicleDocumentsInput;
};


export type MutationUpdateVehicleFinancingArgs = {
  input: UpdateVehicleFinancingInput;
};


export type MutationUpdateVehicleImagesArgs = {
  input: UpdateVehicleImagesInput;
};


export type MutationUpdateVehicleInsuranceArgs = {
  input: UpdateVehicleInsuranceInput;
};


export type MutationUpdateVehicleOwnerArgs = {
  input: UpdateVehicleOwnerInput;
};


export type MutationUpdateVehicleTransferLogArgs = {
  input: UpdateVehicleTransferLogInput;
};


export type MutationUpdateYardArgs = {
  input: UpdateYardInput;
};


export type MutationUpdatedocumentsAggregatesResultArgs = {
  input: UpdatedocumentsAggregatesResultInput;
};

export type NearFilter = {
  coordinate: PointRef;
  distance: Scalars['Float'];
};

export type Notification = {
  __typename?: 'Notification';
  createdAt?: Maybe<Scalars['DateTime']>;
  forUsers?: Maybe<Array<Maybe<User>>>;
  forUsersAggregate?: Maybe<UserAggregateResult>;
  id: Scalars['ID'];
  leadStatusEvent: LeadStatusEvent;
  remarks?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};


export type NotificationForUsersArgs = {
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<UserOrder>;
};


export type NotificationForUsersAggregateArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type NotificationLeadStatusEventArgs = {
  filter?: InputMaybe<LeadStatusEventFilter>;
};

export type NotificationAggregateResult = {
  __typename?: 'NotificationAggregateResult';
  count?: Maybe<Scalars['Int']>;
  createdAtMax?: Maybe<Scalars['DateTime']>;
  createdAtMin?: Maybe<Scalars['DateTime']>;
  remarksMax?: Maybe<Scalars['String']>;
  remarksMin?: Maybe<Scalars['String']>;
  subtitleMax?: Maybe<Scalars['String']>;
  subtitleMin?: Maybe<Scalars['String']>;
  titleMax?: Maybe<Scalars['String']>;
  titleMin?: Maybe<Scalars['String']>;
};

export type NotificationFilter = {
  and?: InputMaybe<Array<InputMaybe<NotificationFilter>>>;
  has?: InputMaybe<Array<InputMaybe<NotificationHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<NotificationFilter>;
  or?: InputMaybe<Array<InputMaybe<NotificationFilter>>>;
};

export enum NotificationHasFilter {
  CreatedAt = 'createdAt',
  ForUsers = 'forUsers',
  LeadStatusEvent = 'leadStatusEvent',
  Remarks = 'remarks',
  Subtitle = 'subtitle',
  Title = 'title'
}

export type NotificationOrder = {
  asc?: InputMaybe<NotificationOrderable>;
  desc?: InputMaybe<NotificationOrderable>;
  then?: InputMaybe<NotificationOrder>;
};

export enum NotificationOrderable {
  CreatedAt = 'createdAt',
  Remarks = 'remarks',
  Subtitle = 'subtitle',
  Title = 'title'
}

export type NotificationPatch = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  forUsers?: InputMaybe<Array<InputMaybe<UserRef>>>;
  leadStatusEvent?: InputMaybe<LeadStatusEventRef>;
  remarks?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type NotificationRef = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  forUsers?: InputMaybe<Array<InputMaybe<UserRef>>>;
  id?: InputMaybe<Scalars['ID']>;
  leadStatusEvent?: InputMaybe<LeadStatusEventRef>;
  remarks?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type NumberOfPendingTasks = {
  __typename?: 'NumberOfPendingTasks';
  count: Scalars['Int'];
};

export type NumberOfPendingTasksAggregateResult = {
  __typename?: 'NumberOfPendingTasksAggregateResult';
  count?: Maybe<Scalars['Int']>;
  countAvg?: Maybe<Scalars['Float']>;
  countMax?: Maybe<Scalars['Int']>;
  countMin?: Maybe<Scalars['Int']>;
  countSum?: Maybe<Scalars['Int']>;
};

export type NumberOfPendingTasksFilter = {
  and?: InputMaybe<Array<InputMaybe<NumberOfPendingTasksFilter>>>;
  has?: InputMaybe<Array<InputMaybe<NumberOfPendingTasksHasFilter>>>;
  not?: InputMaybe<NumberOfPendingTasksFilter>;
  or?: InputMaybe<Array<InputMaybe<NumberOfPendingTasksFilter>>>;
};

export enum NumberOfPendingTasksHasFilter {
  Count = 'count'
}

export type NumberOfPendingTasksOrder = {
  asc?: InputMaybe<NumberOfPendingTasksOrderable>;
  desc?: InputMaybe<NumberOfPendingTasksOrderable>;
  then?: InputMaybe<NumberOfPendingTasksOrder>;
};

export enum NumberOfPendingTasksOrderable {
  Count = 'count'
}

export type NumberOfPendingTasksPatch = {
  count?: InputMaybe<Scalars['Int']>;
};

export type NumberOfPendingTasksRef = {
  count?: InputMaybe<Scalars['Int']>;
};

export enum Ownership {
  AboveFourth = 'ABOVE_FOURTH',
  First = 'FIRST',
  Fourth = 'FOURTH',
  Second = 'SECOND',
  Third = 'THIRD'
}

export type ParkingBeneficiary = {
  __typename?: 'ParkingBeneficiary';
  accountHolderName: Scalars['String'];
  accountNumber: Scalars['String'];
  bankName?: Maybe<BankName>;
  id: Scalars['ID'];
  ifscCode: Scalars['String'];
  leads?: Maybe<Array<Maybe<Lead>>>;
  leadsAggregate?: Maybe<LeadAggregateResult>;
  proofUrl?: Maybe<Scalars['String']>;
  upiId?: Maybe<Scalars['String']>;
};


export type ParkingBeneficiaryLeadsArgs = {
  filter?: InputMaybe<LeadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadOrder>;
};


export type ParkingBeneficiaryLeadsAggregateArgs = {
  filter?: InputMaybe<LeadFilter>;
};

export type ParkingBeneficiaryAggregateResult = {
  __typename?: 'ParkingBeneficiaryAggregateResult';
  accountHolderNameMax?: Maybe<Scalars['String']>;
  accountHolderNameMin?: Maybe<Scalars['String']>;
  accountNumberMax?: Maybe<Scalars['String']>;
  accountNumberMin?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  ifscCodeMax?: Maybe<Scalars['String']>;
  ifscCodeMin?: Maybe<Scalars['String']>;
  proofUrlMax?: Maybe<Scalars['String']>;
  proofUrlMin?: Maybe<Scalars['String']>;
  upiIdMax?: Maybe<Scalars['String']>;
  upiIdMin?: Maybe<Scalars['String']>;
};

export type ParkingBeneficiaryFilter = {
  accountNumber?: InputMaybe<StringHashFilter>;
  and?: InputMaybe<Array<InputMaybe<ParkingBeneficiaryFilter>>>;
  has?: InputMaybe<Array<InputMaybe<ParkingBeneficiaryHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<ParkingBeneficiaryFilter>;
  or?: InputMaybe<Array<InputMaybe<ParkingBeneficiaryFilter>>>;
};

export enum ParkingBeneficiaryHasFilter {
  AccountHolderName = 'accountHolderName',
  AccountNumber = 'accountNumber',
  BankName = 'bankName',
  IfscCode = 'ifscCode',
  Leads = 'leads',
  ProofUrl = 'proofUrl',
  UpiId = 'upiId'
}

export type ParkingBeneficiaryOrder = {
  asc?: InputMaybe<ParkingBeneficiaryOrderable>;
  desc?: InputMaybe<ParkingBeneficiaryOrderable>;
  then?: InputMaybe<ParkingBeneficiaryOrder>;
};

export enum ParkingBeneficiaryOrderable {
  AccountHolderName = 'accountHolderName',
  AccountNumber = 'accountNumber',
  IfscCode = 'ifscCode',
  ProofUrl = 'proofUrl',
  UpiId = 'upiId'
}

export type ParkingBeneficiaryPatch = {
  accountHolderName?: InputMaybe<Scalars['String']>;
  bankName?: InputMaybe<BankName>;
  ifscCode?: InputMaybe<Scalars['String']>;
  leads?: InputMaybe<Array<InputMaybe<LeadRef>>>;
  proofUrl?: InputMaybe<Scalars['String']>;
  upiId?: InputMaybe<Scalars['String']>;
};

export type ParkingBeneficiaryRef = {
  accountHolderName?: InputMaybe<Scalars['String']>;
  accountNumber?: InputMaybe<Scalars['String']>;
  bankName?: InputMaybe<BankName>;
  id?: InputMaybe<Scalars['ID']>;
  ifscCode?: InputMaybe<Scalars['String']>;
  leads?: InputMaybe<Array<InputMaybe<LeadRef>>>;
  proofUrl?: InputMaybe<Scalars['String']>;
  upiId?: InputMaybe<Scalars['String']>;
};

export type Payment = {
  __typename?: 'Payment';
  accountHolderName?: Maybe<Scalars['String']>;
  accountNo?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Int']>;
  bankName?: Maybe<BankName>;
  booking?: Maybe<Booking>;
  by: User;
  confirmedBy?: Maybe<User>;
  createdAt: Scalars['DateTime'];
  dealerStance?: Maybe<DealerStance>;
  for: PaymentFor;
  id: Scalars['ID'];
  ifsc?: Maybe<Scalars['String']>;
  invoice?: Maybe<PaymentInvoices>;
  lead?: Maybe<Lead>;
  loanClosedBy?: Maybe<LoanToBeClosedBy>;
  mode?: Maybe<PaymentMethod>;
  modeFM?: Maybe<PaymentMethod>;
  parkingBeneficiary?: Maybe<ParkingBeneficiary>;
  paymentProcessedAt?: Maybe<Scalars['DateTime']>;
  paymentTo?: Maybe<PaymentTo>;
  proofUrl?: Maybe<Scalars['String']>;
  purchase?: Maybe<Purchase>;
  receiptUrl?: Maybe<Scalars['String']>;
  reconciliationStatus?: Maybe<PaymentReconciliationStatus>;
  refurbishmentBeneficiary?: Maybe<RefurbishmentBeneficiary>;
  source?: Maybe<LeadSource>;
  status: PaymentStatus;
  tripExpense?: Maybe<TripExpense>;
  type?: Maybe<PaymentType>;
  upiId?: Maybe<Scalars['String']>;
};


export type PaymentBookingArgs = {
  filter?: InputMaybe<BookingFilter>;
};


export type PaymentByArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type PaymentConfirmedByArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type PaymentDealerStanceArgs = {
  filter?: InputMaybe<DealerStanceFilter>;
};


export type PaymentInvoiceArgs = {
  filter?: InputMaybe<PaymentInvoicesFilter>;
};


export type PaymentLeadArgs = {
  filter?: InputMaybe<LeadFilter>;
};


export type PaymentParkingBeneficiaryArgs = {
  filter?: InputMaybe<ParkingBeneficiaryFilter>;
};


export type PaymentPurchaseArgs = {
  filter?: InputMaybe<PurchaseFilter>;
};


export type PaymentRefurbishmentBeneficiaryArgs = {
  filter?: InputMaybe<RefurbishmentBeneficiaryFilter>;
};


export type PaymentTripExpenseArgs = {
  filter?: InputMaybe<TripExpenseFilter>;
};

export type PaymentAggregateResult = {
  __typename?: 'PaymentAggregateResult';
  accountHolderNameMax?: Maybe<Scalars['String']>;
  accountHolderNameMin?: Maybe<Scalars['String']>;
  accountNoMax?: Maybe<Scalars['String']>;
  accountNoMin?: Maybe<Scalars['String']>;
  amountAvg?: Maybe<Scalars['Float']>;
  amountMax?: Maybe<Scalars['Int']>;
  amountMin?: Maybe<Scalars['Int']>;
  amountSum?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  createdAtMax?: Maybe<Scalars['DateTime']>;
  createdAtMin?: Maybe<Scalars['DateTime']>;
  ifscMax?: Maybe<Scalars['String']>;
  ifscMin?: Maybe<Scalars['String']>;
  paymentProcessedAtMax?: Maybe<Scalars['DateTime']>;
  paymentProcessedAtMin?: Maybe<Scalars['DateTime']>;
  proofUrlMax?: Maybe<Scalars['String']>;
  proofUrlMin?: Maybe<Scalars['String']>;
  receiptUrlMax?: Maybe<Scalars['String']>;
  receiptUrlMin?: Maybe<Scalars['String']>;
  upiIdMax?: Maybe<Scalars['String']>;
  upiIdMin?: Maybe<Scalars['String']>;
};

export type PaymentFilter = {
  and?: InputMaybe<Array<InputMaybe<PaymentFilter>>>;
  has?: InputMaybe<Array<InputMaybe<PaymentHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<PaymentFilter>;
  or?: InputMaybe<Array<InputMaybe<PaymentFilter>>>;
  paymentProcessedAt?: InputMaybe<DateTimeFilter>;
};

export enum PaymentFor {
  BookingDelivery = 'BOOKING_DELIVERY',
  BookingInsurance = 'BOOKING_INSURANCE',
  BookingLoan = 'BOOKING_LOAN',
  BookingPart = 'BOOKING_PART',
  BookingToken = 'BOOKING_TOKEN',
  DealDelivery = 'DEAL_DELIVERY',
  DealPayment = 'DEAL_PAYMENT',
  DealToken = 'DEAL_TOKEN',
  DeliveryExpense = 'DELIVERY_EXPENSE',
  HoldbackRepayment = 'HOLDBACK_REPAYMENT',
  LoanRepayment = 'LOAN_REPAYMENT',
  ParkingExpense = 'PARKING_EXPENSE',
  Refurbishment = 'REFURBISHMENT'
}

export enum PaymentHasFilter {
  AccountHolderName = 'accountHolderName',
  AccountNo = 'accountNo',
  Amount = 'amount',
  BankName = 'bankName',
  Booking = 'booking',
  By = 'by',
  ConfirmedBy = 'confirmedBy',
  CreatedAt = 'createdAt',
  DealerStance = 'dealerStance',
  For = 'for',
  Ifsc = 'ifsc',
  Invoice = 'invoice',
  Lead = 'lead',
  LoanClosedBy = 'loanClosedBy',
  Mode = 'mode',
  ModeFm = 'modeFM',
  ParkingBeneficiary = 'parkingBeneficiary',
  PaymentProcessedAt = 'paymentProcessedAt',
  PaymentTo = 'paymentTo',
  ProofUrl = 'proofUrl',
  Purchase = 'purchase',
  ReceiptUrl = 'receiptUrl',
  ReconciliationStatus = 'reconciliationStatus',
  RefurbishmentBeneficiary = 'refurbishmentBeneficiary',
  Source = 'source',
  Status = 'status',
  TripExpense = 'tripExpense',
  Type = 'type',
  UpiId = 'upiId'
}

export type PaymentInvoices = {
  __typename?: 'PaymentInvoices';
  GSTNumber?: Maybe<Scalars['String']>;
  createdBy?: Maybe<User>;
  customerName?: Maybe<Scalars['String']>;
  customerNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  invoiceDate?: Maybe<Scalars['DateTime']>;
  invoiceId: Scalars['String'];
  lead: Lead;
  payment?: Maybe<Payment>;
  serialNo: Scalars['String'];
  smsLogs?: Maybe<Array<Maybe<SmsLogs>>>;
  smsLogsAggregate?: Maybe<SmsLogsAggregateResult>;
};


export type PaymentInvoicesCreatedByArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type PaymentInvoicesLeadArgs = {
  filter?: InputMaybe<LeadFilter>;
};


export type PaymentInvoicesPaymentArgs = {
  filter?: InputMaybe<PaymentFilter>;
};


export type PaymentInvoicesSmsLogsArgs = {
  filter?: InputMaybe<SmsLogsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<SmsLogsOrder>;
};


export type PaymentInvoicesSmsLogsAggregateArgs = {
  filter?: InputMaybe<SmsLogsFilter>;
};

export type PaymentInvoicesAggregateResult = {
  __typename?: 'PaymentInvoicesAggregateResult';
  GSTNumberMax?: Maybe<Scalars['String']>;
  GSTNumberMin?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  customerNameMax?: Maybe<Scalars['String']>;
  customerNameMin?: Maybe<Scalars['String']>;
  customerNumberMax?: Maybe<Scalars['String']>;
  customerNumberMin?: Maybe<Scalars['String']>;
  invoiceDateMax?: Maybe<Scalars['DateTime']>;
  invoiceDateMin?: Maybe<Scalars['DateTime']>;
  invoiceIdMax?: Maybe<Scalars['String']>;
  invoiceIdMin?: Maybe<Scalars['String']>;
  serialNoMax?: Maybe<Scalars['String']>;
  serialNoMin?: Maybe<Scalars['String']>;
};

export type PaymentInvoicesFilter = {
  and?: InputMaybe<Array<InputMaybe<PaymentInvoicesFilter>>>;
  has?: InputMaybe<Array<InputMaybe<PaymentInvoicesHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<PaymentInvoicesFilter>;
  or?: InputMaybe<Array<InputMaybe<PaymentInvoicesFilter>>>;
};

export enum PaymentInvoicesHasFilter {
  GstNumber = 'GSTNumber',
  CreatedBy = 'createdBy',
  CustomerName = 'customerName',
  CustomerNumber = 'customerNumber',
  InvoiceDate = 'invoiceDate',
  InvoiceId = 'invoiceId',
  Lead = 'lead',
  Payment = 'payment',
  SerialNo = 'serialNo',
  SmsLogs = 'smsLogs'
}

export type PaymentInvoicesOrder = {
  asc?: InputMaybe<PaymentInvoicesOrderable>;
  desc?: InputMaybe<PaymentInvoicesOrderable>;
  then?: InputMaybe<PaymentInvoicesOrder>;
};

export enum PaymentInvoicesOrderable {
  GstNumber = 'GSTNumber',
  CustomerName = 'customerName',
  CustomerNumber = 'customerNumber',
  InvoiceDate = 'invoiceDate',
  InvoiceId = 'invoiceId',
  SerialNo = 'serialNo'
}

export type PaymentInvoicesPatch = {
  GSTNumber?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<UserRef>;
  customerName?: InputMaybe<Scalars['String']>;
  customerNumber?: InputMaybe<Scalars['String']>;
  invoiceDate?: InputMaybe<Scalars['DateTime']>;
  invoiceId?: InputMaybe<Scalars['String']>;
  lead?: InputMaybe<LeadRef>;
  payment?: InputMaybe<PaymentRef>;
  serialNo?: InputMaybe<Scalars['String']>;
  smsLogs?: InputMaybe<Array<InputMaybe<SmsLogsRef>>>;
};

export type PaymentInvoicesRef = {
  GSTNumber?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<UserRef>;
  customerName?: InputMaybe<Scalars['String']>;
  customerNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  invoiceDate?: InputMaybe<Scalars['DateTime']>;
  invoiceId?: InputMaybe<Scalars['String']>;
  lead?: InputMaybe<LeadRef>;
  payment?: InputMaybe<PaymentRef>;
  serialNo?: InputMaybe<Scalars['String']>;
  smsLogs?: InputMaybe<Array<InputMaybe<SmsLogsRef>>>;
};

export enum PaymentMethod {
  BankTransferImps = 'BANK_TRANSFER_IMPS',
  BankTransferNeft = 'BANK_TRANSFER_NEFT',
  BankTransferRtgs = 'BANK_TRANSFER_RTGS',
  Cash = 'CASH',
  Upi = 'UPI'
}

export type PaymentOrder = {
  asc?: InputMaybe<PaymentOrderable>;
  desc?: InputMaybe<PaymentOrderable>;
  then?: InputMaybe<PaymentOrder>;
};

export enum PaymentOrderable {
  AccountHolderName = 'accountHolderName',
  AccountNo = 'accountNo',
  Amount = 'amount',
  CreatedAt = 'createdAt',
  Ifsc = 'ifsc',
  PaymentProcessedAt = 'paymentProcessedAt',
  ProofUrl = 'proofUrl',
  ReceiptUrl = 'receiptUrl',
  UpiId = 'upiId'
}

export type PaymentPatch = {
  accountHolderName?: InputMaybe<Scalars['String']>;
  accountNo?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['Int']>;
  bankName?: InputMaybe<BankName>;
  booking?: InputMaybe<BookingRef>;
  by?: InputMaybe<UserRef>;
  confirmedBy?: InputMaybe<UserRef>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dealerStance?: InputMaybe<DealerStanceRef>;
  for?: InputMaybe<PaymentFor>;
  ifsc?: InputMaybe<Scalars['String']>;
  invoice?: InputMaybe<PaymentInvoicesRef>;
  lead?: InputMaybe<LeadRef>;
  loanClosedBy?: InputMaybe<LoanToBeClosedBy>;
  mode?: InputMaybe<PaymentMethod>;
  modeFM?: InputMaybe<PaymentMethod>;
  parkingBeneficiary?: InputMaybe<ParkingBeneficiaryRef>;
  paymentProcessedAt?: InputMaybe<Scalars['DateTime']>;
  paymentTo?: InputMaybe<PaymentTo>;
  proofUrl?: InputMaybe<Scalars['String']>;
  purchase?: InputMaybe<PurchaseRef>;
  receiptUrl?: InputMaybe<Scalars['String']>;
  reconciliationStatus?: InputMaybe<PaymentReconciliationStatus>;
  refurbishmentBeneficiary?: InputMaybe<RefurbishmentBeneficiaryRef>;
  source?: InputMaybe<LeadSource>;
  status?: InputMaybe<PaymentStatus>;
  tripExpense?: InputMaybe<TripExpenseRef>;
  type?: InputMaybe<PaymentType>;
  upiId?: InputMaybe<Scalars['String']>;
};

export enum PaymentRecepient {
  Bank = 'BANK',
  Dealer = 'DEALER'
}

export enum PaymentReconciliationStatus {
  Done = 'DONE',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type PaymentRef = {
  accountHolderName?: InputMaybe<Scalars['String']>;
  accountNo?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['Int']>;
  bankName?: InputMaybe<BankName>;
  booking?: InputMaybe<BookingRef>;
  by?: InputMaybe<UserRef>;
  confirmedBy?: InputMaybe<UserRef>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dealerStance?: InputMaybe<DealerStanceRef>;
  for?: InputMaybe<PaymentFor>;
  id?: InputMaybe<Scalars['ID']>;
  ifsc?: InputMaybe<Scalars['String']>;
  invoice?: InputMaybe<PaymentInvoicesRef>;
  lead?: InputMaybe<LeadRef>;
  loanClosedBy?: InputMaybe<LoanToBeClosedBy>;
  mode?: InputMaybe<PaymentMethod>;
  modeFM?: InputMaybe<PaymentMethod>;
  parkingBeneficiary?: InputMaybe<ParkingBeneficiaryRef>;
  paymentProcessedAt?: InputMaybe<Scalars['DateTime']>;
  paymentTo?: InputMaybe<PaymentTo>;
  proofUrl?: InputMaybe<Scalars['String']>;
  purchase?: InputMaybe<PurchaseRef>;
  receiptUrl?: InputMaybe<Scalars['String']>;
  reconciliationStatus?: InputMaybe<PaymentReconciliationStatus>;
  refurbishmentBeneficiary?: InputMaybe<RefurbishmentBeneficiaryRef>;
  source?: InputMaybe<LeadSource>;
  status?: InputMaybe<PaymentStatus>;
  tripExpense?: InputMaybe<TripExpenseRef>;
  type?: InputMaybe<PaymentType>;
  upiId?: InputMaybe<Scalars['String']>;
};

export enum PaymentStatus {
  Approved = 'APPROVED',
  Done = 'DONE',
  Estimated = 'ESTIMATED',
  Failed = 'FAILED',
  Processed = 'PROCESSED',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED'
}

export type PaymentStatus_Hash = {
  eq?: InputMaybe<PaymentStatus>;
  in?: InputMaybe<Array<InputMaybe<PaymentStatus>>>;
};

export enum PaymentTo {
  Employee = 'EMPLOYEE',
  Vendor = 'VENDOR'
}

export enum PaymentType {
  PayInFull = 'PAY_IN_FULL',
  PayInParts = 'PAY_IN_PARTS'
}

export type Pickup = {
  __typename?: 'Pickup';
  by?: Maybe<User>;
  from?: Maybe<Point>;
  id: Scalars['ID'];
  lead?: Maybe<Lead>;
  pickEndTime?: Maybe<Scalars['DateTime']>;
  pickupStartTime?: Maybe<Scalars['DateTime']>;
  regNo: Scalars['String'];
  to?: Maybe<Point>;
};


export type PickupByArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type PickupLeadArgs = {
  filter?: InputMaybe<LeadFilter>;
};

export type PickupAggregateResult = {
  __typename?: 'PickupAggregateResult';
  count?: Maybe<Scalars['Int']>;
  pickEndTimeMax?: Maybe<Scalars['DateTime']>;
  pickEndTimeMin?: Maybe<Scalars['DateTime']>;
  pickupStartTimeMax?: Maybe<Scalars['DateTime']>;
  pickupStartTimeMin?: Maybe<Scalars['DateTime']>;
  regNoMax?: Maybe<Scalars['String']>;
  regNoMin?: Maybe<Scalars['String']>;
};

export type PickupFilter = {
  and?: InputMaybe<Array<InputMaybe<PickupFilter>>>;
  has?: InputMaybe<Array<InputMaybe<PickupHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<PickupFilter>;
  or?: InputMaybe<Array<InputMaybe<PickupFilter>>>;
  regNo?: InputMaybe<StringHashFilter>;
};

export enum PickupHasFilter {
  By = 'by',
  From = 'from',
  Lead = 'lead',
  PickEndTime = 'pickEndTime',
  PickupStartTime = 'pickupStartTime',
  RegNo = 'regNo',
  To = 'to'
}

export type PickupOrder = {
  asc?: InputMaybe<PickupOrderable>;
  desc?: InputMaybe<PickupOrderable>;
  then?: InputMaybe<PickupOrder>;
};

export enum PickupOrderable {
  PickEndTime = 'pickEndTime',
  PickupStartTime = 'pickupStartTime',
  RegNo = 'regNo'
}

export type PickupPatch = {
  by?: InputMaybe<UserRef>;
  from?: InputMaybe<PointRef>;
  lead?: InputMaybe<LeadRef>;
  pickEndTime?: InputMaybe<Scalars['DateTime']>;
  pickupStartTime?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<PointRef>;
};

export type PickupRef = {
  by?: InputMaybe<UserRef>;
  from?: InputMaybe<PointRef>;
  id?: InputMaybe<Scalars['ID']>;
  lead?: InputMaybe<LeadRef>;
  pickEndTime?: InputMaybe<Scalars['DateTime']>;
  pickupStartTime?: InputMaybe<Scalars['DateTime']>;
  regNo?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<PointRef>;
};

export type Point = {
  __typename?: 'Point';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type PointGeoFilter = {
  near?: InputMaybe<NearFilter>;
  within?: InputMaybe<WithinFilter>;
};

export type PointList = {
  __typename?: 'PointList';
  points: Array<Point>;
};

export type PointListRef = {
  points: Array<PointRef>;
};

export type PointRef = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type Polygon = {
  __typename?: 'Polygon';
  coordinates: Array<PointList>;
};

export type PolygonGeoFilter = {
  contains?: InputMaybe<ContainsFilter>;
  intersects?: InputMaybe<IntersectsFilter>;
  near?: InputMaybe<NearFilter>;
  within?: InputMaybe<WithinFilter>;
};

export type PolygonRef = {
  coordinates: Array<PointListRef>;
};

export type PriceRange = {
  max?: InputMaybe<Scalars['String']>;
  min?: InputMaybe<Scalars['String']>;
};

export type Product = {
  __typename?: 'Product';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  variant?: Maybe<Scalars['String']>;
};

export type ProductAggregateResult = {
  __typename?: 'ProductAggregateResult';
  count?: Maybe<Scalars['Int']>;
  descriptionMax?: Maybe<Scalars['String']>;
  descriptionMin?: Maybe<Scalars['String']>;
  nameMax?: Maybe<Scalars['String']>;
  nameMin?: Maybe<Scalars['String']>;
  variantMax?: Maybe<Scalars['String']>;
  variantMin?: Maybe<Scalars['String']>;
};

export type ProductFilter = {
  and?: InputMaybe<Array<InputMaybe<ProductFilter>>>;
  has?: InputMaybe<Array<InputMaybe<ProductHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<StringHashFilter>;
  not?: InputMaybe<ProductFilter>;
  or?: InputMaybe<Array<InputMaybe<ProductFilter>>>;
};

export enum ProductHasFilter {
  Description = 'description',
  Name = 'name',
  Variant = 'variant'
}

export type ProductOrder = {
  asc?: InputMaybe<ProductOrderable>;
  desc?: InputMaybe<ProductOrderable>;
  then?: InputMaybe<ProductOrder>;
};

export enum ProductOrderable {
  Description = 'description',
  Name = 'name',
  Variant = 'variant'
}

export type ProductPatch = {
  description?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<Scalars['String']>;
};

export type ProductRef = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<Scalars['String']>;
};

export type Purchase = {
  __typename?: 'Purchase';
  approvedBy?: Maybe<User>;
  centre: Centre;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  invoiceUrl?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<PurchaseItem>>>;
  itemsAggregate?: Maybe<PurchaseItemAggregateResult>;
  madeBy: User;
  payment?: Maybe<Payment>;
  refurbishment?: Maybe<RefurbishmentRequest>;
  requestedItemId?: Maybe<Scalars['String']>;
  status?: Maybe<PurchaseStatus>;
  totalPrice?: Maybe<Scalars['Int']>;
};


export type PurchaseApprovedByArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type PurchaseCentreArgs = {
  filter?: InputMaybe<CentreFilter>;
};


export type PurchaseItemsArgs = {
  filter?: InputMaybe<PurchaseItemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PurchaseItemOrder>;
};


export type PurchaseItemsAggregateArgs = {
  filter?: InputMaybe<PurchaseItemFilter>;
};


export type PurchaseMadeByArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type PurchasePaymentArgs = {
  filter?: InputMaybe<PaymentFilter>;
};


export type PurchaseRefurbishmentArgs = {
  filter?: InputMaybe<RefurbishmentRequestFilter>;
};

export type PurchaseAggregateResult = {
  __typename?: 'PurchaseAggregateResult';
  count?: Maybe<Scalars['Int']>;
  createdAtMax?: Maybe<Scalars['DateTime']>;
  createdAtMin?: Maybe<Scalars['DateTime']>;
  invoiceUrlMax?: Maybe<Scalars['String']>;
  invoiceUrlMin?: Maybe<Scalars['String']>;
  requestedItemIdMax?: Maybe<Scalars['String']>;
  requestedItemIdMin?: Maybe<Scalars['String']>;
  totalPriceAvg?: Maybe<Scalars['Float']>;
  totalPriceMax?: Maybe<Scalars['Int']>;
  totalPriceMin?: Maybe<Scalars['Int']>;
  totalPriceSum?: Maybe<Scalars['Int']>;
};

export type PurchaseFilter = {
  and?: InputMaybe<Array<InputMaybe<PurchaseFilter>>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  has?: InputMaybe<Array<InputMaybe<PurchaseHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<PurchaseFilter>;
  or?: InputMaybe<Array<InputMaybe<PurchaseFilter>>>;
  status?: InputMaybe<PurchaseStatus_Hash>;
};

export enum PurchaseHasFilter {
  ApprovedBy = 'approvedBy',
  Centre = 'centre',
  CreatedAt = 'createdAt',
  InvoiceUrl = 'invoiceUrl',
  Items = 'items',
  MadeBy = 'madeBy',
  Payment = 'payment',
  Refurbishment = 'refurbishment',
  RequestedItemId = 'requestedItemId',
  Status = 'status',
  TotalPrice = 'totalPrice'
}

export type PurchaseItem = {
  __typename?: 'PurchaseItem';
  approvedPriceLimit?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isApproved?: Maybe<Scalars['Boolean']>;
  price?: Maybe<Scalars['Int']>;
  product: Product;
  purchase: Purchase;
  purchaseProofUrl?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  requestedItemId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};


export type PurchaseItemProductArgs = {
  filter?: InputMaybe<ProductFilter>;
};


export type PurchaseItemPurchaseArgs = {
  filter?: InputMaybe<PurchaseFilter>;
};

export type PurchaseItemAggregateResult = {
  __typename?: 'PurchaseItemAggregateResult';
  approvedPriceLimitAvg?: Maybe<Scalars['Float']>;
  approvedPriceLimitMax?: Maybe<Scalars['Int']>;
  approvedPriceLimitMin?: Maybe<Scalars['Int']>;
  approvedPriceLimitSum?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  descriptionMax?: Maybe<Scalars['String']>;
  descriptionMin?: Maybe<Scalars['String']>;
  priceAvg?: Maybe<Scalars['Float']>;
  priceMax?: Maybe<Scalars['Int']>;
  priceMin?: Maybe<Scalars['Int']>;
  priceSum?: Maybe<Scalars['Int']>;
  purchaseProofUrlMax?: Maybe<Scalars['String']>;
  purchaseProofUrlMin?: Maybe<Scalars['String']>;
  quantityAvg?: Maybe<Scalars['Float']>;
  quantityMax?: Maybe<Scalars['Int']>;
  quantityMin?: Maybe<Scalars['Int']>;
  quantitySum?: Maybe<Scalars['Int']>;
  requestedItemIdMax?: Maybe<Scalars['String']>;
  requestedItemIdMin?: Maybe<Scalars['String']>;
  typeMax?: Maybe<Scalars['String']>;
  typeMin?: Maybe<Scalars['String']>;
};

export type PurchaseItemFilter = {
  and?: InputMaybe<Array<InputMaybe<PurchaseItemFilter>>>;
  has?: InputMaybe<Array<InputMaybe<PurchaseItemHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<PurchaseItemFilter>;
  or?: InputMaybe<Array<InputMaybe<PurchaseItemFilter>>>;
  price?: InputMaybe<IntFilter>;
};

export enum PurchaseItemHasFilter {
  ApprovedPriceLimit = 'approvedPriceLimit',
  Description = 'description',
  IsApproved = 'isApproved',
  Price = 'price',
  Product = 'product',
  Purchase = 'purchase',
  PurchaseProofUrl = 'purchaseProofUrl',
  Quantity = 'quantity',
  RequestedItemId = 'requestedItemId',
  Type = 'type'
}

export type PurchaseItemOrder = {
  asc?: InputMaybe<PurchaseItemOrderable>;
  desc?: InputMaybe<PurchaseItemOrderable>;
  then?: InputMaybe<PurchaseItemOrder>;
};

export enum PurchaseItemOrderable {
  ApprovedPriceLimit = 'approvedPriceLimit',
  Description = 'description',
  Price = 'price',
  PurchaseProofUrl = 'purchaseProofUrl',
  Quantity = 'quantity',
  RequestedItemId = 'requestedItemId',
  Type = 'type'
}

export type PurchaseItemPatch = {
  approvedPriceLimit?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  price?: InputMaybe<Scalars['Int']>;
  product?: InputMaybe<ProductRef>;
  purchase?: InputMaybe<PurchaseRef>;
  purchaseProofUrl?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requestedItemId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type PurchaseItemRef = {
  approvedPriceLimit?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  price?: InputMaybe<Scalars['Int']>;
  product?: InputMaybe<ProductRef>;
  purchase?: InputMaybe<PurchaseRef>;
  purchaseProofUrl?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requestedItemId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type PurchaseOrder = {
  asc?: InputMaybe<PurchaseOrderable>;
  desc?: InputMaybe<PurchaseOrderable>;
  then?: InputMaybe<PurchaseOrder>;
};

export enum PurchaseOrderable {
  CreatedAt = 'createdAt',
  InvoiceUrl = 'invoiceUrl',
  RequestedItemId = 'requestedItemId',
  TotalPrice = 'totalPrice'
}

export type PurchasePatch = {
  approvedBy?: InputMaybe<UserRef>;
  centre?: InputMaybe<CentreRef>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  invoiceUrl?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<InputMaybe<PurchaseItemRef>>>;
  madeBy?: InputMaybe<UserRef>;
  payment?: InputMaybe<PaymentRef>;
  refurbishment?: InputMaybe<RefurbishmentRequestRef>;
  requestedItemId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PurchaseStatus>;
  totalPrice?: InputMaybe<Scalars['Int']>;
};

export type PurchaseRef = {
  approvedBy?: InputMaybe<UserRef>;
  centre?: InputMaybe<CentreRef>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  invoiceUrl?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<InputMaybe<PurchaseItemRef>>>;
  madeBy?: InputMaybe<UserRef>;
  payment?: InputMaybe<PaymentRef>;
  refurbishment?: InputMaybe<RefurbishmentRequestRef>;
  requestedItemId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PurchaseStatus>;
  totalPrice?: InputMaybe<Scalars['Int']>;
};

export enum PurchaseStatus {
  Approved = 'APPROVED',
  BillsUploaded = 'BILLS_UPLOADED',
  Paid = 'PAID',
  PaymentRequested = 'PAYMENT_REQUESTED',
  PurchaseConfirmed = 'PURCHASE_CONFIRMED',
  PurchaseRejected = 'PURCHASE_REJECTED',
  Received = 'RECEIVED',
  RefurbishmentApproved = 'REFURBISHMENT_APPROVED',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED'
}

export type PurchaseStatus_Hash = {
  eq?: InputMaybe<PurchaseStatus>;
  in?: InputMaybe<Array<InputMaybe<PurchaseStatus>>>;
};

export enum PurchaseTractorFrom {
  Broker = 'BROKER',
  Customer = 'CUSTOMER',
  NewTractorDealer = 'NEW_TRACTOR_DEALER'
}

export type Query = {
  __typename?: 'Query';
  aggregateAccessoriesCheck?: Maybe<AccessoriesCheckAggregateResult>;
  aggregateAccessoriesCheckListWithStage?: Maybe<AccessoriesCheckListWithStageAggregateResult>;
  aggregateAccessoriesChecklist?: Maybe<AccessoriesChecklistAggregateResult>;
  aggregateActiveStateWithGSTN?: Maybe<ActiveStateWithGstnAggregateResult>;
  aggregateAdminLeadStatusEvent?: Maybe<AdminLeadStatusEventAggregateResult>;
  aggregateAgency?: Maybe<AgencyAggregateResult>;
  aggregateAuctionHistory?: Maybe<AuctionHistoryAggregateResult>;
  aggregateBank?: Maybe<BankAggregateResult>;
  aggregateBankAuctionLeadCountByName?: Maybe<BankAuctionLeadCountByNameAggregateResult>;
  aggregateBooking?: Maybe<BookingAggregateResult>;
  aggregateBookingPayment?: Maybe<BookingPaymentAggregateResult>;
  aggregateBrand?: Maybe<BrandAggregateResult>;
  aggregateBulkApprovalResponse?: Maybe<BulkApprovalResponseAggregateResult>;
  aggregateCenterlizeLocationDistrcitsResponse?: Maybe<CenterlizeLocationDistrcitsResponseAggregateResult>;
  aggregateCenterlizeLocationDistrict?: Maybe<CenterlizeLocationDistrictAggregateResult>;
  aggregateCenterlizeLocationStates?: Maybe<CenterlizeLocationStatesAggregateResult>;
  aggregateCenterlizeLocationStatesResponse?: Maybe<CenterlizeLocationStatesResponseAggregateResult>;
  aggregateCenterlizeLocationTehsil?: Maybe<CenterlizeLocationTehsilAggregateResult>;
  aggregateCenterlizeLocationTehsilResponse?: Maybe<CenterlizeLocationTehsilResponseAggregateResult>;
  aggregateCentre?: Maybe<CentreAggregateResult>;
  aggregateCentreAggregates?: Maybe<CentreAggregatesAggregateResult>;
  aggregateCity?: Maybe<CityAggregateResult>;
  aggregateCreateBulkLeadResponse?: Maybe<CreateBulkLeadResponseAggregateResult>;
  aggregateCustomer?: Maybe<CustomerAggregateResult>;
  aggregateDealer?: Maybe<DealerAggregateResult>;
  aggregateDealerStance?: Maybe<DealerStanceAggregateResult>;
  aggregateDealershipDocument?: Maybe<DealershipDocumentAggregateResult>;
  aggregateDealershipLeadCountByPEName?: Maybe<DealershipLeadCountByPeNameAggregateResult>;
  aggregateDistrict?: Maybe<DistrictAggregateResult>;
  aggregateDocument?: Maybe<DocumentAggregateResult>;
  aggregateDocumentChecklist?: Maybe<DocumentChecklistAggregateResult>;
  aggregateDocumentsCount?: Maybe<DocumentsCountAggregateResult>;
  aggregateDocumentsFollowups?: Maybe<DocumentsFollowupsAggregateResult>;
  aggregateDriverAggregates?: Maybe<DriverAggregatesAggregateResult>;
  aggregateEnquiry?: Maybe<EnquiryAggregateResult>;
  aggregateEnquiryAdherence?: Maybe<EnquiryAdherenceAggregateResult>;
  aggregateEnquiryAggByCentre?: Maybe<EnquiryAggByCentreAggregateResult>;
  aggregateEnquiryCloserAgg?: Maybe<EnquiryCloserAggAggregateResult>;
  aggregateEnquiryClosure?: Maybe<EnquiryClosureAggregateResult>;
  aggregateFollowup?: Maybe<FollowupAggregateResult>;
  aggregateIdByName?: Maybe<IdByNameAggregateResult>;
  aggregateIdentificationDocument?: Maybe<IdentificationDocumentAggregateResult>;
  aggregateIdsByNameForListingReponse?: Maybe<IdsByNameForListingReponseAggregateResult>;
  aggregateInventoryDetails?: Maybe<InventoryDetailsAggregateResult>;
  aggregateIssue?: Maybe<IssueAggregateResult>;
  aggregateIssueItem?: Maybe<IssueItemAggregateResult>;
  aggregateItemInventoryDetails?: Maybe<ItemInventoryDetailsAggregateResult>;
  aggregateLead?: Maybe<LeadAggregateResult>;
  aggregateLeadCountByStatus?: Maybe<LeadCountByStatusAggregateResult>;
  aggregateLeadDocuments?: Maybe<LeadDocumentsAggregateResult>;
  aggregateLeadExpense?: Maybe<LeadExpenseAggregateResult>;
  aggregateLeadStatusEvent?: Maybe<LeadStatusEventAggregateResult>;
  aggregateLeadStatusFlow?: Maybe<LeadStatusFlowAggregateResult>;
  aggregateLeadTimelineAction?: Maybe<LeadTimelineActionAggregateResult>;
  aggregateLeadTimelineStatus?: Maybe<LeadTimelineStatusAggregateResult>;
  aggregateLoan?: Maybe<LoanAggregateResult>;
  aggregateLogTracking?: Maybe<LogTrackingAggregateResult>;
  aggregateMarkSoldResponse?: Maybe<MarkSoldResponseAggregateResult>;
  aggregateMessage?: Maybe<MessageAggregateResult>;
  aggregateModel?: Maybe<ModelAggregateResult>;
  aggregateModelByMake?: Maybe<ModelByMakeAggregateResult>;
  aggregateNotification?: Maybe<NotificationAggregateResult>;
  aggregateNumberOfPendingTasks?: Maybe<NumberOfPendingTasksAggregateResult>;
  aggregateParkingBeneficiary?: Maybe<ParkingBeneficiaryAggregateResult>;
  aggregatePayment?: Maybe<PaymentAggregateResult>;
  aggregatePaymentInvoices?: Maybe<PaymentInvoicesAggregateResult>;
  aggregatePickup?: Maybe<PickupAggregateResult>;
  aggregateProduct?: Maybe<ProductAggregateResult>;
  aggregatePurchase?: Maybe<PurchaseAggregateResult>;
  aggregatePurchaseItem?: Maybe<PurchaseItemAggregateResult>;
  aggregateRefurbishmentBeneficiary?: Maybe<RefurbishmentBeneficiaryAggregateResult>;
  aggregateRefurbishmentDetails?: Maybe<RefurbishmentDetailsAggregateResult>;
  aggregateRefurbishmentItem?: Maybe<RefurbishmentItemAggregateResult>;
  aggregateRefurbishmentRequest?: Maybe<RefurbishmentRequestAggregateResult>;
  aggregateSMSLogs?: Maybe<SmsLogsAggregateResult>;
  aggregateSendSmsToCustomerResponse?: Maybe<SendSmsToCustomerResponseAggregateResult>;
  aggregateStateCodeWithRegNumber?: Maybe<StateCodeWithRegNumberAggregateResult>;
  aggregateStatusAggregate?: Maybe<StatusAggregateAggregateResult>;
  aggregateTJCentre?: Maybe<TjCentreAggregateResult>;
  aggregateTask?: Maybe<TaskAggregateResult>;
  aggregateTehsil?: Maybe<TehsilAggregateResult>;
  aggregateTripExpense?: Maybe<TripExpenseAggregateResult>;
  aggregateUser?: Maybe<UserAggregateResult>;
  aggregateVehicle?: Maybe<VehicleAggregateResult>;
  aggregateVehicleDocuments?: Maybe<VehicleDocumentsAggregateResult>;
  aggregateVehicleFinancing?: Maybe<VehicleFinancingAggregateResult>;
  aggregateVehicleImages?: Maybe<VehicleImagesAggregateResult>;
  aggregateVehicleInsurance?: Maybe<VehicleInsuranceAggregateResult>;
  aggregateVehicleOwner?: Maybe<VehicleOwnerAggregateResult>;
  aggregateVehicleTransferLog?: Maybe<VehicleTransferLogAggregateResult>;
  aggregateYard?: Maybe<YardAggregateResult>;
  aggregatedocumentsAggregatesResult?: Maybe<DocumentsAggregatesResultAggregateResult>;
  bankAuctionLeadCountByName?: Maybe<Array<Maybe<BankAuctionLeadCountByName>>>;
  bulkApproval?: Maybe<Array<Maybe<BulkApprovalResponse>>>;
  centreAggregatesData?: Maybe<Array<Maybe<CentreAggregates>>>;
  commonEnquiry?: Maybe<Array<Maybe<Enquiry>>>;
  createBulkLeads?: Maybe<Array<Maybe<CreateBulkLeadResponse>>>;
  dealershipLeadCountByPEName?: Maybe<Array<Maybe<DealershipLeadCountByPeName>>>;
  documentsAggregatesData?: Maybe<DocumentsAggregatesResult>;
  doneBySomeone?: Maybe<User>;
  driverData?: Maybe<Array<Maybe<DriverAggregates>>>;
  enquiryAggrigateByCentre?: Maybe<Array<Maybe<EnquiryAggByCentre>>>;
  enquiryFollowupAdderence?: Maybe<Array<Maybe<EnquiryAdherence>>>;
  filteredBookings?: Maybe<Array<Maybe<Booking>>>;
  filteredEnquiry?: Maybe<Array<Maybe<Enquiry>>>;
  filteredLeads?: Maybe<Array<Maybe<Lead>>>;
  getAccessoriesCheck?: Maybe<AccessoriesCheck>;
  getAccessoriesCheckListWithStage?: Maybe<AccessoriesCheckListWithStage>;
  getAccessoriesChecklist?: Maybe<AccessoriesChecklist>;
  getActiveStateWithGSTN?: Maybe<ActiveStateWithGstn>;
  getAdminLeadStatusEvent?: Maybe<AdminLeadStatusEvent>;
  getAgency?: Maybe<Agency>;
  getAuctionHistory?: Maybe<AuctionHistory>;
  getBank?: Maybe<Bank>;
  getBooking?: Maybe<Booking>;
  getBookingPayment?: Maybe<BookingPayment>;
  getBrand?: Maybe<Brand>;
  getCentre?: Maybe<Centre>;
  getCentreDataFromTJ?: Maybe<Array<Maybe<Centre>>>;
  getCity?: Maybe<City>;
  getCustomer?: Maybe<Customer>;
  getDealer?: Maybe<Dealer>;
  getDealerStance?: Maybe<DealerStance>;
  getDealershipDocument?: Maybe<DealershipDocument>;
  getDistrict?: Maybe<District>;
  getDistrictByStateInfo?: Maybe<CenterlizeLocationDistrcitsResponse>;
  getDocumentChecklist?: Maybe<DocumentChecklist>;
  getDocumentsFollowups?: Maybe<DocumentsFollowups>;
  getEnquiry?: Maybe<Enquiry>;
  getFollowup?: Maybe<Followup>;
  getIdentificationDocument?: Maybe<IdentificationDocument>;
  getIdsByNameForListing?: Maybe<IdsByNameForListingReponse>;
  getInventoryDetails?: Maybe<InventoryDetails>;
  getIssue?: Maybe<Issue>;
  getIssueItem?: Maybe<IssueItem>;
  getItemInventoryDetails?: Maybe<ItemInventoryDetails>;
  getLead?: Maybe<Lead>;
  getLeadDocuments?: Maybe<LeadDocuments>;
  getLeadExpense?: Maybe<LeadExpense>;
  getLeadStatusEvent?: Maybe<LeadStatusEvent>;
  getLeadStatusFlow?: Maybe<LeadStatusFlow>;
  getLeadTimelineAction?: Maybe<LeadTimelineAction>;
  getLeadTimelineStatus?: Maybe<LeadTimelineStatus>;
  getLoan?: Maybe<Loan>;
  getLogTracking?: Maybe<LogTracking>;
  getMessage?: Maybe<Message>;
  getModel?: Maybe<Model>;
  getNotification?: Maybe<Notification>;
  getParkingBeneficiary?: Maybe<ParkingBeneficiary>;
  getPayment?: Maybe<Payment>;
  getPaymentInvoices?: Maybe<PaymentInvoices>;
  getPickup?: Maybe<Pickup>;
  getProduct?: Maybe<Product>;
  getPurchase?: Maybe<Purchase>;
  getPurchaseItem?: Maybe<PurchaseItem>;
  getRefurbishmentBeneficiary?: Maybe<RefurbishmentBeneficiary>;
  getRefurbishmentDetails?: Maybe<RefurbishmentDetails>;
  getRefurbishmentItem?: Maybe<RefurbishmentItem>;
  getRefurbishmentRequest?: Maybe<RefurbishmentRequest>;
  getStateCodeWithRegNumber?: Maybe<StateCodeWithRegNumber>;
  getStateInfo?: Maybe<CenterlizeLocationStatesResponse>;
  getTask?: Maybe<Task>;
  getTehsil?: Maybe<Tehsil>;
  getTehsilByDistricts?: Maybe<CenterlizeLocationTehsilResponse>;
  getTripExpense?: Maybe<TripExpense>;
  getUser?: Maybe<User>;
  getVehicle?: Maybe<Vehicle>;
  getVehicleDocuments?: Maybe<VehicleDocuments>;
  getVehicleFinancing?: Maybe<VehicleFinancing>;
  getVehicleImages?: Maybe<VehicleImages>;
  getVehicleInsurance?: Maybe<VehicleInsurance>;
  getVehicleOwner?: Maybe<VehicleOwner>;
  getVehicleTransferLog?: Maybe<VehicleTransferLog>;
  getYard?: Maybe<Yard>;
  inventoryDetails?: Maybe<InventoryDetails>;
  leadCountsByStatus?: Maybe<Array<Maybe<LeadCountByStatus>>>;
  leadsForListing?: Maybe<Array<Maybe<Lead>>>;
  markTractorAsSoldWrapper?: Maybe<MarkSoldResponse>;
  myPendingTasks?: Maybe<Array<Maybe<LeadStatusEvent>>>;
  numberOfPendingTasks: NumberOfPendingTasks;
  /** to be deprecated */
  pendingTasks?: Maybe<Array<Maybe<Lead>>>;
  queryAccessoriesCheck?: Maybe<Array<Maybe<AccessoriesCheck>>>;
  queryAccessoriesCheckListWithStage?: Maybe<Array<Maybe<AccessoriesCheckListWithStage>>>;
  queryAccessoriesChecklist?: Maybe<Array<Maybe<AccessoriesChecklist>>>;
  queryActiveStateWithGSTN?: Maybe<Array<Maybe<ActiveStateWithGstn>>>;
  queryAdminLeadStatusEvent?: Maybe<Array<Maybe<AdminLeadStatusEvent>>>;
  queryAgency?: Maybe<Array<Maybe<Agency>>>;
  queryAuctionHistory?: Maybe<Array<Maybe<AuctionHistory>>>;
  queryBank?: Maybe<Array<Maybe<Bank>>>;
  queryBankAuctionLeadCountByName?: Maybe<Array<Maybe<BankAuctionLeadCountByName>>>;
  queryBooking?: Maybe<Array<Maybe<Booking>>>;
  queryBookingPayment?: Maybe<Array<Maybe<BookingPayment>>>;
  queryBrand?: Maybe<Array<Maybe<Brand>>>;
  queryBulkApprovalResponse?: Maybe<Array<Maybe<BulkApprovalResponse>>>;
  queryCenterlizeLocationDistrcitsResponse?: Maybe<Array<Maybe<CenterlizeLocationDistrcitsResponse>>>;
  queryCenterlizeLocationDistrict?: Maybe<Array<Maybe<CenterlizeLocationDistrict>>>;
  queryCenterlizeLocationStates?: Maybe<Array<Maybe<CenterlizeLocationStates>>>;
  queryCenterlizeLocationStatesResponse?: Maybe<Array<Maybe<CenterlizeLocationStatesResponse>>>;
  queryCenterlizeLocationTehsil?: Maybe<Array<Maybe<CenterlizeLocationTehsil>>>;
  queryCenterlizeLocationTehsilResponse?: Maybe<Array<Maybe<CenterlizeLocationTehsilResponse>>>;
  queryCentre?: Maybe<Array<Maybe<Centre>>>;
  queryCentreAggregates?: Maybe<Array<Maybe<CentreAggregates>>>;
  queryCity?: Maybe<Array<Maybe<City>>>;
  queryCreateBulkLeadResponse?: Maybe<Array<Maybe<CreateBulkLeadResponse>>>;
  queryCustomer?: Maybe<Array<Maybe<Customer>>>;
  queryDealer?: Maybe<Array<Maybe<Dealer>>>;
  queryDealerStance?: Maybe<Array<Maybe<DealerStance>>>;
  queryDealershipDocument?: Maybe<Array<Maybe<DealershipDocument>>>;
  queryDealershipLeadCountByPEName?: Maybe<Array<Maybe<DealershipLeadCountByPeName>>>;
  queryDistrict?: Maybe<Array<Maybe<District>>>;
  queryDocument?: Maybe<Array<Maybe<Document>>>;
  queryDocumentChecklist?: Maybe<Array<Maybe<DocumentChecklist>>>;
  queryDocumentsCount?: Maybe<Array<Maybe<DocumentsCount>>>;
  queryDocumentsFollowups?: Maybe<Array<Maybe<DocumentsFollowups>>>;
  queryDriverAggregates?: Maybe<Array<Maybe<DriverAggregates>>>;
  queryEnquiry?: Maybe<Array<Maybe<Enquiry>>>;
  queryEnquiryAdherence?: Maybe<Array<Maybe<EnquiryAdherence>>>;
  queryEnquiryAggByCentre?: Maybe<Array<Maybe<EnquiryAggByCentre>>>;
  queryEnquiryCloserAgg?: Maybe<Array<Maybe<EnquiryCloserAgg>>>;
  queryEnquiryClosure?: Maybe<Array<Maybe<EnquiryClosure>>>;
  queryFollowup?: Maybe<Array<Maybe<Followup>>>;
  queryIdByName?: Maybe<Array<Maybe<IdByName>>>;
  queryIdentificationDocument?: Maybe<Array<Maybe<IdentificationDocument>>>;
  queryIdsByNameForListingReponse?: Maybe<Array<Maybe<IdsByNameForListingReponse>>>;
  queryInventoryDetails?: Maybe<Array<Maybe<InventoryDetails>>>;
  queryIssue?: Maybe<Array<Maybe<Issue>>>;
  queryIssueItem?: Maybe<Array<Maybe<IssueItem>>>;
  queryItemInventoryDetails?: Maybe<Array<Maybe<ItemInventoryDetails>>>;
  queryLead?: Maybe<Array<Maybe<Lead>>>;
  queryLeadCountByStatus?: Maybe<Array<Maybe<LeadCountByStatus>>>;
  queryLeadDocuments?: Maybe<Array<Maybe<LeadDocuments>>>;
  queryLeadExpense?: Maybe<Array<Maybe<LeadExpense>>>;
  queryLeadStatusEvent?: Maybe<Array<Maybe<LeadStatusEvent>>>;
  queryLeadStatusFlow?: Maybe<Array<Maybe<LeadStatusFlow>>>;
  queryLeadTimelineAction?: Maybe<Array<Maybe<LeadTimelineAction>>>;
  queryLeadTimelineStatus?: Maybe<Array<Maybe<LeadTimelineStatus>>>;
  queryLoan?: Maybe<Array<Maybe<Loan>>>;
  queryLogTracking?: Maybe<Array<Maybe<LogTracking>>>;
  queryMarkSoldResponse?: Maybe<Array<Maybe<MarkSoldResponse>>>;
  queryMessage?: Maybe<Array<Maybe<Message>>>;
  queryModel?: Maybe<Array<Maybe<Model>>>;
  queryModelByMake?: Maybe<Array<Maybe<ModelByMake>>>;
  queryNotification?: Maybe<Array<Maybe<Notification>>>;
  queryNumberOfPendingTasks?: Maybe<Array<Maybe<NumberOfPendingTasks>>>;
  queryParkingBeneficiary?: Maybe<Array<Maybe<ParkingBeneficiary>>>;
  queryPayment?: Maybe<Array<Maybe<Payment>>>;
  queryPaymentInvoices?: Maybe<Array<Maybe<PaymentInvoices>>>;
  queryPickup?: Maybe<Array<Maybe<Pickup>>>;
  queryProduct?: Maybe<Array<Maybe<Product>>>;
  queryPurchase?: Maybe<Array<Maybe<Purchase>>>;
  queryPurchaseItem?: Maybe<Array<Maybe<PurchaseItem>>>;
  queryRefurbishmentBeneficiary?: Maybe<Array<Maybe<RefurbishmentBeneficiary>>>;
  queryRefurbishmentDetails?: Maybe<Array<Maybe<RefurbishmentDetails>>>;
  queryRefurbishmentItem?: Maybe<Array<Maybe<RefurbishmentItem>>>;
  queryRefurbishmentRequest?: Maybe<Array<Maybe<RefurbishmentRequest>>>;
  querySMSLogs?: Maybe<Array<Maybe<SmsLogs>>>;
  querySendSmsToCustomerResponse?: Maybe<Array<Maybe<SendSmsToCustomerResponse>>>;
  queryStateCodeWithRegNumber?: Maybe<Array<Maybe<StateCodeWithRegNumber>>>;
  queryStatusAggregate?: Maybe<Array<Maybe<StatusAggregate>>>;
  queryTJCentre?: Maybe<Array<Maybe<TjCentre>>>;
  queryTask?: Maybe<Array<Maybe<Task>>>;
  queryTehsil?: Maybe<Array<Maybe<Tehsil>>>;
  queryTripExpense?: Maybe<Array<Maybe<TripExpense>>>;
  queryUser?: Maybe<Array<Maybe<User>>>;
  queryVehicle?: Maybe<Array<Maybe<Vehicle>>>;
  queryVehicleDocuments?: Maybe<Array<Maybe<VehicleDocuments>>>;
  queryVehicleFinancing?: Maybe<Array<Maybe<VehicleFinancing>>>;
  queryVehicleImages?: Maybe<Array<Maybe<VehicleImages>>>;
  queryVehicleInsurance?: Maybe<Array<Maybe<VehicleInsurance>>>;
  queryVehicleOwner?: Maybe<Array<Maybe<VehicleOwner>>>;
  queryVehicleTransferLog?: Maybe<Array<Maybe<VehicleTransferLog>>>;
  queryYard?: Maybe<Array<Maybe<Yard>>>;
  querydocumentsAggregatesResult?: Maybe<Array<Maybe<DocumentsAggregatesResult>>>;
  sendSmsToCustomer?: Maybe<SendSmsToCustomerResponse>;
  statusAggregates?: Maybe<Array<Maybe<StatusAggregate>>>;
};


export type QueryAggregateAccessoriesCheckArgs = {
  filter?: InputMaybe<AccessoriesCheckFilter>;
};


export type QueryAggregateAccessoriesCheckListWithStageArgs = {
  filter?: InputMaybe<AccessoriesCheckListWithStageFilter>;
};


export type QueryAggregateAccessoriesChecklistArgs = {
  filter?: InputMaybe<AccessoriesChecklistFilter>;
};


export type QueryAggregateActiveStateWithGstnArgs = {
  filter?: InputMaybe<ActiveStateWithGstnFilter>;
};


export type QueryAggregateAdminLeadStatusEventArgs = {
  filter?: InputMaybe<AdminLeadStatusEventFilter>;
};


export type QueryAggregateAgencyArgs = {
  filter?: InputMaybe<AgencyFilter>;
};


export type QueryAggregateAuctionHistoryArgs = {
  filter?: InputMaybe<AuctionHistoryFilter>;
};


export type QueryAggregateBankArgs = {
  filter?: InputMaybe<BankFilter>;
};


export type QueryAggregateBankAuctionLeadCountByNameArgs = {
  filter?: InputMaybe<BankAuctionLeadCountByNameFilter>;
};


export type QueryAggregateBookingArgs = {
  filter?: InputMaybe<BookingFilter>;
};


export type QueryAggregateBookingPaymentArgs = {
  filter?: InputMaybe<BookingPaymentFilter>;
};


export type QueryAggregateBrandArgs = {
  filter?: InputMaybe<BrandFilter>;
};


export type QueryAggregateBulkApprovalResponseArgs = {
  filter?: InputMaybe<BulkApprovalResponseFilter>;
};


export type QueryAggregateCenterlizeLocationDistrcitsResponseArgs = {
  filter?: InputMaybe<CenterlizeLocationDistrcitsResponseFilter>;
};


export type QueryAggregateCenterlizeLocationDistrictArgs = {
  filter?: InputMaybe<CenterlizeLocationDistrictFilter>;
};


export type QueryAggregateCenterlizeLocationStatesArgs = {
  filter?: InputMaybe<CenterlizeLocationStatesFilter>;
};


export type QueryAggregateCenterlizeLocationStatesResponseArgs = {
  filter?: InputMaybe<CenterlizeLocationStatesResponseFilter>;
};


export type QueryAggregateCenterlizeLocationTehsilArgs = {
  filter?: InputMaybe<CenterlizeLocationTehsilFilter>;
};


export type QueryAggregateCenterlizeLocationTehsilResponseArgs = {
  filter?: InputMaybe<CenterlizeLocationTehsilResponseFilter>;
};


export type QueryAggregateCentreArgs = {
  filter?: InputMaybe<CentreFilter>;
};


export type QueryAggregateCentreAggregatesArgs = {
  filter?: InputMaybe<CentreAggregatesFilter>;
};


export type QueryAggregateCityArgs = {
  filter?: InputMaybe<CityFilter>;
};


export type QueryAggregateCreateBulkLeadResponseArgs = {
  filter?: InputMaybe<CreateBulkLeadResponseFilter>;
};


export type QueryAggregateCustomerArgs = {
  filter?: InputMaybe<CustomerFilter>;
};


export type QueryAggregateDealerArgs = {
  filter?: InputMaybe<DealerFilter>;
};


export type QueryAggregateDealerStanceArgs = {
  filter?: InputMaybe<DealerStanceFilter>;
};


export type QueryAggregateDealershipDocumentArgs = {
  filter?: InputMaybe<DealershipDocumentFilter>;
};


export type QueryAggregateDealershipLeadCountByPeNameArgs = {
  filter?: InputMaybe<DealershipLeadCountByPeNameFilter>;
};


export type QueryAggregateDistrictArgs = {
  filter?: InputMaybe<DistrictFilter>;
};


export type QueryAggregateDocumentArgs = {
  filter?: InputMaybe<DocumentFilter>;
};


export type QueryAggregateDocumentChecklistArgs = {
  filter?: InputMaybe<DocumentChecklistFilter>;
};


export type QueryAggregateDocumentsCountArgs = {
  filter?: InputMaybe<DocumentsCountFilter>;
};


export type QueryAggregateDocumentsFollowupsArgs = {
  filter?: InputMaybe<DocumentsFollowupsFilter>;
};


export type QueryAggregateDriverAggregatesArgs = {
  filter?: InputMaybe<DriverAggregatesFilter>;
};


export type QueryAggregateEnquiryArgs = {
  filter?: InputMaybe<EnquiryFilter>;
};


export type QueryAggregateEnquiryAdherenceArgs = {
  filter?: InputMaybe<EnquiryAdherenceFilter>;
};


export type QueryAggregateEnquiryAggByCentreArgs = {
  filter?: InputMaybe<EnquiryAggByCentreFilter>;
};


export type QueryAggregateEnquiryCloserAggArgs = {
  filter?: InputMaybe<EnquiryCloserAggFilter>;
};


export type QueryAggregateEnquiryClosureArgs = {
  filter?: InputMaybe<EnquiryClosureFilter>;
};


export type QueryAggregateFollowupArgs = {
  filter?: InputMaybe<FollowupFilter>;
};


export type QueryAggregateIdByNameArgs = {
  filter?: InputMaybe<IdByNameFilter>;
};


export type QueryAggregateIdentificationDocumentArgs = {
  filter?: InputMaybe<IdentificationDocumentFilter>;
};


export type QueryAggregateIdsByNameForListingReponseArgs = {
  filter?: InputMaybe<IdsByNameForListingReponseFilter>;
};


export type QueryAggregateInventoryDetailsArgs = {
  filter?: InputMaybe<InventoryDetailsFilter>;
};


export type QueryAggregateIssueArgs = {
  filter?: InputMaybe<IssueFilter>;
};


export type QueryAggregateIssueItemArgs = {
  filter?: InputMaybe<IssueItemFilter>;
};


export type QueryAggregateItemInventoryDetailsArgs = {
  filter?: InputMaybe<ItemInventoryDetailsFilter>;
};


export type QueryAggregateLeadArgs = {
  filter?: InputMaybe<LeadFilter>;
};


export type QueryAggregateLeadCountByStatusArgs = {
  filter?: InputMaybe<LeadCountByStatusFilter>;
};


export type QueryAggregateLeadDocumentsArgs = {
  filter?: InputMaybe<LeadDocumentsFilter>;
};


export type QueryAggregateLeadExpenseArgs = {
  filter?: InputMaybe<LeadExpenseFilter>;
};


export type QueryAggregateLeadStatusEventArgs = {
  filter?: InputMaybe<LeadStatusEventFilter>;
};


export type QueryAggregateLeadStatusFlowArgs = {
  filter?: InputMaybe<LeadStatusFlowFilter>;
};


export type QueryAggregateLeadTimelineActionArgs = {
  filter?: InputMaybe<LeadTimelineActionFilter>;
};


export type QueryAggregateLeadTimelineStatusArgs = {
  filter?: InputMaybe<LeadTimelineStatusFilter>;
};


export type QueryAggregateLoanArgs = {
  filter?: InputMaybe<LoanFilter>;
};


export type QueryAggregateLogTrackingArgs = {
  filter?: InputMaybe<LogTrackingFilter>;
};


export type QueryAggregateMarkSoldResponseArgs = {
  filter?: InputMaybe<MarkSoldResponseFilter>;
};


export type QueryAggregateMessageArgs = {
  filter?: InputMaybe<MessageFilter>;
};


export type QueryAggregateModelArgs = {
  filter?: InputMaybe<ModelFilter>;
};


export type QueryAggregateModelByMakeArgs = {
  filter?: InputMaybe<ModelByMakeFilter>;
};


export type QueryAggregateNotificationArgs = {
  filter?: InputMaybe<NotificationFilter>;
};


export type QueryAggregateNumberOfPendingTasksArgs = {
  filter?: InputMaybe<NumberOfPendingTasksFilter>;
};


export type QueryAggregateParkingBeneficiaryArgs = {
  filter?: InputMaybe<ParkingBeneficiaryFilter>;
};


export type QueryAggregatePaymentArgs = {
  filter?: InputMaybe<PaymentFilter>;
};


export type QueryAggregatePaymentInvoicesArgs = {
  filter?: InputMaybe<PaymentInvoicesFilter>;
};


export type QueryAggregatePickupArgs = {
  filter?: InputMaybe<PickupFilter>;
};


export type QueryAggregateProductArgs = {
  filter?: InputMaybe<ProductFilter>;
};


export type QueryAggregatePurchaseArgs = {
  filter?: InputMaybe<PurchaseFilter>;
};


export type QueryAggregatePurchaseItemArgs = {
  filter?: InputMaybe<PurchaseItemFilter>;
};


export type QueryAggregateRefurbishmentBeneficiaryArgs = {
  filter?: InputMaybe<RefurbishmentBeneficiaryFilter>;
};


export type QueryAggregateRefurbishmentDetailsArgs = {
  filter?: InputMaybe<RefurbishmentDetailsFilter>;
};


export type QueryAggregateRefurbishmentItemArgs = {
  filter?: InputMaybe<RefurbishmentItemFilter>;
};


export type QueryAggregateRefurbishmentRequestArgs = {
  filter?: InputMaybe<RefurbishmentRequestFilter>;
};


export type QueryAggregateSmsLogsArgs = {
  filter?: InputMaybe<SmsLogsFilter>;
};


export type QueryAggregateSendSmsToCustomerResponseArgs = {
  filter?: InputMaybe<SendSmsToCustomerResponseFilter>;
};


export type QueryAggregateStateCodeWithRegNumberArgs = {
  filter?: InputMaybe<StateCodeWithRegNumberFilter>;
};


export type QueryAggregateStatusAggregateArgs = {
  filter?: InputMaybe<StatusAggregateFilter>;
};


export type QueryAggregateTjCentreArgs = {
  filter?: InputMaybe<TjCentreFilter>;
};


export type QueryAggregateTaskArgs = {
  filter?: InputMaybe<TaskFilter>;
};


export type QueryAggregateTehsilArgs = {
  filter?: InputMaybe<TehsilFilter>;
};


export type QueryAggregateTripExpenseArgs = {
  filter?: InputMaybe<TripExpenseFilter>;
};


export type QueryAggregateUserArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type QueryAggregateVehicleArgs = {
  filter?: InputMaybe<VehicleFilter>;
};


export type QueryAggregateVehicleDocumentsArgs = {
  filter?: InputMaybe<VehicleDocumentsFilter>;
};


export type QueryAggregateVehicleFinancingArgs = {
  filter?: InputMaybe<VehicleFinancingFilter>;
};


export type QueryAggregateVehicleImagesArgs = {
  filter?: InputMaybe<VehicleImagesFilter>;
};


export type QueryAggregateVehicleInsuranceArgs = {
  filter?: InputMaybe<VehicleInsuranceFilter>;
};


export type QueryAggregateVehicleOwnerArgs = {
  filter?: InputMaybe<VehicleOwnerFilter>;
};


export type QueryAggregateVehicleTransferLogArgs = {
  filter?: InputMaybe<VehicleTransferLogFilter>;
};


export type QueryAggregateYardArgs = {
  filter?: InputMaybe<YardFilter>;
};


export type QueryAggregatedocumentsAggregatesResultArgs = {
  filter?: InputMaybe<DocumentsAggregatesResultFilter>;
};


export type QueryBankAuctionLeadCountByNameArgs = {
  end?: InputMaybe<Scalars['DateTime']>;
  regState?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['DateTime']>;
};


export type QueryBulkApprovalArgs = {
  createById?: InputMaybe<Scalars['String']>;
  leads: Array<BulkApprovalInput>;
};


export type QueryCentreAggregatesDataArgs = {
  centreReportFilters?: InputMaybe<ReportFilters>;
};


export type QueryCommonEnquiryArgs = {
  filters?: InputMaybe<CommonEnquiryFilter>;
};


export type QueryCreateBulkLeadsArgs = {
  leads: Array<BulkLeadInput>;
  userId: Scalars['String'];
};


export type QueryDealershipLeadCountByPeNameArgs = {
  end?: InputMaybe<Scalars['DateTime']>;
  regState?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['DateTime']>;
};


export type QueryDocumentsAggregatesDataArgs = {
  filters?: InputMaybe<DocumentsFilters>;
};


export type QueryDoneBySomeoneArgs = {
  desiredStatus: LeadStatus;
  leadId: Scalars['ID'];
};


export type QueryDriverDataArgs = {
  driverReportFilters?: InputMaybe<ReportFilters>;
};


export type QueryEnquiryAggrigateByCentreArgs = {
  dateRange?: InputMaybe<EnquiryDateRange>;
  key?: InputMaybe<Scalars['String']>;
};


export type QueryEnquiryFollowupAdderenceArgs = {
  dateRange?: InputMaybe<EnquiryDateRange>;
  key?: InputMaybe<Scalars['String']>;
};


export type QueryFilteredBookingsArgs = {
  bookingFilters?: InputMaybe<BookingFilters>;
};


export type QueryFilteredEnquiryArgs = {
  enquiryFilters?: InputMaybe<EnquiryFilters>;
};


export type QueryFilteredLeadsArgs = {
  leadFilters?: InputMaybe<LeadFilters>;
};


export type QueryGetAccessoriesCheckArgs = {
  id: Scalars['ID'];
};


export type QueryGetAccessoriesCheckListWithStageArgs = {
  id: Scalars['ID'];
};


export type QueryGetAccessoriesChecklistArgs = {
  id: Scalars['ID'];
};


export type QueryGetActiveStateWithGstnArgs = {
  id?: InputMaybe<Scalars['ID']>;
  state?: InputMaybe<Scalars['String']>;
};


export type QueryGetAdminLeadStatusEventArgs = {
  id: Scalars['ID'];
};


export type QueryGetAgencyArgs = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};


export type QueryGetAuctionHistoryArgs = {
  id: Scalars['ID'];
};


export type QueryGetBankArgs = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};


export type QueryGetBookingArgs = {
  id: Scalars['ID'];
};


export type QueryGetBookingPaymentArgs = {
  id: Scalars['ID'];
};


export type QueryGetBrandArgs = {
  brand_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryGetCentreArgs = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};


export type QueryGetCityArgs = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};


export type QueryGetCustomerArgs = {
  id?: InputMaybe<Scalars['ID']>;
  phoneNo?: InputMaybe<Scalars['String']>;
};


export type QueryGetDealerArgs = {
  id?: InputMaybe<Scalars['ID']>;
  phoneNo?: InputMaybe<Scalars['String']>;
};


export type QueryGetDealerStanceArgs = {
  id: Scalars['ID'];
};


export type QueryGetDealershipDocumentArgs = {
  id?: InputMaybe<Scalars['ID']>;
  regNo?: InputMaybe<Scalars['String']>;
};


export type QueryGetDistrictArgs = {
  id: Scalars['ID'];
};


export type QueryGetDistrictByStateInfoArgs = {
  state_id?: InputMaybe<Scalars['Int']>;
};


export type QueryGetDocumentChecklistArgs = {
  id?: InputMaybe<Scalars['ID']>;
  regNo?: InputMaybe<Scalars['String']>;
};


export type QueryGetDocumentsFollowupsArgs = {
  id: Scalars['ID'];
};


export type QueryGetEnquiryArgs = {
  customerPhoneNo?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryGetFollowupArgs = {
  id: Scalars['ID'];
};


export type QueryGetIdentificationDocumentArgs = {
  id: Scalars['ID'];
};


export type QueryGetIdsByNameForListingArgs = {
  IdsByNameForListingInput?: InputMaybe<IdsByNameForListingInput>;
};


export type QueryGetInventoryDetailsArgs = {
  id: Scalars['String'];
};


export type QueryGetIssueArgs = {
  id: Scalars['ID'];
};


export type QueryGetIssueItemArgs = {
  id: Scalars['ID'];
};


export type QueryGetItemInventoryDetailsArgs = {
  id: Scalars['String'];
};


export type QueryGetLeadArgs = {
  id?: InputMaybe<Scalars['ID']>;
  regNo?: InputMaybe<Scalars['String']>;
};


export type QueryGetLeadDocumentsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  regNo?: InputMaybe<Scalars['String']>;
};


export type QueryGetLeadExpenseArgs = {
  id: Scalars['ID'];
};


export type QueryGetLeadStatusEventArgs = {
  id: Scalars['ID'];
};


export type QueryGetLeadStatusFlowArgs = {
  id: Scalars['ID'];
};


export type QueryGetLeadTimelineActionArgs = {
  id: Scalars['ID'];
};


export type QueryGetLeadTimelineStatusArgs = {
  id: Scalars['ID'];
};


export type QueryGetLoanArgs = {
  id: Scalars['ID'];
};


export type QueryGetLogTrackingArgs = {
  id: Scalars['ID'];
};


export type QueryGetMessageArgs = {
  id: Scalars['ID'];
};


export type QueryGetModelArgs = {
  id?: InputMaybe<Scalars['ID']>;
  model_id?: InputMaybe<Scalars['Int']>;
};


export type QueryGetNotificationArgs = {
  id: Scalars['ID'];
};


export type QueryGetParkingBeneficiaryArgs = {
  accountNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryGetPaymentArgs = {
  id: Scalars['ID'];
};


export type QueryGetPaymentInvoicesArgs = {
  id: Scalars['ID'];
};


export type QueryGetPickupArgs = {
  id?: InputMaybe<Scalars['ID']>;
  regNo?: InputMaybe<Scalars['String']>;
};


export type QueryGetProductArgs = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};


export type QueryGetPurchaseArgs = {
  id: Scalars['ID'];
};


export type QueryGetPurchaseItemArgs = {
  id: Scalars['ID'];
};


export type QueryGetRefurbishmentBeneficiaryArgs = {
  accountNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryGetRefurbishmentDetailsArgs = {
  id: Scalars['ID'];
};


export type QueryGetRefurbishmentItemArgs = {
  id: Scalars['ID'];
};


export type QueryGetRefurbishmentRequestArgs = {
  id: Scalars['ID'];
};


export type QueryGetStateCodeWithRegNumberArgs = {
  id?: InputMaybe<Scalars['ID']>;
  state?: InputMaybe<Scalars['String']>;
};


export type QueryGetStateInfoArgs = {
  activeState?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetTaskArgs = {
  id: Scalars['ID'];
};


export type QueryGetTehsilArgs = {
  id: Scalars['ID'];
};


export type QueryGetTehsilByDistrictsArgs = {
  district_idd?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type QueryGetTripExpenseArgs = {
  id: Scalars['ID'];
};


export type QueryGetUserArgs = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryGetVehicleArgs = {
  id?: InputMaybe<Scalars['ID']>;
  regNo?: InputMaybe<Scalars['String']>;
};


export type QueryGetVehicleDocumentsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  regNo?: InputMaybe<Scalars['String']>;
};


export type QueryGetVehicleFinancingArgs = {
  id: Scalars['ID'];
};


export type QueryGetVehicleImagesArgs = {
  id?: InputMaybe<Scalars['ID']>;
  vehicleImagesId?: InputMaybe<Scalars['String']>;
};


export type QueryGetVehicleInsuranceArgs = {
  id: Scalars['ID'];
};


export type QueryGetVehicleOwnerArgs = {
  id: Scalars['ID'];
};


export type QueryGetVehicleTransferLogArgs = {
  id: Scalars['ID'];
};


export type QueryGetYardArgs = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};


export type QueryInventoryDetailsArgs = {
  centreId?: InputMaybe<Scalars['ID']>;
};


export type QueryLeadCountsByStatusArgs = {
  end?: InputMaybe<Scalars['DateTime']>;
  regState?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['DateTime']>;
};


export type QueryLeadsForListingArgs = {
  filters?: InputMaybe<LeadsForListingFilter>;
};


export type QueryMarkTractorAsSoldWrapperArgs = {
  markSoldInput?: InputMaybe<MarkSoldInput>;
};


export type QueryMyPendingTasksArgs = {
  centreId?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  role: UserRole;
  searchString?: InputMaybe<Scalars['String']>;
  taskForNotifications?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
};


export type QueryNumberOfPendingTasksArgs = {
  centreId?: InputMaybe<Scalars['ID']>;
  role: UserRole;
  userId: Scalars['ID'];
};


export type QueryPendingTasksArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  role: UserRole;
  userId: Scalars['ID'];
};


export type QueryQueryAccessoriesCheckArgs = {
  filter?: InputMaybe<AccessoriesCheckFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryAccessoriesCheckListWithStageArgs = {
  filter?: InputMaybe<AccessoriesCheckListWithStageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<AccessoriesCheckListWithStageOrder>;
};


export type QueryQueryAccessoriesChecklistArgs = {
  filter?: InputMaybe<AccessoriesChecklistFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<AccessoriesChecklistOrder>;
};


export type QueryQueryActiveStateWithGstnArgs = {
  filter?: InputMaybe<ActiveStateWithGstnFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ActiveStateWithGstnOrder>;
};


export type QueryQueryAdminLeadStatusEventArgs = {
  filter?: InputMaybe<AdminLeadStatusEventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<AdminLeadStatusEventOrder>;
};


export type QueryQueryAgencyArgs = {
  filter?: InputMaybe<AgencyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<AgencyOrder>;
};


export type QueryQueryAuctionHistoryArgs = {
  filter?: InputMaybe<AuctionHistoryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<AuctionHistoryOrder>;
};


export type QueryQueryBankArgs = {
  filter?: InputMaybe<BankFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<BankOrder>;
};


export type QueryQueryBankAuctionLeadCountByNameArgs = {
  filter?: InputMaybe<BankAuctionLeadCountByNameFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<BankAuctionLeadCountByNameOrder>;
};


export type QueryQueryBookingArgs = {
  filter?: InputMaybe<BookingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<BookingOrder>;
};


export type QueryQueryBookingPaymentArgs = {
  filter?: InputMaybe<BookingPaymentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<BookingPaymentOrder>;
};


export type QueryQueryBrandArgs = {
  filter?: InputMaybe<BrandFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<BrandOrder>;
};


export type QueryQueryBulkApprovalResponseArgs = {
  filter?: InputMaybe<BulkApprovalResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<BulkApprovalResponseOrder>;
};


export type QueryQueryCenterlizeLocationDistrcitsResponseArgs = {
  filter?: InputMaybe<CenterlizeLocationDistrcitsResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CenterlizeLocationDistrcitsResponseOrder>;
};


export type QueryQueryCenterlizeLocationDistrictArgs = {
  filter?: InputMaybe<CenterlizeLocationDistrictFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CenterlizeLocationDistrictOrder>;
};


export type QueryQueryCenterlizeLocationStatesArgs = {
  filter?: InputMaybe<CenterlizeLocationStatesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CenterlizeLocationStatesOrder>;
};


export type QueryQueryCenterlizeLocationStatesResponseArgs = {
  filter?: InputMaybe<CenterlizeLocationStatesResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CenterlizeLocationStatesResponseOrder>;
};


export type QueryQueryCenterlizeLocationTehsilArgs = {
  filter?: InputMaybe<CenterlizeLocationTehsilFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CenterlizeLocationTehsilOrder>;
};


export type QueryQueryCenterlizeLocationTehsilResponseArgs = {
  filter?: InputMaybe<CenterlizeLocationTehsilResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CenterlizeLocationTehsilResponseOrder>;
};


export type QueryQueryCentreArgs = {
  filter?: InputMaybe<CentreFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CentreOrder>;
};


export type QueryQueryCentreAggregatesArgs = {
  filter?: InputMaybe<CentreAggregatesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CentreAggregatesOrder>;
};


export type QueryQueryCityArgs = {
  filter?: InputMaybe<CityFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CityOrder>;
};


export type QueryQueryCreateBulkLeadResponseArgs = {
  filter?: InputMaybe<CreateBulkLeadResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CreateBulkLeadResponseOrder>;
};


export type QueryQueryCustomerArgs = {
  filter?: InputMaybe<CustomerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CustomerOrder>;
};


export type QueryQueryDealerArgs = {
  filter?: InputMaybe<DealerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DealerOrder>;
};


export type QueryQueryDealerStanceArgs = {
  filter?: InputMaybe<DealerStanceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryDealershipDocumentArgs = {
  filter?: InputMaybe<DealershipDocumentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DealershipDocumentOrder>;
};


export type QueryQueryDealershipLeadCountByPeNameArgs = {
  filter?: InputMaybe<DealershipLeadCountByPeNameFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DealershipLeadCountByPeNameOrder>;
};


export type QueryQueryDistrictArgs = {
  filter?: InputMaybe<DistrictFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DistrictOrder>;
};


export type QueryQueryDocumentArgs = {
  filter?: InputMaybe<DocumentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DocumentOrder>;
};


export type QueryQueryDocumentChecklistArgs = {
  filter?: InputMaybe<DocumentChecklistFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DocumentChecklistOrder>;
};


export type QueryQueryDocumentsCountArgs = {
  filter?: InputMaybe<DocumentsCountFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DocumentsCountOrder>;
};


export type QueryQueryDocumentsFollowupsArgs = {
  filter?: InputMaybe<DocumentsFollowupsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DocumentsFollowupsOrder>;
};


export type QueryQueryDriverAggregatesArgs = {
  filter?: InputMaybe<DriverAggregatesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DriverAggregatesOrder>;
};


export type QueryQueryEnquiryArgs = {
  filter?: InputMaybe<EnquiryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<EnquiryOrder>;
};


export type QueryQueryEnquiryAdherenceArgs = {
  filter?: InputMaybe<EnquiryAdherenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<EnquiryAdherenceOrder>;
};


export type QueryQueryEnquiryAggByCentreArgs = {
  filter?: InputMaybe<EnquiryAggByCentreFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<EnquiryAggByCentreOrder>;
};


export type QueryQueryEnquiryCloserAggArgs = {
  filter?: InputMaybe<EnquiryCloserAggFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<EnquiryCloserAggOrder>;
};


export type QueryQueryEnquiryClosureArgs = {
  filter?: InputMaybe<EnquiryClosureFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<EnquiryClosureOrder>;
};


export type QueryQueryFollowupArgs = {
  filter?: InputMaybe<FollowupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<FollowupOrder>;
};


export type QueryQueryIdByNameArgs = {
  filter?: InputMaybe<IdByNameFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<IdByNameOrder>;
};


export type QueryQueryIdentificationDocumentArgs = {
  filter?: InputMaybe<IdentificationDocumentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<IdentificationDocumentOrder>;
};


export type QueryQueryIdsByNameForListingReponseArgs = {
  filter?: InputMaybe<IdsByNameForListingReponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<IdsByNameForListingReponseOrder>;
};


export type QueryQueryInventoryDetailsArgs = {
  filter?: InputMaybe<InventoryDetailsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<InventoryDetailsOrder>;
};


export type QueryQueryIssueArgs = {
  filter?: InputMaybe<IssueFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<IssueOrder>;
};


export type QueryQueryIssueItemArgs = {
  filter?: InputMaybe<IssueItemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<IssueItemOrder>;
};


export type QueryQueryItemInventoryDetailsArgs = {
  filter?: InputMaybe<ItemInventoryDetailsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ItemInventoryDetailsOrder>;
};


export type QueryQueryLeadArgs = {
  filter?: InputMaybe<LeadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadOrder>;
};


export type QueryQueryLeadCountByStatusArgs = {
  filter?: InputMaybe<LeadCountByStatusFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadCountByStatusOrder>;
};


export type QueryQueryLeadDocumentsArgs = {
  filter?: InputMaybe<LeadDocumentsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadDocumentsOrder>;
};


export type QueryQueryLeadExpenseArgs = {
  filter?: InputMaybe<LeadExpenseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadExpenseOrder>;
};


export type QueryQueryLeadStatusEventArgs = {
  filter?: InputMaybe<LeadStatusEventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadStatusEventOrder>;
};


export type QueryQueryLeadStatusFlowArgs = {
  filter?: InputMaybe<LeadStatusFlowFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadStatusFlowOrder>;
};


export type QueryQueryLeadTimelineActionArgs = {
  filter?: InputMaybe<LeadTimelineActionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadTimelineActionOrder>;
};


export type QueryQueryLeadTimelineStatusArgs = {
  filter?: InputMaybe<LeadTimelineStatusFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryLoanArgs = {
  filter?: InputMaybe<LoanFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LoanOrder>;
};


export type QueryQueryLogTrackingArgs = {
  filter?: InputMaybe<LogTrackingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LogTrackingOrder>;
};


export type QueryQueryMarkSoldResponseArgs = {
  filter?: InputMaybe<MarkSoldResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<MarkSoldResponseOrder>;
};


export type QueryQueryMessageArgs = {
  filter?: InputMaybe<MessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<MessageOrder>;
};


export type QueryQueryModelArgs = {
  filter?: InputMaybe<ModelFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ModelOrder>;
};


export type QueryQueryModelByMakeArgs = {
  filter?: InputMaybe<ModelByMakeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ModelByMakeOrder>;
};


export type QueryQueryNotificationArgs = {
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<NotificationOrder>;
};


export type QueryQueryNumberOfPendingTasksArgs = {
  filter?: InputMaybe<NumberOfPendingTasksFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<NumberOfPendingTasksOrder>;
};


export type QueryQueryParkingBeneficiaryArgs = {
  filter?: InputMaybe<ParkingBeneficiaryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ParkingBeneficiaryOrder>;
};


export type QueryQueryPaymentArgs = {
  filter?: InputMaybe<PaymentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaymentOrder>;
};


export type QueryQueryPaymentInvoicesArgs = {
  filter?: InputMaybe<PaymentInvoicesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaymentInvoicesOrder>;
};


export type QueryQueryPickupArgs = {
  filter?: InputMaybe<PickupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PickupOrder>;
};


export type QueryQueryProductArgs = {
  filter?: InputMaybe<ProductFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ProductOrder>;
};


export type QueryQueryPurchaseArgs = {
  filter?: InputMaybe<PurchaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PurchaseOrder>;
};


export type QueryQueryPurchaseItemArgs = {
  filter?: InputMaybe<PurchaseItemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PurchaseItemOrder>;
};


export type QueryQueryRefurbishmentBeneficiaryArgs = {
  filter?: InputMaybe<RefurbishmentBeneficiaryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<RefurbishmentBeneficiaryOrder>;
};


export type QueryQueryRefurbishmentDetailsArgs = {
  filter?: InputMaybe<RefurbishmentDetailsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQueryRefurbishmentItemArgs = {
  filter?: InputMaybe<RefurbishmentItemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<RefurbishmentItemOrder>;
};


export type QueryQueryRefurbishmentRequestArgs = {
  filter?: InputMaybe<RefurbishmentRequestFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<RefurbishmentRequestOrder>;
};


export type QueryQuerySmsLogsArgs = {
  filter?: InputMaybe<SmsLogsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<SmsLogsOrder>;
};


export type QueryQuerySendSmsToCustomerResponseArgs = {
  filter?: InputMaybe<SendSmsToCustomerResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<SendSmsToCustomerResponseOrder>;
};


export type QueryQueryStateCodeWithRegNumberArgs = {
  filter?: InputMaybe<StateCodeWithRegNumberFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<StateCodeWithRegNumberOrder>;
};


export type QueryQueryStatusAggregateArgs = {
  filter?: InputMaybe<StatusAggregateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<StatusAggregateOrder>;
};


export type QueryQueryTjCentreArgs = {
  filter?: InputMaybe<TjCentreFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<TjCentreOrder>;
};


export type QueryQueryTaskArgs = {
  filter?: InputMaybe<TaskFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<TaskOrder>;
};


export type QueryQueryTehsilArgs = {
  filter?: InputMaybe<TehsilFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<TehsilOrder>;
};


export type QueryQueryTripExpenseArgs = {
  filter?: InputMaybe<TripExpenseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<TripExpenseOrder>;
};


export type QueryQueryUserArgs = {
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<UserOrder>;
};


export type QueryQueryVehicleArgs = {
  filter?: InputMaybe<VehicleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleOrder>;
};


export type QueryQueryVehicleDocumentsArgs = {
  filter?: InputMaybe<VehicleDocumentsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleDocumentsOrder>;
};


export type QueryQueryVehicleFinancingArgs = {
  filter?: InputMaybe<VehicleFinancingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleFinancingOrder>;
};


export type QueryQueryVehicleImagesArgs = {
  filter?: InputMaybe<VehicleImagesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleImagesOrder>;
};


export type QueryQueryVehicleInsuranceArgs = {
  filter?: InputMaybe<VehicleInsuranceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleInsuranceOrder>;
};


export type QueryQueryVehicleOwnerArgs = {
  filter?: InputMaybe<VehicleOwnerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleOwnerOrder>;
};


export type QueryQueryVehicleTransferLogArgs = {
  filter?: InputMaybe<VehicleTransferLogFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleTransferLogOrder>;
};


export type QueryQueryYardArgs = {
  filter?: InputMaybe<YardFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<YardOrder>;
};


export type QueryQuerydocumentsAggregatesResultArgs = {
  filter?: InputMaybe<DocumentsAggregatesResultFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QuerySendSmsToCustomerArgs = {
  env?: InputMaybe<Scalars['String']>;
  invoiceId?: InputMaybe<Scalars['String']>;
};

export type RefurbishmentBeneficiary = {
  __typename?: 'RefurbishmentBeneficiary';
  accountHolderName: Scalars['String'];
  accountNumber: Scalars['String'];
  bankName?: Maybe<BankName>;
  id: Scalars['ID'];
  ifscCode: Scalars['String'];
  payment?: Maybe<Array<Maybe<Payment>>>;
  paymentAggregate?: Maybe<PaymentAggregateResult>;
  proofUrl?: Maybe<Scalars['String']>;
  refurbishmentRequest?: Maybe<RefurbishmentRequest>;
  upiId?: Maybe<Scalars['String']>;
};


export type RefurbishmentBeneficiaryPaymentArgs = {
  filter?: InputMaybe<PaymentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaymentOrder>;
};


export type RefurbishmentBeneficiaryPaymentAggregateArgs = {
  filter?: InputMaybe<PaymentFilter>;
};


export type RefurbishmentBeneficiaryRefurbishmentRequestArgs = {
  filter?: InputMaybe<RefurbishmentRequestFilter>;
};

export type RefurbishmentBeneficiaryAggregateResult = {
  __typename?: 'RefurbishmentBeneficiaryAggregateResult';
  accountHolderNameMax?: Maybe<Scalars['String']>;
  accountHolderNameMin?: Maybe<Scalars['String']>;
  accountNumberMax?: Maybe<Scalars['String']>;
  accountNumberMin?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  ifscCodeMax?: Maybe<Scalars['String']>;
  ifscCodeMin?: Maybe<Scalars['String']>;
  proofUrlMax?: Maybe<Scalars['String']>;
  proofUrlMin?: Maybe<Scalars['String']>;
  upiIdMax?: Maybe<Scalars['String']>;
  upiIdMin?: Maybe<Scalars['String']>;
};

export type RefurbishmentBeneficiaryFilter = {
  accountNumber?: InputMaybe<StringHashFilter>;
  and?: InputMaybe<Array<InputMaybe<RefurbishmentBeneficiaryFilter>>>;
  has?: InputMaybe<Array<InputMaybe<RefurbishmentBeneficiaryHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<RefurbishmentBeneficiaryFilter>;
  or?: InputMaybe<Array<InputMaybe<RefurbishmentBeneficiaryFilter>>>;
};

export enum RefurbishmentBeneficiaryHasFilter {
  AccountHolderName = 'accountHolderName',
  AccountNumber = 'accountNumber',
  BankName = 'bankName',
  IfscCode = 'ifscCode',
  Payment = 'payment',
  ProofUrl = 'proofUrl',
  RefurbishmentRequest = 'refurbishmentRequest',
  UpiId = 'upiId'
}

export type RefurbishmentBeneficiaryOrder = {
  asc?: InputMaybe<RefurbishmentBeneficiaryOrderable>;
  desc?: InputMaybe<RefurbishmentBeneficiaryOrderable>;
  then?: InputMaybe<RefurbishmentBeneficiaryOrder>;
};

export enum RefurbishmentBeneficiaryOrderable {
  AccountHolderName = 'accountHolderName',
  AccountNumber = 'accountNumber',
  IfscCode = 'ifscCode',
  ProofUrl = 'proofUrl',
  UpiId = 'upiId'
}

export type RefurbishmentBeneficiaryPatch = {
  accountHolderName?: InputMaybe<Scalars['String']>;
  bankName?: InputMaybe<BankName>;
  ifscCode?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<Array<InputMaybe<PaymentRef>>>;
  proofUrl?: InputMaybe<Scalars['String']>;
  refurbishmentRequest?: InputMaybe<RefurbishmentRequestRef>;
  upiId?: InputMaybe<Scalars['String']>;
};

export type RefurbishmentBeneficiaryRef = {
  accountHolderName?: InputMaybe<Scalars['String']>;
  accountNumber?: InputMaybe<Scalars['String']>;
  bankName?: InputMaybe<BankName>;
  id?: InputMaybe<Scalars['ID']>;
  ifscCode?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<Array<InputMaybe<PaymentRef>>>;
  proofUrl?: InputMaybe<Scalars['String']>;
  refurbishmentRequest?: InputMaybe<RefurbishmentRequestRef>;
  upiId?: InputMaybe<Scalars['String']>;
};

export type RefurbishmentDetails = {
  __typename?: 'RefurbishmentDetails';
  id: Scalars['ID'];
  isRequired?: Maybe<Scalars['Boolean']>;
  lead?: Maybe<Lead>;
  requests?: Maybe<Array<Maybe<RefurbishmentRequest>>>;
  requestsAggregate?: Maybe<RefurbishmentRequestAggregateResult>;
};


export type RefurbishmentDetailsLeadArgs = {
  filter?: InputMaybe<LeadFilter>;
};


export type RefurbishmentDetailsRequestsArgs = {
  filter?: InputMaybe<RefurbishmentRequestFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<RefurbishmentRequestOrder>;
};


export type RefurbishmentDetailsRequestsAggregateArgs = {
  filter?: InputMaybe<RefurbishmentRequestFilter>;
};

export type RefurbishmentDetailsAggregateResult = {
  __typename?: 'RefurbishmentDetailsAggregateResult';
  count?: Maybe<Scalars['Int']>;
};

export type RefurbishmentDetailsFilter = {
  and?: InputMaybe<Array<InputMaybe<RefurbishmentDetailsFilter>>>;
  has?: InputMaybe<Array<InputMaybe<RefurbishmentDetailsHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  isRequired?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<RefurbishmentDetailsFilter>;
  or?: InputMaybe<Array<InputMaybe<RefurbishmentDetailsFilter>>>;
};

export enum RefurbishmentDetailsHasFilter {
  IsRequired = 'isRequired',
  Lead = 'lead',
  Requests = 'requests'
}

export type RefurbishmentDetailsPatch = {
  isRequired?: InputMaybe<Scalars['Boolean']>;
  lead?: InputMaybe<LeadRef>;
  requests?: InputMaybe<Array<InputMaybe<RefurbishmentRequestRef>>>;
};

export type RefurbishmentDetailsRef = {
  id?: InputMaybe<Scalars['ID']>;
  isRequired?: InputMaybe<Scalars['Boolean']>;
  lead?: InputMaybe<LeadRef>;
  requests?: InputMaybe<Array<InputMaybe<RefurbishmentRequestRef>>>;
};

export type RefurbishmentItem = {
  __typename?: 'RefurbishmentItem';
  description?: Maybe<Scalars['String']>;
  expectedBuyingPrice?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  installationProofUrl?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  product: Product;
  quantity?: Maybe<Scalars['Int']>;
  refurbishmentProofUrl?: Maybe<Scalars['String']>;
  status?: Maybe<RefurbishmentStatus>;
};


export type RefurbishmentItemProductArgs = {
  filter?: InputMaybe<ProductFilter>;
};

export type RefurbishmentItemAggregateResult = {
  __typename?: 'RefurbishmentItemAggregateResult';
  count?: Maybe<Scalars['Int']>;
  descriptionMax?: Maybe<Scalars['String']>;
  descriptionMin?: Maybe<Scalars['String']>;
  expectedBuyingPriceAvg?: Maybe<Scalars['Float']>;
  expectedBuyingPriceMax?: Maybe<Scalars['Int']>;
  expectedBuyingPriceMin?: Maybe<Scalars['Int']>;
  expectedBuyingPriceSum?: Maybe<Scalars['Int']>;
  installationProofUrlMax?: Maybe<Scalars['String']>;
  installationProofUrlMin?: Maybe<Scalars['String']>;
  priceAvg?: Maybe<Scalars['Float']>;
  priceMax?: Maybe<Scalars['Int']>;
  priceMin?: Maybe<Scalars['Int']>;
  priceSum?: Maybe<Scalars['Int']>;
  quantityAvg?: Maybe<Scalars['Float']>;
  quantityMax?: Maybe<Scalars['Int']>;
  quantityMin?: Maybe<Scalars['Int']>;
  quantitySum?: Maybe<Scalars['Int']>;
  refurbishmentProofUrlMax?: Maybe<Scalars['String']>;
  refurbishmentProofUrlMin?: Maybe<Scalars['String']>;
};

export type RefurbishmentItemFilter = {
  and?: InputMaybe<Array<InputMaybe<RefurbishmentItemFilter>>>;
  has?: InputMaybe<Array<InputMaybe<RefurbishmentItemHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<RefurbishmentItemFilter>;
  or?: InputMaybe<Array<InputMaybe<RefurbishmentItemFilter>>>;
};

export enum RefurbishmentItemHasFilter {
  Description = 'description',
  ExpectedBuyingPrice = 'expectedBuyingPrice',
  InstallationProofUrl = 'installationProofUrl',
  Price = 'price',
  Product = 'product',
  Quantity = 'quantity',
  RefurbishmentProofUrl = 'refurbishmentProofUrl',
  Status = 'status'
}

export type RefurbishmentItemOrder = {
  asc?: InputMaybe<RefurbishmentItemOrderable>;
  desc?: InputMaybe<RefurbishmentItemOrderable>;
  then?: InputMaybe<RefurbishmentItemOrder>;
};

export enum RefurbishmentItemOrderable {
  Description = 'description',
  ExpectedBuyingPrice = 'expectedBuyingPrice',
  InstallationProofUrl = 'installationProofUrl',
  Price = 'price',
  Quantity = 'quantity',
  RefurbishmentProofUrl = 'refurbishmentProofUrl'
}

export type RefurbishmentItemPatch = {
  description?: InputMaybe<Scalars['String']>;
  expectedBuyingPrice?: InputMaybe<Scalars['Int']>;
  installationProofUrl?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  product?: InputMaybe<ProductRef>;
  quantity?: InputMaybe<Scalars['Int']>;
  refurbishmentProofUrl?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<RefurbishmentStatus>;
};

export type RefurbishmentItemRef = {
  description?: InputMaybe<Scalars['String']>;
  expectedBuyingPrice?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  installationProofUrl?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  product?: InputMaybe<ProductRef>;
  quantity?: InputMaybe<Scalars['Int']>;
  refurbishmentProofUrl?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<RefurbishmentStatus>;
};

export type RefurbishmentRequest = {
  __typename?: 'RefurbishmentRequest';
  createdAt?: Maybe<Scalars['DateTime']>;
  hasTransportationCharge?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  issue?: Maybe<Issue>;
  items?: Maybe<Array<Maybe<RefurbishmentItem>>>;
  itemsAggregate?: Maybe<RefurbishmentItemAggregateResult>;
  purchase?: Maybe<Purchase>;
  raisedBy?: Maybe<User>;
  refurbishmentBeneficiary?: Maybe<RefurbishmentBeneficiary>;
  refurbishmentDetails?: Maybe<RefurbishmentDetails>;
  requestStatus?: Maybe<RefurbishmentStatus>;
  transportationCharge?: Maybe<Scalars['Int']>;
};


export type RefurbishmentRequestIssueArgs = {
  filter?: InputMaybe<IssueFilter>;
};


export type RefurbishmentRequestItemsArgs = {
  filter?: InputMaybe<RefurbishmentItemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<RefurbishmentItemOrder>;
};


export type RefurbishmentRequestItemsAggregateArgs = {
  filter?: InputMaybe<RefurbishmentItemFilter>;
};


export type RefurbishmentRequestPurchaseArgs = {
  filter?: InputMaybe<PurchaseFilter>;
};


export type RefurbishmentRequestRaisedByArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type RefurbishmentRequestRefurbishmentBeneficiaryArgs = {
  filter?: InputMaybe<RefurbishmentBeneficiaryFilter>;
};


export type RefurbishmentRequestRefurbishmentDetailsArgs = {
  filter?: InputMaybe<RefurbishmentDetailsFilter>;
};

export type RefurbishmentRequestAggregateResult = {
  __typename?: 'RefurbishmentRequestAggregateResult';
  count?: Maybe<Scalars['Int']>;
  createdAtMax?: Maybe<Scalars['DateTime']>;
  createdAtMin?: Maybe<Scalars['DateTime']>;
  transportationChargeAvg?: Maybe<Scalars['Float']>;
  transportationChargeMax?: Maybe<Scalars['Int']>;
  transportationChargeMin?: Maybe<Scalars['Int']>;
  transportationChargeSum?: Maybe<Scalars['Int']>;
};

export type RefurbishmentRequestFilter = {
  and?: InputMaybe<Array<InputMaybe<RefurbishmentRequestFilter>>>;
  has?: InputMaybe<Array<InputMaybe<RefurbishmentRequestHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<RefurbishmentRequestFilter>;
  or?: InputMaybe<Array<InputMaybe<RefurbishmentRequestFilter>>>;
};

export enum RefurbishmentRequestHasFilter {
  CreatedAt = 'createdAt',
  HasTransportationCharge = 'hasTransportationCharge',
  Issue = 'issue',
  Items = 'items',
  Purchase = 'purchase',
  RaisedBy = 'raisedBy',
  RefurbishmentBeneficiary = 'refurbishmentBeneficiary',
  RefurbishmentDetails = 'refurbishmentDetails',
  RequestStatus = 'requestStatus',
  TransportationCharge = 'transportationCharge'
}

export type RefurbishmentRequestOrder = {
  asc?: InputMaybe<RefurbishmentRequestOrderable>;
  desc?: InputMaybe<RefurbishmentRequestOrderable>;
  then?: InputMaybe<RefurbishmentRequestOrder>;
};

export enum RefurbishmentRequestOrderable {
  CreatedAt = 'createdAt',
  TransportationCharge = 'transportationCharge'
}

export type RefurbishmentRequestPatch = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  hasTransportationCharge?: InputMaybe<Scalars['Boolean']>;
  issue?: InputMaybe<IssueRef>;
  items?: InputMaybe<Array<InputMaybe<RefurbishmentItemRef>>>;
  purchase?: InputMaybe<PurchaseRef>;
  raisedBy?: InputMaybe<UserRef>;
  refurbishmentBeneficiary?: InputMaybe<RefurbishmentBeneficiaryRef>;
  refurbishmentDetails?: InputMaybe<RefurbishmentDetailsRef>;
  requestStatus?: InputMaybe<RefurbishmentStatus>;
  transportationCharge?: InputMaybe<Scalars['Int']>;
};

export type RefurbishmentRequestRef = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  hasTransportationCharge?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  issue?: InputMaybe<IssueRef>;
  items?: InputMaybe<Array<InputMaybe<RefurbishmentItemRef>>>;
  purchase?: InputMaybe<PurchaseRef>;
  raisedBy?: InputMaybe<UserRef>;
  refurbishmentBeneficiary?: InputMaybe<RefurbishmentBeneficiaryRef>;
  refurbishmentDetails?: InputMaybe<RefurbishmentDetailsRef>;
  requestStatus?: InputMaybe<RefurbishmentStatus>;
  transportationCharge?: InputMaybe<Scalars['Int']>;
};

export enum RefurbishmentStatus {
  Approved = 'APPROVED',
  Installed = 'INSTALLED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED'
}

export type ReportFilters = {
  end?: InputMaybe<Scalars['DateTime']>;
  regState?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['DateTime']>;
};

export type SmsLogs = {
  __typename?: 'SMSLogs';
  createdAt?: Maybe<Scalars['DateTime']>;
  invoice?: Maybe<PaymentInvoices>;
  response?: Maybe<Scalars['String']>;
  status?: Maybe<TaskStatus>;
};


export type SmsLogsInvoiceArgs = {
  filter?: InputMaybe<PaymentInvoicesFilter>;
};

export type SmsLogsAggregateResult = {
  __typename?: 'SMSLogsAggregateResult';
  count?: Maybe<Scalars['Int']>;
  createdAtMax?: Maybe<Scalars['DateTime']>;
  createdAtMin?: Maybe<Scalars['DateTime']>;
  responseMax?: Maybe<Scalars['String']>;
  responseMin?: Maybe<Scalars['String']>;
};

export type SmsLogsFilter = {
  and?: InputMaybe<Array<InputMaybe<SmsLogsFilter>>>;
  has?: InputMaybe<Array<InputMaybe<SmsLogsHasFilter>>>;
  not?: InputMaybe<SmsLogsFilter>;
  or?: InputMaybe<Array<InputMaybe<SmsLogsFilter>>>;
};

export enum SmsLogsHasFilter {
  CreatedAt = 'createdAt',
  Invoice = 'invoice',
  Response = 'response',
  Status = 'status'
}

export type SmsLogsOrder = {
  asc?: InputMaybe<SmsLogsOrderable>;
  desc?: InputMaybe<SmsLogsOrderable>;
  then?: InputMaybe<SmsLogsOrder>;
};

export enum SmsLogsOrderable {
  CreatedAt = 'createdAt',
  Response = 'response'
}

export type SmsLogsPatch = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  invoice?: InputMaybe<PaymentInvoicesRef>;
  response?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TaskStatus>;
};

export type SmsLogsRef = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  invoice?: InputMaybe<PaymentInvoicesRef>;
  response?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TaskStatus>;
};

export enum SelectTypeOfDate {
  EnquiryCreatedDateRange = 'ENQUIRY_CREATED_DATE_RANGE',
  FollowUpDateRange = 'FOLLOW_UP_DATE_RANGE',
  LastUpdatedDateRange = 'LAST_UPDATED_DATE_RANGE',
  LastVisitDateRange = 'LAST_VISIT_DATE_RANGE'
}

export type SendSmsToCustomerResponse = {
  __typename?: 'SendSmsToCustomerResponse';
  invoice?: Maybe<PaymentInvoices>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};


export type SendSmsToCustomerResponseInvoiceArgs = {
  filter?: InputMaybe<PaymentInvoicesFilter>;
};

export type SendSmsToCustomerResponseAggregateResult = {
  __typename?: 'SendSmsToCustomerResponseAggregateResult';
  count?: Maybe<Scalars['Int']>;
  messageMax?: Maybe<Scalars['String']>;
  messageMin?: Maybe<Scalars['String']>;
};

export type SendSmsToCustomerResponseFilter = {
  and?: InputMaybe<Array<InputMaybe<SendSmsToCustomerResponseFilter>>>;
  has?: InputMaybe<Array<InputMaybe<SendSmsToCustomerResponseHasFilter>>>;
  not?: InputMaybe<SendSmsToCustomerResponseFilter>;
  or?: InputMaybe<Array<InputMaybe<SendSmsToCustomerResponseFilter>>>;
};

export enum SendSmsToCustomerResponseHasFilter {
  Invoice = 'invoice',
  Message = 'message',
  Success = 'success'
}

export type SendSmsToCustomerResponseOrder = {
  asc?: InputMaybe<SendSmsToCustomerResponseOrderable>;
  desc?: InputMaybe<SendSmsToCustomerResponseOrderable>;
  then?: InputMaybe<SendSmsToCustomerResponseOrder>;
};

export enum SendSmsToCustomerResponseOrderable {
  Message = 'message'
}

export type SendSmsToCustomerResponsePatch = {
  invoice?: InputMaybe<PaymentInvoicesRef>;
  message?: InputMaybe<Scalars['String']>;
  success?: InputMaybe<Scalars['Boolean']>;
};

export type SendSmsToCustomerResponseRef = {
  invoice?: InputMaybe<PaymentInvoicesRef>;
  message?: InputMaybe<Scalars['String']>;
  success?: InputMaybe<Scalars['Boolean']>;
};

export enum SparePart {
  Battery = 'BATTERY',
  Engine = 'ENGINE',
  Hood = 'HOOD',
  Others = 'OTHERS',
  PairOfBackTyre_12X28 = 'PAIR_OF_BACK_TYRE_12X28',
  PairOfBackTyre_13X28 = 'PAIR_OF_BACK_TYRE_13X28',
  PairOfBackTyre_14X28 = 'PAIR_OF_BACK_TYRE_14X28',
  PairOfFrontTyre_6X16 = 'PAIR_OF_FRONT_TYRE_6X16',
  PairOfFrontTyre_7X16 = 'PAIR_OF_FRONT_TYRE_7X16'
}

export type StateCodeWithRegNumber = {
  __typename?: 'StateCodeWithRegNumber';
  RTOCode?: Maybe<Scalars['String']>;
  districts?: Maybe<Array<Maybe<District>>>;
  districtsAggregate?: Maybe<DistrictAggregateResult>;
  id: Scalars['ID'];
  state: Scalars['String'];
  tehsils?: Maybe<Array<Maybe<Tehsil>>>;
  tehsilsAggregate?: Maybe<TehsilAggregateResult>;
};


export type StateCodeWithRegNumberDistrictsArgs = {
  filter?: InputMaybe<DistrictFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DistrictOrder>;
};


export type StateCodeWithRegNumberDistrictsAggregateArgs = {
  filter?: InputMaybe<DistrictFilter>;
};


export type StateCodeWithRegNumberTehsilsArgs = {
  filter?: InputMaybe<TehsilFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<TehsilOrder>;
};


export type StateCodeWithRegNumberTehsilsAggregateArgs = {
  filter?: InputMaybe<TehsilFilter>;
};

export type StateCodeWithRegNumberAggregateResult = {
  __typename?: 'StateCodeWithRegNumberAggregateResult';
  RTOCodeMax?: Maybe<Scalars['String']>;
  RTOCodeMin?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  stateMax?: Maybe<Scalars['String']>;
  stateMin?: Maybe<Scalars['String']>;
};

export type StateCodeWithRegNumberFilter = {
  and?: InputMaybe<Array<InputMaybe<StateCodeWithRegNumberFilter>>>;
  has?: InputMaybe<Array<InputMaybe<StateCodeWithRegNumberHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<StateCodeWithRegNumberFilter>;
  or?: InputMaybe<Array<InputMaybe<StateCodeWithRegNumberFilter>>>;
  state?: InputMaybe<StringFullTextFilter_StringHashFilter_StringTermFilter>;
};

export enum StateCodeWithRegNumberHasFilter {
  RtoCode = 'RTOCode',
  Districts = 'districts',
  State = 'state',
  Tehsils = 'tehsils'
}

export type StateCodeWithRegNumberOrder = {
  asc?: InputMaybe<StateCodeWithRegNumberOrderable>;
  desc?: InputMaybe<StateCodeWithRegNumberOrderable>;
  then?: InputMaybe<StateCodeWithRegNumberOrder>;
};

export enum StateCodeWithRegNumberOrderable {
  RtoCode = 'RTOCode',
  State = 'state'
}

export type StateCodeWithRegNumberPatch = {
  RTOCode?: InputMaybe<Scalars['String']>;
  districts?: InputMaybe<Array<InputMaybe<DistrictRef>>>;
  tehsils?: InputMaybe<Array<InputMaybe<TehsilRef>>>;
};

export type StateCodeWithRegNumberRef = {
  RTOCode?: InputMaybe<Scalars['String']>;
  districts?: InputMaybe<Array<InputMaybe<DistrictRef>>>;
  id?: InputMaybe<Scalars['ID']>;
  state?: InputMaybe<Scalars['String']>;
  tehsils?: InputMaybe<Array<InputMaybe<TehsilRef>>>;
};

export type StatusAggregate = {
  __typename?: 'StatusAggregate';
  count?: Maybe<Scalars['Int']>;
  status?: Maybe<LeadStatus>;
};

export type StatusAggregateAggregateResult = {
  __typename?: 'StatusAggregateAggregateResult';
  count?: Maybe<Scalars['Int']>;
  countAvg?: Maybe<Scalars['Float']>;
  countMax?: Maybe<Scalars['Int']>;
  countMin?: Maybe<Scalars['Int']>;
  countSum?: Maybe<Scalars['Int']>;
};

export type StatusAggregateFilter = {
  and?: InputMaybe<Array<InputMaybe<StatusAggregateFilter>>>;
  has?: InputMaybe<Array<InputMaybe<StatusAggregateHasFilter>>>;
  not?: InputMaybe<StatusAggregateFilter>;
  or?: InputMaybe<Array<InputMaybe<StatusAggregateFilter>>>;
};

export enum StatusAggregateHasFilter {
  Count = 'count',
  Status = 'status'
}

export type StatusAggregateOrder = {
  asc?: InputMaybe<StatusAggregateOrderable>;
  desc?: InputMaybe<StatusAggregateOrderable>;
  then?: InputMaybe<StatusAggregateOrder>;
};

export enum StatusAggregateOrderable {
  Count = 'count'
}

export type StatusAggregatePatch = {
  count?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<LeadStatus>;
};

export type StatusAggregateRef = {
  count?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<LeadStatus>;
};

export enum StatusOfEnquiry {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export type StringExactFilter = {
  between?: InputMaybe<StringRange>;
  eq?: InputMaybe<Scalars['String']>;
  ge?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  le?: InputMaybe<Scalars['String']>;
  lt?: InputMaybe<Scalars['String']>;
};

export type StringFullTextFilter = {
  alloftext?: InputMaybe<Scalars['String']>;
  anyoftext?: InputMaybe<Scalars['String']>;
};

export type StringFullTextFilter_StringHashFilter = {
  alloftext?: InputMaybe<Scalars['String']>;
  anyoftext?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type StringFullTextFilter_StringHashFilter_StringRegExpFilter = {
  alloftext?: InputMaybe<Scalars['String']>;
  anyoftext?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regexp?: InputMaybe<Scalars['String']>;
};

export type StringFullTextFilter_StringHashFilter_StringRegExpFilter_StringTermFilter = {
  allofterms?: InputMaybe<Scalars['String']>;
  alloftext?: InputMaybe<Scalars['String']>;
  anyofterms?: InputMaybe<Scalars['String']>;
  anyoftext?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regexp?: InputMaybe<Scalars['String']>;
};

export type StringFullTextFilter_StringHashFilter_StringTermFilter = {
  allofterms?: InputMaybe<Scalars['String']>;
  alloftext?: InputMaybe<Scalars['String']>;
  anyofterms?: InputMaybe<Scalars['String']>;
  anyoftext?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type StringFullTextFilter_StringRegExpFilter = {
  alloftext?: InputMaybe<Scalars['String']>;
  anyoftext?: InputMaybe<Scalars['String']>;
  regexp?: InputMaybe<Scalars['String']>;
};

export type StringFullTextFilter_StringTermFilter = {
  allofterms?: InputMaybe<Scalars['String']>;
  alloftext?: InputMaybe<Scalars['String']>;
  anyofterms?: InputMaybe<Scalars['String']>;
  anyoftext?: InputMaybe<Scalars['String']>;
};

export type StringHashFilter = {
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type StringHashFilter_StringRegExpFilter_StringTermFilter = {
  allofterms?: InputMaybe<Scalars['String']>;
  anyofterms?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regexp?: InputMaybe<Scalars['String']>;
};

export type StringRange = {
  max: Scalars['String'];
  min: Scalars['String'];
};

export type StringRegExpFilter = {
  regexp?: InputMaybe<Scalars['String']>;
};

export type StringRegExpFilter_StringTermFilter = {
  allofterms?: InputMaybe<Scalars['String']>;
  anyofterms?: InputMaybe<Scalars['String']>;
  regexp?: InputMaybe<Scalars['String']>;
};

export type StringTermFilter = {
  allofterms?: InputMaybe<Scalars['String']>;
  anyofterms?: InputMaybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  aggregateAdminLeadStatusEvent?: Maybe<AdminLeadStatusEventAggregateResult>;
  aggregateLeadStatusEvent?: Maybe<LeadStatusEventAggregateResult>;
  aggregateMessage?: Maybe<MessageAggregateResult>;
  aggregateUser?: Maybe<UserAggregateResult>;
  getAdminLeadStatusEvent?: Maybe<AdminLeadStatusEvent>;
  getLeadStatusEvent?: Maybe<LeadStatusEvent>;
  getMessage?: Maybe<Message>;
  getUser?: Maybe<User>;
  queryAdminLeadStatusEvent?: Maybe<Array<Maybe<AdminLeadStatusEvent>>>;
  queryLeadStatusEvent?: Maybe<Array<Maybe<LeadStatusEvent>>>;
  queryMessage?: Maybe<Array<Maybe<Message>>>;
  queryUser?: Maybe<Array<Maybe<User>>>;
};


export type SubscriptionAggregateAdminLeadStatusEventArgs = {
  filter?: InputMaybe<AdminLeadStatusEventFilter>;
};


export type SubscriptionAggregateLeadStatusEventArgs = {
  filter?: InputMaybe<LeadStatusEventFilter>;
};


export type SubscriptionAggregateMessageArgs = {
  filter?: InputMaybe<MessageFilter>;
};


export type SubscriptionAggregateUserArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type SubscriptionGetAdminLeadStatusEventArgs = {
  id: Scalars['ID'];
};


export type SubscriptionGetLeadStatusEventArgs = {
  id: Scalars['ID'];
};


export type SubscriptionGetMessageArgs = {
  id: Scalars['ID'];
};


export type SubscriptionGetUserArgs = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type SubscriptionQueryAdminLeadStatusEventArgs = {
  filter?: InputMaybe<AdminLeadStatusEventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<AdminLeadStatusEventOrder>;
};


export type SubscriptionQueryLeadStatusEventArgs = {
  filter?: InputMaybe<LeadStatusEventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadStatusEventOrder>;
};


export type SubscriptionQueryMessageArgs = {
  filter?: InputMaybe<MessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<MessageOrder>;
};


export type SubscriptionQueryUserArgs = {
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<UserOrder>;
};

export type TjCentre = {
  __typename?: 'TJCentre';
  address?: Maybe<Scalars['String']>;
  center_image?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  district_id?: Maybe<Scalars['Int']>;
  district_name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  mobile?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  name_en?: Maybe<Scalars['String']>;
  name_hi?: Maybe<Scalars['String']>;
  name_mr?: Maybe<Scalars['String']>;
  name_ta?: Maybe<Scalars['String']>;
  name_te?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['Int']>;
  short_address?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  state_id?: Maybe<Scalars['Int']>;
  state_name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  tehsil_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type TjCentreAggregateResult = {
  __typename?: 'TJCentreAggregateResult';
  addressMax?: Maybe<Scalars['String']>;
  addressMin?: Maybe<Scalars['String']>;
  center_imageMax?: Maybe<Scalars['String']>;
  center_imageMin?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  created_atMax?: Maybe<Scalars['String']>;
  created_atMin?: Maybe<Scalars['String']>;
  district_idAvg?: Maybe<Scalars['Float']>;
  district_idMax?: Maybe<Scalars['Int']>;
  district_idMin?: Maybe<Scalars['Int']>;
  district_idSum?: Maybe<Scalars['Int']>;
  district_nameMax?: Maybe<Scalars['String']>;
  district_nameMin?: Maybe<Scalars['String']>;
  emailMax?: Maybe<Scalars['String']>;
  emailMin?: Maybe<Scalars['String']>;
  idAvg?: Maybe<Scalars['Float']>;
  idMax?: Maybe<Scalars['Int']>;
  idMin?: Maybe<Scalars['Int']>;
  idSum?: Maybe<Scalars['Int']>;
  latitudeAvg?: Maybe<Scalars['Float']>;
  latitudeMax?: Maybe<Scalars['Float']>;
  latitudeMin?: Maybe<Scalars['Float']>;
  latitudeSum?: Maybe<Scalars['Float']>;
  longitudeAvg?: Maybe<Scalars['Float']>;
  longitudeMax?: Maybe<Scalars['Float']>;
  longitudeMin?: Maybe<Scalars['Float']>;
  longitudeSum?: Maybe<Scalars['Float']>;
  mobileMax?: Maybe<Scalars['String']>;
  mobileMin?: Maybe<Scalars['String']>;
  nameMax?: Maybe<Scalars['String']>;
  nameMin?: Maybe<Scalars['String']>;
  name_enMax?: Maybe<Scalars['String']>;
  name_enMin?: Maybe<Scalars['String']>;
  name_hiMax?: Maybe<Scalars['String']>;
  name_hiMin?: Maybe<Scalars['String']>;
  name_mrMax?: Maybe<Scalars['String']>;
  name_mrMin?: Maybe<Scalars['String']>;
  name_taMax?: Maybe<Scalars['String']>;
  name_taMin?: Maybe<Scalars['String']>;
  name_teMax?: Maybe<Scalars['String']>;
  name_teMin?: Maybe<Scalars['String']>;
  postal_codeAvg?: Maybe<Scalars['Float']>;
  postal_codeMax?: Maybe<Scalars['Int']>;
  postal_codeMin?: Maybe<Scalars['Int']>;
  postal_codeSum?: Maybe<Scalars['Int']>;
  short_addressMax?: Maybe<Scalars['String']>;
  short_addressMin?: Maybe<Scalars['String']>;
  slugMax?: Maybe<Scalars['String']>;
  slugMin?: Maybe<Scalars['String']>;
  state_idAvg?: Maybe<Scalars['Float']>;
  state_idMax?: Maybe<Scalars['Int']>;
  state_idMin?: Maybe<Scalars['Int']>;
  state_idSum?: Maybe<Scalars['Int']>;
  state_nameMax?: Maybe<Scalars['String']>;
  state_nameMin?: Maybe<Scalars['String']>;
  statusAvg?: Maybe<Scalars['Float']>;
  statusMax?: Maybe<Scalars['Int']>;
  statusMin?: Maybe<Scalars['Int']>;
  statusSum?: Maybe<Scalars['Int']>;
  tehsil_idAvg?: Maybe<Scalars['Float']>;
  tehsil_idMax?: Maybe<Scalars['Int']>;
  tehsil_idMin?: Maybe<Scalars['Int']>;
  tehsil_idSum?: Maybe<Scalars['Int']>;
  updated_atMax?: Maybe<Scalars['String']>;
  updated_atMin?: Maybe<Scalars['String']>;
};

export type TjCentreFilter = {
  and?: InputMaybe<Array<InputMaybe<TjCentreFilter>>>;
  has?: InputMaybe<Array<InputMaybe<TjCentreHasFilter>>>;
  not?: InputMaybe<TjCentreFilter>;
  or?: InputMaybe<Array<InputMaybe<TjCentreFilter>>>;
};

export enum TjCentreHasFilter {
  Address = 'address',
  CenterImage = 'center_image',
  CreatedAt = 'created_at',
  DistrictId = 'district_id',
  DistrictName = 'district_name',
  Email = 'email',
  Id = 'id',
  Latitude = 'latitude',
  Longitude = 'longitude',
  Mobile = 'mobile',
  Name = 'name',
  NameEn = 'name_en',
  NameHi = 'name_hi',
  NameMr = 'name_mr',
  NameTa = 'name_ta',
  NameTe = 'name_te',
  PostalCode = 'postal_code',
  ShortAddress = 'short_address',
  Slug = 'slug',
  StateId = 'state_id',
  StateName = 'state_name',
  Status = 'status',
  TehsilId = 'tehsil_id',
  UpdatedAt = 'updated_at'
}

export type TjCentreOrder = {
  asc?: InputMaybe<TjCentreOrderable>;
  desc?: InputMaybe<TjCentreOrderable>;
  then?: InputMaybe<TjCentreOrder>;
};

export enum TjCentreOrderable {
  Address = 'address',
  CenterImage = 'center_image',
  CreatedAt = 'created_at',
  DistrictId = 'district_id',
  DistrictName = 'district_name',
  Email = 'email',
  Id = 'id',
  Latitude = 'latitude',
  Longitude = 'longitude',
  Mobile = 'mobile',
  Name = 'name',
  NameEn = 'name_en',
  NameHi = 'name_hi',
  NameMr = 'name_mr',
  NameTa = 'name_ta',
  NameTe = 'name_te',
  PostalCode = 'postal_code',
  ShortAddress = 'short_address',
  Slug = 'slug',
  StateId = 'state_id',
  StateName = 'state_name',
  Status = 'status',
  TehsilId = 'tehsil_id',
  UpdatedAt = 'updated_at'
}

export type TjCentrePatch = {
  address?: InputMaybe<Scalars['String']>;
  center_image?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['String']>;
  district_id?: InputMaybe<Scalars['Int']>;
  district_name?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_hi?: InputMaybe<Scalars['String']>;
  name_mr?: InputMaybe<Scalars['String']>;
  name_ta?: InputMaybe<Scalars['String']>;
  name_te?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['Int']>;
  short_address?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  state_id?: InputMaybe<Scalars['Int']>;
  state_name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Int']>;
  tehsil_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['String']>;
};

export type TjCentreRef = {
  address?: InputMaybe<Scalars['String']>;
  center_image?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['String']>;
  district_id?: InputMaybe<Scalars['Int']>;
  district_name?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_hi?: InputMaybe<Scalars['String']>;
  name_mr?: InputMaybe<Scalars['String']>;
  name_ta?: InputMaybe<Scalars['String']>;
  name_te?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['Int']>;
  short_address?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  state_id?: InputMaybe<Scalars['Int']>;
  state_name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Int']>;
  tehsil_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['String']>;
};

export type Task = {
  __typename?: 'Task';
  assignedTo?: Maybe<User>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isCompleted?: Maybe<Scalars['Boolean']>;
  leadStatusEvent: LeadStatusEvent;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};


export type TaskAssignedToArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type TaskLeadStatusEventArgs = {
  filter?: InputMaybe<LeadStatusEventFilter>;
};

export type TaskAggregateResult = {
  __typename?: 'TaskAggregateResult';
  completedAtMax?: Maybe<Scalars['DateTime']>;
  completedAtMin?: Maybe<Scalars['DateTime']>;
  count?: Maybe<Scalars['Int']>;
  createdAtMax?: Maybe<Scalars['DateTime']>;
  createdAtMin?: Maybe<Scalars['DateTime']>;
  subtitleMax?: Maybe<Scalars['String']>;
  subtitleMin?: Maybe<Scalars['String']>;
  titleMax?: Maybe<Scalars['String']>;
  titleMin?: Maybe<Scalars['String']>;
};

export type TaskFilter = {
  and?: InputMaybe<Array<InputMaybe<TaskFilter>>>;
  has?: InputMaybe<Array<InputMaybe<TaskHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<TaskFilter>;
  or?: InputMaybe<Array<InputMaybe<TaskFilter>>>;
};

export enum TaskHasFilter {
  AssignedTo = 'assignedTo',
  CompletedAt = 'completedAt',
  CreatedAt = 'createdAt',
  IsCompleted = 'isCompleted',
  LeadStatusEvent = 'leadStatusEvent',
  Subtitle = 'subtitle',
  Title = 'title'
}

export type TaskOrder = {
  asc?: InputMaybe<TaskOrderable>;
  desc?: InputMaybe<TaskOrderable>;
  then?: InputMaybe<TaskOrder>;
};

export enum TaskOrderable {
  CompletedAt = 'completedAt',
  CreatedAt = 'createdAt',
  Subtitle = 'subtitle',
  Title = 'title'
}

export type TaskPatch = {
  assignedTo?: InputMaybe<UserRef>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  leadStatusEvent?: InputMaybe<LeadStatusEventRef>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type TaskRef = {
  assignedTo?: InputMaybe<UserRef>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  leadStatusEvent?: InputMaybe<LeadStatusEventRef>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export enum TaskStatus {
  Failed = 'FAILED',
  Success = 'SUCCESS'
}

export type TaskStatus_Hash = {
  eq?: InputMaybe<TaskStatus>;
  in?: InputMaybe<Array<InputMaybe<TaskStatus>>>;
};

export type Tehsil = {
  __typename?: 'Tehsil';
  distId?: Maybe<Scalars['String']>;
  district?: Maybe<District>;
  id: Scalars['ID'];
  name: Scalars['String'];
  state?: Maybe<StateCodeWithRegNumber>;
  stateId?: Maybe<Scalars['String']>;
};


export type TehsilDistrictArgs = {
  filter?: InputMaybe<DistrictFilter>;
};


export type TehsilStateArgs = {
  filter?: InputMaybe<StateCodeWithRegNumberFilter>;
};

export type TehsilAggregateResult = {
  __typename?: 'TehsilAggregateResult';
  count?: Maybe<Scalars['Int']>;
  distIdMax?: Maybe<Scalars['String']>;
  distIdMin?: Maybe<Scalars['String']>;
  nameMax?: Maybe<Scalars['String']>;
  nameMin?: Maybe<Scalars['String']>;
  stateIdMax?: Maybe<Scalars['String']>;
  stateIdMin?: Maybe<Scalars['String']>;
};

export type TehsilFilter = {
  and?: InputMaybe<Array<InputMaybe<TehsilFilter>>>;
  has?: InputMaybe<Array<InputMaybe<TehsilHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<StringFullTextFilter_StringTermFilter>;
  not?: InputMaybe<TehsilFilter>;
  or?: InputMaybe<Array<InputMaybe<TehsilFilter>>>;
};

export enum TehsilHasFilter {
  DistId = 'distId',
  District = 'district',
  Name = 'name',
  State = 'state',
  StateId = 'stateId'
}

export type TehsilOrder = {
  asc?: InputMaybe<TehsilOrderable>;
  desc?: InputMaybe<TehsilOrderable>;
  then?: InputMaybe<TehsilOrder>;
};

export enum TehsilOrderable {
  DistId = 'distId',
  Name = 'name',
  StateId = 'stateId'
}

export type TehsilPatch = {
  distId?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<DistrictRef>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<StateCodeWithRegNumberRef>;
  stateId?: InputMaybe<Scalars['String']>;
};

export type TehsilRef = {
  distId?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<DistrictRef>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<StateCodeWithRegNumberRef>;
  stateId?: InputMaybe<Scalars['String']>;
};

export enum TentativePurchaseTime {
  Later = 'LATER',
  Within_15Days = 'WITHIN_15_DAYS',
  Within_30Days = 'WITHIN_30_DAYS'
}

export type TripExpense = {
  __typename?: 'TripExpense';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  expensePayment?: Maybe<Payment>;
  expenses?: Maybe<Array<Maybe<LeadExpense>>>;
  expensesAggregate?: Maybe<LeadExpenseAggregateResult>;
  id: Scalars['ID'];
  leads?: Maybe<Array<Maybe<Lead>>>;
  leadsAggregate?: Maybe<LeadAggregateResult>;
  remarksByFinance?: Maybe<Scalars['String']>;
  remarksByOps?: Maybe<Scalars['String']>;
  status?: Maybe<LeadExpenseStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<User>;
  updatedByFinance?: Maybe<User>;
  updatedByFinanceAt?: Maybe<Scalars['DateTime']>;
  updatedByOperations?: Maybe<User>;
  updatedByOperationsAt?: Maybe<Scalars['DateTime']>;
};


export type TripExpenseCreatedByArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type TripExpenseExpensePaymentArgs = {
  filter?: InputMaybe<PaymentFilter>;
};


export type TripExpenseExpensesArgs = {
  filter?: InputMaybe<LeadExpenseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadExpenseOrder>;
};


export type TripExpenseExpensesAggregateArgs = {
  filter?: InputMaybe<LeadExpenseFilter>;
};


export type TripExpenseLeadsArgs = {
  filter?: InputMaybe<LeadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadOrder>;
};


export type TripExpenseLeadsAggregateArgs = {
  filter?: InputMaybe<LeadFilter>;
};


export type TripExpenseUpdatedByArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type TripExpenseUpdatedByFinanceArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type TripExpenseUpdatedByOperationsArgs = {
  filter?: InputMaybe<UserFilter>;
};

export type TripExpenseAggregateResult = {
  __typename?: 'TripExpenseAggregateResult';
  count?: Maybe<Scalars['Int']>;
  createdAtMax?: Maybe<Scalars['DateTime']>;
  createdAtMin?: Maybe<Scalars['DateTime']>;
  remarksByFinanceMax?: Maybe<Scalars['String']>;
  remarksByFinanceMin?: Maybe<Scalars['String']>;
  remarksByOpsMax?: Maybe<Scalars['String']>;
  remarksByOpsMin?: Maybe<Scalars['String']>;
  updatedAtMax?: Maybe<Scalars['DateTime']>;
  updatedAtMin?: Maybe<Scalars['DateTime']>;
  updatedByFinanceAtMax?: Maybe<Scalars['DateTime']>;
  updatedByFinanceAtMin?: Maybe<Scalars['DateTime']>;
  updatedByOperationsAtMax?: Maybe<Scalars['DateTime']>;
  updatedByOperationsAtMin?: Maybe<Scalars['DateTime']>;
};

export type TripExpenseFilter = {
  and?: InputMaybe<Array<InputMaybe<TripExpenseFilter>>>;
  has?: InputMaybe<Array<InputMaybe<TripExpenseHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<TripExpenseFilter>;
  or?: InputMaybe<Array<InputMaybe<TripExpenseFilter>>>;
  status?: InputMaybe<LeadExpenseStatus_Hash>;
};

export enum TripExpenseHasFilter {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  ExpensePayment = 'expensePayment',
  Expenses = 'expenses',
  Leads = 'leads',
  RemarksByFinance = 'remarksByFinance',
  RemarksByOps = 'remarksByOps',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  UpdatedBy = 'updatedBy',
  UpdatedByFinance = 'updatedByFinance',
  UpdatedByFinanceAt = 'updatedByFinanceAt',
  UpdatedByOperations = 'updatedByOperations',
  UpdatedByOperationsAt = 'updatedByOperationsAt'
}

export type TripExpenseOrder = {
  asc?: InputMaybe<TripExpenseOrderable>;
  desc?: InputMaybe<TripExpenseOrderable>;
  then?: InputMaybe<TripExpenseOrder>;
};

export enum TripExpenseOrderable {
  CreatedAt = 'createdAt',
  RemarksByFinance = 'remarksByFinance',
  RemarksByOps = 'remarksByOps',
  UpdatedAt = 'updatedAt',
  UpdatedByFinanceAt = 'updatedByFinanceAt',
  UpdatedByOperationsAt = 'updatedByOperationsAt'
}

export type TripExpensePatch = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserRef>;
  expensePayment?: InputMaybe<PaymentRef>;
  expenses?: InputMaybe<Array<InputMaybe<LeadExpenseRef>>>;
  leads?: InputMaybe<Array<InputMaybe<LeadRef>>>;
  remarksByFinance?: InputMaybe<Scalars['String']>;
  remarksByOps?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<LeadExpenseStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedBy?: InputMaybe<UserRef>;
  updatedByFinance?: InputMaybe<UserRef>;
  updatedByFinanceAt?: InputMaybe<Scalars['DateTime']>;
  updatedByOperations?: InputMaybe<UserRef>;
  updatedByOperationsAt?: InputMaybe<Scalars['DateTime']>;
};

export type TripExpenseRef = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<UserRef>;
  expensePayment?: InputMaybe<PaymentRef>;
  expenses?: InputMaybe<Array<InputMaybe<LeadExpenseRef>>>;
  id?: InputMaybe<Scalars['ID']>;
  leads?: InputMaybe<Array<InputMaybe<LeadRef>>>;
  remarksByFinance?: InputMaybe<Scalars['String']>;
  remarksByOps?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<LeadExpenseStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedBy?: InputMaybe<UserRef>;
  updatedByFinance?: InputMaybe<UserRef>;
  updatedByFinanceAt?: InputMaybe<Scalars['DateTime']>;
  updatedByOperations?: InputMaybe<UserRef>;
  updatedByOperationsAt?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateAccessoriesCheckInput = {
  filter: AccessoriesCheckFilter;
  remove?: InputMaybe<AccessoriesCheckPatch>;
  set?: InputMaybe<AccessoriesCheckPatch>;
};

export type UpdateAccessoriesCheckListWithStageInput = {
  filter: AccessoriesCheckListWithStageFilter;
  remove?: InputMaybe<AccessoriesCheckListWithStagePatch>;
  set?: InputMaybe<AccessoriesCheckListWithStagePatch>;
};

export type UpdateAccessoriesCheckListWithStagePayload = {
  __typename?: 'UpdateAccessoriesCheckListWithStagePayload';
  accessoriesCheckListWithStage?: Maybe<Array<Maybe<AccessoriesCheckListWithStage>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateAccessoriesCheckListWithStagePayloadAccessoriesCheckListWithStageArgs = {
  filter?: InputMaybe<AccessoriesCheckListWithStageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<AccessoriesCheckListWithStageOrder>;
};

export type UpdateAccessoriesCheckPayload = {
  __typename?: 'UpdateAccessoriesCheckPayload';
  accessoriesCheck?: Maybe<Array<Maybe<AccessoriesCheck>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateAccessoriesCheckPayloadAccessoriesCheckArgs = {
  filter?: InputMaybe<AccessoriesCheckFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type UpdateAccessoriesChecklistInput = {
  filter: AccessoriesChecklistFilter;
  remove?: InputMaybe<AccessoriesChecklistPatch>;
  set?: InputMaybe<AccessoriesChecklistPatch>;
};

export type UpdateAccessoriesChecklistPayload = {
  __typename?: 'UpdateAccessoriesChecklistPayload';
  accessoriesChecklist?: Maybe<Array<Maybe<AccessoriesChecklist>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateAccessoriesChecklistPayloadAccessoriesChecklistArgs = {
  filter?: InputMaybe<AccessoriesChecklistFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<AccessoriesChecklistOrder>;
};

export type UpdateActiveStateWithGstnInput = {
  filter: ActiveStateWithGstnFilter;
  remove?: InputMaybe<ActiveStateWithGstnPatch>;
  set?: InputMaybe<ActiveStateWithGstnPatch>;
};

export type UpdateActiveStateWithGstnPayload = {
  __typename?: 'UpdateActiveStateWithGSTNPayload';
  activeStateWithGSTN?: Maybe<Array<Maybe<ActiveStateWithGstn>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateActiveStateWithGstnPayloadActiveStateWithGstnArgs = {
  filter?: InputMaybe<ActiveStateWithGstnFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ActiveStateWithGstnOrder>;
};

export type UpdateAdminLeadStatusEventInput = {
  filter: AdminLeadStatusEventFilter;
  remove?: InputMaybe<AdminLeadStatusEventPatch>;
  set?: InputMaybe<AdminLeadStatusEventPatch>;
};

export type UpdateAdminLeadStatusEventPayload = {
  __typename?: 'UpdateAdminLeadStatusEventPayload';
  adminLeadStatusEvent?: Maybe<Array<Maybe<AdminLeadStatusEvent>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateAdminLeadStatusEventPayloadAdminLeadStatusEventArgs = {
  filter?: InputMaybe<AdminLeadStatusEventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<AdminLeadStatusEventOrder>;
};

export type UpdateAgencyInput = {
  filter: AgencyFilter;
  remove?: InputMaybe<AgencyPatch>;
  set?: InputMaybe<AgencyPatch>;
};

export type UpdateAgencyPayload = {
  __typename?: 'UpdateAgencyPayload';
  agency?: Maybe<Array<Maybe<Agency>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateAgencyPayloadAgencyArgs = {
  filter?: InputMaybe<AgencyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<AgencyOrder>;
};

export type UpdateAuctionHistoryInput = {
  filter: AuctionHistoryFilter;
  remove?: InputMaybe<AuctionHistoryPatch>;
  set?: InputMaybe<AuctionHistoryPatch>;
};

export type UpdateAuctionHistoryPayload = {
  __typename?: 'UpdateAuctionHistoryPayload';
  auctionHistory?: Maybe<Array<Maybe<AuctionHistory>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateAuctionHistoryPayloadAuctionHistoryArgs = {
  filter?: InputMaybe<AuctionHistoryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<AuctionHistoryOrder>;
};

export type UpdateBankAuctionLeadCountByNameInput = {
  filter: BankAuctionLeadCountByNameFilter;
  remove?: InputMaybe<BankAuctionLeadCountByNamePatch>;
  set?: InputMaybe<BankAuctionLeadCountByNamePatch>;
};

export type UpdateBankAuctionLeadCountByNamePayload = {
  __typename?: 'UpdateBankAuctionLeadCountByNamePayload';
  bankAuctionLeadCountByName?: Maybe<Array<Maybe<BankAuctionLeadCountByName>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateBankAuctionLeadCountByNamePayloadBankAuctionLeadCountByNameArgs = {
  filter?: InputMaybe<BankAuctionLeadCountByNameFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<BankAuctionLeadCountByNameOrder>;
};

export type UpdateBankInput = {
  filter: BankFilter;
  remove?: InputMaybe<BankPatch>;
  set?: InputMaybe<BankPatch>;
};

export type UpdateBankPayload = {
  __typename?: 'UpdateBankPayload';
  bank?: Maybe<Array<Maybe<Bank>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateBankPayloadBankArgs = {
  filter?: InputMaybe<BankFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<BankOrder>;
};

export type UpdateBookingInput = {
  filter: BookingFilter;
  remove?: InputMaybe<BookingPatch>;
  set?: InputMaybe<BookingPatch>;
};

export type UpdateBookingPayload = {
  __typename?: 'UpdateBookingPayload';
  booking?: Maybe<Array<Maybe<Booking>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateBookingPayloadBookingArgs = {
  filter?: InputMaybe<BookingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<BookingOrder>;
};

export type UpdateBookingPaymentInput = {
  filter: BookingPaymentFilter;
  remove?: InputMaybe<BookingPaymentPatch>;
  set?: InputMaybe<BookingPaymentPatch>;
};

export type UpdateBookingPaymentPayload = {
  __typename?: 'UpdateBookingPaymentPayload';
  bookingPayment?: Maybe<Array<Maybe<BookingPayment>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateBookingPaymentPayloadBookingPaymentArgs = {
  filter?: InputMaybe<BookingPaymentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<BookingPaymentOrder>;
};

export type UpdateBrandInput = {
  filter: BrandFilter;
  remove?: InputMaybe<BrandPatch>;
  set?: InputMaybe<BrandPatch>;
};

export type UpdateBrandPayload = {
  __typename?: 'UpdateBrandPayload';
  brand?: Maybe<Array<Maybe<Brand>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateBrandPayloadBrandArgs = {
  filter?: InputMaybe<BrandFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<BrandOrder>;
};

export type UpdateBulkApprovalResponseInput = {
  filter: BulkApprovalResponseFilter;
  remove?: InputMaybe<BulkApprovalResponsePatch>;
  set?: InputMaybe<BulkApprovalResponsePatch>;
};

export type UpdateBulkApprovalResponsePayload = {
  __typename?: 'UpdateBulkApprovalResponsePayload';
  bulkApprovalResponse?: Maybe<Array<Maybe<BulkApprovalResponse>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateBulkApprovalResponsePayloadBulkApprovalResponseArgs = {
  filter?: InputMaybe<BulkApprovalResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<BulkApprovalResponseOrder>;
};

export type UpdateCenterlizeLocationDistrcitsResponseInput = {
  filter: CenterlizeLocationDistrcitsResponseFilter;
  remove?: InputMaybe<CenterlizeLocationDistrcitsResponsePatch>;
  set?: InputMaybe<CenterlizeLocationDistrcitsResponsePatch>;
};

export type UpdateCenterlizeLocationDistrcitsResponsePayload = {
  __typename?: 'UpdateCenterlizeLocationDistrcitsResponsePayload';
  centerlizeLocationDistrcitsResponse?: Maybe<Array<Maybe<CenterlizeLocationDistrcitsResponse>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateCenterlizeLocationDistrcitsResponsePayloadCenterlizeLocationDistrcitsResponseArgs = {
  filter?: InputMaybe<CenterlizeLocationDistrcitsResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CenterlizeLocationDistrcitsResponseOrder>;
};

export type UpdateCenterlizeLocationDistrictInput = {
  filter: CenterlizeLocationDistrictFilter;
  remove?: InputMaybe<CenterlizeLocationDistrictPatch>;
  set?: InputMaybe<CenterlizeLocationDistrictPatch>;
};

export type UpdateCenterlizeLocationDistrictPayload = {
  __typename?: 'UpdateCenterlizeLocationDistrictPayload';
  centerlizeLocationDistrict?: Maybe<Array<Maybe<CenterlizeLocationDistrict>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateCenterlizeLocationDistrictPayloadCenterlizeLocationDistrictArgs = {
  filter?: InputMaybe<CenterlizeLocationDistrictFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CenterlizeLocationDistrictOrder>;
};

export type UpdateCenterlizeLocationStatesInput = {
  filter: CenterlizeLocationStatesFilter;
  remove?: InputMaybe<CenterlizeLocationStatesPatch>;
  set?: InputMaybe<CenterlizeLocationStatesPatch>;
};

export type UpdateCenterlizeLocationStatesPayload = {
  __typename?: 'UpdateCenterlizeLocationStatesPayload';
  centerlizeLocationStates?: Maybe<Array<Maybe<CenterlizeLocationStates>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateCenterlizeLocationStatesPayloadCenterlizeLocationStatesArgs = {
  filter?: InputMaybe<CenterlizeLocationStatesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CenterlizeLocationStatesOrder>;
};

export type UpdateCenterlizeLocationStatesResponseInput = {
  filter: CenterlizeLocationStatesResponseFilter;
  remove?: InputMaybe<CenterlizeLocationStatesResponsePatch>;
  set?: InputMaybe<CenterlizeLocationStatesResponsePatch>;
};

export type UpdateCenterlizeLocationStatesResponsePayload = {
  __typename?: 'UpdateCenterlizeLocationStatesResponsePayload';
  centerlizeLocationStatesResponse?: Maybe<Array<Maybe<CenterlizeLocationStatesResponse>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateCenterlizeLocationStatesResponsePayloadCenterlizeLocationStatesResponseArgs = {
  filter?: InputMaybe<CenterlizeLocationStatesResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CenterlizeLocationStatesResponseOrder>;
};

export type UpdateCenterlizeLocationTehsilInput = {
  filter: CenterlizeLocationTehsilFilter;
  remove?: InputMaybe<CenterlizeLocationTehsilPatch>;
  set?: InputMaybe<CenterlizeLocationTehsilPatch>;
};

export type UpdateCenterlizeLocationTehsilPayload = {
  __typename?: 'UpdateCenterlizeLocationTehsilPayload';
  centerlizeLocationTehsil?: Maybe<Array<Maybe<CenterlizeLocationTehsil>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateCenterlizeLocationTehsilPayloadCenterlizeLocationTehsilArgs = {
  filter?: InputMaybe<CenterlizeLocationTehsilFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CenterlizeLocationTehsilOrder>;
};

export type UpdateCenterlizeLocationTehsilResponseInput = {
  filter: CenterlizeLocationTehsilResponseFilter;
  remove?: InputMaybe<CenterlizeLocationTehsilResponsePatch>;
  set?: InputMaybe<CenterlizeLocationTehsilResponsePatch>;
};

export type UpdateCenterlizeLocationTehsilResponsePayload = {
  __typename?: 'UpdateCenterlizeLocationTehsilResponsePayload';
  centerlizeLocationTehsilResponse?: Maybe<Array<Maybe<CenterlizeLocationTehsilResponse>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateCenterlizeLocationTehsilResponsePayloadCenterlizeLocationTehsilResponseArgs = {
  filter?: InputMaybe<CenterlizeLocationTehsilResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CenterlizeLocationTehsilResponseOrder>;
};

export type UpdateCentreAggregatesInput = {
  filter: CentreAggregatesFilter;
  remove?: InputMaybe<CentreAggregatesPatch>;
  set?: InputMaybe<CentreAggregatesPatch>;
};

export type UpdateCentreAggregatesPayload = {
  __typename?: 'UpdateCentreAggregatesPayload';
  centreAggregates?: Maybe<Array<Maybe<CentreAggregates>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateCentreAggregatesPayloadCentreAggregatesArgs = {
  filter?: InputMaybe<CentreAggregatesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CentreAggregatesOrder>;
};

export type UpdateCentreInput = {
  filter: CentreFilter;
  remove?: InputMaybe<CentrePatch>;
  set?: InputMaybe<CentrePatch>;
};

export type UpdateCentrePayload = {
  __typename?: 'UpdateCentrePayload';
  centre?: Maybe<Array<Maybe<Centre>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateCentrePayloadCentreArgs = {
  filter?: InputMaybe<CentreFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CentreOrder>;
};

export type UpdateCreateBulkLeadResponseInput = {
  filter: CreateBulkLeadResponseFilter;
  remove?: InputMaybe<CreateBulkLeadResponsePatch>;
  set?: InputMaybe<CreateBulkLeadResponsePatch>;
};

export type UpdateCreateBulkLeadResponsePayload = {
  __typename?: 'UpdateCreateBulkLeadResponsePayload';
  createBulkLeadResponse?: Maybe<Array<Maybe<CreateBulkLeadResponse>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateCreateBulkLeadResponsePayloadCreateBulkLeadResponseArgs = {
  filter?: InputMaybe<CreateBulkLeadResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CreateBulkLeadResponseOrder>;
};

export type UpdateCustomerInput = {
  filter: CustomerFilter;
  remove?: InputMaybe<CustomerPatch>;
  set?: InputMaybe<CustomerPatch>;
};

export type UpdateCustomerPayload = {
  __typename?: 'UpdateCustomerPayload';
  customer?: Maybe<Array<Maybe<Customer>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateCustomerPayloadCustomerArgs = {
  filter?: InputMaybe<CustomerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CustomerOrder>;
};

export type UpdateDealerInput = {
  filter: DealerFilter;
  remove?: InputMaybe<DealerPatch>;
  set?: InputMaybe<DealerPatch>;
};

export type UpdateDealerPayload = {
  __typename?: 'UpdateDealerPayload';
  dealer?: Maybe<Array<Maybe<Dealer>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateDealerPayloadDealerArgs = {
  filter?: InputMaybe<DealerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DealerOrder>;
};

export type UpdateDealerStanceInput = {
  filter: DealerStanceFilter;
  remove?: InputMaybe<DealerStancePatch>;
  set?: InputMaybe<DealerStancePatch>;
};

export type UpdateDealerStancePayload = {
  __typename?: 'UpdateDealerStancePayload';
  dealerStance?: Maybe<Array<Maybe<DealerStance>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateDealerStancePayloadDealerStanceArgs = {
  filter?: InputMaybe<DealerStanceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type UpdateDealershipDocumentInput = {
  filter: DealershipDocumentFilter;
  remove?: InputMaybe<DealershipDocumentPatch>;
  set?: InputMaybe<DealershipDocumentPatch>;
};

export type UpdateDealershipDocumentPayload = {
  __typename?: 'UpdateDealershipDocumentPayload';
  dealershipDocument?: Maybe<Array<Maybe<DealershipDocument>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateDealershipDocumentPayloadDealershipDocumentArgs = {
  filter?: InputMaybe<DealershipDocumentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DealershipDocumentOrder>;
};

export type UpdateDealershipLeadCountByPeNameInput = {
  filter: DealershipLeadCountByPeNameFilter;
  remove?: InputMaybe<DealershipLeadCountByPeNamePatch>;
  set?: InputMaybe<DealershipLeadCountByPeNamePatch>;
};

export type UpdateDealershipLeadCountByPeNamePayload = {
  __typename?: 'UpdateDealershipLeadCountByPENamePayload';
  dealershipLeadCountByPEName?: Maybe<Array<Maybe<DealershipLeadCountByPeName>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateDealershipLeadCountByPeNamePayloadDealershipLeadCountByPeNameArgs = {
  filter?: InputMaybe<DealershipLeadCountByPeNameFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DealershipLeadCountByPeNameOrder>;
};

export type UpdateDistrictInput = {
  filter: DistrictFilter;
  remove?: InputMaybe<DistrictPatch>;
  set?: InputMaybe<DistrictPatch>;
};

export type UpdateDistrictPayload = {
  __typename?: 'UpdateDistrictPayload';
  district?: Maybe<Array<Maybe<District>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateDistrictPayloadDistrictArgs = {
  filter?: InputMaybe<DistrictFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DistrictOrder>;
};

export type UpdateDocumentChecklistInput = {
  filter: DocumentChecklistFilter;
  remove?: InputMaybe<DocumentChecklistPatch>;
  set?: InputMaybe<DocumentChecklistPatch>;
};

export type UpdateDocumentChecklistPayload = {
  __typename?: 'UpdateDocumentChecklistPayload';
  documentChecklist?: Maybe<Array<Maybe<DocumentChecklist>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateDocumentChecklistPayloadDocumentChecklistArgs = {
  filter?: InputMaybe<DocumentChecklistFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DocumentChecklistOrder>;
};

export type UpdateDocumentInput = {
  filter: DocumentFilter;
  remove?: InputMaybe<DocumentPatch>;
  set?: InputMaybe<DocumentPatch>;
};

export type UpdateDocumentPayload = {
  __typename?: 'UpdateDocumentPayload';
  document?: Maybe<Array<Maybe<Document>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateDocumentPayloadDocumentArgs = {
  filter?: InputMaybe<DocumentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DocumentOrder>;
};

export type UpdateDocumentsCountInput = {
  filter: DocumentsCountFilter;
  remove?: InputMaybe<DocumentsCountPatch>;
  set?: InputMaybe<DocumentsCountPatch>;
};

export type UpdateDocumentsCountPayload = {
  __typename?: 'UpdateDocumentsCountPayload';
  documentsCount?: Maybe<Array<Maybe<DocumentsCount>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateDocumentsCountPayloadDocumentsCountArgs = {
  filter?: InputMaybe<DocumentsCountFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DocumentsCountOrder>;
};

export type UpdateDocumentsFollowupsInput = {
  filter: DocumentsFollowupsFilter;
  remove?: InputMaybe<DocumentsFollowupsPatch>;
  set?: InputMaybe<DocumentsFollowupsPatch>;
};

export type UpdateDocumentsFollowupsPayload = {
  __typename?: 'UpdateDocumentsFollowupsPayload';
  documentsFollowups?: Maybe<Array<Maybe<DocumentsFollowups>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateDocumentsFollowupsPayloadDocumentsFollowupsArgs = {
  filter?: InputMaybe<DocumentsFollowupsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DocumentsFollowupsOrder>;
};

export type UpdateDriverAggregatesInput = {
  filter: DriverAggregatesFilter;
  remove?: InputMaybe<DriverAggregatesPatch>;
  set?: InputMaybe<DriverAggregatesPatch>;
};

export type UpdateDriverAggregatesPayload = {
  __typename?: 'UpdateDriverAggregatesPayload';
  driverAggregates?: Maybe<Array<Maybe<DriverAggregates>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateDriverAggregatesPayloadDriverAggregatesArgs = {
  filter?: InputMaybe<DriverAggregatesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DriverAggregatesOrder>;
};

export type UpdateEnquiryAdherenceInput = {
  filter: EnquiryAdherenceFilter;
  remove?: InputMaybe<EnquiryAdherencePatch>;
  set?: InputMaybe<EnquiryAdherencePatch>;
};

export type UpdateEnquiryAdherencePayload = {
  __typename?: 'UpdateEnquiryAdherencePayload';
  enquiryAdherence?: Maybe<Array<Maybe<EnquiryAdherence>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateEnquiryAdherencePayloadEnquiryAdherenceArgs = {
  filter?: InputMaybe<EnquiryAdherenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<EnquiryAdherenceOrder>;
};

export type UpdateEnquiryAggByCentreInput = {
  filter: EnquiryAggByCentreFilter;
  remove?: InputMaybe<EnquiryAggByCentrePatch>;
  set?: InputMaybe<EnquiryAggByCentrePatch>;
};

export type UpdateEnquiryAggByCentrePayload = {
  __typename?: 'UpdateEnquiryAggByCentrePayload';
  enquiryAggByCentre?: Maybe<Array<Maybe<EnquiryAggByCentre>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateEnquiryAggByCentrePayloadEnquiryAggByCentreArgs = {
  filter?: InputMaybe<EnquiryAggByCentreFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<EnquiryAggByCentreOrder>;
};

export type UpdateEnquiryCloserAggInput = {
  filter: EnquiryCloserAggFilter;
  remove?: InputMaybe<EnquiryCloserAggPatch>;
  set?: InputMaybe<EnquiryCloserAggPatch>;
};

export type UpdateEnquiryCloserAggPayload = {
  __typename?: 'UpdateEnquiryCloserAggPayload';
  enquiryCloserAgg?: Maybe<Array<Maybe<EnquiryCloserAgg>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateEnquiryCloserAggPayloadEnquiryCloserAggArgs = {
  filter?: InputMaybe<EnquiryCloserAggFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<EnquiryCloserAggOrder>;
};

export type UpdateEnquiryClosureInput = {
  filter: EnquiryClosureFilter;
  remove?: InputMaybe<EnquiryClosurePatch>;
  set?: InputMaybe<EnquiryClosurePatch>;
};

export type UpdateEnquiryClosurePayload = {
  __typename?: 'UpdateEnquiryClosurePayload';
  enquiryClosure?: Maybe<Array<Maybe<EnquiryClosure>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateEnquiryClosurePayloadEnquiryClosureArgs = {
  filter?: InputMaybe<EnquiryClosureFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<EnquiryClosureOrder>;
};

export type UpdateEnquiryInput = {
  filter: EnquiryFilter;
  remove?: InputMaybe<EnquiryPatch>;
  set?: InputMaybe<EnquiryPatch>;
};

export type UpdateEnquiryPayload = {
  __typename?: 'UpdateEnquiryPayload';
  enquiry?: Maybe<Array<Maybe<Enquiry>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateEnquiryPayloadEnquiryArgs = {
  filter?: InputMaybe<EnquiryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<EnquiryOrder>;
};

export type UpdateFollowupInput = {
  filter: FollowupFilter;
  remove?: InputMaybe<FollowupPatch>;
  set?: InputMaybe<FollowupPatch>;
};

export type UpdateFollowupPayload = {
  __typename?: 'UpdateFollowupPayload';
  followup?: Maybe<Array<Maybe<Followup>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateFollowupPayloadFollowupArgs = {
  filter?: InputMaybe<FollowupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<FollowupOrder>;
};

export type UpdateIdByNameInput = {
  filter: IdByNameFilter;
  remove?: InputMaybe<IdByNamePatch>;
  set?: InputMaybe<IdByNamePatch>;
};

export type UpdateIdByNamePayload = {
  __typename?: 'UpdateIdByNamePayload';
  idByName?: Maybe<Array<Maybe<IdByName>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateIdByNamePayloadIdByNameArgs = {
  filter?: InputMaybe<IdByNameFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<IdByNameOrder>;
};

export type UpdateIdentificationDocumentInput = {
  filter: IdentificationDocumentFilter;
  remove?: InputMaybe<IdentificationDocumentPatch>;
  set?: InputMaybe<IdentificationDocumentPatch>;
};

export type UpdateIdentificationDocumentPayload = {
  __typename?: 'UpdateIdentificationDocumentPayload';
  identificationDocument?: Maybe<Array<Maybe<IdentificationDocument>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateIdentificationDocumentPayloadIdentificationDocumentArgs = {
  filter?: InputMaybe<IdentificationDocumentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<IdentificationDocumentOrder>;
};

export type UpdateIdsByNameForListingReponseInput = {
  filter: IdsByNameForListingReponseFilter;
  remove?: InputMaybe<IdsByNameForListingReponsePatch>;
  set?: InputMaybe<IdsByNameForListingReponsePatch>;
};

export type UpdateIdsByNameForListingReponsePayload = {
  __typename?: 'UpdateIdsByNameForListingReponsePayload';
  idsByNameForListingReponse?: Maybe<Array<Maybe<IdsByNameForListingReponse>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateIdsByNameForListingReponsePayloadIdsByNameForListingReponseArgs = {
  filter?: InputMaybe<IdsByNameForListingReponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<IdsByNameForListingReponseOrder>;
};

export type UpdateInventoryDetailsInput = {
  filter: InventoryDetailsFilter;
  remove?: InputMaybe<InventoryDetailsPatch>;
  set?: InputMaybe<InventoryDetailsPatch>;
};

export type UpdateInventoryDetailsPayload = {
  __typename?: 'UpdateInventoryDetailsPayload';
  inventoryDetails?: Maybe<Array<Maybe<InventoryDetails>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateInventoryDetailsPayloadInventoryDetailsArgs = {
  filter?: InputMaybe<InventoryDetailsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<InventoryDetailsOrder>;
};

export type UpdateIssueInput = {
  filter: IssueFilter;
  remove?: InputMaybe<IssuePatch>;
  set?: InputMaybe<IssuePatch>;
};

export type UpdateIssueItemInput = {
  filter: IssueItemFilter;
  remove?: InputMaybe<IssueItemPatch>;
  set?: InputMaybe<IssueItemPatch>;
};

export type UpdateIssueItemPayload = {
  __typename?: 'UpdateIssueItemPayload';
  issueItem?: Maybe<Array<Maybe<IssueItem>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateIssueItemPayloadIssueItemArgs = {
  filter?: InputMaybe<IssueItemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<IssueItemOrder>;
};

export type UpdateIssuePayload = {
  __typename?: 'UpdateIssuePayload';
  issue?: Maybe<Array<Maybe<Issue>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateIssuePayloadIssueArgs = {
  filter?: InputMaybe<IssueFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<IssueOrder>;
};

export type UpdateItemInventoryDetailsInput = {
  filter: ItemInventoryDetailsFilter;
  remove?: InputMaybe<ItemInventoryDetailsPatch>;
  set?: InputMaybe<ItemInventoryDetailsPatch>;
};

export type UpdateItemInventoryDetailsPayload = {
  __typename?: 'UpdateItemInventoryDetailsPayload';
  itemInventoryDetails?: Maybe<Array<Maybe<ItemInventoryDetails>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateItemInventoryDetailsPayloadItemInventoryDetailsArgs = {
  filter?: InputMaybe<ItemInventoryDetailsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ItemInventoryDetailsOrder>;
};

export type UpdateLeadCountByStatusInput = {
  filter: LeadCountByStatusFilter;
  remove?: InputMaybe<LeadCountByStatusPatch>;
  set?: InputMaybe<LeadCountByStatusPatch>;
};

export type UpdateLeadCountByStatusPayload = {
  __typename?: 'UpdateLeadCountByStatusPayload';
  leadCountByStatus?: Maybe<Array<Maybe<LeadCountByStatus>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateLeadCountByStatusPayloadLeadCountByStatusArgs = {
  filter?: InputMaybe<LeadCountByStatusFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadCountByStatusOrder>;
};

export type UpdateLeadDocumentsInput = {
  filter: LeadDocumentsFilter;
  remove?: InputMaybe<LeadDocumentsPatch>;
  set?: InputMaybe<LeadDocumentsPatch>;
};

export type UpdateLeadDocumentsPayload = {
  __typename?: 'UpdateLeadDocumentsPayload';
  leadDocuments?: Maybe<Array<Maybe<LeadDocuments>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateLeadDocumentsPayloadLeadDocumentsArgs = {
  filter?: InputMaybe<LeadDocumentsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadDocumentsOrder>;
};

export type UpdateLeadExpenseInput = {
  filter: LeadExpenseFilter;
  remove?: InputMaybe<LeadExpensePatch>;
  set?: InputMaybe<LeadExpensePatch>;
};

export type UpdateLeadExpensePayload = {
  __typename?: 'UpdateLeadExpensePayload';
  leadExpense?: Maybe<Array<Maybe<LeadExpense>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateLeadExpensePayloadLeadExpenseArgs = {
  filter?: InputMaybe<LeadExpenseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadExpenseOrder>;
};

export type UpdateLeadInput = {
  filter: LeadFilter;
  remove?: InputMaybe<LeadPatch>;
  set?: InputMaybe<LeadPatch>;
};

export type UpdateLeadPayload = {
  __typename?: 'UpdateLeadPayload';
  lead?: Maybe<Array<Maybe<Lead>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateLeadPayloadLeadArgs = {
  filter?: InputMaybe<LeadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadOrder>;
};

export type UpdateLeadStatusEventInput = {
  filter: LeadStatusEventFilter;
  remove?: InputMaybe<LeadStatusEventPatch>;
  set?: InputMaybe<LeadStatusEventPatch>;
};

export type UpdateLeadStatusEventPayload = {
  __typename?: 'UpdateLeadStatusEventPayload';
  leadStatusEvent?: Maybe<Array<Maybe<LeadStatusEvent>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateLeadStatusEventPayloadLeadStatusEventArgs = {
  filter?: InputMaybe<LeadStatusEventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadStatusEventOrder>;
};

export type UpdateLeadStatusFlowInput = {
  filter: LeadStatusFlowFilter;
  remove?: InputMaybe<LeadStatusFlowPatch>;
  set?: InputMaybe<LeadStatusFlowPatch>;
};

export type UpdateLeadStatusFlowPayload = {
  __typename?: 'UpdateLeadStatusFlowPayload';
  leadStatusFlow?: Maybe<Array<Maybe<LeadStatusFlow>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateLeadStatusFlowPayloadLeadStatusFlowArgs = {
  filter?: InputMaybe<LeadStatusFlowFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadStatusFlowOrder>;
};

export type UpdateLeadTimelineActionInput = {
  filter: LeadTimelineActionFilter;
  remove?: InputMaybe<LeadTimelineActionPatch>;
  set?: InputMaybe<LeadTimelineActionPatch>;
};

export type UpdateLeadTimelineActionPayload = {
  __typename?: 'UpdateLeadTimelineActionPayload';
  leadTimelineAction?: Maybe<Array<Maybe<LeadTimelineAction>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateLeadTimelineActionPayloadLeadTimelineActionArgs = {
  filter?: InputMaybe<LeadTimelineActionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadTimelineActionOrder>;
};

export type UpdateLeadTimelineStatusInput = {
  filter: LeadTimelineStatusFilter;
  remove?: InputMaybe<LeadTimelineStatusPatch>;
  set?: InputMaybe<LeadTimelineStatusPatch>;
};

export type UpdateLeadTimelineStatusPayload = {
  __typename?: 'UpdateLeadTimelineStatusPayload';
  leadTimelineStatus?: Maybe<Array<Maybe<LeadTimelineStatus>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateLeadTimelineStatusPayloadLeadTimelineStatusArgs = {
  filter?: InputMaybe<LeadTimelineStatusFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type UpdateLoanInput = {
  filter: LoanFilter;
  remove?: InputMaybe<LoanPatch>;
  set?: InputMaybe<LoanPatch>;
};

export type UpdateLoanPayload = {
  __typename?: 'UpdateLoanPayload';
  loan?: Maybe<Array<Maybe<Loan>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateLoanPayloadLoanArgs = {
  filter?: InputMaybe<LoanFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LoanOrder>;
};

export type UpdateLogTrackingInput = {
  filter: LogTrackingFilter;
  remove?: InputMaybe<LogTrackingPatch>;
  set?: InputMaybe<LogTrackingPatch>;
};

export type UpdateLogTrackingPayload = {
  __typename?: 'UpdateLogTrackingPayload';
  logTracking?: Maybe<Array<Maybe<LogTracking>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateLogTrackingPayloadLogTrackingArgs = {
  filter?: InputMaybe<LogTrackingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LogTrackingOrder>;
};

export type UpdateMarkSoldResponseInput = {
  filter: MarkSoldResponseFilter;
  remove?: InputMaybe<MarkSoldResponsePatch>;
  set?: InputMaybe<MarkSoldResponsePatch>;
};

export type UpdateMarkSoldResponsePayload = {
  __typename?: 'UpdateMarkSoldResponsePayload';
  markSoldResponse?: Maybe<Array<Maybe<MarkSoldResponse>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateMarkSoldResponsePayloadMarkSoldResponseArgs = {
  filter?: InputMaybe<MarkSoldResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<MarkSoldResponseOrder>;
};

export type UpdateMessageInput = {
  filter: MessageFilter;
  remove?: InputMaybe<MessagePatch>;
  set?: InputMaybe<MessagePatch>;
};

export type UpdateMessagePayload = {
  __typename?: 'UpdateMessagePayload';
  message?: Maybe<Array<Maybe<Message>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateMessagePayloadMessageArgs = {
  filter?: InputMaybe<MessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<MessageOrder>;
};

export type UpdateModelByMakeInput = {
  filter: ModelByMakeFilter;
  remove?: InputMaybe<ModelByMakePatch>;
  set?: InputMaybe<ModelByMakePatch>;
};

export type UpdateModelByMakePayload = {
  __typename?: 'UpdateModelByMakePayload';
  modelByMake?: Maybe<Array<Maybe<ModelByMake>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateModelByMakePayloadModelByMakeArgs = {
  filter?: InputMaybe<ModelByMakeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ModelByMakeOrder>;
};

export type UpdateModelInput = {
  filter: ModelFilter;
  remove?: InputMaybe<ModelPatch>;
  set?: InputMaybe<ModelPatch>;
};

export type UpdateModelPayload = {
  __typename?: 'UpdateModelPayload';
  model?: Maybe<Array<Maybe<Model>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateModelPayloadModelArgs = {
  filter?: InputMaybe<ModelFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ModelOrder>;
};

export type UpdateNotificationInput = {
  filter: NotificationFilter;
  remove?: InputMaybe<NotificationPatch>;
  set?: InputMaybe<NotificationPatch>;
};

export type UpdateNotificationPayload = {
  __typename?: 'UpdateNotificationPayload';
  notification?: Maybe<Array<Maybe<Notification>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdateNotificationPayloadNotificationArgs = {
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<NotificationOrder>;
};

export type UpdateNumberOfPendingTasksInput = {
  filter: NumberOfPendingTasksFilter;
  remove?: InputMaybe<NumberOfPendingTasksPatch>;
  set?: InputMaybe<NumberOfPendingTasksPatch>;
};

export type UpdateNumberOfPendingTasksPayload = {
  __typename?: 'UpdateNumberOfPendingTasksPayload';
  numUids?: Maybe<Scalars['Int']>;
  numberOfPendingTasks?: Maybe<Array<Maybe<NumberOfPendingTasks>>>;
};


export type UpdateNumberOfPendingTasksPayloadNumberOfPendingTasksArgs = {
  filter?: InputMaybe<NumberOfPendingTasksFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<NumberOfPendingTasksOrder>;
};

export type UpdateParkingBeneficiaryInput = {
  filter: ParkingBeneficiaryFilter;
  remove?: InputMaybe<ParkingBeneficiaryPatch>;
  set?: InputMaybe<ParkingBeneficiaryPatch>;
};

export type UpdateParkingBeneficiaryPayload = {
  __typename?: 'UpdateParkingBeneficiaryPayload';
  numUids?: Maybe<Scalars['Int']>;
  parkingBeneficiary?: Maybe<Array<Maybe<ParkingBeneficiary>>>;
};


export type UpdateParkingBeneficiaryPayloadParkingBeneficiaryArgs = {
  filter?: InputMaybe<ParkingBeneficiaryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ParkingBeneficiaryOrder>;
};

export type UpdatePaymentInput = {
  filter: PaymentFilter;
  remove?: InputMaybe<PaymentPatch>;
  set?: InputMaybe<PaymentPatch>;
};

export type UpdatePaymentInvoicesInput = {
  filter: PaymentInvoicesFilter;
  remove?: InputMaybe<PaymentInvoicesPatch>;
  set?: InputMaybe<PaymentInvoicesPatch>;
};

export type UpdatePaymentInvoicesPayload = {
  __typename?: 'UpdatePaymentInvoicesPayload';
  numUids?: Maybe<Scalars['Int']>;
  paymentInvoices?: Maybe<Array<Maybe<PaymentInvoices>>>;
};


export type UpdatePaymentInvoicesPayloadPaymentInvoicesArgs = {
  filter?: InputMaybe<PaymentInvoicesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaymentInvoicesOrder>;
};

export type UpdatePaymentPayload = {
  __typename?: 'UpdatePaymentPayload';
  numUids?: Maybe<Scalars['Int']>;
  payment?: Maybe<Array<Maybe<Payment>>>;
};


export type UpdatePaymentPayloadPaymentArgs = {
  filter?: InputMaybe<PaymentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaymentOrder>;
};

export type UpdatePickupInput = {
  filter: PickupFilter;
  remove?: InputMaybe<PickupPatch>;
  set?: InputMaybe<PickupPatch>;
};

export type UpdatePickupPayload = {
  __typename?: 'UpdatePickupPayload';
  numUids?: Maybe<Scalars['Int']>;
  pickup?: Maybe<Array<Maybe<Pickup>>>;
};


export type UpdatePickupPayloadPickupArgs = {
  filter?: InputMaybe<PickupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PickupOrder>;
};

export type UpdateProductInput = {
  filter: ProductFilter;
  remove?: InputMaybe<ProductPatch>;
  set?: InputMaybe<ProductPatch>;
};

export type UpdateProductPayload = {
  __typename?: 'UpdateProductPayload';
  numUids?: Maybe<Scalars['Int']>;
  product?: Maybe<Array<Maybe<Product>>>;
};


export type UpdateProductPayloadProductArgs = {
  filter?: InputMaybe<ProductFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ProductOrder>;
};

export type UpdatePurchaseInput = {
  filter: PurchaseFilter;
  remove?: InputMaybe<PurchasePatch>;
  set?: InputMaybe<PurchasePatch>;
};

export type UpdatePurchaseItemInput = {
  filter: PurchaseItemFilter;
  remove?: InputMaybe<PurchaseItemPatch>;
  set?: InputMaybe<PurchaseItemPatch>;
};

export type UpdatePurchaseItemPayload = {
  __typename?: 'UpdatePurchaseItemPayload';
  numUids?: Maybe<Scalars['Int']>;
  purchaseItem?: Maybe<Array<Maybe<PurchaseItem>>>;
};


export type UpdatePurchaseItemPayloadPurchaseItemArgs = {
  filter?: InputMaybe<PurchaseItemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PurchaseItemOrder>;
};

export type UpdatePurchasePayload = {
  __typename?: 'UpdatePurchasePayload';
  numUids?: Maybe<Scalars['Int']>;
  purchase?: Maybe<Array<Maybe<Purchase>>>;
};


export type UpdatePurchasePayloadPurchaseArgs = {
  filter?: InputMaybe<PurchaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PurchaseOrder>;
};

export type UpdateRefurbishmentBeneficiaryInput = {
  filter: RefurbishmentBeneficiaryFilter;
  remove?: InputMaybe<RefurbishmentBeneficiaryPatch>;
  set?: InputMaybe<RefurbishmentBeneficiaryPatch>;
};

export type UpdateRefurbishmentBeneficiaryPayload = {
  __typename?: 'UpdateRefurbishmentBeneficiaryPayload';
  numUids?: Maybe<Scalars['Int']>;
  refurbishmentBeneficiary?: Maybe<Array<Maybe<RefurbishmentBeneficiary>>>;
};


export type UpdateRefurbishmentBeneficiaryPayloadRefurbishmentBeneficiaryArgs = {
  filter?: InputMaybe<RefurbishmentBeneficiaryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<RefurbishmentBeneficiaryOrder>;
};

export type UpdateRefurbishmentDetailsInput = {
  filter: RefurbishmentDetailsFilter;
  remove?: InputMaybe<RefurbishmentDetailsPatch>;
  set?: InputMaybe<RefurbishmentDetailsPatch>;
};

export type UpdateRefurbishmentDetailsPayload = {
  __typename?: 'UpdateRefurbishmentDetailsPayload';
  numUids?: Maybe<Scalars['Int']>;
  refurbishmentDetails?: Maybe<Array<Maybe<RefurbishmentDetails>>>;
};


export type UpdateRefurbishmentDetailsPayloadRefurbishmentDetailsArgs = {
  filter?: InputMaybe<RefurbishmentDetailsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type UpdateRefurbishmentItemInput = {
  filter: RefurbishmentItemFilter;
  remove?: InputMaybe<RefurbishmentItemPatch>;
  set?: InputMaybe<RefurbishmentItemPatch>;
};

export type UpdateRefurbishmentItemPayload = {
  __typename?: 'UpdateRefurbishmentItemPayload';
  numUids?: Maybe<Scalars['Int']>;
  refurbishmentItem?: Maybe<Array<Maybe<RefurbishmentItem>>>;
};


export type UpdateRefurbishmentItemPayloadRefurbishmentItemArgs = {
  filter?: InputMaybe<RefurbishmentItemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<RefurbishmentItemOrder>;
};

export type UpdateRefurbishmentRequestInput = {
  filter: RefurbishmentRequestFilter;
  remove?: InputMaybe<RefurbishmentRequestPatch>;
  set?: InputMaybe<RefurbishmentRequestPatch>;
};

export type UpdateRefurbishmentRequestPayload = {
  __typename?: 'UpdateRefurbishmentRequestPayload';
  numUids?: Maybe<Scalars['Int']>;
  refurbishmentRequest?: Maybe<Array<Maybe<RefurbishmentRequest>>>;
};


export type UpdateRefurbishmentRequestPayloadRefurbishmentRequestArgs = {
  filter?: InputMaybe<RefurbishmentRequestFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<RefurbishmentRequestOrder>;
};

export type UpdateSmsLogsInput = {
  filter: SmsLogsFilter;
  remove?: InputMaybe<SmsLogsPatch>;
  set?: InputMaybe<SmsLogsPatch>;
};

export type UpdateSmsLogsPayload = {
  __typename?: 'UpdateSMSLogsPayload';
  numUids?: Maybe<Scalars['Int']>;
  sMSLogs?: Maybe<Array<Maybe<SmsLogs>>>;
};


export type UpdateSmsLogsPayloadSMsLogsArgs = {
  filter?: InputMaybe<SmsLogsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<SmsLogsOrder>;
};

export type UpdateSendSmsToCustomerResponseInput = {
  filter: SendSmsToCustomerResponseFilter;
  remove?: InputMaybe<SendSmsToCustomerResponsePatch>;
  set?: InputMaybe<SendSmsToCustomerResponsePatch>;
};

export type UpdateSendSmsToCustomerResponsePayload = {
  __typename?: 'UpdateSendSmsToCustomerResponsePayload';
  numUids?: Maybe<Scalars['Int']>;
  sendSmsToCustomerResponse?: Maybe<Array<Maybe<SendSmsToCustomerResponse>>>;
};


export type UpdateSendSmsToCustomerResponsePayloadSendSmsToCustomerResponseArgs = {
  filter?: InputMaybe<SendSmsToCustomerResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<SendSmsToCustomerResponseOrder>;
};

export type UpdateStateCodeWithRegNumberInput = {
  filter: StateCodeWithRegNumberFilter;
  remove?: InputMaybe<StateCodeWithRegNumberPatch>;
  set?: InputMaybe<StateCodeWithRegNumberPatch>;
};

export type UpdateStateCodeWithRegNumberPayload = {
  __typename?: 'UpdateStateCodeWithRegNumberPayload';
  numUids?: Maybe<Scalars['Int']>;
  stateCodeWithRegNumber?: Maybe<Array<Maybe<StateCodeWithRegNumber>>>;
};


export type UpdateStateCodeWithRegNumberPayloadStateCodeWithRegNumberArgs = {
  filter?: InputMaybe<StateCodeWithRegNumberFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<StateCodeWithRegNumberOrder>;
};

export type UpdateStatusAggregateInput = {
  filter: StatusAggregateFilter;
  remove?: InputMaybe<StatusAggregatePatch>;
  set?: InputMaybe<StatusAggregatePatch>;
};

export type UpdateStatusAggregatePayload = {
  __typename?: 'UpdateStatusAggregatePayload';
  numUids?: Maybe<Scalars['Int']>;
  statusAggregate?: Maybe<Array<Maybe<StatusAggregate>>>;
};


export type UpdateStatusAggregatePayloadStatusAggregateArgs = {
  filter?: InputMaybe<StatusAggregateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<StatusAggregateOrder>;
};

export type UpdateTjCentreInput = {
  filter: TjCentreFilter;
  remove?: InputMaybe<TjCentrePatch>;
  set?: InputMaybe<TjCentrePatch>;
};

export type UpdateTjCentrePayload = {
  __typename?: 'UpdateTJCentrePayload';
  numUids?: Maybe<Scalars['Int']>;
  tJCentre?: Maybe<Array<Maybe<TjCentre>>>;
};


export type UpdateTjCentrePayloadTjCentreArgs = {
  filter?: InputMaybe<TjCentreFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<TjCentreOrder>;
};

export type UpdateTaskInput = {
  filter: TaskFilter;
  remove?: InputMaybe<TaskPatch>;
  set?: InputMaybe<TaskPatch>;
};

export type UpdateTaskPayload = {
  __typename?: 'UpdateTaskPayload';
  numUids?: Maybe<Scalars['Int']>;
  task?: Maybe<Array<Maybe<Task>>>;
};


export type UpdateTaskPayloadTaskArgs = {
  filter?: InputMaybe<TaskFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<TaskOrder>;
};

export type UpdateTehsilInput = {
  filter: TehsilFilter;
  remove?: InputMaybe<TehsilPatch>;
  set?: InputMaybe<TehsilPatch>;
};

export type UpdateTehsilPayload = {
  __typename?: 'UpdateTehsilPayload';
  numUids?: Maybe<Scalars['Int']>;
  tehsil?: Maybe<Array<Maybe<Tehsil>>>;
};


export type UpdateTehsilPayloadTehsilArgs = {
  filter?: InputMaybe<TehsilFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<TehsilOrder>;
};

export type UpdateTripExpenseInput = {
  filter: TripExpenseFilter;
  remove?: InputMaybe<TripExpensePatch>;
  set?: InputMaybe<TripExpensePatch>;
};

export type UpdateTripExpensePayload = {
  __typename?: 'UpdateTripExpensePayload';
  numUids?: Maybe<Scalars['Int']>;
  tripExpense?: Maybe<Array<Maybe<TripExpense>>>;
};


export type UpdateTripExpensePayloadTripExpenseArgs = {
  filter?: InputMaybe<TripExpenseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<TripExpenseOrder>;
};

export type UpdateUserInput = {
  filter: UserFilter;
  remove?: InputMaybe<UserPatch>;
  set?: InputMaybe<UserPatch>;
};

export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  numUids?: Maybe<Scalars['Int']>;
  user?: Maybe<Array<Maybe<User>>>;
};


export type UpdateUserPayloadUserArgs = {
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<UserOrder>;
};

export type UpdateVehicleDocumentsInput = {
  filter: VehicleDocumentsFilter;
  remove?: InputMaybe<VehicleDocumentsPatch>;
  set?: InputMaybe<VehicleDocumentsPatch>;
};

export type UpdateVehicleDocumentsPayload = {
  __typename?: 'UpdateVehicleDocumentsPayload';
  numUids?: Maybe<Scalars['Int']>;
  vehicleDocuments?: Maybe<Array<Maybe<VehicleDocuments>>>;
};


export type UpdateVehicleDocumentsPayloadVehicleDocumentsArgs = {
  filter?: InputMaybe<VehicleDocumentsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleDocumentsOrder>;
};

export type UpdateVehicleFinancingInput = {
  filter: VehicleFinancingFilter;
  remove?: InputMaybe<VehicleFinancingPatch>;
  set?: InputMaybe<VehicleFinancingPatch>;
};

export type UpdateVehicleFinancingPayload = {
  __typename?: 'UpdateVehicleFinancingPayload';
  numUids?: Maybe<Scalars['Int']>;
  vehicleFinancing?: Maybe<Array<Maybe<VehicleFinancing>>>;
};


export type UpdateVehicleFinancingPayloadVehicleFinancingArgs = {
  filter?: InputMaybe<VehicleFinancingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleFinancingOrder>;
};

export type UpdateVehicleImagesInput = {
  filter: VehicleImagesFilter;
  remove?: InputMaybe<VehicleImagesPatch>;
  set?: InputMaybe<VehicleImagesPatch>;
};

export type UpdateVehicleImagesPayload = {
  __typename?: 'UpdateVehicleImagesPayload';
  numUids?: Maybe<Scalars['Int']>;
  vehicleImages?: Maybe<Array<Maybe<VehicleImages>>>;
};


export type UpdateVehicleImagesPayloadVehicleImagesArgs = {
  filter?: InputMaybe<VehicleImagesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleImagesOrder>;
};

export type UpdateVehicleInput = {
  filter: VehicleFilter;
  remove?: InputMaybe<VehiclePatch>;
  set?: InputMaybe<VehiclePatch>;
};

export type UpdateVehicleInsuranceInput = {
  filter: VehicleInsuranceFilter;
  remove?: InputMaybe<VehicleInsurancePatch>;
  set?: InputMaybe<VehicleInsurancePatch>;
};

export type UpdateVehicleInsurancePayload = {
  __typename?: 'UpdateVehicleInsurancePayload';
  numUids?: Maybe<Scalars['Int']>;
  vehicleInsurance?: Maybe<Array<Maybe<VehicleInsurance>>>;
};


export type UpdateVehicleInsurancePayloadVehicleInsuranceArgs = {
  filter?: InputMaybe<VehicleInsuranceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleInsuranceOrder>;
};

export type UpdateVehicleOwnerInput = {
  filter: VehicleOwnerFilter;
  remove?: InputMaybe<VehicleOwnerPatch>;
  set?: InputMaybe<VehicleOwnerPatch>;
};

export type UpdateVehicleOwnerPayload = {
  __typename?: 'UpdateVehicleOwnerPayload';
  numUids?: Maybe<Scalars['Int']>;
  vehicleOwner?: Maybe<Array<Maybe<VehicleOwner>>>;
};


export type UpdateVehicleOwnerPayloadVehicleOwnerArgs = {
  filter?: InputMaybe<VehicleOwnerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleOwnerOrder>;
};

export type UpdateVehiclePayload = {
  __typename?: 'UpdateVehiclePayload';
  numUids?: Maybe<Scalars['Int']>;
  vehicle?: Maybe<Array<Maybe<Vehicle>>>;
};


export type UpdateVehiclePayloadVehicleArgs = {
  filter?: InputMaybe<VehicleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleOrder>;
};

export type UpdateVehicleTransferLogInput = {
  filter: VehicleTransferLogFilter;
  remove?: InputMaybe<VehicleTransferLogPatch>;
  set?: InputMaybe<VehicleTransferLogPatch>;
};

export type UpdateVehicleTransferLogPayload = {
  __typename?: 'UpdateVehicleTransferLogPayload';
  numUids?: Maybe<Scalars['Int']>;
  vehicleTransferLog?: Maybe<Array<Maybe<VehicleTransferLog>>>;
};


export type UpdateVehicleTransferLogPayloadVehicleTransferLogArgs = {
  filter?: InputMaybe<VehicleTransferLogFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleTransferLogOrder>;
};

export type UpdateYardInput = {
  filter: YardFilter;
  remove?: InputMaybe<YardPatch>;
  set?: InputMaybe<YardPatch>;
};

export type UpdateYardPayload = {
  __typename?: 'UpdateYardPayload';
  numUids?: Maybe<Scalars['Int']>;
  yard?: Maybe<Array<Maybe<Yard>>>;
};


export type UpdateYardPayloadYardArgs = {
  filter?: InputMaybe<YardFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<YardOrder>;
};

export type UpdatedocumentsAggregatesResultInput = {
  filter: DocumentsAggregatesResultFilter;
  remove?: InputMaybe<DocumentsAggregatesResultPatch>;
  set?: InputMaybe<DocumentsAggregatesResultPatch>;
};

export type UpdatedocumentsAggregatesResultPayload = {
  __typename?: 'UpdatedocumentsAggregatesResultPayload';
  documentsAggregatesResult?: Maybe<Array<Maybe<DocumentsAggregatesResult>>>;
  numUids?: Maybe<Scalars['Int']>;
};


export type UpdatedocumentsAggregatesResultPayloadDocumentsAggregatesResultArgs = {
  filter?: InputMaybe<DocumentsAggregatesResultFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** User is internal in the organization. Onboarded with org email created. */
export type User = {
  __typename?: 'User';
  addedTripExpenses?: Maybe<Array<Maybe<TripExpense>>>;
  addedTripExpensesAggregate?: Maybe<TripExpenseAggregateResult>;
  additionalRole?: Maybe<Array<Maybe<UserRole>>>;
  approvedIssues?: Maybe<Array<Maybe<Issue>>>;
  approvedIssuesAggregate?: Maybe<IssueAggregateResult>;
  approvedPurchases?: Maybe<Array<Maybe<Purchase>>>;
  approvedPurchasesAggregate?: Maybe<PurchaseAggregateResult>;
  assignedInternalTransfer?: Maybe<Array<Maybe<VehicleTransferLog>>>;
  assignedInternalTransferAggregate?: Maybe<VehicleTransferLogAggregateResult>;
  assignedTasks?: Maybe<Array<Maybe<Task>>>;
  assignedTasksAggregate?: Maybe<TaskAggregateResult>;
  avatar?: Maybe<Scalars['String']>;
  centre?: Maybe<Centre>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdLeads?: Maybe<Array<Maybe<Lead>>>;
  createdLeadsAggregate?: Maybe<LeadAggregateResult>;
  email: Scalars['String'];
  /** Expo generated token to send push notifications */
  expoPushNotificationAddress?: Maybe<Scalars['String']>;
  hasAdminPanelAccess?: Maybe<Scalars['Boolean']>;
  /** auto_generated id */
  id: Scalars['ID'];
  /** to be deprecated if no use case for anyone managing multiple centres */
  inchargeOfCentres?: Maybe<Array<Maybe<Centre>>>;
  inchargeOfCentresAggregate?: Maybe<CentreAggregateResult>;
  isActive?: Maybe<Scalars['Boolean']>;
  isReportingManagerOf?: Maybe<Array<Maybe<User>>>;
  isReportingManagerOfAggregate?: Maybe<UserAggregateResult>;
  location?: Maybe<Point>;
  madeIssues?: Maybe<Array<Maybe<Issue>>>;
  madeIssuesAggregate?: Maybe<IssueAggregateResult>;
  madePurchases?: Maybe<Array<Maybe<Purchase>>>;
  madePurchasesAggregate?: Maybe<PurchaseAggregateResult>;
  managingCentres?: Maybe<Array<Maybe<Centre>>>;
  managingCentresAggregate?: Maybe<CentreAggregateResult>;
  name: Scalars['String'];
  notifications?: Maybe<Array<Maybe<Notification>>>;
  notificationsAggregate?: Maybe<NotificationAggregateResult>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  paymentsAggregate?: Maybe<PaymentAggregateResult>;
  phoneNo?: Maybe<Scalars['String']>;
  pickups?: Maybe<Array<Maybe<Pickup>>>;
  pickupsAggregate?: Maybe<PickupAggregateResult>;
  punchedEvents?: Maybe<Array<Maybe<LeadStatusEvent>>>;
  punchedEventsAggregate?: Maybe<LeadStatusEventAggregateResult>;
  raisedRefurbishments?: Maybe<Array<Maybe<RefurbishmentRequest>>>;
  raisedRefurbishmentsAggregate?: Maybe<RefurbishmentRequestAggregateResult>;
  readMessages?: Maybe<Array<Maybe<Message>>>;
  readMessagesAggregate?: Maybe<MessageAggregateResult>;
  registrationState?: Maybe<Array<Maybe<Scalars['String']>>>;
  reportingManager?: Maybe<User>;
  role?: Maybe<UserRole>;
  sentMessages?: Maybe<Array<Maybe<Message>>>;
  sentMessagesAggregate?: Maybe<MessageAggregateResult>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedListings?: Maybe<Array<Maybe<Lead>>>;
  updatedListingsAggregate?: Maybe<LeadAggregateResult>;
  userLogs?: Maybe<Array<Maybe<LogTracking>>>;
  userLogsAggregate?: Maybe<LogTrackingAggregateResult>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserAddedTripExpensesArgs = {
  filter?: InputMaybe<TripExpenseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<TripExpenseOrder>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserAddedTripExpensesAggregateArgs = {
  filter?: InputMaybe<TripExpenseFilter>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserApprovedIssuesArgs = {
  filter?: InputMaybe<IssueFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<IssueOrder>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserApprovedIssuesAggregateArgs = {
  filter?: InputMaybe<IssueFilter>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserApprovedPurchasesArgs = {
  filter?: InputMaybe<PurchaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PurchaseOrder>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserApprovedPurchasesAggregateArgs = {
  filter?: InputMaybe<PurchaseFilter>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserAssignedInternalTransferArgs = {
  filter?: InputMaybe<VehicleTransferLogFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleTransferLogOrder>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserAssignedInternalTransferAggregateArgs = {
  filter?: InputMaybe<VehicleTransferLogFilter>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserAssignedTasksArgs = {
  filter?: InputMaybe<TaskFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<TaskOrder>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserAssignedTasksAggregateArgs = {
  filter?: InputMaybe<TaskFilter>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserCentreArgs = {
  filter?: InputMaybe<CentreFilter>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserCreatedLeadsArgs = {
  filter?: InputMaybe<LeadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadOrder>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserCreatedLeadsAggregateArgs = {
  filter?: InputMaybe<LeadFilter>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserInchargeOfCentresArgs = {
  filter?: InputMaybe<CentreFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CentreOrder>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserInchargeOfCentresAggregateArgs = {
  filter?: InputMaybe<CentreFilter>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserIsReportingManagerOfArgs = {
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<UserOrder>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserIsReportingManagerOfAggregateArgs = {
  filter?: InputMaybe<UserFilter>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserMadeIssuesArgs = {
  filter?: InputMaybe<IssueFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<IssueOrder>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserMadeIssuesAggregateArgs = {
  filter?: InputMaybe<IssueFilter>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserMadePurchasesArgs = {
  filter?: InputMaybe<PurchaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PurchaseOrder>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserMadePurchasesAggregateArgs = {
  filter?: InputMaybe<PurchaseFilter>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserManagingCentresArgs = {
  filter?: InputMaybe<CentreFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<CentreOrder>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserManagingCentresAggregateArgs = {
  filter?: InputMaybe<CentreFilter>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserNotificationsArgs = {
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<NotificationOrder>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserNotificationsAggregateArgs = {
  filter?: InputMaybe<NotificationFilter>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserPaymentsArgs = {
  filter?: InputMaybe<PaymentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaymentOrder>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserPaymentsAggregateArgs = {
  filter?: InputMaybe<PaymentFilter>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserPickupsArgs = {
  filter?: InputMaybe<PickupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PickupOrder>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserPickupsAggregateArgs = {
  filter?: InputMaybe<PickupFilter>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserPunchedEventsArgs = {
  filter?: InputMaybe<LeadStatusEventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadStatusEventOrder>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserPunchedEventsAggregateArgs = {
  filter?: InputMaybe<LeadStatusEventFilter>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserRaisedRefurbishmentsArgs = {
  filter?: InputMaybe<RefurbishmentRequestFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<RefurbishmentRequestOrder>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserRaisedRefurbishmentsAggregateArgs = {
  filter?: InputMaybe<RefurbishmentRequestFilter>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserReadMessagesArgs = {
  filter?: InputMaybe<MessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<MessageOrder>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserReadMessagesAggregateArgs = {
  filter?: InputMaybe<MessageFilter>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserReportingManagerArgs = {
  filter?: InputMaybe<UserFilter>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserSentMessagesArgs = {
  filter?: InputMaybe<MessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<MessageOrder>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserSentMessagesAggregateArgs = {
  filter?: InputMaybe<MessageFilter>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserUpdatedListingsArgs = {
  filter?: InputMaybe<LeadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadOrder>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserUpdatedListingsAggregateArgs = {
  filter?: InputMaybe<LeadFilter>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserUserLogsArgs = {
  filter?: InputMaybe<LogTrackingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LogTrackingOrder>;
};


/** User is internal in the organization. Onboarded with org email created. */
export type UserUserLogsAggregateArgs = {
  filter?: InputMaybe<LogTrackingFilter>;
};

export type UserAggregateResult = {
  __typename?: 'UserAggregateResult';
  avatarMax?: Maybe<Scalars['String']>;
  avatarMin?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  createdAtMax?: Maybe<Scalars['DateTime']>;
  createdAtMin?: Maybe<Scalars['DateTime']>;
  emailMax?: Maybe<Scalars['String']>;
  emailMin?: Maybe<Scalars['String']>;
  expoPushNotificationAddressMax?: Maybe<Scalars['String']>;
  expoPushNotificationAddressMin?: Maybe<Scalars['String']>;
  nameMax?: Maybe<Scalars['String']>;
  nameMin?: Maybe<Scalars['String']>;
  phoneNoMax?: Maybe<Scalars['String']>;
  phoneNoMin?: Maybe<Scalars['String']>;
  updatedAtMax?: Maybe<Scalars['DateTime']>;
  updatedAtMin?: Maybe<Scalars['DateTime']>;
};

export type UserFilter = {
  additionalRole?: InputMaybe<UserRole_Hash>;
  and?: InputMaybe<Array<InputMaybe<UserFilter>>>;
  email?: InputMaybe<StringHashFilter>;
  has?: InputMaybe<Array<InputMaybe<UserHasFilter>>>;
  hasAdminPanelAccess?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<StringRegExpFilter_StringTermFilter>;
  not?: InputMaybe<UserFilter>;
  or?: InputMaybe<Array<InputMaybe<UserFilter>>>;
  role?: InputMaybe<UserRole_Hash>;
};

export enum UserHasFilter {
  AddedTripExpenses = 'addedTripExpenses',
  AdditionalRole = 'additionalRole',
  ApprovedIssues = 'approvedIssues',
  ApprovedPurchases = 'approvedPurchases',
  AssignedInternalTransfer = 'assignedInternalTransfer',
  AssignedTasks = 'assignedTasks',
  Avatar = 'avatar',
  Centre = 'centre',
  CreatedAt = 'createdAt',
  CreatedLeads = 'createdLeads',
  Email = 'email',
  ExpoPushNotificationAddress = 'expoPushNotificationAddress',
  HasAdminPanelAccess = 'hasAdminPanelAccess',
  InchargeOfCentres = 'inchargeOfCentres',
  IsActive = 'isActive',
  IsReportingManagerOf = 'isReportingManagerOf',
  Location = 'location',
  MadeIssues = 'madeIssues',
  MadePurchases = 'madePurchases',
  ManagingCentres = 'managingCentres',
  Name = 'name',
  Notifications = 'notifications',
  Payments = 'payments',
  PhoneNo = 'phoneNo',
  Pickups = 'pickups',
  PunchedEvents = 'punchedEvents',
  RaisedRefurbishments = 'raisedRefurbishments',
  ReadMessages = 'readMessages',
  RegistrationState = 'registrationState',
  ReportingManager = 'reportingManager',
  Role = 'role',
  SentMessages = 'sentMessages',
  UpdatedAt = 'updatedAt',
  UpdatedListings = 'updatedListings',
  UserLogs = 'userLogs'
}

export type UserOrder = {
  asc?: InputMaybe<UserOrderable>;
  desc?: InputMaybe<UserOrderable>;
  then?: InputMaybe<UserOrder>;
};

export enum UserOrderable {
  Avatar = 'avatar',
  CreatedAt = 'createdAt',
  Email = 'email',
  ExpoPushNotificationAddress = 'expoPushNotificationAddress',
  Name = 'name',
  PhoneNo = 'phoneNo',
  UpdatedAt = 'updatedAt'
}

export type UserPatch = {
  addedTripExpenses?: InputMaybe<Array<InputMaybe<TripExpenseRef>>>;
  additionalRole?: InputMaybe<Array<InputMaybe<UserRole>>>;
  approvedIssues?: InputMaybe<Array<InputMaybe<IssueRef>>>;
  approvedPurchases?: InputMaybe<Array<InputMaybe<PurchaseRef>>>;
  assignedInternalTransfer?: InputMaybe<Array<InputMaybe<VehicleTransferLogRef>>>;
  assignedTasks?: InputMaybe<Array<InputMaybe<TaskRef>>>;
  avatar?: InputMaybe<Scalars['String']>;
  centre?: InputMaybe<CentreRef>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdLeads?: InputMaybe<Array<InputMaybe<LeadRef>>>;
  /** Expo generated token to send push notifications */
  expoPushNotificationAddress?: InputMaybe<Scalars['String']>;
  hasAdminPanelAccess?: InputMaybe<Scalars['Boolean']>;
  inchargeOfCentres?: InputMaybe<Array<InputMaybe<CentreRef>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isReportingManagerOf?: InputMaybe<Array<InputMaybe<UserRef>>>;
  location?: InputMaybe<PointRef>;
  madeIssues?: InputMaybe<Array<InputMaybe<IssueRef>>>;
  madePurchases?: InputMaybe<Array<InputMaybe<PurchaseRef>>>;
  managingCentres?: InputMaybe<Array<InputMaybe<CentreRef>>>;
  name?: InputMaybe<Scalars['String']>;
  notifications?: InputMaybe<Array<InputMaybe<NotificationRef>>>;
  payments?: InputMaybe<Array<InputMaybe<PaymentRef>>>;
  phoneNo?: InputMaybe<Scalars['String']>;
  pickups?: InputMaybe<Array<InputMaybe<PickupRef>>>;
  punchedEvents?: InputMaybe<Array<InputMaybe<LeadStatusEventRef>>>;
  raisedRefurbishments?: InputMaybe<Array<InputMaybe<RefurbishmentRequestRef>>>;
  readMessages?: InputMaybe<Array<InputMaybe<MessageRef>>>;
  registrationState?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  reportingManager?: InputMaybe<UserRef>;
  role?: InputMaybe<UserRole>;
  sentMessages?: InputMaybe<Array<InputMaybe<MessageRef>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedListings?: InputMaybe<Array<InputMaybe<LeadRef>>>;
  userLogs?: InputMaybe<Array<InputMaybe<LogTrackingRef>>>;
};

export type UserRef = {
  addedTripExpenses?: InputMaybe<Array<InputMaybe<TripExpenseRef>>>;
  additionalRole?: InputMaybe<Array<InputMaybe<UserRole>>>;
  approvedIssues?: InputMaybe<Array<InputMaybe<IssueRef>>>;
  approvedPurchases?: InputMaybe<Array<InputMaybe<PurchaseRef>>>;
  assignedInternalTransfer?: InputMaybe<Array<InputMaybe<VehicleTransferLogRef>>>;
  assignedTasks?: InputMaybe<Array<InputMaybe<TaskRef>>>;
  avatar?: InputMaybe<Scalars['String']>;
  centre?: InputMaybe<CentreRef>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdLeads?: InputMaybe<Array<InputMaybe<LeadRef>>>;
  email?: InputMaybe<Scalars['String']>;
  /** Expo generated token to send push notifications */
  expoPushNotificationAddress?: InputMaybe<Scalars['String']>;
  hasAdminPanelAccess?: InputMaybe<Scalars['Boolean']>;
  /** auto_generated id */
  id?: InputMaybe<Scalars['ID']>;
  inchargeOfCentres?: InputMaybe<Array<InputMaybe<CentreRef>>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isReportingManagerOf?: InputMaybe<Array<InputMaybe<UserRef>>>;
  location?: InputMaybe<PointRef>;
  madeIssues?: InputMaybe<Array<InputMaybe<IssueRef>>>;
  madePurchases?: InputMaybe<Array<InputMaybe<PurchaseRef>>>;
  managingCentres?: InputMaybe<Array<InputMaybe<CentreRef>>>;
  name?: InputMaybe<Scalars['String']>;
  notifications?: InputMaybe<Array<InputMaybe<NotificationRef>>>;
  payments?: InputMaybe<Array<InputMaybe<PaymentRef>>>;
  phoneNo?: InputMaybe<Scalars['String']>;
  pickups?: InputMaybe<Array<InputMaybe<PickupRef>>>;
  punchedEvents?: InputMaybe<Array<InputMaybe<LeadStatusEventRef>>>;
  raisedRefurbishments?: InputMaybe<Array<InputMaybe<RefurbishmentRequestRef>>>;
  readMessages?: InputMaybe<Array<InputMaybe<MessageRef>>>;
  registrationState?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  reportingManager?: InputMaybe<UserRef>;
  role?: InputMaybe<UserRole>;
  sentMessages?: InputMaybe<Array<InputMaybe<MessageRef>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedListings?: InputMaybe<Array<InputMaybe<LeadRef>>>;
  userLogs?: InputMaybe<Array<InputMaybe<LogTrackingRef>>>;
};

export enum UserRole {
  Admin = 'ADMIN',
  BranchManager = 'BRANCH_MANAGER',
  CentreManager = 'CENTRE_MANAGER',
  Driver = 'DRIVER',
  EngineeringDeveloper = 'ENGINEERING_DEVELOPER',
  EngineeringHead = 'ENGINEERING_HEAD',
  EngineeringManager = 'ENGINEERING_MANAGER',
  EngineeringQa = 'ENGINEERING_QA',
  FinanceExecutive = 'FINANCE_EXECUTIVE',
  FinanceHead = 'FINANCE_HEAD',
  FinanceManager = 'FINANCE_MANAGER',
  LogisticsExecutive = 'LOGISTICS_EXECUTIVE',
  LogisticsHead = 'LOGISTICS_HEAD',
  LogisticsManager = 'LOGISTICS_MANAGER',
  OperationsExecutive = 'OPERATIONS_EXECUTIVE',
  OperationsHead = 'OPERATIONS_HEAD',
  OperationsManager = 'OPERATIONS_MANAGER',
  ProcurementExecutive = 'PROCUREMENT_EXECUTIVE',
  ProcurementHead = 'PROCUREMENT_HEAD',
  ProcurementManager = 'PROCUREMENT_MANAGER',
  ProcurementTail = 'PROCUREMENT_TAIL',
  ProductHead = 'PRODUCT_HEAD',
  ProductManager = 'PRODUCT_MANAGER',
  RetailFinanceManager = 'RETAIL_FINANCE_MANAGER',
  SalesExecutive = 'SALES_EXECUTIVE',
  SalesHead = 'SALES_HEAD',
  SalesManager = 'SALES_MANAGER',
  StateHead = 'STATE_HEAD',
  SuperAdmin = 'SUPER_ADMIN',
  TerritoryManager = 'TERRITORY_MANAGER'
}

export type UserRole_Hash = {
  eq?: InputMaybe<UserRole>;
  in?: InputMaybe<Array<InputMaybe<UserRole>>>;
};

export type Vehicle = {
  __typename?: 'Vehicle';
  challanAmount?: Maybe<Scalars['Int']>;
  chassisNumber?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  documents?: Maybe<VehicleDocuments>;
  dueTaxesAmount?: Maybe<Scalars['Int']>;
  engineCondition?: Maybe<Scalars['Int']>;
  engineNumber?: Maybe<Scalars['String']>;
  financingDetails?: Maybe<VehicleFinancing>;
  fitnessValidUpto?: Maybe<Scalars['DateTime']>;
  fuelType?: Maybe<VehicleFuelType>;
  hasDueTaxes?: Maybe<Scalars['Boolean']>;
  horsePower?: Maybe<Scalars['Int']>;
  hoursMeter?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  images?: Maybe<Array<Maybe<VehicleImages>>>;
  imagesAggregate?: Maybe<VehicleImagesAggregateResult>;
  insuranceDetails?: Maybe<VehicleInsurance>;
  isBlacklisted?: Maybe<Scalars['Boolean']>;
  isChallanAvailable?: Maybe<Scalars['Boolean']>;
  isHSRPAvailable?: Maybe<Scalars['Boolean']>;
  isHypo?: Maybe<Scalars['Boolean']>;
  isRcAvailable?: Maybe<Scalars['Boolean']>;
  isVehicleFinanced?: Maybe<Scalars['Boolean']>;
  isVehicleInsured?: Maybe<Scalars['Boolean']>;
  kind?: Maybe<VehicleKind>;
  make?: Maybe<VehicleMake>;
  manufacturingDate?: Maybe<Scalars['DateTime']>;
  model?: Maybe<Scalars['String']>;
  owner?: Maybe<VehicleOwner>;
  price?: Maybe<Scalars['Int']>;
  purchaseDate?: Maybe<Scalars['DateTime']>;
  regNo: Scalars['String'];
  registrationDate?: Maybe<Scalars['DateTime']>;
  registrationNumber?: Maybe<Scalars['String']>;
  repossessionDate?: Maybe<Scalars['DateTime']>;
  tempChassisNumber?: Maybe<Scalars['String']>;
  tempEngineNumber?: Maybe<Scalars['String']>;
  tempIsVehicleFinanced?: Maybe<Scalars['Boolean']>;
  tempMake?: Maybe<VehicleMake>;
  tempManufacturingDate?: Maybe<Scalars['DateTime']>;
  tempModel?: Maybe<Scalars['String']>;
  /** To be put in by the driver */
  tempRepossessionDate?: Maybe<Scalars['DateTime']>;
  tempVehicleBrand?: Maybe<Brand>;
  tempVehicleModel?: Maybe<Model>;
  totalHourRun?: Maybe<Scalars['Int']>;
  totalKmsRun?: Maybe<Scalars['Int']>;
  typeCondition?: Maybe<Scalars['Int']>;
  vehicleBrand?: Maybe<Brand>;
  vehicleModel?: Maybe<Model>;
  verificationRemarks?: Maybe<Scalars['String']>;
};


export type VehicleDocumentsArgs = {
  filter?: InputMaybe<VehicleDocumentsFilter>;
};


export type VehicleFinancingDetailsArgs = {
  filter?: InputMaybe<VehicleFinancingFilter>;
};


export type VehicleImagesArgs = {
  filter?: InputMaybe<VehicleImagesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<VehicleImagesOrder>;
};


export type VehicleImagesAggregateArgs = {
  filter?: InputMaybe<VehicleImagesFilter>;
};


export type VehicleInsuranceDetailsArgs = {
  filter?: InputMaybe<VehicleInsuranceFilter>;
};


export type VehicleOwnerArgs = {
  filter?: InputMaybe<VehicleOwnerFilter>;
};


export type VehicleTempVehicleBrandArgs = {
  filter?: InputMaybe<BrandFilter>;
};


export type VehicleTempVehicleModelArgs = {
  filter?: InputMaybe<ModelFilter>;
};


export type VehicleVehicleBrandArgs = {
  filter?: InputMaybe<BrandFilter>;
};


export type VehicleVehicleModelArgs = {
  filter?: InputMaybe<ModelFilter>;
};

export type VehicleAggregateResult = {
  __typename?: 'VehicleAggregateResult';
  challanAmountAvg?: Maybe<Scalars['Float']>;
  challanAmountMax?: Maybe<Scalars['Int']>;
  challanAmountMin?: Maybe<Scalars['Int']>;
  challanAmountSum?: Maybe<Scalars['Int']>;
  chassisNumberMax?: Maybe<Scalars['String']>;
  chassisNumberMin?: Maybe<Scalars['String']>;
  colorMax?: Maybe<Scalars['String']>;
  colorMin?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  dueTaxesAmountAvg?: Maybe<Scalars['Float']>;
  dueTaxesAmountMax?: Maybe<Scalars['Int']>;
  dueTaxesAmountMin?: Maybe<Scalars['Int']>;
  dueTaxesAmountSum?: Maybe<Scalars['Int']>;
  engineConditionAvg?: Maybe<Scalars['Float']>;
  engineConditionMax?: Maybe<Scalars['Int']>;
  engineConditionMin?: Maybe<Scalars['Int']>;
  engineConditionSum?: Maybe<Scalars['Int']>;
  engineNumberMax?: Maybe<Scalars['String']>;
  engineNumberMin?: Maybe<Scalars['String']>;
  fitnessValidUptoMax?: Maybe<Scalars['DateTime']>;
  fitnessValidUptoMin?: Maybe<Scalars['DateTime']>;
  horsePowerAvg?: Maybe<Scalars['Float']>;
  horsePowerMax?: Maybe<Scalars['Int']>;
  horsePowerMin?: Maybe<Scalars['Int']>;
  horsePowerSum?: Maybe<Scalars['Int']>;
  hoursMeterAvg?: Maybe<Scalars['Float']>;
  hoursMeterMax?: Maybe<Scalars['Int']>;
  hoursMeterMin?: Maybe<Scalars['Int']>;
  hoursMeterSum?: Maybe<Scalars['Int']>;
  manufacturingDateMax?: Maybe<Scalars['DateTime']>;
  manufacturingDateMin?: Maybe<Scalars['DateTime']>;
  modelMax?: Maybe<Scalars['String']>;
  modelMin?: Maybe<Scalars['String']>;
  priceAvg?: Maybe<Scalars['Float']>;
  priceMax?: Maybe<Scalars['Int']>;
  priceMin?: Maybe<Scalars['Int']>;
  priceSum?: Maybe<Scalars['Int']>;
  purchaseDateMax?: Maybe<Scalars['DateTime']>;
  purchaseDateMin?: Maybe<Scalars['DateTime']>;
  regNoMax?: Maybe<Scalars['String']>;
  regNoMin?: Maybe<Scalars['String']>;
  registrationDateMax?: Maybe<Scalars['DateTime']>;
  registrationDateMin?: Maybe<Scalars['DateTime']>;
  registrationNumberMax?: Maybe<Scalars['String']>;
  registrationNumberMin?: Maybe<Scalars['String']>;
  repossessionDateMax?: Maybe<Scalars['DateTime']>;
  repossessionDateMin?: Maybe<Scalars['DateTime']>;
  tempChassisNumberMax?: Maybe<Scalars['String']>;
  tempChassisNumberMin?: Maybe<Scalars['String']>;
  tempEngineNumberMax?: Maybe<Scalars['String']>;
  tempEngineNumberMin?: Maybe<Scalars['String']>;
  tempManufacturingDateMax?: Maybe<Scalars['DateTime']>;
  tempManufacturingDateMin?: Maybe<Scalars['DateTime']>;
  tempModelMax?: Maybe<Scalars['String']>;
  tempModelMin?: Maybe<Scalars['String']>;
  tempRepossessionDateMax?: Maybe<Scalars['DateTime']>;
  tempRepossessionDateMin?: Maybe<Scalars['DateTime']>;
  totalHourRunAvg?: Maybe<Scalars['Float']>;
  totalHourRunMax?: Maybe<Scalars['Int']>;
  totalHourRunMin?: Maybe<Scalars['Int']>;
  totalHourRunSum?: Maybe<Scalars['Int']>;
  totalKmsRunAvg?: Maybe<Scalars['Float']>;
  totalKmsRunMax?: Maybe<Scalars['Int']>;
  totalKmsRunMin?: Maybe<Scalars['Int']>;
  totalKmsRunSum?: Maybe<Scalars['Int']>;
  typeConditionAvg?: Maybe<Scalars['Float']>;
  typeConditionMax?: Maybe<Scalars['Int']>;
  typeConditionMin?: Maybe<Scalars['Int']>;
  typeConditionSum?: Maybe<Scalars['Int']>;
  verificationRemarksMax?: Maybe<Scalars['String']>;
  verificationRemarksMin?: Maybe<Scalars['String']>;
};

export type VehicleDocuments = {
  __typename?: 'VehicleDocuments';
  approvalMailUrl?: Maybe<Scalars['String']>;
  blacklistProofUrl?: Maybe<Scalars['String']>;
  challanUrl?: Maybe<Scalars['String']>;
  fitnessCertificateUrl?: Maybe<Scalars['String']>;
  fitnessCertificateValidUpto?: Maybe<Scalars['DateTime']>;
  hsrbProofUrl?: Maybe<Scalars['String']>;
  hypothecationProofUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  regNo: Scalars['String'];
  registrationCertificateUrl?: Maybe<Scalars['String']>;
  rtoVerificationProofUrl?: Maybe<Scalars['String']>;
  vehicle: Vehicle;
};


export type VehicleDocumentsVehicleArgs = {
  filter?: InputMaybe<VehicleFilter>;
};

export type VehicleDocumentsAggregateResult = {
  __typename?: 'VehicleDocumentsAggregateResult';
  approvalMailUrlMax?: Maybe<Scalars['String']>;
  approvalMailUrlMin?: Maybe<Scalars['String']>;
  blacklistProofUrlMax?: Maybe<Scalars['String']>;
  blacklistProofUrlMin?: Maybe<Scalars['String']>;
  challanUrlMax?: Maybe<Scalars['String']>;
  challanUrlMin?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  fitnessCertificateUrlMax?: Maybe<Scalars['String']>;
  fitnessCertificateUrlMin?: Maybe<Scalars['String']>;
  fitnessCertificateValidUptoMax?: Maybe<Scalars['DateTime']>;
  fitnessCertificateValidUptoMin?: Maybe<Scalars['DateTime']>;
  hsrbProofUrlMax?: Maybe<Scalars['String']>;
  hsrbProofUrlMin?: Maybe<Scalars['String']>;
  hypothecationProofUrlMax?: Maybe<Scalars['String']>;
  hypothecationProofUrlMin?: Maybe<Scalars['String']>;
  regNoMax?: Maybe<Scalars['String']>;
  regNoMin?: Maybe<Scalars['String']>;
  registrationCertificateUrlMax?: Maybe<Scalars['String']>;
  registrationCertificateUrlMin?: Maybe<Scalars['String']>;
  rtoVerificationProofUrlMax?: Maybe<Scalars['String']>;
  rtoVerificationProofUrlMin?: Maybe<Scalars['String']>;
};

export type VehicleDocumentsFilter = {
  and?: InputMaybe<Array<InputMaybe<VehicleDocumentsFilter>>>;
  fitnessCertificateValidUpto?: InputMaybe<DateTimeFilter>;
  has?: InputMaybe<Array<InputMaybe<VehicleDocumentsHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<VehicleDocumentsFilter>;
  or?: InputMaybe<Array<InputMaybe<VehicleDocumentsFilter>>>;
  regNo?: InputMaybe<StringHashFilter>;
};

export enum VehicleDocumentsHasFilter {
  ApprovalMailUrl = 'approvalMailUrl',
  BlacklistProofUrl = 'blacklistProofUrl',
  ChallanUrl = 'challanUrl',
  FitnessCertificateUrl = 'fitnessCertificateUrl',
  FitnessCertificateValidUpto = 'fitnessCertificateValidUpto',
  HsrbProofUrl = 'hsrbProofUrl',
  HypothecationProofUrl = 'hypothecationProofUrl',
  RegNo = 'regNo',
  RegistrationCertificateUrl = 'registrationCertificateUrl',
  RtoVerificationProofUrl = 'rtoVerificationProofUrl',
  Vehicle = 'vehicle'
}

export type VehicleDocumentsOrder = {
  asc?: InputMaybe<VehicleDocumentsOrderable>;
  desc?: InputMaybe<VehicleDocumentsOrderable>;
  then?: InputMaybe<VehicleDocumentsOrder>;
};

export enum VehicleDocumentsOrderable {
  ApprovalMailUrl = 'approvalMailUrl',
  BlacklistProofUrl = 'blacklistProofUrl',
  ChallanUrl = 'challanUrl',
  FitnessCertificateUrl = 'fitnessCertificateUrl',
  FitnessCertificateValidUpto = 'fitnessCertificateValidUpto',
  HsrbProofUrl = 'hsrbProofUrl',
  HypothecationProofUrl = 'hypothecationProofUrl',
  RegNo = 'regNo',
  RegistrationCertificateUrl = 'registrationCertificateUrl',
  RtoVerificationProofUrl = 'rtoVerificationProofUrl'
}

export type VehicleDocumentsPatch = {
  approvalMailUrl?: InputMaybe<Scalars['String']>;
  blacklistProofUrl?: InputMaybe<Scalars['String']>;
  challanUrl?: InputMaybe<Scalars['String']>;
  fitnessCertificateUrl?: InputMaybe<Scalars['String']>;
  fitnessCertificateValidUpto?: InputMaybe<Scalars['DateTime']>;
  hsrbProofUrl?: InputMaybe<Scalars['String']>;
  hypothecationProofUrl?: InputMaybe<Scalars['String']>;
  registrationCertificateUrl?: InputMaybe<Scalars['String']>;
  rtoVerificationProofUrl?: InputMaybe<Scalars['String']>;
  vehicle?: InputMaybe<VehicleRef>;
};

export type VehicleDocumentsRef = {
  approvalMailUrl?: InputMaybe<Scalars['String']>;
  blacklistProofUrl?: InputMaybe<Scalars['String']>;
  challanUrl?: InputMaybe<Scalars['String']>;
  fitnessCertificateUrl?: InputMaybe<Scalars['String']>;
  fitnessCertificateValidUpto?: InputMaybe<Scalars['DateTime']>;
  hsrbProofUrl?: InputMaybe<Scalars['String']>;
  hypothecationProofUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  regNo?: InputMaybe<Scalars['String']>;
  registrationCertificateUrl?: InputMaybe<Scalars['String']>;
  rtoVerificationProofUrl?: InputMaybe<Scalars['String']>;
  vehicle?: InputMaybe<VehicleRef>;
};

export type VehicleFilter = {
  and?: InputMaybe<Array<InputMaybe<VehicleFilter>>>;
  chassisNumber?: InputMaybe<StringTermFilter>;
  engineCondition?: InputMaybe<IntFilter>;
  engineNumber?: InputMaybe<StringTermFilter>;
  has?: InputMaybe<Array<InputMaybe<VehicleHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  isRcAvailable?: InputMaybe<Scalars['Boolean']>;
  make?: InputMaybe<VehicleMake_Hash>;
  manufacturingDate?: InputMaybe<DateTimeFilter>;
  model?: InputMaybe<StringFullTextFilter>;
  not?: InputMaybe<VehicleFilter>;
  or?: InputMaybe<Array<InputMaybe<VehicleFilter>>>;
  purchaseDate?: InputMaybe<DateTimeFilter>;
  regNo?: InputMaybe<StringHashFilter>;
  registrationDate?: InputMaybe<DateTimeFilter>;
  registrationNumber?: InputMaybe<StringTermFilter>;
  tempModel?: InputMaybe<StringHashFilter>;
  totalHourRun?: InputMaybe<IntFilter>;
  totalKmsRun?: InputMaybe<IntFilter>;
  typeCondition?: InputMaybe<IntFilter>;
};

export type VehicleFinancing = {
  __typename?: 'VehicleFinancing';
  bankNOCUrl?: Maybe<Scalars['String']>;
  financerName?: Maybe<Scalars['String']>;
  foreclosureCertificateUrl?: Maybe<Scalars['String']>;
  form35Url?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isLoanClosed?: Maybe<Scalars['Boolean']>;
  loanToBeClosedBy?: Maybe<LoanToBeClosedBy>;
  pendingLoanAmount?: Maybe<Scalars['Int']>;
  tempFinancerName?: Maybe<Scalars['String']>;
  tempLoanToBeClosedBy?: Maybe<LoanToBeClosedBy>;
  vehicle: Vehicle;
};


export type VehicleFinancingVehicleArgs = {
  filter?: InputMaybe<VehicleFilter>;
};

export type VehicleFinancingAggregateResult = {
  __typename?: 'VehicleFinancingAggregateResult';
  bankNOCUrlMax?: Maybe<Scalars['String']>;
  bankNOCUrlMin?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  financerNameMax?: Maybe<Scalars['String']>;
  financerNameMin?: Maybe<Scalars['String']>;
  foreclosureCertificateUrlMax?: Maybe<Scalars['String']>;
  foreclosureCertificateUrlMin?: Maybe<Scalars['String']>;
  form35UrlMax?: Maybe<Scalars['String']>;
  form35UrlMin?: Maybe<Scalars['String']>;
  pendingLoanAmountAvg?: Maybe<Scalars['Float']>;
  pendingLoanAmountMax?: Maybe<Scalars['Int']>;
  pendingLoanAmountMin?: Maybe<Scalars['Int']>;
  pendingLoanAmountSum?: Maybe<Scalars['Int']>;
  tempFinancerNameMax?: Maybe<Scalars['String']>;
  tempFinancerNameMin?: Maybe<Scalars['String']>;
};

export type VehicleFinancingFilter = {
  and?: InputMaybe<Array<InputMaybe<VehicleFinancingFilter>>>;
  has?: InputMaybe<Array<InputMaybe<VehicleFinancingHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<VehicleFinancingFilter>;
  or?: InputMaybe<Array<InputMaybe<VehicleFinancingFilter>>>;
};

export enum VehicleFinancingHasFilter {
  BankNocUrl = 'bankNOCUrl',
  FinancerName = 'financerName',
  ForeclosureCertificateUrl = 'foreclosureCertificateUrl',
  Form35Url = 'form35Url',
  IsLoanClosed = 'isLoanClosed',
  LoanToBeClosedBy = 'loanToBeClosedBy',
  PendingLoanAmount = 'pendingLoanAmount',
  TempFinancerName = 'tempFinancerName',
  TempLoanToBeClosedBy = 'tempLoanToBeClosedBy',
  Vehicle = 'vehicle'
}

export type VehicleFinancingOrder = {
  asc?: InputMaybe<VehicleFinancingOrderable>;
  desc?: InputMaybe<VehicleFinancingOrderable>;
  then?: InputMaybe<VehicleFinancingOrder>;
};

export enum VehicleFinancingOrderable {
  BankNocUrl = 'bankNOCUrl',
  FinancerName = 'financerName',
  ForeclosureCertificateUrl = 'foreclosureCertificateUrl',
  Form35Url = 'form35Url',
  PendingLoanAmount = 'pendingLoanAmount',
  TempFinancerName = 'tempFinancerName'
}

export type VehicleFinancingPatch = {
  bankNOCUrl?: InputMaybe<Scalars['String']>;
  financerName?: InputMaybe<Scalars['String']>;
  foreclosureCertificateUrl?: InputMaybe<Scalars['String']>;
  form35Url?: InputMaybe<Scalars['String']>;
  isLoanClosed?: InputMaybe<Scalars['Boolean']>;
  loanToBeClosedBy?: InputMaybe<LoanToBeClosedBy>;
  pendingLoanAmount?: InputMaybe<Scalars['Int']>;
  tempFinancerName?: InputMaybe<Scalars['String']>;
  tempLoanToBeClosedBy?: InputMaybe<LoanToBeClosedBy>;
  vehicle?: InputMaybe<VehicleRef>;
};

export type VehicleFinancingRef = {
  bankNOCUrl?: InputMaybe<Scalars['String']>;
  financerName?: InputMaybe<Scalars['String']>;
  foreclosureCertificateUrl?: InputMaybe<Scalars['String']>;
  form35Url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  isLoanClosed?: InputMaybe<Scalars['Boolean']>;
  loanToBeClosedBy?: InputMaybe<LoanToBeClosedBy>;
  pendingLoanAmount?: InputMaybe<Scalars['Int']>;
  tempFinancerName?: InputMaybe<Scalars['String']>;
  tempLoanToBeClosedBy?: InputMaybe<LoanToBeClosedBy>;
  vehicle?: InputMaybe<VehicleRef>;
};

export enum VehicleFuelType {
  Diesel = 'DIESEL',
  Petrol = 'PETROL'
}

export enum VehicleHasFilter {
  ChallanAmount = 'challanAmount',
  ChassisNumber = 'chassisNumber',
  Color = 'color',
  Documents = 'documents',
  DueTaxesAmount = 'dueTaxesAmount',
  EngineCondition = 'engineCondition',
  EngineNumber = 'engineNumber',
  FinancingDetails = 'financingDetails',
  FitnessValidUpto = 'fitnessValidUpto',
  FuelType = 'fuelType',
  HasDueTaxes = 'hasDueTaxes',
  HorsePower = 'horsePower',
  HoursMeter = 'hoursMeter',
  Images = 'images',
  InsuranceDetails = 'insuranceDetails',
  IsBlacklisted = 'isBlacklisted',
  IsChallanAvailable = 'isChallanAvailable',
  IsHsrpAvailable = 'isHSRPAvailable',
  IsHypo = 'isHypo',
  IsRcAvailable = 'isRcAvailable',
  IsVehicleFinanced = 'isVehicleFinanced',
  IsVehicleInsured = 'isVehicleInsured',
  Kind = 'kind',
  Make = 'make',
  ManufacturingDate = 'manufacturingDate',
  Model = 'model',
  Owner = 'owner',
  Price = 'price',
  PurchaseDate = 'purchaseDate',
  RegNo = 'regNo',
  RegistrationDate = 'registrationDate',
  RegistrationNumber = 'registrationNumber',
  RepossessionDate = 'repossessionDate',
  TempChassisNumber = 'tempChassisNumber',
  TempEngineNumber = 'tempEngineNumber',
  TempIsVehicleFinanced = 'tempIsVehicleFinanced',
  TempMake = 'tempMake',
  TempManufacturingDate = 'tempManufacturingDate',
  TempModel = 'tempModel',
  TempRepossessionDate = 'tempRepossessionDate',
  TempVehicleBrand = 'tempVehicleBrand',
  TempVehicleModel = 'tempVehicleModel',
  TotalHourRun = 'totalHourRun',
  TotalKmsRun = 'totalKmsRun',
  TypeCondition = 'typeCondition',
  VehicleBrand = 'vehicleBrand',
  VehicleModel = 'vehicleModel',
  VerificationRemarks = 'verificationRemarks'
}

export type VehicleImages = {
  __typename?: 'VehicleImages';
  backBodySide?: Maybe<Scalars['String']>;
  backLeftTyre?: Maybe<Scalars['String']>;
  backRightTyre?: Maybe<Scalars['String']>;
  chassisNumber?: Maybe<Scalars['String']>;
  engineNumber?: Maybe<Scalars['String']>;
  frontBodySide?: Maybe<Scalars['String']>;
  frontLeftTyre?: Maybe<Scalars['String']>;
  frontRightTyre?: Maybe<Scalars['String']>;
  fuelInjectionPumpPlate?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imagesTakenAtStage?: Maybe<ImageStage>;
  inspectionVideoUrl?: Maybe<Scalars['String']>;
  leftBodySide?: Maybe<Scalars['String']>;
  odometer?: Maybe<Scalars['String']>;
  rightBodySide?: Maybe<Scalars['String']>;
  vehicle: Vehicle;
  /** syntax : regNo_imageStage */
  vehicleImagesId: Scalars['String'];
};


export type VehicleImagesVehicleArgs = {
  filter?: InputMaybe<VehicleFilter>;
};

export type VehicleImagesAggregateResult = {
  __typename?: 'VehicleImagesAggregateResult';
  backBodySideMax?: Maybe<Scalars['String']>;
  backBodySideMin?: Maybe<Scalars['String']>;
  backLeftTyreMax?: Maybe<Scalars['String']>;
  backLeftTyreMin?: Maybe<Scalars['String']>;
  backRightTyreMax?: Maybe<Scalars['String']>;
  backRightTyreMin?: Maybe<Scalars['String']>;
  chassisNumberMax?: Maybe<Scalars['String']>;
  chassisNumberMin?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  engineNumberMax?: Maybe<Scalars['String']>;
  engineNumberMin?: Maybe<Scalars['String']>;
  frontBodySideMax?: Maybe<Scalars['String']>;
  frontBodySideMin?: Maybe<Scalars['String']>;
  frontLeftTyreMax?: Maybe<Scalars['String']>;
  frontLeftTyreMin?: Maybe<Scalars['String']>;
  frontRightTyreMax?: Maybe<Scalars['String']>;
  frontRightTyreMin?: Maybe<Scalars['String']>;
  fuelInjectionPumpPlateMax?: Maybe<Scalars['String']>;
  fuelInjectionPumpPlateMin?: Maybe<Scalars['String']>;
  inspectionVideoUrlMax?: Maybe<Scalars['String']>;
  inspectionVideoUrlMin?: Maybe<Scalars['String']>;
  leftBodySideMax?: Maybe<Scalars['String']>;
  leftBodySideMin?: Maybe<Scalars['String']>;
  odometerMax?: Maybe<Scalars['String']>;
  odometerMin?: Maybe<Scalars['String']>;
  rightBodySideMax?: Maybe<Scalars['String']>;
  rightBodySideMin?: Maybe<Scalars['String']>;
  vehicleImagesIdMax?: Maybe<Scalars['String']>;
  vehicleImagesIdMin?: Maybe<Scalars['String']>;
};

export type VehicleImagesFilter = {
  and?: InputMaybe<Array<InputMaybe<VehicleImagesFilter>>>;
  has?: InputMaybe<Array<InputMaybe<VehicleImagesHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  imagesTakenAtStage?: InputMaybe<ImageStage_Hash>;
  not?: InputMaybe<VehicleImagesFilter>;
  or?: InputMaybe<Array<InputMaybe<VehicleImagesFilter>>>;
  vehicleImagesId?: InputMaybe<StringHashFilter>;
};

export enum VehicleImagesHasFilter {
  BackBodySide = 'backBodySide',
  BackLeftTyre = 'backLeftTyre',
  BackRightTyre = 'backRightTyre',
  ChassisNumber = 'chassisNumber',
  EngineNumber = 'engineNumber',
  FrontBodySide = 'frontBodySide',
  FrontLeftTyre = 'frontLeftTyre',
  FrontRightTyre = 'frontRightTyre',
  FuelInjectionPumpPlate = 'fuelInjectionPumpPlate',
  ImagesTakenAtStage = 'imagesTakenAtStage',
  InspectionVideoUrl = 'inspectionVideoUrl',
  LeftBodySide = 'leftBodySide',
  Odometer = 'odometer',
  RightBodySide = 'rightBodySide',
  Vehicle = 'vehicle',
  VehicleImagesId = 'vehicleImagesId'
}

export type VehicleImagesOrder = {
  asc?: InputMaybe<VehicleImagesOrderable>;
  desc?: InputMaybe<VehicleImagesOrderable>;
  then?: InputMaybe<VehicleImagesOrder>;
};

export enum VehicleImagesOrderable {
  BackBodySide = 'backBodySide',
  BackLeftTyre = 'backLeftTyre',
  BackRightTyre = 'backRightTyre',
  ChassisNumber = 'chassisNumber',
  EngineNumber = 'engineNumber',
  FrontBodySide = 'frontBodySide',
  FrontLeftTyre = 'frontLeftTyre',
  FrontRightTyre = 'frontRightTyre',
  FuelInjectionPumpPlate = 'fuelInjectionPumpPlate',
  InspectionVideoUrl = 'inspectionVideoUrl',
  LeftBodySide = 'leftBodySide',
  Odometer = 'odometer',
  RightBodySide = 'rightBodySide',
  VehicleImagesId = 'vehicleImagesId'
}

export type VehicleImagesPatch = {
  backBodySide?: InputMaybe<Scalars['String']>;
  backLeftTyre?: InputMaybe<Scalars['String']>;
  backRightTyre?: InputMaybe<Scalars['String']>;
  chassisNumber?: InputMaybe<Scalars['String']>;
  engineNumber?: InputMaybe<Scalars['String']>;
  frontBodySide?: InputMaybe<Scalars['String']>;
  frontLeftTyre?: InputMaybe<Scalars['String']>;
  frontRightTyre?: InputMaybe<Scalars['String']>;
  fuelInjectionPumpPlate?: InputMaybe<Scalars['String']>;
  imagesTakenAtStage?: InputMaybe<ImageStage>;
  inspectionVideoUrl?: InputMaybe<Scalars['String']>;
  leftBodySide?: InputMaybe<Scalars['String']>;
  odometer?: InputMaybe<Scalars['String']>;
  rightBodySide?: InputMaybe<Scalars['String']>;
  vehicle?: InputMaybe<VehicleRef>;
};

export type VehicleImagesRef = {
  backBodySide?: InputMaybe<Scalars['String']>;
  backLeftTyre?: InputMaybe<Scalars['String']>;
  backRightTyre?: InputMaybe<Scalars['String']>;
  chassisNumber?: InputMaybe<Scalars['String']>;
  engineNumber?: InputMaybe<Scalars['String']>;
  frontBodySide?: InputMaybe<Scalars['String']>;
  frontLeftTyre?: InputMaybe<Scalars['String']>;
  frontRightTyre?: InputMaybe<Scalars['String']>;
  fuelInjectionPumpPlate?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  imagesTakenAtStage?: InputMaybe<ImageStage>;
  inspectionVideoUrl?: InputMaybe<Scalars['String']>;
  leftBodySide?: InputMaybe<Scalars['String']>;
  odometer?: InputMaybe<Scalars['String']>;
  rightBodySide?: InputMaybe<Scalars['String']>;
  vehicle?: InputMaybe<VehicleRef>;
  /** syntax : regNo_imageStage */
  vehicleImagesId?: InputMaybe<Scalars['String']>;
};

export type VehicleInsurance = {
  __typename?: 'VehicleInsurance';
  id: Scalars['ID'];
  insuraceCertificateUrl?: Maybe<Scalars['String']>;
  insuranceType?: Maybe<InsuranceType>;
  insurerName?: Maybe<InsurerName>;
  policyExpiryDate?: Maybe<Scalars['DateTime']>;
  policyNumber?: Maybe<Scalars['String']>;
  vehicle: Vehicle;
};


export type VehicleInsuranceVehicleArgs = {
  filter?: InputMaybe<VehicleFilter>;
};

export type VehicleInsuranceAggregateResult = {
  __typename?: 'VehicleInsuranceAggregateResult';
  count?: Maybe<Scalars['Int']>;
  insuraceCertificateUrlMax?: Maybe<Scalars['String']>;
  insuraceCertificateUrlMin?: Maybe<Scalars['String']>;
  policyExpiryDateMax?: Maybe<Scalars['DateTime']>;
  policyExpiryDateMin?: Maybe<Scalars['DateTime']>;
  policyNumberMax?: Maybe<Scalars['String']>;
  policyNumberMin?: Maybe<Scalars['String']>;
};

export type VehicleInsuranceFilter = {
  and?: InputMaybe<Array<InputMaybe<VehicleInsuranceFilter>>>;
  has?: InputMaybe<Array<InputMaybe<VehicleInsuranceHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<VehicleInsuranceFilter>;
  or?: InputMaybe<Array<InputMaybe<VehicleInsuranceFilter>>>;
  policyExpiryDate?: InputMaybe<DateTimeFilter>;
};

export enum VehicleInsuranceHasFilter {
  InsuraceCertificateUrl = 'insuraceCertificateUrl',
  InsuranceType = 'insuranceType',
  InsurerName = 'insurerName',
  PolicyExpiryDate = 'policyExpiryDate',
  PolicyNumber = 'policyNumber',
  Vehicle = 'vehicle'
}

export type VehicleInsuranceOrder = {
  asc?: InputMaybe<VehicleInsuranceOrderable>;
  desc?: InputMaybe<VehicleInsuranceOrderable>;
  then?: InputMaybe<VehicleInsuranceOrder>;
};

export enum VehicleInsuranceOrderable {
  InsuraceCertificateUrl = 'insuraceCertificateUrl',
  PolicyExpiryDate = 'policyExpiryDate',
  PolicyNumber = 'policyNumber'
}

export type VehicleInsurancePatch = {
  insuraceCertificateUrl?: InputMaybe<Scalars['String']>;
  insuranceType?: InputMaybe<InsuranceType>;
  insurerName?: InputMaybe<InsurerName>;
  policyExpiryDate?: InputMaybe<Scalars['DateTime']>;
  policyNumber?: InputMaybe<Scalars['String']>;
  vehicle?: InputMaybe<VehicleRef>;
};

export type VehicleInsuranceRef = {
  id?: InputMaybe<Scalars['ID']>;
  insuraceCertificateUrl?: InputMaybe<Scalars['String']>;
  insuranceType?: InputMaybe<InsuranceType>;
  insurerName?: InputMaybe<InsurerName>;
  policyExpiryDate?: InputMaybe<Scalars['DateTime']>;
  policyNumber?: InputMaybe<Scalars['String']>;
  vehicle?: InputMaybe<VehicleRef>;
};

export enum VehicleKind {
  Bike = 'BIKE',
  Infra = 'INFRA',
  Tractor = 'TRACTOR',
  Truck = 'TRUCK'
}

export enum VehicleMake {
  Ace = 'ACE',
  Captain = 'CAPTAIN',
  DeutzFahr = 'DEUTZ_FAHR',
  Digitrac = 'DIGITRAC',
  Eicher = 'EICHER',
  Escort = 'ESCORT',
  Escorts = 'ESCORTS',
  Farmtrac = 'FARMTRAC',
  Force = 'FORCE',
  Hindustan = 'HINDUSTAN',
  JohnDeere = 'JOHN_DEERE',
  Kartar = 'KARTAR',
  Kubota = 'KUBOTA',
  Mahindra = 'MAHINDRA',
  MasseyFerguson = 'MASSEY_FERGUSON',
  NewHolland = 'NEW_HOLLAND',
  Powertrac = 'POWERTRAC',
  Preet = 'PREET',
  Solis = 'SOLIS',
  Sonalika = 'SONALIKA',
  Standard = 'STANDARD',
  Swaraj = 'SWARAJ',
  Tracstar = 'TRACSTAR',
  Vst = 'VST'
}

export type VehicleMake_Hash = {
  eq?: InputMaybe<VehicleMake>;
  in?: InputMaybe<Array<InputMaybe<VehicleMake>>>;
};

export enum VehicleModel {
  AceDi_854Ng = 'ACE__DI_854_NG',
  Captain_120Di = 'CAPTAIN__120_DI',
  Captain_120Di_4Wd = 'CAPTAIN__120_DI_4WD',
  Captain_200Di = 'CAPTAIN__200_DI',
  Eicher_242 = 'EICHER__242',
  JohnDeere_5050E = 'JOHN_DEERE__5050_E',
  Mahindra_265Di = 'MAHINDRA__265_DI',
  MahindraArjunNovo_605DiI_4Wd = 'MAHINDRA__ARJUN_NOVO_605_DI_I_4WD'
}

export type VehicleOrder = {
  asc?: InputMaybe<VehicleOrderable>;
  desc?: InputMaybe<VehicleOrderable>;
  then?: InputMaybe<VehicleOrder>;
};

export enum VehicleOrderable {
  ChallanAmount = 'challanAmount',
  ChassisNumber = 'chassisNumber',
  Color = 'color',
  DueTaxesAmount = 'dueTaxesAmount',
  EngineCondition = 'engineCondition',
  EngineNumber = 'engineNumber',
  FitnessValidUpto = 'fitnessValidUpto',
  HorsePower = 'horsePower',
  HoursMeter = 'hoursMeter',
  ManufacturingDate = 'manufacturingDate',
  Model = 'model',
  Price = 'price',
  PurchaseDate = 'purchaseDate',
  RegNo = 'regNo',
  RegistrationDate = 'registrationDate',
  RegistrationNumber = 'registrationNumber',
  RepossessionDate = 'repossessionDate',
  TempChassisNumber = 'tempChassisNumber',
  TempEngineNumber = 'tempEngineNumber',
  TempManufacturingDate = 'tempManufacturingDate',
  TempModel = 'tempModel',
  TempRepossessionDate = 'tempRepossessionDate',
  TotalHourRun = 'totalHourRun',
  TotalKmsRun = 'totalKmsRun',
  TypeCondition = 'typeCondition',
  VerificationRemarks = 'verificationRemarks'
}

export type VehicleOwner = {
  __typename?: 'VehicleOwner';
  address?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  orgName?: Maybe<Scalars['String']>;
  phoneNo: Scalars['String'];
  pincode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  tehsil?: Maybe<Scalars['String']>;
};

export type VehicleOwnerAggregateResult = {
  __typename?: 'VehicleOwnerAggregateResult';
  addressMax?: Maybe<Scalars['String']>;
  addressMin?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  districtMax?: Maybe<Scalars['String']>;
  districtMin?: Maybe<Scalars['String']>;
  emailMax?: Maybe<Scalars['String']>;
  emailMin?: Maybe<Scalars['String']>;
  nameMax?: Maybe<Scalars['String']>;
  nameMin?: Maybe<Scalars['String']>;
  orgNameMax?: Maybe<Scalars['String']>;
  orgNameMin?: Maybe<Scalars['String']>;
  phoneNoMax?: Maybe<Scalars['String']>;
  phoneNoMin?: Maybe<Scalars['String']>;
  pincodeMax?: Maybe<Scalars['String']>;
  pincodeMin?: Maybe<Scalars['String']>;
  stateMax?: Maybe<Scalars['String']>;
  stateMin?: Maybe<Scalars['String']>;
  tehsilMax?: Maybe<Scalars['String']>;
  tehsilMin?: Maybe<Scalars['String']>;
};

export type VehicleOwnerFilter = {
  and?: InputMaybe<Array<InputMaybe<VehicleOwnerFilter>>>;
  district?: InputMaybe<StringTermFilter>;
  has?: InputMaybe<Array<InputMaybe<VehicleOwnerHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<StringTermFilter>;
  not?: InputMaybe<VehicleOwnerFilter>;
  or?: InputMaybe<Array<InputMaybe<VehicleOwnerFilter>>>;
  phoneNo?: InputMaybe<StringTermFilter>;
  state?: InputMaybe<StringTermFilter>;
};

export enum VehicleOwnerHasFilter {
  Address = 'address',
  District = 'district',
  Email = 'email',
  Name = 'name',
  OrgName = 'orgName',
  PhoneNo = 'phoneNo',
  Pincode = 'pincode',
  State = 'state',
  Tehsil = 'tehsil'
}

export type VehicleOwnerOrder = {
  asc?: InputMaybe<VehicleOwnerOrderable>;
  desc?: InputMaybe<VehicleOwnerOrderable>;
  then?: InputMaybe<VehicleOwnerOrder>;
};

export enum VehicleOwnerOrderable {
  Address = 'address',
  District = 'district',
  Email = 'email',
  Name = 'name',
  OrgName = 'orgName',
  PhoneNo = 'phoneNo',
  Pincode = 'pincode',
  State = 'state',
  Tehsil = 'tehsil'
}

export type VehicleOwnerPatch = {
  address?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  orgName?: InputMaybe<Scalars['String']>;
  phoneNo?: InputMaybe<Scalars['String']>;
  pincode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  tehsil?: InputMaybe<Scalars['String']>;
};

export type VehicleOwnerRef = {
  address?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  orgName?: InputMaybe<Scalars['String']>;
  phoneNo?: InputMaybe<Scalars['String']>;
  pincode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  tehsil?: InputMaybe<Scalars['String']>;
};

export type VehiclePatch = {
  challanAmount?: InputMaybe<Scalars['Int']>;
  chassisNumber?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  documents?: InputMaybe<VehicleDocumentsRef>;
  dueTaxesAmount?: InputMaybe<Scalars['Int']>;
  engineCondition?: InputMaybe<Scalars['Int']>;
  engineNumber?: InputMaybe<Scalars['String']>;
  financingDetails?: InputMaybe<VehicleFinancingRef>;
  fitnessValidUpto?: InputMaybe<Scalars['DateTime']>;
  fuelType?: InputMaybe<VehicleFuelType>;
  hasDueTaxes?: InputMaybe<Scalars['Boolean']>;
  horsePower?: InputMaybe<Scalars['Int']>;
  hoursMeter?: InputMaybe<Scalars['Int']>;
  images?: InputMaybe<Array<InputMaybe<VehicleImagesRef>>>;
  insuranceDetails?: InputMaybe<VehicleInsuranceRef>;
  isBlacklisted?: InputMaybe<Scalars['Boolean']>;
  isChallanAvailable?: InputMaybe<Scalars['Boolean']>;
  isHSRPAvailable?: InputMaybe<Scalars['Boolean']>;
  isHypo?: InputMaybe<Scalars['Boolean']>;
  isRcAvailable?: InputMaybe<Scalars['Boolean']>;
  isVehicleFinanced?: InputMaybe<Scalars['Boolean']>;
  isVehicleInsured?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<VehicleKind>;
  make?: InputMaybe<VehicleMake>;
  manufacturingDate?: InputMaybe<Scalars['DateTime']>;
  model?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<VehicleOwnerRef>;
  price?: InputMaybe<Scalars['Int']>;
  purchaseDate?: InputMaybe<Scalars['DateTime']>;
  registrationDate?: InputMaybe<Scalars['DateTime']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
  repossessionDate?: InputMaybe<Scalars['DateTime']>;
  tempChassisNumber?: InputMaybe<Scalars['String']>;
  tempEngineNumber?: InputMaybe<Scalars['String']>;
  tempIsVehicleFinanced?: InputMaybe<Scalars['Boolean']>;
  tempMake?: InputMaybe<VehicleMake>;
  tempManufacturingDate?: InputMaybe<Scalars['DateTime']>;
  tempModel?: InputMaybe<Scalars['String']>;
  /** To be put in by the driver */
  tempRepossessionDate?: InputMaybe<Scalars['DateTime']>;
  tempVehicleBrand?: InputMaybe<BrandRef>;
  tempVehicleModel?: InputMaybe<ModelRef>;
  totalHourRun?: InputMaybe<Scalars['Int']>;
  totalKmsRun?: InputMaybe<Scalars['Int']>;
  typeCondition?: InputMaybe<Scalars['Int']>;
  vehicleBrand?: InputMaybe<BrandRef>;
  vehicleModel?: InputMaybe<ModelRef>;
  verificationRemarks?: InputMaybe<Scalars['String']>;
};

export type VehicleRef = {
  challanAmount?: InputMaybe<Scalars['Int']>;
  chassisNumber?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  documents?: InputMaybe<VehicleDocumentsRef>;
  dueTaxesAmount?: InputMaybe<Scalars['Int']>;
  engineCondition?: InputMaybe<Scalars['Int']>;
  engineNumber?: InputMaybe<Scalars['String']>;
  financingDetails?: InputMaybe<VehicleFinancingRef>;
  fitnessValidUpto?: InputMaybe<Scalars['DateTime']>;
  fuelType?: InputMaybe<VehicleFuelType>;
  hasDueTaxes?: InputMaybe<Scalars['Boolean']>;
  horsePower?: InputMaybe<Scalars['Int']>;
  hoursMeter?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  images?: InputMaybe<Array<InputMaybe<VehicleImagesRef>>>;
  insuranceDetails?: InputMaybe<VehicleInsuranceRef>;
  isBlacklisted?: InputMaybe<Scalars['Boolean']>;
  isChallanAvailable?: InputMaybe<Scalars['Boolean']>;
  isHSRPAvailable?: InputMaybe<Scalars['Boolean']>;
  isHypo?: InputMaybe<Scalars['Boolean']>;
  isRcAvailable?: InputMaybe<Scalars['Boolean']>;
  isVehicleFinanced?: InputMaybe<Scalars['Boolean']>;
  isVehicleInsured?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<VehicleKind>;
  make?: InputMaybe<VehicleMake>;
  manufacturingDate?: InputMaybe<Scalars['DateTime']>;
  model?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<VehicleOwnerRef>;
  price?: InputMaybe<Scalars['Int']>;
  purchaseDate?: InputMaybe<Scalars['DateTime']>;
  regNo?: InputMaybe<Scalars['String']>;
  registrationDate?: InputMaybe<Scalars['DateTime']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
  repossessionDate?: InputMaybe<Scalars['DateTime']>;
  tempChassisNumber?: InputMaybe<Scalars['String']>;
  tempEngineNumber?: InputMaybe<Scalars['String']>;
  tempIsVehicleFinanced?: InputMaybe<Scalars['Boolean']>;
  tempMake?: InputMaybe<VehicleMake>;
  tempManufacturingDate?: InputMaybe<Scalars['DateTime']>;
  tempModel?: InputMaybe<Scalars['String']>;
  /** To be put in by the driver */
  tempRepossessionDate?: InputMaybe<Scalars['DateTime']>;
  tempVehicleBrand?: InputMaybe<BrandRef>;
  tempVehicleModel?: InputMaybe<ModelRef>;
  totalHourRun?: InputMaybe<Scalars['Int']>;
  totalKmsRun?: InputMaybe<Scalars['Int']>;
  typeCondition?: InputMaybe<Scalars['Int']>;
  vehicleBrand?: InputMaybe<BrandRef>;
  vehicleModel?: InputMaybe<ModelRef>;
  verificationRemarks?: InputMaybe<Scalars['String']>;
};

export type VehicleTransferLog = {
  __typename?: 'VehicleTransferLog';
  assignedTo?: Maybe<User>;
  deliveredOn?: Maybe<Scalars['DateTime']>;
  from?: Maybe<Centre>;
  id: Scalars['ID'];
  lead?: Maybe<Lead>;
  pickupDate?: Maybe<Scalars['DateTime']>;
  remarks?: Maybe<Scalars['String']>;
  requestedOn?: Maybe<Scalars['DateTime']>;
  selfieUrl?: Maybe<Scalars['String']>;
  status?: Maybe<InternalTransferStatus>;
  to?: Maybe<Centre>;
};


export type VehicleTransferLogAssignedToArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type VehicleTransferLogFromArgs = {
  filter?: InputMaybe<CentreFilter>;
};


export type VehicleTransferLogLeadArgs = {
  filter?: InputMaybe<LeadFilter>;
};


export type VehicleTransferLogToArgs = {
  filter?: InputMaybe<CentreFilter>;
};

export type VehicleTransferLogAggregateResult = {
  __typename?: 'VehicleTransferLogAggregateResult';
  count?: Maybe<Scalars['Int']>;
  deliveredOnMax?: Maybe<Scalars['DateTime']>;
  deliveredOnMin?: Maybe<Scalars['DateTime']>;
  pickupDateMax?: Maybe<Scalars['DateTime']>;
  pickupDateMin?: Maybe<Scalars['DateTime']>;
  remarksMax?: Maybe<Scalars['String']>;
  remarksMin?: Maybe<Scalars['String']>;
  requestedOnMax?: Maybe<Scalars['DateTime']>;
  requestedOnMin?: Maybe<Scalars['DateTime']>;
  selfieUrlMax?: Maybe<Scalars['String']>;
  selfieUrlMin?: Maybe<Scalars['String']>;
};

export type VehicleTransferLogFilter = {
  and?: InputMaybe<Array<InputMaybe<VehicleTransferLogFilter>>>;
  has?: InputMaybe<Array<InputMaybe<VehicleTransferLogHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  not?: InputMaybe<VehicleTransferLogFilter>;
  or?: InputMaybe<Array<InputMaybe<VehicleTransferLogFilter>>>;
  status?: InputMaybe<InternalTransferStatus_Hash>;
};

export enum VehicleTransferLogHasFilter {
  AssignedTo = 'assignedTo',
  DeliveredOn = 'deliveredOn',
  From = 'from',
  Lead = 'lead',
  PickupDate = 'pickupDate',
  Remarks = 'remarks',
  RequestedOn = 'requestedOn',
  SelfieUrl = 'selfieUrl',
  Status = 'status',
  To = 'to'
}

export type VehicleTransferLogOrder = {
  asc?: InputMaybe<VehicleTransferLogOrderable>;
  desc?: InputMaybe<VehicleTransferLogOrderable>;
  then?: InputMaybe<VehicleTransferLogOrder>;
};

export enum VehicleTransferLogOrderable {
  DeliveredOn = 'deliveredOn',
  PickupDate = 'pickupDate',
  Remarks = 'remarks',
  RequestedOn = 'requestedOn',
  SelfieUrl = 'selfieUrl'
}

export type VehicleTransferLogPatch = {
  assignedTo?: InputMaybe<UserRef>;
  deliveredOn?: InputMaybe<Scalars['DateTime']>;
  from?: InputMaybe<CentreRef>;
  lead?: InputMaybe<LeadRef>;
  pickupDate?: InputMaybe<Scalars['DateTime']>;
  remarks?: InputMaybe<Scalars['String']>;
  requestedOn?: InputMaybe<Scalars['DateTime']>;
  selfieUrl?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<InternalTransferStatus>;
  to?: InputMaybe<CentreRef>;
};

export type VehicleTransferLogRef = {
  assignedTo?: InputMaybe<UserRef>;
  deliveredOn?: InputMaybe<Scalars['DateTime']>;
  from?: InputMaybe<CentreRef>;
  id?: InputMaybe<Scalars['ID']>;
  lead?: InputMaybe<LeadRef>;
  pickupDate?: InputMaybe<Scalars['DateTime']>;
  remarks?: InputMaybe<Scalars['String']>;
  requestedOn?: InputMaybe<Scalars['DateTime']>;
  selfieUrl?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<InternalTransferStatus>;
  to?: InputMaybe<CentreRef>;
};

export enum WalkinType {
  CallCenter = 'CALL_CENTER',
  Normal = 'NORMAL'
}

export type WithinFilter = {
  polygon: PolygonRef;
};

export type Yard = {
  __typename?: 'Yard';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  leads?: Maybe<Array<Maybe<Lead>>>;
  leadsAggregate?: Maybe<LeadAggregateResult>;
  location?: Maybe<Point>;
  locationUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  perDayParkingCharge?: Maybe<Scalars['Float']>;
  spocName?: Maybe<Scalars['String']>;
  spocNo?: Maybe<Scalars['String']>;
  tempPerDayParkingCharge?: Maybe<Scalars['Float']>;
};


export type YardLeadsArgs = {
  filter?: InputMaybe<LeadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadOrder>;
};


export type YardLeadsAggregateArgs = {
  filter?: InputMaybe<LeadFilter>;
};

export type YardAggregateResult = {
  __typename?: 'YardAggregateResult';
  addressMax?: Maybe<Scalars['String']>;
  addressMin?: Maybe<Scalars['String']>;
  cityMax?: Maybe<Scalars['String']>;
  cityMin?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  locationUrlMax?: Maybe<Scalars['String']>;
  locationUrlMin?: Maybe<Scalars['String']>;
  nameMax?: Maybe<Scalars['String']>;
  nameMin?: Maybe<Scalars['String']>;
  perDayParkingChargeAvg?: Maybe<Scalars['Float']>;
  perDayParkingChargeMax?: Maybe<Scalars['Float']>;
  perDayParkingChargeMin?: Maybe<Scalars['Float']>;
  perDayParkingChargeSum?: Maybe<Scalars['Float']>;
  spocNameMax?: Maybe<Scalars['String']>;
  spocNameMin?: Maybe<Scalars['String']>;
  spocNoMax?: Maybe<Scalars['String']>;
  spocNoMin?: Maybe<Scalars['String']>;
  tempPerDayParkingChargeAvg?: Maybe<Scalars['Float']>;
  tempPerDayParkingChargeMax?: Maybe<Scalars['Float']>;
  tempPerDayParkingChargeMin?: Maybe<Scalars['Float']>;
  tempPerDayParkingChargeSum?: Maybe<Scalars['Float']>;
};

export type YardFilter = {
  and?: InputMaybe<Array<InputMaybe<YardFilter>>>;
  has?: InputMaybe<Array<InputMaybe<YardHasFilter>>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<StringHashFilter>;
  not?: InputMaybe<YardFilter>;
  or?: InputMaybe<Array<InputMaybe<YardFilter>>>;
};

export enum YardHasFilter {
  Address = 'address',
  City = 'city',
  Leads = 'leads',
  Location = 'location',
  LocationUrl = 'locationUrl',
  Name = 'name',
  PerDayParkingCharge = 'perDayParkingCharge',
  SpocName = 'spocName',
  SpocNo = 'spocNo',
  TempPerDayParkingCharge = 'tempPerDayParkingCharge'
}

export type YardOrder = {
  asc?: InputMaybe<YardOrderable>;
  desc?: InputMaybe<YardOrderable>;
  then?: InputMaybe<YardOrder>;
};

export enum YardOrderable {
  Address = 'address',
  City = 'city',
  LocationUrl = 'locationUrl',
  Name = 'name',
  PerDayParkingCharge = 'perDayParkingCharge',
  SpocName = 'spocName',
  SpocNo = 'spocNo',
  TempPerDayParkingCharge = 'tempPerDayParkingCharge'
}

export type YardPatch = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  leads?: InputMaybe<Array<InputMaybe<LeadRef>>>;
  location?: InputMaybe<PointRef>;
  locationUrl?: InputMaybe<Scalars['String']>;
  perDayParkingCharge?: InputMaybe<Scalars['Float']>;
  spocName?: InputMaybe<Scalars['String']>;
  spocNo?: InputMaybe<Scalars['String']>;
  tempPerDayParkingCharge?: InputMaybe<Scalars['Float']>;
};

export type YardRef = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  leads?: InputMaybe<Array<InputMaybe<LeadRef>>>;
  location?: InputMaybe<PointRef>;
  locationUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  perDayParkingCharge?: InputMaybe<Scalars['Float']>;
  spocName?: InputMaybe<Scalars['String']>;
  spocNo?: InputMaybe<Scalars['String']>;
  tempPerDayParkingCharge?: InputMaybe<Scalars['Float']>;
};

export type DocumentsAggregatesResult = {
  __typename?: 'documentsAggregatesResult';
  documentsCount?: Maybe<DocumentsCount>;
  leads?: Maybe<Array<Maybe<Lead>>>;
  leadsAggregate?: Maybe<LeadAggregateResult>;
};


export type DocumentsAggregatesResultDocumentsCountArgs = {
  filter?: InputMaybe<DocumentsCountFilter>;
};


export type DocumentsAggregatesResultLeadsArgs = {
  filter?: InputMaybe<LeadFilter>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<LeadOrder>;
};


export type DocumentsAggregatesResultLeadsAggregateArgs = {
  filter?: InputMaybe<LeadFilter>;
};

export type DocumentsAggregatesResultAggregateResult = {
  __typename?: 'documentsAggregatesResultAggregateResult';
  count?: Maybe<Scalars['Int']>;
};

export type DocumentsAggregatesResultFilter = {
  and?: InputMaybe<Array<InputMaybe<DocumentsAggregatesResultFilter>>>;
  has?: InputMaybe<Array<InputMaybe<DocumentsAggregatesResultHasFilter>>>;
  not?: InputMaybe<DocumentsAggregatesResultFilter>;
  or?: InputMaybe<Array<InputMaybe<DocumentsAggregatesResultFilter>>>;
};

export enum DocumentsAggregatesResultHasFilter {
  DocumentsCount = 'documentsCount',
  Leads = 'leads'
}

export type DocumentsAggregatesResultPatch = {
  documentsCount?: InputMaybe<DocumentsCountRef>;
  leads?: InputMaybe<Array<InputMaybe<LeadRef>>>;
};

export type DocumentsAggregatesResultRef = {
  documentsCount?: InputMaybe<DocumentsCountRef>;
  leads?: InputMaybe<Array<InputMaybe<LeadRef>>>;
};

export type AccessoriesCheckKeySpecifier = ('accessory' | 'id' | 'status' | AccessoriesCheckKeySpecifier)[];
export type AccessoriesCheckFieldPolicy = {
	accessory?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccessoriesCheckAggregateResultKeySpecifier = ('count' | AccessoriesCheckAggregateResultKeySpecifier)[];
export type AccessoriesCheckAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccessoriesCheckListWithStageKeySpecifier = ('backLeftTyre' | 'backRightTyre' | 'battery' | 'bumper' | 'drawbar' | 'frontLeftTyre' | 'frontRightTyre' | 'hood' | 'id' | 'regNo' | 'stage' | 'toplink' | AccessoriesCheckListWithStageKeySpecifier)[];
export type AccessoriesCheckListWithStageFieldPolicy = {
	backLeftTyre?: FieldPolicy<any> | FieldReadFunction<any>,
	backRightTyre?: FieldPolicy<any> | FieldReadFunction<any>,
	battery?: FieldPolicy<any> | FieldReadFunction<any>,
	bumper?: FieldPolicy<any> | FieldReadFunction<any>,
	drawbar?: FieldPolicy<any> | FieldReadFunction<any>,
	frontLeftTyre?: FieldPolicy<any> | FieldReadFunction<any>,
	frontRightTyre?: FieldPolicy<any> | FieldReadFunction<any>,
	hood?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	regNo?: FieldPolicy<any> | FieldReadFunction<any>,
	stage?: FieldPolicy<any> | FieldReadFunction<any>,
	toplink?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccessoriesCheckListWithStageAggregateResultKeySpecifier = ('count' | 'regNoMax' | 'regNoMin' | AccessoriesCheckListWithStageAggregateResultKeySpecifier)[];
export type AccessoriesCheckListWithStageAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	regNoMax?: FieldPolicy<any> | FieldReadFunction<any>,
	regNoMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccessoriesChecklistKeySpecifier = ('by' | 'checks' | 'checksAggregate' | 'id' | 'remarks' | 'stage' | AccessoriesChecklistKeySpecifier)[];
export type AccessoriesChecklistFieldPolicy = {
	by?: FieldPolicy<any> | FieldReadFunction<any>,
	checks?: FieldPolicy<any> | FieldReadFunction<any>,
	checksAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	remarks?: FieldPolicy<any> | FieldReadFunction<any>,
	stage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccessoriesChecklistAggregateResultKeySpecifier = ('count' | 'remarksMax' | 'remarksMin' | AccessoriesChecklistAggregateResultKeySpecifier)[];
export type AccessoriesChecklistAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	remarksMax?: FieldPolicy<any> | FieldReadFunction<any>,
	remarksMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActiveStateWithGSTNKeySpecifier = ('GSTNumber' | 'RTOCode' | 'active' | 'createdAt' | 'id' | 'state' | 'updatedAt' | ActiveStateWithGSTNKeySpecifier)[];
export type ActiveStateWithGSTNFieldPolicy = {
	GSTNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	RTOCode?: FieldPolicy<any> | FieldReadFunction<any>,
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActiveStateWithGSTNAggregateResultKeySpecifier = ('GSTNumberMax' | 'GSTNumberMin' | 'RTOCodeMax' | 'RTOCodeMin' | 'count' | 'createdAtMax' | 'createdAtMin' | 'stateMax' | 'stateMin' | 'updatedAtMax' | 'updatedAtMin' | ActiveStateWithGSTNAggregateResultKeySpecifier)[];
export type ActiveStateWithGSTNAggregateResultFieldPolicy = {
	GSTNumberMax?: FieldPolicy<any> | FieldReadFunction<any>,
	GSTNumberMin?: FieldPolicy<any> | FieldReadFunction<any>,
	RTOCodeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	RTOCodeMin?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	stateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	stateMin?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAtMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddAccessoriesCheckListWithStagePayloadKeySpecifier = ('accessoriesCheckListWithStage' | 'numUids' | AddAccessoriesCheckListWithStagePayloadKeySpecifier)[];
export type AddAccessoriesCheckListWithStagePayloadFieldPolicy = {
	accessoriesCheckListWithStage?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddAccessoriesCheckPayloadKeySpecifier = ('accessoriesCheck' | 'numUids' | AddAccessoriesCheckPayloadKeySpecifier)[];
export type AddAccessoriesCheckPayloadFieldPolicy = {
	accessoriesCheck?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddAccessoriesChecklistPayloadKeySpecifier = ('accessoriesChecklist' | 'numUids' | AddAccessoriesChecklistPayloadKeySpecifier)[];
export type AddAccessoriesChecklistPayloadFieldPolicy = {
	accessoriesChecklist?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddActiveStateWithGSTNPayloadKeySpecifier = ('activeStateWithGSTN' | 'numUids' | AddActiveStateWithGSTNPayloadKeySpecifier)[];
export type AddActiveStateWithGSTNPayloadFieldPolicy = {
	activeStateWithGSTN?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddAdminLeadStatusEventPayloadKeySpecifier = ('adminLeadStatusEvent' | 'numUids' | AddAdminLeadStatusEventPayloadKeySpecifier)[];
export type AddAdminLeadStatusEventPayloadFieldPolicy = {
	adminLeadStatusEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddAgencyPayloadKeySpecifier = ('agency' | 'numUids' | AddAgencyPayloadKeySpecifier)[];
export type AddAgencyPayloadFieldPolicy = {
	agency?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddAuctionHistoryPayloadKeySpecifier = ('auctionHistory' | 'numUids' | AddAuctionHistoryPayloadKeySpecifier)[];
export type AddAuctionHistoryPayloadFieldPolicy = {
	auctionHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddBankAuctionLeadCountByNamePayloadKeySpecifier = ('bankAuctionLeadCountByName' | 'numUids' | AddBankAuctionLeadCountByNamePayloadKeySpecifier)[];
export type AddBankAuctionLeadCountByNamePayloadFieldPolicy = {
	bankAuctionLeadCountByName?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddBankPayloadKeySpecifier = ('bank' | 'numUids' | AddBankPayloadKeySpecifier)[];
export type AddBankPayloadFieldPolicy = {
	bank?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddBookingPayloadKeySpecifier = ('booking' | 'numUids' | AddBookingPayloadKeySpecifier)[];
export type AddBookingPayloadFieldPolicy = {
	booking?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddBookingPaymentPayloadKeySpecifier = ('bookingPayment' | 'numUids' | AddBookingPaymentPayloadKeySpecifier)[];
export type AddBookingPaymentPayloadFieldPolicy = {
	bookingPayment?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddBrandPayloadKeySpecifier = ('brand' | 'numUids' | AddBrandPayloadKeySpecifier)[];
export type AddBrandPayloadFieldPolicy = {
	brand?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddBulkApprovalResponsePayloadKeySpecifier = ('bulkApprovalResponse' | 'numUids' | AddBulkApprovalResponsePayloadKeySpecifier)[];
export type AddBulkApprovalResponsePayloadFieldPolicy = {
	bulkApprovalResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddCenterlizeLocationDistrcitsResponsePayloadKeySpecifier = ('centerlizeLocationDistrcitsResponse' | 'numUids' | AddCenterlizeLocationDistrcitsResponsePayloadKeySpecifier)[];
export type AddCenterlizeLocationDistrcitsResponsePayloadFieldPolicy = {
	centerlizeLocationDistrcitsResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddCenterlizeLocationDistrictPayloadKeySpecifier = ('centerlizeLocationDistrict' | 'numUids' | AddCenterlizeLocationDistrictPayloadKeySpecifier)[];
export type AddCenterlizeLocationDistrictPayloadFieldPolicy = {
	centerlizeLocationDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddCenterlizeLocationStatesPayloadKeySpecifier = ('centerlizeLocationStates' | 'numUids' | AddCenterlizeLocationStatesPayloadKeySpecifier)[];
export type AddCenterlizeLocationStatesPayloadFieldPolicy = {
	centerlizeLocationStates?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddCenterlizeLocationStatesResponsePayloadKeySpecifier = ('centerlizeLocationStatesResponse' | 'numUids' | AddCenterlizeLocationStatesResponsePayloadKeySpecifier)[];
export type AddCenterlizeLocationStatesResponsePayloadFieldPolicy = {
	centerlizeLocationStatesResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddCenterlizeLocationTehsilPayloadKeySpecifier = ('centerlizeLocationTehsil' | 'numUids' | AddCenterlizeLocationTehsilPayloadKeySpecifier)[];
export type AddCenterlizeLocationTehsilPayloadFieldPolicy = {
	centerlizeLocationTehsil?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddCenterlizeLocationTehsilResponsePayloadKeySpecifier = ('centerlizeLocationTehsilResponse' | 'numUids' | AddCenterlizeLocationTehsilResponsePayloadKeySpecifier)[];
export type AddCenterlizeLocationTehsilResponsePayloadFieldPolicy = {
	centerlizeLocationTehsilResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddCentreAggregatesPayloadKeySpecifier = ('centreAggregates' | 'numUids' | AddCentreAggregatesPayloadKeySpecifier)[];
export type AddCentreAggregatesPayloadFieldPolicy = {
	centreAggregates?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddCentrePayloadKeySpecifier = ('centre' | 'numUids' | AddCentrePayloadKeySpecifier)[];
export type AddCentrePayloadFieldPolicy = {
	centre?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddCityPayloadKeySpecifier = ('city' | 'numUids' | AddCityPayloadKeySpecifier)[];
export type AddCityPayloadFieldPolicy = {
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddCreateBulkLeadResponsePayloadKeySpecifier = ('createBulkLeadResponse' | 'numUids' | AddCreateBulkLeadResponsePayloadKeySpecifier)[];
export type AddCreateBulkLeadResponsePayloadFieldPolicy = {
	createBulkLeadResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddCustomerPayloadKeySpecifier = ('customer' | 'numUids' | AddCustomerPayloadKeySpecifier)[];
export type AddCustomerPayloadFieldPolicy = {
	customer?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddDealerPayloadKeySpecifier = ('dealer' | 'numUids' | AddDealerPayloadKeySpecifier)[];
export type AddDealerPayloadFieldPolicy = {
	dealer?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddDealerStancePayloadKeySpecifier = ('dealerStance' | 'numUids' | AddDealerStancePayloadKeySpecifier)[];
export type AddDealerStancePayloadFieldPolicy = {
	dealerStance?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddDealershipDocumentPayloadKeySpecifier = ('dealershipDocument' | 'numUids' | AddDealershipDocumentPayloadKeySpecifier)[];
export type AddDealershipDocumentPayloadFieldPolicy = {
	dealershipDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddDealershipLeadCountByPENamePayloadKeySpecifier = ('dealershipLeadCountByPEName' | 'numUids' | AddDealershipLeadCountByPENamePayloadKeySpecifier)[];
export type AddDealershipLeadCountByPENamePayloadFieldPolicy = {
	dealershipLeadCountByPEName?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddDistrictPayloadKeySpecifier = ('district' | 'numUids' | AddDistrictPayloadKeySpecifier)[];
export type AddDistrictPayloadFieldPolicy = {
	district?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddDocumentChecklistPayloadKeySpecifier = ('documentChecklist' | 'numUids' | AddDocumentChecklistPayloadKeySpecifier)[];
export type AddDocumentChecklistPayloadFieldPolicy = {
	documentChecklist?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddDocumentPayloadKeySpecifier = ('document' | 'numUids' | AddDocumentPayloadKeySpecifier)[];
export type AddDocumentPayloadFieldPolicy = {
	document?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddDocumentsCountPayloadKeySpecifier = ('documentsCount' | 'numUids' | AddDocumentsCountPayloadKeySpecifier)[];
export type AddDocumentsCountPayloadFieldPolicy = {
	documentsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddDocumentsFollowupsPayloadKeySpecifier = ('documentsFollowups' | 'numUids' | AddDocumentsFollowupsPayloadKeySpecifier)[];
export type AddDocumentsFollowupsPayloadFieldPolicy = {
	documentsFollowups?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddDriverAggregatesPayloadKeySpecifier = ('driverAggregates' | 'numUids' | AddDriverAggregatesPayloadKeySpecifier)[];
export type AddDriverAggregatesPayloadFieldPolicy = {
	driverAggregates?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddEnquiryAdherencePayloadKeySpecifier = ('enquiryAdherence' | 'numUids' | AddEnquiryAdherencePayloadKeySpecifier)[];
export type AddEnquiryAdherencePayloadFieldPolicy = {
	enquiryAdherence?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddEnquiryAggByCentrePayloadKeySpecifier = ('enquiryAggByCentre' | 'numUids' | AddEnquiryAggByCentrePayloadKeySpecifier)[];
export type AddEnquiryAggByCentrePayloadFieldPolicy = {
	enquiryAggByCentre?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddEnquiryCloserAggPayloadKeySpecifier = ('enquiryCloserAgg' | 'numUids' | AddEnquiryCloserAggPayloadKeySpecifier)[];
export type AddEnquiryCloserAggPayloadFieldPolicy = {
	enquiryCloserAgg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddEnquiryClosurePayloadKeySpecifier = ('enquiryClosure' | 'numUids' | AddEnquiryClosurePayloadKeySpecifier)[];
export type AddEnquiryClosurePayloadFieldPolicy = {
	enquiryClosure?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddEnquiryPayloadKeySpecifier = ('enquiry' | 'numUids' | AddEnquiryPayloadKeySpecifier)[];
export type AddEnquiryPayloadFieldPolicy = {
	enquiry?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddFollowupPayloadKeySpecifier = ('followup' | 'numUids' | AddFollowupPayloadKeySpecifier)[];
export type AddFollowupPayloadFieldPolicy = {
	followup?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddIdByNamePayloadKeySpecifier = ('idByName' | 'numUids' | AddIdByNamePayloadKeySpecifier)[];
export type AddIdByNamePayloadFieldPolicy = {
	idByName?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddIdentificationDocumentPayloadKeySpecifier = ('identificationDocument' | 'numUids' | AddIdentificationDocumentPayloadKeySpecifier)[];
export type AddIdentificationDocumentPayloadFieldPolicy = {
	identificationDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddIdsByNameForListingReponsePayloadKeySpecifier = ('idsByNameForListingReponse' | 'numUids' | AddIdsByNameForListingReponsePayloadKeySpecifier)[];
export type AddIdsByNameForListingReponsePayloadFieldPolicy = {
	idsByNameForListingReponse?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddInventoryDetailsPayloadKeySpecifier = ('inventoryDetails' | 'numUids' | AddInventoryDetailsPayloadKeySpecifier)[];
export type AddInventoryDetailsPayloadFieldPolicy = {
	inventoryDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddIssueItemPayloadKeySpecifier = ('issueItem' | 'numUids' | AddIssueItemPayloadKeySpecifier)[];
export type AddIssueItemPayloadFieldPolicy = {
	issueItem?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddIssuePayloadKeySpecifier = ('issue' | 'numUids' | AddIssuePayloadKeySpecifier)[];
export type AddIssuePayloadFieldPolicy = {
	issue?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddItemInventoryDetailsPayloadKeySpecifier = ('itemInventoryDetails' | 'numUids' | AddItemInventoryDetailsPayloadKeySpecifier)[];
export type AddItemInventoryDetailsPayloadFieldPolicy = {
	itemInventoryDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddLeadCountByStatusPayloadKeySpecifier = ('leadCountByStatus' | 'numUids' | AddLeadCountByStatusPayloadKeySpecifier)[];
export type AddLeadCountByStatusPayloadFieldPolicy = {
	leadCountByStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddLeadDocumentsPayloadKeySpecifier = ('leadDocuments' | 'numUids' | AddLeadDocumentsPayloadKeySpecifier)[];
export type AddLeadDocumentsPayloadFieldPolicy = {
	leadDocuments?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddLeadExpensePayloadKeySpecifier = ('leadExpense' | 'numUids' | AddLeadExpensePayloadKeySpecifier)[];
export type AddLeadExpensePayloadFieldPolicy = {
	leadExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddLeadPayloadKeySpecifier = ('lead' | 'numUids' | AddLeadPayloadKeySpecifier)[];
export type AddLeadPayloadFieldPolicy = {
	lead?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddLeadStatusEventPayloadKeySpecifier = ('leadStatusEvent' | 'numUids' | AddLeadStatusEventPayloadKeySpecifier)[];
export type AddLeadStatusEventPayloadFieldPolicy = {
	leadStatusEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddLeadStatusFlowPayloadKeySpecifier = ('leadStatusFlow' | 'numUids' | AddLeadStatusFlowPayloadKeySpecifier)[];
export type AddLeadStatusFlowPayloadFieldPolicy = {
	leadStatusFlow?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddLeadTimelineActionPayloadKeySpecifier = ('leadTimelineAction' | 'numUids' | AddLeadTimelineActionPayloadKeySpecifier)[];
export type AddLeadTimelineActionPayloadFieldPolicy = {
	leadTimelineAction?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddLoanPayloadKeySpecifier = ('loan' | 'numUids' | AddLoanPayloadKeySpecifier)[];
export type AddLoanPayloadFieldPolicy = {
	loan?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddLogTrackingPayloadKeySpecifier = ('logTracking' | 'numUids' | AddLogTrackingPayloadKeySpecifier)[];
export type AddLogTrackingPayloadFieldPolicy = {
	logTracking?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddMarkSoldResponsePayloadKeySpecifier = ('markSoldResponse' | 'numUids' | AddMarkSoldResponsePayloadKeySpecifier)[];
export type AddMarkSoldResponsePayloadFieldPolicy = {
	markSoldResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddMessagePayloadKeySpecifier = ('message' | 'numUids' | AddMessagePayloadKeySpecifier)[];
export type AddMessagePayloadFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddModelByMakePayloadKeySpecifier = ('modelByMake' | 'numUids' | AddModelByMakePayloadKeySpecifier)[];
export type AddModelByMakePayloadFieldPolicy = {
	modelByMake?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddModelPayloadKeySpecifier = ('model' | 'numUids' | AddModelPayloadKeySpecifier)[];
export type AddModelPayloadFieldPolicy = {
	model?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddNotificationPayloadKeySpecifier = ('notification' | 'numUids' | AddNotificationPayloadKeySpecifier)[];
export type AddNotificationPayloadFieldPolicy = {
	notification?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddNumberOfPendingTasksPayloadKeySpecifier = ('numUids' | 'numberOfPendingTasks' | AddNumberOfPendingTasksPayloadKeySpecifier)[];
export type AddNumberOfPendingTasksPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfPendingTasks?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddParkingBeneficiaryPayloadKeySpecifier = ('numUids' | 'parkingBeneficiary' | AddParkingBeneficiaryPayloadKeySpecifier)[];
export type AddParkingBeneficiaryPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	parkingBeneficiary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddPaymentInvoicesPayloadKeySpecifier = ('numUids' | 'paymentInvoices' | AddPaymentInvoicesPayloadKeySpecifier)[];
export type AddPaymentInvoicesPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentInvoices?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddPaymentPayloadKeySpecifier = ('numUids' | 'payment' | AddPaymentPayloadKeySpecifier)[];
export type AddPaymentPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	payment?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddPickupPayloadKeySpecifier = ('numUids' | 'pickup' | AddPickupPayloadKeySpecifier)[];
export type AddPickupPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	pickup?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddProductPayloadKeySpecifier = ('numUids' | 'product' | AddProductPayloadKeySpecifier)[];
export type AddProductPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddPurchaseItemPayloadKeySpecifier = ('numUids' | 'purchaseItem' | AddPurchaseItemPayloadKeySpecifier)[];
export type AddPurchaseItemPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseItem?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddPurchasePayloadKeySpecifier = ('numUids' | 'purchase' | AddPurchasePayloadKeySpecifier)[];
export type AddPurchasePayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	purchase?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddRefurbishmentBeneficiaryPayloadKeySpecifier = ('numUids' | 'refurbishmentBeneficiary' | AddRefurbishmentBeneficiaryPayloadKeySpecifier)[];
export type AddRefurbishmentBeneficiaryPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	refurbishmentBeneficiary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddRefurbishmentDetailsPayloadKeySpecifier = ('numUids' | 'refurbishmentDetails' | AddRefurbishmentDetailsPayloadKeySpecifier)[];
export type AddRefurbishmentDetailsPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	refurbishmentDetails?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddRefurbishmentItemPayloadKeySpecifier = ('numUids' | 'refurbishmentItem' | AddRefurbishmentItemPayloadKeySpecifier)[];
export type AddRefurbishmentItemPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	refurbishmentItem?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddRefurbishmentRequestPayloadKeySpecifier = ('numUids' | 'refurbishmentRequest' | AddRefurbishmentRequestPayloadKeySpecifier)[];
export type AddRefurbishmentRequestPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	refurbishmentRequest?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddSMSLogsPayloadKeySpecifier = ('numUids' | 'sMSLogs' | AddSMSLogsPayloadKeySpecifier)[];
export type AddSMSLogsPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	sMSLogs?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddSendSmsToCustomerResponsePayloadKeySpecifier = ('numUids' | 'sendSmsToCustomerResponse' | AddSendSmsToCustomerResponsePayloadKeySpecifier)[];
export type AddSendSmsToCustomerResponsePayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	sendSmsToCustomerResponse?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddStateCodeWithRegNumberPayloadKeySpecifier = ('numUids' | 'stateCodeWithRegNumber' | AddStateCodeWithRegNumberPayloadKeySpecifier)[];
export type AddStateCodeWithRegNumberPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	stateCodeWithRegNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddStatusAggregatePayloadKeySpecifier = ('numUids' | 'statusAggregate' | AddStatusAggregatePayloadKeySpecifier)[];
export type AddStatusAggregatePayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	statusAggregate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddTJCentrePayloadKeySpecifier = ('numUids' | 'tJCentre' | AddTJCentrePayloadKeySpecifier)[];
export type AddTJCentrePayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	tJCentre?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddTaskPayloadKeySpecifier = ('numUids' | 'task' | AddTaskPayloadKeySpecifier)[];
export type AddTaskPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	task?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddTehsilPayloadKeySpecifier = ('numUids' | 'tehsil' | AddTehsilPayloadKeySpecifier)[];
export type AddTehsilPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	tehsil?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddTripExpensePayloadKeySpecifier = ('numUids' | 'tripExpense' | AddTripExpensePayloadKeySpecifier)[];
export type AddTripExpensePayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	tripExpense?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddUserPayloadKeySpecifier = ('numUids' | 'user' | AddUserPayloadKeySpecifier)[];
export type AddUserPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddVehicleDocumentsPayloadKeySpecifier = ('numUids' | 'vehicleDocuments' | AddVehicleDocumentsPayloadKeySpecifier)[];
export type AddVehicleDocumentsPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleDocuments?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddVehicleFinancingPayloadKeySpecifier = ('numUids' | 'vehicleFinancing' | AddVehicleFinancingPayloadKeySpecifier)[];
export type AddVehicleFinancingPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleFinancing?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddVehicleImagesPayloadKeySpecifier = ('numUids' | 'vehicleImages' | AddVehicleImagesPayloadKeySpecifier)[];
export type AddVehicleImagesPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleImages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddVehicleInsurancePayloadKeySpecifier = ('numUids' | 'vehicleInsurance' | AddVehicleInsurancePayloadKeySpecifier)[];
export type AddVehicleInsurancePayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleInsurance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddVehicleOwnerPayloadKeySpecifier = ('numUids' | 'vehicleOwner' | AddVehicleOwnerPayloadKeySpecifier)[];
export type AddVehicleOwnerPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleOwner?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddVehiclePayloadKeySpecifier = ('numUids' | 'vehicle' | AddVehiclePayloadKeySpecifier)[];
export type AddVehiclePayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicle?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddVehicleTransferLogPayloadKeySpecifier = ('numUids' | 'vehicleTransferLog' | AddVehicleTransferLogPayloadKeySpecifier)[];
export type AddVehicleTransferLogPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleTransferLog?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddYardPayloadKeySpecifier = ('numUids' | 'yard' | AddYardPayloadKeySpecifier)[];
export type AddYardPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	yard?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdddocumentsAggregatesResultPayloadKeySpecifier = ('documentsAggregatesResult' | 'numUids' | AdddocumentsAggregatesResultPayloadKeySpecifier)[];
export type AdddocumentsAggregatesResultPayloadFieldPolicy = {
	documentsAggregatesResult?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdminLeadStatusEventKeySpecifier = ('createdAt' | 'createdBy' | 'id' | 'lead' | 'notification' | 'notifyTo' | 'status' | AdminLeadStatusEventKeySpecifier)[];
export type AdminLeadStatusEventFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lead?: FieldPolicy<any> | FieldReadFunction<any>,
	notification?: FieldPolicy<any> | FieldReadFunction<any>,
	notifyTo?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdminLeadStatusEventAggregateResultKeySpecifier = ('count' | 'createdAtMax' | 'createdAtMin' | AdminLeadStatusEventAggregateResultKeySpecifier)[];
export type AdminLeadStatusEventAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AgencyKeySpecifier = ('id' | 'leads' | 'leadsAggregate' | 'name' | 'spocNo' | AgencyKeySpecifier)[];
export type AgencyFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	leads?: FieldPolicy<any> | FieldReadFunction<any>,
	leadsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	spocNo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AgencyAggregateResultKeySpecifier = ('count' | 'nameMax' | 'nameMin' | 'spocNoMax' | 'spocNoMin' | AgencyAggregateResultKeySpecifier)[];
export type AgencyAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	spocNoMax?: FieldPolicy<any> | FieldReadFunction<any>,
	spocNoMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AuctionHistoryKeySpecifier = ('amount' | 'createdAt' | 'id' | 'status' | 'updatedAt' | AuctionHistoryKeySpecifier)[];
export type AuctionHistoryFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AuctionHistoryAggregateResultKeySpecifier = ('amountAvg' | 'amountMax' | 'amountMin' | 'amountSum' | 'count' | 'createdAtMax' | 'createdAtMin' | 'updatedAtMax' | 'updatedAtMin' | AuctionHistoryAggregateResultKeySpecifier)[];
export type AuctionHistoryAggregateResultFieldPolicy = {
	amountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	amountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	amountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	amountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAtMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BankKeySpecifier = ('id' | 'leads' | 'leadsAggregate' | 'name' | 'spocNo' | BankKeySpecifier)[];
export type BankFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	leads?: FieldPolicy<any> | FieldReadFunction<any>,
	leadsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	spocNo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BankAggregateResultKeySpecifier = ('count' | 'nameMax' | 'nameMin' | 'spocNoMax' | 'spocNoMin' | BankAggregateResultKeySpecifier)[];
export type BankAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	spocNoMax?: FieldPolicy<any> | FieldReadFunction<any>,
	spocNoMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BankAuctionLeadCountByNameKeySpecifier = ('approvalRecived' | 'bankName' | 'vahanChecked' | 'vehicleInAuction' | 'wonInAuction' | BankAuctionLeadCountByNameKeySpecifier)[];
export type BankAuctionLeadCountByNameFieldPolicy = {
	approvalRecived?: FieldPolicy<any> | FieldReadFunction<any>,
	bankName?: FieldPolicy<any> | FieldReadFunction<any>,
	vahanChecked?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleInAuction?: FieldPolicy<any> | FieldReadFunction<any>,
	wonInAuction?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BankAuctionLeadCountByNameAggregateResultKeySpecifier = ('approvalRecivedMax' | 'approvalRecivedMin' | 'bankNameMax' | 'bankNameMin' | 'count' | 'vahanCheckedMax' | 'vahanCheckedMin' | 'vehicleInAuctionMax' | 'vehicleInAuctionMin' | 'wonInAuctionMax' | 'wonInAuctionMin' | BankAuctionLeadCountByNameAggregateResultKeySpecifier)[];
export type BankAuctionLeadCountByNameAggregateResultFieldPolicy = {
	approvalRecivedMax?: FieldPolicy<any> | FieldReadFunction<any>,
	approvalRecivedMin?: FieldPolicy<any> | FieldReadFunction<any>,
	bankNameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	bankNameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	vahanCheckedMax?: FieldPolicy<any> | FieldReadFunction<any>,
	vahanCheckedMin?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleInAuctionMax?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleInAuctionMin?: FieldPolicy<any> | FieldReadFunction<any>,
	wonInAuctionMax?: FieldPolicy<any> | FieldReadFunction<any>,
	wonInAuctionMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BookingKeySpecifier = ('activeLoan' | 'archivedLoans' | 'archivedLoansAggregate' | 'bookingPayment' | 'cancellationReason' | 'cancellationRemarks' | 'cancelledChequeUrl' | 'cheque' | 'createdAt' | 'customer' | 'deliveryForm' | 'deliveryPhotoUrl' | 'id' | 'isInsuranceReq' | 'isLoanDrop' | 'isRCTransferReq' | 'lead' | 'leadWithActiveBooking' | 'leadWithArchivedBooking' | 'loanCancellationReason' | 'payments' | 'paymentsAggregate' | 'searchString' | 'status' | 'updatedAt' | 'vehicleTransferFormUrl' | BookingKeySpecifier)[];
export type BookingFieldPolicy = {
	activeLoan?: FieldPolicy<any> | FieldReadFunction<any>,
	archivedLoans?: FieldPolicy<any> | FieldReadFunction<any>,
	archivedLoansAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingPayment?: FieldPolicy<any> | FieldReadFunction<any>,
	cancellationReason?: FieldPolicy<any> | FieldReadFunction<any>,
	cancellationRemarks?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelledChequeUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	cheque?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	customer?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryForm?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryPhotoUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isInsuranceReq?: FieldPolicy<any> | FieldReadFunction<any>,
	isLoanDrop?: FieldPolicy<any> | FieldReadFunction<any>,
	isRCTransferReq?: FieldPolicy<any> | FieldReadFunction<any>,
	lead?: FieldPolicy<any> | FieldReadFunction<any>,
	leadWithActiveBooking?: FieldPolicy<any> | FieldReadFunction<any>,
	leadWithArchivedBooking?: FieldPolicy<any> | FieldReadFunction<any>,
	loanCancellationReason?: FieldPolicy<any> | FieldReadFunction<any>,
	payments?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	searchString?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleTransferFormUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BookingAggregateResultKeySpecifier = ('cancellationRemarksMax' | 'cancellationRemarksMin' | 'cancelledChequeUrlMax' | 'cancelledChequeUrlMin' | 'chequeMax' | 'chequeMin' | 'count' | 'createdAtMax' | 'createdAtMin' | 'deliveryFormMax' | 'deliveryFormMin' | 'deliveryPhotoUrlMax' | 'deliveryPhotoUrlMin' | 'searchStringMax' | 'searchStringMin' | 'updatedAtMax' | 'updatedAtMin' | 'vehicleTransferFormUrlMax' | 'vehicleTransferFormUrlMin' | BookingAggregateResultKeySpecifier)[];
export type BookingAggregateResultFieldPolicy = {
	cancellationRemarksMax?: FieldPolicy<any> | FieldReadFunction<any>,
	cancellationRemarksMin?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelledChequeUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelledChequeUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	chequeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	chequeMin?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryFormMax?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryFormMin?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryPhotoUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryPhotoUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	searchStringMax?: FieldPolicy<any> | FieldReadFunction<any>,
	searchStringMin?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleTransferFormUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleTransferFormUrlMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BookingPaymentKeySpecifier = ('appliedLoanAmount' | 'booking' | 'bookingPaymentMode' | 'bookingType' | 'createdAt' | 'id' | 'insuranceAmount' | 'rcTransferAmount' | 'saleAmount' | 'totalSaleAmount' | 'updatedAt' | BookingPaymentKeySpecifier)[];
export type BookingPaymentFieldPolicy = {
	appliedLoanAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	booking?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingPaymentMode?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingType?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	insuranceAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	rcTransferAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	saleAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	totalSaleAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BookingPaymentAggregateResultKeySpecifier = ('appliedLoanAmountAvg' | 'appliedLoanAmountMax' | 'appliedLoanAmountMin' | 'appliedLoanAmountSum' | 'count' | 'createdAtMax' | 'createdAtMin' | 'insuranceAmountAvg' | 'insuranceAmountMax' | 'insuranceAmountMin' | 'insuranceAmountSum' | 'rcTransferAmountAvg' | 'rcTransferAmountMax' | 'rcTransferAmountMin' | 'rcTransferAmountSum' | 'saleAmountAvg' | 'saleAmountMax' | 'saleAmountMin' | 'saleAmountSum' | 'totalSaleAmountAvg' | 'totalSaleAmountMax' | 'totalSaleAmountMin' | 'totalSaleAmountSum' | 'updatedAtMax' | 'updatedAtMin' | BookingPaymentAggregateResultKeySpecifier)[];
export type BookingPaymentAggregateResultFieldPolicy = {
	appliedLoanAmountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	appliedLoanAmountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	appliedLoanAmountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	appliedLoanAmountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	insuranceAmountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	insuranceAmountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	insuranceAmountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	insuranceAmountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	rcTransferAmountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	rcTransferAmountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	rcTransferAmountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	rcTransferAmountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	saleAmountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	saleAmountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	saleAmountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	saleAmountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	totalSaleAmountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	totalSaleAmountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	totalSaleAmountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	totalSaleAmountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAtMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BrandKeySpecifier = ('brand_id' | 'id' | 'models' | 'modelsAggregate' | 'name' | BrandKeySpecifier)[];
export type BrandFieldPolicy = {
	brand_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	models?: FieldPolicy<any> | FieldReadFunction<any>,
	modelsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BrandAggregateResultKeySpecifier = ('brand_idAvg' | 'brand_idMax' | 'brand_idMin' | 'brand_idSum' | 'count' | 'nameMax' | 'nameMin' | BrandAggregateResultKeySpecifier)[];
export type BrandAggregateResultFieldPolicy = {
	brand_idAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	brand_idMax?: FieldPolicy<any> | FieldReadFunction<any>,
	brand_idMin?: FieldPolicy<any> | FieldReadFunction<any>,
	brand_idSum?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BulkApprovalResponseKeySpecifier = ('bankConfirmationStatus' | 'bidStatus' | 'email' | 'failureReason' | 'finalBidAmount' | 'processingStatus' | 'proposedBidAmount' | 'regNo' | 'source' | BulkApprovalResponseKeySpecifier)[];
export type BulkApprovalResponseFieldPolicy = {
	bankConfirmationStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	bidStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	failureReason?: FieldPolicy<any> | FieldReadFunction<any>,
	finalBidAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	processingStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	proposedBidAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	regNo?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BulkApprovalResponseAggregateResultKeySpecifier = ('bankConfirmationStatusMax' | 'bankConfirmationStatusMin' | 'bidStatusMax' | 'bidStatusMin' | 'count' | 'emailMax' | 'emailMin' | 'failureReasonMax' | 'failureReasonMin' | 'finalBidAmountAvg' | 'finalBidAmountMax' | 'finalBidAmountMin' | 'finalBidAmountSum' | 'processingStatusMax' | 'processingStatusMin' | 'proposedBidAmountAvg' | 'proposedBidAmountMax' | 'proposedBidAmountMin' | 'proposedBidAmountSum' | 'regNoMax' | 'regNoMin' | 'sourceMax' | 'sourceMin' | BulkApprovalResponseAggregateResultKeySpecifier)[];
export type BulkApprovalResponseAggregateResultFieldPolicy = {
	bankConfirmationStatusMax?: FieldPolicy<any> | FieldReadFunction<any>,
	bankConfirmationStatusMin?: FieldPolicy<any> | FieldReadFunction<any>,
	bidStatusMax?: FieldPolicy<any> | FieldReadFunction<any>,
	bidStatusMin?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	emailMax?: FieldPolicy<any> | FieldReadFunction<any>,
	emailMin?: FieldPolicy<any> | FieldReadFunction<any>,
	failureReasonMax?: FieldPolicy<any> | FieldReadFunction<any>,
	failureReasonMin?: FieldPolicy<any> | FieldReadFunction<any>,
	finalBidAmountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	finalBidAmountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	finalBidAmountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	finalBidAmountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	processingStatusMax?: FieldPolicy<any> | FieldReadFunction<any>,
	processingStatusMin?: FieldPolicy<any> | FieldReadFunction<any>,
	proposedBidAmountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	proposedBidAmountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	proposedBidAmountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	proposedBidAmountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	regNoMax?: FieldPolicy<any> | FieldReadFunction<any>,
	regNoMin?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceMax?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CenterlizeLocationDistrcitsResponseKeySpecifier = ('data' | 'dataAggregate' | 'msg' | 'status' | CenterlizeLocationDistrcitsResponseKeySpecifier)[];
export type CenterlizeLocationDistrcitsResponseFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	dataAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CenterlizeLocationDistrcitsResponseAggregateResultKeySpecifier = ('count' | 'msgMax' | 'msgMin' | CenterlizeLocationDistrcitsResponseAggregateResultKeySpecifier)[];
export type CenterlizeLocationDistrcitsResponseAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	msgMax?: FieldPolicy<any> | FieldReadFunction<any>,
	msgMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CenterlizeLocationDistrictKeySpecifier = ('district_id' | 'district_name' | 'state_id' | 'state_name' | 'tr_district_id' | 'tr_state_id' | CenterlizeLocationDistrictKeySpecifier)[];
export type CenterlizeLocationDistrictFieldPolicy = {
	district_id?: FieldPolicy<any> | FieldReadFunction<any>,
	district_name?: FieldPolicy<any> | FieldReadFunction<any>,
	state_id?: FieldPolicy<any> | FieldReadFunction<any>,
	state_name?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_district_id?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_state_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CenterlizeLocationDistrictAggregateResultKeySpecifier = ('count' | 'district_idAvg' | 'district_idMax' | 'district_idMin' | 'district_idSum' | 'district_nameMax' | 'district_nameMin' | 'state_idAvg' | 'state_idMax' | 'state_idMin' | 'state_idSum' | 'state_nameMax' | 'state_nameMin' | 'tr_district_idAvg' | 'tr_district_idMax' | 'tr_district_idMin' | 'tr_district_idSum' | 'tr_state_idAvg' | 'tr_state_idMax' | 'tr_state_idMin' | 'tr_state_idSum' | CenterlizeLocationDistrictAggregateResultKeySpecifier)[];
export type CenterlizeLocationDistrictAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	district_idAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	district_idMax?: FieldPolicy<any> | FieldReadFunction<any>,
	district_idMin?: FieldPolicy<any> | FieldReadFunction<any>,
	district_idSum?: FieldPolicy<any> | FieldReadFunction<any>,
	district_nameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	district_nameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	state_idAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	state_idMax?: FieldPolicy<any> | FieldReadFunction<any>,
	state_idMin?: FieldPolicy<any> | FieldReadFunction<any>,
	state_idSum?: FieldPolicy<any> | FieldReadFunction<any>,
	state_nameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	state_nameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_district_idAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_district_idMax?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_district_idMin?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_district_idSum?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_state_idAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_state_idMax?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_state_idMin?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_state_idSum?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CenterlizeLocationStatesKeySpecifier = ('GSTNumber' | 'state_code' | 'state_id' | 'state_name' | 'tr_state_id' | CenterlizeLocationStatesKeySpecifier)[];
export type CenterlizeLocationStatesFieldPolicy = {
	GSTNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	state_code?: FieldPolicy<any> | FieldReadFunction<any>,
	state_id?: FieldPolicy<any> | FieldReadFunction<any>,
	state_name?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_state_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CenterlizeLocationStatesAggregateResultKeySpecifier = ('GSTNumberMax' | 'GSTNumberMin' | 'count' | 'state_codeMax' | 'state_codeMin' | 'state_idAvg' | 'state_idMax' | 'state_idMin' | 'state_idSum' | 'state_nameMax' | 'state_nameMin' | 'tr_state_idAvg' | 'tr_state_idMax' | 'tr_state_idMin' | 'tr_state_idSum' | CenterlizeLocationStatesAggregateResultKeySpecifier)[];
export type CenterlizeLocationStatesAggregateResultFieldPolicy = {
	GSTNumberMax?: FieldPolicy<any> | FieldReadFunction<any>,
	GSTNumberMin?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	state_codeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	state_codeMin?: FieldPolicy<any> | FieldReadFunction<any>,
	state_idAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	state_idMax?: FieldPolicy<any> | FieldReadFunction<any>,
	state_idMin?: FieldPolicy<any> | FieldReadFunction<any>,
	state_idSum?: FieldPolicy<any> | FieldReadFunction<any>,
	state_nameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	state_nameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_state_idAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_state_idMax?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_state_idMin?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_state_idSum?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CenterlizeLocationStatesResponseKeySpecifier = ('data' | 'dataAggregate' | 'msg' | 'status' | CenterlizeLocationStatesResponseKeySpecifier)[];
export type CenterlizeLocationStatesResponseFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	dataAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CenterlizeLocationStatesResponseAggregateResultKeySpecifier = ('count' | 'msgMax' | 'msgMin' | CenterlizeLocationStatesResponseAggregateResultKeySpecifier)[];
export type CenterlizeLocationStatesResponseAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	msgMax?: FieldPolicy<any> | FieldReadFunction<any>,
	msgMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CenterlizeLocationTehsilKeySpecifier = ('district_id' | 'district_name' | 'state_id' | 'state_name' | 'tehsil_id' | 'tehsil_name' | 'tr_district_id' | 'tr_state_id' | 'tr_tehsil_id' | CenterlizeLocationTehsilKeySpecifier)[];
export type CenterlizeLocationTehsilFieldPolicy = {
	district_id?: FieldPolicy<any> | FieldReadFunction<any>,
	district_name?: FieldPolicy<any> | FieldReadFunction<any>,
	state_id?: FieldPolicy<any> | FieldReadFunction<any>,
	state_name?: FieldPolicy<any> | FieldReadFunction<any>,
	tehsil_id?: FieldPolicy<any> | FieldReadFunction<any>,
	tehsil_name?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_district_id?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_state_id?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_tehsil_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CenterlizeLocationTehsilAggregateResultKeySpecifier = ('count' | 'district_idAvg' | 'district_idMax' | 'district_idMin' | 'district_idSum' | 'district_nameMax' | 'district_nameMin' | 'state_idAvg' | 'state_idMax' | 'state_idMin' | 'state_idSum' | 'state_nameMax' | 'state_nameMin' | 'tehsil_idAvg' | 'tehsil_idMax' | 'tehsil_idMin' | 'tehsil_idSum' | 'tehsil_nameMax' | 'tehsil_nameMin' | 'tr_district_idAvg' | 'tr_district_idMax' | 'tr_district_idMin' | 'tr_district_idSum' | 'tr_state_idAvg' | 'tr_state_idMax' | 'tr_state_idMin' | 'tr_state_idSum' | 'tr_tehsil_idAvg' | 'tr_tehsil_idMax' | 'tr_tehsil_idMin' | 'tr_tehsil_idSum' | CenterlizeLocationTehsilAggregateResultKeySpecifier)[];
export type CenterlizeLocationTehsilAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	district_idAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	district_idMax?: FieldPolicy<any> | FieldReadFunction<any>,
	district_idMin?: FieldPolicy<any> | FieldReadFunction<any>,
	district_idSum?: FieldPolicy<any> | FieldReadFunction<any>,
	district_nameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	district_nameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	state_idAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	state_idMax?: FieldPolicy<any> | FieldReadFunction<any>,
	state_idMin?: FieldPolicy<any> | FieldReadFunction<any>,
	state_idSum?: FieldPolicy<any> | FieldReadFunction<any>,
	state_nameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	state_nameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	tehsil_idAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	tehsil_idMax?: FieldPolicy<any> | FieldReadFunction<any>,
	tehsil_idMin?: FieldPolicy<any> | FieldReadFunction<any>,
	tehsil_idSum?: FieldPolicy<any> | FieldReadFunction<any>,
	tehsil_nameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	tehsil_nameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_district_idAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_district_idMax?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_district_idMin?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_district_idSum?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_state_idAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_state_idMax?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_state_idMin?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_state_idSum?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_tehsil_idAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_tehsil_idMax?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_tehsil_idMin?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_tehsil_idSum?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CenterlizeLocationTehsilResponseKeySpecifier = ('data' | 'dataAggregate' | 'msg' | 'status' | CenterlizeLocationTehsilResponseKeySpecifier)[];
export type CenterlizeLocationTehsilResponseFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	dataAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CenterlizeLocationTehsilResponseAggregateResultKeySpecifier = ('count' | 'msgMax' | 'msgMin' | CenterlizeLocationTehsilResponseAggregateResultKeySpecifier)[];
export type CenterlizeLocationTehsilResponseAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	msgMax?: FieldPolicy<any> | FieldReadFunction<any>,
	msgMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CentreKeySpecifier = ('TJCentre' | 'address' | 'capacity' | 'city' | 'createdAt' | 'district' | 'employees' | 'employeesAggregate' | 'id' | 'incharge' | 'issues' | 'issuesAggregate' | 'leads' | 'leadsAggregate' | 'location' | 'managedBy' | 'managedByAggregate' | 'name' | 'phoneNumber' | 'pincode' | 'purchases' | 'purchasesAggregate' | 'regNo' | 'state' | 'status' | 'tehsil' | 'updatedAt' | CentreKeySpecifier)[];
export type CentreFieldPolicy = {
	TJCentre?: FieldPolicy<any> | FieldReadFunction<any>,
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	capacity?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	district?: FieldPolicy<any> | FieldReadFunction<any>,
	employees?: FieldPolicy<any> | FieldReadFunction<any>,
	employeesAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	incharge?: FieldPolicy<any> | FieldReadFunction<any>,
	issues?: FieldPolicy<any> | FieldReadFunction<any>,
	issuesAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	leads?: FieldPolicy<any> | FieldReadFunction<any>,
	leadsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	managedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	managedByAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	pincode?: FieldPolicy<any> | FieldReadFunction<any>,
	purchases?: FieldPolicy<any> | FieldReadFunction<any>,
	purchasesAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	regNo?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	tehsil?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CentreAggregateResultKeySpecifier = ('addressMax' | 'addressMin' | 'capacityAvg' | 'capacityMax' | 'capacityMin' | 'capacitySum' | 'cityMax' | 'cityMin' | 'count' | 'createdAtMax' | 'createdAtMin' | 'districtMax' | 'districtMin' | 'nameMax' | 'nameMin' | 'phoneNumberMax' | 'phoneNumberMin' | 'pincodeAvg' | 'pincodeMax' | 'pincodeMin' | 'pincodeSum' | 'regNoMax' | 'regNoMin' | 'stateMax' | 'stateMin' | 'tehsilMax' | 'tehsilMin' | 'updatedAtMax' | 'updatedAtMin' | CentreAggregateResultKeySpecifier)[];
export type CentreAggregateResultFieldPolicy = {
	addressMax?: FieldPolicy<any> | FieldReadFunction<any>,
	addressMin?: FieldPolicy<any> | FieldReadFunction<any>,
	capacityAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	capacityMax?: FieldPolicy<any> | FieldReadFunction<any>,
	capacityMin?: FieldPolicy<any> | FieldReadFunction<any>,
	capacitySum?: FieldPolicy<any> | FieldReadFunction<any>,
	cityMax?: FieldPolicy<any> | FieldReadFunction<any>,
	cityMin?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	districtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	districtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumberMax?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumberMin?: FieldPolicy<any> | FieldReadFunction<any>,
	pincodeAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	pincodeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	pincodeMin?: FieldPolicy<any> | FieldReadFunction<any>,
	pincodeSum?: FieldPolicy<any> | FieldReadFunction<any>,
	regNoMax?: FieldPolicy<any> | FieldReadFunction<any>,
	regNoMin?: FieldPolicy<any> | FieldReadFunction<any>,
	stateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	stateMin?: FieldPolicy<any> | FieldReadFunction<any>,
	tehsilMax?: FieldPolicy<any> | FieldReadFunction<any>,
	tehsilMin?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAtMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CentreAggregatesKeySpecifier = ('bookedVehiclesCount' | 'centreId' | 'centreName' | 'inStockVehiclesCount' | 'soldAndDeliveredVehicleCount' | 'totalInventory' | CentreAggregatesKeySpecifier)[];
export type CentreAggregatesFieldPolicy = {
	bookedVehiclesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	centreId?: FieldPolicy<any> | FieldReadFunction<any>,
	centreName?: FieldPolicy<any> | FieldReadFunction<any>,
	inStockVehiclesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	soldAndDeliveredVehicleCount?: FieldPolicy<any> | FieldReadFunction<any>,
	totalInventory?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CentreAggregatesAggregateResultKeySpecifier = ('bookedVehiclesCountAvg' | 'bookedVehiclesCountMax' | 'bookedVehiclesCountMin' | 'bookedVehiclesCountSum' | 'centreIdMax' | 'centreIdMin' | 'centreNameMax' | 'centreNameMin' | 'count' | 'inStockVehiclesCountAvg' | 'inStockVehiclesCountMax' | 'inStockVehiclesCountMin' | 'inStockVehiclesCountSum' | 'soldAndDeliveredVehicleCountAvg' | 'soldAndDeliveredVehicleCountMax' | 'soldAndDeliveredVehicleCountMin' | 'soldAndDeliveredVehicleCountSum' | 'totalInventoryAvg' | 'totalInventoryMax' | 'totalInventoryMin' | 'totalInventorySum' | CentreAggregatesAggregateResultKeySpecifier)[];
export type CentreAggregatesAggregateResultFieldPolicy = {
	bookedVehiclesCountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	bookedVehiclesCountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	bookedVehiclesCountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	bookedVehiclesCountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	centreIdMax?: FieldPolicy<any> | FieldReadFunction<any>,
	centreIdMin?: FieldPolicy<any> | FieldReadFunction<any>,
	centreNameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	centreNameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	inStockVehiclesCountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	inStockVehiclesCountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	inStockVehiclesCountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	inStockVehiclesCountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	soldAndDeliveredVehicleCountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	soldAndDeliveredVehicleCountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	soldAndDeliveredVehicleCountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	soldAndDeliveredVehicleCountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	totalInventoryAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	totalInventoryMax?: FieldPolicy<any> | FieldReadFunction<any>,
	totalInventoryMin?: FieldPolicy<any> | FieldReadFunction<any>,
	totalInventorySum?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CityKeySpecifier = ('id' | 'name' | CityKeySpecifier)[];
export type CityFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CityAggregateResultKeySpecifier = ('count' | 'nameMax' | 'nameMin' | CityAggregateResultKeySpecifier)[];
export type CityAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateBulkLeadResponseKeySpecifier = ('auctionByBank' | 'chassisNumber' | 'createById' | 'demandAmount' | 'email' | 'engineNumber' | 'failureReason' | 'hoursMeter' | 'make' | 'manufacturingDate' | 'model' | 'ownershipType' | 'processingStatus' | 'regNo' | 'registrationState' | 'remark' | 'source' | 'status' | CreateBulkLeadResponseKeySpecifier)[];
export type CreateBulkLeadResponseFieldPolicy = {
	auctionByBank?: FieldPolicy<any> | FieldReadFunction<any>,
	chassisNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	createById?: FieldPolicy<any> | FieldReadFunction<any>,
	demandAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	engineNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	failureReason?: FieldPolicy<any> | FieldReadFunction<any>,
	hoursMeter?: FieldPolicy<any> | FieldReadFunction<any>,
	make?: FieldPolicy<any> | FieldReadFunction<any>,
	manufacturingDate?: FieldPolicy<any> | FieldReadFunction<any>,
	model?: FieldPolicy<any> | FieldReadFunction<any>,
	ownershipType?: FieldPolicy<any> | FieldReadFunction<any>,
	processingStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	regNo?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationState?: FieldPolicy<any> | FieldReadFunction<any>,
	remark?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateBulkLeadResponseAggregateResultKeySpecifier = ('auctionByBankMax' | 'auctionByBankMin' | 'chassisNumberMax' | 'chassisNumberMin' | 'count' | 'createByIdMax' | 'createByIdMin' | 'demandAmountMax' | 'demandAmountMin' | 'emailMax' | 'emailMin' | 'engineNumberMax' | 'engineNumberMin' | 'failureReasonMax' | 'failureReasonMin' | 'hoursMeterMax' | 'hoursMeterMin' | 'makeMax' | 'makeMin' | 'manufacturingDateMax' | 'manufacturingDateMin' | 'modelMax' | 'modelMin' | 'ownershipTypeMax' | 'ownershipTypeMin' | 'processingStatusMax' | 'processingStatusMin' | 'regNoMax' | 'regNoMin' | 'registrationStateMax' | 'registrationStateMin' | 'remarkMax' | 'remarkMin' | 'sourceMax' | 'sourceMin' | 'statusMax' | 'statusMin' | CreateBulkLeadResponseAggregateResultKeySpecifier)[];
export type CreateBulkLeadResponseAggregateResultFieldPolicy = {
	auctionByBankMax?: FieldPolicy<any> | FieldReadFunction<any>,
	auctionByBankMin?: FieldPolicy<any> | FieldReadFunction<any>,
	chassisNumberMax?: FieldPolicy<any> | FieldReadFunction<any>,
	chassisNumberMin?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	createByIdMax?: FieldPolicy<any> | FieldReadFunction<any>,
	createByIdMin?: FieldPolicy<any> | FieldReadFunction<any>,
	demandAmountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	demandAmountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	emailMax?: FieldPolicy<any> | FieldReadFunction<any>,
	emailMin?: FieldPolicy<any> | FieldReadFunction<any>,
	engineNumberMax?: FieldPolicy<any> | FieldReadFunction<any>,
	engineNumberMin?: FieldPolicy<any> | FieldReadFunction<any>,
	failureReasonMax?: FieldPolicy<any> | FieldReadFunction<any>,
	failureReasonMin?: FieldPolicy<any> | FieldReadFunction<any>,
	hoursMeterMax?: FieldPolicy<any> | FieldReadFunction<any>,
	hoursMeterMin?: FieldPolicy<any> | FieldReadFunction<any>,
	makeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	makeMin?: FieldPolicy<any> | FieldReadFunction<any>,
	manufacturingDateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	manufacturingDateMin?: FieldPolicy<any> | FieldReadFunction<any>,
	modelMax?: FieldPolicy<any> | FieldReadFunction<any>,
	modelMin?: FieldPolicy<any> | FieldReadFunction<any>,
	ownershipTypeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	ownershipTypeMin?: FieldPolicy<any> | FieldReadFunction<any>,
	processingStatusMax?: FieldPolicy<any> | FieldReadFunction<any>,
	processingStatusMin?: FieldPolicy<any> | FieldReadFunction<any>,
	regNoMax?: FieldPolicy<any> | FieldReadFunction<any>,
	regNoMin?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationStateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationStateMin?: FieldPolicy<any> | FieldReadFunction<any>,
	remarkMax?: FieldPolicy<any> | FieldReadFunction<any>,
	remarkMin?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceMax?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceMin?: FieldPolicy<any> | FieldReadFunction<any>,
	statusMax?: FieldPolicy<any> | FieldReadFunction<any>,
	statusMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerKeySpecifier = ('bookings' | 'bookingsAggregate' | 'createdAt' | 'customerDistrict' | 'customerId' | 'customerState' | 'customerTehsil' | 'district' | 'enquiries' | 'enquiriesAggregate' | 'enquiry' | 'id' | 'idNumber' | 'idProofUrl' | 'identificationDocuments' | 'name' | 'phoneNo' | 'state' | 'tehsil' | 'updatedAt' | CustomerKeySpecifier)[];
export type CustomerFieldPolicy = {
	bookings?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	customerDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	customerId?: FieldPolicy<any> | FieldReadFunction<any>,
	customerState?: FieldPolicy<any> | FieldReadFunction<any>,
	customerTehsil?: FieldPolicy<any> | FieldReadFunction<any>,
	district?: FieldPolicy<any> | FieldReadFunction<any>,
	enquiries?: FieldPolicy<any> | FieldReadFunction<any>,
	enquiriesAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	enquiry?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	idNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	idProofUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	identificationDocuments?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNo?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	tehsil?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerAggregateResultKeySpecifier = ('count' | 'createdAtMax' | 'createdAtMin' | 'districtMax' | 'districtMin' | 'idNumberMax' | 'idNumberMin' | 'idProofUrlMax' | 'idProofUrlMin' | 'nameMax' | 'nameMin' | 'phoneNoMax' | 'phoneNoMin' | 'stateMax' | 'stateMin' | 'tehsilMax' | 'tehsilMin' | 'updatedAtMax' | 'updatedAtMin' | CustomerAggregateResultKeySpecifier)[];
export type CustomerAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	districtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	districtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	idNumberMax?: FieldPolicy<any> | FieldReadFunction<any>,
	idNumberMin?: FieldPolicy<any> | FieldReadFunction<any>,
	idProofUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	idProofUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNoMax?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNoMin?: FieldPolicy<any> | FieldReadFunction<any>,
	stateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	stateMin?: FieldPolicy<any> | FieldReadFunction<any>,
	tehsilMax?: FieldPolicy<any> | FieldReadFunction<any>,
	tehsilMin?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAtMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DealerKeySpecifier = ('id' | 'leads' | 'leadsAggregate' | 'name' | 'phoneNo' | DealerKeySpecifier)[];
export type DealerFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	leads?: FieldPolicy<any> | FieldReadFunction<any>,
	leadsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DealerAggregateResultKeySpecifier = ('count' | 'nameMax' | 'nameMin' | 'phoneNoMax' | 'phoneNoMin' | DealerAggregateResultKeySpecifier)[];
export type DealerAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNoMax?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNoMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DealerStanceKeySpecifier = ('clearBlackList' | 'clearChallan' | 'clearHSRP' | 'id' | 'lead' | DealerStanceKeySpecifier)[];
export type DealerStanceFieldPolicy = {
	clearBlackList?: FieldPolicy<any> | FieldReadFunction<any>,
	clearChallan?: FieldPolicy<any> | FieldReadFunction<any>,
	clearHSRP?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lead?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DealerStanceAggregateResultKeySpecifier = ('count' | DealerStanceAggregateResultKeySpecifier)[];
export type DealerStanceAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DealershipDocumentKeySpecifier = ('approvalMailUrl' | 'bankNOC' | 'blacklist' | 'challanUrl' | 'form26' | 'form28' | 'form29' | 'form30' | 'form35' | 'form36' | 'form60' | 'form60_sellerPan' | 'hsrbProofUrl' | 'hypothecationProofUrl' | 'id' | 'insuranceCertificate' | 'lead' | 'loanForeclosure' | 'ownerAddressProof' | 'regNo' | 'registrationCertificate' | 'rtoVerificationProofUrl' | 'sellerAadharCard' | 'sellerPAN' | DealershipDocumentKeySpecifier)[];
export type DealershipDocumentFieldPolicy = {
	approvalMailUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	bankNOC?: FieldPolicy<any> | FieldReadFunction<any>,
	blacklist?: FieldPolicy<any> | FieldReadFunction<any>,
	challanUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	form26?: FieldPolicy<any> | FieldReadFunction<any>,
	form28?: FieldPolicy<any> | FieldReadFunction<any>,
	form29?: FieldPolicy<any> | FieldReadFunction<any>,
	form30?: FieldPolicy<any> | FieldReadFunction<any>,
	form35?: FieldPolicy<any> | FieldReadFunction<any>,
	form36?: FieldPolicy<any> | FieldReadFunction<any>,
	form60?: FieldPolicy<any> | FieldReadFunction<any>,
	form60_sellerPan?: FieldPolicy<any> | FieldReadFunction<any>,
	hsrbProofUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	hypothecationProofUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	insuranceCertificate?: FieldPolicy<any> | FieldReadFunction<any>,
	lead?: FieldPolicy<any> | FieldReadFunction<any>,
	loanForeclosure?: FieldPolicy<any> | FieldReadFunction<any>,
	ownerAddressProof?: FieldPolicy<any> | FieldReadFunction<any>,
	regNo?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationCertificate?: FieldPolicy<any> | FieldReadFunction<any>,
	rtoVerificationProofUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	sellerAadharCard?: FieldPolicy<any> | FieldReadFunction<any>,
	sellerPAN?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DealershipDocumentAggregateResultKeySpecifier = ('count' | 'regNoMax' | 'regNoMin' | DealershipDocumentAggregateResultKeySpecifier)[];
export type DealershipDocumentAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	regNoMax?: FieldPolicy<any> | FieldReadFunction<any>,
	regNoMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DealershipLeadCountByPENameKeySpecifier = ('dealClosedCount' | 'leadCreatedCount' | 'name' | 'priceRecivedCount' | 'userId' | DealershipLeadCountByPENameKeySpecifier)[];
export type DealershipLeadCountByPENameFieldPolicy = {
	dealClosedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	leadCreatedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	priceRecivedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DealershipLeadCountByPENameAggregateResultKeySpecifier = ('count' | 'dealClosedCountMax' | 'dealClosedCountMin' | 'leadCreatedCountMax' | 'leadCreatedCountMin' | 'nameMax' | 'nameMin' | 'priceRecivedCountMax' | 'priceRecivedCountMin' | 'userIdMax' | 'userIdMin' | DealershipLeadCountByPENameAggregateResultKeySpecifier)[];
export type DealershipLeadCountByPENameAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	dealClosedCountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	dealClosedCountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	leadCreatedCountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	leadCreatedCountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	priceRecivedCountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	priceRecivedCountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	userIdMax?: FieldPolicy<any> | FieldReadFunction<any>,
	userIdMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteAccessoriesCheckListWithStagePayloadKeySpecifier = ('accessoriesCheckListWithStage' | 'msg' | 'numUids' | DeleteAccessoriesCheckListWithStagePayloadKeySpecifier)[];
export type DeleteAccessoriesCheckListWithStagePayloadFieldPolicy = {
	accessoriesCheckListWithStage?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteAccessoriesCheckPayloadKeySpecifier = ('accessoriesCheck' | 'msg' | 'numUids' | DeleteAccessoriesCheckPayloadKeySpecifier)[];
export type DeleteAccessoriesCheckPayloadFieldPolicy = {
	accessoriesCheck?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteAccessoriesChecklistPayloadKeySpecifier = ('accessoriesChecklist' | 'msg' | 'numUids' | DeleteAccessoriesChecklistPayloadKeySpecifier)[];
export type DeleteAccessoriesChecklistPayloadFieldPolicy = {
	accessoriesChecklist?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteActiveStateWithGSTNPayloadKeySpecifier = ('activeStateWithGSTN' | 'msg' | 'numUids' | DeleteActiveStateWithGSTNPayloadKeySpecifier)[];
export type DeleteActiveStateWithGSTNPayloadFieldPolicy = {
	activeStateWithGSTN?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteAdminLeadStatusEventPayloadKeySpecifier = ('adminLeadStatusEvent' | 'msg' | 'numUids' | DeleteAdminLeadStatusEventPayloadKeySpecifier)[];
export type DeleteAdminLeadStatusEventPayloadFieldPolicy = {
	adminLeadStatusEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteAgencyPayloadKeySpecifier = ('agency' | 'msg' | 'numUids' | DeleteAgencyPayloadKeySpecifier)[];
export type DeleteAgencyPayloadFieldPolicy = {
	agency?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteAuctionHistoryPayloadKeySpecifier = ('auctionHistory' | 'msg' | 'numUids' | DeleteAuctionHistoryPayloadKeySpecifier)[];
export type DeleteAuctionHistoryPayloadFieldPolicy = {
	auctionHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteBankAuctionLeadCountByNamePayloadKeySpecifier = ('bankAuctionLeadCountByName' | 'msg' | 'numUids' | DeleteBankAuctionLeadCountByNamePayloadKeySpecifier)[];
export type DeleteBankAuctionLeadCountByNamePayloadFieldPolicy = {
	bankAuctionLeadCountByName?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteBankPayloadKeySpecifier = ('bank' | 'msg' | 'numUids' | DeleteBankPayloadKeySpecifier)[];
export type DeleteBankPayloadFieldPolicy = {
	bank?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteBookingPayloadKeySpecifier = ('booking' | 'msg' | 'numUids' | DeleteBookingPayloadKeySpecifier)[];
export type DeleteBookingPayloadFieldPolicy = {
	booking?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteBookingPaymentPayloadKeySpecifier = ('bookingPayment' | 'msg' | 'numUids' | DeleteBookingPaymentPayloadKeySpecifier)[];
export type DeleteBookingPaymentPayloadFieldPolicy = {
	bookingPayment?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteBrandPayloadKeySpecifier = ('brand' | 'msg' | 'numUids' | DeleteBrandPayloadKeySpecifier)[];
export type DeleteBrandPayloadFieldPolicy = {
	brand?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteBulkApprovalResponsePayloadKeySpecifier = ('bulkApprovalResponse' | 'msg' | 'numUids' | DeleteBulkApprovalResponsePayloadKeySpecifier)[];
export type DeleteBulkApprovalResponsePayloadFieldPolicy = {
	bulkApprovalResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteCenterlizeLocationDistrcitsResponsePayloadKeySpecifier = ('centerlizeLocationDistrcitsResponse' | 'msg' | 'numUids' | DeleteCenterlizeLocationDistrcitsResponsePayloadKeySpecifier)[];
export type DeleteCenterlizeLocationDistrcitsResponsePayloadFieldPolicy = {
	centerlizeLocationDistrcitsResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteCenterlizeLocationDistrictPayloadKeySpecifier = ('centerlizeLocationDistrict' | 'msg' | 'numUids' | DeleteCenterlizeLocationDistrictPayloadKeySpecifier)[];
export type DeleteCenterlizeLocationDistrictPayloadFieldPolicy = {
	centerlizeLocationDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteCenterlizeLocationStatesPayloadKeySpecifier = ('centerlizeLocationStates' | 'msg' | 'numUids' | DeleteCenterlizeLocationStatesPayloadKeySpecifier)[];
export type DeleteCenterlizeLocationStatesPayloadFieldPolicy = {
	centerlizeLocationStates?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteCenterlizeLocationStatesResponsePayloadKeySpecifier = ('centerlizeLocationStatesResponse' | 'msg' | 'numUids' | DeleteCenterlizeLocationStatesResponsePayloadKeySpecifier)[];
export type DeleteCenterlizeLocationStatesResponsePayloadFieldPolicy = {
	centerlizeLocationStatesResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteCenterlizeLocationTehsilPayloadKeySpecifier = ('centerlizeLocationTehsil' | 'msg' | 'numUids' | DeleteCenterlizeLocationTehsilPayloadKeySpecifier)[];
export type DeleteCenterlizeLocationTehsilPayloadFieldPolicy = {
	centerlizeLocationTehsil?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteCenterlizeLocationTehsilResponsePayloadKeySpecifier = ('centerlizeLocationTehsilResponse' | 'msg' | 'numUids' | DeleteCenterlizeLocationTehsilResponsePayloadKeySpecifier)[];
export type DeleteCenterlizeLocationTehsilResponsePayloadFieldPolicy = {
	centerlizeLocationTehsilResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteCentreAggregatesPayloadKeySpecifier = ('centreAggregates' | 'msg' | 'numUids' | DeleteCentreAggregatesPayloadKeySpecifier)[];
export type DeleteCentreAggregatesPayloadFieldPolicy = {
	centreAggregates?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteCentrePayloadKeySpecifier = ('centre' | 'msg' | 'numUids' | DeleteCentrePayloadKeySpecifier)[];
export type DeleteCentrePayloadFieldPolicy = {
	centre?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteCityPayloadKeySpecifier = ('city' | 'msg' | 'numUids' | DeleteCityPayloadKeySpecifier)[];
export type DeleteCityPayloadFieldPolicy = {
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteCreateBulkLeadResponsePayloadKeySpecifier = ('createBulkLeadResponse' | 'msg' | 'numUids' | DeleteCreateBulkLeadResponsePayloadKeySpecifier)[];
export type DeleteCreateBulkLeadResponsePayloadFieldPolicy = {
	createBulkLeadResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteCustomerPayloadKeySpecifier = ('customer' | 'msg' | 'numUids' | DeleteCustomerPayloadKeySpecifier)[];
export type DeleteCustomerPayloadFieldPolicy = {
	customer?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteDealerPayloadKeySpecifier = ('dealer' | 'msg' | 'numUids' | DeleteDealerPayloadKeySpecifier)[];
export type DeleteDealerPayloadFieldPolicy = {
	dealer?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteDealerStancePayloadKeySpecifier = ('dealerStance' | 'msg' | 'numUids' | DeleteDealerStancePayloadKeySpecifier)[];
export type DeleteDealerStancePayloadFieldPolicy = {
	dealerStance?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteDealershipDocumentPayloadKeySpecifier = ('dealershipDocument' | 'msg' | 'numUids' | DeleteDealershipDocumentPayloadKeySpecifier)[];
export type DeleteDealershipDocumentPayloadFieldPolicy = {
	dealershipDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteDealershipLeadCountByPENamePayloadKeySpecifier = ('dealershipLeadCountByPEName' | 'msg' | 'numUids' | DeleteDealershipLeadCountByPENamePayloadKeySpecifier)[];
export type DeleteDealershipLeadCountByPENamePayloadFieldPolicy = {
	dealershipLeadCountByPEName?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteDistrictPayloadKeySpecifier = ('district' | 'msg' | 'numUids' | DeleteDistrictPayloadKeySpecifier)[];
export type DeleteDistrictPayloadFieldPolicy = {
	district?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteDocumentChecklistPayloadKeySpecifier = ('documentChecklist' | 'msg' | 'numUids' | DeleteDocumentChecklistPayloadKeySpecifier)[];
export type DeleteDocumentChecklistPayloadFieldPolicy = {
	documentChecklist?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteDocumentPayloadKeySpecifier = ('document' | 'msg' | 'numUids' | DeleteDocumentPayloadKeySpecifier)[];
export type DeleteDocumentPayloadFieldPolicy = {
	document?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteDocumentsCountPayloadKeySpecifier = ('documentsCount' | 'msg' | 'numUids' | DeleteDocumentsCountPayloadKeySpecifier)[];
export type DeleteDocumentsCountPayloadFieldPolicy = {
	documentsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteDocumentsFollowupsPayloadKeySpecifier = ('documentsFollowups' | 'msg' | 'numUids' | DeleteDocumentsFollowupsPayloadKeySpecifier)[];
export type DeleteDocumentsFollowupsPayloadFieldPolicy = {
	documentsFollowups?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteDriverAggregatesPayloadKeySpecifier = ('driverAggregates' | 'msg' | 'numUids' | DeleteDriverAggregatesPayloadKeySpecifier)[];
export type DeleteDriverAggregatesPayloadFieldPolicy = {
	driverAggregates?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteEnquiryAdherencePayloadKeySpecifier = ('enquiryAdherence' | 'msg' | 'numUids' | DeleteEnquiryAdherencePayloadKeySpecifier)[];
export type DeleteEnquiryAdherencePayloadFieldPolicy = {
	enquiryAdherence?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteEnquiryAggByCentrePayloadKeySpecifier = ('enquiryAggByCentre' | 'msg' | 'numUids' | DeleteEnquiryAggByCentrePayloadKeySpecifier)[];
export type DeleteEnquiryAggByCentrePayloadFieldPolicy = {
	enquiryAggByCentre?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteEnquiryCloserAggPayloadKeySpecifier = ('enquiryCloserAgg' | 'msg' | 'numUids' | DeleteEnquiryCloserAggPayloadKeySpecifier)[];
export type DeleteEnquiryCloserAggPayloadFieldPolicy = {
	enquiryCloserAgg?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteEnquiryClosurePayloadKeySpecifier = ('enquiryClosure' | 'msg' | 'numUids' | DeleteEnquiryClosurePayloadKeySpecifier)[];
export type DeleteEnquiryClosurePayloadFieldPolicy = {
	enquiryClosure?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteEnquiryPayloadKeySpecifier = ('enquiry' | 'msg' | 'numUids' | DeleteEnquiryPayloadKeySpecifier)[];
export type DeleteEnquiryPayloadFieldPolicy = {
	enquiry?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteFollowupPayloadKeySpecifier = ('followup' | 'msg' | 'numUids' | DeleteFollowupPayloadKeySpecifier)[];
export type DeleteFollowupPayloadFieldPolicy = {
	followup?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteIdByNamePayloadKeySpecifier = ('idByName' | 'msg' | 'numUids' | DeleteIdByNamePayloadKeySpecifier)[];
export type DeleteIdByNamePayloadFieldPolicy = {
	idByName?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteIdentificationDocumentPayloadKeySpecifier = ('identificationDocument' | 'msg' | 'numUids' | DeleteIdentificationDocumentPayloadKeySpecifier)[];
export type DeleteIdentificationDocumentPayloadFieldPolicy = {
	identificationDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteIdsByNameForListingReponsePayloadKeySpecifier = ('idsByNameForListingReponse' | 'msg' | 'numUids' | DeleteIdsByNameForListingReponsePayloadKeySpecifier)[];
export type DeleteIdsByNameForListingReponsePayloadFieldPolicy = {
	idsByNameForListingReponse?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteInventoryDetailsPayloadKeySpecifier = ('inventoryDetails' | 'msg' | 'numUids' | DeleteInventoryDetailsPayloadKeySpecifier)[];
export type DeleteInventoryDetailsPayloadFieldPolicy = {
	inventoryDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteIssueItemPayloadKeySpecifier = ('issueItem' | 'msg' | 'numUids' | DeleteIssueItemPayloadKeySpecifier)[];
export type DeleteIssueItemPayloadFieldPolicy = {
	issueItem?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteIssuePayloadKeySpecifier = ('issue' | 'msg' | 'numUids' | DeleteIssuePayloadKeySpecifier)[];
export type DeleteIssuePayloadFieldPolicy = {
	issue?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteItemInventoryDetailsPayloadKeySpecifier = ('itemInventoryDetails' | 'msg' | 'numUids' | DeleteItemInventoryDetailsPayloadKeySpecifier)[];
export type DeleteItemInventoryDetailsPayloadFieldPolicy = {
	itemInventoryDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteLeadCountByStatusPayloadKeySpecifier = ('leadCountByStatus' | 'msg' | 'numUids' | DeleteLeadCountByStatusPayloadKeySpecifier)[];
export type DeleteLeadCountByStatusPayloadFieldPolicy = {
	leadCountByStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteLeadDocumentsPayloadKeySpecifier = ('leadDocuments' | 'msg' | 'numUids' | DeleteLeadDocumentsPayloadKeySpecifier)[];
export type DeleteLeadDocumentsPayloadFieldPolicy = {
	leadDocuments?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteLeadExpensePayloadKeySpecifier = ('leadExpense' | 'msg' | 'numUids' | DeleteLeadExpensePayloadKeySpecifier)[];
export type DeleteLeadExpensePayloadFieldPolicy = {
	leadExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteLeadPayloadKeySpecifier = ('lead' | 'msg' | 'numUids' | DeleteLeadPayloadKeySpecifier)[];
export type DeleteLeadPayloadFieldPolicy = {
	lead?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteLeadStatusEventPayloadKeySpecifier = ('leadStatusEvent' | 'msg' | 'numUids' | DeleteLeadStatusEventPayloadKeySpecifier)[];
export type DeleteLeadStatusEventPayloadFieldPolicy = {
	leadStatusEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteLeadStatusFlowPayloadKeySpecifier = ('leadStatusFlow' | 'msg' | 'numUids' | DeleteLeadStatusFlowPayloadKeySpecifier)[];
export type DeleteLeadStatusFlowPayloadFieldPolicy = {
	leadStatusFlow?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteLeadTimelineActionPayloadKeySpecifier = ('leadTimelineAction' | 'msg' | 'numUids' | DeleteLeadTimelineActionPayloadKeySpecifier)[];
export type DeleteLeadTimelineActionPayloadFieldPolicy = {
	leadTimelineAction?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteLeadTimelineStatusPayloadKeySpecifier = ('leadTimelineStatus' | 'msg' | 'numUids' | DeleteLeadTimelineStatusPayloadKeySpecifier)[];
export type DeleteLeadTimelineStatusPayloadFieldPolicy = {
	leadTimelineStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteLoanPayloadKeySpecifier = ('loan' | 'msg' | 'numUids' | DeleteLoanPayloadKeySpecifier)[];
export type DeleteLoanPayloadFieldPolicy = {
	loan?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteLogTrackingPayloadKeySpecifier = ('logTracking' | 'msg' | 'numUids' | DeleteLogTrackingPayloadKeySpecifier)[];
export type DeleteLogTrackingPayloadFieldPolicy = {
	logTracking?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteMarkSoldResponsePayloadKeySpecifier = ('markSoldResponse' | 'msg' | 'numUids' | DeleteMarkSoldResponsePayloadKeySpecifier)[];
export type DeleteMarkSoldResponsePayloadFieldPolicy = {
	markSoldResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteMessagePayloadKeySpecifier = ('message' | 'msg' | 'numUids' | DeleteMessagePayloadKeySpecifier)[];
export type DeleteMessagePayloadFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteModelByMakePayloadKeySpecifier = ('modelByMake' | 'msg' | 'numUids' | DeleteModelByMakePayloadKeySpecifier)[];
export type DeleteModelByMakePayloadFieldPolicy = {
	modelByMake?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteModelPayloadKeySpecifier = ('model' | 'msg' | 'numUids' | DeleteModelPayloadKeySpecifier)[];
export type DeleteModelPayloadFieldPolicy = {
	model?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteNotificationPayloadKeySpecifier = ('msg' | 'notification' | 'numUids' | DeleteNotificationPayloadKeySpecifier)[];
export type DeleteNotificationPayloadFieldPolicy = {
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	notification?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteNumberOfPendingTasksPayloadKeySpecifier = ('msg' | 'numUids' | 'numberOfPendingTasks' | DeleteNumberOfPendingTasksPayloadKeySpecifier)[];
export type DeleteNumberOfPendingTasksPayloadFieldPolicy = {
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfPendingTasks?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteParkingBeneficiaryPayloadKeySpecifier = ('msg' | 'numUids' | 'parkingBeneficiary' | DeleteParkingBeneficiaryPayloadKeySpecifier)[];
export type DeleteParkingBeneficiaryPayloadFieldPolicy = {
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	parkingBeneficiary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeletePaymentInvoicesPayloadKeySpecifier = ('msg' | 'numUids' | 'paymentInvoices' | DeletePaymentInvoicesPayloadKeySpecifier)[];
export type DeletePaymentInvoicesPayloadFieldPolicy = {
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentInvoices?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeletePaymentPayloadKeySpecifier = ('msg' | 'numUids' | 'payment' | DeletePaymentPayloadKeySpecifier)[];
export type DeletePaymentPayloadFieldPolicy = {
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	payment?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeletePickupPayloadKeySpecifier = ('msg' | 'numUids' | 'pickup' | DeletePickupPayloadKeySpecifier)[];
export type DeletePickupPayloadFieldPolicy = {
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	pickup?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteProductPayloadKeySpecifier = ('msg' | 'numUids' | 'product' | DeleteProductPayloadKeySpecifier)[];
export type DeleteProductPayloadFieldPolicy = {
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeletePurchaseItemPayloadKeySpecifier = ('msg' | 'numUids' | 'purchaseItem' | DeletePurchaseItemPayloadKeySpecifier)[];
export type DeletePurchaseItemPayloadFieldPolicy = {
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseItem?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeletePurchasePayloadKeySpecifier = ('msg' | 'numUids' | 'purchase' | DeletePurchasePayloadKeySpecifier)[];
export type DeletePurchasePayloadFieldPolicy = {
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	purchase?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteRefurbishmentBeneficiaryPayloadKeySpecifier = ('msg' | 'numUids' | 'refurbishmentBeneficiary' | DeleteRefurbishmentBeneficiaryPayloadKeySpecifier)[];
export type DeleteRefurbishmentBeneficiaryPayloadFieldPolicy = {
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	refurbishmentBeneficiary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteRefurbishmentDetailsPayloadKeySpecifier = ('msg' | 'numUids' | 'refurbishmentDetails' | DeleteRefurbishmentDetailsPayloadKeySpecifier)[];
export type DeleteRefurbishmentDetailsPayloadFieldPolicy = {
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	refurbishmentDetails?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteRefurbishmentItemPayloadKeySpecifier = ('msg' | 'numUids' | 'refurbishmentItem' | DeleteRefurbishmentItemPayloadKeySpecifier)[];
export type DeleteRefurbishmentItemPayloadFieldPolicy = {
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	refurbishmentItem?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteRefurbishmentRequestPayloadKeySpecifier = ('msg' | 'numUids' | 'refurbishmentRequest' | DeleteRefurbishmentRequestPayloadKeySpecifier)[];
export type DeleteRefurbishmentRequestPayloadFieldPolicy = {
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	refurbishmentRequest?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteSMSLogsPayloadKeySpecifier = ('msg' | 'numUids' | 'sMSLogs' | DeleteSMSLogsPayloadKeySpecifier)[];
export type DeleteSMSLogsPayloadFieldPolicy = {
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	sMSLogs?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteSendSmsToCustomerResponsePayloadKeySpecifier = ('msg' | 'numUids' | 'sendSmsToCustomerResponse' | DeleteSendSmsToCustomerResponsePayloadKeySpecifier)[];
export type DeleteSendSmsToCustomerResponsePayloadFieldPolicy = {
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	sendSmsToCustomerResponse?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteStateCodeWithRegNumberPayloadKeySpecifier = ('msg' | 'numUids' | 'stateCodeWithRegNumber' | DeleteStateCodeWithRegNumberPayloadKeySpecifier)[];
export type DeleteStateCodeWithRegNumberPayloadFieldPolicy = {
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	stateCodeWithRegNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteStatusAggregatePayloadKeySpecifier = ('msg' | 'numUids' | 'statusAggregate' | DeleteStatusAggregatePayloadKeySpecifier)[];
export type DeleteStatusAggregatePayloadFieldPolicy = {
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	statusAggregate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteTJCentrePayloadKeySpecifier = ('msg' | 'numUids' | 'tJCentre' | DeleteTJCentrePayloadKeySpecifier)[];
export type DeleteTJCentrePayloadFieldPolicy = {
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	tJCentre?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteTaskPayloadKeySpecifier = ('msg' | 'numUids' | 'task' | DeleteTaskPayloadKeySpecifier)[];
export type DeleteTaskPayloadFieldPolicy = {
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	task?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteTehsilPayloadKeySpecifier = ('msg' | 'numUids' | 'tehsil' | DeleteTehsilPayloadKeySpecifier)[];
export type DeleteTehsilPayloadFieldPolicy = {
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	tehsil?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteTripExpensePayloadKeySpecifier = ('msg' | 'numUids' | 'tripExpense' | DeleteTripExpensePayloadKeySpecifier)[];
export type DeleteTripExpensePayloadFieldPolicy = {
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	tripExpense?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteUserPayloadKeySpecifier = ('msg' | 'numUids' | 'user' | DeleteUserPayloadKeySpecifier)[];
export type DeleteUserPayloadFieldPolicy = {
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteVehicleDocumentsPayloadKeySpecifier = ('msg' | 'numUids' | 'vehicleDocuments' | DeleteVehicleDocumentsPayloadKeySpecifier)[];
export type DeleteVehicleDocumentsPayloadFieldPolicy = {
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleDocuments?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteVehicleFinancingPayloadKeySpecifier = ('msg' | 'numUids' | 'vehicleFinancing' | DeleteVehicleFinancingPayloadKeySpecifier)[];
export type DeleteVehicleFinancingPayloadFieldPolicy = {
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleFinancing?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteVehicleImagesPayloadKeySpecifier = ('msg' | 'numUids' | 'vehicleImages' | DeleteVehicleImagesPayloadKeySpecifier)[];
export type DeleteVehicleImagesPayloadFieldPolicy = {
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleImages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteVehicleInsurancePayloadKeySpecifier = ('msg' | 'numUids' | 'vehicleInsurance' | DeleteVehicleInsurancePayloadKeySpecifier)[];
export type DeleteVehicleInsurancePayloadFieldPolicy = {
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleInsurance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteVehicleOwnerPayloadKeySpecifier = ('msg' | 'numUids' | 'vehicleOwner' | DeleteVehicleOwnerPayloadKeySpecifier)[];
export type DeleteVehicleOwnerPayloadFieldPolicy = {
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleOwner?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteVehiclePayloadKeySpecifier = ('msg' | 'numUids' | 'vehicle' | DeleteVehiclePayloadKeySpecifier)[];
export type DeleteVehiclePayloadFieldPolicy = {
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicle?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteVehicleTransferLogPayloadKeySpecifier = ('msg' | 'numUids' | 'vehicleTransferLog' | DeleteVehicleTransferLogPayloadKeySpecifier)[];
export type DeleteVehicleTransferLogPayloadFieldPolicy = {
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleTransferLog?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteYardPayloadKeySpecifier = ('msg' | 'numUids' | 'yard' | DeleteYardPayloadKeySpecifier)[];
export type DeleteYardPayloadFieldPolicy = {
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	yard?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeletedocumentsAggregatesResultPayloadKeySpecifier = ('documentsAggregatesResult' | 'msg' | 'numUids' | DeletedocumentsAggregatesResultPayloadKeySpecifier)[];
export type DeletedocumentsAggregatesResultPayloadFieldPolicy = {
	documentsAggregatesResult?: FieldPolicy<any> | FieldReadFunction<any>,
	msg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DistrictKeySpecifier = ('code' | 'id' | 'name' | 'state' | 'tehsils' | 'tehsilsAggregate' | DistrictKeySpecifier)[];
export type DistrictFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	tehsils?: FieldPolicy<any> | FieldReadFunction<any>,
	tehsilsAggregate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DistrictAggregateResultKeySpecifier = ('codeMax' | 'codeMin' | 'count' | 'nameMax' | 'nameMin' | DistrictAggregateResultKeySpecifier)[];
export type DistrictAggregateResultFieldPolicy = {
	codeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	codeMin?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DocumentKeySpecifier = ('expectedDate' | 'isAvailable' | 'url' | DocumentKeySpecifier)[];
export type DocumentFieldPolicy = {
	expectedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	isAvailable?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DocumentAggregateResultKeySpecifier = ('count' | 'expectedDateMax' | 'expectedDateMin' | 'urlMax' | 'urlMin' | DocumentAggregateResultKeySpecifier)[];
export type DocumentAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	expectedDateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	expectedDateMin?: FieldPolicy<any> | FieldReadFunction<any>,
	urlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	urlMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DocumentChecklistKeySpecifier = ('bankNOC' | 'form26' | 'form28' | 'form29' | 'form30' | 'form35' | 'form36' | 'form60' | 'form60_sellerPan' | 'id' | 'indemnityBond' | 'insuranceCertificate' | 'lead' | 'loanForeclosure' | 'ownerAddressProof' | 'regNo' | 'registrationCertificate' | 'releaseOrder' | 'sellerAadharCard' | 'sellerPAN' | DocumentChecklistKeySpecifier)[];
export type DocumentChecklistFieldPolicy = {
	bankNOC?: FieldPolicy<any> | FieldReadFunction<any>,
	form26?: FieldPolicy<any> | FieldReadFunction<any>,
	form28?: FieldPolicy<any> | FieldReadFunction<any>,
	form29?: FieldPolicy<any> | FieldReadFunction<any>,
	form30?: FieldPolicy<any> | FieldReadFunction<any>,
	form35?: FieldPolicy<any> | FieldReadFunction<any>,
	form36?: FieldPolicy<any> | FieldReadFunction<any>,
	form60?: FieldPolicy<any> | FieldReadFunction<any>,
	form60_sellerPan?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	indemnityBond?: FieldPolicy<any> | FieldReadFunction<any>,
	insuranceCertificate?: FieldPolicy<any> | FieldReadFunction<any>,
	lead?: FieldPolicy<any> | FieldReadFunction<any>,
	loanForeclosure?: FieldPolicy<any> | FieldReadFunction<any>,
	ownerAddressProof?: FieldPolicy<any> | FieldReadFunction<any>,
	regNo?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationCertificate?: FieldPolicy<any> | FieldReadFunction<any>,
	releaseOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	sellerAadharCard?: FieldPolicy<any> | FieldReadFunction<any>,
	sellerPAN?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DocumentChecklistAggregateResultKeySpecifier = ('count' | 'regNoMax' | 'regNoMin' | DocumentChecklistAggregateResultKeySpecifier)[];
export type DocumentChecklistAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	regNoMax?: FieldPolicy<any> | FieldReadFunction<any>,
	regNoMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DocumentsCountKeySpecifier = ('pending' | 'received' | 'required' | DocumentsCountKeySpecifier)[];
export type DocumentsCountFieldPolicy = {
	pending?: FieldPolicy<any> | FieldReadFunction<any>,
	received?: FieldPolicy<any> | FieldReadFunction<any>,
	required?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DocumentsCountAggregateResultKeySpecifier = ('count' | 'pendingAvg' | 'pendingMax' | 'pendingMin' | 'pendingSum' | 'receivedAvg' | 'receivedMax' | 'receivedMin' | 'receivedSum' | 'requiredAvg' | 'requiredMax' | 'requiredMin' | 'requiredSum' | DocumentsCountAggregateResultKeySpecifier)[];
export type DocumentsCountAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	pendingAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	pendingMax?: FieldPolicy<any> | FieldReadFunction<any>,
	pendingMin?: FieldPolicy<any> | FieldReadFunction<any>,
	pendingSum?: FieldPolicy<any> | FieldReadFunction<any>,
	receivedAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	receivedMax?: FieldPolicy<any> | FieldReadFunction<any>,
	receivedMin?: FieldPolicy<any> | FieldReadFunction<any>,
	receivedSum?: FieldPolicy<any> | FieldReadFunction<any>,
	requiredAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	requiredMax?: FieldPolicy<any> | FieldReadFunction<any>,
	requiredMin?: FieldPolicy<any> | FieldReadFunction<any>,
	requiredSum?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DocumentsFollowupsKeySpecifier = ('actionType' | 'documentName' | 'followedUpBy' | 'followupDate' | 'id' | 'lead' | 'nextFollowupDate' | 'remarks' | 'source' | DocumentsFollowupsKeySpecifier)[];
export type DocumentsFollowupsFieldPolicy = {
	actionType?: FieldPolicy<any> | FieldReadFunction<any>,
	documentName?: FieldPolicy<any> | FieldReadFunction<any>,
	followedUpBy?: FieldPolicy<any> | FieldReadFunction<any>,
	followupDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lead?: FieldPolicy<any> | FieldReadFunction<any>,
	nextFollowupDate?: FieldPolicy<any> | FieldReadFunction<any>,
	remarks?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DocumentsFollowupsAggregateResultKeySpecifier = ('count' | 'documentNameMax' | 'documentNameMin' | 'followupDateMax' | 'followupDateMin' | 'nextFollowupDateMax' | 'nextFollowupDateMin' | 'remarksMax' | 'remarksMin' | 'sourceMax' | 'sourceMin' | DocumentsFollowupsAggregateResultKeySpecifier)[];
export type DocumentsFollowupsAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	documentNameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	documentNameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	followupDateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	followupDateMin?: FieldPolicy<any> | FieldReadFunction<any>,
	nextFollowupDateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	nextFollowupDateMin?: FieldPolicy<any> | FieldReadFunction<any>,
	remarksMax?: FieldPolicy<any> | FieldReadFunction<any>,
	remarksMin?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceMax?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DriverAggregatesKeySpecifier = ('assignedPickupsAcceptedCount' | 'assignedPickupsCount' | 'assignedPickupsDeliveredCount' | 'assignedPickupsInTransitCount' | 'assignedPickupsRejectedOrWithdrawnCount' | 'driverName' | 'id' | DriverAggregatesKeySpecifier)[];
export type DriverAggregatesFieldPolicy = {
	assignedPickupsAcceptedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedPickupsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedPickupsDeliveredCount?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedPickupsInTransitCount?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedPickupsRejectedOrWithdrawnCount?: FieldPolicy<any> | FieldReadFunction<any>,
	driverName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DriverAggregatesAggregateResultKeySpecifier = ('assignedPickupsAcceptedCountAvg' | 'assignedPickupsAcceptedCountMax' | 'assignedPickupsAcceptedCountMin' | 'assignedPickupsAcceptedCountSum' | 'assignedPickupsCountAvg' | 'assignedPickupsCountMax' | 'assignedPickupsCountMin' | 'assignedPickupsCountSum' | 'assignedPickupsDeliveredCountAvg' | 'assignedPickupsDeliveredCountMax' | 'assignedPickupsDeliveredCountMin' | 'assignedPickupsDeliveredCountSum' | 'assignedPickupsInTransitCountAvg' | 'assignedPickupsInTransitCountMax' | 'assignedPickupsInTransitCountMin' | 'assignedPickupsInTransitCountSum' | 'assignedPickupsRejectedOrWithdrawnCountAvg' | 'assignedPickupsRejectedOrWithdrawnCountMax' | 'assignedPickupsRejectedOrWithdrawnCountMin' | 'assignedPickupsRejectedOrWithdrawnCountSum' | 'count' | 'driverNameMax' | 'driverNameMin' | 'idMax' | 'idMin' | DriverAggregatesAggregateResultKeySpecifier)[];
export type DriverAggregatesAggregateResultFieldPolicy = {
	assignedPickupsAcceptedCountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedPickupsAcceptedCountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedPickupsAcceptedCountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedPickupsAcceptedCountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedPickupsCountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedPickupsCountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedPickupsCountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedPickupsCountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedPickupsDeliveredCountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedPickupsDeliveredCountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedPickupsDeliveredCountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedPickupsDeliveredCountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedPickupsInTransitCountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedPickupsInTransitCountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedPickupsInTransitCountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedPickupsInTransitCountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedPickupsRejectedOrWithdrawnCountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedPickupsRejectedOrWithdrawnCountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedPickupsRejectedOrWithdrawnCountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedPickupsRejectedOrWithdrawnCountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	driverNameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	driverNameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	idMax?: FieldPolicy<any> | FieldReadFunction<any>,
	idMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnquiryKeySpecifier = ('budget' | 'centre' | 'createdAt' | 'createdBy' | 'customer' | 'customerPhoneNo' | 'enquiryClosure' | 'enquiryType' | 'followups' | 'followupsAggregate' | 'id' | 'interestedIn' | 'interestedInAggregate' | 'interestedInProducts' | 'interestedInProductsAggregate' | 'isClosed' | 'lastVisitDate' | 'searchString' | 'status' | 'tentativePurchaseTime' | 'updatedAt' | 'updatedBy' | EnquiryKeySpecifier)[];
export type EnquiryFieldPolicy = {
	budget?: FieldPolicy<any> | FieldReadFunction<any>,
	centre?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	customer?: FieldPolicy<any> | FieldReadFunction<any>,
	customerPhoneNo?: FieldPolicy<any> | FieldReadFunction<any>,
	enquiryClosure?: FieldPolicy<any> | FieldReadFunction<any>,
	enquiryType?: FieldPolicy<any> | FieldReadFunction<any>,
	followups?: FieldPolicy<any> | FieldReadFunction<any>,
	followupsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	interestedIn?: FieldPolicy<any> | FieldReadFunction<any>,
	interestedInAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	interestedInProducts?: FieldPolicy<any> | FieldReadFunction<any>,
	interestedInProductsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	isClosed?: FieldPolicy<any> | FieldReadFunction<any>,
	lastVisitDate?: FieldPolicy<any> | FieldReadFunction<any>,
	searchString?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	tentativePurchaseTime?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedBy?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnquiryAdherenceKeySpecifier = ('AdhirenceRatio' | 'AvgAging' | 'centre' | 'closedFollowups' | 'totalClosed' | 'totalEnquiry' | 'totalFollowups' | 'totalOpen' | EnquiryAdherenceKeySpecifier)[];
export type EnquiryAdherenceFieldPolicy = {
	AdhirenceRatio?: FieldPolicy<any> | FieldReadFunction<any>,
	AvgAging?: FieldPolicy<any> | FieldReadFunction<any>,
	centre?: FieldPolicy<any> | FieldReadFunction<any>,
	closedFollowups?: FieldPolicy<any> | FieldReadFunction<any>,
	totalClosed?: FieldPolicy<any> | FieldReadFunction<any>,
	totalEnquiry?: FieldPolicy<any> | FieldReadFunction<any>,
	totalFollowups?: FieldPolicy<any> | FieldReadFunction<any>,
	totalOpen?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnquiryAdherenceAggregateResultKeySpecifier = ('AdhirenceRatioAvg' | 'AdhirenceRatioMax' | 'AdhirenceRatioMin' | 'AdhirenceRatioSum' | 'AvgAgingAvg' | 'AvgAgingMax' | 'AvgAgingMin' | 'AvgAgingSum' | 'closedFollowupsAvg' | 'closedFollowupsMax' | 'closedFollowupsMin' | 'closedFollowupsSum' | 'count' | 'totalClosedAvg' | 'totalClosedMax' | 'totalClosedMin' | 'totalClosedSum' | 'totalEnquiryAvg' | 'totalEnquiryMax' | 'totalEnquiryMin' | 'totalEnquirySum' | 'totalFollowupsAvg' | 'totalFollowupsMax' | 'totalFollowupsMin' | 'totalFollowupsSum' | 'totalOpenAvg' | 'totalOpenMax' | 'totalOpenMin' | 'totalOpenSum' | EnquiryAdherenceAggregateResultKeySpecifier)[];
export type EnquiryAdherenceAggregateResultFieldPolicy = {
	AdhirenceRatioAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	AdhirenceRatioMax?: FieldPolicy<any> | FieldReadFunction<any>,
	AdhirenceRatioMin?: FieldPolicy<any> | FieldReadFunction<any>,
	AdhirenceRatioSum?: FieldPolicy<any> | FieldReadFunction<any>,
	AvgAgingAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	AvgAgingMax?: FieldPolicy<any> | FieldReadFunction<any>,
	AvgAgingMin?: FieldPolicy<any> | FieldReadFunction<any>,
	AvgAgingSum?: FieldPolicy<any> | FieldReadFunction<any>,
	closedFollowupsAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	closedFollowupsMax?: FieldPolicy<any> | FieldReadFunction<any>,
	closedFollowupsMin?: FieldPolicy<any> | FieldReadFunction<any>,
	closedFollowupsSum?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	totalClosedAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	totalClosedMax?: FieldPolicy<any> | FieldReadFunction<any>,
	totalClosedMin?: FieldPolicy<any> | FieldReadFunction<any>,
	totalClosedSum?: FieldPolicy<any> | FieldReadFunction<any>,
	totalEnquiryAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	totalEnquiryMax?: FieldPolicy<any> | FieldReadFunction<any>,
	totalEnquiryMin?: FieldPolicy<any> | FieldReadFunction<any>,
	totalEnquirySum?: FieldPolicy<any> | FieldReadFunction<any>,
	totalFollowupsAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	totalFollowupsMax?: FieldPolicy<any> | FieldReadFunction<any>,
	totalFollowupsMin?: FieldPolicy<any> | FieldReadFunction<any>,
	totalFollowupsSum?: FieldPolicy<any> | FieldReadFunction<any>,
	totalOpenAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	totalOpenMax?: FieldPolicy<any> | FieldReadFunction<any>,
	totalOpenMin?: FieldPolicy<any> | FieldReadFunction<any>,
	totalOpenSum?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnquiryAggByCentreKeySpecifier = ('centre' | 'coldEnquiryCloser' | 'hotEnquiryCloser' | 'totalCold' | 'totalHot' | 'totalWarm' | 'warmEnquiryCloser' | EnquiryAggByCentreKeySpecifier)[];
export type EnquiryAggByCentreFieldPolicy = {
	centre?: FieldPolicy<any> | FieldReadFunction<any>,
	coldEnquiryCloser?: FieldPolicy<any> | FieldReadFunction<any>,
	hotEnquiryCloser?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCold?: FieldPolicy<any> | FieldReadFunction<any>,
	totalHot?: FieldPolicy<any> | FieldReadFunction<any>,
	totalWarm?: FieldPolicy<any> | FieldReadFunction<any>,
	warmEnquiryCloser?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnquiryAggByCentreAggregateResultKeySpecifier = ('count' | 'totalColdAvg' | 'totalColdMax' | 'totalColdMin' | 'totalColdSum' | 'totalHotAvg' | 'totalHotMax' | 'totalHotMin' | 'totalHotSum' | 'totalWarmAvg' | 'totalWarmMax' | 'totalWarmMin' | 'totalWarmSum' | EnquiryAggByCentreAggregateResultKeySpecifier)[];
export type EnquiryAggByCentreAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	totalColdAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	totalColdMax?: FieldPolicy<any> | FieldReadFunction<any>,
	totalColdMin?: FieldPolicy<any> | FieldReadFunction<any>,
	totalColdSum?: FieldPolicy<any> | FieldReadFunction<any>,
	totalHotAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	totalHotMax?: FieldPolicy<any> | FieldReadFunction<any>,
	totalHotMin?: FieldPolicy<any> | FieldReadFunction<any>,
	totalHotSum?: FieldPolicy<any> | FieldReadFunction<any>,
	totalWarmAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	totalWarmMax?: FieldPolicy<any> | FieldReadFunction<any>,
	totalWarmMin?: FieldPolicy<any> | FieldReadFunction<any>,
	totalWarmSum?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnquiryAggregateResultKeySpecifier = ('budgetAvg' | 'budgetMax' | 'budgetMin' | 'budgetSum' | 'count' | 'createdAtMax' | 'createdAtMin' | 'customerPhoneNoMax' | 'customerPhoneNoMin' | 'lastVisitDateMax' | 'lastVisitDateMin' | 'searchStringMax' | 'searchStringMin' | 'updatedAtMax' | 'updatedAtMin' | EnquiryAggregateResultKeySpecifier)[];
export type EnquiryAggregateResultFieldPolicy = {
	budgetAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	budgetMax?: FieldPolicy<any> | FieldReadFunction<any>,
	budgetMin?: FieldPolicy<any> | FieldReadFunction<any>,
	budgetSum?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	customerPhoneNoMax?: FieldPolicy<any> | FieldReadFunction<any>,
	customerPhoneNoMin?: FieldPolicy<any> | FieldReadFunction<any>,
	lastVisitDateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	lastVisitDateMin?: FieldPolicy<any> | FieldReadFunction<any>,
	searchStringMax?: FieldPolicy<any> | FieldReadFunction<any>,
	searchStringMin?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAtMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnquiryCloserAggKeySpecifier = ('closed' | 'infollowUp' | 'notIntrested' | 'notResponding' | 'purchaseNewTractor' | 'purchasedUsedTractor' | 'tractorBooked' | EnquiryCloserAggKeySpecifier)[];
export type EnquiryCloserAggFieldPolicy = {
	closed?: FieldPolicy<any> | FieldReadFunction<any>,
	infollowUp?: FieldPolicy<any> | FieldReadFunction<any>,
	notIntrested?: FieldPolicy<any> | FieldReadFunction<any>,
	notResponding?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseNewTractor?: FieldPolicy<any> | FieldReadFunction<any>,
	purchasedUsedTractor?: FieldPolicy<any> | FieldReadFunction<any>,
	tractorBooked?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnquiryCloserAggAggregateResultKeySpecifier = ('closedAvg' | 'closedMax' | 'closedMin' | 'closedSum' | 'count' | 'infollowUpAvg' | 'infollowUpMax' | 'infollowUpMin' | 'infollowUpSum' | 'notIntrestedAvg' | 'notIntrestedMax' | 'notIntrestedMin' | 'notIntrestedSum' | 'notRespondingAvg' | 'notRespondingMax' | 'notRespondingMin' | 'notRespondingSum' | 'purchaseNewTractorAvg' | 'purchaseNewTractorMax' | 'purchaseNewTractorMin' | 'purchaseNewTractorSum' | 'purchasedUsedTractorAvg' | 'purchasedUsedTractorMax' | 'purchasedUsedTractorMin' | 'purchasedUsedTractorSum' | 'tractorBookedAvg' | 'tractorBookedMax' | 'tractorBookedMin' | 'tractorBookedSum' | EnquiryCloserAggAggregateResultKeySpecifier)[];
export type EnquiryCloserAggAggregateResultFieldPolicy = {
	closedAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	closedMax?: FieldPolicy<any> | FieldReadFunction<any>,
	closedMin?: FieldPolicy<any> | FieldReadFunction<any>,
	closedSum?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	infollowUpAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	infollowUpMax?: FieldPolicy<any> | FieldReadFunction<any>,
	infollowUpMin?: FieldPolicy<any> | FieldReadFunction<any>,
	infollowUpSum?: FieldPolicy<any> | FieldReadFunction<any>,
	notIntrestedAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	notIntrestedMax?: FieldPolicy<any> | FieldReadFunction<any>,
	notIntrestedMin?: FieldPolicy<any> | FieldReadFunction<any>,
	notIntrestedSum?: FieldPolicy<any> | FieldReadFunction<any>,
	notRespondingAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	notRespondingMax?: FieldPolicy<any> | FieldReadFunction<any>,
	notRespondingMin?: FieldPolicy<any> | FieldReadFunction<any>,
	notRespondingSum?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseNewTractorAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseNewTractorMax?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseNewTractorMin?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseNewTractorSum?: FieldPolicy<any> | FieldReadFunction<any>,
	purchasedUsedTractorAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	purchasedUsedTractorMax?: FieldPolicy<any> | FieldReadFunction<any>,
	purchasedUsedTractorMin?: FieldPolicy<any> | FieldReadFunction<any>,
	purchasedUsedTractorSum?: FieldPolicy<any> | FieldReadFunction<any>,
	tractorBookedAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	tractorBookedMax?: FieldPolicy<any> | FieldReadFunction<any>,
	tractorBookedMin?: FieldPolicy<any> | FieldReadFunction<any>,
	tractorBookedSum?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnquiryClosureKeySpecifier = ('centre' | 'enquiryCloseReason' | 'purchaseFrom' | 'purchasePrice' | 'purchaseProduct' | 'regNo' | 'remarks' | 'year' | EnquiryClosureKeySpecifier)[];
export type EnquiryClosureFieldPolicy = {
	centre?: FieldPolicy<any> | FieldReadFunction<any>,
	enquiryCloseReason?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	purchasePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseProduct?: FieldPolicy<any> | FieldReadFunction<any>,
	regNo?: FieldPolicy<any> | FieldReadFunction<any>,
	remarks?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnquiryClosureAggregateResultKeySpecifier = ('count' | 'purchasePriceAvg' | 'purchasePriceMax' | 'purchasePriceMin' | 'purchasePriceSum' | 'regNoMax' | 'regNoMin' | 'remarksMax' | 'remarksMin' | 'yearMax' | 'yearMin' | EnquiryClosureAggregateResultKeySpecifier)[];
export type EnquiryClosureAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	purchasePriceAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	purchasePriceMax?: FieldPolicy<any> | FieldReadFunction<any>,
	purchasePriceMin?: FieldPolicy<any> | FieldReadFunction<any>,
	purchasePriceSum?: FieldPolicy<any> | FieldReadFunction<any>,
	regNoMax?: FieldPolicy<any> | FieldReadFunction<any>,
	regNoMin?: FieldPolicy<any> | FieldReadFunction<any>,
	remarksMax?: FieldPolicy<any> | FieldReadFunction<any>,
	remarksMin?: FieldPolicy<any> | FieldReadFunction<any>,
	yearMax?: FieldPolicy<any> | FieldReadFunction<any>,
	yearMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FollowupKeySpecifier = ('enquiry' | 'followedUpBy' | 'followupDate' | 'id' | 'isWalkin' | 'nextFollowup' | 'previousFollowup' | 'remarks' | 'status' | FollowupKeySpecifier)[];
export type FollowupFieldPolicy = {
	enquiry?: FieldPolicy<any> | FieldReadFunction<any>,
	followedUpBy?: FieldPolicy<any> | FieldReadFunction<any>,
	followupDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isWalkin?: FieldPolicy<any> | FieldReadFunction<any>,
	nextFollowup?: FieldPolicy<any> | FieldReadFunction<any>,
	previousFollowup?: FieldPolicy<any> | FieldReadFunction<any>,
	remarks?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FollowupAggregateResultKeySpecifier = ('count' | 'followupDateMax' | 'followupDateMin' | 'remarksMax' | 'remarksMin' | FollowupAggregateResultKeySpecifier)[];
export type FollowupAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	followupDateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	followupDateMin?: FieldPolicy<any> | FieldReadFunction<any>,
	remarksMax?: FieldPolicy<any> | FieldReadFunction<any>,
	remarksMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IdByNameKeySpecifier = ('brand_id' | 'district_id' | 'engine_capacity' | 'horse_power' | 'model_id' | 'state_id' | 'tahsil_id' | IdByNameKeySpecifier)[];
export type IdByNameFieldPolicy = {
	brand_id?: FieldPolicy<any> | FieldReadFunction<any>,
	district_id?: FieldPolicy<any> | FieldReadFunction<any>,
	engine_capacity?: FieldPolicy<any> | FieldReadFunction<any>,
	horse_power?: FieldPolicy<any> | FieldReadFunction<any>,
	model_id?: FieldPolicy<any> | FieldReadFunction<any>,
	state_id?: FieldPolicy<any> | FieldReadFunction<any>,
	tahsil_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IdByNameAggregateResultKeySpecifier = ('brand_idAvg' | 'brand_idMax' | 'brand_idMin' | 'brand_idSum' | 'count' | 'district_idAvg' | 'district_idMax' | 'district_idMin' | 'district_idSum' | 'engine_capacityMax' | 'engine_capacityMin' | 'horse_powerMax' | 'horse_powerMin' | 'model_idAvg' | 'model_idMax' | 'model_idMin' | 'model_idSum' | 'state_idAvg' | 'state_idMax' | 'state_idMin' | 'state_idSum' | 'tahsil_idAvg' | 'tahsil_idMax' | 'tahsil_idMin' | 'tahsil_idSum' | IdByNameAggregateResultKeySpecifier)[];
export type IdByNameAggregateResultFieldPolicy = {
	brand_idAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	brand_idMax?: FieldPolicy<any> | FieldReadFunction<any>,
	brand_idMin?: FieldPolicy<any> | FieldReadFunction<any>,
	brand_idSum?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	district_idAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	district_idMax?: FieldPolicy<any> | FieldReadFunction<any>,
	district_idMin?: FieldPolicy<any> | FieldReadFunction<any>,
	district_idSum?: FieldPolicy<any> | FieldReadFunction<any>,
	engine_capacityMax?: FieldPolicy<any> | FieldReadFunction<any>,
	engine_capacityMin?: FieldPolicy<any> | FieldReadFunction<any>,
	horse_powerMax?: FieldPolicy<any> | FieldReadFunction<any>,
	horse_powerMin?: FieldPolicy<any> | FieldReadFunction<any>,
	model_idAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	model_idMax?: FieldPolicy<any> | FieldReadFunction<any>,
	model_idMin?: FieldPolicy<any> | FieldReadFunction<any>,
	model_idSum?: FieldPolicy<any> | FieldReadFunction<any>,
	state_idAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	state_idMax?: FieldPolicy<any> | FieldReadFunction<any>,
	state_idMin?: FieldPolicy<any> | FieldReadFunction<any>,
	state_idSum?: FieldPolicy<any> | FieldReadFunction<any>,
	tahsil_idAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	tahsil_idMax?: FieldPolicy<any> | FieldReadFunction<any>,
	tahsil_idMin?: FieldPolicy<any> | FieldReadFunction<any>,
	tahsil_idSum?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IdentificationDocumentKeySpecifier = ('aadhaarBackPhotoUrl' | 'aadhaarFrontPhotoUrl' | 'aadhaarNumber' | 'customer' | 'id' | 'panNumber' | 'panPhotoUrl' | 'voterIdNumber' | 'voterIdPhotoUrl' | IdentificationDocumentKeySpecifier)[];
export type IdentificationDocumentFieldPolicy = {
	aadhaarBackPhotoUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	aadhaarFrontPhotoUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	aadhaarNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	customer?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	panNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	panPhotoUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	voterIdNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	voterIdPhotoUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IdentificationDocumentAggregateResultKeySpecifier = ('aadhaarBackPhotoUrlMax' | 'aadhaarBackPhotoUrlMin' | 'aadhaarFrontPhotoUrlMax' | 'aadhaarFrontPhotoUrlMin' | 'aadhaarNumberMax' | 'aadhaarNumberMin' | 'count' | 'panNumberMax' | 'panNumberMin' | 'panPhotoUrlMax' | 'panPhotoUrlMin' | 'voterIdNumberMax' | 'voterIdNumberMin' | 'voterIdPhotoUrlMax' | 'voterIdPhotoUrlMin' | IdentificationDocumentAggregateResultKeySpecifier)[];
export type IdentificationDocumentAggregateResultFieldPolicy = {
	aadhaarBackPhotoUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	aadhaarBackPhotoUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	aadhaarFrontPhotoUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	aadhaarFrontPhotoUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	aadhaarNumberMax?: FieldPolicy<any> | FieldReadFunction<any>,
	aadhaarNumberMin?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	panNumberMax?: FieldPolicy<any> | FieldReadFunction<any>,
	panNumberMin?: FieldPolicy<any> | FieldReadFunction<any>,
	panPhotoUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	panPhotoUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	voterIdNumberMax?: FieldPolicy<any> | FieldReadFunction<any>,
	voterIdNumberMin?: FieldPolicy<any> | FieldReadFunction<any>,
	voterIdPhotoUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	voterIdPhotoUrlMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IdsByNameForListingReponseKeySpecifier = ('data' | 'message' | 'status' | IdsByNameForListingReponseKeySpecifier)[];
export type IdsByNameForListingReponseFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IdsByNameForListingReponseAggregateResultKeySpecifier = ('count' | 'messageMax' | 'messageMin' | IdsByNameForListingReponseAggregateResultKeySpecifier)[];
export type IdsByNameForListingReponseAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	messageMax?: FieldPolicy<any> | FieldReadFunction<any>,
	messageMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InventoryDetailsKeySpecifier = ('id' | 'items' | 'itemsAggregate' | InventoryDetailsKeySpecifier)[];
export type InventoryDetailsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	itemsAggregate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InventoryDetailsAggregateResultKeySpecifier = ('count' | 'idMax' | 'idMin' | InventoryDetailsAggregateResultKeySpecifier)[];
export type InventoryDetailsAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	idMax?: FieldPolicy<any> | FieldReadFunction<any>,
	idMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IssueKeySpecifier = ('approvedBy' | 'centre' | 'createdAt' | 'id' | 'items' | 'itemsAggregate' | 'madeBy' | 'refurbishment' | 'regNo' | 'requestedItemId' | 'status' | 'totalPrice' | IssueKeySpecifier)[];
export type IssueFieldPolicy = {
	approvedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	centre?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	itemsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	madeBy?: FieldPolicy<any> | FieldReadFunction<any>,
	refurbishment?: FieldPolicy<any> | FieldReadFunction<any>,
	regNo?: FieldPolicy<any> | FieldReadFunction<any>,
	requestedItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPrice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IssueAggregateResultKeySpecifier = ('count' | 'createdAtMax' | 'createdAtMin' | 'regNoMax' | 'regNoMin' | 'requestedItemIdMax' | 'requestedItemIdMin' | 'totalPriceAvg' | 'totalPriceMax' | 'totalPriceMin' | 'totalPriceSum' | IssueAggregateResultKeySpecifier)[];
export type IssueAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	regNoMax?: FieldPolicy<any> | FieldReadFunction<any>,
	regNoMin?: FieldPolicy<any> | FieldReadFunction<any>,
	requestedItemIdMax?: FieldPolicy<any> | FieldReadFunction<any>,
	requestedItemIdMin?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPriceAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPriceMax?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPriceMin?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPriceSum?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IssueItemKeySpecifier = ('description' | 'id' | 'isApproved' | 'issue' | 'price' | 'product' | 'quantity' | 'requestedItemId' | IssueItemKeySpecifier)[];
export type IssueItemFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isApproved?: FieldPolicy<any> | FieldReadFunction<any>,
	issue?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	requestedItemId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IssueItemAggregateResultKeySpecifier = ('count' | 'descriptionMax' | 'descriptionMin' | 'priceAvg' | 'priceMax' | 'priceMin' | 'priceSum' | 'quantityAvg' | 'quantityMax' | 'quantityMin' | 'quantitySum' | 'requestedItemIdMax' | 'requestedItemIdMin' | IssueItemAggregateResultKeySpecifier)[];
export type IssueItemAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptionMax?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptionMin?: FieldPolicy<any> | FieldReadFunction<any>,
	priceAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	priceMax?: FieldPolicy<any> | FieldReadFunction<any>,
	priceMin?: FieldPolicy<any> | FieldReadFunction<any>,
	priceSum?: FieldPolicy<any> | FieldReadFunction<any>,
	quantityAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	quantityMax?: FieldPolicy<any> | FieldReadFunction<any>,
	quantityMin?: FieldPolicy<any> | FieldReadFunction<any>,
	quantitySum?: FieldPolicy<any> | FieldReadFunction<any>,
	requestedItemIdMax?: FieldPolicy<any> | FieldReadFunction<any>,
	requestedItemIdMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ItemInventoryDetailsKeySpecifier = ('availableInStock' | 'avgUnitPrice' | 'consumed' | 'createdAt' | 'id' | 'issueQueue' | 'product' | 'purchaseQueue' | 'totalPrice' | 'totalPurchase' | 'updatedAt' | ItemInventoryDetailsKeySpecifier)[];
export type ItemInventoryDetailsFieldPolicy = {
	availableInStock?: FieldPolicy<any> | FieldReadFunction<any>,
	avgUnitPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	consumed?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	issueQueue?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseQueue?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPurchase?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ItemInventoryDetailsAggregateResultKeySpecifier = ('availableInStockAvg' | 'availableInStockMax' | 'availableInStockMin' | 'availableInStockSum' | 'avgUnitPriceMax' | 'avgUnitPriceMin' | 'consumedAvg' | 'consumedMax' | 'consumedMin' | 'consumedSum' | 'count' | 'createdAtMax' | 'createdAtMin' | 'idMax' | 'idMin' | 'issueQueueAvg' | 'issueQueueMax' | 'issueQueueMin' | 'issueQueueSum' | 'purchaseQueueAvg' | 'purchaseQueueMax' | 'purchaseQueueMin' | 'purchaseQueueSum' | 'totalPriceAvg' | 'totalPriceMax' | 'totalPriceMin' | 'totalPriceSum' | 'totalPurchaseAvg' | 'totalPurchaseMax' | 'totalPurchaseMin' | 'totalPurchaseSum' | 'updatedAtMax' | 'updatedAtMin' | ItemInventoryDetailsAggregateResultKeySpecifier)[];
export type ItemInventoryDetailsAggregateResultFieldPolicy = {
	availableInStockAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	availableInStockMax?: FieldPolicy<any> | FieldReadFunction<any>,
	availableInStockMin?: FieldPolicy<any> | FieldReadFunction<any>,
	availableInStockSum?: FieldPolicy<any> | FieldReadFunction<any>,
	avgUnitPriceMax?: FieldPolicy<any> | FieldReadFunction<any>,
	avgUnitPriceMin?: FieldPolicy<any> | FieldReadFunction<any>,
	consumedAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	consumedMax?: FieldPolicy<any> | FieldReadFunction<any>,
	consumedMin?: FieldPolicy<any> | FieldReadFunction<any>,
	consumedSum?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	idMax?: FieldPolicy<any> | FieldReadFunction<any>,
	idMin?: FieldPolicy<any> | FieldReadFunction<any>,
	issueQueueAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	issueQueueMax?: FieldPolicy<any> | FieldReadFunction<any>,
	issueQueueMin?: FieldPolicy<any> | FieldReadFunction<any>,
	issueQueueSum?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseQueueAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseQueueMax?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseQueueMin?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseQueueSum?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPriceAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPriceMax?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPriceMin?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPriceSum?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPurchaseAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPurchaseMax?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPurchaseMin?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPurchaseSum?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAtMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LeadKeySpecifier = ('accessories' | 'accessoriesAggregate' | 'accessoriesChecklist' | 'accessoriesChecklistAggregate' | 'activeBooking' | 'actualParkingCharges' | 'actualPickupDate' | 'approvedDealAmount' | 'approvedParkingChargesFor' | 'archivedBookings' | 'archivedBookingsAggregate' | 'auctionByBank' | 'auctionHistory' | 'auctionHistoryAggregate' | 'auctioningAgency' | 'auctioningBank' | 'bookings' | 'bookingsAggregate' | 'centre' | 'createdAt' | 'createdBy' | 'dealer' | 'dealerStance' | 'dealershipDocuments' | 'deliveredSelfieUrl' | 'deliveryAmount' | 'deliveryCentre' | 'demandAmount' | 'documentCharges' | 'documentChecklist' | 'documents' | 'documentsFollowups' | 'documentsFollowupsAggregate' | 'estimatedParkingCharges' | 'expectedPickupDate' | 'expenses' | 'expensesAggregate' | 'expensesCoveredIn' | 'expensesCoveredInAggregate' | 'finalBidAmount' | 'finalParkingCharges' | 'holdbackAmount' | 'id' | 'internalTransfers' | 'internalTransfersAggregate' | 'listingOnWebUpdatedAt' | 'listingPrice' | 'listingStatus' | 'listingUpdatedBy' | 'loanAmount' | 'loanToBeClosedBy' | 'ownershipType' | 'parkingBeneficiary' | 'payInParts' | 'paymentType' | 'payments' | 'paymentsAggregate' | 'pickup' | 'proposedBidLimitAmount' | 'proposedDealAmount' | 'refurbishmentDetails' | 'regNo' | 'registrationState' | 'searchString' | 'sellingPrice' | 'source' | 'status' | 'statusEvents' | 'statusEventsAggregate' | 'tokenAmount' | 'updatedAt' | 'updatedBy' | 'vehicle' | 'yard' | 'yardPerDayParkingCharges' | 'yardPerDayParkingChargesByDriver' | LeadKeySpecifier)[];
export type LeadFieldPolicy = {
	accessories?: FieldPolicy<any> | FieldReadFunction<any>,
	accessoriesAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	accessoriesChecklist?: FieldPolicy<any> | FieldReadFunction<any>,
	accessoriesChecklistAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	activeBooking?: FieldPolicy<any> | FieldReadFunction<any>,
	actualParkingCharges?: FieldPolicy<any> | FieldReadFunction<any>,
	actualPickupDate?: FieldPolicy<any> | FieldReadFunction<any>,
	approvedDealAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	approvedParkingChargesFor?: FieldPolicy<any> | FieldReadFunction<any>,
	archivedBookings?: FieldPolicy<any> | FieldReadFunction<any>,
	archivedBookingsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	auctionByBank?: FieldPolicy<any> | FieldReadFunction<any>,
	auctionHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	auctionHistoryAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	auctioningAgency?: FieldPolicy<any> | FieldReadFunction<any>,
	auctioningBank?: FieldPolicy<any> | FieldReadFunction<any>,
	bookings?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	centre?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	dealer?: FieldPolicy<any> | FieldReadFunction<any>,
	dealerStance?: FieldPolicy<any> | FieldReadFunction<any>,
	dealershipDocuments?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveredSelfieUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryCentre?: FieldPolicy<any> | FieldReadFunction<any>,
	demandAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	documentCharges?: FieldPolicy<any> | FieldReadFunction<any>,
	documentChecklist?: FieldPolicy<any> | FieldReadFunction<any>,
	documents?: FieldPolicy<any> | FieldReadFunction<any>,
	documentsFollowups?: FieldPolicy<any> | FieldReadFunction<any>,
	documentsFollowupsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	estimatedParkingCharges?: FieldPolicy<any> | FieldReadFunction<any>,
	expectedPickupDate?: FieldPolicy<any> | FieldReadFunction<any>,
	expenses?: FieldPolicy<any> | FieldReadFunction<any>,
	expensesAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	expensesCoveredIn?: FieldPolicy<any> | FieldReadFunction<any>,
	expensesCoveredInAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	finalBidAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	finalParkingCharges?: FieldPolicy<any> | FieldReadFunction<any>,
	holdbackAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	internalTransfers?: FieldPolicy<any> | FieldReadFunction<any>,
	internalTransfersAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	listingOnWebUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	listingStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	listingUpdatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	loanAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	loanToBeClosedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	ownershipType?: FieldPolicy<any> | FieldReadFunction<any>,
	parkingBeneficiary?: FieldPolicy<any> | FieldReadFunction<any>,
	payInParts?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentType?: FieldPolicy<any> | FieldReadFunction<any>,
	payments?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	pickup?: FieldPolicy<any> | FieldReadFunction<any>,
	proposedBidLimitAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	proposedDealAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	refurbishmentDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	regNo?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationState?: FieldPolicy<any> | FieldReadFunction<any>,
	searchString?: FieldPolicy<any> | FieldReadFunction<any>,
	sellingPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	statusEvents?: FieldPolicy<any> | FieldReadFunction<any>,
	statusEventsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	tokenAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicle?: FieldPolicy<any> | FieldReadFunction<any>,
	yard?: FieldPolicy<any> | FieldReadFunction<any>,
	yardPerDayParkingCharges?: FieldPolicy<any> | FieldReadFunction<any>,
	yardPerDayParkingChargesByDriver?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LeadAggregateResultKeySpecifier = ('actualParkingChargesAvg' | 'actualParkingChargesMax' | 'actualParkingChargesMin' | 'actualParkingChargesSum' | 'actualPickupDateMax' | 'actualPickupDateMin' | 'approvedDealAmountAvg' | 'approvedDealAmountMax' | 'approvedDealAmountMin' | 'approvedDealAmountSum' | 'count' | 'createdAtMax' | 'createdAtMin' | 'deliveredSelfieUrlMax' | 'deliveredSelfieUrlMin' | 'deliveryAmountAvg' | 'deliveryAmountMax' | 'deliveryAmountMin' | 'deliveryAmountSum' | 'demandAmountAvg' | 'demandAmountMax' | 'demandAmountMin' | 'demandAmountSum' | 'documentChargesAvg' | 'documentChargesMax' | 'documentChargesMin' | 'documentChargesSum' | 'estimatedParkingChargesAvg' | 'estimatedParkingChargesMax' | 'estimatedParkingChargesMin' | 'estimatedParkingChargesSum' | 'expectedPickupDateMax' | 'expectedPickupDateMin' | 'finalBidAmountAvg' | 'finalBidAmountMax' | 'finalBidAmountMin' | 'finalBidAmountSum' | 'finalParkingChargesAvg' | 'finalParkingChargesMax' | 'finalParkingChargesMin' | 'finalParkingChargesSum' | 'holdbackAmountAvg' | 'holdbackAmountMax' | 'holdbackAmountMin' | 'holdbackAmountSum' | 'listingOnWebUpdatedAtMax' | 'listingOnWebUpdatedAtMin' | 'listingPriceAvg' | 'listingPriceMax' | 'listingPriceMin' | 'listingPriceSum' | 'loanAmountAvg' | 'loanAmountMax' | 'loanAmountMin' | 'loanAmountSum' | 'proposedBidLimitAmountAvg' | 'proposedBidLimitAmountMax' | 'proposedBidLimitAmountMin' | 'proposedBidLimitAmountSum' | 'proposedDealAmountAvg' | 'proposedDealAmountMax' | 'proposedDealAmountMin' | 'proposedDealAmountSum' | 'regNoMax' | 'regNoMin' | 'registrationStateMax' | 'registrationStateMin' | 'searchStringMax' | 'searchStringMin' | 'sellingPriceAvg' | 'sellingPriceMax' | 'sellingPriceMin' | 'sellingPriceSum' | 'tokenAmountAvg' | 'tokenAmountMax' | 'tokenAmountMin' | 'tokenAmountSum' | 'updatedAtMax' | 'updatedAtMin' | 'yardPerDayParkingChargesAvg' | 'yardPerDayParkingChargesByDriverAvg' | 'yardPerDayParkingChargesByDriverMax' | 'yardPerDayParkingChargesByDriverMin' | 'yardPerDayParkingChargesByDriverSum' | 'yardPerDayParkingChargesMax' | 'yardPerDayParkingChargesMin' | 'yardPerDayParkingChargesSum' | LeadAggregateResultKeySpecifier)[];
export type LeadAggregateResultFieldPolicy = {
	actualParkingChargesAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	actualParkingChargesMax?: FieldPolicy<any> | FieldReadFunction<any>,
	actualParkingChargesMin?: FieldPolicy<any> | FieldReadFunction<any>,
	actualParkingChargesSum?: FieldPolicy<any> | FieldReadFunction<any>,
	actualPickupDateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	actualPickupDateMin?: FieldPolicy<any> | FieldReadFunction<any>,
	approvedDealAmountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	approvedDealAmountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	approvedDealAmountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	approvedDealAmountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveredSelfieUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveredSelfieUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryAmountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryAmountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryAmountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryAmountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	demandAmountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	demandAmountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	demandAmountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	demandAmountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	documentChargesAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	documentChargesMax?: FieldPolicy<any> | FieldReadFunction<any>,
	documentChargesMin?: FieldPolicy<any> | FieldReadFunction<any>,
	documentChargesSum?: FieldPolicy<any> | FieldReadFunction<any>,
	estimatedParkingChargesAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	estimatedParkingChargesMax?: FieldPolicy<any> | FieldReadFunction<any>,
	estimatedParkingChargesMin?: FieldPolicy<any> | FieldReadFunction<any>,
	estimatedParkingChargesSum?: FieldPolicy<any> | FieldReadFunction<any>,
	expectedPickupDateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	expectedPickupDateMin?: FieldPolicy<any> | FieldReadFunction<any>,
	finalBidAmountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	finalBidAmountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	finalBidAmountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	finalBidAmountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	finalParkingChargesAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	finalParkingChargesMax?: FieldPolicy<any> | FieldReadFunction<any>,
	finalParkingChargesMin?: FieldPolicy<any> | FieldReadFunction<any>,
	finalParkingChargesSum?: FieldPolicy<any> | FieldReadFunction<any>,
	holdbackAmountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	holdbackAmountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	holdbackAmountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	holdbackAmountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	listingOnWebUpdatedAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	listingOnWebUpdatedAtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPriceAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPriceMax?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPriceMin?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPriceSum?: FieldPolicy<any> | FieldReadFunction<any>,
	loanAmountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	loanAmountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	loanAmountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	loanAmountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	proposedBidLimitAmountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	proposedBidLimitAmountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	proposedBidLimitAmountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	proposedBidLimitAmountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	proposedDealAmountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	proposedDealAmountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	proposedDealAmountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	proposedDealAmountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	regNoMax?: FieldPolicy<any> | FieldReadFunction<any>,
	regNoMin?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationStateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationStateMin?: FieldPolicy<any> | FieldReadFunction<any>,
	searchStringMax?: FieldPolicy<any> | FieldReadFunction<any>,
	searchStringMin?: FieldPolicy<any> | FieldReadFunction<any>,
	sellingPriceAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	sellingPriceMax?: FieldPolicy<any> | FieldReadFunction<any>,
	sellingPriceMin?: FieldPolicy<any> | FieldReadFunction<any>,
	sellingPriceSum?: FieldPolicy<any> | FieldReadFunction<any>,
	tokenAmountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	tokenAmountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	tokenAmountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	tokenAmountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	yardPerDayParkingChargesAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	yardPerDayParkingChargesByDriverAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	yardPerDayParkingChargesByDriverMax?: FieldPolicy<any> | FieldReadFunction<any>,
	yardPerDayParkingChargesByDriverMin?: FieldPolicy<any> | FieldReadFunction<any>,
	yardPerDayParkingChargesByDriverSum?: FieldPolicy<any> | FieldReadFunction<any>,
	yardPerDayParkingChargesMax?: FieldPolicy<any> | FieldReadFunction<any>,
	yardPerDayParkingChargesMin?: FieldPolicy<any> | FieldReadFunction<any>,
	yardPerDayParkingChargesSum?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LeadCountByStatusKeySpecifier = ('count' | 'status' | LeadCountByStatusKeySpecifier)[];
export type LeadCountByStatusFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LeadCountByStatusAggregateResultKeySpecifier = ('count' | 'countAvg' | 'countMax' | 'countMin' | 'countSum' | LeadCountByStatusAggregateResultKeySpecifier)[];
export type LeadCountByStatusAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	countAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	countMax?: FieldPolicy<any> | FieldReadFunction<any>,
	countMin?: FieldPolicy<any> | FieldReadFunction<any>,
	countSum?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LeadDocumentsKeySpecifier = ('bankAccountProofUrl' | 'bankNOC' | 'dealPaymentProofUrl' | 'form26' | 'form28' | 'form29' | 'form30' | 'form35' | 'form36' | 'form60' | 'form60_sellerPan' | 'id' | 'indemnityBond' | 'insuranceCertificate' | 'lead' | 'loanForeclosure' | 'ownerAddressProof' | 'parkingPaymentProofUrl' | 'regNo' | 'registrationCertificate' | 'releaseOrder' | 'sellerAadharCard' | 'sellerPAN' | LeadDocumentsKeySpecifier)[];
export type LeadDocumentsFieldPolicy = {
	bankAccountProofUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	bankNOC?: FieldPolicy<any> | FieldReadFunction<any>,
	dealPaymentProofUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	form26?: FieldPolicy<any> | FieldReadFunction<any>,
	form28?: FieldPolicy<any> | FieldReadFunction<any>,
	form29?: FieldPolicy<any> | FieldReadFunction<any>,
	form30?: FieldPolicy<any> | FieldReadFunction<any>,
	form35?: FieldPolicy<any> | FieldReadFunction<any>,
	form36?: FieldPolicy<any> | FieldReadFunction<any>,
	form60?: FieldPolicy<any> | FieldReadFunction<any>,
	form60_sellerPan?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	indemnityBond?: FieldPolicy<any> | FieldReadFunction<any>,
	insuranceCertificate?: FieldPolicy<any> | FieldReadFunction<any>,
	lead?: FieldPolicy<any> | FieldReadFunction<any>,
	loanForeclosure?: FieldPolicy<any> | FieldReadFunction<any>,
	ownerAddressProof?: FieldPolicy<any> | FieldReadFunction<any>,
	parkingPaymentProofUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	regNo?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationCertificate?: FieldPolicy<any> | FieldReadFunction<any>,
	releaseOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	sellerAadharCard?: FieldPolicy<any> | FieldReadFunction<any>,
	sellerPAN?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LeadDocumentsAggregateResultKeySpecifier = ('bankAccountProofUrlMax' | 'bankAccountProofUrlMin' | 'bankNOCMax' | 'bankNOCMin' | 'count' | 'dealPaymentProofUrlMax' | 'dealPaymentProofUrlMin' | 'form26Max' | 'form26Min' | 'form28Max' | 'form28Min' | 'form29Max' | 'form29Min' | 'form30Max' | 'form30Min' | 'form35Max' | 'form35Min' | 'form36Max' | 'form36Min' | 'form60Max' | 'form60Min' | 'form60_sellerPanMax' | 'form60_sellerPanMin' | 'indemnityBondMax' | 'indemnityBondMin' | 'insuranceCertificateMax' | 'insuranceCertificateMin' | 'loanForeclosureMax' | 'loanForeclosureMin' | 'ownerAddressProofMax' | 'ownerAddressProofMin' | 'parkingPaymentProofUrlMax' | 'parkingPaymentProofUrlMin' | 'regNoMax' | 'regNoMin' | 'registrationCertificateMax' | 'registrationCertificateMin' | 'releaseOrderMax' | 'releaseOrderMin' | 'sellerAadharCardMax' | 'sellerAadharCardMin' | 'sellerPANMax' | 'sellerPANMin' | LeadDocumentsAggregateResultKeySpecifier)[];
export type LeadDocumentsAggregateResultFieldPolicy = {
	bankAccountProofUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	bankAccountProofUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	bankNOCMax?: FieldPolicy<any> | FieldReadFunction<any>,
	bankNOCMin?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	dealPaymentProofUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	dealPaymentProofUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	form26Max?: FieldPolicy<any> | FieldReadFunction<any>,
	form26Min?: FieldPolicy<any> | FieldReadFunction<any>,
	form28Max?: FieldPolicy<any> | FieldReadFunction<any>,
	form28Min?: FieldPolicy<any> | FieldReadFunction<any>,
	form29Max?: FieldPolicy<any> | FieldReadFunction<any>,
	form29Min?: FieldPolicy<any> | FieldReadFunction<any>,
	form30Max?: FieldPolicy<any> | FieldReadFunction<any>,
	form30Min?: FieldPolicy<any> | FieldReadFunction<any>,
	form35Max?: FieldPolicy<any> | FieldReadFunction<any>,
	form35Min?: FieldPolicy<any> | FieldReadFunction<any>,
	form36Max?: FieldPolicy<any> | FieldReadFunction<any>,
	form36Min?: FieldPolicy<any> | FieldReadFunction<any>,
	form60Max?: FieldPolicy<any> | FieldReadFunction<any>,
	form60Min?: FieldPolicy<any> | FieldReadFunction<any>,
	form60_sellerPanMax?: FieldPolicy<any> | FieldReadFunction<any>,
	form60_sellerPanMin?: FieldPolicy<any> | FieldReadFunction<any>,
	indemnityBondMax?: FieldPolicy<any> | FieldReadFunction<any>,
	indemnityBondMin?: FieldPolicy<any> | FieldReadFunction<any>,
	insuranceCertificateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	insuranceCertificateMin?: FieldPolicy<any> | FieldReadFunction<any>,
	loanForeclosureMax?: FieldPolicy<any> | FieldReadFunction<any>,
	loanForeclosureMin?: FieldPolicy<any> | FieldReadFunction<any>,
	ownerAddressProofMax?: FieldPolicy<any> | FieldReadFunction<any>,
	ownerAddressProofMin?: FieldPolicy<any> | FieldReadFunction<any>,
	parkingPaymentProofUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	parkingPaymentProofUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	regNoMax?: FieldPolicy<any> | FieldReadFunction<any>,
	regNoMin?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationCertificateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationCertificateMin?: FieldPolicy<any> | FieldReadFunction<any>,
	releaseOrderMax?: FieldPolicy<any> | FieldReadFunction<any>,
	releaseOrderMin?: FieldPolicy<any> | FieldReadFunction<any>,
	sellerAadharCardMax?: FieldPolicy<any> | FieldReadFunction<any>,
	sellerAadharCardMin?: FieldPolicy<any> | FieldReadFunction<any>,
	sellerPANMax?: FieldPolicy<any> | FieldReadFunction<any>,
	sellerPANMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LeadExpenseKeySpecifier = ('belongsTo' | 'category' | 'createdAt' | 'createdBy' | 'description' | 'id' | 'isApproved' | 'lead' | 'paymentStatus' | 'receiptUrl' | 'spentAmount' | LeadExpenseKeySpecifier)[];
export type LeadExpenseFieldPolicy = {
	belongsTo?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isApproved?: FieldPolicy<any> | FieldReadFunction<any>,
	lead?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	receiptUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	spentAmount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LeadExpenseAggregateResultKeySpecifier = ('count' | 'createdAtMax' | 'createdAtMin' | 'descriptionMax' | 'descriptionMin' | 'receiptUrlMax' | 'receiptUrlMin' | 'spentAmountMax' | 'spentAmountMin' | LeadExpenseAggregateResultKeySpecifier)[];
export type LeadExpenseAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptionMax?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptionMin?: FieldPolicy<any> | FieldReadFunction<any>,
	receiptUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	receiptUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	spentAmountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	spentAmountMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LeadStatusEventKeySpecifier = ('assignTaskTo' | 'createdAt' | 'createdBy' | 'deviceType' | 'id' | 'isTaskCompleted' | 'lead' | 'metadata' | 'next' | 'notification' | 'notifyTo' | 'postTimeline' | 'preTimeline' | 'previous' | 'remarks' | 'status' | 'task' | 'taskButtonTitle' | 'taskTitle' | LeadStatusEventKeySpecifier)[];
export type LeadStatusEventFieldPolicy = {
	assignTaskTo?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isTaskCompleted?: FieldPolicy<any> | FieldReadFunction<any>,
	lead?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	next?: FieldPolicy<any> | FieldReadFunction<any>,
	notification?: FieldPolicy<any> | FieldReadFunction<any>,
	notifyTo?: FieldPolicy<any> | FieldReadFunction<any>,
	postTimeline?: FieldPolicy<any> | FieldReadFunction<any>,
	preTimeline?: FieldPolicy<any> | FieldReadFunction<any>,
	previous?: FieldPolicy<any> | FieldReadFunction<any>,
	remarks?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	task?: FieldPolicy<any> | FieldReadFunction<any>,
	taskButtonTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	taskTitle?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LeadStatusEventAggregateResultKeySpecifier = ('count' | 'createdAtMax' | 'createdAtMin' | 'metadataMax' | 'metadataMin' | 'postTimelineMax' | 'postTimelineMin' | 'preTimelineMax' | 'preTimelineMin' | 'remarksMax' | 'remarksMin' | 'taskButtonTitleMax' | 'taskButtonTitleMin' | 'taskTitleMax' | 'taskTitleMin' | LeadStatusEventAggregateResultKeySpecifier)[];
export type LeadStatusEventAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	metadataMax?: FieldPolicy<any> | FieldReadFunction<any>,
	metadataMin?: FieldPolicy<any> | FieldReadFunction<any>,
	postTimelineMax?: FieldPolicy<any> | FieldReadFunction<any>,
	postTimelineMin?: FieldPolicy<any> | FieldReadFunction<any>,
	preTimelineMax?: FieldPolicy<any> | FieldReadFunction<any>,
	preTimelineMin?: FieldPolicy<any> | FieldReadFunction<any>,
	remarksMax?: FieldPolicy<any> | FieldReadFunction<any>,
	remarksMin?: FieldPolicy<any> | FieldReadFunction<any>,
	taskButtonTitleMax?: FieldPolicy<any> | FieldReadFunction<any>,
	taskButtonTitleMin?: FieldPolicy<any> | FieldReadFunction<any>,
	taskTitleMax?: FieldPolicy<any> | FieldReadFunction<any>,
	taskTitleMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LeadStatusFlowKeySpecifier = ('assignTaskTo' | 'canGoBack' | 'canGoForward' | 'cta' | 'current' | 'desired' | 'freshLeadTimelineAction' | 'hideForm' | 'hideUndesiredButton' | 'id' | 'isNegativeCase' | 'next' | 'notificationTitle' | 'notifyTo' | 'popupDescription' | 'popupTitle' | 'previous' | 'rejectedLeadTimelineAction' | 'showPopup' | 'showPopupRemark' | 'showPopupWithInputField' | 'source' | 'taskButtonTitle' | 'taskFormActionTitle' | 'taskFormNegativeActionTitle' | 'taskPerformedBy' | 'taskTitle' | 'taskTitleWas' | 'undesired' | LeadStatusFlowKeySpecifier)[];
export type LeadStatusFlowFieldPolicy = {
	assignTaskTo?: FieldPolicy<any> | FieldReadFunction<any>,
	canGoBack?: FieldPolicy<any> | FieldReadFunction<any>,
	canGoForward?: FieldPolicy<any> | FieldReadFunction<any>,
	cta?: FieldPolicy<any> | FieldReadFunction<any>,
	current?: FieldPolicy<any> | FieldReadFunction<any>,
	desired?: FieldPolicy<any> | FieldReadFunction<any>,
	freshLeadTimelineAction?: FieldPolicy<any> | FieldReadFunction<any>,
	hideForm?: FieldPolicy<any> | FieldReadFunction<any>,
	hideUndesiredButton?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isNegativeCase?: FieldPolicy<any> | FieldReadFunction<any>,
	next?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	notifyTo?: FieldPolicy<any> | FieldReadFunction<any>,
	popupDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	popupTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	previous?: FieldPolicy<any> | FieldReadFunction<any>,
	rejectedLeadTimelineAction?: FieldPolicy<any> | FieldReadFunction<any>,
	showPopup?: FieldPolicy<any> | FieldReadFunction<any>,
	showPopupRemark?: FieldPolicy<any> | FieldReadFunction<any>,
	showPopupWithInputField?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	taskButtonTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	taskFormActionTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	taskFormNegativeActionTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	taskPerformedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	taskTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	taskTitleWas?: FieldPolicy<any> | FieldReadFunction<any>,
	undesired?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LeadStatusFlowAggregateResultKeySpecifier = ('count' | 'ctaMax' | 'ctaMin' | 'notificationTitleMax' | 'notificationTitleMin' | 'popupDescriptionMax' | 'popupDescriptionMin' | 'popupTitleMax' | 'popupTitleMin' | 'taskButtonTitleMax' | 'taskButtonTitleMin' | 'taskFormActionTitleMax' | 'taskFormActionTitleMin' | 'taskFormNegativeActionTitleMax' | 'taskFormNegativeActionTitleMin' | 'taskTitleMax' | 'taskTitleMin' | 'taskTitleWasMax' | 'taskTitleWasMin' | LeadStatusFlowAggregateResultKeySpecifier)[];
export type LeadStatusFlowAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaMax?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaMin?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationTitleMax?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationTitleMin?: FieldPolicy<any> | FieldReadFunction<any>,
	popupDescriptionMax?: FieldPolicy<any> | FieldReadFunction<any>,
	popupDescriptionMin?: FieldPolicy<any> | FieldReadFunction<any>,
	popupTitleMax?: FieldPolicy<any> | FieldReadFunction<any>,
	popupTitleMin?: FieldPolicy<any> | FieldReadFunction<any>,
	taskButtonTitleMax?: FieldPolicy<any> | FieldReadFunction<any>,
	taskButtonTitleMin?: FieldPolicy<any> | FieldReadFunction<any>,
	taskFormActionTitleMax?: FieldPolicy<any> | FieldReadFunction<any>,
	taskFormActionTitleMin?: FieldPolicy<any> | FieldReadFunction<any>,
	taskFormNegativeActionTitleMax?: FieldPolicy<any> | FieldReadFunction<any>,
	taskFormNegativeActionTitleMin?: FieldPolicy<any> | FieldReadFunction<any>,
	taskTitleMax?: FieldPolicy<any> | FieldReadFunction<any>,
	taskTitleMin?: FieldPolicy<any> | FieldReadFunction<any>,
	taskTitleWasMax?: FieldPolicy<any> | FieldReadFunction<any>,
	taskTitleWasMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LeadTimelineActionKeySpecifier = ('id' | 'postAction' | 'preAction' | LeadTimelineActionKeySpecifier)[];
export type LeadTimelineActionFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	postAction?: FieldPolicy<any> | FieldReadFunction<any>,
	preAction?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LeadTimelineActionAggregateResultKeySpecifier = ('count' | 'postActionMax' | 'postActionMin' | 'preActionMax' | 'preActionMin' | LeadTimelineActionAggregateResultKeySpecifier)[];
export type LeadTimelineActionAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	postActionMax?: FieldPolicy<any> | FieldReadFunction<any>,
	postActionMin?: FieldPolicy<any> | FieldReadFunction<any>,
	preActionMax?: FieldPolicy<any> | FieldReadFunction<any>,
	preActionMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LeadTimelineStatusKeySpecifier = ('freshLeadTimelineAction' | 'id' | 'rejectedLeadTimelineAction' | LeadTimelineStatusKeySpecifier)[];
export type LeadTimelineStatusFieldPolicy = {
	freshLeadTimelineAction?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	rejectedLeadTimelineAction?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LeadTimelineStatusAggregateResultKeySpecifier = ('count' | LeadTimelineStatusAggregateResultKeySpecifier)[];
export type LeadTimelineStatusAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LoanKeySpecifier = ('appliedLoanAmount' | 'bankName' | 'booking' | 'bookingWithArchivedLoan' | 'createdAt' | 'deliveryOrderDate' | 'deliveryOrderDocUrl' | 'deliveryOrderStatus' | 'deliveryOrderValidity' | 'fieldInspectionConfirmedDate' | 'fieldInspectionDate' | 'fieldInspectionStatus' | 'id' | 'loanCancelReason' | 'loanStage' | 'loanStatus' | 'loginApplicationFormUrl' | 'loginDate' | 'loginStatus' | 'rejectedAt' | 'rejectionReason' | 'sanctionedLoanAmount' | 'updatedAt' | LoanKeySpecifier)[];
export type LoanFieldPolicy = {
	appliedLoanAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	bankName?: FieldPolicy<any> | FieldReadFunction<any>,
	booking?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingWithArchivedLoan?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryOrderDate?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryOrderDocUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryOrderStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryOrderValidity?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldInspectionConfirmedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldInspectionDate?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldInspectionStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	loanCancelReason?: FieldPolicy<any> | FieldReadFunction<any>,
	loanStage?: FieldPolicy<any> | FieldReadFunction<any>,
	loanStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	loginApplicationFormUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	loginDate?: FieldPolicy<any> | FieldReadFunction<any>,
	loginStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	rejectedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	rejectionReason?: FieldPolicy<any> | FieldReadFunction<any>,
	sanctionedLoanAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LoanAggregateResultKeySpecifier = ('appliedLoanAmountAvg' | 'appliedLoanAmountMax' | 'appliedLoanAmountMin' | 'appliedLoanAmountSum' | 'count' | 'createdAtMax' | 'createdAtMin' | 'deliveryOrderDateMax' | 'deliveryOrderDateMin' | 'deliveryOrderDocUrlMax' | 'deliveryOrderDocUrlMin' | 'deliveryOrderValidityAvg' | 'deliveryOrderValidityMax' | 'deliveryOrderValidityMin' | 'deliveryOrderValiditySum' | 'fieldInspectionConfirmedDateMax' | 'fieldInspectionConfirmedDateMin' | 'fieldInspectionDateMax' | 'fieldInspectionDateMin' | 'loginApplicationFormUrlMax' | 'loginApplicationFormUrlMin' | 'loginDateMax' | 'loginDateMin' | 'sanctionedLoanAmountAvg' | 'sanctionedLoanAmountMax' | 'sanctionedLoanAmountMin' | 'sanctionedLoanAmountSum' | 'updatedAtMax' | 'updatedAtMin' | LoanAggregateResultKeySpecifier)[];
export type LoanAggregateResultFieldPolicy = {
	appliedLoanAmountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	appliedLoanAmountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	appliedLoanAmountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	appliedLoanAmountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryOrderDateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryOrderDateMin?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryOrderDocUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryOrderDocUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryOrderValidityAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryOrderValidityMax?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryOrderValidityMin?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryOrderValiditySum?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldInspectionConfirmedDateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldInspectionConfirmedDateMin?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldInspectionDateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldInspectionDateMin?: FieldPolicy<any> | FieldReadFunction<any>,
	loginApplicationFormUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	loginApplicationFormUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	loginDateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	loginDateMin?: FieldPolicy<any> | FieldReadFunction<any>,
	sanctionedLoanAmountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	sanctionedLoanAmountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	sanctionedLoanAmountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	sanctionedLoanAmountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAtMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LogTrackingKeySpecifier = ('actionType' | 'createdAt' | 'id' | 'module' | 'previousValue' | 'source' | 'sourceUpdated' | 'status' | 'taskPerformedBy' | 'updatedValue' | LogTrackingKeySpecifier)[];
export type LogTrackingFieldPolicy = {
	actionType?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	module?: FieldPolicy<any> | FieldReadFunction<any>,
	previousValue?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceUpdated?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	taskPerformedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedValue?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LogTrackingAggregateResultKeySpecifier = ('count' | 'createdAtMax' | 'createdAtMin' | 'previousValueMax' | 'previousValueMin' | 'sourceUpdatedMax' | 'sourceUpdatedMin' | 'updatedValueMax' | 'updatedValueMin' | LogTrackingAggregateResultKeySpecifier)[];
export type LogTrackingAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	previousValueMax?: FieldPolicy<any> | FieldReadFunction<any>,
	previousValueMin?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceUpdatedMax?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceUpdatedMin?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedValueMax?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedValueMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MarkSoldResponseKeySpecifier = ('message' | 'status' | MarkSoldResponseKeySpecifier)[];
export type MarkSoldResponseFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MarkSoldResponseAggregateResultKeySpecifier = ('count' | 'messageMax' | 'messageMin' | MarkSoldResponseAggregateResultKeySpecifier)[];
export type MarkSoldResponseAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	messageMax?: FieldPolicy<any> | FieldReadFunction<any>,
	messageMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MessageKeySpecifier = ('createdAt' | 'id' | 'readBy' | 'readByAggregate' | 'sentBy' | 'text' | MessageKeySpecifier)[];
export type MessageFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	readBy?: FieldPolicy<any> | FieldReadFunction<any>,
	readByAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	sentBy?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MessageAggregateResultKeySpecifier = ('count' | 'createdAtMax' | 'createdAtMin' | 'textMax' | 'textMin' | MessageAggregateResultKeySpecifier)[];
export type MessageAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	textMax?: FieldPolicy<any> | FieldReadFunction<any>,
	textMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ModelKeySpecifier = ('brand' | 'id' | 'model_id' | 'name' | ModelKeySpecifier)[];
export type ModelFieldPolicy = {
	brand?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	model_id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ModelAggregateResultKeySpecifier = ('count' | 'model_idAvg' | 'model_idMax' | 'model_idMin' | 'model_idSum' | 'nameMax' | 'nameMin' | ModelAggregateResultKeySpecifier)[];
export type ModelAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	model_idAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	model_idMax?: FieldPolicy<any> | FieldReadFunction<any>,
	model_idMin?: FieldPolicy<any> | FieldReadFunction<any>,
	model_idSum?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ModelByMakeKeySpecifier = ('id' | 'make' | 'model' | ModelByMakeKeySpecifier)[];
export type ModelByMakeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	make?: FieldPolicy<any> | FieldReadFunction<any>,
	model?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ModelByMakeAggregateResultKeySpecifier = ('count' | 'idMax' | 'idMin' | 'makeMax' | 'makeMin' | 'modelMax' | 'modelMin' | ModelByMakeAggregateResultKeySpecifier)[];
export type ModelByMakeAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	idMax?: FieldPolicy<any> | FieldReadFunction<any>,
	idMin?: FieldPolicy<any> | FieldReadFunction<any>,
	makeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	makeMin?: FieldPolicy<any> | FieldReadFunction<any>,
	modelMax?: FieldPolicy<any> | FieldReadFunction<any>,
	modelMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MultiPolygonKeySpecifier = ('polygons' | MultiPolygonKeySpecifier)[];
export type MultiPolygonFieldPolicy = {
	polygons?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationKeySpecifier = ('addAccessoriesCheck' | 'addAccessoriesCheckListWithStage' | 'addAccessoriesChecklist' | 'addActiveStateWithGSTN' | 'addAdminLeadStatusEvent' | 'addAgency' | 'addAuctionHistory' | 'addBank' | 'addBankAuctionLeadCountByName' | 'addBooking' | 'addBookingPayment' | 'addBrand' | 'addBulkApprovalResponse' | 'addCenterlizeLocationDistrcitsResponse' | 'addCenterlizeLocationDistrict' | 'addCenterlizeLocationStates' | 'addCenterlizeLocationStatesResponse' | 'addCenterlizeLocationTehsil' | 'addCenterlizeLocationTehsilResponse' | 'addCentre' | 'addCentreAggregates' | 'addCity' | 'addCreateBulkLeadResponse' | 'addCustomer' | 'addDealer' | 'addDealerStance' | 'addDealershipDocument' | 'addDealershipLeadCountByPEName' | 'addDistrict' | 'addDocument' | 'addDocumentChecklist' | 'addDocumentsCount' | 'addDocumentsFollowups' | 'addDriverAggregates' | 'addEnquiry' | 'addEnquiryAdherence' | 'addEnquiryAggByCentre' | 'addEnquiryCloserAgg' | 'addEnquiryClosure' | 'addFollowup' | 'addIdByName' | 'addIdentificationDocument' | 'addIdsByNameForListingReponse' | 'addInventoryDetails' | 'addIssue' | 'addIssueItem' | 'addItemInventoryDetails' | 'addLead' | 'addLeadCountByStatus' | 'addLeadDocuments' | 'addLeadExpense' | 'addLeadStatusEvent' | 'addLeadStatusFlow' | 'addLeadTimelineAction' | 'addLoan' | 'addLogTracking' | 'addMarkSoldResponse' | 'addMessage' | 'addModel' | 'addModelByMake' | 'addNotification' | 'addNumberOfPendingTasks' | 'addParkingBeneficiary' | 'addPayment' | 'addPaymentInvoices' | 'addPickup' | 'addProduct' | 'addPurchase' | 'addPurchaseItem' | 'addRefurbishmentBeneficiary' | 'addRefurbishmentDetails' | 'addRefurbishmentItem' | 'addRefurbishmentRequest' | 'addSMSLogs' | 'addSendSmsToCustomerResponse' | 'addStateCodeWithRegNumber' | 'addStatusAggregate' | 'addTJCentre' | 'addTask' | 'addTehsil' | 'addTripExpense' | 'addUser' | 'addVehicle' | 'addVehicleDocuments' | 'addVehicleFinancing' | 'addVehicleImages' | 'addVehicleInsurance' | 'addVehicleOwner' | 'addVehicleTransferLog' | 'addYard' | 'adddocumentsAggregatesResult' | 'deleteAccessoriesCheck' | 'deleteAccessoriesCheckListWithStage' | 'deleteAccessoriesChecklist' | 'deleteActiveStateWithGSTN' | 'deleteAdminLeadStatusEvent' | 'deleteAgency' | 'deleteAuctionHistory' | 'deleteBank' | 'deleteBankAuctionLeadCountByName' | 'deleteBooking' | 'deleteBookingPayment' | 'deleteBrand' | 'deleteBulkApprovalResponse' | 'deleteCenterlizeLocationDistrcitsResponse' | 'deleteCenterlizeLocationDistrict' | 'deleteCenterlizeLocationStates' | 'deleteCenterlizeLocationStatesResponse' | 'deleteCenterlizeLocationTehsil' | 'deleteCenterlizeLocationTehsilResponse' | 'deleteCentre' | 'deleteCentreAggregates' | 'deleteCity' | 'deleteCreateBulkLeadResponse' | 'deleteCustomer' | 'deleteDealer' | 'deleteDealerStance' | 'deleteDealershipDocument' | 'deleteDealershipLeadCountByPEName' | 'deleteDistrict' | 'deleteDocument' | 'deleteDocumentChecklist' | 'deleteDocumentsCount' | 'deleteDocumentsFollowups' | 'deleteDriverAggregates' | 'deleteEnquiry' | 'deleteEnquiryAdherence' | 'deleteEnquiryAggByCentre' | 'deleteEnquiryCloserAgg' | 'deleteEnquiryClosure' | 'deleteFollowup' | 'deleteIdByName' | 'deleteIdentificationDocument' | 'deleteIdsByNameForListingReponse' | 'deleteInventoryDetails' | 'deleteIssue' | 'deleteIssueItem' | 'deleteItemInventoryDetails' | 'deleteLead' | 'deleteLeadCountByStatus' | 'deleteLeadDocuments' | 'deleteLeadExpense' | 'deleteLeadStatusEvent' | 'deleteLeadStatusFlow' | 'deleteLeadTimelineAction' | 'deleteLeadTimelineStatus' | 'deleteLoan' | 'deleteLogTracking' | 'deleteMarkSoldResponse' | 'deleteMessage' | 'deleteModel' | 'deleteModelByMake' | 'deleteNotification' | 'deleteNumberOfPendingTasks' | 'deleteParkingBeneficiary' | 'deletePayment' | 'deletePaymentInvoices' | 'deletePickup' | 'deleteProduct' | 'deletePurchase' | 'deletePurchaseItem' | 'deleteRefurbishmentBeneficiary' | 'deleteRefurbishmentDetails' | 'deleteRefurbishmentItem' | 'deleteRefurbishmentRequest' | 'deleteSMSLogs' | 'deleteSendSmsToCustomerResponse' | 'deleteStateCodeWithRegNumber' | 'deleteStatusAggregate' | 'deleteTJCentre' | 'deleteTask' | 'deleteTehsil' | 'deleteTripExpense' | 'deleteUser' | 'deleteVehicle' | 'deleteVehicleDocuments' | 'deleteVehicleFinancing' | 'deleteVehicleImages' | 'deleteVehicleInsurance' | 'deleteVehicleOwner' | 'deleteVehicleTransferLog' | 'deleteYard' | 'deletedocumentsAggregatesResult' | 'updateAccessoriesCheck' | 'updateAccessoriesCheckListWithStage' | 'updateAccessoriesChecklist' | 'updateActiveStateWithGSTN' | 'updateAdminLeadStatusEvent' | 'updateAgency' | 'updateAuctionHistory' | 'updateBank' | 'updateBankAuctionLeadCountByName' | 'updateBooking' | 'updateBookingPayment' | 'updateBrand' | 'updateBulkApprovalResponse' | 'updateCenterlizeLocationDistrcitsResponse' | 'updateCenterlizeLocationDistrict' | 'updateCenterlizeLocationStates' | 'updateCenterlizeLocationStatesResponse' | 'updateCenterlizeLocationTehsil' | 'updateCenterlizeLocationTehsilResponse' | 'updateCentre' | 'updateCentreAggregates' | 'updateCreateBulkLeadResponse' | 'updateCustomer' | 'updateDealer' | 'updateDealerStance' | 'updateDealershipDocument' | 'updateDealershipLeadCountByPEName' | 'updateDistrict' | 'updateDocument' | 'updateDocumentChecklist' | 'updateDocumentsCount' | 'updateDocumentsFollowups' | 'updateDriverAggregates' | 'updateEnquiry' | 'updateEnquiryAdherence' | 'updateEnquiryAggByCentre' | 'updateEnquiryCloserAgg' | 'updateEnquiryClosure' | 'updateFollowup' | 'updateIdByName' | 'updateIdentificationDocument' | 'updateIdsByNameForListingReponse' | 'updateInventoryDetails' | 'updateIssue' | 'updateIssueItem' | 'updateItemInventoryDetails' | 'updateLead' | 'updateLeadCountByStatus' | 'updateLeadDocuments' | 'updateLeadExpense' | 'updateLeadStatusEvent' | 'updateLeadStatusFlow' | 'updateLeadTimelineAction' | 'updateLeadTimelineStatus' | 'updateLoan' | 'updateLogTracking' | 'updateMarkSoldResponse' | 'updateMessage' | 'updateModel' | 'updateModelByMake' | 'updateNotification' | 'updateNumberOfPendingTasks' | 'updateParkingBeneficiary' | 'updatePayment' | 'updatePaymentInvoices' | 'updatePickup' | 'updateProduct' | 'updatePurchase' | 'updatePurchaseItem' | 'updateRefurbishmentBeneficiary' | 'updateRefurbishmentDetails' | 'updateRefurbishmentItem' | 'updateRefurbishmentRequest' | 'updateSMSLogs' | 'updateSendSmsToCustomerResponse' | 'updateStateCodeWithRegNumber' | 'updateStatusAggregate' | 'updateTJCentre' | 'updateTask' | 'updateTehsil' | 'updateTripExpense' | 'updateUser' | 'updateVehicle' | 'updateVehicleDocuments' | 'updateVehicleFinancing' | 'updateVehicleImages' | 'updateVehicleInsurance' | 'updateVehicleOwner' | 'updateVehicleTransferLog' | 'updateYard' | 'updatedocumentsAggregatesResult' | MutationKeySpecifier)[];
export type MutationFieldPolicy = {
	addAccessoriesCheck?: FieldPolicy<any> | FieldReadFunction<any>,
	addAccessoriesCheckListWithStage?: FieldPolicy<any> | FieldReadFunction<any>,
	addAccessoriesChecklist?: FieldPolicy<any> | FieldReadFunction<any>,
	addActiveStateWithGSTN?: FieldPolicy<any> | FieldReadFunction<any>,
	addAdminLeadStatusEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	addAgency?: FieldPolicy<any> | FieldReadFunction<any>,
	addAuctionHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	addBank?: FieldPolicy<any> | FieldReadFunction<any>,
	addBankAuctionLeadCountByName?: FieldPolicy<any> | FieldReadFunction<any>,
	addBooking?: FieldPolicy<any> | FieldReadFunction<any>,
	addBookingPayment?: FieldPolicy<any> | FieldReadFunction<any>,
	addBrand?: FieldPolicy<any> | FieldReadFunction<any>,
	addBulkApprovalResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	addCenterlizeLocationDistrcitsResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	addCenterlizeLocationDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	addCenterlizeLocationStates?: FieldPolicy<any> | FieldReadFunction<any>,
	addCenterlizeLocationStatesResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	addCenterlizeLocationTehsil?: FieldPolicy<any> | FieldReadFunction<any>,
	addCenterlizeLocationTehsilResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	addCentre?: FieldPolicy<any> | FieldReadFunction<any>,
	addCentreAggregates?: FieldPolicy<any> | FieldReadFunction<any>,
	addCity?: FieldPolicy<any> | FieldReadFunction<any>,
	addCreateBulkLeadResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	addCustomer?: FieldPolicy<any> | FieldReadFunction<any>,
	addDealer?: FieldPolicy<any> | FieldReadFunction<any>,
	addDealerStance?: FieldPolicy<any> | FieldReadFunction<any>,
	addDealershipDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	addDealershipLeadCountByPEName?: FieldPolicy<any> | FieldReadFunction<any>,
	addDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	addDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	addDocumentChecklist?: FieldPolicy<any> | FieldReadFunction<any>,
	addDocumentsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	addDocumentsFollowups?: FieldPolicy<any> | FieldReadFunction<any>,
	addDriverAggregates?: FieldPolicy<any> | FieldReadFunction<any>,
	addEnquiry?: FieldPolicy<any> | FieldReadFunction<any>,
	addEnquiryAdherence?: FieldPolicy<any> | FieldReadFunction<any>,
	addEnquiryAggByCentre?: FieldPolicy<any> | FieldReadFunction<any>,
	addEnquiryCloserAgg?: FieldPolicy<any> | FieldReadFunction<any>,
	addEnquiryClosure?: FieldPolicy<any> | FieldReadFunction<any>,
	addFollowup?: FieldPolicy<any> | FieldReadFunction<any>,
	addIdByName?: FieldPolicy<any> | FieldReadFunction<any>,
	addIdentificationDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	addIdsByNameForListingReponse?: FieldPolicy<any> | FieldReadFunction<any>,
	addInventoryDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	addIssue?: FieldPolicy<any> | FieldReadFunction<any>,
	addIssueItem?: FieldPolicy<any> | FieldReadFunction<any>,
	addItemInventoryDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	addLead?: FieldPolicy<any> | FieldReadFunction<any>,
	addLeadCountByStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	addLeadDocuments?: FieldPolicy<any> | FieldReadFunction<any>,
	addLeadExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	addLeadStatusEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	addLeadStatusFlow?: FieldPolicy<any> | FieldReadFunction<any>,
	addLeadTimelineAction?: FieldPolicy<any> | FieldReadFunction<any>,
	addLoan?: FieldPolicy<any> | FieldReadFunction<any>,
	addLogTracking?: FieldPolicy<any> | FieldReadFunction<any>,
	addMarkSoldResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	addMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	addModel?: FieldPolicy<any> | FieldReadFunction<any>,
	addModelByMake?: FieldPolicy<any> | FieldReadFunction<any>,
	addNotification?: FieldPolicy<any> | FieldReadFunction<any>,
	addNumberOfPendingTasks?: FieldPolicy<any> | FieldReadFunction<any>,
	addParkingBeneficiary?: FieldPolicy<any> | FieldReadFunction<any>,
	addPayment?: FieldPolicy<any> | FieldReadFunction<any>,
	addPaymentInvoices?: FieldPolicy<any> | FieldReadFunction<any>,
	addPickup?: FieldPolicy<any> | FieldReadFunction<any>,
	addProduct?: FieldPolicy<any> | FieldReadFunction<any>,
	addPurchase?: FieldPolicy<any> | FieldReadFunction<any>,
	addPurchaseItem?: FieldPolicy<any> | FieldReadFunction<any>,
	addRefurbishmentBeneficiary?: FieldPolicy<any> | FieldReadFunction<any>,
	addRefurbishmentDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	addRefurbishmentItem?: FieldPolicy<any> | FieldReadFunction<any>,
	addRefurbishmentRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	addSMSLogs?: FieldPolicy<any> | FieldReadFunction<any>,
	addSendSmsToCustomerResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	addStateCodeWithRegNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	addStatusAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	addTJCentre?: FieldPolicy<any> | FieldReadFunction<any>,
	addTask?: FieldPolicy<any> | FieldReadFunction<any>,
	addTehsil?: FieldPolicy<any> | FieldReadFunction<any>,
	addTripExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	addUser?: FieldPolicy<any> | FieldReadFunction<any>,
	addVehicle?: FieldPolicy<any> | FieldReadFunction<any>,
	addVehicleDocuments?: FieldPolicy<any> | FieldReadFunction<any>,
	addVehicleFinancing?: FieldPolicy<any> | FieldReadFunction<any>,
	addVehicleImages?: FieldPolicy<any> | FieldReadFunction<any>,
	addVehicleInsurance?: FieldPolicy<any> | FieldReadFunction<any>,
	addVehicleOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	addVehicleTransferLog?: FieldPolicy<any> | FieldReadFunction<any>,
	addYard?: FieldPolicy<any> | FieldReadFunction<any>,
	adddocumentsAggregatesResult?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAccessoriesCheck?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAccessoriesCheckListWithStage?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAccessoriesChecklist?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteActiveStateWithGSTN?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAdminLeadStatusEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAgency?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAuctionHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteBank?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteBankAuctionLeadCountByName?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteBooking?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteBookingPayment?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteBrand?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteBulkApprovalResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCenterlizeLocationDistrcitsResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCenterlizeLocationDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCenterlizeLocationStates?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCenterlizeLocationStatesResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCenterlizeLocationTehsil?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCenterlizeLocationTehsilResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCentre?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCentreAggregates?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCity?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCreateBulkLeadResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCustomer?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDealer?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDealerStance?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDealershipDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDealershipLeadCountByPEName?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDocumentChecklist?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDocumentsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDocumentsFollowups?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDriverAggregates?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEnquiry?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEnquiryAdherence?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEnquiryAggByCentre?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEnquiryCloserAgg?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEnquiryClosure?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteFollowup?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteIdByName?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteIdentificationDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteIdsByNameForListingReponse?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteInventoryDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteIssue?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteIssueItem?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteItemInventoryDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteLead?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteLeadCountByStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteLeadDocuments?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteLeadExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteLeadStatusEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteLeadStatusFlow?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteLeadTimelineAction?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteLeadTimelineStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteLoan?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteLogTracking?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteMarkSoldResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteModel?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteModelByMake?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteNotification?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteNumberOfPendingTasks?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteParkingBeneficiary?: FieldPolicy<any> | FieldReadFunction<any>,
	deletePayment?: FieldPolicy<any> | FieldReadFunction<any>,
	deletePaymentInvoices?: FieldPolicy<any> | FieldReadFunction<any>,
	deletePickup?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteProduct?: FieldPolicy<any> | FieldReadFunction<any>,
	deletePurchase?: FieldPolicy<any> | FieldReadFunction<any>,
	deletePurchaseItem?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteRefurbishmentBeneficiary?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteRefurbishmentDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteRefurbishmentItem?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteRefurbishmentRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteSMSLogs?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteSendSmsToCustomerResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteStateCodeWithRegNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteStatusAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteTJCentre?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteTask?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteTehsil?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteTripExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteUser?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteVehicle?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteVehicleDocuments?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteVehicleFinancing?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteVehicleImages?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteVehicleInsurance?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteVehicleOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteVehicleTransferLog?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteYard?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedocumentsAggregatesResult?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAccessoriesCheck?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAccessoriesCheckListWithStage?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAccessoriesChecklist?: FieldPolicy<any> | FieldReadFunction<any>,
	updateActiveStateWithGSTN?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAdminLeadStatusEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAgency?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAuctionHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	updateBank?: FieldPolicy<any> | FieldReadFunction<any>,
	updateBankAuctionLeadCountByName?: FieldPolicy<any> | FieldReadFunction<any>,
	updateBooking?: FieldPolicy<any> | FieldReadFunction<any>,
	updateBookingPayment?: FieldPolicy<any> | FieldReadFunction<any>,
	updateBrand?: FieldPolicy<any> | FieldReadFunction<any>,
	updateBulkApprovalResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCenterlizeLocationDistrcitsResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCenterlizeLocationDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCenterlizeLocationStates?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCenterlizeLocationStatesResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCenterlizeLocationTehsil?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCenterlizeLocationTehsilResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCentre?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCentreAggregates?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCreateBulkLeadResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCustomer?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDealer?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDealerStance?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDealershipDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDealershipLeadCountByPEName?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDocumentChecklist?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDocumentsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDocumentsFollowups?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDriverAggregates?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEnquiry?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEnquiryAdherence?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEnquiryAggByCentre?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEnquiryCloserAgg?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEnquiryClosure?: FieldPolicy<any> | FieldReadFunction<any>,
	updateFollowup?: FieldPolicy<any> | FieldReadFunction<any>,
	updateIdByName?: FieldPolicy<any> | FieldReadFunction<any>,
	updateIdentificationDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	updateIdsByNameForListingReponse?: FieldPolicy<any> | FieldReadFunction<any>,
	updateInventoryDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	updateIssue?: FieldPolicy<any> | FieldReadFunction<any>,
	updateIssueItem?: FieldPolicy<any> | FieldReadFunction<any>,
	updateItemInventoryDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	updateLead?: FieldPolicy<any> | FieldReadFunction<any>,
	updateLeadCountByStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	updateLeadDocuments?: FieldPolicy<any> | FieldReadFunction<any>,
	updateLeadExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	updateLeadStatusEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	updateLeadStatusFlow?: FieldPolicy<any> | FieldReadFunction<any>,
	updateLeadTimelineAction?: FieldPolicy<any> | FieldReadFunction<any>,
	updateLeadTimelineStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	updateLoan?: FieldPolicy<any> | FieldReadFunction<any>,
	updateLogTracking?: FieldPolicy<any> | FieldReadFunction<any>,
	updateMarkSoldResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	updateMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	updateModel?: FieldPolicy<any> | FieldReadFunction<any>,
	updateModelByMake?: FieldPolicy<any> | FieldReadFunction<any>,
	updateNotification?: FieldPolicy<any> | FieldReadFunction<any>,
	updateNumberOfPendingTasks?: FieldPolicy<any> | FieldReadFunction<any>,
	updateParkingBeneficiary?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePayment?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePaymentInvoices?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePickup?: FieldPolicy<any> | FieldReadFunction<any>,
	updateProduct?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePurchase?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePurchaseItem?: FieldPolicy<any> | FieldReadFunction<any>,
	updateRefurbishmentBeneficiary?: FieldPolicy<any> | FieldReadFunction<any>,
	updateRefurbishmentDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	updateRefurbishmentItem?: FieldPolicy<any> | FieldReadFunction<any>,
	updateRefurbishmentRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSMSLogs?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSendSmsToCustomerResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	updateStateCodeWithRegNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	updateStatusAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTJCentre?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTask?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTehsil?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTripExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUser?: FieldPolicy<any> | FieldReadFunction<any>,
	updateVehicle?: FieldPolicy<any> | FieldReadFunction<any>,
	updateVehicleDocuments?: FieldPolicy<any> | FieldReadFunction<any>,
	updateVehicleFinancing?: FieldPolicy<any> | FieldReadFunction<any>,
	updateVehicleImages?: FieldPolicy<any> | FieldReadFunction<any>,
	updateVehicleInsurance?: FieldPolicy<any> | FieldReadFunction<any>,
	updateVehicleOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	updateVehicleTransferLog?: FieldPolicy<any> | FieldReadFunction<any>,
	updateYard?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedocumentsAggregatesResult?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationKeySpecifier = ('createdAt' | 'forUsers' | 'forUsersAggregate' | 'id' | 'leadStatusEvent' | 'remarks' | 'subtitle' | 'title' | NotificationKeySpecifier)[];
export type NotificationFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	forUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	forUsersAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	leadStatusEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	remarks?: FieldPolicy<any> | FieldReadFunction<any>,
	subtitle?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationAggregateResultKeySpecifier = ('count' | 'createdAtMax' | 'createdAtMin' | 'remarksMax' | 'remarksMin' | 'subtitleMax' | 'subtitleMin' | 'titleMax' | 'titleMin' | NotificationAggregateResultKeySpecifier)[];
export type NotificationAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	remarksMax?: FieldPolicy<any> | FieldReadFunction<any>,
	remarksMin?: FieldPolicy<any> | FieldReadFunction<any>,
	subtitleMax?: FieldPolicy<any> | FieldReadFunction<any>,
	subtitleMin?: FieldPolicy<any> | FieldReadFunction<any>,
	titleMax?: FieldPolicy<any> | FieldReadFunction<any>,
	titleMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NumberOfPendingTasksKeySpecifier = ('count' | NumberOfPendingTasksKeySpecifier)[];
export type NumberOfPendingTasksFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NumberOfPendingTasksAggregateResultKeySpecifier = ('count' | 'countAvg' | 'countMax' | 'countMin' | 'countSum' | NumberOfPendingTasksAggregateResultKeySpecifier)[];
export type NumberOfPendingTasksAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	countAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	countMax?: FieldPolicy<any> | FieldReadFunction<any>,
	countMin?: FieldPolicy<any> | FieldReadFunction<any>,
	countSum?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ParkingBeneficiaryKeySpecifier = ('accountHolderName' | 'accountNumber' | 'bankName' | 'id' | 'ifscCode' | 'leads' | 'leadsAggregate' | 'proofUrl' | 'upiId' | ParkingBeneficiaryKeySpecifier)[];
export type ParkingBeneficiaryFieldPolicy = {
	accountHolderName?: FieldPolicy<any> | FieldReadFunction<any>,
	accountNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	bankName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	ifscCode?: FieldPolicy<any> | FieldReadFunction<any>,
	leads?: FieldPolicy<any> | FieldReadFunction<any>,
	leadsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	proofUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	upiId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ParkingBeneficiaryAggregateResultKeySpecifier = ('accountHolderNameMax' | 'accountHolderNameMin' | 'accountNumberMax' | 'accountNumberMin' | 'count' | 'ifscCodeMax' | 'ifscCodeMin' | 'proofUrlMax' | 'proofUrlMin' | 'upiIdMax' | 'upiIdMin' | ParkingBeneficiaryAggregateResultKeySpecifier)[];
export type ParkingBeneficiaryAggregateResultFieldPolicy = {
	accountHolderNameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	accountHolderNameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	accountNumberMax?: FieldPolicy<any> | FieldReadFunction<any>,
	accountNumberMin?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	ifscCodeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	ifscCodeMin?: FieldPolicy<any> | FieldReadFunction<any>,
	proofUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	proofUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	upiIdMax?: FieldPolicy<any> | FieldReadFunction<any>,
	upiIdMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentKeySpecifier = ('accountHolderName' | 'accountNo' | 'amount' | 'bankName' | 'booking' | 'by' | 'confirmedBy' | 'createdAt' | 'dealerStance' | 'for' | 'id' | 'ifsc' | 'invoice' | 'lead' | 'loanClosedBy' | 'mode' | 'modeFM' | 'parkingBeneficiary' | 'paymentProcessedAt' | 'paymentTo' | 'proofUrl' | 'purchase' | 'receiptUrl' | 'reconciliationStatus' | 'refurbishmentBeneficiary' | 'source' | 'status' | 'tripExpense' | 'type' | 'upiId' | PaymentKeySpecifier)[];
export type PaymentFieldPolicy = {
	accountHolderName?: FieldPolicy<any> | FieldReadFunction<any>,
	accountNo?: FieldPolicy<any> | FieldReadFunction<any>,
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	bankName?: FieldPolicy<any> | FieldReadFunction<any>,
	booking?: FieldPolicy<any> | FieldReadFunction<any>,
	by?: FieldPolicy<any> | FieldReadFunction<any>,
	confirmedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	dealerStance?: FieldPolicy<any> | FieldReadFunction<any>,
	for?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	ifsc?: FieldPolicy<any> | FieldReadFunction<any>,
	invoice?: FieldPolicy<any> | FieldReadFunction<any>,
	lead?: FieldPolicy<any> | FieldReadFunction<any>,
	loanClosedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	mode?: FieldPolicy<any> | FieldReadFunction<any>,
	modeFM?: FieldPolicy<any> | FieldReadFunction<any>,
	parkingBeneficiary?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentProcessedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentTo?: FieldPolicy<any> | FieldReadFunction<any>,
	proofUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	purchase?: FieldPolicy<any> | FieldReadFunction<any>,
	receiptUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	reconciliationStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	refurbishmentBeneficiary?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	tripExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	upiId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentAggregateResultKeySpecifier = ('accountHolderNameMax' | 'accountHolderNameMin' | 'accountNoMax' | 'accountNoMin' | 'amountAvg' | 'amountMax' | 'amountMin' | 'amountSum' | 'count' | 'createdAtMax' | 'createdAtMin' | 'ifscMax' | 'ifscMin' | 'paymentProcessedAtMax' | 'paymentProcessedAtMin' | 'proofUrlMax' | 'proofUrlMin' | 'receiptUrlMax' | 'receiptUrlMin' | 'upiIdMax' | 'upiIdMin' | PaymentAggregateResultKeySpecifier)[];
export type PaymentAggregateResultFieldPolicy = {
	accountHolderNameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	accountHolderNameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	accountNoMax?: FieldPolicy<any> | FieldReadFunction<any>,
	accountNoMin?: FieldPolicy<any> | FieldReadFunction<any>,
	amountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	amountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	amountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	amountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	ifscMax?: FieldPolicy<any> | FieldReadFunction<any>,
	ifscMin?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentProcessedAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentProcessedAtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	proofUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	proofUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	receiptUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	receiptUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	upiIdMax?: FieldPolicy<any> | FieldReadFunction<any>,
	upiIdMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentInvoicesKeySpecifier = ('GSTNumber' | 'createdBy' | 'customerName' | 'customerNumber' | 'id' | 'invoiceDate' | 'invoiceId' | 'lead' | 'payment' | 'serialNo' | 'smsLogs' | 'smsLogsAggregate' | PaymentInvoicesKeySpecifier)[];
export type PaymentInvoicesFieldPolicy = {
	GSTNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	customerName?: FieldPolicy<any> | FieldReadFunction<any>,
	customerNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceDate?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceId?: FieldPolicy<any> | FieldReadFunction<any>,
	lead?: FieldPolicy<any> | FieldReadFunction<any>,
	payment?: FieldPolicy<any> | FieldReadFunction<any>,
	serialNo?: FieldPolicy<any> | FieldReadFunction<any>,
	smsLogs?: FieldPolicy<any> | FieldReadFunction<any>,
	smsLogsAggregate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentInvoicesAggregateResultKeySpecifier = ('GSTNumberMax' | 'GSTNumberMin' | 'count' | 'customerNameMax' | 'customerNameMin' | 'customerNumberMax' | 'customerNumberMin' | 'invoiceDateMax' | 'invoiceDateMin' | 'invoiceIdMax' | 'invoiceIdMin' | 'serialNoMax' | 'serialNoMin' | PaymentInvoicesAggregateResultKeySpecifier)[];
export type PaymentInvoicesAggregateResultFieldPolicy = {
	GSTNumberMax?: FieldPolicy<any> | FieldReadFunction<any>,
	GSTNumberMin?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	customerNameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	customerNameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	customerNumberMax?: FieldPolicy<any> | FieldReadFunction<any>,
	customerNumberMin?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceDateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceDateMin?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceIdMax?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceIdMin?: FieldPolicy<any> | FieldReadFunction<any>,
	serialNoMax?: FieldPolicy<any> | FieldReadFunction<any>,
	serialNoMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PickupKeySpecifier = ('by' | 'from' | 'id' | 'lead' | 'pickEndTime' | 'pickupStartTime' | 'regNo' | 'to' | PickupKeySpecifier)[];
export type PickupFieldPolicy = {
	by?: FieldPolicy<any> | FieldReadFunction<any>,
	from?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lead?: FieldPolicy<any> | FieldReadFunction<any>,
	pickEndTime?: FieldPolicy<any> | FieldReadFunction<any>,
	pickupStartTime?: FieldPolicy<any> | FieldReadFunction<any>,
	regNo?: FieldPolicy<any> | FieldReadFunction<any>,
	to?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PickupAggregateResultKeySpecifier = ('count' | 'pickEndTimeMax' | 'pickEndTimeMin' | 'pickupStartTimeMax' | 'pickupStartTimeMin' | 'regNoMax' | 'regNoMin' | PickupAggregateResultKeySpecifier)[];
export type PickupAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	pickEndTimeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	pickEndTimeMin?: FieldPolicy<any> | FieldReadFunction<any>,
	pickupStartTimeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	pickupStartTimeMin?: FieldPolicy<any> | FieldReadFunction<any>,
	regNoMax?: FieldPolicy<any> | FieldReadFunction<any>,
	regNoMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PointKeySpecifier = ('latitude' | 'longitude' | PointKeySpecifier)[];
export type PointFieldPolicy = {
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PointListKeySpecifier = ('points' | PointListKeySpecifier)[];
export type PointListFieldPolicy = {
	points?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PolygonKeySpecifier = ('coordinates' | PolygonKeySpecifier)[];
export type PolygonFieldPolicy = {
	coordinates?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductKeySpecifier = ('description' | 'id' | 'name' | 'variant' | ProductKeySpecifier)[];
export type ProductFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	variant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductAggregateResultKeySpecifier = ('count' | 'descriptionMax' | 'descriptionMin' | 'nameMax' | 'nameMin' | 'variantMax' | 'variantMin' | ProductAggregateResultKeySpecifier)[];
export type ProductAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptionMax?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptionMin?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	variantMax?: FieldPolicy<any> | FieldReadFunction<any>,
	variantMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PurchaseKeySpecifier = ('approvedBy' | 'centre' | 'createdAt' | 'id' | 'invoiceUrl' | 'items' | 'itemsAggregate' | 'madeBy' | 'payment' | 'refurbishment' | 'requestedItemId' | 'status' | 'totalPrice' | PurchaseKeySpecifier)[];
export type PurchaseFieldPolicy = {
	approvedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	centre?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	itemsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	madeBy?: FieldPolicy<any> | FieldReadFunction<any>,
	payment?: FieldPolicy<any> | FieldReadFunction<any>,
	refurbishment?: FieldPolicy<any> | FieldReadFunction<any>,
	requestedItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPrice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PurchaseAggregateResultKeySpecifier = ('count' | 'createdAtMax' | 'createdAtMin' | 'invoiceUrlMax' | 'invoiceUrlMin' | 'requestedItemIdMax' | 'requestedItemIdMin' | 'totalPriceAvg' | 'totalPriceMax' | 'totalPriceMin' | 'totalPriceSum' | PurchaseAggregateResultKeySpecifier)[];
export type PurchaseAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	requestedItemIdMax?: FieldPolicy<any> | FieldReadFunction<any>,
	requestedItemIdMin?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPriceAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPriceMax?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPriceMin?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPriceSum?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PurchaseItemKeySpecifier = ('approvedPriceLimit' | 'description' | 'id' | 'isApproved' | 'price' | 'product' | 'purchase' | 'purchaseProofUrl' | 'quantity' | 'requestedItemId' | 'type' | PurchaseItemKeySpecifier)[];
export type PurchaseItemFieldPolicy = {
	approvedPriceLimit?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isApproved?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	purchase?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseProofUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	requestedItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PurchaseItemAggregateResultKeySpecifier = ('approvedPriceLimitAvg' | 'approvedPriceLimitMax' | 'approvedPriceLimitMin' | 'approvedPriceLimitSum' | 'count' | 'descriptionMax' | 'descriptionMin' | 'priceAvg' | 'priceMax' | 'priceMin' | 'priceSum' | 'purchaseProofUrlMax' | 'purchaseProofUrlMin' | 'quantityAvg' | 'quantityMax' | 'quantityMin' | 'quantitySum' | 'requestedItemIdMax' | 'requestedItemIdMin' | 'typeMax' | 'typeMin' | PurchaseItemAggregateResultKeySpecifier)[];
export type PurchaseItemAggregateResultFieldPolicy = {
	approvedPriceLimitAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	approvedPriceLimitMax?: FieldPolicy<any> | FieldReadFunction<any>,
	approvedPriceLimitMin?: FieldPolicy<any> | FieldReadFunction<any>,
	approvedPriceLimitSum?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptionMax?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptionMin?: FieldPolicy<any> | FieldReadFunction<any>,
	priceAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	priceMax?: FieldPolicy<any> | FieldReadFunction<any>,
	priceMin?: FieldPolicy<any> | FieldReadFunction<any>,
	priceSum?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseProofUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseProofUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	quantityAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	quantityMax?: FieldPolicy<any> | FieldReadFunction<any>,
	quantityMin?: FieldPolicy<any> | FieldReadFunction<any>,
	quantitySum?: FieldPolicy<any> | FieldReadFunction<any>,
	requestedItemIdMax?: FieldPolicy<any> | FieldReadFunction<any>,
	requestedItemIdMin?: FieldPolicy<any> | FieldReadFunction<any>,
	typeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	typeMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueryKeySpecifier = ('aggregateAccessoriesCheck' | 'aggregateAccessoriesCheckListWithStage' | 'aggregateAccessoriesChecklist' | 'aggregateActiveStateWithGSTN' | 'aggregateAdminLeadStatusEvent' | 'aggregateAgency' | 'aggregateAuctionHistory' | 'aggregateBank' | 'aggregateBankAuctionLeadCountByName' | 'aggregateBooking' | 'aggregateBookingPayment' | 'aggregateBrand' | 'aggregateBulkApprovalResponse' | 'aggregateCenterlizeLocationDistrcitsResponse' | 'aggregateCenterlizeLocationDistrict' | 'aggregateCenterlizeLocationStates' | 'aggregateCenterlizeLocationStatesResponse' | 'aggregateCenterlizeLocationTehsil' | 'aggregateCenterlizeLocationTehsilResponse' | 'aggregateCentre' | 'aggregateCentreAggregates' | 'aggregateCity' | 'aggregateCreateBulkLeadResponse' | 'aggregateCustomer' | 'aggregateDealer' | 'aggregateDealerStance' | 'aggregateDealershipDocument' | 'aggregateDealershipLeadCountByPEName' | 'aggregateDistrict' | 'aggregateDocument' | 'aggregateDocumentChecklist' | 'aggregateDocumentsCount' | 'aggregateDocumentsFollowups' | 'aggregateDriverAggregates' | 'aggregateEnquiry' | 'aggregateEnquiryAdherence' | 'aggregateEnquiryAggByCentre' | 'aggregateEnquiryCloserAgg' | 'aggregateEnquiryClosure' | 'aggregateFollowup' | 'aggregateIdByName' | 'aggregateIdentificationDocument' | 'aggregateIdsByNameForListingReponse' | 'aggregateInventoryDetails' | 'aggregateIssue' | 'aggregateIssueItem' | 'aggregateItemInventoryDetails' | 'aggregateLead' | 'aggregateLeadCountByStatus' | 'aggregateLeadDocuments' | 'aggregateLeadExpense' | 'aggregateLeadStatusEvent' | 'aggregateLeadStatusFlow' | 'aggregateLeadTimelineAction' | 'aggregateLeadTimelineStatus' | 'aggregateLoan' | 'aggregateLogTracking' | 'aggregateMarkSoldResponse' | 'aggregateMessage' | 'aggregateModel' | 'aggregateModelByMake' | 'aggregateNotification' | 'aggregateNumberOfPendingTasks' | 'aggregateParkingBeneficiary' | 'aggregatePayment' | 'aggregatePaymentInvoices' | 'aggregatePickup' | 'aggregateProduct' | 'aggregatePurchase' | 'aggregatePurchaseItem' | 'aggregateRefurbishmentBeneficiary' | 'aggregateRefurbishmentDetails' | 'aggregateRefurbishmentItem' | 'aggregateRefurbishmentRequest' | 'aggregateSMSLogs' | 'aggregateSendSmsToCustomerResponse' | 'aggregateStateCodeWithRegNumber' | 'aggregateStatusAggregate' | 'aggregateTJCentre' | 'aggregateTask' | 'aggregateTehsil' | 'aggregateTripExpense' | 'aggregateUser' | 'aggregateVehicle' | 'aggregateVehicleDocuments' | 'aggregateVehicleFinancing' | 'aggregateVehicleImages' | 'aggregateVehicleInsurance' | 'aggregateVehicleOwner' | 'aggregateVehicleTransferLog' | 'aggregateYard' | 'aggregatedocumentsAggregatesResult' | 'bankAuctionLeadCountByName' | 'bulkApproval' | 'centreAggregatesData' | 'commonEnquiry' | 'createBulkLeads' | 'dealershipLeadCountByPEName' | 'documentsAggregatesData' | 'doneBySomeone' | 'driverData' | 'enquiryAggrigateByCentre' | 'enquiryFollowupAdderence' | 'filteredBookings' | 'filteredEnquiry' | 'filteredLeads' | 'getAccessoriesCheck' | 'getAccessoriesCheckListWithStage' | 'getAccessoriesChecklist' | 'getActiveStateWithGSTN' | 'getAdminLeadStatusEvent' | 'getAgency' | 'getAuctionHistory' | 'getBank' | 'getBooking' | 'getBookingPayment' | 'getBrand' | 'getCentre' | 'getCentreDataFromTJ' | 'getCity' | 'getCustomer' | 'getDealer' | 'getDealerStance' | 'getDealershipDocument' | 'getDistrict' | 'getDistrictByStateInfo' | 'getDocumentChecklist' | 'getDocumentsFollowups' | 'getEnquiry' | 'getFollowup' | 'getIdentificationDocument' | 'getIdsByNameForListing' | 'getInventoryDetails' | 'getIssue' | 'getIssueItem' | 'getItemInventoryDetails' | 'getLead' | 'getLeadDocuments' | 'getLeadExpense' | 'getLeadStatusEvent' | 'getLeadStatusFlow' | 'getLeadTimelineAction' | 'getLeadTimelineStatus' | 'getLoan' | 'getLogTracking' | 'getMessage' | 'getModel' | 'getNotification' | 'getParkingBeneficiary' | 'getPayment' | 'getPaymentInvoices' | 'getPickup' | 'getProduct' | 'getPurchase' | 'getPurchaseItem' | 'getRefurbishmentBeneficiary' | 'getRefurbishmentDetails' | 'getRefurbishmentItem' | 'getRefurbishmentRequest' | 'getStateCodeWithRegNumber' | 'getStateInfo' | 'getTask' | 'getTehsil' | 'getTehsilByDistricts' | 'getTripExpense' | 'getUser' | 'getVehicle' | 'getVehicleDocuments' | 'getVehicleFinancing' | 'getVehicleImages' | 'getVehicleInsurance' | 'getVehicleOwner' | 'getVehicleTransferLog' | 'getYard' | 'inventoryDetails' | 'leadCountsByStatus' | 'leadsForListing' | 'markTractorAsSoldWrapper' | 'myPendingTasks' | 'numberOfPendingTasks' | 'pendingTasks' | 'queryAccessoriesCheck' | 'queryAccessoriesCheckListWithStage' | 'queryAccessoriesChecklist' | 'queryActiveStateWithGSTN' | 'queryAdminLeadStatusEvent' | 'queryAgency' | 'queryAuctionHistory' | 'queryBank' | 'queryBankAuctionLeadCountByName' | 'queryBooking' | 'queryBookingPayment' | 'queryBrand' | 'queryBulkApprovalResponse' | 'queryCenterlizeLocationDistrcitsResponse' | 'queryCenterlizeLocationDistrict' | 'queryCenterlizeLocationStates' | 'queryCenterlizeLocationStatesResponse' | 'queryCenterlizeLocationTehsil' | 'queryCenterlizeLocationTehsilResponse' | 'queryCentre' | 'queryCentreAggregates' | 'queryCity' | 'queryCreateBulkLeadResponse' | 'queryCustomer' | 'queryDealer' | 'queryDealerStance' | 'queryDealershipDocument' | 'queryDealershipLeadCountByPEName' | 'queryDistrict' | 'queryDocument' | 'queryDocumentChecklist' | 'queryDocumentsCount' | 'queryDocumentsFollowups' | 'queryDriverAggregates' | 'queryEnquiry' | 'queryEnquiryAdherence' | 'queryEnquiryAggByCentre' | 'queryEnquiryCloserAgg' | 'queryEnquiryClosure' | 'queryFollowup' | 'queryIdByName' | 'queryIdentificationDocument' | 'queryIdsByNameForListingReponse' | 'queryInventoryDetails' | 'queryIssue' | 'queryIssueItem' | 'queryItemInventoryDetails' | 'queryLead' | 'queryLeadCountByStatus' | 'queryLeadDocuments' | 'queryLeadExpense' | 'queryLeadStatusEvent' | 'queryLeadStatusFlow' | 'queryLeadTimelineAction' | 'queryLeadTimelineStatus' | 'queryLoan' | 'queryLogTracking' | 'queryMarkSoldResponse' | 'queryMessage' | 'queryModel' | 'queryModelByMake' | 'queryNotification' | 'queryNumberOfPendingTasks' | 'queryParkingBeneficiary' | 'queryPayment' | 'queryPaymentInvoices' | 'queryPickup' | 'queryProduct' | 'queryPurchase' | 'queryPurchaseItem' | 'queryRefurbishmentBeneficiary' | 'queryRefurbishmentDetails' | 'queryRefurbishmentItem' | 'queryRefurbishmentRequest' | 'querySMSLogs' | 'querySendSmsToCustomerResponse' | 'queryStateCodeWithRegNumber' | 'queryStatusAggregate' | 'queryTJCentre' | 'queryTask' | 'queryTehsil' | 'queryTripExpense' | 'queryUser' | 'queryVehicle' | 'queryVehicleDocuments' | 'queryVehicleFinancing' | 'queryVehicleImages' | 'queryVehicleInsurance' | 'queryVehicleOwner' | 'queryVehicleTransferLog' | 'queryYard' | 'querydocumentsAggregatesResult' | 'sendSmsToCustomer' | 'statusAggregates' | QueryKeySpecifier)[];
export type QueryFieldPolicy = {
	aggregateAccessoriesCheck?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateAccessoriesCheckListWithStage?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateAccessoriesChecklist?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateActiveStateWithGSTN?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateAdminLeadStatusEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateAgency?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateAuctionHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateBank?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateBankAuctionLeadCountByName?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateBooking?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateBookingPayment?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateBrand?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateBulkApprovalResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateCenterlizeLocationDistrcitsResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateCenterlizeLocationDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateCenterlizeLocationStates?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateCenterlizeLocationStatesResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateCenterlizeLocationTehsil?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateCenterlizeLocationTehsilResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateCentre?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateCentreAggregates?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateCity?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateCreateBulkLeadResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateCustomer?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateDealer?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateDealerStance?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateDealershipDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateDealershipLeadCountByPEName?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateDocumentChecklist?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateDocumentsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateDocumentsFollowups?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateDriverAggregates?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateEnquiry?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateEnquiryAdherence?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateEnquiryAggByCentre?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateEnquiryCloserAgg?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateEnquiryClosure?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateFollowup?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateIdByName?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateIdentificationDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateIdsByNameForListingReponse?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateInventoryDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateIssue?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateIssueItem?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateItemInventoryDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateLead?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateLeadCountByStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateLeadDocuments?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateLeadExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateLeadStatusEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateLeadStatusFlow?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateLeadTimelineAction?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateLeadTimelineStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateLoan?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateLogTracking?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateMarkSoldResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateModel?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateModelByMake?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateNotification?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateNumberOfPendingTasks?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateParkingBeneficiary?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregatePayment?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregatePaymentInvoices?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregatePickup?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateProduct?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregatePurchase?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregatePurchaseItem?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateRefurbishmentBeneficiary?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateRefurbishmentDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateRefurbishmentItem?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateRefurbishmentRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateSMSLogs?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateSendSmsToCustomerResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateStateCodeWithRegNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateStatusAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateTJCentre?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateTask?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateTehsil?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateTripExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateUser?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateVehicle?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateVehicleDocuments?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateVehicleFinancing?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateVehicleImages?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateVehicleInsurance?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateVehicleOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateVehicleTransferLog?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateYard?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregatedocumentsAggregatesResult?: FieldPolicy<any> | FieldReadFunction<any>,
	bankAuctionLeadCountByName?: FieldPolicy<any> | FieldReadFunction<any>,
	bulkApproval?: FieldPolicy<any> | FieldReadFunction<any>,
	centreAggregatesData?: FieldPolicy<any> | FieldReadFunction<any>,
	commonEnquiry?: FieldPolicy<any> | FieldReadFunction<any>,
	createBulkLeads?: FieldPolicy<any> | FieldReadFunction<any>,
	dealershipLeadCountByPEName?: FieldPolicy<any> | FieldReadFunction<any>,
	documentsAggregatesData?: FieldPolicy<any> | FieldReadFunction<any>,
	doneBySomeone?: FieldPolicy<any> | FieldReadFunction<any>,
	driverData?: FieldPolicy<any> | FieldReadFunction<any>,
	enquiryAggrigateByCentre?: FieldPolicy<any> | FieldReadFunction<any>,
	enquiryFollowupAdderence?: FieldPolicy<any> | FieldReadFunction<any>,
	filteredBookings?: FieldPolicy<any> | FieldReadFunction<any>,
	filteredEnquiry?: FieldPolicy<any> | FieldReadFunction<any>,
	filteredLeads?: FieldPolicy<any> | FieldReadFunction<any>,
	getAccessoriesCheck?: FieldPolicy<any> | FieldReadFunction<any>,
	getAccessoriesCheckListWithStage?: FieldPolicy<any> | FieldReadFunction<any>,
	getAccessoriesChecklist?: FieldPolicy<any> | FieldReadFunction<any>,
	getActiveStateWithGSTN?: FieldPolicy<any> | FieldReadFunction<any>,
	getAdminLeadStatusEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	getAgency?: FieldPolicy<any> | FieldReadFunction<any>,
	getAuctionHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	getBank?: FieldPolicy<any> | FieldReadFunction<any>,
	getBooking?: FieldPolicy<any> | FieldReadFunction<any>,
	getBookingPayment?: FieldPolicy<any> | FieldReadFunction<any>,
	getBrand?: FieldPolicy<any> | FieldReadFunction<any>,
	getCentre?: FieldPolicy<any> | FieldReadFunction<any>,
	getCentreDataFromTJ?: FieldPolicy<any> | FieldReadFunction<any>,
	getCity?: FieldPolicy<any> | FieldReadFunction<any>,
	getCustomer?: FieldPolicy<any> | FieldReadFunction<any>,
	getDealer?: FieldPolicy<any> | FieldReadFunction<any>,
	getDealerStance?: FieldPolicy<any> | FieldReadFunction<any>,
	getDealershipDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	getDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	getDistrictByStateInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	getDocumentChecklist?: FieldPolicy<any> | FieldReadFunction<any>,
	getDocumentsFollowups?: FieldPolicy<any> | FieldReadFunction<any>,
	getEnquiry?: FieldPolicy<any> | FieldReadFunction<any>,
	getFollowup?: FieldPolicy<any> | FieldReadFunction<any>,
	getIdentificationDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	getIdsByNameForListing?: FieldPolicy<any> | FieldReadFunction<any>,
	getInventoryDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	getIssue?: FieldPolicy<any> | FieldReadFunction<any>,
	getIssueItem?: FieldPolicy<any> | FieldReadFunction<any>,
	getItemInventoryDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	getLead?: FieldPolicy<any> | FieldReadFunction<any>,
	getLeadDocuments?: FieldPolicy<any> | FieldReadFunction<any>,
	getLeadExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	getLeadStatusEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	getLeadStatusFlow?: FieldPolicy<any> | FieldReadFunction<any>,
	getLeadTimelineAction?: FieldPolicy<any> | FieldReadFunction<any>,
	getLeadTimelineStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	getLoan?: FieldPolicy<any> | FieldReadFunction<any>,
	getLogTracking?: FieldPolicy<any> | FieldReadFunction<any>,
	getMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	getModel?: FieldPolicy<any> | FieldReadFunction<any>,
	getNotification?: FieldPolicy<any> | FieldReadFunction<any>,
	getParkingBeneficiary?: FieldPolicy<any> | FieldReadFunction<any>,
	getPayment?: FieldPolicy<any> | FieldReadFunction<any>,
	getPaymentInvoices?: FieldPolicy<any> | FieldReadFunction<any>,
	getPickup?: FieldPolicy<any> | FieldReadFunction<any>,
	getProduct?: FieldPolicy<any> | FieldReadFunction<any>,
	getPurchase?: FieldPolicy<any> | FieldReadFunction<any>,
	getPurchaseItem?: FieldPolicy<any> | FieldReadFunction<any>,
	getRefurbishmentBeneficiary?: FieldPolicy<any> | FieldReadFunction<any>,
	getRefurbishmentDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	getRefurbishmentItem?: FieldPolicy<any> | FieldReadFunction<any>,
	getRefurbishmentRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	getStateCodeWithRegNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	getStateInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	getTask?: FieldPolicy<any> | FieldReadFunction<any>,
	getTehsil?: FieldPolicy<any> | FieldReadFunction<any>,
	getTehsilByDistricts?: FieldPolicy<any> | FieldReadFunction<any>,
	getTripExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	getUser?: FieldPolicy<any> | FieldReadFunction<any>,
	getVehicle?: FieldPolicy<any> | FieldReadFunction<any>,
	getVehicleDocuments?: FieldPolicy<any> | FieldReadFunction<any>,
	getVehicleFinancing?: FieldPolicy<any> | FieldReadFunction<any>,
	getVehicleImages?: FieldPolicy<any> | FieldReadFunction<any>,
	getVehicleInsurance?: FieldPolicy<any> | FieldReadFunction<any>,
	getVehicleOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	getVehicleTransferLog?: FieldPolicy<any> | FieldReadFunction<any>,
	getYard?: FieldPolicy<any> | FieldReadFunction<any>,
	inventoryDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	leadCountsByStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	leadsForListing?: FieldPolicy<any> | FieldReadFunction<any>,
	markTractorAsSoldWrapper?: FieldPolicy<any> | FieldReadFunction<any>,
	myPendingTasks?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfPendingTasks?: FieldPolicy<any> | FieldReadFunction<any>,
	pendingTasks?: FieldPolicy<any> | FieldReadFunction<any>,
	queryAccessoriesCheck?: FieldPolicy<any> | FieldReadFunction<any>,
	queryAccessoriesCheckListWithStage?: FieldPolicy<any> | FieldReadFunction<any>,
	queryAccessoriesChecklist?: FieldPolicy<any> | FieldReadFunction<any>,
	queryActiveStateWithGSTN?: FieldPolicy<any> | FieldReadFunction<any>,
	queryAdminLeadStatusEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	queryAgency?: FieldPolicy<any> | FieldReadFunction<any>,
	queryAuctionHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	queryBank?: FieldPolicy<any> | FieldReadFunction<any>,
	queryBankAuctionLeadCountByName?: FieldPolicy<any> | FieldReadFunction<any>,
	queryBooking?: FieldPolicy<any> | FieldReadFunction<any>,
	queryBookingPayment?: FieldPolicy<any> | FieldReadFunction<any>,
	queryBrand?: FieldPolicy<any> | FieldReadFunction<any>,
	queryBulkApprovalResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	queryCenterlizeLocationDistrcitsResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	queryCenterlizeLocationDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	queryCenterlizeLocationStates?: FieldPolicy<any> | FieldReadFunction<any>,
	queryCenterlizeLocationStatesResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	queryCenterlizeLocationTehsil?: FieldPolicy<any> | FieldReadFunction<any>,
	queryCenterlizeLocationTehsilResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	queryCentre?: FieldPolicy<any> | FieldReadFunction<any>,
	queryCentreAggregates?: FieldPolicy<any> | FieldReadFunction<any>,
	queryCity?: FieldPolicy<any> | FieldReadFunction<any>,
	queryCreateBulkLeadResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	queryCustomer?: FieldPolicy<any> | FieldReadFunction<any>,
	queryDealer?: FieldPolicy<any> | FieldReadFunction<any>,
	queryDealerStance?: FieldPolicy<any> | FieldReadFunction<any>,
	queryDealershipDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	queryDealershipLeadCountByPEName?: FieldPolicy<any> | FieldReadFunction<any>,
	queryDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	queryDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	queryDocumentChecklist?: FieldPolicy<any> | FieldReadFunction<any>,
	queryDocumentsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	queryDocumentsFollowups?: FieldPolicy<any> | FieldReadFunction<any>,
	queryDriverAggregates?: FieldPolicy<any> | FieldReadFunction<any>,
	queryEnquiry?: FieldPolicy<any> | FieldReadFunction<any>,
	queryEnquiryAdherence?: FieldPolicy<any> | FieldReadFunction<any>,
	queryEnquiryAggByCentre?: FieldPolicy<any> | FieldReadFunction<any>,
	queryEnquiryCloserAgg?: FieldPolicy<any> | FieldReadFunction<any>,
	queryEnquiryClosure?: FieldPolicy<any> | FieldReadFunction<any>,
	queryFollowup?: FieldPolicy<any> | FieldReadFunction<any>,
	queryIdByName?: FieldPolicy<any> | FieldReadFunction<any>,
	queryIdentificationDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	queryIdsByNameForListingReponse?: FieldPolicy<any> | FieldReadFunction<any>,
	queryInventoryDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	queryIssue?: FieldPolicy<any> | FieldReadFunction<any>,
	queryIssueItem?: FieldPolicy<any> | FieldReadFunction<any>,
	queryItemInventoryDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	queryLead?: FieldPolicy<any> | FieldReadFunction<any>,
	queryLeadCountByStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	queryLeadDocuments?: FieldPolicy<any> | FieldReadFunction<any>,
	queryLeadExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	queryLeadStatusEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	queryLeadStatusFlow?: FieldPolicy<any> | FieldReadFunction<any>,
	queryLeadTimelineAction?: FieldPolicy<any> | FieldReadFunction<any>,
	queryLeadTimelineStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	queryLoan?: FieldPolicy<any> | FieldReadFunction<any>,
	queryLogTracking?: FieldPolicy<any> | FieldReadFunction<any>,
	queryMarkSoldResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	queryMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	queryModel?: FieldPolicy<any> | FieldReadFunction<any>,
	queryModelByMake?: FieldPolicy<any> | FieldReadFunction<any>,
	queryNotification?: FieldPolicy<any> | FieldReadFunction<any>,
	queryNumberOfPendingTasks?: FieldPolicy<any> | FieldReadFunction<any>,
	queryParkingBeneficiary?: FieldPolicy<any> | FieldReadFunction<any>,
	queryPayment?: FieldPolicy<any> | FieldReadFunction<any>,
	queryPaymentInvoices?: FieldPolicy<any> | FieldReadFunction<any>,
	queryPickup?: FieldPolicy<any> | FieldReadFunction<any>,
	queryProduct?: FieldPolicy<any> | FieldReadFunction<any>,
	queryPurchase?: FieldPolicy<any> | FieldReadFunction<any>,
	queryPurchaseItem?: FieldPolicy<any> | FieldReadFunction<any>,
	queryRefurbishmentBeneficiary?: FieldPolicy<any> | FieldReadFunction<any>,
	queryRefurbishmentDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	queryRefurbishmentItem?: FieldPolicy<any> | FieldReadFunction<any>,
	queryRefurbishmentRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	querySMSLogs?: FieldPolicy<any> | FieldReadFunction<any>,
	querySendSmsToCustomerResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	queryStateCodeWithRegNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	queryStatusAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	queryTJCentre?: FieldPolicy<any> | FieldReadFunction<any>,
	queryTask?: FieldPolicy<any> | FieldReadFunction<any>,
	queryTehsil?: FieldPolicy<any> | FieldReadFunction<any>,
	queryTripExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	queryUser?: FieldPolicy<any> | FieldReadFunction<any>,
	queryVehicle?: FieldPolicy<any> | FieldReadFunction<any>,
	queryVehicleDocuments?: FieldPolicy<any> | FieldReadFunction<any>,
	queryVehicleFinancing?: FieldPolicy<any> | FieldReadFunction<any>,
	queryVehicleImages?: FieldPolicy<any> | FieldReadFunction<any>,
	queryVehicleInsurance?: FieldPolicy<any> | FieldReadFunction<any>,
	queryVehicleOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	queryVehicleTransferLog?: FieldPolicy<any> | FieldReadFunction<any>,
	queryYard?: FieldPolicy<any> | FieldReadFunction<any>,
	querydocumentsAggregatesResult?: FieldPolicy<any> | FieldReadFunction<any>,
	sendSmsToCustomer?: FieldPolicy<any> | FieldReadFunction<any>,
	statusAggregates?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RefurbishmentBeneficiaryKeySpecifier = ('accountHolderName' | 'accountNumber' | 'bankName' | 'id' | 'ifscCode' | 'payment' | 'paymentAggregate' | 'proofUrl' | 'refurbishmentRequest' | 'upiId' | RefurbishmentBeneficiaryKeySpecifier)[];
export type RefurbishmentBeneficiaryFieldPolicy = {
	accountHolderName?: FieldPolicy<any> | FieldReadFunction<any>,
	accountNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	bankName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	ifscCode?: FieldPolicy<any> | FieldReadFunction<any>,
	payment?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	proofUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	refurbishmentRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	upiId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RefurbishmentBeneficiaryAggregateResultKeySpecifier = ('accountHolderNameMax' | 'accountHolderNameMin' | 'accountNumberMax' | 'accountNumberMin' | 'count' | 'ifscCodeMax' | 'ifscCodeMin' | 'proofUrlMax' | 'proofUrlMin' | 'upiIdMax' | 'upiIdMin' | RefurbishmentBeneficiaryAggregateResultKeySpecifier)[];
export type RefurbishmentBeneficiaryAggregateResultFieldPolicy = {
	accountHolderNameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	accountHolderNameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	accountNumberMax?: FieldPolicy<any> | FieldReadFunction<any>,
	accountNumberMin?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	ifscCodeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	ifscCodeMin?: FieldPolicy<any> | FieldReadFunction<any>,
	proofUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	proofUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	upiIdMax?: FieldPolicy<any> | FieldReadFunction<any>,
	upiIdMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RefurbishmentDetailsKeySpecifier = ('id' | 'isRequired' | 'lead' | 'requests' | 'requestsAggregate' | RefurbishmentDetailsKeySpecifier)[];
export type RefurbishmentDetailsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isRequired?: FieldPolicy<any> | FieldReadFunction<any>,
	lead?: FieldPolicy<any> | FieldReadFunction<any>,
	requests?: FieldPolicy<any> | FieldReadFunction<any>,
	requestsAggregate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RefurbishmentDetailsAggregateResultKeySpecifier = ('count' | RefurbishmentDetailsAggregateResultKeySpecifier)[];
export type RefurbishmentDetailsAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RefurbishmentItemKeySpecifier = ('description' | 'expectedBuyingPrice' | 'id' | 'installationProofUrl' | 'price' | 'product' | 'quantity' | 'refurbishmentProofUrl' | 'status' | RefurbishmentItemKeySpecifier)[];
export type RefurbishmentItemFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	expectedBuyingPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	installationProofUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	refurbishmentProofUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RefurbishmentItemAggregateResultKeySpecifier = ('count' | 'descriptionMax' | 'descriptionMin' | 'expectedBuyingPriceAvg' | 'expectedBuyingPriceMax' | 'expectedBuyingPriceMin' | 'expectedBuyingPriceSum' | 'installationProofUrlMax' | 'installationProofUrlMin' | 'priceAvg' | 'priceMax' | 'priceMin' | 'priceSum' | 'quantityAvg' | 'quantityMax' | 'quantityMin' | 'quantitySum' | 'refurbishmentProofUrlMax' | 'refurbishmentProofUrlMin' | RefurbishmentItemAggregateResultKeySpecifier)[];
export type RefurbishmentItemAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptionMax?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptionMin?: FieldPolicy<any> | FieldReadFunction<any>,
	expectedBuyingPriceAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	expectedBuyingPriceMax?: FieldPolicy<any> | FieldReadFunction<any>,
	expectedBuyingPriceMin?: FieldPolicy<any> | FieldReadFunction<any>,
	expectedBuyingPriceSum?: FieldPolicy<any> | FieldReadFunction<any>,
	installationProofUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	installationProofUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	priceAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	priceMax?: FieldPolicy<any> | FieldReadFunction<any>,
	priceMin?: FieldPolicy<any> | FieldReadFunction<any>,
	priceSum?: FieldPolicy<any> | FieldReadFunction<any>,
	quantityAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	quantityMax?: FieldPolicy<any> | FieldReadFunction<any>,
	quantityMin?: FieldPolicy<any> | FieldReadFunction<any>,
	quantitySum?: FieldPolicy<any> | FieldReadFunction<any>,
	refurbishmentProofUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	refurbishmentProofUrlMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RefurbishmentRequestKeySpecifier = ('createdAt' | 'hasTransportationCharge' | 'id' | 'issue' | 'items' | 'itemsAggregate' | 'purchase' | 'raisedBy' | 'refurbishmentBeneficiary' | 'refurbishmentDetails' | 'requestStatus' | 'transportationCharge' | RefurbishmentRequestKeySpecifier)[];
export type RefurbishmentRequestFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	hasTransportationCharge?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	issue?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	itemsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	purchase?: FieldPolicy<any> | FieldReadFunction<any>,
	raisedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	refurbishmentBeneficiary?: FieldPolicy<any> | FieldReadFunction<any>,
	refurbishmentDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	requestStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	transportationCharge?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RefurbishmentRequestAggregateResultKeySpecifier = ('count' | 'createdAtMax' | 'createdAtMin' | 'transportationChargeAvg' | 'transportationChargeMax' | 'transportationChargeMin' | 'transportationChargeSum' | RefurbishmentRequestAggregateResultKeySpecifier)[];
export type RefurbishmentRequestAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	transportationChargeAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	transportationChargeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	transportationChargeMin?: FieldPolicy<any> | FieldReadFunction<any>,
	transportationChargeSum?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SMSLogsKeySpecifier = ('createdAt' | 'invoice' | 'response' | 'status' | SMSLogsKeySpecifier)[];
export type SMSLogsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	invoice?: FieldPolicy<any> | FieldReadFunction<any>,
	response?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SMSLogsAggregateResultKeySpecifier = ('count' | 'createdAtMax' | 'createdAtMin' | 'responseMax' | 'responseMin' | SMSLogsAggregateResultKeySpecifier)[];
export type SMSLogsAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	responseMax?: FieldPolicy<any> | FieldReadFunction<any>,
	responseMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SendSmsToCustomerResponseKeySpecifier = ('invoice' | 'message' | 'success' | SendSmsToCustomerResponseKeySpecifier)[];
export type SendSmsToCustomerResponseFieldPolicy = {
	invoice?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SendSmsToCustomerResponseAggregateResultKeySpecifier = ('count' | 'messageMax' | 'messageMin' | SendSmsToCustomerResponseAggregateResultKeySpecifier)[];
export type SendSmsToCustomerResponseAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	messageMax?: FieldPolicy<any> | FieldReadFunction<any>,
	messageMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StateCodeWithRegNumberKeySpecifier = ('RTOCode' | 'districts' | 'districtsAggregate' | 'id' | 'state' | 'tehsils' | 'tehsilsAggregate' | StateCodeWithRegNumberKeySpecifier)[];
export type StateCodeWithRegNumberFieldPolicy = {
	RTOCode?: FieldPolicy<any> | FieldReadFunction<any>,
	districts?: FieldPolicy<any> | FieldReadFunction<any>,
	districtsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	tehsils?: FieldPolicy<any> | FieldReadFunction<any>,
	tehsilsAggregate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StateCodeWithRegNumberAggregateResultKeySpecifier = ('RTOCodeMax' | 'RTOCodeMin' | 'count' | 'stateMax' | 'stateMin' | StateCodeWithRegNumberAggregateResultKeySpecifier)[];
export type StateCodeWithRegNumberAggregateResultFieldPolicy = {
	RTOCodeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	RTOCodeMin?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	stateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	stateMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StatusAggregateKeySpecifier = ('count' | 'status' | StatusAggregateKeySpecifier)[];
export type StatusAggregateFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StatusAggregateAggregateResultKeySpecifier = ('count' | 'countAvg' | 'countMax' | 'countMin' | 'countSum' | StatusAggregateAggregateResultKeySpecifier)[];
export type StatusAggregateAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	countAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	countMax?: FieldPolicy<any> | FieldReadFunction<any>,
	countMin?: FieldPolicy<any> | FieldReadFunction<any>,
	countSum?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubscriptionKeySpecifier = ('aggregateAdminLeadStatusEvent' | 'aggregateLeadStatusEvent' | 'aggregateMessage' | 'aggregateUser' | 'getAdminLeadStatusEvent' | 'getLeadStatusEvent' | 'getMessage' | 'getUser' | 'queryAdminLeadStatusEvent' | 'queryLeadStatusEvent' | 'queryMessage' | 'queryUser' | SubscriptionKeySpecifier)[];
export type SubscriptionFieldPolicy = {
	aggregateAdminLeadStatusEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateLeadStatusEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	aggregateUser?: FieldPolicy<any> | FieldReadFunction<any>,
	getAdminLeadStatusEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	getLeadStatusEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	getMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	getUser?: FieldPolicy<any> | FieldReadFunction<any>,
	queryAdminLeadStatusEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	queryLeadStatusEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	queryMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	queryUser?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TJCentreKeySpecifier = ('address' | 'center_image' | 'created_at' | 'district_id' | 'district_name' | 'email' | 'id' | 'latitude' | 'longitude' | 'mobile' | 'name' | 'name_en' | 'name_hi' | 'name_mr' | 'name_ta' | 'name_te' | 'postal_code' | 'short_address' | 'slug' | 'state_id' | 'state_name' | 'status' | 'tehsil_id' | 'updated_at' | TJCentreKeySpecifier)[];
export type TJCentreFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	center_image?: FieldPolicy<any> | FieldReadFunction<any>,
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	district_id?: FieldPolicy<any> | FieldReadFunction<any>,
	district_name?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	mobile?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	name_en?: FieldPolicy<any> | FieldReadFunction<any>,
	name_hi?: FieldPolicy<any> | FieldReadFunction<any>,
	name_mr?: FieldPolicy<any> | FieldReadFunction<any>,
	name_ta?: FieldPolicy<any> | FieldReadFunction<any>,
	name_te?: FieldPolicy<any> | FieldReadFunction<any>,
	postal_code?: FieldPolicy<any> | FieldReadFunction<any>,
	short_address?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	state_id?: FieldPolicy<any> | FieldReadFunction<any>,
	state_name?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	tehsil_id?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TJCentreAggregateResultKeySpecifier = ('addressMax' | 'addressMin' | 'center_imageMax' | 'center_imageMin' | 'count' | 'created_atMax' | 'created_atMin' | 'district_idAvg' | 'district_idMax' | 'district_idMin' | 'district_idSum' | 'district_nameMax' | 'district_nameMin' | 'emailMax' | 'emailMin' | 'idAvg' | 'idMax' | 'idMin' | 'idSum' | 'latitudeAvg' | 'latitudeMax' | 'latitudeMin' | 'latitudeSum' | 'longitudeAvg' | 'longitudeMax' | 'longitudeMin' | 'longitudeSum' | 'mobileMax' | 'mobileMin' | 'nameMax' | 'nameMin' | 'name_enMax' | 'name_enMin' | 'name_hiMax' | 'name_hiMin' | 'name_mrMax' | 'name_mrMin' | 'name_taMax' | 'name_taMin' | 'name_teMax' | 'name_teMin' | 'postal_codeAvg' | 'postal_codeMax' | 'postal_codeMin' | 'postal_codeSum' | 'short_addressMax' | 'short_addressMin' | 'slugMax' | 'slugMin' | 'state_idAvg' | 'state_idMax' | 'state_idMin' | 'state_idSum' | 'state_nameMax' | 'state_nameMin' | 'statusAvg' | 'statusMax' | 'statusMin' | 'statusSum' | 'tehsil_idAvg' | 'tehsil_idMax' | 'tehsil_idMin' | 'tehsil_idSum' | 'updated_atMax' | 'updated_atMin' | TJCentreAggregateResultKeySpecifier)[];
export type TJCentreAggregateResultFieldPolicy = {
	addressMax?: FieldPolicy<any> | FieldReadFunction<any>,
	addressMin?: FieldPolicy<any> | FieldReadFunction<any>,
	center_imageMax?: FieldPolicy<any> | FieldReadFunction<any>,
	center_imageMin?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	created_atMax?: FieldPolicy<any> | FieldReadFunction<any>,
	created_atMin?: FieldPolicy<any> | FieldReadFunction<any>,
	district_idAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	district_idMax?: FieldPolicy<any> | FieldReadFunction<any>,
	district_idMin?: FieldPolicy<any> | FieldReadFunction<any>,
	district_idSum?: FieldPolicy<any> | FieldReadFunction<any>,
	district_nameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	district_nameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	emailMax?: FieldPolicy<any> | FieldReadFunction<any>,
	emailMin?: FieldPolicy<any> | FieldReadFunction<any>,
	idAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	idMax?: FieldPolicy<any> | FieldReadFunction<any>,
	idMin?: FieldPolicy<any> | FieldReadFunction<any>,
	idSum?: FieldPolicy<any> | FieldReadFunction<any>,
	latitudeAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	latitudeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	latitudeMin?: FieldPolicy<any> | FieldReadFunction<any>,
	latitudeSum?: FieldPolicy<any> | FieldReadFunction<any>,
	longitudeAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	longitudeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	longitudeMin?: FieldPolicy<any> | FieldReadFunction<any>,
	longitudeSum?: FieldPolicy<any> | FieldReadFunction<any>,
	mobileMax?: FieldPolicy<any> | FieldReadFunction<any>,
	mobileMin?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	name_enMax?: FieldPolicy<any> | FieldReadFunction<any>,
	name_enMin?: FieldPolicy<any> | FieldReadFunction<any>,
	name_hiMax?: FieldPolicy<any> | FieldReadFunction<any>,
	name_hiMin?: FieldPolicy<any> | FieldReadFunction<any>,
	name_mrMax?: FieldPolicy<any> | FieldReadFunction<any>,
	name_mrMin?: FieldPolicy<any> | FieldReadFunction<any>,
	name_taMax?: FieldPolicy<any> | FieldReadFunction<any>,
	name_taMin?: FieldPolicy<any> | FieldReadFunction<any>,
	name_teMax?: FieldPolicy<any> | FieldReadFunction<any>,
	name_teMin?: FieldPolicy<any> | FieldReadFunction<any>,
	postal_codeAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	postal_codeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	postal_codeMin?: FieldPolicy<any> | FieldReadFunction<any>,
	postal_codeSum?: FieldPolicy<any> | FieldReadFunction<any>,
	short_addressMax?: FieldPolicy<any> | FieldReadFunction<any>,
	short_addressMin?: FieldPolicy<any> | FieldReadFunction<any>,
	slugMax?: FieldPolicy<any> | FieldReadFunction<any>,
	slugMin?: FieldPolicy<any> | FieldReadFunction<any>,
	state_idAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	state_idMax?: FieldPolicy<any> | FieldReadFunction<any>,
	state_idMin?: FieldPolicy<any> | FieldReadFunction<any>,
	state_idSum?: FieldPolicy<any> | FieldReadFunction<any>,
	state_nameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	state_nameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	statusAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	statusMax?: FieldPolicy<any> | FieldReadFunction<any>,
	statusMin?: FieldPolicy<any> | FieldReadFunction<any>,
	statusSum?: FieldPolicy<any> | FieldReadFunction<any>,
	tehsil_idAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	tehsil_idMax?: FieldPolicy<any> | FieldReadFunction<any>,
	tehsil_idMin?: FieldPolicy<any> | FieldReadFunction<any>,
	tehsil_idSum?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_atMax?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_atMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskKeySpecifier = ('assignedTo' | 'completedAt' | 'createdAt' | 'id' | 'isCompleted' | 'leadStatusEvent' | 'subtitle' | 'title' | TaskKeySpecifier)[];
export type TaskFieldPolicy = {
	assignedTo?: FieldPolicy<any> | FieldReadFunction<any>,
	completedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isCompleted?: FieldPolicy<any> | FieldReadFunction<any>,
	leadStatusEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	subtitle?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskAggregateResultKeySpecifier = ('completedAtMax' | 'completedAtMin' | 'count' | 'createdAtMax' | 'createdAtMin' | 'subtitleMax' | 'subtitleMin' | 'titleMax' | 'titleMin' | TaskAggregateResultKeySpecifier)[];
export type TaskAggregateResultFieldPolicy = {
	completedAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	completedAtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	subtitleMax?: FieldPolicy<any> | FieldReadFunction<any>,
	subtitleMin?: FieldPolicy<any> | FieldReadFunction<any>,
	titleMax?: FieldPolicy<any> | FieldReadFunction<any>,
	titleMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TehsilKeySpecifier = ('distId' | 'district' | 'id' | 'name' | 'state' | 'stateId' | TehsilKeySpecifier)[];
export type TehsilFieldPolicy = {
	distId?: FieldPolicy<any> | FieldReadFunction<any>,
	district?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	stateId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TehsilAggregateResultKeySpecifier = ('count' | 'distIdMax' | 'distIdMin' | 'nameMax' | 'nameMin' | 'stateIdMax' | 'stateIdMin' | TehsilAggregateResultKeySpecifier)[];
export type TehsilAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	distIdMax?: FieldPolicy<any> | FieldReadFunction<any>,
	distIdMin?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	stateIdMax?: FieldPolicy<any> | FieldReadFunction<any>,
	stateIdMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TripExpenseKeySpecifier = ('createdAt' | 'createdBy' | 'expensePayment' | 'expenses' | 'expensesAggregate' | 'id' | 'leads' | 'leadsAggregate' | 'remarksByFinance' | 'remarksByOps' | 'status' | 'updatedAt' | 'updatedBy' | 'updatedByFinance' | 'updatedByFinanceAt' | 'updatedByOperations' | 'updatedByOperationsAt' | TripExpenseKeySpecifier)[];
export type TripExpenseFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	expensePayment?: FieldPolicy<any> | FieldReadFunction<any>,
	expenses?: FieldPolicy<any> | FieldReadFunction<any>,
	expensesAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	leads?: FieldPolicy<any> | FieldReadFunction<any>,
	leadsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	remarksByFinance?: FieldPolicy<any> | FieldReadFunction<any>,
	remarksByOps?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedByFinance?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedByFinanceAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedByOperations?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedByOperationsAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TripExpenseAggregateResultKeySpecifier = ('count' | 'createdAtMax' | 'createdAtMin' | 'remarksByFinanceMax' | 'remarksByFinanceMin' | 'remarksByOpsMax' | 'remarksByOpsMin' | 'updatedAtMax' | 'updatedAtMin' | 'updatedByFinanceAtMax' | 'updatedByFinanceAtMin' | 'updatedByOperationsAtMax' | 'updatedByOperationsAtMin' | TripExpenseAggregateResultKeySpecifier)[];
export type TripExpenseAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	remarksByFinanceMax?: FieldPolicy<any> | FieldReadFunction<any>,
	remarksByFinanceMin?: FieldPolicy<any> | FieldReadFunction<any>,
	remarksByOpsMax?: FieldPolicy<any> | FieldReadFunction<any>,
	remarksByOpsMin?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedByFinanceAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedByFinanceAtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedByOperationsAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedByOperationsAtMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateAccessoriesCheckListWithStagePayloadKeySpecifier = ('accessoriesCheckListWithStage' | 'numUids' | UpdateAccessoriesCheckListWithStagePayloadKeySpecifier)[];
export type UpdateAccessoriesCheckListWithStagePayloadFieldPolicy = {
	accessoriesCheckListWithStage?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateAccessoriesCheckPayloadKeySpecifier = ('accessoriesCheck' | 'numUids' | UpdateAccessoriesCheckPayloadKeySpecifier)[];
export type UpdateAccessoriesCheckPayloadFieldPolicy = {
	accessoriesCheck?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateAccessoriesChecklistPayloadKeySpecifier = ('accessoriesChecklist' | 'numUids' | UpdateAccessoriesChecklistPayloadKeySpecifier)[];
export type UpdateAccessoriesChecklistPayloadFieldPolicy = {
	accessoriesChecklist?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateActiveStateWithGSTNPayloadKeySpecifier = ('activeStateWithGSTN' | 'numUids' | UpdateActiveStateWithGSTNPayloadKeySpecifier)[];
export type UpdateActiveStateWithGSTNPayloadFieldPolicy = {
	activeStateWithGSTN?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateAdminLeadStatusEventPayloadKeySpecifier = ('adminLeadStatusEvent' | 'numUids' | UpdateAdminLeadStatusEventPayloadKeySpecifier)[];
export type UpdateAdminLeadStatusEventPayloadFieldPolicy = {
	adminLeadStatusEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateAgencyPayloadKeySpecifier = ('agency' | 'numUids' | UpdateAgencyPayloadKeySpecifier)[];
export type UpdateAgencyPayloadFieldPolicy = {
	agency?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateAuctionHistoryPayloadKeySpecifier = ('auctionHistory' | 'numUids' | UpdateAuctionHistoryPayloadKeySpecifier)[];
export type UpdateAuctionHistoryPayloadFieldPolicy = {
	auctionHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateBankAuctionLeadCountByNamePayloadKeySpecifier = ('bankAuctionLeadCountByName' | 'numUids' | UpdateBankAuctionLeadCountByNamePayloadKeySpecifier)[];
export type UpdateBankAuctionLeadCountByNamePayloadFieldPolicy = {
	bankAuctionLeadCountByName?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateBankPayloadKeySpecifier = ('bank' | 'numUids' | UpdateBankPayloadKeySpecifier)[];
export type UpdateBankPayloadFieldPolicy = {
	bank?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateBookingPayloadKeySpecifier = ('booking' | 'numUids' | UpdateBookingPayloadKeySpecifier)[];
export type UpdateBookingPayloadFieldPolicy = {
	booking?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateBookingPaymentPayloadKeySpecifier = ('bookingPayment' | 'numUids' | UpdateBookingPaymentPayloadKeySpecifier)[];
export type UpdateBookingPaymentPayloadFieldPolicy = {
	bookingPayment?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateBrandPayloadKeySpecifier = ('brand' | 'numUids' | UpdateBrandPayloadKeySpecifier)[];
export type UpdateBrandPayloadFieldPolicy = {
	brand?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateBulkApprovalResponsePayloadKeySpecifier = ('bulkApprovalResponse' | 'numUids' | UpdateBulkApprovalResponsePayloadKeySpecifier)[];
export type UpdateBulkApprovalResponsePayloadFieldPolicy = {
	bulkApprovalResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateCenterlizeLocationDistrcitsResponsePayloadKeySpecifier = ('centerlizeLocationDistrcitsResponse' | 'numUids' | UpdateCenterlizeLocationDistrcitsResponsePayloadKeySpecifier)[];
export type UpdateCenterlizeLocationDistrcitsResponsePayloadFieldPolicy = {
	centerlizeLocationDistrcitsResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateCenterlizeLocationDistrictPayloadKeySpecifier = ('centerlizeLocationDistrict' | 'numUids' | UpdateCenterlizeLocationDistrictPayloadKeySpecifier)[];
export type UpdateCenterlizeLocationDistrictPayloadFieldPolicy = {
	centerlizeLocationDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateCenterlizeLocationStatesPayloadKeySpecifier = ('centerlizeLocationStates' | 'numUids' | UpdateCenterlizeLocationStatesPayloadKeySpecifier)[];
export type UpdateCenterlizeLocationStatesPayloadFieldPolicy = {
	centerlizeLocationStates?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateCenterlizeLocationStatesResponsePayloadKeySpecifier = ('centerlizeLocationStatesResponse' | 'numUids' | UpdateCenterlizeLocationStatesResponsePayloadKeySpecifier)[];
export type UpdateCenterlizeLocationStatesResponsePayloadFieldPolicy = {
	centerlizeLocationStatesResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateCenterlizeLocationTehsilPayloadKeySpecifier = ('centerlizeLocationTehsil' | 'numUids' | UpdateCenterlizeLocationTehsilPayloadKeySpecifier)[];
export type UpdateCenterlizeLocationTehsilPayloadFieldPolicy = {
	centerlizeLocationTehsil?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateCenterlizeLocationTehsilResponsePayloadKeySpecifier = ('centerlizeLocationTehsilResponse' | 'numUids' | UpdateCenterlizeLocationTehsilResponsePayloadKeySpecifier)[];
export type UpdateCenterlizeLocationTehsilResponsePayloadFieldPolicy = {
	centerlizeLocationTehsilResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateCentreAggregatesPayloadKeySpecifier = ('centreAggregates' | 'numUids' | UpdateCentreAggregatesPayloadKeySpecifier)[];
export type UpdateCentreAggregatesPayloadFieldPolicy = {
	centreAggregates?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateCentrePayloadKeySpecifier = ('centre' | 'numUids' | UpdateCentrePayloadKeySpecifier)[];
export type UpdateCentrePayloadFieldPolicy = {
	centre?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateCreateBulkLeadResponsePayloadKeySpecifier = ('createBulkLeadResponse' | 'numUids' | UpdateCreateBulkLeadResponsePayloadKeySpecifier)[];
export type UpdateCreateBulkLeadResponsePayloadFieldPolicy = {
	createBulkLeadResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateCustomerPayloadKeySpecifier = ('customer' | 'numUids' | UpdateCustomerPayloadKeySpecifier)[];
export type UpdateCustomerPayloadFieldPolicy = {
	customer?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateDealerPayloadKeySpecifier = ('dealer' | 'numUids' | UpdateDealerPayloadKeySpecifier)[];
export type UpdateDealerPayloadFieldPolicy = {
	dealer?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateDealerStancePayloadKeySpecifier = ('dealerStance' | 'numUids' | UpdateDealerStancePayloadKeySpecifier)[];
export type UpdateDealerStancePayloadFieldPolicy = {
	dealerStance?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateDealershipDocumentPayloadKeySpecifier = ('dealershipDocument' | 'numUids' | UpdateDealershipDocumentPayloadKeySpecifier)[];
export type UpdateDealershipDocumentPayloadFieldPolicy = {
	dealershipDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateDealershipLeadCountByPENamePayloadKeySpecifier = ('dealershipLeadCountByPEName' | 'numUids' | UpdateDealershipLeadCountByPENamePayloadKeySpecifier)[];
export type UpdateDealershipLeadCountByPENamePayloadFieldPolicy = {
	dealershipLeadCountByPEName?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateDistrictPayloadKeySpecifier = ('district' | 'numUids' | UpdateDistrictPayloadKeySpecifier)[];
export type UpdateDistrictPayloadFieldPolicy = {
	district?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateDocumentChecklistPayloadKeySpecifier = ('documentChecklist' | 'numUids' | UpdateDocumentChecklistPayloadKeySpecifier)[];
export type UpdateDocumentChecklistPayloadFieldPolicy = {
	documentChecklist?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateDocumentPayloadKeySpecifier = ('document' | 'numUids' | UpdateDocumentPayloadKeySpecifier)[];
export type UpdateDocumentPayloadFieldPolicy = {
	document?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateDocumentsCountPayloadKeySpecifier = ('documentsCount' | 'numUids' | UpdateDocumentsCountPayloadKeySpecifier)[];
export type UpdateDocumentsCountPayloadFieldPolicy = {
	documentsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateDocumentsFollowupsPayloadKeySpecifier = ('documentsFollowups' | 'numUids' | UpdateDocumentsFollowupsPayloadKeySpecifier)[];
export type UpdateDocumentsFollowupsPayloadFieldPolicy = {
	documentsFollowups?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateDriverAggregatesPayloadKeySpecifier = ('driverAggregates' | 'numUids' | UpdateDriverAggregatesPayloadKeySpecifier)[];
export type UpdateDriverAggregatesPayloadFieldPolicy = {
	driverAggregates?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateEnquiryAdherencePayloadKeySpecifier = ('enquiryAdherence' | 'numUids' | UpdateEnquiryAdherencePayloadKeySpecifier)[];
export type UpdateEnquiryAdherencePayloadFieldPolicy = {
	enquiryAdherence?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateEnquiryAggByCentrePayloadKeySpecifier = ('enquiryAggByCentre' | 'numUids' | UpdateEnquiryAggByCentrePayloadKeySpecifier)[];
export type UpdateEnquiryAggByCentrePayloadFieldPolicy = {
	enquiryAggByCentre?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateEnquiryCloserAggPayloadKeySpecifier = ('enquiryCloserAgg' | 'numUids' | UpdateEnquiryCloserAggPayloadKeySpecifier)[];
export type UpdateEnquiryCloserAggPayloadFieldPolicy = {
	enquiryCloserAgg?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateEnquiryClosurePayloadKeySpecifier = ('enquiryClosure' | 'numUids' | UpdateEnquiryClosurePayloadKeySpecifier)[];
export type UpdateEnquiryClosurePayloadFieldPolicy = {
	enquiryClosure?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateEnquiryPayloadKeySpecifier = ('enquiry' | 'numUids' | UpdateEnquiryPayloadKeySpecifier)[];
export type UpdateEnquiryPayloadFieldPolicy = {
	enquiry?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateFollowupPayloadKeySpecifier = ('followup' | 'numUids' | UpdateFollowupPayloadKeySpecifier)[];
export type UpdateFollowupPayloadFieldPolicy = {
	followup?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateIdByNamePayloadKeySpecifier = ('idByName' | 'numUids' | UpdateIdByNamePayloadKeySpecifier)[];
export type UpdateIdByNamePayloadFieldPolicy = {
	idByName?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateIdentificationDocumentPayloadKeySpecifier = ('identificationDocument' | 'numUids' | UpdateIdentificationDocumentPayloadKeySpecifier)[];
export type UpdateIdentificationDocumentPayloadFieldPolicy = {
	identificationDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateIdsByNameForListingReponsePayloadKeySpecifier = ('idsByNameForListingReponse' | 'numUids' | UpdateIdsByNameForListingReponsePayloadKeySpecifier)[];
export type UpdateIdsByNameForListingReponsePayloadFieldPolicy = {
	idsByNameForListingReponse?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateInventoryDetailsPayloadKeySpecifier = ('inventoryDetails' | 'numUids' | UpdateInventoryDetailsPayloadKeySpecifier)[];
export type UpdateInventoryDetailsPayloadFieldPolicy = {
	inventoryDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateIssueItemPayloadKeySpecifier = ('issueItem' | 'numUids' | UpdateIssueItemPayloadKeySpecifier)[];
export type UpdateIssueItemPayloadFieldPolicy = {
	issueItem?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateIssuePayloadKeySpecifier = ('issue' | 'numUids' | UpdateIssuePayloadKeySpecifier)[];
export type UpdateIssuePayloadFieldPolicy = {
	issue?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateItemInventoryDetailsPayloadKeySpecifier = ('itemInventoryDetails' | 'numUids' | UpdateItemInventoryDetailsPayloadKeySpecifier)[];
export type UpdateItemInventoryDetailsPayloadFieldPolicy = {
	itemInventoryDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateLeadCountByStatusPayloadKeySpecifier = ('leadCountByStatus' | 'numUids' | UpdateLeadCountByStatusPayloadKeySpecifier)[];
export type UpdateLeadCountByStatusPayloadFieldPolicy = {
	leadCountByStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateLeadDocumentsPayloadKeySpecifier = ('leadDocuments' | 'numUids' | UpdateLeadDocumentsPayloadKeySpecifier)[];
export type UpdateLeadDocumentsPayloadFieldPolicy = {
	leadDocuments?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateLeadExpensePayloadKeySpecifier = ('leadExpense' | 'numUids' | UpdateLeadExpensePayloadKeySpecifier)[];
export type UpdateLeadExpensePayloadFieldPolicy = {
	leadExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateLeadPayloadKeySpecifier = ('lead' | 'numUids' | UpdateLeadPayloadKeySpecifier)[];
export type UpdateLeadPayloadFieldPolicy = {
	lead?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateLeadStatusEventPayloadKeySpecifier = ('leadStatusEvent' | 'numUids' | UpdateLeadStatusEventPayloadKeySpecifier)[];
export type UpdateLeadStatusEventPayloadFieldPolicy = {
	leadStatusEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateLeadStatusFlowPayloadKeySpecifier = ('leadStatusFlow' | 'numUids' | UpdateLeadStatusFlowPayloadKeySpecifier)[];
export type UpdateLeadStatusFlowPayloadFieldPolicy = {
	leadStatusFlow?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateLeadTimelineActionPayloadKeySpecifier = ('leadTimelineAction' | 'numUids' | UpdateLeadTimelineActionPayloadKeySpecifier)[];
export type UpdateLeadTimelineActionPayloadFieldPolicy = {
	leadTimelineAction?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateLeadTimelineStatusPayloadKeySpecifier = ('leadTimelineStatus' | 'numUids' | UpdateLeadTimelineStatusPayloadKeySpecifier)[];
export type UpdateLeadTimelineStatusPayloadFieldPolicy = {
	leadTimelineStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateLoanPayloadKeySpecifier = ('loan' | 'numUids' | UpdateLoanPayloadKeySpecifier)[];
export type UpdateLoanPayloadFieldPolicy = {
	loan?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateLogTrackingPayloadKeySpecifier = ('logTracking' | 'numUids' | UpdateLogTrackingPayloadKeySpecifier)[];
export type UpdateLogTrackingPayloadFieldPolicy = {
	logTracking?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateMarkSoldResponsePayloadKeySpecifier = ('markSoldResponse' | 'numUids' | UpdateMarkSoldResponsePayloadKeySpecifier)[];
export type UpdateMarkSoldResponsePayloadFieldPolicy = {
	markSoldResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateMessagePayloadKeySpecifier = ('message' | 'numUids' | UpdateMessagePayloadKeySpecifier)[];
export type UpdateMessagePayloadFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateModelByMakePayloadKeySpecifier = ('modelByMake' | 'numUids' | UpdateModelByMakePayloadKeySpecifier)[];
export type UpdateModelByMakePayloadFieldPolicy = {
	modelByMake?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateModelPayloadKeySpecifier = ('model' | 'numUids' | UpdateModelPayloadKeySpecifier)[];
export type UpdateModelPayloadFieldPolicy = {
	model?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateNotificationPayloadKeySpecifier = ('notification' | 'numUids' | UpdateNotificationPayloadKeySpecifier)[];
export type UpdateNotificationPayloadFieldPolicy = {
	notification?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateNumberOfPendingTasksPayloadKeySpecifier = ('numUids' | 'numberOfPendingTasks' | UpdateNumberOfPendingTasksPayloadKeySpecifier)[];
export type UpdateNumberOfPendingTasksPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfPendingTasks?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateParkingBeneficiaryPayloadKeySpecifier = ('numUids' | 'parkingBeneficiary' | UpdateParkingBeneficiaryPayloadKeySpecifier)[];
export type UpdateParkingBeneficiaryPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	parkingBeneficiary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdatePaymentInvoicesPayloadKeySpecifier = ('numUids' | 'paymentInvoices' | UpdatePaymentInvoicesPayloadKeySpecifier)[];
export type UpdatePaymentInvoicesPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentInvoices?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdatePaymentPayloadKeySpecifier = ('numUids' | 'payment' | UpdatePaymentPayloadKeySpecifier)[];
export type UpdatePaymentPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	payment?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdatePickupPayloadKeySpecifier = ('numUids' | 'pickup' | UpdatePickupPayloadKeySpecifier)[];
export type UpdatePickupPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	pickup?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateProductPayloadKeySpecifier = ('numUids' | 'product' | UpdateProductPayloadKeySpecifier)[];
export type UpdateProductPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdatePurchaseItemPayloadKeySpecifier = ('numUids' | 'purchaseItem' | UpdatePurchaseItemPayloadKeySpecifier)[];
export type UpdatePurchaseItemPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseItem?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdatePurchasePayloadKeySpecifier = ('numUids' | 'purchase' | UpdatePurchasePayloadKeySpecifier)[];
export type UpdatePurchasePayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	purchase?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateRefurbishmentBeneficiaryPayloadKeySpecifier = ('numUids' | 'refurbishmentBeneficiary' | UpdateRefurbishmentBeneficiaryPayloadKeySpecifier)[];
export type UpdateRefurbishmentBeneficiaryPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	refurbishmentBeneficiary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateRefurbishmentDetailsPayloadKeySpecifier = ('numUids' | 'refurbishmentDetails' | UpdateRefurbishmentDetailsPayloadKeySpecifier)[];
export type UpdateRefurbishmentDetailsPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	refurbishmentDetails?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateRefurbishmentItemPayloadKeySpecifier = ('numUids' | 'refurbishmentItem' | UpdateRefurbishmentItemPayloadKeySpecifier)[];
export type UpdateRefurbishmentItemPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	refurbishmentItem?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateRefurbishmentRequestPayloadKeySpecifier = ('numUids' | 'refurbishmentRequest' | UpdateRefurbishmentRequestPayloadKeySpecifier)[];
export type UpdateRefurbishmentRequestPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	refurbishmentRequest?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateSMSLogsPayloadKeySpecifier = ('numUids' | 'sMSLogs' | UpdateSMSLogsPayloadKeySpecifier)[];
export type UpdateSMSLogsPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	sMSLogs?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateSendSmsToCustomerResponsePayloadKeySpecifier = ('numUids' | 'sendSmsToCustomerResponse' | UpdateSendSmsToCustomerResponsePayloadKeySpecifier)[];
export type UpdateSendSmsToCustomerResponsePayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	sendSmsToCustomerResponse?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateStateCodeWithRegNumberPayloadKeySpecifier = ('numUids' | 'stateCodeWithRegNumber' | UpdateStateCodeWithRegNumberPayloadKeySpecifier)[];
export type UpdateStateCodeWithRegNumberPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	stateCodeWithRegNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateStatusAggregatePayloadKeySpecifier = ('numUids' | 'statusAggregate' | UpdateStatusAggregatePayloadKeySpecifier)[];
export type UpdateStatusAggregatePayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	statusAggregate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateTJCentrePayloadKeySpecifier = ('numUids' | 'tJCentre' | UpdateTJCentrePayloadKeySpecifier)[];
export type UpdateTJCentrePayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	tJCentre?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateTaskPayloadKeySpecifier = ('numUids' | 'task' | UpdateTaskPayloadKeySpecifier)[];
export type UpdateTaskPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	task?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateTehsilPayloadKeySpecifier = ('numUids' | 'tehsil' | UpdateTehsilPayloadKeySpecifier)[];
export type UpdateTehsilPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	tehsil?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateTripExpensePayloadKeySpecifier = ('numUids' | 'tripExpense' | UpdateTripExpensePayloadKeySpecifier)[];
export type UpdateTripExpensePayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	tripExpense?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateUserPayloadKeySpecifier = ('numUids' | 'user' | UpdateUserPayloadKeySpecifier)[];
export type UpdateUserPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateVehicleDocumentsPayloadKeySpecifier = ('numUids' | 'vehicleDocuments' | UpdateVehicleDocumentsPayloadKeySpecifier)[];
export type UpdateVehicleDocumentsPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleDocuments?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateVehicleFinancingPayloadKeySpecifier = ('numUids' | 'vehicleFinancing' | UpdateVehicleFinancingPayloadKeySpecifier)[];
export type UpdateVehicleFinancingPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleFinancing?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateVehicleImagesPayloadKeySpecifier = ('numUids' | 'vehicleImages' | UpdateVehicleImagesPayloadKeySpecifier)[];
export type UpdateVehicleImagesPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleImages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateVehicleInsurancePayloadKeySpecifier = ('numUids' | 'vehicleInsurance' | UpdateVehicleInsurancePayloadKeySpecifier)[];
export type UpdateVehicleInsurancePayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleInsurance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateVehicleOwnerPayloadKeySpecifier = ('numUids' | 'vehicleOwner' | UpdateVehicleOwnerPayloadKeySpecifier)[];
export type UpdateVehicleOwnerPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleOwner?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateVehiclePayloadKeySpecifier = ('numUids' | 'vehicle' | UpdateVehiclePayloadKeySpecifier)[];
export type UpdateVehiclePayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicle?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateVehicleTransferLogPayloadKeySpecifier = ('numUids' | 'vehicleTransferLog' | UpdateVehicleTransferLogPayloadKeySpecifier)[];
export type UpdateVehicleTransferLogPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleTransferLog?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateYardPayloadKeySpecifier = ('numUids' | 'yard' | UpdateYardPayloadKeySpecifier)[];
export type UpdateYardPayloadFieldPolicy = {
	numUids?: FieldPolicy<any> | FieldReadFunction<any>,
	yard?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdatedocumentsAggregatesResultPayloadKeySpecifier = ('documentsAggregatesResult' | 'numUids' | UpdatedocumentsAggregatesResultPayloadKeySpecifier)[];
export type UpdatedocumentsAggregatesResultPayloadFieldPolicy = {
	documentsAggregatesResult?: FieldPolicy<any> | FieldReadFunction<any>,
	numUids?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserKeySpecifier = ('addedTripExpenses' | 'addedTripExpensesAggregate' | 'additionalRole' | 'approvedIssues' | 'approvedIssuesAggregate' | 'approvedPurchases' | 'approvedPurchasesAggregate' | 'assignedInternalTransfer' | 'assignedInternalTransferAggregate' | 'assignedTasks' | 'assignedTasksAggregate' | 'avatar' | 'centre' | 'createdAt' | 'createdLeads' | 'createdLeadsAggregate' | 'email' | 'expoPushNotificationAddress' | 'hasAdminPanelAccess' | 'id' | 'inchargeOfCentres' | 'inchargeOfCentresAggregate' | 'isActive' | 'isReportingManagerOf' | 'isReportingManagerOfAggregate' | 'location' | 'madeIssues' | 'madeIssuesAggregate' | 'madePurchases' | 'madePurchasesAggregate' | 'managingCentres' | 'managingCentresAggregate' | 'name' | 'notifications' | 'notificationsAggregate' | 'payments' | 'paymentsAggregate' | 'phoneNo' | 'pickups' | 'pickupsAggregate' | 'punchedEvents' | 'punchedEventsAggregate' | 'raisedRefurbishments' | 'raisedRefurbishmentsAggregate' | 'readMessages' | 'readMessagesAggregate' | 'registrationState' | 'reportingManager' | 'role' | 'sentMessages' | 'sentMessagesAggregate' | 'updatedAt' | 'updatedListings' | 'updatedListingsAggregate' | 'userLogs' | 'userLogsAggregate' | UserKeySpecifier)[];
export type UserFieldPolicy = {
	addedTripExpenses?: FieldPolicy<any> | FieldReadFunction<any>,
	addedTripExpensesAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	additionalRole?: FieldPolicy<any> | FieldReadFunction<any>,
	approvedIssues?: FieldPolicy<any> | FieldReadFunction<any>,
	approvedIssuesAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	approvedPurchases?: FieldPolicy<any> | FieldReadFunction<any>,
	approvedPurchasesAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedInternalTransfer?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedInternalTransferAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedTasks?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedTasksAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	avatar?: FieldPolicy<any> | FieldReadFunction<any>,
	centre?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdLeads?: FieldPolicy<any> | FieldReadFunction<any>,
	createdLeadsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	expoPushNotificationAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	hasAdminPanelAccess?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	inchargeOfCentres?: FieldPolicy<any> | FieldReadFunction<any>,
	inchargeOfCentresAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isReportingManagerOf?: FieldPolicy<any> | FieldReadFunction<any>,
	isReportingManagerOfAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	madeIssues?: FieldPolicy<any> | FieldReadFunction<any>,
	madeIssuesAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	madePurchases?: FieldPolicy<any> | FieldReadFunction<any>,
	madePurchasesAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	managingCentres?: FieldPolicy<any> | FieldReadFunction<any>,
	managingCentresAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	notifications?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	payments?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNo?: FieldPolicy<any> | FieldReadFunction<any>,
	pickups?: FieldPolicy<any> | FieldReadFunction<any>,
	pickupsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	punchedEvents?: FieldPolicy<any> | FieldReadFunction<any>,
	punchedEventsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	raisedRefurbishments?: FieldPolicy<any> | FieldReadFunction<any>,
	raisedRefurbishmentsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	readMessages?: FieldPolicy<any> | FieldReadFunction<any>,
	readMessagesAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationState?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingManager?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	sentMessages?: FieldPolicy<any> | FieldReadFunction<any>,
	sentMessagesAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedListings?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedListingsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	userLogs?: FieldPolicy<any> | FieldReadFunction<any>,
	userLogsAggregate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserAggregateResultKeySpecifier = ('avatarMax' | 'avatarMin' | 'count' | 'createdAtMax' | 'createdAtMin' | 'emailMax' | 'emailMin' | 'expoPushNotificationAddressMax' | 'expoPushNotificationAddressMin' | 'nameMax' | 'nameMin' | 'phoneNoMax' | 'phoneNoMin' | 'updatedAtMax' | 'updatedAtMin' | UserAggregateResultKeySpecifier)[];
export type UserAggregateResultFieldPolicy = {
	avatarMax?: FieldPolicy<any> | FieldReadFunction<any>,
	avatarMin?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	emailMax?: FieldPolicy<any> | FieldReadFunction<any>,
	emailMin?: FieldPolicy<any> | FieldReadFunction<any>,
	expoPushNotificationAddressMax?: FieldPolicy<any> | FieldReadFunction<any>,
	expoPushNotificationAddressMin?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNoMax?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNoMin?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAtMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VehicleKeySpecifier = ('challanAmount' | 'chassisNumber' | 'color' | 'documents' | 'dueTaxesAmount' | 'engineCondition' | 'engineNumber' | 'financingDetails' | 'fitnessValidUpto' | 'fuelType' | 'hasDueTaxes' | 'horsePower' | 'hoursMeter' | 'id' | 'images' | 'imagesAggregate' | 'insuranceDetails' | 'isBlacklisted' | 'isChallanAvailable' | 'isHSRPAvailable' | 'isHypo' | 'isRcAvailable' | 'isVehicleFinanced' | 'isVehicleInsured' | 'kind' | 'make' | 'manufacturingDate' | 'model' | 'owner' | 'price' | 'purchaseDate' | 'regNo' | 'registrationDate' | 'registrationNumber' | 'repossessionDate' | 'tempChassisNumber' | 'tempEngineNumber' | 'tempIsVehicleFinanced' | 'tempMake' | 'tempManufacturingDate' | 'tempModel' | 'tempRepossessionDate' | 'tempVehicleBrand' | 'tempVehicleModel' | 'totalHourRun' | 'totalKmsRun' | 'typeCondition' | 'vehicleBrand' | 'vehicleModel' | 'verificationRemarks' | VehicleKeySpecifier)[];
export type VehicleFieldPolicy = {
	challanAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	chassisNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	documents?: FieldPolicy<any> | FieldReadFunction<any>,
	dueTaxesAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	engineCondition?: FieldPolicy<any> | FieldReadFunction<any>,
	engineNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	financingDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	fitnessValidUpto?: FieldPolicy<any> | FieldReadFunction<any>,
	fuelType?: FieldPolicy<any> | FieldReadFunction<any>,
	hasDueTaxes?: FieldPolicy<any> | FieldReadFunction<any>,
	horsePower?: FieldPolicy<any> | FieldReadFunction<any>,
	hoursMeter?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	images?: FieldPolicy<any> | FieldReadFunction<any>,
	imagesAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	insuranceDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	isBlacklisted?: FieldPolicy<any> | FieldReadFunction<any>,
	isChallanAvailable?: FieldPolicy<any> | FieldReadFunction<any>,
	isHSRPAvailable?: FieldPolicy<any> | FieldReadFunction<any>,
	isHypo?: FieldPolicy<any> | FieldReadFunction<any>,
	isRcAvailable?: FieldPolicy<any> | FieldReadFunction<any>,
	isVehicleFinanced?: FieldPolicy<any> | FieldReadFunction<any>,
	isVehicleInsured?: FieldPolicy<any> | FieldReadFunction<any>,
	kind?: FieldPolicy<any> | FieldReadFunction<any>,
	make?: FieldPolicy<any> | FieldReadFunction<any>,
	manufacturingDate?: FieldPolicy<any> | FieldReadFunction<any>,
	model?: FieldPolicy<any> | FieldReadFunction<any>,
	owner?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseDate?: FieldPolicy<any> | FieldReadFunction<any>,
	regNo?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	repossessionDate?: FieldPolicy<any> | FieldReadFunction<any>,
	tempChassisNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	tempEngineNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	tempIsVehicleFinanced?: FieldPolicy<any> | FieldReadFunction<any>,
	tempMake?: FieldPolicy<any> | FieldReadFunction<any>,
	tempManufacturingDate?: FieldPolicy<any> | FieldReadFunction<any>,
	tempModel?: FieldPolicy<any> | FieldReadFunction<any>,
	tempRepossessionDate?: FieldPolicy<any> | FieldReadFunction<any>,
	tempVehicleBrand?: FieldPolicy<any> | FieldReadFunction<any>,
	tempVehicleModel?: FieldPolicy<any> | FieldReadFunction<any>,
	totalHourRun?: FieldPolicy<any> | FieldReadFunction<any>,
	totalKmsRun?: FieldPolicy<any> | FieldReadFunction<any>,
	typeCondition?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleBrand?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleModel?: FieldPolicy<any> | FieldReadFunction<any>,
	verificationRemarks?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VehicleAggregateResultKeySpecifier = ('challanAmountAvg' | 'challanAmountMax' | 'challanAmountMin' | 'challanAmountSum' | 'chassisNumberMax' | 'chassisNumberMin' | 'colorMax' | 'colorMin' | 'count' | 'dueTaxesAmountAvg' | 'dueTaxesAmountMax' | 'dueTaxesAmountMin' | 'dueTaxesAmountSum' | 'engineConditionAvg' | 'engineConditionMax' | 'engineConditionMin' | 'engineConditionSum' | 'engineNumberMax' | 'engineNumberMin' | 'fitnessValidUptoMax' | 'fitnessValidUptoMin' | 'horsePowerAvg' | 'horsePowerMax' | 'horsePowerMin' | 'horsePowerSum' | 'hoursMeterAvg' | 'hoursMeterMax' | 'hoursMeterMin' | 'hoursMeterSum' | 'manufacturingDateMax' | 'manufacturingDateMin' | 'modelMax' | 'modelMin' | 'priceAvg' | 'priceMax' | 'priceMin' | 'priceSum' | 'purchaseDateMax' | 'purchaseDateMin' | 'regNoMax' | 'regNoMin' | 'registrationDateMax' | 'registrationDateMin' | 'registrationNumberMax' | 'registrationNumberMin' | 'repossessionDateMax' | 'repossessionDateMin' | 'tempChassisNumberMax' | 'tempChassisNumberMin' | 'tempEngineNumberMax' | 'tempEngineNumberMin' | 'tempManufacturingDateMax' | 'tempManufacturingDateMin' | 'tempModelMax' | 'tempModelMin' | 'tempRepossessionDateMax' | 'tempRepossessionDateMin' | 'totalHourRunAvg' | 'totalHourRunMax' | 'totalHourRunMin' | 'totalHourRunSum' | 'totalKmsRunAvg' | 'totalKmsRunMax' | 'totalKmsRunMin' | 'totalKmsRunSum' | 'typeConditionAvg' | 'typeConditionMax' | 'typeConditionMin' | 'typeConditionSum' | 'verificationRemarksMax' | 'verificationRemarksMin' | VehicleAggregateResultKeySpecifier)[];
export type VehicleAggregateResultFieldPolicy = {
	challanAmountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	challanAmountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	challanAmountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	challanAmountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	chassisNumberMax?: FieldPolicy<any> | FieldReadFunction<any>,
	chassisNumberMin?: FieldPolicy<any> | FieldReadFunction<any>,
	colorMax?: FieldPolicy<any> | FieldReadFunction<any>,
	colorMin?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	dueTaxesAmountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	dueTaxesAmountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	dueTaxesAmountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	dueTaxesAmountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	engineConditionAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	engineConditionMax?: FieldPolicy<any> | FieldReadFunction<any>,
	engineConditionMin?: FieldPolicy<any> | FieldReadFunction<any>,
	engineConditionSum?: FieldPolicy<any> | FieldReadFunction<any>,
	engineNumberMax?: FieldPolicy<any> | FieldReadFunction<any>,
	engineNumberMin?: FieldPolicy<any> | FieldReadFunction<any>,
	fitnessValidUptoMax?: FieldPolicy<any> | FieldReadFunction<any>,
	fitnessValidUptoMin?: FieldPolicy<any> | FieldReadFunction<any>,
	horsePowerAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	horsePowerMax?: FieldPolicy<any> | FieldReadFunction<any>,
	horsePowerMin?: FieldPolicy<any> | FieldReadFunction<any>,
	horsePowerSum?: FieldPolicy<any> | FieldReadFunction<any>,
	hoursMeterAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	hoursMeterMax?: FieldPolicy<any> | FieldReadFunction<any>,
	hoursMeterMin?: FieldPolicy<any> | FieldReadFunction<any>,
	hoursMeterSum?: FieldPolicy<any> | FieldReadFunction<any>,
	manufacturingDateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	manufacturingDateMin?: FieldPolicy<any> | FieldReadFunction<any>,
	modelMax?: FieldPolicy<any> | FieldReadFunction<any>,
	modelMin?: FieldPolicy<any> | FieldReadFunction<any>,
	priceAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	priceMax?: FieldPolicy<any> | FieldReadFunction<any>,
	priceMin?: FieldPolicy<any> | FieldReadFunction<any>,
	priceSum?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseDateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseDateMin?: FieldPolicy<any> | FieldReadFunction<any>,
	regNoMax?: FieldPolicy<any> | FieldReadFunction<any>,
	regNoMin?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationDateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationDateMin?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationNumberMax?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationNumberMin?: FieldPolicy<any> | FieldReadFunction<any>,
	repossessionDateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	repossessionDateMin?: FieldPolicy<any> | FieldReadFunction<any>,
	tempChassisNumberMax?: FieldPolicy<any> | FieldReadFunction<any>,
	tempChassisNumberMin?: FieldPolicy<any> | FieldReadFunction<any>,
	tempEngineNumberMax?: FieldPolicy<any> | FieldReadFunction<any>,
	tempEngineNumberMin?: FieldPolicy<any> | FieldReadFunction<any>,
	tempManufacturingDateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	tempManufacturingDateMin?: FieldPolicy<any> | FieldReadFunction<any>,
	tempModelMax?: FieldPolicy<any> | FieldReadFunction<any>,
	tempModelMin?: FieldPolicy<any> | FieldReadFunction<any>,
	tempRepossessionDateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	tempRepossessionDateMin?: FieldPolicy<any> | FieldReadFunction<any>,
	totalHourRunAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	totalHourRunMax?: FieldPolicy<any> | FieldReadFunction<any>,
	totalHourRunMin?: FieldPolicy<any> | FieldReadFunction<any>,
	totalHourRunSum?: FieldPolicy<any> | FieldReadFunction<any>,
	totalKmsRunAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	totalKmsRunMax?: FieldPolicy<any> | FieldReadFunction<any>,
	totalKmsRunMin?: FieldPolicy<any> | FieldReadFunction<any>,
	totalKmsRunSum?: FieldPolicy<any> | FieldReadFunction<any>,
	typeConditionAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	typeConditionMax?: FieldPolicy<any> | FieldReadFunction<any>,
	typeConditionMin?: FieldPolicy<any> | FieldReadFunction<any>,
	typeConditionSum?: FieldPolicy<any> | FieldReadFunction<any>,
	verificationRemarksMax?: FieldPolicy<any> | FieldReadFunction<any>,
	verificationRemarksMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VehicleDocumentsKeySpecifier = ('approvalMailUrl' | 'blacklistProofUrl' | 'challanUrl' | 'fitnessCertificateUrl' | 'fitnessCertificateValidUpto' | 'hsrbProofUrl' | 'hypothecationProofUrl' | 'id' | 'regNo' | 'registrationCertificateUrl' | 'rtoVerificationProofUrl' | 'vehicle' | VehicleDocumentsKeySpecifier)[];
export type VehicleDocumentsFieldPolicy = {
	approvalMailUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	blacklistProofUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	challanUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	fitnessCertificateUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	fitnessCertificateValidUpto?: FieldPolicy<any> | FieldReadFunction<any>,
	hsrbProofUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	hypothecationProofUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	regNo?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationCertificateUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	rtoVerificationProofUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicle?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VehicleDocumentsAggregateResultKeySpecifier = ('approvalMailUrlMax' | 'approvalMailUrlMin' | 'blacklistProofUrlMax' | 'blacklistProofUrlMin' | 'challanUrlMax' | 'challanUrlMin' | 'count' | 'fitnessCertificateUrlMax' | 'fitnessCertificateUrlMin' | 'fitnessCertificateValidUptoMax' | 'fitnessCertificateValidUptoMin' | 'hsrbProofUrlMax' | 'hsrbProofUrlMin' | 'hypothecationProofUrlMax' | 'hypothecationProofUrlMin' | 'regNoMax' | 'regNoMin' | 'registrationCertificateUrlMax' | 'registrationCertificateUrlMin' | 'rtoVerificationProofUrlMax' | 'rtoVerificationProofUrlMin' | VehicleDocumentsAggregateResultKeySpecifier)[];
export type VehicleDocumentsAggregateResultFieldPolicy = {
	approvalMailUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	approvalMailUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	blacklistProofUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	blacklistProofUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	challanUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	challanUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	fitnessCertificateUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	fitnessCertificateUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	fitnessCertificateValidUptoMax?: FieldPolicy<any> | FieldReadFunction<any>,
	fitnessCertificateValidUptoMin?: FieldPolicy<any> | FieldReadFunction<any>,
	hsrbProofUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	hsrbProofUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	hypothecationProofUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	hypothecationProofUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	regNoMax?: FieldPolicy<any> | FieldReadFunction<any>,
	regNoMin?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationCertificateUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationCertificateUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	rtoVerificationProofUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	rtoVerificationProofUrlMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VehicleFinancingKeySpecifier = ('bankNOCUrl' | 'financerName' | 'foreclosureCertificateUrl' | 'form35Url' | 'id' | 'isLoanClosed' | 'loanToBeClosedBy' | 'pendingLoanAmount' | 'tempFinancerName' | 'tempLoanToBeClosedBy' | 'vehicle' | VehicleFinancingKeySpecifier)[];
export type VehicleFinancingFieldPolicy = {
	bankNOCUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	financerName?: FieldPolicy<any> | FieldReadFunction<any>,
	foreclosureCertificateUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	form35Url?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isLoanClosed?: FieldPolicy<any> | FieldReadFunction<any>,
	loanToBeClosedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	pendingLoanAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	tempFinancerName?: FieldPolicy<any> | FieldReadFunction<any>,
	tempLoanToBeClosedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicle?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VehicleFinancingAggregateResultKeySpecifier = ('bankNOCUrlMax' | 'bankNOCUrlMin' | 'count' | 'financerNameMax' | 'financerNameMin' | 'foreclosureCertificateUrlMax' | 'foreclosureCertificateUrlMin' | 'form35UrlMax' | 'form35UrlMin' | 'pendingLoanAmountAvg' | 'pendingLoanAmountMax' | 'pendingLoanAmountMin' | 'pendingLoanAmountSum' | 'tempFinancerNameMax' | 'tempFinancerNameMin' | VehicleFinancingAggregateResultKeySpecifier)[];
export type VehicleFinancingAggregateResultFieldPolicy = {
	bankNOCUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	bankNOCUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	financerNameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	financerNameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	foreclosureCertificateUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	foreclosureCertificateUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	form35UrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	form35UrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	pendingLoanAmountAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	pendingLoanAmountMax?: FieldPolicy<any> | FieldReadFunction<any>,
	pendingLoanAmountMin?: FieldPolicy<any> | FieldReadFunction<any>,
	pendingLoanAmountSum?: FieldPolicy<any> | FieldReadFunction<any>,
	tempFinancerNameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	tempFinancerNameMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VehicleImagesKeySpecifier = ('backBodySide' | 'backLeftTyre' | 'backRightTyre' | 'chassisNumber' | 'engineNumber' | 'frontBodySide' | 'frontLeftTyre' | 'frontRightTyre' | 'fuelInjectionPumpPlate' | 'id' | 'imagesTakenAtStage' | 'inspectionVideoUrl' | 'leftBodySide' | 'odometer' | 'rightBodySide' | 'vehicle' | 'vehicleImagesId' | VehicleImagesKeySpecifier)[];
export type VehicleImagesFieldPolicy = {
	backBodySide?: FieldPolicy<any> | FieldReadFunction<any>,
	backLeftTyre?: FieldPolicy<any> | FieldReadFunction<any>,
	backRightTyre?: FieldPolicy<any> | FieldReadFunction<any>,
	chassisNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	engineNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	frontBodySide?: FieldPolicy<any> | FieldReadFunction<any>,
	frontLeftTyre?: FieldPolicy<any> | FieldReadFunction<any>,
	frontRightTyre?: FieldPolicy<any> | FieldReadFunction<any>,
	fuelInjectionPumpPlate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	imagesTakenAtStage?: FieldPolicy<any> | FieldReadFunction<any>,
	inspectionVideoUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	leftBodySide?: FieldPolicy<any> | FieldReadFunction<any>,
	odometer?: FieldPolicy<any> | FieldReadFunction<any>,
	rightBodySide?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicle?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleImagesId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VehicleImagesAggregateResultKeySpecifier = ('backBodySideMax' | 'backBodySideMin' | 'backLeftTyreMax' | 'backLeftTyreMin' | 'backRightTyreMax' | 'backRightTyreMin' | 'chassisNumberMax' | 'chassisNumberMin' | 'count' | 'engineNumberMax' | 'engineNumberMin' | 'frontBodySideMax' | 'frontBodySideMin' | 'frontLeftTyreMax' | 'frontLeftTyreMin' | 'frontRightTyreMax' | 'frontRightTyreMin' | 'fuelInjectionPumpPlateMax' | 'fuelInjectionPumpPlateMin' | 'inspectionVideoUrlMax' | 'inspectionVideoUrlMin' | 'leftBodySideMax' | 'leftBodySideMin' | 'odometerMax' | 'odometerMin' | 'rightBodySideMax' | 'rightBodySideMin' | 'vehicleImagesIdMax' | 'vehicleImagesIdMin' | VehicleImagesAggregateResultKeySpecifier)[];
export type VehicleImagesAggregateResultFieldPolicy = {
	backBodySideMax?: FieldPolicy<any> | FieldReadFunction<any>,
	backBodySideMin?: FieldPolicy<any> | FieldReadFunction<any>,
	backLeftTyreMax?: FieldPolicy<any> | FieldReadFunction<any>,
	backLeftTyreMin?: FieldPolicy<any> | FieldReadFunction<any>,
	backRightTyreMax?: FieldPolicy<any> | FieldReadFunction<any>,
	backRightTyreMin?: FieldPolicy<any> | FieldReadFunction<any>,
	chassisNumberMax?: FieldPolicy<any> | FieldReadFunction<any>,
	chassisNumberMin?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	engineNumberMax?: FieldPolicy<any> | FieldReadFunction<any>,
	engineNumberMin?: FieldPolicy<any> | FieldReadFunction<any>,
	frontBodySideMax?: FieldPolicy<any> | FieldReadFunction<any>,
	frontBodySideMin?: FieldPolicy<any> | FieldReadFunction<any>,
	frontLeftTyreMax?: FieldPolicy<any> | FieldReadFunction<any>,
	frontLeftTyreMin?: FieldPolicy<any> | FieldReadFunction<any>,
	frontRightTyreMax?: FieldPolicy<any> | FieldReadFunction<any>,
	frontRightTyreMin?: FieldPolicy<any> | FieldReadFunction<any>,
	fuelInjectionPumpPlateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	fuelInjectionPumpPlateMin?: FieldPolicy<any> | FieldReadFunction<any>,
	inspectionVideoUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	inspectionVideoUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	leftBodySideMax?: FieldPolicy<any> | FieldReadFunction<any>,
	leftBodySideMin?: FieldPolicy<any> | FieldReadFunction<any>,
	odometerMax?: FieldPolicy<any> | FieldReadFunction<any>,
	odometerMin?: FieldPolicy<any> | FieldReadFunction<any>,
	rightBodySideMax?: FieldPolicy<any> | FieldReadFunction<any>,
	rightBodySideMin?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleImagesIdMax?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicleImagesIdMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VehicleInsuranceKeySpecifier = ('id' | 'insuraceCertificateUrl' | 'insuranceType' | 'insurerName' | 'policyExpiryDate' | 'policyNumber' | 'vehicle' | VehicleInsuranceKeySpecifier)[];
export type VehicleInsuranceFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	insuraceCertificateUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	insuranceType?: FieldPolicy<any> | FieldReadFunction<any>,
	insurerName?: FieldPolicy<any> | FieldReadFunction<any>,
	policyExpiryDate?: FieldPolicy<any> | FieldReadFunction<any>,
	policyNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	vehicle?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VehicleInsuranceAggregateResultKeySpecifier = ('count' | 'insuraceCertificateUrlMax' | 'insuraceCertificateUrlMin' | 'policyExpiryDateMax' | 'policyExpiryDateMin' | 'policyNumberMax' | 'policyNumberMin' | VehicleInsuranceAggregateResultKeySpecifier)[];
export type VehicleInsuranceAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	insuraceCertificateUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	insuraceCertificateUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	policyExpiryDateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	policyExpiryDateMin?: FieldPolicy<any> | FieldReadFunction<any>,
	policyNumberMax?: FieldPolicy<any> | FieldReadFunction<any>,
	policyNumberMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VehicleOwnerKeySpecifier = ('address' | 'district' | 'email' | 'id' | 'name' | 'orgName' | 'phoneNo' | 'pincode' | 'state' | 'tehsil' | VehicleOwnerKeySpecifier)[];
export type VehicleOwnerFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	district?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	orgName?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNo?: FieldPolicy<any> | FieldReadFunction<any>,
	pincode?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	tehsil?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VehicleOwnerAggregateResultKeySpecifier = ('addressMax' | 'addressMin' | 'count' | 'districtMax' | 'districtMin' | 'emailMax' | 'emailMin' | 'nameMax' | 'nameMin' | 'orgNameMax' | 'orgNameMin' | 'phoneNoMax' | 'phoneNoMin' | 'pincodeMax' | 'pincodeMin' | 'stateMax' | 'stateMin' | 'tehsilMax' | 'tehsilMin' | VehicleOwnerAggregateResultKeySpecifier)[];
export type VehicleOwnerAggregateResultFieldPolicy = {
	addressMax?: FieldPolicy<any> | FieldReadFunction<any>,
	addressMin?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	districtMax?: FieldPolicy<any> | FieldReadFunction<any>,
	districtMin?: FieldPolicy<any> | FieldReadFunction<any>,
	emailMax?: FieldPolicy<any> | FieldReadFunction<any>,
	emailMin?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	orgNameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	orgNameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNoMax?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNoMin?: FieldPolicy<any> | FieldReadFunction<any>,
	pincodeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	pincodeMin?: FieldPolicy<any> | FieldReadFunction<any>,
	stateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	stateMin?: FieldPolicy<any> | FieldReadFunction<any>,
	tehsilMax?: FieldPolicy<any> | FieldReadFunction<any>,
	tehsilMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VehicleTransferLogKeySpecifier = ('assignedTo' | 'deliveredOn' | 'from' | 'id' | 'lead' | 'pickupDate' | 'remarks' | 'requestedOn' | 'selfieUrl' | 'status' | 'to' | VehicleTransferLogKeySpecifier)[];
export type VehicleTransferLogFieldPolicy = {
	assignedTo?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveredOn?: FieldPolicy<any> | FieldReadFunction<any>,
	from?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lead?: FieldPolicy<any> | FieldReadFunction<any>,
	pickupDate?: FieldPolicy<any> | FieldReadFunction<any>,
	remarks?: FieldPolicy<any> | FieldReadFunction<any>,
	requestedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	selfieUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	to?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VehicleTransferLogAggregateResultKeySpecifier = ('count' | 'deliveredOnMax' | 'deliveredOnMin' | 'pickupDateMax' | 'pickupDateMin' | 'remarksMax' | 'remarksMin' | 'requestedOnMax' | 'requestedOnMin' | 'selfieUrlMax' | 'selfieUrlMin' | VehicleTransferLogAggregateResultKeySpecifier)[];
export type VehicleTransferLogAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveredOnMax?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveredOnMin?: FieldPolicy<any> | FieldReadFunction<any>,
	pickupDateMax?: FieldPolicy<any> | FieldReadFunction<any>,
	pickupDateMin?: FieldPolicy<any> | FieldReadFunction<any>,
	remarksMax?: FieldPolicy<any> | FieldReadFunction<any>,
	remarksMin?: FieldPolicy<any> | FieldReadFunction<any>,
	requestedOnMax?: FieldPolicy<any> | FieldReadFunction<any>,
	requestedOnMin?: FieldPolicy<any> | FieldReadFunction<any>,
	selfieUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	selfieUrlMin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type YardKeySpecifier = ('address' | 'city' | 'id' | 'leads' | 'leadsAggregate' | 'location' | 'locationUrl' | 'name' | 'perDayParkingCharge' | 'spocName' | 'spocNo' | 'tempPerDayParkingCharge' | YardKeySpecifier)[];
export type YardFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	leads?: FieldPolicy<any> | FieldReadFunction<any>,
	leadsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	locationUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	perDayParkingCharge?: FieldPolicy<any> | FieldReadFunction<any>,
	spocName?: FieldPolicy<any> | FieldReadFunction<any>,
	spocNo?: FieldPolicy<any> | FieldReadFunction<any>,
	tempPerDayParkingCharge?: FieldPolicy<any> | FieldReadFunction<any>
};
export type YardAggregateResultKeySpecifier = ('addressMax' | 'addressMin' | 'cityMax' | 'cityMin' | 'count' | 'locationUrlMax' | 'locationUrlMin' | 'nameMax' | 'nameMin' | 'perDayParkingChargeAvg' | 'perDayParkingChargeMax' | 'perDayParkingChargeMin' | 'perDayParkingChargeSum' | 'spocNameMax' | 'spocNameMin' | 'spocNoMax' | 'spocNoMin' | 'tempPerDayParkingChargeAvg' | 'tempPerDayParkingChargeMax' | 'tempPerDayParkingChargeMin' | 'tempPerDayParkingChargeSum' | YardAggregateResultKeySpecifier)[];
export type YardAggregateResultFieldPolicy = {
	addressMax?: FieldPolicy<any> | FieldReadFunction<any>,
	addressMin?: FieldPolicy<any> | FieldReadFunction<any>,
	cityMax?: FieldPolicy<any> | FieldReadFunction<any>,
	cityMin?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	locationUrlMax?: FieldPolicy<any> | FieldReadFunction<any>,
	locationUrlMin?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	nameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	perDayParkingChargeAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	perDayParkingChargeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	perDayParkingChargeMin?: FieldPolicy<any> | FieldReadFunction<any>,
	perDayParkingChargeSum?: FieldPolicy<any> | FieldReadFunction<any>,
	spocNameMax?: FieldPolicy<any> | FieldReadFunction<any>,
	spocNameMin?: FieldPolicy<any> | FieldReadFunction<any>,
	spocNoMax?: FieldPolicy<any> | FieldReadFunction<any>,
	spocNoMin?: FieldPolicy<any> | FieldReadFunction<any>,
	tempPerDayParkingChargeAvg?: FieldPolicy<any> | FieldReadFunction<any>,
	tempPerDayParkingChargeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	tempPerDayParkingChargeMin?: FieldPolicy<any> | FieldReadFunction<any>,
	tempPerDayParkingChargeSum?: FieldPolicy<any> | FieldReadFunction<any>
};
export type documentsAggregatesResultKeySpecifier = ('documentsCount' | 'leads' | 'leadsAggregate' | documentsAggregatesResultKeySpecifier)[];
export type documentsAggregatesResultFieldPolicy = {
	documentsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	leads?: FieldPolicy<any> | FieldReadFunction<any>,
	leadsAggregate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type documentsAggregatesResultAggregateResultKeySpecifier = ('count' | documentsAggregatesResultAggregateResultKeySpecifier)[];
export type documentsAggregatesResultAggregateResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	AccessoriesCheck?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccessoriesCheckKeySpecifier | (() => undefined | AccessoriesCheckKeySpecifier),
		fields?: AccessoriesCheckFieldPolicy,
	},
	AccessoriesCheckAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccessoriesCheckAggregateResultKeySpecifier | (() => undefined | AccessoriesCheckAggregateResultKeySpecifier),
		fields?: AccessoriesCheckAggregateResultFieldPolicy,
	},
	AccessoriesCheckListWithStage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccessoriesCheckListWithStageKeySpecifier | (() => undefined | AccessoriesCheckListWithStageKeySpecifier),
		fields?: AccessoriesCheckListWithStageFieldPolicy,
	},
	AccessoriesCheckListWithStageAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccessoriesCheckListWithStageAggregateResultKeySpecifier | (() => undefined | AccessoriesCheckListWithStageAggregateResultKeySpecifier),
		fields?: AccessoriesCheckListWithStageAggregateResultFieldPolicy,
	},
	AccessoriesChecklist?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccessoriesChecklistKeySpecifier | (() => undefined | AccessoriesChecklistKeySpecifier),
		fields?: AccessoriesChecklistFieldPolicy,
	},
	AccessoriesChecklistAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccessoriesChecklistAggregateResultKeySpecifier | (() => undefined | AccessoriesChecklistAggregateResultKeySpecifier),
		fields?: AccessoriesChecklistAggregateResultFieldPolicy,
	},
	ActiveStateWithGSTN?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActiveStateWithGSTNKeySpecifier | (() => undefined | ActiveStateWithGSTNKeySpecifier),
		fields?: ActiveStateWithGSTNFieldPolicy,
	},
	ActiveStateWithGSTNAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActiveStateWithGSTNAggregateResultKeySpecifier | (() => undefined | ActiveStateWithGSTNAggregateResultKeySpecifier),
		fields?: ActiveStateWithGSTNAggregateResultFieldPolicy,
	},
	AddAccessoriesCheckListWithStagePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddAccessoriesCheckListWithStagePayloadKeySpecifier | (() => undefined | AddAccessoriesCheckListWithStagePayloadKeySpecifier),
		fields?: AddAccessoriesCheckListWithStagePayloadFieldPolicy,
	},
	AddAccessoriesCheckPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddAccessoriesCheckPayloadKeySpecifier | (() => undefined | AddAccessoriesCheckPayloadKeySpecifier),
		fields?: AddAccessoriesCheckPayloadFieldPolicy,
	},
	AddAccessoriesChecklistPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddAccessoriesChecklistPayloadKeySpecifier | (() => undefined | AddAccessoriesChecklistPayloadKeySpecifier),
		fields?: AddAccessoriesChecklistPayloadFieldPolicy,
	},
	AddActiveStateWithGSTNPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddActiveStateWithGSTNPayloadKeySpecifier | (() => undefined | AddActiveStateWithGSTNPayloadKeySpecifier),
		fields?: AddActiveStateWithGSTNPayloadFieldPolicy,
	},
	AddAdminLeadStatusEventPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddAdminLeadStatusEventPayloadKeySpecifier | (() => undefined | AddAdminLeadStatusEventPayloadKeySpecifier),
		fields?: AddAdminLeadStatusEventPayloadFieldPolicy,
	},
	AddAgencyPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddAgencyPayloadKeySpecifier | (() => undefined | AddAgencyPayloadKeySpecifier),
		fields?: AddAgencyPayloadFieldPolicy,
	},
	AddAuctionHistoryPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddAuctionHistoryPayloadKeySpecifier | (() => undefined | AddAuctionHistoryPayloadKeySpecifier),
		fields?: AddAuctionHistoryPayloadFieldPolicy,
	},
	AddBankAuctionLeadCountByNamePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddBankAuctionLeadCountByNamePayloadKeySpecifier | (() => undefined | AddBankAuctionLeadCountByNamePayloadKeySpecifier),
		fields?: AddBankAuctionLeadCountByNamePayloadFieldPolicy,
	},
	AddBankPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddBankPayloadKeySpecifier | (() => undefined | AddBankPayloadKeySpecifier),
		fields?: AddBankPayloadFieldPolicy,
	},
	AddBookingPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddBookingPayloadKeySpecifier | (() => undefined | AddBookingPayloadKeySpecifier),
		fields?: AddBookingPayloadFieldPolicy,
	},
	AddBookingPaymentPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddBookingPaymentPayloadKeySpecifier | (() => undefined | AddBookingPaymentPayloadKeySpecifier),
		fields?: AddBookingPaymentPayloadFieldPolicy,
	},
	AddBrandPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddBrandPayloadKeySpecifier | (() => undefined | AddBrandPayloadKeySpecifier),
		fields?: AddBrandPayloadFieldPolicy,
	},
	AddBulkApprovalResponsePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddBulkApprovalResponsePayloadKeySpecifier | (() => undefined | AddBulkApprovalResponsePayloadKeySpecifier),
		fields?: AddBulkApprovalResponsePayloadFieldPolicy,
	},
	AddCenterlizeLocationDistrcitsResponsePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddCenterlizeLocationDistrcitsResponsePayloadKeySpecifier | (() => undefined | AddCenterlizeLocationDistrcitsResponsePayloadKeySpecifier),
		fields?: AddCenterlizeLocationDistrcitsResponsePayloadFieldPolicy,
	},
	AddCenterlizeLocationDistrictPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddCenterlizeLocationDistrictPayloadKeySpecifier | (() => undefined | AddCenterlizeLocationDistrictPayloadKeySpecifier),
		fields?: AddCenterlizeLocationDistrictPayloadFieldPolicy,
	},
	AddCenterlizeLocationStatesPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddCenterlizeLocationStatesPayloadKeySpecifier | (() => undefined | AddCenterlizeLocationStatesPayloadKeySpecifier),
		fields?: AddCenterlizeLocationStatesPayloadFieldPolicy,
	},
	AddCenterlizeLocationStatesResponsePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddCenterlizeLocationStatesResponsePayloadKeySpecifier | (() => undefined | AddCenterlizeLocationStatesResponsePayloadKeySpecifier),
		fields?: AddCenterlizeLocationStatesResponsePayloadFieldPolicy,
	},
	AddCenterlizeLocationTehsilPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddCenterlizeLocationTehsilPayloadKeySpecifier | (() => undefined | AddCenterlizeLocationTehsilPayloadKeySpecifier),
		fields?: AddCenterlizeLocationTehsilPayloadFieldPolicy,
	},
	AddCenterlizeLocationTehsilResponsePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddCenterlizeLocationTehsilResponsePayloadKeySpecifier | (() => undefined | AddCenterlizeLocationTehsilResponsePayloadKeySpecifier),
		fields?: AddCenterlizeLocationTehsilResponsePayloadFieldPolicy,
	},
	AddCentreAggregatesPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddCentreAggregatesPayloadKeySpecifier | (() => undefined | AddCentreAggregatesPayloadKeySpecifier),
		fields?: AddCentreAggregatesPayloadFieldPolicy,
	},
	AddCentrePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddCentrePayloadKeySpecifier | (() => undefined | AddCentrePayloadKeySpecifier),
		fields?: AddCentrePayloadFieldPolicy,
	},
	AddCityPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddCityPayloadKeySpecifier | (() => undefined | AddCityPayloadKeySpecifier),
		fields?: AddCityPayloadFieldPolicy,
	},
	AddCreateBulkLeadResponsePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddCreateBulkLeadResponsePayloadKeySpecifier | (() => undefined | AddCreateBulkLeadResponsePayloadKeySpecifier),
		fields?: AddCreateBulkLeadResponsePayloadFieldPolicy,
	},
	AddCustomerPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddCustomerPayloadKeySpecifier | (() => undefined | AddCustomerPayloadKeySpecifier),
		fields?: AddCustomerPayloadFieldPolicy,
	},
	AddDealerPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddDealerPayloadKeySpecifier | (() => undefined | AddDealerPayloadKeySpecifier),
		fields?: AddDealerPayloadFieldPolicy,
	},
	AddDealerStancePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddDealerStancePayloadKeySpecifier | (() => undefined | AddDealerStancePayloadKeySpecifier),
		fields?: AddDealerStancePayloadFieldPolicy,
	},
	AddDealershipDocumentPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddDealershipDocumentPayloadKeySpecifier | (() => undefined | AddDealershipDocumentPayloadKeySpecifier),
		fields?: AddDealershipDocumentPayloadFieldPolicy,
	},
	AddDealershipLeadCountByPENamePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddDealershipLeadCountByPENamePayloadKeySpecifier | (() => undefined | AddDealershipLeadCountByPENamePayloadKeySpecifier),
		fields?: AddDealershipLeadCountByPENamePayloadFieldPolicy,
	},
	AddDistrictPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddDistrictPayloadKeySpecifier | (() => undefined | AddDistrictPayloadKeySpecifier),
		fields?: AddDistrictPayloadFieldPolicy,
	},
	AddDocumentChecklistPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddDocumentChecklistPayloadKeySpecifier | (() => undefined | AddDocumentChecklistPayloadKeySpecifier),
		fields?: AddDocumentChecklistPayloadFieldPolicy,
	},
	AddDocumentPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddDocumentPayloadKeySpecifier | (() => undefined | AddDocumentPayloadKeySpecifier),
		fields?: AddDocumentPayloadFieldPolicy,
	},
	AddDocumentsCountPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddDocumentsCountPayloadKeySpecifier | (() => undefined | AddDocumentsCountPayloadKeySpecifier),
		fields?: AddDocumentsCountPayloadFieldPolicy,
	},
	AddDocumentsFollowupsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddDocumentsFollowupsPayloadKeySpecifier | (() => undefined | AddDocumentsFollowupsPayloadKeySpecifier),
		fields?: AddDocumentsFollowupsPayloadFieldPolicy,
	},
	AddDriverAggregatesPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddDriverAggregatesPayloadKeySpecifier | (() => undefined | AddDriverAggregatesPayloadKeySpecifier),
		fields?: AddDriverAggregatesPayloadFieldPolicy,
	},
	AddEnquiryAdherencePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddEnquiryAdherencePayloadKeySpecifier | (() => undefined | AddEnquiryAdherencePayloadKeySpecifier),
		fields?: AddEnquiryAdherencePayloadFieldPolicy,
	},
	AddEnquiryAggByCentrePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddEnquiryAggByCentrePayloadKeySpecifier | (() => undefined | AddEnquiryAggByCentrePayloadKeySpecifier),
		fields?: AddEnquiryAggByCentrePayloadFieldPolicy,
	},
	AddEnquiryCloserAggPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddEnquiryCloserAggPayloadKeySpecifier | (() => undefined | AddEnquiryCloserAggPayloadKeySpecifier),
		fields?: AddEnquiryCloserAggPayloadFieldPolicy,
	},
	AddEnquiryClosurePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddEnquiryClosurePayloadKeySpecifier | (() => undefined | AddEnquiryClosurePayloadKeySpecifier),
		fields?: AddEnquiryClosurePayloadFieldPolicy,
	},
	AddEnquiryPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddEnquiryPayloadKeySpecifier | (() => undefined | AddEnquiryPayloadKeySpecifier),
		fields?: AddEnquiryPayloadFieldPolicy,
	},
	AddFollowupPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddFollowupPayloadKeySpecifier | (() => undefined | AddFollowupPayloadKeySpecifier),
		fields?: AddFollowupPayloadFieldPolicy,
	},
	AddIdByNamePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddIdByNamePayloadKeySpecifier | (() => undefined | AddIdByNamePayloadKeySpecifier),
		fields?: AddIdByNamePayloadFieldPolicy,
	},
	AddIdentificationDocumentPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddIdentificationDocumentPayloadKeySpecifier | (() => undefined | AddIdentificationDocumentPayloadKeySpecifier),
		fields?: AddIdentificationDocumentPayloadFieldPolicy,
	},
	AddIdsByNameForListingReponsePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddIdsByNameForListingReponsePayloadKeySpecifier | (() => undefined | AddIdsByNameForListingReponsePayloadKeySpecifier),
		fields?: AddIdsByNameForListingReponsePayloadFieldPolicy,
	},
	AddInventoryDetailsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddInventoryDetailsPayloadKeySpecifier | (() => undefined | AddInventoryDetailsPayloadKeySpecifier),
		fields?: AddInventoryDetailsPayloadFieldPolicy,
	},
	AddIssueItemPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddIssueItemPayloadKeySpecifier | (() => undefined | AddIssueItemPayloadKeySpecifier),
		fields?: AddIssueItemPayloadFieldPolicy,
	},
	AddIssuePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddIssuePayloadKeySpecifier | (() => undefined | AddIssuePayloadKeySpecifier),
		fields?: AddIssuePayloadFieldPolicy,
	},
	AddItemInventoryDetailsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddItemInventoryDetailsPayloadKeySpecifier | (() => undefined | AddItemInventoryDetailsPayloadKeySpecifier),
		fields?: AddItemInventoryDetailsPayloadFieldPolicy,
	},
	AddLeadCountByStatusPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddLeadCountByStatusPayloadKeySpecifier | (() => undefined | AddLeadCountByStatusPayloadKeySpecifier),
		fields?: AddLeadCountByStatusPayloadFieldPolicy,
	},
	AddLeadDocumentsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddLeadDocumentsPayloadKeySpecifier | (() => undefined | AddLeadDocumentsPayloadKeySpecifier),
		fields?: AddLeadDocumentsPayloadFieldPolicy,
	},
	AddLeadExpensePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddLeadExpensePayloadKeySpecifier | (() => undefined | AddLeadExpensePayloadKeySpecifier),
		fields?: AddLeadExpensePayloadFieldPolicy,
	},
	AddLeadPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddLeadPayloadKeySpecifier | (() => undefined | AddLeadPayloadKeySpecifier),
		fields?: AddLeadPayloadFieldPolicy,
	},
	AddLeadStatusEventPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddLeadStatusEventPayloadKeySpecifier | (() => undefined | AddLeadStatusEventPayloadKeySpecifier),
		fields?: AddLeadStatusEventPayloadFieldPolicy,
	},
	AddLeadStatusFlowPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddLeadStatusFlowPayloadKeySpecifier | (() => undefined | AddLeadStatusFlowPayloadKeySpecifier),
		fields?: AddLeadStatusFlowPayloadFieldPolicy,
	},
	AddLeadTimelineActionPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddLeadTimelineActionPayloadKeySpecifier | (() => undefined | AddLeadTimelineActionPayloadKeySpecifier),
		fields?: AddLeadTimelineActionPayloadFieldPolicy,
	},
	AddLoanPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddLoanPayloadKeySpecifier | (() => undefined | AddLoanPayloadKeySpecifier),
		fields?: AddLoanPayloadFieldPolicy,
	},
	AddLogTrackingPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddLogTrackingPayloadKeySpecifier | (() => undefined | AddLogTrackingPayloadKeySpecifier),
		fields?: AddLogTrackingPayloadFieldPolicy,
	},
	AddMarkSoldResponsePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddMarkSoldResponsePayloadKeySpecifier | (() => undefined | AddMarkSoldResponsePayloadKeySpecifier),
		fields?: AddMarkSoldResponsePayloadFieldPolicy,
	},
	AddMessagePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddMessagePayloadKeySpecifier | (() => undefined | AddMessagePayloadKeySpecifier),
		fields?: AddMessagePayloadFieldPolicy,
	},
	AddModelByMakePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddModelByMakePayloadKeySpecifier | (() => undefined | AddModelByMakePayloadKeySpecifier),
		fields?: AddModelByMakePayloadFieldPolicy,
	},
	AddModelPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddModelPayloadKeySpecifier | (() => undefined | AddModelPayloadKeySpecifier),
		fields?: AddModelPayloadFieldPolicy,
	},
	AddNotificationPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddNotificationPayloadKeySpecifier | (() => undefined | AddNotificationPayloadKeySpecifier),
		fields?: AddNotificationPayloadFieldPolicy,
	},
	AddNumberOfPendingTasksPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddNumberOfPendingTasksPayloadKeySpecifier | (() => undefined | AddNumberOfPendingTasksPayloadKeySpecifier),
		fields?: AddNumberOfPendingTasksPayloadFieldPolicy,
	},
	AddParkingBeneficiaryPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddParkingBeneficiaryPayloadKeySpecifier | (() => undefined | AddParkingBeneficiaryPayloadKeySpecifier),
		fields?: AddParkingBeneficiaryPayloadFieldPolicy,
	},
	AddPaymentInvoicesPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddPaymentInvoicesPayloadKeySpecifier | (() => undefined | AddPaymentInvoicesPayloadKeySpecifier),
		fields?: AddPaymentInvoicesPayloadFieldPolicy,
	},
	AddPaymentPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddPaymentPayloadKeySpecifier | (() => undefined | AddPaymentPayloadKeySpecifier),
		fields?: AddPaymentPayloadFieldPolicy,
	},
	AddPickupPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddPickupPayloadKeySpecifier | (() => undefined | AddPickupPayloadKeySpecifier),
		fields?: AddPickupPayloadFieldPolicy,
	},
	AddProductPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddProductPayloadKeySpecifier | (() => undefined | AddProductPayloadKeySpecifier),
		fields?: AddProductPayloadFieldPolicy,
	},
	AddPurchaseItemPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddPurchaseItemPayloadKeySpecifier | (() => undefined | AddPurchaseItemPayloadKeySpecifier),
		fields?: AddPurchaseItemPayloadFieldPolicy,
	},
	AddPurchasePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddPurchasePayloadKeySpecifier | (() => undefined | AddPurchasePayloadKeySpecifier),
		fields?: AddPurchasePayloadFieldPolicy,
	},
	AddRefurbishmentBeneficiaryPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddRefurbishmentBeneficiaryPayloadKeySpecifier | (() => undefined | AddRefurbishmentBeneficiaryPayloadKeySpecifier),
		fields?: AddRefurbishmentBeneficiaryPayloadFieldPolicy,
	},
	AddRefurbishmentDetailsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddRefurbishmentDetailsPayloadKeySpecifier | (() => undefined | AddRefurbishmentDetailsPayloadKeySpecifier),
		fields?: AddRefurbishmentDetailsPayloadFieldPolicy,
	},
	AddRefurbishmentItemPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddRefurbishmentItemPayloadKeySpecifier | (() => undefined | AddRefurbishmentItemPayloadKeySpecifier),
		fields?: AddRefurbishmentItemPayloadFieldPolicy,
	},
	AddRefurbishmentRequestPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddRefurbishmentRequestPayloadKeySpecifier | (() => undefined | AddRefurbishmentRequestPayloadKeySpecifier),
		fields?: AddRefurbishmentRequestPayloadFieldPolicy,
	},
	AddSMSLogsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddSMSLogsPayloadKeySpecifier | (() => undefined | AddSMSLogsPayloadKeySpecifier),
		fields?: AddSMSLogsPayloadFieldPolicy,
	},
	AddSendSmsToCustomerResponsePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddSendSmsToCustomerResponsePayloadKeySpecifier | (() => undefined | AddSendSmsToCustomerResponsePayloadKeySpecifier),
		fields?: AddSendSmsToCustomerResponsePayloadFieldPolicy,
	},
	AddStateCodeWithRegNumberPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddStateCodeWithRegNumberPayloadKeySpecifier | (() => undefined | AddStateCodeWithRegNumberPayloadKeySpecifier),
		fields?: AddStateCodeWithRegNumberPayloadFieldPolicy,
	},
	AddStatusAggregatePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddStatusAggregatePayloadKeySpecifier | (() => undefined | AddStatusAggregatePayloadKeySpecifier),
		fields?: AddStatusAggregatePayloadFieldPolicy,
	},
	AddTJCentrePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddTJCentrePayloadKeySpecifier | (() => undefined | AddTJCentrePayloadKeySpecifier),
		fields?: AddTJCentrePayloadFieldPolicy,
	},
	AddTaskPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddTaskPayloadKeySpecifier | (() => undefined | AddTaskPayloadKeySpecifier),
		fields?: AddTaskPayloadFieldPolicy,
	},
	AddTehsilPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddTehsilPayloadKeySpecifier | (() => undefined | AddTehsilPayloadKeySpecifier),
		fields?: AddTehsilPayloadFieldPolicy,
	},
	AddTripExpensePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddTripExpensePayloadKeySpecifier | (() => undefined | AddTripExpensePayloadKeySpecifier),
		fields?: AddTripExpensePayloadFieldPolicy,
	},
	AddUserPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddUserPayloadKeySpecifier | (() => undefined | AddUserPayloadKeySpecifier),
		fields?: AddUserPayloadFieldPolicy,
	},
	AddVehicleDocumentsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddVehicleDocumentsPayloadKeySpecifier | (() => undefined | AddVehicleDocumentsPayloadKeySpecifier),
		fields?: AddVehicleDocumentsPayloadFieldPolicy,
	},
	AddVehicleFinancingPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddVehicleFinancingPayloadKeySpecifier | (() => undefined | AddVehicleFinancingPayloadKeySpecifier),
		fields?: AddVehicleFinancingPayloadFieldPolicy,
	},
	AddVehicleImagesPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddVehicleImagesPayloadKeySpecifier | (() => undefined | AddVehicleImagesPayloadKeySpecifier),
		fields?: AddVehicleImagesPayloadFieldPolicy,
	},
	AddVehicleInsurancePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddVehicleInsurancePayloadKeySpecifier | (() => undefined | AddVehicleInsurancePayloadKeySpecifier),
		fields?: AddVehicleInsurancePayloadFieldPolicy,
	},
	AddVehicleOwnerPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddVehicleOwnerPayloadKeySpecifier | (() => undefined | AddVehicleOwnerPayloadKeySpecifier),
		fields?: AddVehicleOwnerPayloadFieldPolicy,
	},
	AddVehiclePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddVehiclePayloadKeySpecifier | (() => undefined | AddVehiclePayloadKeySpecifier),
		fields?: AddVehiclePayloadFieldPolicy,
	},
	AddVehicleTransferLogPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddVehicleTransferLogPayloadKeySpecifier | (() => undefined | AddVehicleTransferLogPayloadKeySpecifier),
		fields?: AddVehicleTransferLogPayloadFieldPolicy,
	},
	AddYardPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddYardPayloadKeySpecifier | (() => undefined | AddYardPayloadKeySpecifier),
		fields?: AddYardPayloadFieldPolicy,
	},
	AdddocumentsAggregatesResultPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdddocumentsAggregatesResultPayloadKeySpecifier | (() => undefined | AdddocumentsAggregatesResultPayloadKeySpecifier),
		fields?: AdddocumentsAggregatesResultPayloadFieldPolicy,
	},
	AdminLeadStatusEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdminLeadStatusEventKeySpecifier | (() => undefined | AdminLeadStatusEventKeySpecifier),
		fields?: AdminLeadStatusEventFieldPolicy,
	},
	AdminLeadStatusEventAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdminLeadStatusEventAggregateResultKeySpecifier | (() => undefined | AdminLeadStatusEventAggregateResultKeySpecifier),
		fields?: AdminLeadStatusEventAggregateResultFieldPolicy,
	},
	Agency?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AgencyKeySpecifier | (() => undefined | AgencyKeySpecifier),
		fields?: AgencyFieldPolicy,
	},
	AgencyAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AgencyAggregateResultKeySpecifier | (() => undefined | AgencyAggregateResultKeySpecifier),
		fields?: AgencyAggregateResultFieldPolicy,
	},
	AuctionHistory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AuctionHistoryKeySpecifier | (() => undefined | AuctionHistoryKeySpecifier),
		fields?: AuctionHistoryFieldPolicy,
	},
	AuctionHistoryAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AuctionHistoryAggregateResultKeySpecifier | (() => undefined | AuctionHistoryAggregateResultKeySpecifier),
		fields?: AuctionHistoryAggregateResultFieldPolicy,
	},
	Bank?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BankKeySpecifier | (() => undefined | BankKeySpecifier),
		fields?: BankFieldPolicy,
	},
	BankAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BankAggregateResultKeySpecifier | (() => undefined | BankAggregateResultKeySpecifier),
		fields?: BankAggregateResultFieldPolicy,
	},
	BankAuctionLeadCountByName?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BankAuctionLeadCountByNameKeySpecifier | (() => undefined | BankAuctionLeadCountByNameKeySpecifier),
		fields?: BankAuctionLeadCountByNameFieldPolicy,
	},
	BankAuctionLeadCountByNameAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BankAuctionLeadCountByNameAggregateResultKeySpecifier | (() => undefined | BankAuctionLeadCountByNameAggregateResultKeySpecifier),
		fields?: BankAuctionLeadCountByNameAggregateResultFieldPolicy,
	},
	Booking?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BookingKeySpecifier | (() => undefined | BookingKeySpecifier),
		fields?: BookingFieldPolicy,
	},
	BookingAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BookingAggregateResultKeySpecifier | (() => undefined | BookingAggregateResultKeySpecifier),
		fields?: BookingAggregateResultFieldPolicy,
	},
	BookingPayment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BookingPaymentKeySpecifier | (() => undefined | BookingPaymentKeySpecifier),
		fields?: BookingPaymentFieldPolicy,
	},
	BookingPaymentAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BookingPaymentAggregateResultKeySpecifier | (() => undefined | BookingPaymentAggregateResultKeySpecifier),
		fields?: BookingPaymentAggregateResultFieldPolicy,
	},
	Brand?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BrandKeySpecifier | (() => undefined | BrandKeySpecifier),
		fields?: BrandFieldPolicy,
	},
	BrandAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BrandAggregateResultKeySpecifier | (() => undefined | BrandAggregateResultKeySpecifier),
		fields?: BrandAggregateResultFieldPolicy,
	},
	BulkApprovalResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BulkApprovalResponseKeySpecifier | (() => undefined | BulkApprovalResponseKeySpecifier),
		fields?: BulkApprovalResponseFieldPolicy,
	},
	BulkApprovalResponseAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BulkApprovalResponseAggregateResultKeySpecifier | (() => undefined | BulkApprovalResponseAggregateResultKeySpecifier),
		fields?: BulkApprovalResponseAggregateResultFieldPolicy,
	},
	CenterlizeLocationDistrcitsResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CenterlizeLocationDistrcitsResponseKeySpecifier | (() => undefined | CenterlizeLocationDistrcitsResponseKeySpecifier),
		fields?: CenterlizeLocationDistrcitsResponseFieldPolicy,
	},
	CenterlizeLocationDistrcitsResponseAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CenterlizeLocationDistrcitsResponseAggregateResultKeySpecifier | (() => undefined | CenterlizeLocationDistrcitsResponseAggregateResultKeySpecifier),
		fields?: CenterlizeLocationDistrcitsResponseAggregateResultFieldPolicy,
	},
	CenterlizeLocationDistrict?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CenterlizeLocationDistrictKeySpecifier | (() => undefined | CenterlizeLocationDistrictKeySpecifier),
		fields?: CenterlizeLocationDistrictFieldPolicy,
	},
	CenterlizeLocationDistrictAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CenterlizeLocationDistrictAggregateResultKeySpecifier | (() => undefined | CenterlizeLocationDistrictAggregateResultKeySpecifier),
		fields?: CenterlizeLocationDistrictAggregateResultFieldPolicy,
	},
	CenterlizeLocationStates?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CenterlizeLocationStatesKeySpecifier | (() => undefined | CenterlizeLocationStatesKeySpecifier),
		fields?: CenterlizeLocationStatesFieldPolicy,
	},
	CenterlizeLocationStatesAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CenterlizeLocationStatesAggregateResultKeySpecifier | (() => undefined | CenterlizeLocationStatesAggregateResultKeySpecifier),
		fields?: CenterlizeLocationStatesAggregateResultFieldPolicy,
	},
	CenterlizeLocationStatesResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CenterlizeLocationStatesResponseKeySpecifier | (() => undefined | CenterlizeLocationStatesResponseKeySpecifier),
		fields?: CenterlizeLocationStatesResponseFieldPolicy,
	},
	CenterlizeLocationStatesResponseAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CenterlizeLocationStatesResponseAggregateResultKeySpecifier | (() => undefined | CenterlizeLocationStatesResponseAggregateResultKeySpecifier),
		fields?: CenterlizeLocationStatesResponseAggregateResultFieldPolicy,
	},
	CenterlizeLocationTehsil?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CenterlizeLocationTehsilKeySpecifier | (() => undefined | CenterlizeLocationTehsilKeySpecifier),
		fields?: CenterlizeLocationTehsilFieldPolicy,
	},
	CenterlizeLocationTehsilAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CenterlizeLocationTehsilAggregateResultKeySpecifier | (() => undefined | CenterlizeLocationTehsilAggregateResultKeySpecifier),
		fields?: CenterlizeLocationTehsilAggregateResultFieldPolicy,
	},
	CenterlizeLocationTehsilResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CenterlizeLocationTehsilResponseKeySpecifier | (() => undefined | CenterlizeLocationTehsilResponseKeySpecifier),
		fields?: CenterlizeLocationTehsilResponseFieldPolicy,
	},
	CenterlizeLocationTehsilResponseAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CenterlizeLocationTehsilResponseAggregateResultKeySpecifier | (() => undefined | CenterlizeLocationTehsilResponseAggregateResultKeySpecifier),
		fields?: CenterlizeLocationTehsilResponseAggregateResultFieldPolicy,
	},
	Centre?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CentreKeySpecifier | (() => undefined | CentreKeySpecifier),
		fields?: CentreFieldPolicy,
	},
	CentreAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CentreAggregateResultKeySpecifier | (() => undefined | CentreAggregateResultKeySpecifier),
		fields?: CentreAggregateResultFieldPolicy,
	},
	CentreAggregates?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CentreAggregatesKeySpecifier | (() => undefined | CentreAggregatesKeySpecifier),
		fields?: CentreAggregatesFieldPolicy,
	},
	CentreAggregatesAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CentreAggregatesAggregateResultKeySpecifier | (() => undefined | CentreAggregatesAggregateResultKeySpecifier),
		fields?: CentreAggregatesAggregateResultFieldPolicy,
	},
	City?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CityKeySpecifier | (() => undefined | CityKeySpecifier),
		fields?: CityFieldPolicy,
	},
	CityAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CityAggregateResultKeySpecifier | (() => undefined | CityAggregateResultKeySpecifier),
		fields?: CityAggregateResultFieldPolicy,
	},
	CreateBulkLeadResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateBulkLeadResponseKeySpecifier | (() => undefined | CreateBulkLeadResponseKeySpecifier),
		fields?: CreateBulkLeadResponseFieldPolicy,
	},
	CreateBulkLeadResponseAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateBulkLeadResponseAggregateResultKeySpecifier | (() => undefined | CreateBulkLeadResponseAggregateResultKeySpecifier),
		fields?: CreateBulkLeadResponseAggregateResultFieldPolicy,
	},
	Customer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerKeySpecifier | (() => undefined | CustomerKeySpecifier),
		fields?: CustomerFieldPolicy,
	},
	CustomerAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerAggregateResultKeySpecifier | (() => undefined | CustomerAggregateResultKeySpecifier),
		fields?: CustomerAggregateResultFieldPolicy,
	},
	Dealer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DealerKeySpecifier | (() => undefined | DealerKeySpecifier),
		fields?: DealerFieldPolicy,
	},
	DealerAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DealerAggregateResultKeySpecifier | (() => undefined | DealerAggregateResultKeySpecifier),
		fields?: DealerAggregateResultFieldPolicy,
	},
	DealerStance?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DealerStanceKeySpecifier | (() => undefined | DealerStanceKeySpecifier),
		fields?: DealerStanceFieldPolicy,
	},
	DealerStanceAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DealerStanceAggregateResultKeySpecifier | (() => undefined | DealerStanceAggregateResultKeySpecifier),
		fields?: DealerStanceAggregateResultFieldPolicy,
	},
	DealershipDocument?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DealershipDocumentKeySpecifier | (() => undefined | DealershipDocumentKeySpecifier),
		fields?: DealershipDocumentFieldPolicy,
	},
	DealershipDocumentAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DealershipDocumentAggregateResultKeySpecifier | (() => undefined | DealershipDocumentAggregateResultKeySpecifier),
		fields?: DealershipDocumentAggregateResultFieldPolicy,
	},
	DealershipLeadCountByPEName?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DealershipLeadCountByPENameKeySpecifier | (() => undefined | DealershipLeadCountByPENameKeySpecifier),
		fields?: DealershipLeadCountByPENameFieldPolicy,
	},
	DealershipLeadCountByPENameAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DealershipLeadCountByPENameAggregateResultKeySpecifier | (() => undefined | DealershipLeadCountByPENameAggregateResultKeySpecifier),
		fields?: DealershipLeadCountByPENameAggregateResultFieldPolicy,
	},
	DeleteAccessoriesCheckListWithStagePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteAccessoriesCheckListWithStagePayloadKeySpecifier | (() => undefined | DeleteAccessoriesCheckListWithStagePayloadKeySpecifier),
		fields?: DeleteAccessoriesCheckListWithStagePayloadFieldPolicy,
	},
	DeleteAccessoriesCheckPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteAccessoriesCheckPayloadKeySpecifier | (() => undefined | DeleteAccessoriesCheckPayloadKeySpecifier),
		fields?: DeleteAccessoriesCheckPayloadFieldPolicy,
	},
	DeleteAccessoriesChecklistPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteAccessoriesChecklistPayloadKeySpecifier | (() => undefined | DeleteAccessoriesChecklistPayloadKeySpecifier),
		fields?: DeleteAccessoriesChecklistPayloadFieldPolicy,
	},
	DeleteActiveStateWithGSTNPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteActiveStateWithGSTNPayloadKeySpecifier | (() => undefined | DeleteActiveStateWithGSTNPayloadKeySpecifier),
		fields?: DeleteActiveStateWithGSTNPayloadFieldPolicy,
	},
	DeleteAdminLeadStatusEventPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteAdminLeadStatusEventPayloadKeySpecifier | (() => undefined | DeleteAdminLeadStatusEventPayloadKeySpecifier),
		fields?: DeleteAdminLeadStatusEventPayloadFieldPolicy,
	},
	DeleteAgencyPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteAgencyPayloadKeySpecifier | (() => undefined | DeleteAgencyPayloadKeySpecifier),
		fields?: DeleteAgencyPayloadFieldPolicy,
	},
	DeleteAuctionHistoryPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteAuctionHistoryPayloadKeySpecifier | (() => undefined | DeleteAuctionHistoryPayloadKeySpecifier),
		fields?: DeleteAuctionHistoryPayloadFieldPolicy,
	},
	DeleteBankAuctionLeadCountByNamePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteBankAuctionLeadCountByNamePayloadKeySpecifier | (() => undefined | DeleteBankAuctionLeadCountByNamePayloadKeySpecifier),
		fields?: DeleteBankAuctionLeadCountByNamePayloadFieldPolicy,
	},
	DeleteBankPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteBankPayloadKeySpecifier | (() => undefined | DeleteBankPayloadKeySpecifier),
		fields?: DeleteBankPayloadFieldPolicy,
	},
	DeleteBookingPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteBookingPayloadKeySpecifier | (() => undefined | DeleteBookingPayloadKeySpecifier),
		fields?: DeleteBookingPayloadFieldPolicy,
	},
	DeleteBookingPaymentPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteBookingPaymentPayloadKeySpecifier | (() => undefined | DeleteBookingPaymentPayloadKeySpecifier),
		fields?: DeleteBookingPaymentPayloadFieldPolicy,
	},
	DeleteBrandPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteBrandPayloadKeySpecifier | (() => undefined | DeleteBrandPayloadKeySpecifier),
		fields?: DeleteBrandPayloadFieldPolicy,
	},
	DeleteBulkApprovalResponsePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteBulkApprovalResponsePayloadKeySpecifier | (() => undefined | DeleteBulkApprovalResponsePayloadKeySpecifier),
		fields?: DeleteBulkApprovalResponsePayloadFieldPolicy,
	},
	DeleteCenterlizeLocationDistrcitsResponsePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteCenterlizeLocationDistrcitsResponsePayloadKeySpecifier | (() => undefined | DeleteCenterlizeLocationDistrcitsResponsePayloadKeySpecifier),
		fields?: DeleteCenterlizeLocationDistrcitsResponsePayloadFieldPolicy,
	},
	DeleteCenterlizeLocationDistrictPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteCenterlizeLocationDistrictPayloadKeySpecifier | (() => undefined | DeleteCenterlizeLocationDistrictPayloadKeySpecifier),
		fields?: DeleteCenterlizeLocationDistrictPayloadFieldPolicy,
	},
	DeleteCenterlizeLocationStatesPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteCenterlizeLocationStatesPayloadKeySpecifier | (() => undefined | DeleteCenterlizeLocationStatesPayloadKeySpecifier),
		fields?: DeleteCenterlizeLocationStatesPayloadFieldPolicy,
	},
	DeleteCenterlizeLocationStatesResponsePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteCenterlizeLocationStatesResponsePayloadKeySpecifier | (() => undefined | DeleteCenterlizeLocationStatesResponsePayloadKeySpecifier),
		fields?: DeleteCenterlizeLocationStatesResponsePayloadFieldPolicy,
	},
	DeleteCenterlizeLocationTehsilPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteCenterlizeLocationTehsilPayloadKeySpecifier | (() => undefined | DeleteCenterlizeLocationTehsilPayloadKeySpecifier),
		fields?: DeleteCenterlizeLocationTehsilPayloadFieldPolicy,
	},
	DeleteCenterlizeLocationTehsilResponsePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteCenterlizeLocationTehsilResponsePayloadKeySpecifier | (() => undefined | DeleteCenterlizeLocationTehsilResponsePayloadKeySpecifier),
		fields?: DeleteCenterlizeLocationTehsilResponsePayloadFieldPolicy,
	},
	DeleteCentreAggregatesPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteCentreAggregatesPayloadKeySpecifier | (() => undefined | DeleteCentreAggregatesPayloadKeySpecifier),
		fields?: DeleteCentreAggregatesPayloadFieldPolicy,
	},
	DeleteCentrePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteCentrePayloadKeySpecifier | (() => undefined | DeleteCentrePayloadKeySpecifier),
		fields?: DeleteCentrePayloadFieldPolicy,
	},
	DeleteCityPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteCityPayloadKeySpecifier | (() => undefined | DeleteCityPayloadKeySpecifier),
		fields?: DeleteCityPayloadFieldPolicy,
	},
	DeleteCreateBulkLeadResponsePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteCreateBulkLeadResponsePayloadKeySpecifier | (() => undefined | DeleteCreateBulkLeadResponsePayloadKeySpecifier),
		fields?: DeleteCreateBulkLeadResponsePayloadFieldPolicy,
	},
	DeleteCustomerPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteCustomerPayloadKeySpecifier | (() => undefined | DeleteCustomerPayloadKeySpecifier),
		fields?: DeleteCustomerPayloadFieldPolicy,
	},
	DeleteDealerPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteDealerPayloadKeySpecifier | (() => undefined | DeleteDealerPayloadKeySpecifier),
		fields?: DeleteDealerPayloadFieldPolicy,
	},
	DeleteDealerStancePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteDealerStancePayloadKeySpecifier | (() => undefined | DeleteDealerStancePayloadKeySpecifier),
		fields?: DeleteDealerStancePayloadFieldPolicy,
	},
	DeleteDealershipDocumentPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteDealershipDocumentPayloadKeySpecifier | (() => undefined | DeleteDealershipDocumentPayloadKeySpecifier),
		fields?: DeleteDealershipDocumentPayloadFieldPolicy,
	},
	DeleteDealershipLeadCountByPENamePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteDealershipLeadCountByPENamePayloadKeySpecifier | (() => undefined | DeleteDealershipLeadCountByPENamePayloadKeySpecifier),
		fields?: DeleteDealershipLeadCountByPENamePayloadFieldPolicy,
	},
	DeleteDistrictPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteDistrictPayloadKeySpecifier | (() => undefined | DeleteDistrictPayloadKeySpecifier),
		fields?: DeleteDistrictPayloadFieldPolicy,
	},
	DeleteDocumentChecklistPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteDocumentChecklistPayloadKeySpecifier | (() => undefined | DeleteDocumentChecklistPayloadKeySpecifier),
		fields?: DeleteDocumentChecklistPayloadFieldPolicy,
	},
	DeleteDocumentPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteDocumentPayloadKeySpecifier | (() => undefined | DeleteDocumentPayloadKeySpecifier),
		fields?: DeleteDocumentPayloadFieldPolicy,
	},
	DeleteDocumentsCountPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteDocumentsCountPayloadKeySpecifier | (() => undefined | DeleteDocumentsCountPayloadKeySpecifier),
		fields?: DeleteDocumentsCountPayloadFieldPolicy,
	},
	DeleteDocumentsFollowupsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteDocumentsFollowupsPayloadKeySpecifier | (() => undefined | DeleteDocumentsFollowupsPayloadKeySpecifier),
		fields?: DeleteDocumentsFollowupsPayloadFieldPolicy,
	},
	DeleteDriverAggregatesPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteDriverAggregatesPayloadKeySpecifier | (() => undefined | DeleteDriverAggregatesPayloadKeySpecifier),
		fields?: DeleteDriverAggregatesPayloadFieldPolicy,
	},
	DeleteEnquiryAdherencePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteEnquiryAdherencePayloadKeySpecifier | (() => undefined | DeleteEnquiryAdherencePayloadKeySpecifier),
		fields?: DeleteEnquiryAdherencePayloadFieldPolicy,
	},
	DeleteEnquiryAggByCentrePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteEnquiryAggByCentrePayloadKeySpecifier | (() => undefined | DeleteEnquiryAggByCentrePayloadKeySpecifier),
		fields?: DeleteEnquiryAggByCentrePayloadFieldPolicy,
	},
	DeleteEnquiryCloserAggPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteEnquiryCloserAggPayloadKeySpecifier | (() => undefined | DeleteEnquiryCloserAggPayloadKeySpecifier),
		fields?: DeleteEnquiryCloserAggPayloadFieldPolicy,
	},
	DeleteEnquiryClosurePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteEnquiryClosurePayloadKeySpecifier | (() => undefined | DeleteEnquiryClosurePayloadKeySpecifier),
		fields?: DeleteEnquiryClosurePayloadFieldPolicy,
	},
	DeleteEnquiryPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteEnquiryPayloadKeySpecifier | (() => undefined | DeleteEnquiryPayloadKeySpecifier),
		fields?: DeleteEnquiryPayloadFieldPolicy,
	},
	DeleteFollowupPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteFollowupPayloadKeySpecifier | (() => undefined | DeleteFollowupPayloadKeySpecifier),
		fields?: DeleteFollowupPayloadFieldPolicy,
	},
	DeleteIdByNamePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteIdByNamePayloadKeySpecifier | (() => undefined | DeleteIdByNamePayloadKeySpecifier),
		fields?: DeleteIdByNamePayloadFieldPolicy,
	},
	DeleteIdentificationDocumentPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteIdentificationDocumentPayloadKeySpecifier | (() => undefined | DeleteIdentificationDocumentPayloadKeySpecifier),
		fields?: DeleteIdentificationDocumentPayloadFieldPolicy,
	},
	DeleteIdsByNameForListingReponsePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteIdsByNameForListingReponsePayloadKeySpecifier | (() => undefined | DeleteIdsByNameForListingReponsePayloadKeySpecifier),
		fields?: DeleteIdsByNameForListingReponsePayloadFieldPolicy,
	},
	DeleteInventoryDetailsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteInventoryDetailsPayloadKeySpecifier | (() => undefined | DeleteInventoryDetailsPayloadKeySpecifier),
		fields?: DeleteInventoryDetailsPayloadFieldPolicy,
	},
	DeleteIssueItemPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteIssueItemPayloadKeySpecifier | (() => undefined | DeleteIssueItemPayloadKeySpecifier),
		fields?: DeleteIssueItemPayloadFieldPolicy,
	},
	DeleteIssuePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteIssuePayloadKeySpecifier | (() => undefined | DeleteIssuePayloadKeySpecifier),
		fields?: DeleteIssuePayloadFieldPolicy,
	},
	DeleteItemInventoryDetailsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteItemInventoryDetailsPayloadKeySpecifier | (() => undefined | DeleteItemInventoryDetailsPayloadKeySpecifier),
		fields?: DeleteItemInventoryDetailsPayloadFieldPolicy,
	},
	DeleteLeadCountByStatusPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteLeadCountByStatusPayloadKeySpecifier | (() => undefined | DeleteLeadCountByStatusPayloadKeySpecifier),
		fields?: DeleteLeadCountByStatusPayloadFieldPolicy,
	},
	DeleteLeadDocumentsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteLeadDocumentsPayloadKeySpecifier | (() => undefined | DeleteLeadDocumentsPayloadKeySpecifier),
		fields?: DeleteLeadDocumentsPayloadFieldPolicy,
	},
	DeleteLeadExpensePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteLeadExpensePayloadKeySpecifier | (() => undefined | DeleteLeadExpensePayloadKeySpecifier),
		fields?: DeleteLeadExpensePayloadFieldPolicy,
	},
	DeleteLeadPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteLeadPayloadKeySpecifier | (() => undefined | DeleteLeadPayloadKeySpecifier),
		fields?: DeleteLeadPayloadFieldPolicy,
	},
	DeleteLeadStatusEventPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteLeadStatusEventPayloadKeySpecifier | (() => undefined | DeleteLeadStatusEventPayloadKeySpecifier),
		fields?: DeleteLeadStatusEventPayloadFieldPolicy,
	},
	DeleteLeadStatusFlowPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteLeadStatusFlowPayloadKeySpecifier | (() => undefined | DeleteLeadStatusFlowPayloadKeySpecifier),
		fields?: DeleteLeadStatusFlowPayloadFieldPolicy,
	},
	DeleteLeadTimelineActionPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteLeadTimelineActionPayloadKeySpecifier | (() => undefined | DeleteLeadTimelineActionPayloadKeySpecifier),
		fields?: DeleteLeadTimelineActionPayloadFieldPolicy,
	},
	DeleteLeadTimelineStatusPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteLeadTimelineStatusPayloadKeySpecifier | (() => undefined | DeleteLeadTimelineStatusPayloadKeySpecifier),
		fields?: DeleteLeadTimelineStatusPayloadFieldPolicy,
	},
	DeleteLoanPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteLoanPayloadKeySpecifier | (() => undefined | DeleteLoanPayloadKeySpecifier),
		fields?: DeleteLoanPayloadFieldPolicy,
	},
	DeleteLogTrackingPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteLogTrackingPayloadKeySpecifier | (() => undefined | DeleteLogTrackingPayloadKeySpecifier),
		fields?: DeleteLogTrackingPayloadFieldPolicy,
	},
	DeleteMarkSoldResponsePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteMarkSoldResponsePayloadKeySpecifier | (() => undefined | DeleteMarkSoldResponsePayloadKeySpecifier),
		fields?: DeleteMarkSoldResponsePayloadFieldPolicy,
	},
	DeleteMessagePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteMessagePayloadKeySpecifier | (() => undefined | DeleteMessagePayloadKeySpecifier),
		fields?: DeleteMessagePayloadFieldPolicy,
	},
	DeleteModelByMakePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteModelByMakePayloadKeySpecifier | (() => undefined | DeleteModelByMakePayloadKeySpecifier),
		fields?: DeleteModelByMakePayloadFieldPolicy,
	},
	DeleteModelPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteModelPayloadKeySpecifier | (() => undefined | DeleteModelPayloadKeySpecifier),
		fields?: DeleteModelPayloadFieldPolicy,
	},
	DeleteNotificationPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteNotificationPayloadKeySpecifier | (() => undefined | DeleteNotificationPayloadKeySpecifier),
		fields?: DeleteNotificationPayloadFieldPolicy,
	},
	DeleteNumberOfPendingTasksPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteNumberOfPendingTasksPayloadKeySpecifier | (() => undefined | DeleteNumberOfPendingTasksPayloadKeySpecifier),
		fields?: DeleteNumberOfPendingTasksPayloadFieldPolicy,
	},
	DeleteParkingBeneficiaryPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteParkingBeneficiaryPayloadKeySpecifier | (() => undefined | DeleteParkingBeneficiaryPayloadKeySpecifier),
		fields?: DeleteParkingBeneficiaryPayloadFieldPolicy,
	},
	DeletePaymentInvoicesPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeletePaymentInvoicesPayloadKeySpecifier | (() => undefined | DeletePaymentInvoicesPayloadKeySpecifier),
		fields?: DeletePaymentInvoicesPayloadFieldPolicy,
	},
	DeletePaymentPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeletePaymentPayloadKeySpecifier | (() => undefined | DeletePaymentPayloadKeySpecifier),
		fields?: DeletePaymentPayloadFieldPolicy,
	},
	DeletePickupPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeletePickupPayloadKeySpecifier | (() => undefined | DeletePickupPayloadKeySpecifier),
		fields?: DeletePickupPayloadFieldPolicy,
	},
	DeleteProductPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteProductPayloadKeySpecifier | (() => undefined | DeleteProductPayloadKeySpecifier),
		fields?: DeleteProductPayloadFieldPolicy,
	},
	DeletePurchaseItemPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeletePurchaseItemPayloadKeySpecifier | (() => undefined | DeletePurchaseItemPayloadKeySpecifier),
		fields?: DeletePurchaseItemPayloadFieldPolicy,
	},
	DeletePurchasePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeletePurchasePayloadKeySpecifier | (() => undefined | DeletePurchasePayloadKeySpecifier),
		fields?: DeletePurchasePayloadFieldPolicy,
	},
	DeleteRefurbishmentBeneficiaryPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteRefurbishmentBeneficiaryPayloadKeySpecifier | (() => undefined | DeleteRefurbishmentBeneficiaryPayloadKeySpecifier),
		fields?: DeleteRefurbishmentBeneficiaryPayloadFieldPolicy,
	},
	DeleteRefurbishmentDetailsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteRefurbishmentDetailsPayloadKeySpecifier | (() => undefined | DeleteRefurbishmentDetailsPayloadKeySpecifier),
		fields?: DeleteRefurbishmentDetailsPayloadFieldPolicy,
	},
	DeleteRefurbishmentItemPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteRefurbishmentItemPayloadKeySpecifier | (() => undefined | DeleteRefurbishmentItemPayloadKeySpecifier),
		fields?: DeleteRefurbishmentItemPayloadFieldPolicy,
	},
	DeleteRefurbishmentRequestPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteRefurbishmentRequestPayloadKeySpecifier | (() => undefined | DeleteRefurbishmentRequestPayloadKeySpecifier),
		fields?: DeleteRefurbishmentRequestPayloadFieldPolicy,
	},
	DeleteSMSLogsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteSMSLogsPayloadKeySpecifier | (() => undefined | DeleteSMSLogsPayloadKeySpecifier),
		fields?: DeleteSMSLogsPayloadFieldPolicy,
	},
	DeleteSendSmsToCustomerResponsePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteSendSmsToCustomerResponsePayloadKeySpecifier | (() => undefined | DeleteSendSmsToCustomerResponsePayloadKeySpecifier),
		fields?: DeleteSendSmsToCustomerResponsePayloadFieldPolicy,
	},
	DeleteStateCodeWithRegNumberPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteStateCodeWithRegNumberPayloadKeySpecifier | (() => undefined | DeleteStateCodeWithRegNumberPayloadKeySpecifier),
		fields?: DeleteStateCodeWithRegNumberPayloadFieldPolicy,
	},
	DeleteStatusAggregatePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteStatusAggregatePayloadKeySpecifier | (() => undefined | DeleteStatusAggregatePayloadKeySpecifier),
		fields?: DeleteStatusAggregatePayloadFieldPolicy,
	},
	DeleteTJCentrePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteTJCentrePayloadKeySpecifier | (() => undefined | DeleteTJCentrePayloadKeySpecifier),
		fields?: DeleteTJCentrePayloadFieldPolicy,
	},
	DeleteTaskPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteTaskPayloadKeySpecifier | (() => undefined | DeleteTaskPayloadKeySpecifier),
		fields?: DeleteTaskPayloadFieldPolicy,
	},
	DeleteTehsilPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteTehsilPayloadKeySpecifier | (() => undefined | DeleteTehsilPayloadKeySpecifier),
		fields?: DeleteTehsilPayloadFieldPolicy,
	},
	DeleteTripExpensePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteTripExpensePayloadKeySpecifier | (() => undefined | DeleteTripExpensePayloadKeySpecifier),
		fields?: DeleteTripExpensePayloadFieldPolicy,
	},
	DeleteUserPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteUserPayloadKeySpecifier | (() => undefined | DeleteUserPayloadKeySpecifier),
		fields?: DeleteUserPayloadFieldPolicy,
	},
	DeleteVehicleDocumentsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteVehicleDocumentsPayloadKeySpecifier | (() => undefined | DeleteVehicleDocumentsPayloadKeySpecifier),
		fields?: DeleteVehicleDocumentsPayloadFieldPolicy,
	},
	DeleteVehicleFinancingPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteVehicleFinancingPayloadKeySpecifier | (() => undefined | DeleteVehicleFinancingPayloadKeySpecifier),
		fields?: DeleteVehicleFinancingPayloadFieldPolicy,
	},
	DeleteVehicleImagesPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteVehicleImagesPayloadKeySpecifier | (() => undefined | DeleteVehicleImagesPayloadKeySpecifier),
		fields?: DeleteVehicleImagesPayloadFieldPolicy,
	},
	DeleteVehicleInsurancePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteVehicleInsurancePayloadKeySpecifier | (() => undefined | DeleteVehicleInsurancePayloadKeySpecifier),
		fields?: DeleteVehicleInsurancePayloadFieldPolicy,
	},
	DeleteVehicleOwnerPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteVehicleOwnerPayloadKeySpecifier | (() => undefined | DeleteVehicleOwnerPayloadKeySpecifier),
		fields?: DeleteVehicleOwnerPayloadFieldPolicy,
	},
	DeleteVehiclePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteVehiclePayloadKeySpecifier | (() => undefined | DeleteVehiclePayloadKeySpecifier),
		fields?: DeleteVehiclePayloadFieldPolicy,
	},
	DeleteVehicleTransferLogPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteVehicleTransferLogPayloadKeySpecifier | (() => undefined | DeleteVehicleTransferLogPayloadKeySpecifier),
		fields?: DeleteVehicleTransferLogPayloadFieldPolicy,
	},
	DeleteYardPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteYardPayloadKeySpecifier | (() => undefined | DeleteYardPayloadKeySpecifier),
		fields?: DeleteYardPayloadFieldPolicy,
	},
	DeletedocumentsAggregatesResultPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeletedocumentsAggregatesResultPayloadKeySpecifier | (() => undefined | DeletedocumentsAggregatesResultPayloadKeySpecifier),
		fields?: DeletedocumentsAggregatesResultPayloadFieldPolicy,
	},
	District?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DistrictKeySpecifier | (() => undefined | DistrictKeySpecifier),
		fields?: DistrictFieldPolicy,
	},
	DistrictAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DistrictAggregateResultKeySpecifier | (() => undefined | DistrictAggregateResultKeySpecifier),
		fields?: DistrictAggregateResultFieldPolicy,
	},
	Document?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DocumentKeySpecifier | (() => undefined | DocumentKeySpecifier),
		fields?: DocumentFieldPolicy,
	},
	DocumentAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DocumentAggregateResultKeySpecifier | (() => undefined | DocumentAggregateResultKeySpecifier),
		fields?: DocumentAggregateResultFieldPolicy,
	},
	DocumentChecklist?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DocumentChecklistKeySpecifier | (() => undefined | DocumentChecklistKeySpecifier),
		fields?: DocumentChecklistFieldPolicy,
	},
	DocumentChecklistAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DocumentChecklistAggregateResultKeySpecifier | (() => undefined | DocumentChecklistAggregateResultKeySpecifier),
		fields?: DocumentChecklistAggregateResultFieldPolicy,
	},
	DocumentsCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DocumentsCountKeySpecifier | (() => undefined | DocumentsCountKeySpecifier),
		fields?: DocumentsCountFieldPolicy,
	},
	DocumentsCountAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DocumentsCountAggregateResultKeySpecifier | (() => undefined | DocumentsCountAggregateResultKeySpecifier),
		fields?: DocumentsCountAggregateResultFieldPolicy,
	},
	DocumentsFollowups?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DocumentsFollowupsKeySpecifier | (() => undefined | DocumentsFollowupsKeySpecifier),
		fields?: DocumentsFollowupsFieldPolicy,
	},
	DocumentsFollowupsAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DocumentsFollowupsAggregateResultKeySpecifier | (() => undefined | DocumentsFollowupsAggregateResultKeySpecifier),
		fields?: DocumentsFollowupsAggregateResultFieldPolicy,
	},
	DriverAggregates?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DriverAggregatesKeySpecifier | (() => undefined | DriverAggregatesKeySpecifier),
		fields?: DriverAggregatesFieldPolicy,
	},
	DriverAggregatesAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DriverAggregatesAggregateResultKeySpecifier | (() => undefined | DriverAggregatesAggregateResultKeySpecifier),
		fields?: DriverAggregatesAggregateResultFieldPolicy,
	},
	Enquiry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnquiryKeySpecifier | (() => undefined | EnquiryKeySpecifier),
		fields?: EnquiryFieldPolicy,
	},
	EnquiryAdherence?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnquiryAdherenceKeySpecifier | (() => undefined | EnquiryAdherenceKeySpecifier),
		fields?: EnquiryAdherenceFieldPolicy,
	},
	EnquiryAdherenceAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnquiryAdherenceAggregateResultKeySpecifier | (() => undefined | EnquiryAdherenceAggregateResultKeySpecifier),
		fields?: EnquiryAdherenceAggregateResultFieldPolicy,
	},
	EnquiryAggByCentre?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnquiryAggByCentreKeySpecifier | (() => undefined | EnquiryAggByCentreKeySpecifier),
		fields?: EnquiryAggByCentreFieldPolicy,
	},
	EnquiryAggByCentreAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnquiryAggByCentreAggregateResultKeySpecifier | (() => undefined | EnquiryAggByCentreAggregateResultKeySpecifier),
		fields?: EnquiryAggByCentreAggregateResultFieldPolicy,
	},
	EnquiryAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnquiryAggregateResultKeySpecifier | (() => undefined | EnquiryAggregateResultKeySpecifier),
		fields?: EnquiryAggregateResultFieldPolicy,
	},
	EnquiryCloserAgg?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnquiryCloserAggKeySpecifier | (() => undefined | EnquiryCloserAggKeySpecifier),
		fields?: EnquiryCloserAggFieldPolicy,
	},
	EnquiryCloserAggAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnquiryCloserAggAggregateResultKeySpecifier | (() => undefined | EnquiryCloserAggAggregateResultKeySpecifier),
		fields?: EnquiryCloserAggAggregateResultFieldPolicy,
	},
	EnquiryClosure?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnquiryClosureKeySpecifier | (() => undefined | EnquiryClosureKeySpecifier),
		fields?: EnquiryClosureFieldPolicy,
	},
	EnquiryClosureAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnquiryClosureAggregateResultKeySpecifier | (() => undefined | EnquiryClosureAggregateResultKeySpecifier),
		fields?: EnquiryClosureAggregateResultFieldPolicy,
	},
	Followup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FollowupKeySpecifier | (() => undefined | FollowupKeySpecifier),
		fields?: FollowupFieldPolicy,
	},
	FollowupAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FollowupAggregateResultKeySpecifier | (() => undefined | FollowupAggregateResultKeySpecifier),
		fields?: FollowupAggregateResultFieldPolicy,
	},
	IdByName?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IdByNameKeySpecifier | (() => undefined | IdByNameKeySpecifier),
		fields?: IdByNameFieldPolicy,
	},
	IdByNameAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IdByNameAggregateResultKeySpecifier | (() => undefined | IdByNameAggregateResultKeySpecifier),
		fields?: IdByNameAggregateResultFieldPolicy,
	},
	IdentificationDocument?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IdentificationDocumentKeySpecifier | (() => undefined | IdentificationDocumentKeySpecifier),
		fields?: IdentificationDocumentFieldPolicy,
	},
	IdentificationDocumentAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IdentificationDocumentAggregateResultKeySpecifier | (() => undefined | IdentificationDocumentAggregateResultKeySpecifier),
		fields?: IdentificationDocumentAggregateResultFieldPolicy,
	},
	IdsByNameForListingReponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IdsByNameForListingReponseKeySpecifier | (() => undefined | IdsByNameForListingReponseKeySpecifier),
		fields?: IdsByNameForListingReponseFieldPolicy,
	},
	IdsByNameForListingReponseAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IdsByNameForListingReponseAggregateResultKeySpecifier | (() => undefined | IdsByNameForListingReponseAggregateResultKeySpecifier),
		fields?: IdsByNameForListingReponseAggregateResultFieldPolicy,
	},
	InventoryDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InventoryDetailsKeySpecifier | (() => undefined | InventoryDetailsKeySpecifier),
		fields?: InventoryDetailsFieldPolicy,
	},
	InventoryDetailsAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InventoryDetailsAggregateResultKeySpecifier | (() => undefined | InventoryDetailsAggregateResultKeySpecifier),
		fields?: InventoryDetailsAggregateResultFieldPolicy,
	},
	Issue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IssueKeySpecifier | (() => undefined | IssueKeySpecifier),
		fields?: IssueFieldPolicy,
	},
	IssueAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IssueAggregateResultKeySpecifier | (() => undefined | IssueAggregateResultKeySpecifier),
		fields?: IssueAggregateResultFieldPolicy,
	},
	IssueItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IssueItemKeySpecifier | (() => undefined | IssueItemKeySpecifier),
		fields?: IssueItemFieldPolicy,
	},
	IssueItemAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IssueItemAggregateResultKeySpecifier | (() => undefined | IssueItemAggregateResultKeySpecifier),
		fields?: IssueItemAggregateResultFieldPolicy,
	},
	ItemInventoryDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ItemInventoryDetailsKeySpecifier | (() => undefined | ItemInventoryDetailsKeySpecifier),
		fields?: ItemInventoryDetailsFieldPolicy,
	},
	ItemInventoryDetailsAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ItemInventoryDetailsAggregateResultKeySpecifier | (() => undefined | ItemInventoryDetailsAggregateResultKeySpecifier),
		fields?: ItemInventoryDetailsAggregateResultFieldPolicy,
	},
	Lead?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LeadKeySpecifier | (() => undefined | LeadKeySpecifier),
		fields?: LeadFieldPolicy,
	},
	LeadAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LeadAggregateResultKeySpecifier | (() => undefined | LeadAggregateResultKeySpecifier),
		fields?: LeadAggregateResultFieldPolicy,
	},
	LeadCountByStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LeadCountByStatusKeySpecifier | (() => undefined | LeadCountByStatusKeySpecifier),
		fields?: LeadCountByStatusFieldPolicy,
	},
	LeadCountByStatusAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LeadCountByStatusAggregateResultKeySpecifier | (() => undefined | LeadCountByStatusAggregateResultKeySpecifier),
		fields?: LeadCountByStatusAggregateResultFieldPolicy,
	},
	LeadDocuments?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LeadDocumentsKeySpecifier | (() => undefined | LeadDocumentsKeySpecifier),
		fields?: LeadDocumentsFieldPolicy,
	},
	LeadDocumentsAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LeadDocumentsAggregateResultKeySpecifier | (() => undefined | LeadDocumentsAggregateResultKeySpecifier),
		fields?: LeadDocumentsAggregateResultFieldPolicy,
	},
	LeadExpense?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LeadExpenseKeySpecifier | (() => undefined | LeadExpenseKeySpecifier),
		fields?: LeadExpenseFieldPolicy,
	},
	LeadExpenseAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LeadExpenseAggregateResultKeySpecifier | (() => undefined | LeadExpenseAggregateResultKeySpecifier),
		fields?: LeadExpenseAggregateResultFieldPolicy,
	},
	LeadStatusEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LeadStatusEventKeySpecifier | (() => undefined | LeadStatusEventKeySpecifier),
		fields?: LeadStatusEventFieldPolicy,
	},
	LeadStatusEventAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LeadStatusEventAggregateResultKeySpecifier | (() => undefined | LeadStatusEventAggregateResultKeySpecifier),
		fields?: LeadStatusEventAggregateResultFieldPolicy,
	},
	LeadStatusFlow?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LeadStatusFlowKeySpecifier | (() => undefined | LeadStatusFlowKeySpecifier),
		fields?: LeadStatusFlowFieldPolicy,
	},
	LeadStatusFlowAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LeadStatusFlowAggregateResultKeySpecifier | (() => undefined | LeadStatusFlowAggregateResultKeySpecifier),
		fields?: LeadStatusFlowAggregateResultFieldPolicy,
	},
	LeadTimelineAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LeadTimelineActionKeySpecifier | (() => undefined | LeadTimelineActionKeySpecifier),
		fields?: LeadTimelineActionFieldPolicy,
	},
	LeadTimelineActionAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LeadTimelineActionAggregateResultKeySpecifier | (() => undefined | LeadTimelineActionAggregateResultKeySpecifier),
		fields?: LeadTimelineActionAggregateResultFieldPolicy,
	},
	LeadTimelineStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LeadTimelineStatusKeySpecifier | (() => undefined | LeadTimelineStatusKeySpecifier),
		fields?: LeadTimelineStatusFieldPolicy,
	},
	LeadTimelineStatusAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LeadTimelineStatusAggregateResultKeySpecifier | (() => undefined | LeadTimelineStatusAggregateResultKeySpecifier),
		fields?: LeadTimelineStatusAggregateResultFieldPolicy,
	},
	Loan?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LoanKeySpecifier | (() => undefined | LoanKeySpecifier),
		fields?: LoanFieldPolicy,
	},
	LoanAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LoanAggregateResultKeySpecifier | (() => undefined | LoanAggregateResultKeySpecifier),
		fields?: LoanAggregateResultFieldPolicy,
	},
	LogTracking?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LogTrackingKeySpecifier | (() => undefined | LogTrackingKeySpecifier),
		fields?: LogTrackingFieldPolicy,
	},
	LogTrackingAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LogTrackingAggregateResultKeySpecifier | (() => undefined | LogTrackingAggregateResultKeySpecifier),
		fields?: LogTrackingAggregateResultFieldPolicy,
	},
	MarkSoldResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MarkSoldResponseKeySpecifier | (() => undefined | MarkSoldResponseKeySpecifier),
		fields?: MarkSoldResponseFieldPolicy,
	},
	MarkSoldResponseAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MarkSoldResponseAggregateResultKeySpecifier | (() => undefined | MarkSoldResponseAggregateResultKeySpecifier),
		fields?: MarkSoldResponseAggregateResultFieldPolicy,
	},
	Message?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MessageKeySpecifier | (() => undefined | MessageKeySpecifier),
		fields?: MessageFieldPolicy,
	},
	MessageAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MessageAggregateResultKeySpecifier | (() => undefined | MessageAggregateResultKeySpecifier),
		fields?: MessageAggregateResultFieldPolicy,
	},
	Model?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ModelKeySpecifier | (() => undefined | ModelKeySpecifier),
		fields?: ModelFieldPolicy,
	},
	ModelAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ModelAggregateResultKeySpecifier | (() => undefined | ModelAggregateResultKeySpecifier),
		fields?: ModelAggregateResultFieldPolicy,
	},
	ModelByMake?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ModelByMakeKeySpecifier | (() => undefined | ModelByMakeKeySpecifier),
		fields?: ModelByMakeFieldPolicy,
	},
	ModelByMakeAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ModelByMakeAggregateResultKeySpecifier | (() => undefined | ModelByMakeAggregateResultKeySpecifier),
		fields?: ModelByMakeAggregateResultFieldPolicy,
	},
	MultiPolygon?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MultiPolygonKeySpecifier | (() => undefined | MultiPolygonKeySpecifier),
		fields?: MultiPolygonFieldPolicy,
	},
	Mutation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier),
		fields?: MutationFieldPolicy,
	},
	Notification?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationKeySpecifier | (() => undefined | NotificationKeySpecifier),
		fields?: NotificationFieldPolicy,
	},
	NotificationAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationAggregateResultKeySpecifier | (() => undefined | NotificationAggregateResultKeySpecifier),
		fields?: NotificationAggregateResultFieldPolicy,
	},
	NumberOfPendingTasks?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NumberOfPendingTasksKeySpecifier | (() => undefined | NumberOfPendingTasksKeySpecifier),
		fields?: NumberOfPendingTasksFieldPolicy,
	},
	NumberOfPendingTasksAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NumberOfPendingTasksAggregateResultKeySpecifier | (() => undefined | NumberOfPendingTasksAggregateResultKeySpecifier),
		fields?: NumberOfPendingTasksAggregateResultFieldPolicy,
	},
	ParkingBeneficiary?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ParkingBeneficiaryKeySpecifier | (() => undefined | ParkingBeneficiaryKeySpecifier),
		fields?: ParkingBeneficiaryFieldPolicy,
	},
	ParkingBeneficiaryAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ParkingBeneficiaryAggregateResultKeySpecifier | (() => undefined | ParkingBeneficiaryAggregateResultKeySpecifier),
		fields?: ParkingBeneficiaryAggregateResultFieldPolicy,
	},
	Payment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentKeySpecifier | (() => undefined | PaymentKeySpecifier),
		fields?: PaymentFieldPolicy,
	},
	PaymentAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentAggregateResultKeySpecifier | (() => undefined | PaymentAggregateResultKeySpecifier),
		fields?: PaymentAggregateResultFieldPolicy,
	},
	PaymentInvoices?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentInvoicesKeySpecifier | (() => undefined | PaymentInvoicesKeySpecifier),
		fields?: PaymentInvoicesFieldPolicy,
	},
	PaymentInvoicesAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentInvoicesAggregateResultKeySpecifier | (() => undefined | PaymentInvoicesAggregateResultKeySpecifier),
		fields?: PaymentInvoicesAggregateResultFieldPolicy,
	},
	Pickup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PickupKeySpecifier | (() => undefined | PickupKeySpecifier),
		fields?: PickupFieldPolicy,
	},
	PickupAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PickupAggregateResultKeySpecifier | (() => undefined | PickupAggregateResultKeySpecifier),
		fields?: PickupAggregateResultFieldPolicy,
	},
	Point?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PointKeySpecifier | (() => undefined | PointKeySpecifier),
		fields?: PointFieldPolicy,
	},
	PointList?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PointListKeySpecifier | (() => undefined | PointListKeySpecifier),
		fields?: PointListFieldPolicy,
	},
	Polygon?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PolygonKeySpecifier | (() => undefined | PolygonKeySpecifier),
		fields?: PolygonFieldPolicy,
	},
	Product?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductKeySpecifier | (() => undefined | ProductKeySpecifier),
		fields?: ProductFieldPolicy,
	},
	ProductAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductAggregateResultKeySpecifier | (() => undefined | ProductAggregateResultKeySpecifier),
		fields?: ProductAggregateResultFieldPolicy,
	},
	Purchase?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PurchaseKeySpecifier | (() => undefined | PurchaseKeySpecifier),
		fields?: PurchaseFieldPolicy,
	},
	PurchaseAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PurchaseAggregateResultKeySpecifier | (() => undefined | PurchaseAggregateResultKeySpecifier),
		fields?: PurchaseAggregateResultFieldPolicy,
	},
	PurchaseItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PurchaseItemKeySpecifier | (() => undefined | PurchaseItemKeySpecifier),
		fields?: PurchaseItemFieldPolicy,
	},
	PurchaseItemAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PurchaseItemAggregateResultKeySpecifier | (() => undefined | PurchaseItemAggregateResultKeySpecifier),
		fields?: PurchaseItemAggregateResultFieldPolicy,
	},
	Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier),
		fields?: QueryFieldPolicy,
	},
	RefurbishmentBeneficiary?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RefurbishmentBeneficiaryKeySpecifier | (() => undefined | RefurbishmentBeneficiaryKeySpecifier),
		fields?: RefurbishmentBeneficiaryFieldPolicy,
	},
	RefurbishmentBeneficiaryAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RefurbishmentBeneficiaryAggregateResultKeySpecifier | (() => undefined | RefurbishmentBeneficiaryAggregateResultKeySpecifier),
		fields?: RefurbishmentBeneficiaryAggregateResultFieldPolicy,
	},
	RefurbishmentDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RefurbishmentDetailsKeySpecifier | (() => undefined | RefurbishmentDetailsKeySpecifier),
		fields?: RefurbishmentDetailsFieldPolicy,
	},
	RefurbishmentDetailsAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RefurbishmentDetailsAggregateResultKeySpecifier | (() => undefined | RefurbishmentDetailsAggregateResultKeySpecifier),
		fields?: RefurbishmentDetailsAggregateResultFieldPolicy,
	},
	RefurbishmentItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RefurbishmentItemKeySpecifier | (() => undefined | RefurbishmentItemKeySpecifier),
		fields?: RefurbishmentItemFieldPolicy,
	},
	RefurbishmentItemAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RefurbishmentItemAggregateResultKeySpecifier | (() => undefined | RefurbishmentItemAggregateResultKeySpecifier),
		fields?: RefurbishmentItemAggregateResultFieldPolicy,
	},
	RefurbishmentRequest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RefurbishmentRequestKeySpecifier | (() => undefined | RefurbishmentRequestKeySpecifier),
		fields?: RefurbishmentRequestFieldPolicy,
	},
	RefurbishmentRequestAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RefurbishmentRequestAggregateResultKeySpecifier | (() => undefined | RefurbishmentRequestAggregateResultKeySpecifier),
		fields?: RefurbishmentRequestAggregateResultFieldPolicy,
	},
	SMSLogs?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SMSLogsKeySpecifier | (() => undefined | SMSLogsKeySpecifier),
		fields?: SMSLogsFieldPolicy,
	},
	SMSLogsAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SMSLogsAggregateResultKeySpecifier | (() => undefined | SMSLogsAggregateResultKeySpecifier),
		fields?: SMSLogsAggregateResultFieldPolicy,
	},
	SendSmsToCustomerResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SendSmsToCustomerResponseKeySpecifier | (() => undefined | SendSmsToCustomerResponseKeySpecifier),
		fields?: SendSmsToCustomerResponseFieldPolicy,
	},
	SendSmsToCustomerResponseAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SendSmsToCustomerResponseAggregateResultKeySpecifier | (() => undefined | SendSmsToCustomerResponseAggregateResultKeySpecifier),
		fields?: SendSmsToCustomerResponseAggregateResultFieldPolicy,
	},
	StateCodeWithRegNumber?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StateCodeWithRegNumberKeySpecifier | (() => undefined | StateCodeWithRegNumberKeySpecifier),
		fields?: StateCodeWithRegNumberFieldPolicy,
	},
	StateCodeWithRegNumberAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StateCodeWithRegNumberAggregateResultKeySpecifier | (() => undefined | StateCodeWithRegNumberAggregateResultKeySpecifier),
		fields?: StateCodeWithRegNumberAggregateResultFieldPolicy,
	},
	StatusAggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StatusAggregateKeySpecifier | (() => undefined | StatusAggregateKeySpecifier),
		fields?: StatusAggregateFieldPolicy,
	},
	StatusAggregateAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StatusAggregateAggregateResultKeySpecifier | (() => undefined | StatusAggregateAggregateResultKeySpecifier),
		fields?: StatusAggregateAggregateResultFieldPolicy,
	},
	Subscription?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubscriptionKeySpecifier | (() => undefined | SubscriptionKeySpecifier),
		fields?: SubscriptionFieldPolicy,
	},
	TJCentre?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TJCentreKeySpecifier | (() => undefined | TJCentreKeySpecifier),
		fields?: TJCentreFieldPolicy,
	},
	TJCentreAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TJCentreAggregateResultKeySpecifier | (() => undefined | TJCentreAggregateResultKeySpecifier),
		fields?: TJCentreAggregateResultFieldPolicy,
	},
	Task?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskKeySpecifier | (() => undefined | TaskKeySpecifier),
		fields?: TaskFieldPolicy,
	},
	TaskAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskAggregateResultKeySpecifier | (() => undefined | TaskAggregateResultKeySpecifier),
		fields?: TaskAggregateResultFieldPolicy,
	},
	Tehsil?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TehsilKeySpecifier | (() => undefined | TehsilKeySpecifier),
		fields?: TehsilFieldPolicy,
	},
	TehsilAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TehsilAggregateResultKeySpecifier | (() => undefined | TehsilAggregateResultKeySpecifier),
		fields?: TehsilAggregateResultFieldPolicy,
	},
	TripExpense?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TripExpenseKeySpecifier | (() => undefined | TripExpenseKeySpecifier),
		fields?: TripExpenseFieldPolicy,
	},
	TripExpenseAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TripExpenseAggregateResultKeySpecifier | (() => undefined | TripExpenseAggregateResultKeySpecifier),
		fields?: TripExpenseAggregateResultFieldPolicy,
	},
	UpdateAccessoriesCheckListWithStagePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateAccessoriesCheckListWithStagePayloadKeySpecifier | (() => undefined | UpdateAccessoriesCheckListWithStagePayloadKeySpecifier),
		fields?: UpdateAccessoriesCheckListWithStagePayloadFieldPolicy,
	},
	UpdateAccessoriesCheckPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateAccessoriesCheckPayloadKeySpecifier | (() => undefined | UpdateAccessoriesCheckPayloadKeySpecifier),
		fields?: UpdateAccessoriesCheckPayloadFieldPolicy,
	},
	UpdateAccessoriesChecklistPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateAccessoriesChecklistPayloadKeySpecifier | (() => undefined | UpdateAccessoriesChecklistPayloadKeySpecifier),
		fields?: UpdateAccessoriesChecklistPayloadFieldPolicy,
	},
	UpdateActiveStateWithGSTNPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateActiveStateWithGSTNPayloadKeySpecifier | (() => undefined | UpdateActiveStateWithGSTNPayloadKeySpecifier),
		fields?: UpdateActiveStateWithGSTNPayloadFieldPolicy,
	},
	UpdateAdminLeadStatusEventPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateAdminLeadStatusEventPayloadKeySpecifier | (() => undefined | UpdateAdminLeadStatusEventPayloadKeySpecifier),
		fields?: UpdateAdminLeadStatusEventPayloadFieldPolicy,
	},
	UpdateAgencyPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateAgencyPayloadKeySpecifier | (() => undefined | UpdateAgencyPayloadKeySpecifier),
		fields?: UpdateAgencyPayloadFieldPolicy,
	},
	UpdateAuctionHistoryPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateAuctionHistoryPayloadKeySpecifier | (() => undefined | UpdateAuctionHistoryPayloadKeySpecifier),
		fields?: UpdateAuctionHistoryPayloadFieldPolicy,
	},
	UpdateBankAuctionLeadCountByNamePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateBankAuctionLeadCountByNamePayloadKeySpecifier | (() => undefined | UpdateBankAuctionLeadCountByNamePayloadKeySpecifier),
		fields?: UpdateBankAuctionLeadCountByNamePayloadFieldPolicy,
	},
	UpdateBankPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateBankPayloadKeySpecifier | (() => undefined | UpdateBankPayloadKeySpecifier),
		fields?: UpdateBankPayloadFieldPolicy,
	},
	UpdateBookingPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateBookingPayloadKeySpecifier | (() => undefined | UpdateBookingPayloadKeySpecifier),
		fields?: UpdateBookingPayloadFieldPolicy,
	},
	UpdateBookingPaymentPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateBookingPaymentPayloadKeySpecifier | (() => undefined | UpdateBookingPaymentPayloadKeySpecifier),
		fields?: UpdateBookingPaymentPayloadFieldPolicy,
	},
	UpdateBrandPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateBrandPayloadKeySpecifier | (() => undefined | UpdateBrandPayloadKeySpecifier),
		fields?: UpdateBrandPayloadFieldPolicy,
	},
	UpdateBulkApprovalResponsePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateBulkApprovalResponsePayloadKeySpecifier | (() => undefined | UpdateBulkApprovalResponsePayloadKeySpecifier),
		fields?: UpdateBulkApprovalResponsePayloadFieldPolicy,
	},
	UpdateCenterlizeLocationDistrcitsResponsePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateCenterlizeLocationDistrcitsResponsePayloadKeySpecifier | (() => undefined | UpdateCenterlizeLocationDistrcitsResponsePayloadKeySpecifier),
		fields?: UpdateCenterlizeLocationDistrcitsResponsePayloadFieldPolicy,
	},
	UpdateCenterlizeLocationDistrictPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateCenterlizeLocationDistrictPayloadKeySpecifier | (() => undefined | UpdateCenterlizeLocationDistrictPayloadKeySpecifier),
		fields?: UpdateCenterlizeLocationDistrictPayloadFieldPolicy,
	},
	UpdateCenterlizeLocationStatesPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateCenterlizeLocationStatesPayloadKeySpecifier | (() => undefined | UpdateCenterlizeLocationStatesPayloadKeySpecifier),
		fields?: UpdateCenterlizeLocationStatesPayloadFieldPolicy,
	},
	UpdateCenterlizeLocationStatesResponsePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateCenterlizeLocationStatesResponsePayloadKeySpecifier | (() => undefined | UpdateCenterlizeLocationStatesResponsePayloadKeySpecifier),
		fields?: UpdateCenterlizeLocationStatesResponsePayloadFieldPolicy,
	},
	UpdateCenterlizeLocationTehsilPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateCenterlizeLocationTehsilPayloadKeySpecifier | (() => undefined | UpdateCenterlizeLocationTehsilPayloadKeySpecifier),
		fields?: UpdateCenterlizeLocationTehsilPayloadFieldPolicy,
	},
	UpdateCenterlizeLocationTehsilResponsePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateCenterlizeLocationTehsilResponsePayloadKeySpecifier | (() => undefined | UpdateCenterlizeLocationTehsilResponsePayloadKeySpecifier),
		fields?: UpdateCenterlizeLocationTehsilResponsePayloadFieldPolicy,
	},
	UpdateCentreAggregatesPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateCentreAggregatesPayloadKeySpecifier | (() => undefined | UpdateCentreAggregatesPayloadKeySpecifier),
		fields?: UpdateCentreAggregatesPayloadFieldPolicy,
	},
	UpdateCentrePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateCentrePayloadKeySpecifier | (() => undefined | UpdateCentrePayloadKeySpecifier),
		fields?: UpdateCentrePayloadFieldPolicy,
	},
	UpdateCreateBulkLeadResponsePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateCreateBulkLeadResponsePayloadKeySpecifier | (() => undefined | UpdateCreateBulkLeadResponsePayloadKeySpecifier),
		fields?: UpdateCreateBulkLeadResponsePayloadFieldPolicy,
	},
	UpdateCustomerPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateCustomerPayloadKeySpecifier | (() => undefined | UpdateCustomerPayloadKeySpecifier),
		fields?: UpdateCustomerPayloadFieldPolicy,
	},
	UpdateDealerPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateDealerPayloadKeySpecifier | (() => undefined | UpdateDealerPayloadKeySpecifier),
		fields?: UpdateDealerPayloadFieldPolicy,
	},
	UpdateDealerStancePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateDealerStancePayloadKeySpecifier | (() => undefined | UpdateDealerStancePayloadKeySpecifier),
		fields?: UpdateDealerStancePayloadFieldPolicy,
	},
	UpdateDealershipDocumentPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateDealershipDocumentPayloadKeySpecifier | (() => undefined | UpdateDealershipDocumentPayloadKeySpecifier),
		fields?: UpdateDealershipDocumentPayloadFieldPolicy,
	},
	UpdateDealershipLeadCountByPENamePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateDealershipLeadCountByPENamePayloadKeySpecifier | (() => undefined | UpdateDealershipLeadCountByPENamePayloadKeySpecifier),
		fields?: UpdateDealershipLeadCountByPENamePayloadFieldPolicy,
	},
	UpdateDistrictPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateDistrictPayloadKeySpecifier | (() => undefined | UpdateDistrictPayloadKeySpecifier),
		fields?: UpdateDistrictPayloadFieldPolicy,
	},
	UpdateDocumentChecklistPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateDocumentChecklistPayloadKeySpecifier | (() => undefined | UpdateDocumentChecklistPayloadKeySpecifier),
		fields?: UpdateDocumentChecklistPayloadFieldPolicy,
	},
	UpdateDocumentPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateDocumentPayloadKeySpecifier | (() => undefined | UpdateDocumentPayloadKeySpecifier),
		fields?: UpdateDocumentPayloadFieldPolicy,
	},
	UpdateDocumentsCountPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateDocumentsCountPayloadKeySpecifier | (() => undefined | UpdateDocumentsCountPayloadKeySpecifier),
		fields?: UpdateDocumentsCountPayloadFieldPolicy,
	},
	UpdateDocumentsFollowupsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateDocumentsFollowupsPayloadKeySpecifier | (() => undefined | UpdateDocumentsFollowupsPayloadKeySpecifier),
		fields?: UpdateDocumentsFollowupsPayloadFieldPolicy,
	},
	UpdateDriverAggregatesPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateDriverAggregatesPayloadKeySpecifier | (() => undefined | UpdateDriverAggregatesPayloadKeySpecifier),
		fields?: UpdateDriverAggregatesPayloadFieldPolicy,
	},
	UpdateEnquiryAdherencePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateEnquiryAdherencePayloadKeySpecifier | (() => undefined | UpdateEnquiryAdherencePayloadKeySpecifier),
		fields?: UpdateEnquiryAdherencePayloadFieldPolicy,
	},
	UpdateEnquiryAggByCentrePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateEnquiryAggByCentrePayloadKeySpecifier | (() => undefined | UpdateEnquiryAggByCentrePayloadKeySpecifier),
		fields?: UpdateEnquiryAggByCentrePayloadFieldPolicy,
	},
	UpdateEnquiryCloserAggPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateEnquiryCloserAggPayloadKeySpecifier | (() => undefined | UpdateEnquiryCloserAggPayloadKeySpecifier),
		fields?: UpdateEnquiryCloserAggPayloadFieldPolicy,
	},
	UpdateEnquiryClosurePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateEnquiryClosurePayloadKeySpecifier | (() => undefined | UpdateEnquiryClosurePayloadKeySpecifier),
		fields?: UpdateEnquiryClosurePayloadFieldPolicy,
	},
	UpdateEnquiryPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateEnquiryPayloadKeySpecifier | (() => undefined | UpdateEnquiryPayloadKeySpecifier),
		fields?: UpdateEnquiryPayloadFieldPolicy,
	},
	UpdateFollowupPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateFollowupPayloadKeySpecifier | (() => undefined | UpdateFollowupPayloadKeySpecifier),
		fields?: UpdateFollowupPayloadFieldPolicy,
	},
	UpdateIdByNamePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateIdByNamePayloadKeySpecifier | (() => undefined | UpdateIdByNamePayloadKeySpecifier),
		fields?: UpdateIdByNamePayloadFieldPolicy,
	},
	UpdateIdentificationDocumentPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateIdentificationDocumentPayloadKeySpecifier | (() => undefined | UpdateIdentificationDocumentPayloadKeySpecifier),
		fields?: UpdateIdentificationDocumentPayloadFieldPolicy,
	},
	UpdateIdsByNameForListingReponsePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateIdsByNameForListingReponsePayloadKeySpecifier | (() => undefined | UpdateIdsByNameForListingReponsePayloadKeySpecifier),
		fields?: UpdateIdsByNameForListingReponsePayloadFieldPolicy,
	},
	UpdateInventoryDetailsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateInventoryDetailsPayloadKeySpecifier | (() => undefined | UpdateInventoryDetailsPayloadKeySpecifier),
		fields?: UpdateInventoryDetailsPayloadFieldPolicy,
	},
	UpdateIssueItemPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateIssueItemPayloadKeySpecifier | (() => undefined | UpdateIssueItemPayloadKeySpecifier),
		fields?: UpdateIssueItemPayloadFieldPolicy,
	},
	UpdateIssuePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateIssuePayloadKeySpecifier | (() => undefined | UpdateIssuePayloadKeySpecifier),
		fields?: UpdateIssuePayloadFieldPolicy,
	},
	UpdateItemInventoryDetailsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateItemInventoryDetailsPayloadKeySpecifier | (() => undefined | UpdateItemInventoryDetailsPayloadKeySpecifier),
		fields?: UpdateItemInventoryDetailsPayloadFieldPolicy,
	},
	UpdateLeadCountByStatusPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateLeadCountByStatusPayloadKeySpecifier | (() => undefined | UpdateLeadCountByStatusPayloadKeySpecifier),
		fields?: UpdateLeadCountByStatusPayloadFieldPolicy,
	},
	UpdateLeadDocumentsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateLeadDocumentsPayloadKeySpecifier | (() => undefined | UpdateLeadDocumentsPayloadKeySpecifier),
		fields?: UpdateLeadDocumentsPayloadFieldPolicy,
	},
	UpdateLeadExpensePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateLeadExpensePayloadKeySpecifier | (() => undefined | UpdateLeadExpensePayloadKeySpecifier),
		fields?: UpdateLeadExpensePayloadFieldPolicy,
	},
	UpdateLeadPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateLeadPayloadKeySpecifier | (() => undefined | UpdateLeadPayloadKeySpecifier),
		fields?: UpdateLeadPayloadFieldPolicy,
	},
	UpdateLeadStatusEventPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateLeadStatusEventPayloadKeySpecifier | (() => undefined | UpdateLeadStatusEventPayloadKeySpecifier),
		fields?: UpdateLeadStatusEventPayloadFieldPolicy,
	},
	UpdateLeadStatusFlowPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateLeadStatusFlowPayloadKeySpecifier | (() => undefined | UpdateLeadStatusFlowPayloadKeySpecifier),
		fields?: UpdateLeadStatusFlowPayloadFieldPolicy,
	},
	UpdateLeadTimelineActionPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateLeadTimelineActionPayloadKeySpecifier | (() => undefined | UpdateLeadTimelineActionPayloadKeySpecifier),
		fields?: UpdateLeadTimelineActionPayloadFieldPolicy,
	},
	UpdateLeadTimelineStatusPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateLeadTimelineStatusPayloadKeySpecifier | (() => undefined | UpdateLeadTimelineStatusPayloadKeySpecifier),
		fields?: UpdateLeadTimelineStatusPayloadFieldPolicy,
	},
	UpdateLoanPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateLoanPayloadKeySpecifier | (() => undefined | UpdateLoanPayloadKeySpecifier),
		fields?: UpdateLoanPayloadFieldPolicy,
	},
	UpdateLogTrackingPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateLogTrackingPayloadKeySpecifier | (() => undefined | UpdateLogTrackingPayloadKeySpecifier),
		fields?: UpdateLogTrackingPayloadFieldPolicy,
	},
	UpdateMarkSoldResponsePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateMarkSoldResponsePayloadKeySpecifier | (() => undefined | UpdateMarkSoldResponsePayloadKeySpecifier),
		fields?: UpdateMarkSoldResponsePayloadFieldPolicy,
	},
	UpdateMessagePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateMessagePayloadKeySpecifier | (() => undefined | UpdateMessagePayloadKeySpecifier),
		fields?: UpdateMessagePayloadFieldPolicy,
	},
	UpdateModelByMakePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateModelByMakePayloadKeySpecifier | (() => undefined | UpdateModelByMakePayloadKeySpecifier),
		fields?: UpdateModelByMakePayloadFieldPolicy,
	},
	UpdateModelPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateModelPayloadKeySpecifier | (() => undefined | UpdateModelPayloadKeySpecifier),
		fields?: UpdateModelPayloadFieldPolicy,
	},
	UpdateNotificationPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateNotificationPayloadKeySpecifier | (() => undefined | UpdateNotificationPayloadKeySpecifier),
		fields?: UpdateNotificationPayloadFieldPolicy,
	},
	UpdateNumberOfPendingTasksPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateNumberOfPendingTasksPayloadKeySpecifier | (() => undefined | UpdateNumberOfPendingTasksPayloadKeySpecifier),
		fields?: UpdateNumberOfPendingTasksPayloadFieldPolicy,
	},
	UpdateParkingBeneficiaryPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateParkingBeneficiaryPayloadKeySpecifier | (() => undefined | UpdateParkingBeneficiaryPayloadKeySpecifier),
		fields?: UpdateParkingBeneficiaryPayloadFieldPolicy,
	},
	UpdatePaymentInvoicesPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdatePaymentInvoicesPayloadKeySpecifier | (() => undefined | UpdatePaymentInvoicesPayloadKeySpecifier),
		fields?: UpdatePaymentInvoicesPayloadFieldPolicy,
	},
	UpdatePaymentPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdatePaymentPayloadKeySpecifier | (() => undefined | UpdatePaymentPayloadKeySpecifier),
		fields?: UpdatePaymentPayloadFieldPolicy,
	},
	UpdatePickupPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdatePickupPayloadKeySpecifier | (() => undefined | UpdatePickupPayloadKeySpecifier),
		fields?: UpdatePickupPayloadFieldPolicy,
	},
	UpdateProductPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateProductPayloadKeySpecifier | (() => undefined | UpdateProductPayloadKeySpecifier),
		fields?: UpdateProductPayloadFieldPolicy,
	},
	UpdatePurchaseItemPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdatePurchaseItemPayloadKeySpecifier | (() => undefined | UpdatePurchaseItemPayloadKeySpecifier),
		fields?: UpdatePurchaseItemPayloadFieldPolicy,
	},
	UpdatePurchasePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdatePurchasePayloadKeySpecifier | (() => undefined | UpdatePurchasePayloadKeySpecifier),
		fields?: UpdatePurchasePayloadFieldPolicy,
	},
	UpdateRefurbishmentBeneficiaryPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateRefurbishmentBeneficiaryPayloadKeySpecifier | (() => undefined | UpdateRefurbishmentBeneficiaryPayloadKeySpecifier),
		fields?: UpdateRefurbishmentBeneficiaryPayloadFieldPolicy,
	},
	UpdateRefurbishmentDetailsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateRefurbishmentDetailsPayloadKeySpecifier | (() => undefined | UpdateRefurbishmentDetailsPayloadKeySpecifier),
		fields?: UpdateRefurbishmentDetailsPayloadFieldPolicy,
	},
	UpdateRefurbishmentItemPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateRefurbishmentItemPayloadKeySpecifier | (() => undefined | UpdateRefurbishmentItemPayloadKeySpecifier),
		fields?: UpdateRefurbishmentItemPayloadFieldPolicy,
	},
	UpdateRefurbishmentRequestPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateRefurbishmentRequestPayloadKeySpecifier | (() => undefined | UpdateRefurbishmentRequestPayloadKeySpecifier),
		fields?: UpdateRefurbishmentRequestPayloadFieldPolicy,
	},
	UpdateSMSLogsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateSMSLogsPayloadKeySpecifier | (() => undefined | UpdateSMSLogsPayloadKeySpecifier),
		fields?: UpdateSMSLogsPayloadFieldPolicy,
	},
	UpdateSendSmsToCustomerResponsePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateSendSmsToCustomerResponsePayloadKeySpecifier | (() => undefined | UpdateSendSmsToCustomerResponsePayloadKeySpecifier),
		fields?: UpdateSendSmsToCustomerResponsePayloadFieldPolicy,
	},
	UpdateStateCodeWithRegNumberPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateStateCodeWithRegNumberPayloadKeySpecifier | (() => undefined | UpdateStateCodeWithRegNumberPayloadKeySpecifier),
		fields?: UpdateStateCodeWithRegNumberPayloadFieldPolicy,
	},
	UpdateStatusAggregatePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateStatusAggregatePayloadKeySpecifier | (() => undefined | UpdateStatusAggregatePayloadKeySpecifier),
		fields?: UpdateStatusAggregatePayloadFieldPolicy,
	},
	UpdateTJCentrePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateTJCentrePayloadKeySpecifier | (() => undefined | UpdateTJCentrePayloadKeySpecifier),
		fields?: UpdateTJCentrePayloadFieldPolicy,
	},
	UpdateTaskPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateTaskPayloadKeySpecifier | (() => undefined | UpdateTaskPayloadKeySpecifier),
		fields?: UpdateTaskPayloadFieldPolicy,
	},
	UpdateTehsilPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateTehsilPayloadKeySpecifier | (() => undefined | UpdateTehsilPayloadKeySpecifier),
		fields?: UpdateTehsilPayloadFieldPolicy,
	},
	UpdateTripExpensePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateTripExpensePayloadKeySpecifier | (() => undefined | UpdateTripExpensePayloadKeySpecifier),
		fields?: UpdateTripExpensePayloadFieldPolicy,
	},
	UpdateUserPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateUserPayloadKeySpecifier | (() => undefined | UpdateUserPayloadKeySpecifier),
		fields?: UpdateUserPayloadFieldPolicy,
	},
	UpdateVehicleDocumentsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateVehicleDocumentsPayloadKeySpecifier | (() => undefined | UpdateVehicleDocumentsPayloadKeySpecifier),
		fields?: UpdateVehicleDocumentsPayloadFieldPolicy,
	},
	UpdateVehicleFinancingPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateVehicleFinancingPayloadKeySpecifier | (() => undefined | UpdateVehicleFinancingPayloadKeySpecifier),
		fields?: UpdateVehicleFinancingPayloadFieldPolicy,
	},
	UpdateVehicleImagesPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateVehicleImagesPayloadKeySpecifier | (() => undefined | UpdateVehicleImagesPayloadKeySpecifier),
		fields?: UpdateVehicleImagesPayloadFieldPolicy,
	},
	UpdateVehicleInsurancePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateVehicleInsurancePayloadKeySpecifier | (() => undefined | UpdateVehicleInsurancePayloadKeySpecifier),
		fields?: UpdateVehicleInsurancePayloadFieldPolicy,
	},
	UpdateVehicleOwnerPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateVehicleOwnerPayloadKeySpecifier | (() => undefined | UpdateVehicleOwnerPayloadKeySpecifier),
		fields?: UpdateVehicleOwnerPayloadFieldPolicy,
	},
	UpdateVehiclePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateVehiclePayloadKeySpecifier | (() => undefined | UpdateVehiclePayloadKeySpecifier),
		fields?: UpdateVehiclePayloadFieldPolicy,
	},
	UpdateVehicleTransferLogPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateVehicleTransferLogPayloadKeySpecifier | (() => undefined | UpdateVehicleTransferLogPayloadKeySpecifier),
		fields?: UpdateVehicleTransferLogPayloadFieldPolicy,
	},
	UpdateYardPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateYardPayloadKeySpecifier | (() => undefined | UpdateYardPayloadKeySpecifier),
		fields?: UpdateYardPayloadFieldPolicy,
	},
	UpdatedocumentsAggregatesResultPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdatedocumentsAggregatesResultPayloadKeySpecifier | (() => undefined | UpdatedocumentsAggregatesResultPayloadKeySpecifier),
		fields?: UpdatedocumentsAggregatesResultPayloadFieldPolicy,
	},
	User?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserKeySpecifier | (() => undefined | UserKeySpecifier),
		fields?: UserFieldPolicy,
	},
	UserAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserAggregateResultKeySpecifier | (() => undefined | UserAggregateResultKeySpecifier),
		fields?: UserAggregateResultFieldPolicy,
	},
	Vehicle?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VehicleKeySpecifier | (() => undefined | VehicleKeySpecifier),
		fields?: VehicleFieldPolicy,
	},
	VehicleAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VehicleAggregateResultKeySpecifier | (() => undefined | VehicleAggregateResultKeySpecifier),
		fields?: VehicleAggregateResultFieldPolicy,
	},
	VehicleDocuments?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VehicleDocumentsKeySpecifier | (() => undefined | VehicleDocumentsKeySpecifier),
		fields?: VehicleDocumentsFieldPolicy,
	},
	VehicleDocumentsAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VehicleDocumentsAggregateResultKeySpecifier | (() => undefined | VehicleDocumentsAggregateResultKeySpecifier),
		fields?: VehicleDocumentsAggregateResultFieldPolicy,
	},
	VehicleFinancing?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VehicleFinancingKeySpecifier | (() => undefined | VehicleFinancingKeySpecifier),
		fields?: VehicleFinancingFieldPolicy,
	},
	VehicleFinancingAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VehicleFinancingAggregateResultKeySpecifier | (() => undefined | VehicleFinancingAggregateResultKeySpecifier),
		fields?: VehicleFinancingAggregateResultFieldPolicy,
	},
	VehicleImages?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VehicleImagesKeySpecifier | (() => undefined | VehicleImagesKeySpecifier),
		fields?: VehicleImagesFieldPolicy,
	},
	VehicleImagesAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VehicleImagesAggregateResultKeySpecifier | (() => undefined | VehicleImagesAggregateResultKeySpecifier),
		fields?: VehicleImagesAggregateResultFieldPolicy,
	},
	VehicleInsurance?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VehicleInsuranceKeySpecifier | (() => undefined | VehicleInsuranceKeySpecifier),
		fields?: VehicleInsuranceFieldPolicy,
	},
	VehicleInsuranceAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VehicleInsuranceAggregateResultKeySpecifier | (() => undefined | VehicleInsuranceAggregateResultKeySpecifier),
		fields?: VehicleInsuranceAggregateResultFieldPolicy,
	},
	VehicleOwner?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VehicleOwnerKeySpecifier | (() => undefined | VehicleOwnerKeySpecifier),
		fields?: VehicleOwnerFieldPolicy,
	},
	VehicleOwnerAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VehicleOwnerAggregateResultKeySpecifier | (() => undefined | VehicleOwnerAggregateResultKeySpecifier),
		fields?: VehicleOwnerAggregateResultFieldPolicy,
	},
	VehicleTransferLog?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VehicleTransferLogKeySpecifier | (() => undefined | VehicleTransferLogKeySpecifier),
		fields?: VehicleTransferLogFieldPolicy,
	},
	VehicleTransferLogAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VehicleTransferLogAggregateResultKeySpecifier | (() => undefined | VehicleTransferLogAggregateResultKeySpecifier),
		fields?: VehicleTransferLogAggregateResultFieldPolicy,
	},
	Yard?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | YardKeySpecifier | (() => undefined | YardKeySpecifier),
		fields?: YardFieldPolicy,
	},
	YardAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | YardAggregateResultKeySpecifier | (() => undefined | YardAggregateResultKeySpecifier),
		fields?: YardAggregateResultFieldPolicy,
	},
	documentsAggregatesResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | documentsAggregatesResultKeySpecifier | (() => undefined | documentsAggregatesResultKeySpecifier),
		fields?: documentsAggregatesResultFieldPolicy,
	},
	documentsAggregatesResultAggregateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | documentsAggregatesResultAggregateResultKeySpecifier | (() => undefined | documentsAggregatesResultAggregateResultKeySpecifier),
		fields?: documentsAggregatesResultAggregateResultFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;
export type BookingsQueryVariables = Exact<{
  status?: InputMaybe<BookingStatus>;
  name?: InputMaybe<Scalars['String']>;
  phoneNo?: InputMaybe<Scalars['String']>;
  centre?: InputMaybe<Scalars['String']>;
  manufacturingDate?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  districts?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  makes?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  models?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  listingPrice?: InputMaybe<PriceRange>;
  sellingPrice?: InputMaybe<PriceRange>;
  searchString?: InputMaybe<Scalars['String']>;
  purchaseType?: InputMaybe<Scalars['String']>;
  vehicleBrand?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  vehicleModel?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  offset?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
}>;


export type BookingsQuery = { __typename?: 'Query', filteredBookings?: Array<{ __typename?: 'Booking', id: string, status?: BookingStatus, createdAt?: any, updatedAt?: any, customer: { __typename?: 'Customer', name?: string, phoneNo: string, customerDistrict?: { __typename?: 'District', name: string }, customerState?: { __typename?: 'StateCodeWithRegNumber', state: string } }, payments?: Array<{ __typename?: 'Payment', for: PaymentFor, amount?: number }>, bookingPayment?: { __typename?: 'BookingPayment', id: string, bookingType?: BookingType, saleAmount: number, booking: { __typename?: 'Booking', id: string } }, activeLoan?: { __typename?: 'Loan', id: string, fieldInspectionDate?: any, loginDate?: any, deliveryOrderDate?: any, appliedLoanAmount?: number, createdAt?: any }, leadWithActiveBooking?: { __typename?: 'Lead', regNo: string, sellingPrice?: number, listingPrice?: number, centre?: { __typename?: 'Centre', name: string }, vehicle: { __typename?: 'Vehicle', manufacturingDate?: any, vehicleBrand?: { __typename?: 'Brand', name: string }, vehicleModel?: { __typename?: 'Model', name: string } } }, leadWithArchivedBooking?: { __typename?: 'Lead', regNo: string, sellingPrice?: number, listingPrice?: number, centre?: { __typename?: 'Centre', name: string }, vehicle: { __typename?: 'Vehicle', manufacturingDate?: any, vehicleBrand?: { __typename?: 'Brand', name: string }, vehicleModel?: { __typename?: 'Model', name: string } } } }> };

export type GetBookingQueryVariables = Exact<{
  id: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetBookingQuery = { __typename?: 'Query', queryBooking?: Array<{ __typename?: 'Booking', id: string, customer: { __typename?: 'Customer', name?: string, phoneNo: string }, bookingPayment?: { __typename?: 'BookingPayment', id: string, saleAmount: number, booking: { __typename?: 'Booking', id: string } }, activeLoan?: { __typename?: 'Loan', id: string, fieldInspectionDate?: any, loginDate?: any, deliveryOrderDate?: any, appliedLoanAmount?: number, createdAt?: any, fieldInspectionConfirmedDate?: any } }> };

export type UpdateCenterInchargeMutationVariables = Exact<{
  id?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  inchargeId?: InputMaybe<Scalars['ID']>;
}>;


export type UpdateCenterInchargeMutation = { __typename?: 'Mutation', updateCentre?: { __typename?: 'UpdateCentrePayload', numUids?: number, centre?: Array<{ __typename?: 'Centre', id: string, incharge?: { __typename?: 'User', id: string, name: string, email: string } }> } };

export type GetCentreQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCentreQuery = { __typename?: 'Query', queryCentre?: Array<{ __typename?: 'Centre', id: string, incharge?: { __typename?: 'User', id: string, name: string, email: string } }> };

export type UpdateActiveBookingSaleAmountMutationVariables = Exact<{
  id: Array<Scalars['ID']> | Scalars['ID'];
  saleAmount?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateActiveBookingSaleAmountMutation = { __typename?: 'Mutation', updateBookingPayment?: { __typename?: 'UpdateBookingPaymentPayload', bookingPayment?: Array<{ __typename?: 'BookingPayment', id: string, saleAmount: number }> } };

export type UpdateLoanMutationVariables = Exact<{
  id: Array<Scalars['ID']> | Scalars['ID'];
  appliedLoanAmount?: InputMaybe<Scalars['Int']>;
  deliveryOrderDate?: InputMaybe<Scalars['DateTime']>;
  fieldInspectionDate?: InputMaybe<Scalars['DateTime']>;
  loginDate?: InputMaybe<Scalars['DateTime']>;
  fieldInspectionConfirmedDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type UpdateLoanMutation = { __typename?: 'Mutation', updateLoan?: { __typename?: 'UpdateLoanPayload', loan?: Array<{ __typename?: 'Loan', id: string, fieldInspectionDate?: any, deliveryOrderDate?: any, appliedLoanAmount?: number, loginDate?: any, fieldInspectionConfirmedDate?: any }> } };

export type GetCentreListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCentreListQuery = { __typename?: 'Query', queryCentre?: Array<{ __typename?: 'Centre', id: string, name: string }> };

export type GetModelByBrandIdQueryVariables = Exact<{
  brand_id?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
}>;


export type GetModelByBrandIdQuery = { __typename?: 'Query', queryBrand?: Array<{ __typename?: 'Brand', models?: Array<{ __typename?: 'Model', model_id: number, name: string, id: string, brand: { __typename?: 'Brand', brand_id: number } }> }> };

export type GetPurchaseItemQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPurchaseItemQuery = { __typename?: 'Query', queryPurchaseItem?: Array<{ __typename?: 'PurchaseItem', id: string, type?: string }> };

export type GetModelListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetModelListQuery = { __typename?: 'Query', queryVehicle?: Array<{ __typename?: 'Vehicle', id: string, manufacturingDate?: any, vehicleModel?: { __typename?: 'Model', name: string } }> };

export type GetDistrictListQueryVariables = Exact<{
  state?: InputMaybe<Scalars['String']>;
}>;


export type GetDistrictListQuery = { __typename?: 'Query', queryStateCodeWithRegNumber?: Array<{ __typename?: 'StateCodeWithRegNumber', id: string, state: string, districts?: Array<{ __typename?: 'District', id: string, name: string }> }> };

export type CreateBulkLeadsQueryVariables = Exact<{
  userId: Scalars['String'];
  leads: Array<BulkLeadInput> | BulkLeadInput;
}>;


export type CreateBulkLeadsQuery = { __typename?: 'Query', createBulkLeads?: Array<{ __typename?: 'CreateBulkLeadResponse', regNo?: string, status?: string, make?: string, model?: string, source?: string, auctionByBank?: string, engineNumber?: string, chassisNumber?: string, ownershipType?: string, registrationState?: string, email?: string, hoursMeter?: string, demandAmount?: string, manufacturingDate?: string, remark?: string, processingStatus?: string, failureReason?: string }> };

export type LeadsForBulkApprovalQueryVariables = Exact<{
  leads: Array<BulkApprovalInput> | BulkApprovalInput;
  createdBy: Scalars['String'];
}>;


export type LeadsForBulkApprovalQuery = { __typename?: 'Query', bulkApproval?: Array<{ __typename?: 'BulkApprovalResponse', bidStatus?: string, source?: string, finalBidAmount?: number, proposedBidAmount?: number, processingStatus?: string, failureReason?: string, bankConfirmationStatus?: string, email?: string, regNo?: string }> };

export type LeadCountByStatusQueryVariables = Exact<{
  start?: InputMaybe<Scalars['DateTime']>;
  end?: InputMaybe<Scalars['DateTime']>;
  regState?: InputMaybe<Scalars['String']>;
}>;


export type LeadCountByStatusQuery = { __typename?: 'Query', leadCountsByStatus?: Array<{ __typename?: 'LeadCountByStatus', count?: number, status?: LeadStatus }> };

export type DealershipLeadCountByPeNameQueryVariables = Exact<{
  start?: InputMaybe<Scalars['DateTime']>;
  end?: InputMaybe<Scalars['DateTime']>;
  regState?: InputMaybe<Scalars['String']>;
}>;


export type DealershipLeadCountByPeNameQuery = { __typename?: 'Query', dealershipLeadCountByPEName?: Array<{ __typename?: 'DealershipLeadCountByPEName', userId?: string, name?: string, dealClosedCount?: string, leadCreatedCount?: string, priceRecivedCount?: string }> };

export type BankAuctionLeadCountByNameQueryVariables = Exact<{
  start?: InputMaybe<Scalars['DateTime']>;
  end?: InputMaybe<Scalars['DateTime']>;
  regState?: InputMaybe<Scalars['String']>;
}>;


export type BankAuctionLeadCountByNameQuery = { __typename?: 'Query', bankAuctionLeadCountByName?: Array<{ __typename?: 'BankAuctionLeadCountByName', bankName?: string, vahanChecked?: string, vehicleInAuction?: string, approvalRecived?: string, wonInAuction?: string }> };

export type GetBookingAndProcurementQueryVariables = Exact<{
  regState?: InputMaybe<Scalars['String']>;
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
}>;


export type GetBookingAndProcurementQuery = { __typename?: 'Query', queryLead?: Array<{ __typename?: 'Lead', id: string, regNo: string, finalBidAmount?: number, finalParkingCharges?: number, approvedDealAmount?: number, vehicle: { __typename?: 'Vehicle', make?: VehicleMake, model?: string, vehicleBrand?: { __typename?: 'Brand', name: string }, vehicleModel?: { __typename?: 'Model', name: string } }, activeBooking?: { __typename?: 'Booking', id: string, customer: { __typename?: 'Customer', id: string, name?: string }, bookingPayment?: { __typename?: 'BookingPayment', saleAmount: number } } }> };

export type GetRtoStatsQueryVariables = Exact<{
  regState?: InputMaybe<Scalars['String']>;
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
}>;


export type GetRtoStatsQuery = { __typename?: 'Query', queryLead?: Array<{ __typename?: 'Lead', regNo: string, statusEvents?: Array<{ __typename?: 'LeadStatusEvent', status: LeadStatus }> }> };

export type GetDriverReportQueryVariables = Exact<{
  start?: InputMaybe<Scalars['DateTime']>;
  end?: InputMaybe<Scalars['DateTime']>;
  regState?: InputMaybe<Scalars['String']>;
}>;


export type GetDriverReportQuery = { __typename?: 'Query', driverData?: Array<{ __typename?: 'DriverAggregates', id?: string, driverName?: string, assignedPickupsCount?: number, assignedPickupsRejectedOrWithdrawnCount?: number, assignedPickupsAcceptedCount?: number, assignedPickupsInTransitCount?: number, assignedPickupsDeliveredCount?: number }> };

export type GetLogisticFunnelStatsQueryVariables = Exact<{
  start: Scalars['DateTime'];
  end: Scalars['DateTime'];
  regState?: InputMaybe<Scalars['String']>;
}>;


export type GetLogisticFunnelStatsQuery = { __typename?: 'Query', queryLead?: Array<{ __typename?: 'Lead', pickup?: { __typename?: 'Pickup', by?: { __typename?: 'User', id: string, name: string } }, statusEvents?: Array<{ __typename?: 'LeadStatusEvent', status: LeadStatus }> }> };

export type GetCentreAggregatesQueryVariables = Exact<{
  start?: InputMaybe<Scalars['DateTime']>;
  end?: InputMaybe<Scalars['DateTime']>;
  regState?: InputMaybe<Scalars['String']>;
}>;


export type GetCentreAggregatesQuery = { __typename?: 'Query', centreAggregatesData?: Array<{ __typename?: 'CentreAggregates', centreId?: string, centreName?: string, inStockVehiclesCount?: number, bookedVehiclesCount?: number, soldAndDeliveredVehicleCount?: number, totalInventory?: number }> };

export type GetAllEnquiriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllEnquiriesQuery = { __typename?: 'Query', queryEnquiry?: Array<{ __typename?: 'Enquiry', id: string, isClosed?: boolean, createdAt: any, updatedAt?: any, status?: EnquiryStatus, customer: { __typename?: 'Customer', id: string, name?: string, phoneNo: string }, enquiryClosure?: { __typename?: 'EnquiryClosure', enquiryCloseReason?: CloseEnquiryReason, remarks?: string }, followups?: Array<{ __typename?: 'Followup', id: string, followupDate: any, status?: EnquiryStatus, followedUpBy: { __typename?: 'User', id: string, name: string, email: string }, enquiry: { __typename?: 'Enquiry', id: string } }>, followupsAggregate?: { __typename?: 'FollowupAggregateResult', count?: number }, centre: { __typename?: 'Centre', id: string, name: string } }> };

export type ExportEnquiriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ExportEnquiriesQuery = { __typename?: 'Query', queryEnquiry?: Array<{ __typename?: 'Enquiry', id: string, isClosed?: boolean, createdAt: any, lastVisitDate?: any, tentativePurchaseTime?: TentativePurchaseTime, budget?: number, status?: EnquiryStatus, updatedAt?: any, enquiryType?: EnquiryType, customer: { __typename?: 'Customer', name?: string, phoneNo: string, state?: string, district?: string, tehsil?: string, customerState?: { __typename?: 'StateCodeWithRegNumber', state: string }, customerDistrict?: { __typename?: 'District', name: string }, customerTehsil?: { __typename?: 'Tehsil', name: string } }, followups?: Array<{ __typename?: 'Followup', nextFollowup?: { __typename?: 'Followup', followupDate: any } }>, enquiryClosure?: { __typename?: 'EnquiryClosure', enquiryCloseReason?: CloseEnquiryReason }, interestedIn?: Array<{ __typename?: 'Model', id: string, name: string, brand: { __typename?: 'Brand', name: string } }>, centre: { __typename?: 'Centre', name: string }, followupsAggregate?: { __typename?: 'FollowupAggregateResult', count?: number }, createdBy?: { __typename?: 'User', createdAt?: any } }> };

export type GetEnquiriesQueryVariables = Exact<{
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
}>;


export type GetEnquiriesQuery = { __typename?: 'Query', queryEnquiry?: Array<{ __typename?: 'Enquiry', id: string, status?: EnquiryStatus, isClosed?: boolean, updatedAt?: any, enquiryClosure?: { __typename?: 'EnquiryClosure', remarks?: string, enquiryCloseReason?: CloseEnquiryReason } }> };

export type GetDetailEnquiriesQueryVariables = Exact<{
  centre?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  districts?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  tehsils?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  makes?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  models?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  isClosed?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<EnquiryStatus>;
  type?: InputMaybe<EnquiryType>;
  dateType?: InputMaybe<SelectTypeOfDate>;
  start?: InputMaybe<Scalars['DateTime']>;
  end?: InputMaybe<Scalars['DateTime']>;
  search?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
}>;


export type GetDetailEnquiriesQuery = { __typename?: 'Query', filteredEnquiry?: Array<{ __typename?: 'Enquiry', id: string, searchString?: string, isClosed?: boolean, createdAt: any, lastVisitDate?: any, tentativePurchaseTime?: TentativePurchaseTime, budget?: number, status?: EnquiryStatus, updatedAt?: any, enquiryType?: EnquiryType, enquiryClosure?: { __typename?: 'EnquiryClosure', remarks?: string, enquiryCloseReason?: CloseEnquiryReason }, customer: { __typename?: 'Customer', name?: string, phoneNo: string, state?: string, district?: string, tehsil?: string, customerState?: { __typename?: 'StateCodeWithRegNumber', state: string }, customerDistrict?: { __typename?: 'District', name: string }, customerTehsil?: { __typename?: 'Tehsil', name: string } }, followups?: Array<{ __typename?: 'Followup', id: string, remarks?: string, followupDate: any, nextFollowup?: { __typename?: 'Followup', followupDate: any } }>, interestedIn?: Array<{ __typename?: 'Model', id: string, name: string, brand: { __typename?: 'Brand', name: string } }>, centre: { __typename?: 'Centre', name: string }, followupsAggregate?: { __typename?: 'FollowupAggregateResult', count?: number }, createdBy?: { __typename?: 'User', name: string, createdAt?: any } }> };

export type EnquiryFilterQueryVariables = Exact<{
  id: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type EnquiryFilterQuery = { __typename?: 'Query', queryEnquiry?: Array<{ __typename?: 'Enquiry', id: string, isClosed?: boolean, lastVisitDate?: any, createdAt: any, tentativePurchaseTime?: TentativePurchaseTime, budget?: number, status?: EnquiryStatus, updatedAt?: any, enquiryType?: EnquiryType, enquiryClosure?: { __typename?: 'EnquiryClosure', remarks?: string, enquiryCloseReason?: CloseEnquiryReason }, customer: { __typename?: 'Customer', name?: string, phoneNo: string, state?: string, district?: string, tehsil?: string, customerState?: { __typename?: 'StateCodeWithRegNumber', state: string }, customerDistrict?: { __typename?: 'District', name: string }, customerTehsil?: { __typename?: 'Tehsil', name: string } }, interestedIn?: Array<{ __typename?: 'Model', id: string, name: string, brand: { __typename?: 'Brand', name: string } }>, followups?: Array<{ __typename?: 'Followup', followupDate: any, nextFollowup?: { __typename?: 'Followup', followupDate: any } }>, centre: { __typename?: 'Centre', name: string }, followupsAggregate?: { __typename?: 'FollowupAggregateResult', count?: number }, createdBy?: { __typename?: 'User', name: string, createdAt?: any } }> };

export type GetTimeQueryVariables = Exact<{
  id: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetTimeQuery = { __typename?: 'Query', queryEnquiry?: Array<{ __typename?: 'Enquiry', id: string, enquiryType?: EnquiryType, isClosed?: boolean, createdAt: any, status?: EnquiryStatus, enquiryClosure?: { __typename?: 'EnquiryClosure', remarks?: string, enquiryCloseReason?: CloseEnquiryReason }, createdBy?: { __typename?: 'User', name: string, createdAt?: any }, followups?: Array<{ __typename?: 'Followup', id: string, status?: EnquiryStatus, followupDate: any, remarks?: string, isWalkin?: boolean, followedUpBy: { __typename?: 'User', id: string, name: string }, nextFollowup?: { __typename?: 'Followup', id: string, followupDate: any, status?: EnquiryStatus, remarks?: string } }> }> };

export type GetTehsilsQueryVariables = Exact<{
  districtId: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetTehsilsQuery = { __typename?: 'Query', queryDistrict?: Array<{ __typename?: 'District', id: string, name: string, code?: string, tehsils?: Array<{ __typename?: 'Tehsil', id: string, name: string, stateId?: string, distId?: string }> }> };

export type FilteredEnquiryQueryVariables = Exact<{
  state?: InputMaybe<Scalars['String']>;
  districts?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  tehsils?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  makes?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  models?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  isClosed?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<EnquiryStatus>;
  type?: InputMaybe<EnquiryType>;
  dateType?: InputMaybe<SelectTypeOfDate>;
  start?: InputMaybe<Scalars['DateTime']>;
  end?: InputMaybe<Scalars['DateTime']>;
  offset?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
}>;


export type FilteredEnquiryQuery = { __typename?: 'Query', filteredEnquiry?: Array<{ __typename?: 'Enquiry', id: string, isClosed?: boolean, createdAt: any, lastVisitDate?: any, budget?: number, status?: EnquiryStatus, updatedAt?: any, enquiryType?: EnquiryType, enquiryClosure?: { __typename?: 'EnquiryClosure', remarks?: string, enquiryCloseReason?: CloseEnquiryReason }, customer: { __typename?: 'Customer', name?: string, phoneNo: string, state?: string, district?: string, tehsil?: string, customerState?: { __typename?: 'StateCodeWithRegNumber', state: string }, customerDistrict?: { __typename?: 'District', name: string }, customerTehsil?: { __typename?: 'Tehsil', name: string } }, followups?: Array<{ __typename?: 'Followup', nextFollowup?: { __typename?: 'Followup', followupDate: any } }>, centre: { __typename?: 'Centre', name: string }, followupsAggregate?: { __typename?: 'FollowupAggregateResult', count?: number }, createdBy?: { __typename?: 'User', name: string, createdAt?: any } }> };

export type EnquiryByCentreQueryVariables = Exact<{
  start?: InputMaybe<Scalars['DateTime']>;
  end?: InputMaybe<Scalars['DateTime']>;
  key?: InputMaybe<Scalars['String']>;
}>;


export type EnquiryByCentreQuery = { __typename?: 'Query', enquiryAggrigateByCentre?: Array<{ __typename?: 'EnquiryAggByCentre', totalCold?: number, totalHot?: number, totalWarm?: number, centre?: { __typename?: 'Centre', id: string, name: string }, hotEnquiryCloser?: { __typename?: 'EnquiryCloserAgg', closed?: number, infollowUp?: number, notIntrested?: number, notResponding?: number, purchasedUsedTractor?: number, purchaseNewTractor?: number, tractorBooked?: number }, coldEnquiryCloser?: { __typename?: 'EnquiryCloserAgg', closed?: number, infollowUp?: number, notIntrested?: number, notResponding?: number, purchasedUsedTractor?: number, purchaseNewTractor?: number, tractorBooked?: number }, warmEnquiryCloser?: { __typename?: 'EnquiryCloserAgg', closed?: number, infollowUp?: number, notIntrested?: number, notResponding?: number, purchasedUsedTractor?: number, purchaseNewTractor?: number, tractorBooked?: number } }> };

export type FollowupAdherenceQueryVariables = Exact<{
  start?: InputMaybe<Scalars['DateTime']>;
  end?: InputMaybe<Scalars['DateTime']>;
  key?: InputMaybe<Scalars['String']>;
}>;


export type FollowupAdherenceQuery = { __typename?: 'Query', enquiryFollowupAdderence?: Array<{ __typename?: 'EnquiryAdherence', AvgAging?: number, totalEnquiry?: number, totalOpen?: number, totalClosed?: number, totalFollowups?: number, closedFollowups?: number, AdhirenceRatio?: number, centre?: { __typename?: 'Centre', id: string, name: string } }> };

export type EnquiryDashboardExportQueryVariables = Exact<{ [key: string]: never; }>;


export type EnquiryDashboardExportQuery = { __typename?: 'Query', queryEnquiry?: Array<{ __typename?: 'Enquiry', id: string, followups?: Array<{ __typename?: 'Followup', id: string, followupDate: any, nextFollowup?: { __typename?: 'Followup', followupDate: any } }>, customer: { __typename?: 'Customer', name?: string, phoneNo: string, customerDistrict?: { __typename?: 'District', name: string }, customerState?: { __typename?: 'StateCodeWithRegNumber', state: string } } }> };

export type EnquiryDashboardListQueryVariables = Exact<{
  dateType?: InputMaybe<SelectTypeOfDate>;
  start?: InputMaybe<Scalars['DateTime']>;
  end?: InputMaybe<Scalars['DateTime']>;
  centreId?: InputMaybe<Scalars['String']>;
}>;


export type EnquiryDashboardListQuery = { __typename?: 'Query', filteredEnquiry?: Array<{ __typename?: 'Enquiry', id: string, isClosed?: boolean, createdAt: any, lastVisitDate?: any, budget?: number, status?: EnquiryStatus, updatedAt?: any, enquiryType?: EnquiryType, customer: { __typename?: 'Customer', name?: string, phoneNo: string, state?: string, district?: string, tehsil?: string, customerState?: { __typename?: 'StateCodeWithRegNumber', state: string }, customerDistrict?: { __typename?: 'District', name: string }, customerTehsil?: { __typename?: 'Tehsil', name: string } }, centre: { __typename?: 'Centre', name: string }, followupsAggregate?: { __typename?: 'FollowupAggregateResult', count?: number }, createdBy?: { __typename?: 'User', name: string, createdAt?: any } }> };

export type GetLeadFilterResultsQueryVariables = Exact<{
  statuses?: InputMaybe<Array<InputMaybe<LeadStatus>> | InputMaybe<LeadStatus>>;
  dealStatus?: InputMaybe<DealStatus>;
  bankConfirmationStatus?: InputMaybe<BankConfirmationStatus>;
  registrationState?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  makes?: InputMaybe<Array<InputMaybe<VehicleMake>> | InputMaybe<VehicleMake>>;
  models?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  purchaseYearsRange?: InputMaybe<DateRange>;
  auctioningAgencyName?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  sourcedBankName?: InputMaybe<Array<InputMaybe<BankName>> | InputMaybe<BankName>>;
  repositionDateRange?: InputMaybe<DateRange>;
  pickupDateRange?: InputMaybe<DateRange>;
  driverName?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  centreName?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  paymentStatus?: InputMaybe<Array<InputMaybe<PaymentStatus>> | InputMaybe<PaymentStatus>>;
  isRcAvailable?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetLeadFilterResultsQuery = { __typename?: 'Query', filteredLeads?: Array<{ __typename?: 'Lead', id: string, regNo: string, source?: LeadSource, finalBidAmount?: number, createdAt?: any, createdBy?: { __typename?: 'User', name: string }, deliveryCentre?: { __typename?: 'Centre', name: string }, centre?: { __typename?: 'Centre', name: string }, vehicle: { __typename?: 'Vehicle', id: string, manufacturingDate?: any, vehicleBrand?: { __typename?: 'Brand', name: string }, vehicleModel?: { __typename?: 'Model', name: string } }, statusEvents?: Array<{ __typename?: 'LeadStatusEvent', id: string, status: LeadStatus, metadata?: string, deviceType?: DeviceType, assignTaskTo?: UserRole, notifyTo?: Array<UserRole>, taskButtonTitle?: string, taskTitle?: string, createdAt: any, postTimeline?: string, isTaskCompleted?: boolean, preTimeline?: string, remarks?: string, createdBy: { __typename?: 'User', id: string, name: string } }> }> };

export type ModelbyMakeQueryVariables = Exact<{
  make?: InputMaybe<Scalars['String']>;
}>;


export type ModelbyMakeQuery = { __typename?: 'Query', queryModelByMake?: Array<{ __typename?: 'ModelByMake', model?: string }> };

export type AddFollowupsMutationVariables = Exact<{
  regNo?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  documentName?: InputMaybe<Scalars['String']>;
  updatedBy?: InputMaybe<Scalars['ID']>;
  followupDate?: InputMaybe<Scalars['DateTime']>;
  nextFollowupDate?: InputMaybe<Scalars['DateTime']>;
  actionType?: InputMaybe<ActionType>;
  source?: InputMaybe<Scalars['String']>;
}>;


export type AddFollowupsMutation = { __typename?: 'Mutation', updateLead?: { __typename?: 'UpdateLeadPayload', lead?: Array<{ __typename?: 'Lead', documentsFollowups?: Array<{ __typename?: 'DocumentsFollowups', id: string }> }> } };

export type DocumentRequiredMutationVariables = Exact<{
  checklistPatch: Array<AddDocumentChecklistInput> | AddDocumentChecklistInput;
}>;


export type DocumentRequiredMutation = { __typename?: 'Mutation', addDocumentChecklist?: { __typename?: 'AddDocumentChecklistPayload', documentChecklist?: Array<{ __typename?: 'DocumentChecklist', id: string }> } };

export type AddDocumentsMutationVariables = Exact<{
  addLeadDocuments: Array<AddLeadDocumentsInput> | AddLeadDocumentsInput;
}>;


export type AddDocumentsMutation = { __typename?: 'Mutation', addLeadDocuments?: { __typename?: 'AddLeadDocumentsPayload', leadDocuments?: Array<{ __typename?: 'LeadDocuments', form26?: string }> } };

export type GetAllCenterQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCenterQuery = { __typename?: 'Query', queryCentre?: Array<{ __typename?: 'Centre', id: string, name: string, address?: string, state?: string, pincode?: number, city?: string, createdAt?: any, updatedAt?: any, status?: CenterStatus, leads?: Array<{ __typename?: 'Lead', regNo: string, statusEvents?: Array<{ __typename?: 'LeadStatusEvent', id: string }> }>, employees?: Array<{ __typename?: 'User', name: string }>, incharge?: { __typename?: 'User', name: string } }> };

export type GetCentreDataFromTjQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCentreDataFromTjQuery = { __typename?: 'Query', getCentreDataFromTJ?: Array<{ __typename?: 'Centre', id: string, name: string, address?: string, state?: string, pincode?: number, city?: string, createdAt?: any, updatedAt?: any, status?: CenterStatus, leads?: Array<{ __typename?: 'Lead', regNo: string, statusEvents?: Array<{ __typename?: 'LeadStatusEvent', id: string }> }>, employees?: Array<{ __typename?: 'User', name: string }>, incharge?: { __typename?: 'User', name: string } }> };

export type GetStateWithGstinQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStateWithGstinQuery = { __typename?: 'Query', queryActiveStateWithGSTN?: Array<{ __typename?: 'ActiveStateWithGSTN', id: string, GSTNumber?: string, active?: boolean, state: string, createdAt?: any, updatedAt?: any }> };

export type GetStateWithGstinForUpdateQueryVariables = Exact<{
  id: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetStateWithGstinForUpdateQuery = { __typename?: 'Query', queryActiveStateWithGSTN?: Array<{ __typename?: 'ActiveStateWithGSTN', id: string, GSTNumber?: string, active?: boolean, state: string }> };

export type AddStateWithGstnMutationVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  GSTNumber?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
}>;


export type AddStateWithGstnMutation = { __typename?: 'Mutation', addActiveStateWithGSTN?: { __typename?: 'AddActiveStateWithGSTNPayload', activeStateWithGSTN?: Array<{ __typename?: 'ActiveStateWithGSTN', active?: boolean, GSTNumber?: string, state: string }> } };

export type UpdateActiveStateWithGstnMutationVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  GSTNumber?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  updatedAt: Scalars['DateTime'];
}>;


export type UpdateActiveStateWithGstnMutation = { __typename?: 'Mutation', updateActiveStateWithGSTN?: { __typename?: 'UpdateActiveStateWithGSTNPayload', activeStateWithGSTN?: Array<{ __typename?: 'ActiveStateWithGSTN', active?: boolean, GSTNumber?: string, RTOCode?: string }> } };

export type GetAllActiveStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllActiveStateQuery = { __typename?: 'Query', getStateInfo?: { __typename?: 'CenterlizeLocationStatesResponse', data?: Array<{ __typename?: 'CenterlizeLocationStates', state_id?: number, state_name?: string, tr_state_id?: number }> } };

export type GetAllActiveStateListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllActiveStateListQuery = { __typename?: 'Query', getStateInfo?: { __typename?: 'CenterlizeLocationStatesResponse', data?: Array<{ __typename?: 'CenterlizeLocationStates', state_id?: number, state_name?: string, tr_state_id?: number }> } };

export type GetCenterDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCenterDetailsQuery = { __typename?: 'Query', getCentre?: { __typename?: 'Centre', name: string, id: string, address?: string, pincode?: number, state?: string, city?: string, capacity?: number, createdAt?: any, updatedAt?: any, status?: CenterStatus, incharge?: { __typename?: 'User', name: string, phoneNo?: string, email: string }, leads?: Array<{ __typename?: 'Lead', regNo: string, centre?: { __typename?: 'Centre', name: string }, statusEvents?: Array<{ __typename?: 'LeadStatusEvent', id: string }> }>, location?: { __typename?: 'Point', latitude: number, longitude: number } } };

export type GetCentrePurchaseAndIssuesQueryVariables = Exact<{
  centreId: Scalars['ID'];
  productId: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetCentrePurchaseAndIssuesQuery = { __typename?: 'Query', getCentre?: { __typename?: 'Centre', issues?: Array<{ __typename?: 'Issue', id: string, status?: IssueStatus, regNo?: string, createdAt: any, centre: { __typename?: 'Centre', id: string, name: string }, madeBy: { __typename?: 'User', id: string, name: string }, items?: Array<{ __typename?: 'IssueItem', id: string, price?: number, quantity?: number, product: { __typename?: 'Product', name: string, id: string } }> }>, purchases?: Array<{ __typename?: 'Purchase', id: string, status?: PurchaseStatus, invoiceUrl?: string, createdAt: any, centre: { __typename?: 'Centre', id: string, name: string }, madeBy: { __typename?: 'User', id: string, name: string }, items?: Array<{ __typename?: 'PurchaseItem', id: string, price?: number, quantity?: number, product: { __typename?: 'Product', name: string, id: string } }> }> } };

export type CenterPreviewFragment = { __typename?: 'Centre', id: string, name: string, address?: string, state?: string, pincode?: number, city?: string, createdAt?: any, updatedAt?: any, status?: CenterStatus, leads?: Array<{ __typename?: 'Lead', regNo: string, statusEvents?: Array<{ __typename?: 'LeadStatusEvent', id: string }> }>, employees?: Array<{ __typename?: 'User', name: string }>, incharge?: { __typename?: 'User', name: string } };

export type AddStocksMutationVariables = Exact<{
  centreId: Scalars['ID'];
  items?: InputMaybe<Array<InputMaybe<PurchaseItemRef>> | InputMaybe<PurchaseItemRef>>;
  madeById: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  status: PurchaseStatus;
  invoiceUrl?: InputMaybe<Scalars['String']>;
}>;


export type AddStocksMutation = { __typename?: 'Mutation', addPurchase?: { __typename?: 'AddPurchasePayload', purchase?: Array<{ __typename?: 'Purchase', id: string, invoiceUrl?: string, centre: { __typename?: 'Centre', id: string, name: string }, items?: Array<{ __typename?: 'PurchaseItem', id: string, product: { __typename?: 'Product', id: string, name: string, variant?: string } }> }> } };

export type AddIssueStocksMutationVariables = Exact<{
  centreId: Scalars['ID'];
  items?: InputMaybe<Array<InputMaybe<IssueItemRef>> | InputMaybe<IssueItemRef>>;
  madeById: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  status: IssueStatus;
}>;


export type AddIssueStocksMutation = { __typename?: 'Mutation', addIssue?: { __typename?: 'AddIssuePayload', issue?: Array<{ __typename?: 'Issue', id: string, centre: { __typename?: 'Centre', id: string, name: string }, items?: Array<{ __typename?: 'IssueItem', id: string, product: { __typename?: 'Product', id: string, name: string, variant?: string } }> }> } };

export type GetStocksDetailsQueryVariables = Exact<{
  centreId?: InputMaybe<Scalars['ID']>;
}>;


export type GetStocksDetailsQuery = { __typename?: 'Query', inventoryDetails?: { __typename?: 'InventoryDetails', items?: Array<{ __typename?: 'ItemInventoryDetails', availableInStock?: number, avgUnitPrice?: string, consumed?: number, createdAt?: any, id: string, totalPurchase?: number, totalPrice?: number, purchaseQueue?: number, product?: { __typename?: 'Product', id: string, name: string } }> } };

export type GetStocksIndividualQueryVariables = Exact<{
  centreId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['String']>;
}>;


export type GetStocksIndividualQuery = { __typename?: 'Query', inventoryDetails?: { __typename?: 'InventoryDetails', items?: Array<{ __typename?: 'ItemInventoryDetails', availableInStock?: number, avgUnitPrice?: string, consumed?: number, issueQueue?: number, createdAt?: any, id: string, totalPurchase?: number, totalPrice?: number, purchaseQueue?: number, product?: { __typename?: 'Product', id: string, name: string } }> } };

export type CheckDuplicateCenterQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type CheckDuplicateCenterQuery = { __typename?: 'Query', queryCentre?: Array<{ __typename?: 'Centre', name: string }> };

export type StockLeadsQueryVariables = Exact<{
  centerName?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<LeadStatus>;
}>;


export type StockLeadsQuery = { __typename?: 'Query', filteredLeads?: Array<{ __typename?: 'Lead', id: string, regNo: string, source?: LeadSource, createdAt?: any, updatedAt?: any, vehicle: { __typename?: 'Vehicle', make?: VehicleMake, model?: string, manufacturingDate?: any, vehicleBrand?: { __typename?: 'Brand', name: string }, vehicleModel?: { __typename?: 'Model', name: string } }, statusEvents?: Array<{ __typename?: 'LeadStatusEvent', status: LeadStatus, assignTaskTo?: UserRole, createdAt: any }>, createdBy?: { __typename?: 'User', name: string }, centre?: { __typename?: 'Centre', id: string, name: string }, deliveryCentre?: { __typename?: 'Centre', name: string } }> };

export type CenterDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CenterDetailsQuery = { __typename?: 'Query', getCentre?: { __typename?: 'Centre', id: string, name: string, pincode?: number, city?: string, status?: CenterStatus, updatedAt?: any, state?: string, location?: { __typename?: 'Point', longitude: number, latitude: number }, incharge?: { __typename?: 'User', name: string, email: string, phoneNo?: string } } };

export type AddInventoryCentreMutationVariables = Exact<{
  name: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
  pincode?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<CenterStatus>;
  lat: Scalars['Float'];
  long: Scalars['Float'];
  city?: InputMaybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  email: Scalars['String'];
}>;


export type AddInventoryCentreMutation = { __typename?: 'Mutation', addCentre?: { __typename?: 'AddCentrePayload', centre?: Array<{ __typename?: 'Centre', name: string, pincode?: number, state?: string, city?: string, status?: CenterStatus, createdAt?: any, updatedAt?: any, location?: { __typename?: 'Point', latitude: number, longitude: number }, incharge?: { __typename?: 'User', name: string, email: string, phoneNo?: string } }> } };

export type CenterUpdateMutationVariables = Exact<{
  id?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  lat: Scalars['Float'];
  long: Scalars['Float'];
  pincode?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<CenterStatus>;
  updatedAt: Scalars['DateTime'];
  name?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  phoneNo?: InputMaybe<Scalars['String']>;
}>;


export type CenterUpdateMutation = { __typename?: 'Mutation', updateCentre?: { __typename?: 'UpdateCentrePayload', numUids?: number, centre?: Array<{ __typename?: 'Centre', id: string, name: string, pincode?: number, state?: string, city?: string, status?: CenterStatus, updatedAt?: any, incharge?: { __typename?: 'User', name: string, email: string, phoneNo?: string } }> } };

export type GetCenterUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCenterUserQuery = { __typename?: 'Query', queryUser?: Array<{ __typename?: 'User', email: string, name: string, phoneNo?: string }> };

export type GetUserforUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserforUserQuery = { __typename?: 'Query', queryUser?: Array<{ __typename?: 'User', name: string, id: string, registrationState?: Array<string>, email: string, role?: UserRole, isActive?: boolean, centre?: { __typename?: 'Centre', id: string, name: string }, reportingManager?: { __typename?: 'User', name: string, email: string, role?: UserRole } }> };

export type GetUserEmailQueryVariables = Exact<{
  id: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetUserEmailQuery = { __typename?: 'Query', queryUser?: Array<{ __typename?: 'User', id: string, name: string, role?: UserRole, email: string, createdAt?: any, isActive?: boolean, registrationState?: Array<string>, updatedAt?: any, reportingManager?: { __typename?: 'User', name: string, id: string, email: string }, centre?: { __typename?: 'Centre', id: string, name: string, incharge?: { __typename?: 'User', id: string, email: string, name: string } } }> };

export type GenerateInvoiceMutationVariables = Exact<{
  invoicePatch: Array<AddPaymentInvoicesInput> | AddPaymentInvoicesInput;
}>;


export type GenerateInvoiceMutation = { __typename?: 'Mutation', addPaymentInvoices?: { __typename?: 'AddPaymentInvoicesPayload', paymentInvoices?: Array<{ __typename?: 'PaymentInvoices', id?: string, GSTNumber?: string, lead: { __typename?: 'Lead', id: string }, payment?: { __typename?: 'Payment', id: string } }> } };

export type GetGsTforinvoiceQueryVariables = Exact<{
  state?: InputMaybe<Scalars['String']>;
}>;


export type GetGsTforinvoiceQuery = { __typename?: 'Query', queryActiveStateWithGSTN?: Array<{ __typename?: 'ActiveStateWithGSTN', GSTNumber?: string }> };

export type UpdateLeadPaymentInvoiceMutationVariables = Exact<{
  paymentId: Array<Scalars['ID']> | Scalars['ID'];
  invoiceId?: InputMaybe<Scalars['ID']>;
}>;


export type UpdateLeadPaymentInvoiceMutation = { __typename?: 'Mutation', updatePayment?: { __typename?: 'UpdatePaymentPayload', payment?: Array<{ __typename?: 'Payment', invoice?: { __typename?: 'PaymentInvoices', id?: string } }> } };

export type InvoiceDetailsQueryVariables = Exact<{
  id: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type InvoiceDetailsQuery = { __typename?: 'Query', queryPaymentInvoices?: Array<{ __typename?: 'PaymentInvoices', id?: string, GSTNumber?: string, serialNo: string, customerName?: string, customerNumber?: string, payment?: { __typename?: 'Payment', amount?: number, accountHolderName?: string, accountNo?: string, bankName?: BankName, mode?: PaymentMethod, ifsc?: string, createdAt: any }, lead: { __typename?: 'Lead', regNo: string, activeBooking?: { __typename?: 'Booking', isInsuranceReq?: boolean, isRCTransferReq?: boolean, bookingPayment?: { __typename?: 'BookingPayment', saleAmount: number, rcTransferAmount?: number, insuranceAmount?: number } }, vehicle: { __typename?: 'Vehicle', manufacturingDate?: any, vehicleBrand?: { __typename?: 'Brand', name: string }, vehicleModel?: { __typename?: 'Model', name: string } } } }> };

export type GetInvoiceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetInvoiceQuery = { __typename?: 'Query', getLead?: { __typename?: 'Lead', activeBooking?: { __typename?: 'Booking', customer: { __typename?: 'Customer', name?: string, phoneNo: string }, payments?: Array<{ __typename?: 'Payment', id: string, accountHolderName?: string, receiptUrl?: string, accountNo?: string, amount?: number, for: PaymentFor, invoice?: { __typename?: 'PaymentInvoices', id?: string, GSTNumber?: string, invoiceId: string } }> } } };

export type GetLeadsForGridQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type GetLeadsForGridQuery = { __typename?: 'Query', queryLead?: Array<{ __typename?: 'Lead', id: string, regNo: string, source?: LeadSource, finalBidAmount?: number, createdAt?: any, createdBy?: { __typename?: 'User', name: string }, deliveryCentre?: { __typename?: 'Centre', name: string }, centre?: { __typename?: 'Centre', name: string }, vehicle: { __typename?: 'Vehicle', id: string, manufacturingDate?: any, vehicleBrand?: { __typename?: 'Brand', name: string }, vehicleModel?: { __typename?: 'Model', name: string } }, statusEvents?: Array<{ __typename?: 'LeadStatusEvent', id: string, status: LeadStatus, metadata?: string, deviceType?: DeviceType, assignTaskTo?: UserRole, notifyTo?: Array<UserRole>, taskButtonTitle?: string, taskTitle?: string, createdAt: any, postTimeline?: string, isTaskCompleted?: boolean, preTimeline?: string, remarks?: string, createdBy: { __typename?: 'User', id: string, name: string } }> }> };

export type LeadListFilterQueryQueryVariables = Exact<{
  regState?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Array<InputMaybe<VehicleMake>> | InputMaybe<VehicleMake>>;
  model?: InputMaybe<Scalars['String']>;
  isRcAvailable?: InputMaybe<Scalars['Boolean']>;
  sourceBank?: InputMaybe<BankName>;
  centerName?: InputMaybe<Scalars['String']>;
  agencyName?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  driverName?: InputMaybe<Scalars['String']>;
  leadCascade?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type LeadListFilterQueryQuery = { __typename?: 'Query', queryLead?: Array<{ __typename?: 'Lead', id: string, regNo: string, registrationState?: string, auctionByBank?: BankName, auctioningAgency?: { __typename?: 'Agency', name: string }, vehicle: { __typename?: 'Vehicle', id: string, manufacturingDate?: any, registrationDate?: any, engineNumber?: string, isRcAvailable?: boolean, chassisNumber?: string, vehicleBrand?: { __typename?: 'Brand', name: string }, vehicleModel?: { __typename?: 'Model', name: string } }, pickup?: { __typename?: 'Pickup', by?: { __typename?: 'User', name: string } }, centre?: { __typename?: 'Centre', name: string } }> };

export type GetLeadDetailQueryVariables = Exact<{
  regNo?: InputMaybe<Scalars['String']>;
}>;


export type GetLeadDetailQuery = { __typename?: 'Query', getLead?: { __typename?: 'Lead', id: string, regNo: string, yardPerDayParkingChargesByDriver?: number, approvedParkingChargesFor?: UserRole, status?: LeadBusinessStatus, yardPerDayParkingCharges?: number, actualPickupDate?: any, deliveredSelfieUrl?: string, registrationState?: string, listingPrice?: number, listingOnWebUpdatedAt?: any, listingStatus?: ListingStatus, loanAmount?: number, source?: LeadSource, auctionByBank?: BankName, proposedBidLimitAmount?: number, finalBidAmount?: number, expectedPickupDate?: any, actualParkingCharges?: number, demandAmount?: number, ownershipType?: Ownership, paymentType?: PaymentType, finalParkingCharges?: number, estimatedParkingCharges?: number, deliveryAmount?: number, documentCharges?: number, holdbackAmount?: number, tokenAmount?: number, loanToBeClosedBy?: LoanToBeClosedBy, approvedDealAmount?: number, proposedDealAmount?: number, sellingPrice?: number, createdAt?: any, auctionHistory?: Array<{ __typename?: 'AuctionHistory', amount?: number, createdAt?: any, status?: boolean }>, accessories?: Array<{ __typename?: 'AccessoriesCheckListWithStage', id: string, backLeftTyre?: AccessoryStatus, backRightTyre?: AccessoryStatus, stage: ImageStage, regNo: string, bumper?: AccessoryStatus, hood?: AccessoryStatus, battery?: AccessoryStatus, drawbar?: AccessoryStatus, toplink?: AccessoryStatus, frontLeftTyre?: AccessoryStatus, frontRightTyre?: AccessoryStatus }>, listingUpdatedBy?: { __typename?: 'User', id: string, name: string }, dealer?: { __typename?: 'Dealer', id: string, phoneNo: string, name?: string }, documentChecklist?: { __typename?: 'DocumentChecklist', id: string, form30?: boolean, sellerPAN?: boolean, form60?: boolean, form60_sellerPan?: boolean, sellerAadharCard?: boolean, ownerAddressProof?: boolean, releaseOrder?: boolean, indemnityBond?: boolean, registrationCertificate?: boolean, form26?: boolean, loanForeclosure?: boolean, bankNOC?: boolean, form35?: boolean, insuranceCertificate?: boolean, form28?: boolean, form29?: boolean, form36?: boolean }, documents?: { __typename?: 'LeadDocuments', id: string, regNo: string, registrationCertificate?: string, form26?: string, form30?: string, form29?: string, form36?: string, sellerPAN?: string, form60?: string, form60_sellerPan?: string, sellerAadharCard?: string, ownerAddressProof?: string, releaseOrder?: string, indemnityBond?: string, bankAccountProofUrl?: string, dealPaymentProofUrl?: string, parkingPaymentProofUrl?: string, loanForeclosure?: string, bankNOC?: string, form35?: string, insuranceCertificate?: string, form28?: string }, refurbishmentDetails?: { __typename?: 'RefurbishmentDetails', isRequired?: boolean, id: string, requests?: Array<{ __typename?: 'RefurbishmentRequest', id: string, requestStatus?: RefurbishmentStatus, createdAt?: any, transportationCharge?: number, issue?: { __typename?: 'Issue', id: string, status?: IssueStatus, items?: Array<{ __typename?: 'IssueItem', id: string, price?: number, isApproved?: boolean, quantity?: number, product: { __typename?: 'Product', id: string, name: string, variant?: string } }> }, purchase?: { __typename?: 'Purchase', id: string, totalPrice?: number, createdAt: any, items?: Array<{ __typename?: 'PurchaseItem', id: string, purchaseProofUrl?: string, approvedPriceLimit?: number, description?: string, price?: number, product: { __typename?: 'Product', name: string } }>, payment?: { __typename?: 'Payment', id: string, for: PaymentFor, status: PaymentStatus, amount?: number, createdAt: any, paymentProcessedAt?: any, receiptUrl?: string, proofUrl?: string, mode?: PaymentMethod, modeFM?: PaymentMethod, source?: LeadSource, paymentTo?: PaymentTo, accountHolderName?: string, bankName?: BankName, accountNo?: string, ifsc?: string, upiId?: string, refurbishmentBeneficiary?: { __typename?: 'RefurbishmentBeneficiary', id: string, accountHolderName: string, accountNumber: string, bankName?: BankName, ifscCode: string, upiId?: string, proofUrl?: string } } }, items?: Array<{ __typename?: 'RefurbishmentItem', id: string, price?: number, refurbishmentProofUrl?: string, installationProofUrl?: string, status?: RefurbishmentStatus, description?: string, product: { __typename?: 'Product', id: string, name: string, description?: string } }> }> }, activeBooking?: { __typename?: 'Booking', id: string, deliveryPhotoUrl?: string, createdAt?: any, updatedAt?: any, status?: BookingStatus, isRCTransferReq?: boolean, isInsuranceReq?: boolean, loanCancellationReason?: LoanRejectionReason, isLoanDrop?: boolean, vehicleTransferFormUrl?: string, cheque?: string, cancelledChequeUrl?: string, deliveryForm?: string, activeLoan?: { __typename?: 'Loan', id: string, loginDate?: any, fieldInspectionDate?: any, fieldInspectionConfirmedDate?: any, deliveryOrderDate?: any, loanStatus: LoanStatus, deliveryOrderValidity?: number, sanctionedLoanAmount?: number, deliveryOrderDocUrl?: string, createdAt?: any, updatedAt?: any, rejectedAt?: LoanStage, rejectionReason?: LoanRejectionReason, loginStatus?: LoanStatus, fieldInspectionStatus?: LoanStatus, deliveryOrderStatus?: LoanStatus, appliedLoanAmount?: number, loanStage?: LoanStage, bankName?: BankName, loginApplicationFormUrl?: string, loanCancelReason?: LoanRejectionReason }, archivedLoans?: Array<{ __typename?: 'Loan', id: string, rejectionReason?: LoanRejectionReason, loanStatus: LoanStatus, loanCancelReason?: LoanRejectionReason }>, payments?: Array<{ __typename?: 'Payment', id: string, for: PaymentFor, status: PaymentStatus, mode?: PaymentMethod, amount?: number, createdAt: any, proofUrl?: string, paymentProcessedAt?: any, receiptUrl?: string, invoice?: { __typename?: 'PaymentInvoices', id?: string, GSTNumber?: string, invoiceId: string }, confirmedBy?: { __typename?: 'User', id: string, name: string }, parkingBeneficiary?: { __typename?: 'ParkingBeneficiary', id: string, accountHolderName: string } }>, bookingPayment?: { __typename?: 'BookingPayment', id: string, saleAmount: number, bookingType?: BookingType, bookingPaymentMode?: BookingType, totalSaleAmount?: number, rcTransferAmount?: number, insuranceAmount?: number, appliedLoanAmount?: number }, customer: { __typename?: 'Customer', id: string, updatedAt?: any, name?: string, phoneNo: string, state?: string, district?: string, customerId?: CustomerId, idNumber?: string, idProofUrl?: string, createdAt?: any, customerState?: { __typename?: 'StateCodeWithRegNumber', state: string }, customerDistrict?: { __typename?: 'District', name: string }, identificationDocuments?: { __typename?: 'IdentificationDocument', aadhaarNumber?: string, aadhaarFrontPhotoUrl?: string, aadhaarBackPhotoUrl?: string, panNumber?: string, panPhotoUrl?: string, voterIdNumber?: string, voterIdPhotoUrl?: string }, bookings?: Array<{ __typename?: 'Booking', status?: BookingStatus, deliveryForm?: string, cancelledChequeUrl?: string, isRCTransferReq?: boolean, isInsuranceReq?: boolean, vehicleTransferFormUrl?: string, cancellationReason?: BookingCancellationReason }> } }, archivedBookings?: Array<{ __typename?: 'Booking', id: string, status?: BookingStatus, cancellationReason?: BookingCancellationReason, cancellationRemarks?: string, deliveryPhotoUrl?: string, createdAt?: any, updatedAt?: any, isRCTransferReq?: boolean, isInsuranceReq?: boolean, vehicleTransferFormUrl?: string, cheque?: string, cancelledChequeUrl?: string, deliveryForm?: string, archivedLoans?: Array<{ __typename?: 'Loan', id: string, rejectionReason?: LoanRejectionReason, loanStatus: LoanStatus, loanCancelReason?: LoanRejectionReason }>, activeLoan?: { __typename?: 'Loan', id: string, deliveryOrderDate?: any, loanStatus: LoanStatus, fieldInspectionConfirmedDate?: any, deliveryOrderValidity?: number, sanctionedLoanAmount?: number, deliveryOrderDocUrl?: string, createdAt?: any, updatedAt?: any, rejectedAt?: LoanStage, rejectionReason?: LoanRejectionReason, loginStatus?: LoanStatus, fieldInspectionStatus?: LoanStatus, deliveryOrderStatus?: LoanStatus, appliedLoanAmount?: number, loanStage?: LoanStage, bankName?: BankName, loginDate?: any, loginApplicationFormUrl?: string, fieldInspectionDate?: any, loanCancelReason?: LoanRejectionReason }, payments?: Array<{ __typename?: 'Payment', id: string, for: PaymentFor, status: PaymentStatus, mode?: PaymentMethod, amount?: number, createdAt: any, proofUrl?: string, paymentProcessedAt?: any, receiptUrl?: string, invoice?: { __typename?: 'PaymentInvoices', id?: string, GSTNumber?: string, invoiceId: string }, confirmedBy?: { __typename?: 'User', id: string, name: string }, parkingBeneficiary?: { __typename?: 'ParkingBeneficiary', id: string, accountHolderName: string } }>, bookingPayment?: { __typename?: 'BookingPayment', id: string, saleAmount: number, bookingType?: BookingType, bookingPaymentMode?: BookingType, totalSaleAmount?: number, rcTransferAmount?: number, insuranceAmount?: number, appliedLoanAmount?: number }, customer: { __typename?: 'Customer', id: string, updatedAt?: any, name?: string, phoneNo: string, state?: string, district?: string, customerId?: CustomerId, idNumber?: string, idProofUrl?: string, createdAt?: any, customerState?: { __typename?: 'StateCodeWithRegNumber', state: string }, customerDistrict?: { __typename?: 'District', name: string }, identificationDocuments?: { __typename?: 'IdentificationDocument', aadhaarNumber?: string, aadhaarFrontPhotoUrl?: string, aadhaarBackPhotoUrl?: string, panNumber?: string, panPhotoUrl?: string, voterIdNumber?: string, voterIdPhotoUrl?: string }, bookings?: Array<{ __typename?: 'Booking', status?: BookingStatus, deliveryForm?: string, cancelledChequeUrl?: string, isRCTransferReq?: boolean, isInsuranceReq?: boolean, vehicleTransferFormUrl?: string, cancellationReason?: BookingCancellationReason }> } }>, expensesCoveredIn?: Array<{ __typename?: 'TripExpense', id: string }>, vehicle: { __typename?: 'Vehicle', id: string, repossessionDate?: any, tempRepossessionDate?: any, isHypo?: boolean, isChallanAvailable?: boolean, isBlacklisted?: boolean, isHSRPAvailable?: boolean, registrationNumber?: string, fitnessValidUpto?: any, isRcAvailable?: boolean, isVehicleFinanced?: boolean, tempIsVehicleFinanced?: boolean, isVehicleInsured?: boolean, challanAmount?: number, engineNumber?: string, manufacturingDate?: any, registrationDate?: any, tempModel?: string, tempMake?: VehicleMake, tempChassisNumber?: string, tempEngineNumber?: string, tempManufacturingDate?: any, hoursMeter?: number, chassisNumber?: string, typeCondition?: number, price?: number, vehicleBrand?: { __typename?: 'Brand', name: string, id: string }, vehicleModel?: { __typename?: 'Model', name: string, id: string }, tempVehicleBrand?: { __typename?: 'Brand', name: string }, tempVehicleModel?: { __typename?: 'Model', name: string }, documents?: { __typename?: 'VehicleDocuments', id: string, registrationCertificateUrl?: string, approvalMailUrl?: string, hypothecationProofUrl?: string, rtoVerificationProofUrl?: string, hsrbProofUrl?: string, challanUrl?: string, blacklistProofUrl?: string, fitnessCertificateValidUpto?: any }, financingDetails?: { __typename?: 'VehicleFinancing', id: string, isLoanClosed?: boolean, pendingLoanAmount?: number, loanToBeClosedBy?: LoanToBeClosedBy, tempLoanToBeClosedBy?: LoanToBeClosedBy, financerName?: string, tempFinancerName?: string }, insuranceDetails?: { __typename?: 'VehicleInsurance', id: string, insurerName?: InsurerName, insuranceType?: InsuranceType, policyNumber?: string, policyExpiryDate?: any }, owner?: { __typename?: 'VehicleOwner', id: string, district?: string }, images?: Array<{ __typename?: 'VehicleImages', id: string, backBodySide?: string, leftBodySide?: string, frontBodySide?: string, rightBodySide?: string, backRightTyre?: string, frontRightTyre?: string, fuelInjectionPumpPlate?: string, odometer?: string, inspectionVideoUrl?: string, backLeftTyre?: string, frontLeftTyre?: string, engineNumber?: string, chassisNumber?: string, imagesTakenAtStage?: ImageStage, vehicle: { __typename?: 'Vehicle', id: string, registrationNumber?: string, regNo: string } }> }, auctioningAgency?: { __typename?: 'Agency', id: string, name: string, spocNo?: string }, createdBy?: { __typename?: 'User', id: string, phoneNo?: string, name: string }, payments?: Array<{ __typename?: 'Payment', id: string, for: PaymentFor, status: PaymentStatus, amount?: number, createdAt: any, mode?: PaymentMethod, proofUrl?: string, accountHolderName?: string, bankName?: BankName, ifsc?: string, accountNo?: string, upiId?: string, receiptUrl?: string, paymentProcessedAt?: any, type?: PaymentType, loanClosedBy?: LoanToBeClosedBy, parkingBeneficiary?: { __typename?: 'ParkingBeneficiary', id: string, accountHolderName: string, accountNumber: string, bankName?: BankName, ifscCode: string, upiId?: string, proofUrl?: string }, by: { __typename?: 'User', id: string, name: string } }>, expenses?: Array<{ __typename?: 'LeadExpense', id: string, description?: string, spentAmount: string, category: ExpenseCategory, receiptUrl?: string, createdAt?: any, paymentStatus?: PaymentStatus }>, deliveryCentre?: { __typename?: 'Centre', name: string }, centre?: { __typename?: 'Centre', id: string, name: string, state?: string, district?: string, tehsil?: string, address?: string, phoneNumber?: string, location?: { __typename?: 'Point', longitude: number, latitude: number } }, yard?: { __typename?: 'Yard', id: string, name: string, address?: string, locationUrl?: string, perDayParkingCharge?: number, tempPerDayParkingCharge?: number, city?: string, spocName?: string, spocNo?: string, location?: { __typename?: 'Point', longitude: number, latitude: number } }, pickup?: { __typename?: 'Pickup', id: string, by?: { __typename?: 'User', id: string, name: string, phoneNo?: string, email: string } }, parkingBeneficiary?: { __typename?: 'ParkingBeneficiary', id: string, bankName?: BankName, accountHolderName: string, accountNumber: string, ifscCode: string }, statusEvents?: Array<{ __typename?: 'LeadStatusEvent', id: string, status: LeadStatus, metadata?: string, deviceType?: DeviceType, assignTaskTo?: UserRole, notifyTo?: Array<UserRole>, taskButtonTitle?: string, taskTitle?: string, createdAt: any, postTimeline?: string, isTaskCompleted?: boolean, preTimeline?: string, remarks?: string, createdBy: { __typename?: 'User', id: string, name: string } }>, internalTransfers?: Array<{ __typename?: 'VehicleTransferLog', id: string, pickupDate?: any, selfieUrl?: string, deliveredOn?: any, requestedOn?: any, status?: InternalTransferStatus, from?: { __typename?: 'Centre', id: string, name: string }, to?: { __typename?: 'Centre', id: string, name: string }, assignedTo?: { __typename?: 'User', id: string, name: string } }> } };

export type ModelByMakeQueryVariables = Exact<{
  make?: InputMaybe<Scalars['String']>;
}>;


export type ModelByMakeQuery = { __typename?: 'Query', queryModelByMake?: Array<{ __typename?: 'ModelByMake', model?: string }> };

export type GetUserByRoleQueryVariables = Exact<{
  role?: InputMaybe<UserRole>;
}>;


export type GetUserByRoleQuery = { __typename?: 'Query', queryUser?: Array<{ __typename?: 'User', id: string, name: string, role?: UserRole, email: string }> };

export type GetBanklistQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBanklistQuery = { __typename?: 'Query', queryAgency?: Array<{ __typename?: 'Agency', id: string, name: string }> };

export type GetmodelListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetmodelListQuery = { __typename?: 'Query', queryVehicle?: Array<{ __typename?: 'Vehicle', id: string, model?: string }> };

export type GetStateListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStateListQuery = { __typename?: 'Query', queryStateCodeWithRegNumber?: Array<{ __typename?: 'StateCodeWithRegNumber', id: string, state: string }> };

export type RefurbishmentRequestDetailsFragment = { __typename?: 'RefurbishmentDetails', isRequired?: boolean, requests?: Array<{ __typename?: 'RefurbishmentRequest', transportationCharge?: number, id: string, requestStatus?: RefurbishmentStatus, createdAt?: any, issue?: { __typename?: 'Issue', id: string, status?: IssueStatus, items?: Array<{ __typename?: 'IssueItem', id: string, price?: number, isApproved?: boolean, quantity?: number, product: { __typename?: 'Product', id: string, name: string, variant?: string } }> }, purchase?: { __typename?: 'Purchase', id: string, totalPrice?: number, createdAt: any, items?: Array<{ __typename?: 'PurchaseItem', id: string, approvedPriceLimit?: number, purchaseProofUrl?: string, description?: string, price?: number, product: { __typename?: 'Product', name: string } }>, payment?: { __typename?: 'Payment', id: string, for: PaymentFor, status: PaymentStatus, amount?: number, createdAt: any, paymentProcessedAt?: any, receiptUrl?: string, proofUrl?: string, mode?: PaymentMethod, modeFM?: PaymentMethod, source?: LeadSource, paymentTo?: PaymentTo, accountHolderName?: string, bankName?: BankName, accountNo?: string, ifsc?: string, upiId?: string, refurbishmentBeneficiary?: { __typename?: 'RefurbishmentBeneficiary', id: string, accountHolderName: string, accountNumber: string, bankName?: BankName, ifscCode: string, upiId?: string, proofUrl?: string } } }, items?: Array<{ __typename?: 'RefurbishmentItem', id: string, price?: number, refurbishmentProofUrl?: string, installationProofUrl?: string, status?: RefurbishmentStatus, description?: string, product: { __typename?: 'Product', id: string, name: string } }> }> };

export type ActiveLoanDetailsFragment = { __typename?: 'Loan', id: string, deliveryOrderDate?: any, loanStatus: LoanStatus, fieldInspectionConfirmedDate?: any, deliveryOrderValidity?: number, sanctionedLoanAmount?: number, deliveryOrderDocUrl?: string, createdAt?: any, updatedAt?: any, rejectedAt?: LoanStage, rejectionReason?: LoanRejectionReason, loginStatus?: LoanStatus, fieldInspectionStatus?: LoanStatus, deliveryOrderStatus?: LoanStatus, appliedLoanAmount?: number, loanStage?: LoanStage, bankName?: BankName, loginDate?: any, loginApplicationFormUrl?: string, fieldInspectionDate?: any, loanCancelReason?: LoanRejectionReason };

export type ActiveBookingDetailsFragment = { __typename?: 'Booking', id: string, deliveryPhotoUrl?: string, createdAt?: any, updatedAt?: any, status?: BookingStatus, isRCTransferReq?: boolean, isInsuranceReq?: boolean, loanCancellationReason?: LoanRejectionReason, isLoanDrop?: boolean, vehicleTransferFormUrl?: string, cheque?: string, cancelledChequeUrl?: string, deliveryForm?: string, archivedLoans?: Array<{ __typename?: 'Loan', id: string, rejectionReason?: LoanRejectionReason, loanStatus: LoanStatus, loanCancelReason?: LoanRejectionReason }>, activeLoan?: { __typename?: 'Loan', id: string, deliveryOrderDate?: any, loanStatus: LoanStatus, fieldInspectionConfirmedDate?: any, deliveryOrderValidity?: number, sanctionedLoanAmount?: number, deliveryOrderDocUrl?: string, createdAt?: any, updatedAt?: any, rejectedAt?: LoanStage, rejectionReason?: LoanRejectionReason, loginStatus?: LoanStatus, fieldInspectionStatus?: LoanStatus, deliveryOrderStatus?: LoanStatus, appliedLoanAmount?: number, loanStage?: LoanStage, bankName?: BankName, loginDate?: any, loginApplicationFormUrl?: string, fieldInspectionDate?: any, loanCancelReason?: LoanRejectionReason }, payments?: Array<{ __typename?: 'Payment', id: string, for: PaymentFor, status: PaymentStatus, mode?: PaymentMethod, amount?: number, createdAt: any, proofUrl?: string, paymentProcessedAt?: any, receiptUrl?: string, invoice?: { __typename?: 'PaymentInvoices', id?: string, GSTNumber?: string, invoiceId: string }, confirmedBy?: { __typename?: 'User', id: string, name: string }, parkingBeneficiary?: { __typename?: 'ParkingBeneficiary', id: string, accountHolderName: string } }>, bookingPayment?: { __typename?: 'BookingPayment', id: string, saleAmount: number, bookingType?: BookingType, bookingPaymentMode?: BookingType, totalSaleAmount?: number, rcTransferAmount?: number, insuranceAmount?: number, appliedLoanAmount?: number }, customer: { __typename?: 'Customer', id: string, updatedAt?: any, name?: string, phoneNo: string, state?: string, district?: string, customerId?: CustomerId, idNumber?: string, idProofUrl?: string, createdAt?: any, customerState?: { __typename?: 'StateCodeWithRegNumber', state: string }, customerDistrict?: { __typename?: 'District', name: string }, identificationDocuments?: { __typename?: 'IdentificationDocument', aadhaarNumber?: string, aadhaarFrontPhotoUrl?: string, aadhaarBackPhotoUrl?: string, panNumber?: string, panPhotoUrl?: string, voterIdNumber?: string, voterIdPhotoUrl?: string }, bookings?: Array<{ __typename?: 'Booking', status?: BookingStatus, deliveryForm?: string, cancelledChequeUrl?: string, isRCTransferReq?: boolean, isInsuranceReq?: boolean, vehicleTransferFormUrl?: string, cancellationReason?: BookingCancellationReason }> } };

export type LeadDetailsFragment = { __typename?: 'Lead', id: string, regNo: string, yardPerDayParkingChargesByDriver?: number, approvedParkingChargesFor?: UserRole, status?: LeadBusinessStatus, yardPerDayParkingCharges?: number, actualPickupDate?: any, deliveredSelfieUrl?: string, registrationState?: string, listingPrice?: number, listingOnWebUpdatedAt?: any, listingStatus?: ListingStatus, loanAmount?: number, source?: LeadSource, auctionByBank?: BankName, proposedBidLimitAmount?: number, finalBidAmount?: number, expectedPickupDate?: any, actualParkingCharges?: number, demandAmount?: number, ownershipType?: Ownership, paymentType?: PaymentType, finalParkingCharges?: number, estimatedParkingCharges?: number, deliveryAmount?: number, documentCharges?: number, holdbackAmount?: number, tokenAmount?: number, loanToBeClosedBy?: LoanToBeClosedBy, approvedDealAmount?: number, proposedDealAmount?: number, sellingPrice?: number, createdAt?: any, auctionHistory?: Array<{ __typename?: 'AuctionHistory', amount?: number, createdAt?: any, status?: boolean }>, accessories?: Array<{ __typename?: 'AccessoriesCheckListWithStage', id: string, backLeftTyre?: AccessoryStatus, backRightTyre?: AccessoryStatus, stage: ImageStage, regNo: string, bumper?: AccessoryStatus, hood?: AccessoryStatus, battery?: AccessoryStatus, drawbar?: AccessoryStatus, toplink?: AccessoryStatus, frontLeftTyre?: AccessoryStatus, frontRightTyre?: AccessoryStatus }>, listingUpdatedBy?: { __typename?: 'User', id: string, name: string }, dealer?: { __typename?: 'Dealer', id: string, phoneNo: string, name?: string }, documentChecklist?: { __typename?: 'DocumentChecklist', id: string, form30?: boolean, sellerPAN?: boolean, form60?: boolean, form60_sellerPan?: boolean, sellerAadharCard?: boolean, ownerAddressProof?: boolean, releaseOrder?: boolean, indemnityBond?: boolean, registrationCertificate?: boolean, form26?: boolean, loanForeclosure?: boolean, bankNOC?: boolean, form35?: boolean, insuranceCertificate?: boolean, form28?: boolean, form29?: boolean, form36?: boolean }, documents?: { __typename?: 'LeadDocuments', id: string, regNo: string, registrationCertificate?: string, form26?: string, form30?: string, form29?: string, form36?: string, sellerPAN?: string, form60?: string, form60_sellerPan?: string, sellerAadharCard?: string, ownerAddressProof?: string, releaseOrder?: string, indemnityBond?: string, bankAccountProofUrl?: string, dealPaymentProofUrl?: string, parkingPaymentProofUrl?: string, loanForeclosure?: string, bankNOC?: string, form35?: string, insuranceCertificate?: string, form28?: string }, refurbishmentDetails?: { __typename?: 'RefurbishmentDetails', isRequired?: boolean, id: string, requests?: Array<{ __typename?: 'RefurbishmentRequest', id: string, requestStatus?: RefurbishmentStatus, createdAt?: any, transportationCharge?: number, issue?: { __typename?: 'Issue', id: string, status?: IssueStatus, items?: Array<{ __typename?: 'IssueItem', id: string, price?: number, isApproved?: boolean, quantity?: number, product: { __typename?: 'Product', id: string, name: string, variant?: string } }> }, purchase?: { __typename?: 'Purchase', id: string, totalPrice?: number, createdAt: any, items?: Array<{ __typename?: 'PurchaseItem', id: string, purchaseProofUrl?: string, approvedPriceLimit?: number, description?: string, price?: number, product: { __typename?: 'Product', name: string } }>, payment?: { __typename?: 'Payment', id: string, for: PaymentFor, status: PaymentStatus, amount?: number, createdAt: any, paymentProcessedAt?: any, receiptUrl?: string, proofUrl?: string, mode?: PaymentMethod, modeFM?: PaymentMethod, source?: LeadSource, paymentTo?: PaymentTo, accountHolderName?: string, bankName?: BankName, accountNo?: string, ifsc?: string, upiId?: string, refurbishmentBeneficiary?: { __typename?: 'RefurbishmentBeneficiary', id: string, accountHolderName: string, accountNumber: string, bankName?: BankName, ifscCode: string, upiId?: string, proofUrl?: string } } }, items?: Array<{ __typename?: 'RefurbishmentItem', id: string, price?: number, refurbishmentProofUrl?: string, installationProofUrl?: string, status?: RefurbishmentStatus, description?: string, product: { __typename?: 'Product', id: string, name: string, description?: string } }> }> }, activeBooking?: { __typename?: 'Booking', id: string, deliveryPhotoUrl?: string, createdAt?: any, updatedAt?: any, status?: BookingStatus, isRCTransferReq?: boolean, isInsuranceReq?: boolean, loanCancellationReason?: LoanRejectionReason, isLoanDrop?: boolean, vehicleTransferFormUrl?: string, cheque?: string, cancelledChequeUrl?: string, deliveryForm?: string, activeLoan?: { __typename?: 'Loan', id: string, loginDate?: any, fieldInspectionDate?: any, fieldInspectionConfirmedDate?: any, deliveryOrderDate?: any, loanStatus: LoanStatus, deliveryOrderValidity?: number, sanctionedLoanAmount?: number, deliveryOrderDocUrl?: string, createdAt?: any, updatedAt?: any, rejectedAt?: LoanStage, rejectionReason?: LoanRejectionReason, loginStatus?: LoanStatus, fieldInspectionStatus?: LoanStatus, deliveryOrderStatus?: LoanStatus, appliedLoanAmount?: number, loanStage?: LoanStage, bankName?: BankName, loginApplicationFormUrl?: string, loanCancelReason?: LoanRejectionReason }, archivedLoans?: Array<{ __typename?: 'Loan', id: string, rejectionReason?: LoanRejectionReason, loanStatus: LoanStatus, loanCancelReason?: LoanRejectionReason }>, payments?: Array<{ __typename?: 'Payment', id: string, for: PaymentFor, status: PaymentStatus, mode?: PaymentMethod, amount?: number, createdAt: any, proofUrl?: string, paymentProcessedAt?: any, receiptUrl?: string, invoice?: { __typename?: 'PaymentInvoices', id?: string, GSTNumber?: string, invoiceId: string }, confirmedBy?: { __typename?: 'User', id: string, name: string }, parkingBeneficiary?: { __typename?: 'ParkingBeneficiary', id: string, accountHolderName: string } }>, bookingPayment?: { __typename?: 'BookingPayment', id: string, saleAmount: number, bookingType?: BookingType, bookingPaymentMode?: BookingType, totalSaleAmount?: number, rcTransferAmount?: number, insuranceAmount?: number, appliedLoanAmount?: number }, customer: { __typename?: 'Customer', id: string, updatedAt?: any, name?: string, phoneNo: string, state?: string, district?: string, customerId?: CustomerId, idNumber?: string, idProofUrl?: string, createdAt?: any, customerState?: { __typename?: 'StateCodeWithRegNumber', state: string }, customerDistrict?: { __typename?: 'District', name: string }, identificationDocuments?: { __typename?: 'IdentificationDocument', aadhaarNumber?: string, aadhaarFrontPhotoUrl?: string, aadhaarBackPhotoUrl?: string, panNumber?: string, panPhotoUrl?: string, voterIdNumber?: string, voterIdPhotoUrl?: string }, bookings?: Array<{ __typename?: 'Booking', status?: BookingStatus, deliveryForm?: string, cancelledChequeUrl?: string, isRCTransferReq?: boolean, isInsuranceReq?: boolean, vehicleTransferFormUrl?: string, cancellationReason?: BookingCancellationReason }> } }, archivedBookings?: Array<{ __typename?: 'Booking', id: string, status?: BookingStatus, cancellationReason?: BookingCancellationReason, cancellationRemarks?: string, deliveryPhotoUrl?: string, createdAt?: any, updatedAt?: any, isRCTransferReq?: boolean, isInsuranceReq?: boolean, vehicleTransferFormUrl?: string, cheque?: string, cancelledChequeUrl?: string, deliveryForm?: string, archivedLoans?: Array<{ __typename?: 'Loan', id: string, rejectionReason?: LoanRejectionReason, loanStatus: LoanStatus, loanCancelReason?: LoanRejectionReason }>, activeLoan?: { __typename?: 'Loan', id: string, deliveryOrderDate?: any, loanStatus: LoanStatus, fieldInspectionConfirmedDate?: any, deliveryOrderValidity?: number, sanctionedLoanAmount?: number, deliveryOrderDocUrl?: string, createdAt?: any, updatedAt?: any, rejectedAt?: LoanStage, rejectionReason?: LoanRejectionReason, loginStatus?: LoanStatus, fieldInspectionStatus?: LoanStatus, deliveryOrderStatus?: LoanStatus, appliedLoanAmount?: number, loanStage?: LoanStage, bankName?: BankName, loginDate?: any, loginApplicationFormUrl?: string, fieldInspectionDate?: any, loanCancelReason?: LoanRejectionReason }, payments?: Array<{ __typename?: 'Payment', id: string, for: PaymentFor, status: PaymentStatus, mode?: PaymentMethod, amount?: number, createdAt: any, proofUrl?: string, paymentProcessedAt?: any, receiptUrl?: string, invoice?: { __typename?: 'PaymentInvoices', id?: string, GSTNumber?: string, invoiceId: string }, confirmedBy?: { __typename?: 'User', id: string, name: string }, parkingBeneficiary?: { __typename?: 'ParkingBeneficiary', id: string, accountHolderName: string } }>, bookingPayment?: { __typename?: 'BookingPayment', id: string, saleAmount: number, bookingType?: BookingType, bookingPaymentMode?: BookingType, totalSaleAmount?: number, rcTransferAmount?: number, insuranceAmount?: number, appliedLoanAmount?: number }, customer: { __typename?: 'Customer', id: string, updatedAt?: any, name?: string, phoneNo: string, state?: string, district?: string, customerId?: CustomerId, idNumber?: string, idProofUrl?: string, createdAt?: any, customerState?: { __typename?: 'StateCodeWithRegNumber', state: string }, customerDistrict?: { __typename?: 'District', name: string }, identificationDocuments?: { __typename?: 'IdentificationDocument', aadhaarNumber?: string, aadhaarFrontPhotoUrl?: string, aadhaarBackPhotoUrl?: string, panNumber?: string, panPhotoUrl?: string, voterIdNumber?: string, voterIdPhotoUrl?: string }, bookings?: Array<{ __typename?: 'Booking', status?: BookingStatus, deliveryForm?: string, cancelledChequeUrl?: string, isRCTransferReq?: boolean, isInsuranceReq?: boolean, vehicleTransferFormUrl?: string, cancellationReason?: BookingCancellationReason }> } }>, expensesCoveredIn?: Array<{ __typename?: 'TripExpense', id: string }>, vehicle: { __typename?: 'Vehicle', id: string, repossessionDate?: any, tempRepossessionDate?: any, isHypo?: boolean, isChallanAvailable?: boolean, isBlacklisted?: boolean, isHSRPAvailable?: boolean, registrationNumber?: string, fitnessValidUpto?: any, isRcAvailable?: boolean, isVehicleFinanced?: boolean, tempIsVehicleFinanced?: boolean, isVehicleInsured?: boolean, challanAmount?: number, engineNumber?: string, manufacturingDate?: any, registrationDate?: any, tempModel?: string, tempMake?: VehicleMake, tempChassisNumber?: string, tempEngineNumber?: string, tempManufacturingDate?: any, hoursMeter?: number, chassisNumber?: string, typeCondition?: number, price?: number, vehicleBrand?: { __typename?: 'Brand', name: string, id: string }, vehicleModel?: { __typename?: 'Model', name: string, id: string }, tempVehicleBrand?: { __typename?: 'Brand', name: string }, tempVehicleModel?: { __typename?: 'Model', name: string }, documents?: { __typename?: 'VehicleDocuments', id: string, registrationCertificateUrl?: string, approvalMailUrl?: string, hypothecationProofUrl?: string, rtoVerificationProofUrl?: string, hsrbProofUrl?: string, challanUrl?: string, blacklistProofUrl?: string, fitnessCertificateValidUpto?: any }, financingDetails?: { __typename?: 'VehicleFinancing', id: string, isLoanClosed?: boolean, pendingLoanAmount?: number, loanToBeClosedBy?: LoanToBeClosedBy, tempLoanToBeClosedBy?: LoanToBeClosedBy, financerName?: string, tempFinancerName?: string }, insuranceDetails?: { __typename?: 'VehicleInsurance', id: string, insurerName?: InsurerName, insuranceType?: InsuranceType, policyNumber?: string, policyExpiryDate?: any }, owner?: { __typename?: 'VehicleOwner', id: string, district?: string }, images?: Array<{ __typename?: 'VehicleImages', id: string, backBodySide?: string, leftBodySide?: string, frontBodySide?: string, rightBodySide?: string, backRightTyre?: string, frontRightTyre?: string, fuelInjectionPumpPlate?: string, odometer?: string, inspectionVideoUrl?: string, backLeftTyre?: string, frontLeftTyre?: string, engineNumber?: string, chassisNumber?: string, imagesTakenAtStage?: ImageStage, vehicle: { __typename?: 'Vehicle', id: string, registrationNumber?: string, regNo: string } }> }, auctioningAgency?: { __typename?: 'Agency', id: string, name: string, spocNo?: string }, createdBy?: { __typename?: 'User', id: string, phoneNo?: string, name: string }, payments?: Array<{ __typename?: 'Payment', id: string, for: PaymentFor, status: PaymentStatus, amount?: number, createdAt: any, mode?: PaymentMethod, proofUrl?: string, accountHolderName?: string, bankName?: BankName, ifsc?: string, accountNo?: string, upiId?: string, receiptUrl?: string, paymentProcessedAt?: any, type?: PaymentType, loanClosedBy?: LoanToBeClosedBy, parkingBeneficiary?: { __typename?: 'ParkingBeneficiary', id: string, accountHolderName: string, accountNumber: string, bankName?: BankName, ifscCode: string, upiId?: string, proofUrl?: string }, by: { __typename?: 'User', id: string, name: string } }>, expenses?: Array<{ __typename?: 'LeadExpense', id: string, description?: string, spentAmount: string, category: ExpenseCategory, receiptUrl?: string, createdAt?: any, paymentStatus?: PaymentStatus }>, deliveryCentre?: { __typename?: 'Centre', name: string }, centre?: { __typename?: 'Centre', id: string, name: string, state?: string, district?: string, tehsil?: string, address?: string, phoneNumber?: string, location?: { __typename?: 'Point', longitude: number, latitude: number } }, yard?: { __typename?: 'Yard', id: string, name: string, address?: string, locationUrl?: string, perDayParkingCharge?: number, tempPerDayParkingCharge?: number, city?: string, spocName?: string, spocNo?: string, location?: { __typename?: 'Point', longitude: number, latitude: number } }, pickup?: { __typename?: 'Pickup', id: string, by?: { __typename?: 'User', id: string, name: string, phoneNo?: string, email: string } }, parkingBeneficiary?: { __typename?: 'ParkingBeneficiary', id: string, bankName?: BankName, accountHolderName: string, accountNumber: string, ifscCode: string }, statusEvents?: Array<{ __typename?: 'LeadStatusEvent', id: string, status: LeadStatus, metadata?: string, deviceType?: DeviceType, assignTaskTo?: UserRole, notifyTo?: Array<UserRole>, taskButtonTitle?: string, taskTitle?: string, createdAt: any, postTimeline?: string, isTaskCompleted?: boolean, preTimeline?: string, remarks?: string, createdBy: { __typename?: 'User', id: string, name: string } }>, internalTransfers?: Array<{ __typename?: 'VehicleTransferLog', id: string, pickupDate?: any, selfieUrl?: string, deliveredOn?: any, requestedOn?: any, status?: InternalTransferStatus, from?: { __typename?: 'Centre', id: string, name: string }, to?: { __typename?: 'Centre', id: string, name: string }, assignedTo?: { __typename?: 'User', id: string, name: string } }> };

export type LeadDocumentsDetailsFragment = { __typename?: 'LeadDocuments', id: string, regNo: string, registrationCertificate?: string, form26?: string, form30?: string, form29?: string, form36?: string, sellerPAN?: string, form60?: string, form60_sellerPan?: string, sellerAadharCard?: string, ownerAddressProof?: string, releaseOrder?: string, indemnityBond?: string, bankAccountProofUrl?: string, dealPaymentProofUrl?: string, parkingPaymentProofUrl?: string, loanForeclosure?: string, bankNOC?: string, form35?: string, insuranceCertificate?: string, form28?: string };

export type LeadStatusEventDetailsFragment = { __typename?: 'LeadStatusEvent', id: string, status: LeadStatus, metadata?: string, deviceType?: DeviceType, assignTaskTo?: UserRole, notifyTo?: Array<UserRole>, taskButtonTitle?: string, taskTitle?: string, createdAt: any, postTimeline?: string, isTaskCompleted?: boolean, preTimeline?: string, remarks?: string, createdBy: { __typename?: 'User', id: string, name: string } };

export type VehicleImagesDetailsFragment = { __typename?: 'VehicleImages', id: string, backBodySide?: string, leftBodySide?: string, frontBodySide?: string, rightBodySide?: string, backRightTyre?: string, frontRightTyre?: string, fuelInjectionPumpPlate?: string, odometer?: string, inspectionVideoUrl?: string, backLeftTyre?: string, frontLeftTyre?: string, engineNumber?: string, chassisNumber?: string, imagesTakenAtStage?: ImageStage };

export type SendQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  env?: InputMaybe<Scalars['String']>;
}>;


export type SendQuery = { __typename?: 'Query', sendSmsToCustomer?: { __typename?: 'SendSmsToCustomerResponse', message?: string, success?: boolean, invoice?: { __typename?: 'PaymentInvoices', id?: string } } };

export type LeadDocumentCountQueryVariables = Exact<{
  regNo?: InputMaybe<Scalars['String']>;
}>;


export type LeadDocumentCountQuery = { __typename?: 'Query', queryLead?: Array<{ __typename?: 'Lead', regNo: string, source?: LeadSource, documentChecklist?: { __typename?: 'DocumentChecklist', bankNOC?: boolean, form26?: boolean, form28?: boolean, form29?: boolean, form30?: boolean, form35?: boolean, indemnityBond?: boolean, releaseOrder?: boolean, insuranceCertificate?: boolean, loanForeclosure?: boolean, registrationCertificate?: boolean, sellerAadharCard?: boolean, form36?: boolean, form60_sellerPan?: boolean, ownerAddressProof?: boolean }, documents?: { __typename?: 'LeadDocuments', bankNOC?: string, form26?: string, form28?: string, form29?: string, form30?: string, form35?: string, indemnityBond?: string, releaseOrder?: string, insuranceCertificate?: string, loanForeclosure?: string, registrationCertificate?: string, sellerAadharCard?: string, form36?: string, form60_sellerPan?: string, ownerAddressProof?: string }, documentsFollowups?: Array<{ __typename?: 'DocumentsFollowups', id: string, source?: string, followupDate?: any, documentName?: string, actionType?: ActionType, remarks?: string, nextFollowupDate?: any, lead: { __typename?: 'Lead', regNo: string }, followedUpBy: { __typename?: 'User', name: string } }> }> };

export type AggregatesCountDocumentQueryVariables = Exact<{
  source?: InputMaybe<LeadSource>;
  start: Scalars['DateTime'];
  end: Scalars['DateTime'];
  docStatus?: InputMaybe<DocumentStatus>;
  regState?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
}>;


export type AggregatesCountDocumentQuery = { __typename?: 'Query', documentsAggregatesData?: { __typename?: 'documentsAggregatesResult', documentsCount?: { __typename?: 'DocumentsCount', pending?: number, received?: number, required?: number }, leads?: Array<{ __typename?: 'Lead', id: string, source?: LeadSource, registrationState?: string, createdAt?: any, updatedAt?: any, regNo: string, documentsFollowups?: Array<{ __typename?: 'DocumentsFollowups', nextFollowupDate?: any }>, documentChecklist?: { __typename?: 'DocumentChecklist', bankNOC?: boolean, form26?: boolean, form28?: boolean, form29?: boolean, form30?: boolean, form35?: boolean, indemnityBond?: boolean, releaseOrder?: boolean, insuranceCertificate?: boolean, loanForeclosure?: boolean, registrationCertificate?: boolean, sellerAadharCard?: boolean, form36?: boolean, form60_sellerPan?: boolean, ownerAddressProof?: boolean }, documents?: { __typename?: 'LeadDocuments', bankNOC?: string, form26?: string, form28?: string, form29?: string, form30?: string, form35?: string, indemnityBond?: string, releaseOrder?: string, insuranceCertificate?: string, loanForeclosure?: string, registrationCertificate?: string, sellerAadharCard?: string, form36?: string, form60_sellerPan?: string, ownerAddressProof?: string }, vehicle: { __typename?: 'Vehicle', id: string, manufacturingDate?: any, vehicleBrand?: { __typename?: 'Brand', name: string }, vehicleModel?: { __typename?: 'Model', name: string } }, statusEvents?: Array<{ __typename?: 'LeadStatusEvent', id: string, status: LeadStatus, assignTaskTo?: UserRole, notifyTo?: Array<UserRole>, taskButtonTitle?: string, taskTitle?: string, createdAt: any, postTimeline?: string, isTaskCompleted?: boolean, preTimeline?: string, remarks?: string, createdBy: { __typename?: 'User', id: string, name: string } }> }> } };

export type GetFilteredLeadsQueryVariables = Exact<{
  statuses?: InputMaybe<Array<InputMaybe<LeadStatus>> | InputMaybe<LeadStatus>>;
  dealStatus?: InputMaybe<DealStatus>;
  bankConfirmationStatus?: InputMaybe<BankConfirmationStatus>;
  registrationState?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  makes?: InputMaybe<Array<InputMaybe<VehicleMake>> | InputMaybe<VehicleMake>>;
  models?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  vehicleBrand?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  vehicleModel?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  purchaseYearsRange?: InputMaybe<DateRange>;
  auctioningAgencyName?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  sourcedBankName?: InputMaybe<Array<InputMaybe<BankName>> | InputMaybe<BankName>>;
  repositionDateRange?: InputMaybe<DateRange>;
  pickupDateRange?: InputMaybe<DateRange>;
  driverName?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  driverId?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  centreName?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  paymentStatus?: InputMaybe<Array<InputMaybe<PaymentStatus>> | InputMaybe<PaymentStatus>>;
  isRcAvailable?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<LeadSource>;
  createdAtDateRange?: InputMaybe<DateRange>;
  createdBy?: InputMaybe<Scalars['String']>;
  hasStatus?: InputMaybe<Array<InputMaybe<LeadStatus>> | InputMaybe<LeadStatus>>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetFilteredLeadsQuery = { __typename?: 'Query', filteredLeads?: Array<{ __typename?: 'Lead', id: string, regNo: string, source?: LeadSource, finalBidAmount?: number, createdAt?: any, createdBy?: { __typename?: 'User', name: string }, deliveryCentre?: { __typename?: 'Centre', name: string }, centre?: { __typename?: 'Centre', name: string }, vehicle: { __typename?: 'Vehicle', id: string, manufacturingDate?: any, vehicleBrand?: { __typename?: 'Brand', name: string }, vehicleModel?: { __typename?: 'Model', name: string } }, statusEvents?: Array<{ __typename?: 'LeadStatusEvent', id: string, status: LeadStatus, metadata?: string, deviceType?: DeviceType, assignTaskTo?: UserRole, notifyTo?: Array<UserRole>, taskButtonTitle?: string, taskTitle?: string, createdAt: any, postTimeline?: string, isTaskCompleted?: boolean, preTimeline?: string, remarks?: string, createdBy: { __typename?: 'User', id: string, name: string } }> }> };

export type UpdateBidAmountMutationVariables = Exact<{
  regNo: Scalars['String'];
  proposedBidLimitAmount?: InputMaybe<Scalars['Int']>;
  finalBidAmount?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateBidAmountMutation = { __typename?: 'Mutation', updateLead?: { __typename?: 'UpdateLeadPayload', lead?: Array<{ __typename?: 'Lead', id: string, proposedBidLimitAmount?: number, finalBidAmount?: number, expectedPickupDate?: any, auctionByBank?: BankName }> } };

export type GetYardListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetYardListQuery = { __typename?: 'Query', queryYard?: Array<{ __typename?: 'Yard', id: string, address?: string, locationUrl?: string, spocName?: string, name: string, spocNo?: string }> };

export type UpdateYardDetailsMutationVariables = Exact<{
  name: Scalars['String'];
  address?: InputMaybe<Scalars['String']>;
  locationURL?: InputMaybe<Scalars['String']>;
  spocName?: InputMaybe<Scalars['String']>;
  spocMobile?: InputMaybe<Scalars['String']>;
}>;


export type UpdateYardDetailsMutation = { __typename?: 'Mutation', addYard?: { __typename?: 'AddYardPayload', yard?: Array<{ __typename?: 'Yard', name: string, spocNo?: string, spocName?: string, address?: string, locationUrl?: string }> } };

export type UpdateLeadDetailsMutationVariables = Exact<{
  regNo: Scalars['String'];
  proposedBidLimitAmount?: InputMaybe<Scalars['Int']>;
  finalBidAmount?: InputMaybe<Scalars['Int']>;
  finalParkingCharges?: InputMaybe<Scalars['Int']>;
  sellingprice?: InputMaybe<Scalars['Int']>;
  listingPrice?: InputMaybe<Scalars['Int']>;
  demandAmount?: InputMaybe<Scalars['Int']>;
  approvedDealAmount?: InputMaybe<Scalars['Int']>;
  expectedPickupDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type UpdateLeadDetailsMutation = { __typename?: 'Mutation', updateLead?: { __typename?: 'UpdateLeadPayload', lead?: Array<{ __typename?: 'Lead', regNo: string, id: string, tokenAmount?: number, proposedBidLimitAmount?: number, sellingPrice?: number, approvedDealAmount?: number, demandAmount?: number }> } };

export type UpdateLeadCenterMutationVariables = Exact<{
  regNo: Scalars['String'];
  centerName: Scalars['String'];
}>;


export type UpdateLeadCenterMutation = { __typename?: 'Mutation', updateLead?: { __typename?: 'UpdateLeadPayload', lead?: Array<{ __typename?: 'Lead', regNo: string, centre?: { __typename?: 'Centre', id: string, name: string, regNo?: string } }> } };

export type UpdateLeadVehicleDetailsMutationVariables = Exact<{
  regNo: Scalars['String'];
  model_id?: InputMaybe<Scalars['ID']>;
  brand_id?: InputMaybe<Scalars['ID']>;
  manufacturingDate?: InputMaybe<Scalars['DateTime']>;
  repossesionDateByDriver?: InputMaybe<Scalars['DateTime']>;
  repossesionDateByPE?: InputMaybe<Scalars['DateTime']>;
}>;


export type UpdateLeadVehicleDetailsMutation = { __typename?: 'Mutation', updateVehicle?: { __typename?: 'UpdateVehiclePayload', vehicle?: Array<{ __typename?: 'Vehicle', id: string, manufacturingDate?: any, make?: VehicleMake, model?: string, engineNumber?: string, chassisNumber?: string, registrationDate?: any, repossessionDate?: any, isVehicleInsured?: boolean, fitnessValidUpto?: any }> } };

export type UpdatePickupDetailsMutationVariables = Exact<{
  regNo?: InputMaybe<Scalars['String']>;
  driverEmail?: InputMaybe<Scalars['String']>;
  driverName?: InputMaybe<Scalars['String']>;
}>;


export type UpdatePickupDetailsMutation = { __typename?: 'Mutation', updatePickup?: { __typename?: 'UpdatePickupPayload', pickup?: Array<{ __typename?: 'Pickup', by?: { __typename?: 'User', name: string, email: string } }> } };

export type UpdateLeadDocumentsCheckListMutationVariables = Exact<{
  regNo: Scalars['String'];
  registrationCertificate?: InputMaybe<Scalars['Boolean']>;
  form26?: InputMaybe<Scalars['Boolean']>;
  loanForeclosure?: InputMaybe<Scalars['Boolean']>;
  bankNOC?: InputMaybe<Scalars['Boolean']>;
  form35?: InputMaybe<Scalars['Boolean']>;
  insuranceCertificate?: InputMaybe<Scalars['Boolean']>;
  form28?: InputMaybe<Scalars['Boolean']>;
  form29?: InputMaybe<Scalars['Boolean']>;
  from30?: InputMaybe<Scalars['Boolean']>;
  sellerPAN?: InputMaybe<Scalars['Boolean']>;
  form60?: InputMaybe<Scalars['Boolean']>;
  form36?: InputMaybe<Scalars['Boolean']>;
  sellerAadharCard?: InputMaybe<Scalars['Boolean']>;
  releaseOrder?: InputMaybe<Scalars['Boolean']>;
  indemnityBond?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateLeadDocumentsCheckListMutation = { __typename?: 'Mutation', updateDocumentChecklist?: { __typename?: 'UpdateDocumentChecklistPayload', documentChecklist?: Array<{ __typename?: 'DocumentChecklist', registrationCertificate?: boolean, form26?: boolean, loanForeclosure?: boolean, bankNOC?: boolean, form35?: boolean, insuranceCertificate?: boolean, form28?: boolean, form29?: boolean, form30?: boolean, sellerPAN?: boolean, form36?: boolean, form60?: boolean, sellerAadharCard?: boolean, releaseOrder?: boolean, indemnityBond?: boolean }> } };

export type UpdateRtoDocumentsMutationVariables = Exact<{
  regNo: Scalars['String'];
  rtoVerificationProofUrl?: InputMaybe<Scalars['String']>;
  hypothecationProofUrl?: InputMaybe<Scalars['String']>;
  challanUrl?: InputMaybe<Scalars['String']>;
  hsrbProofUrl?: InputMaybe<Scalars['String']>;
  approvalMailUrl?: InputMaybe<Scalars['String']>;
  blacklistProofUrl?: InputMaybe<Scalars['String']>;
}>;


export type UpdateRtoDocumentsMutation = { __typename?: 'Mutation', updateVehicleDocuments?: { __typename?: 'UpdateVehicleDocumentsPayload', numUids?: number, vehicleDocuments?: Array<{ __typename?: 'VehicleDocuments', id: string, regNo: string, rtoVerificationProofUrl?: string, hypothecationProofUrl?: string, challanUrl?: string, hsrbProofUrl?: string, approvalMailUrl?: string, blacklistProofUrl?: string }> } };

export type UpdateVehicleDetailMutationVariables = Exact<{
  id: Array<Scalars['ID']> | Scalars['ID'];
  regNo: Scalars['String'];
  name: Scalars['String'];
  spocNo?: InputMaybe<Scalars['String']>;
  registrationDate?: InputMaybe<Scalars['DateTime']>;
  repossessionDate?: InputMaybe<Scalars['DateTime']>;
  fitnessValidUpto?: InputMaybe<Scalars['DateTime']>;
  isVehicleInsured?: InputMaybe<Scalars['Boolean']>;
  insurerName?: InputMaybe<InsurerName>;
  insuranceType?: InputMaybe<InsuranceType>;
  policyNumber?: InputMaybe<Scalars['String']>;
  policyExpiryDate?: InputMaybe<Scalars['DateTime']>;
  registrationCertificateUrl?: InputMaybe<Scalars['String']>;
}>;


export type UpdateVehicleDetailMutation = { __typename?: 'Mutation', updateAgency?: { __typename?: 'UpdateAgencyPayload', agency?: Array<{ __typename?: 'Agency', name: string, spocNo?: string }> }, updateVehicle?: { __typename?: 'UpdateVehiclePayload', vehicle?: Array<{ __typename?: 'Vehicle', regNo: string, registrationDate?: any, repossessionDate?: any, fitnessValidUpto?: any, isVehicleInsured?: boolean }> }, updateVehicleInsurance?: { __typename?: 'UpdateVehicleInsurancePayload', vehicleInsurance?: Array<{ __typename?: 'VehicleInsurance', insurerName?: InsurerName, insuranceType?: InsuranceType, policyNumber?: string, policyExpiryDate?: any, vehicle: { __typename?: 'Vehicle', regNo: string, insuranceDetails?: { __typename?: 'VehicleInsurance', insurerName?: InsurerName } } }> }, updateVehicleDocuments?: { __typename?: 'UpdateVehicleDocumentsPayload', vehicleDocuments?: Array<{ __typename?: 'VehicleDocuments', id: string, registrationCertificateUrl?: string }> } };

export type UpdateDealPaymentMutationVariables = Exact<{
  id: Array<Scalars['ID']> | Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  accntno?: InputMaybe<Scalars['String']>;
  bank?: InputMaybe<BankName>;
  ifsc?: InputMaybe<Scalars['String']>;
  proof?: InputMaybe<Scalars['String']>;
}>;


export type UpdateDealPaymentMutation = { __typename?: 'Mutation', updatePayment?: { __typename?: 'UpdatePaymentPayload', payment?: Array<{ __typename?: 'Payment', id: string, bankName?: BankName, accountHolderName?: string, accountNo?: string, ifsc?: string, proofUrl?: string }> } };

export type UpdateDocumentsMutationVariables = Exact<{
  id: Array<Scalars['ID']> | Scalars['ID'];
  bankNOC?: InputMaybe<Scalars['String']>;
  form26?: InputMaybe<Scalars['String']>;
  form28?: InputMaybe<Scalars['String']>;
  form29?: InputMaybe<Scalars['String']>;
  form30?: InputMaybe<Scalars['String']>;
  form35?: InputMaybe<Scalars['String']>;
  form36?: InputMaybe<Scalars['String']>;
  form60?: InputMaybe<Scalars['String']>;
  indemnityBond?: InputMaybe<Scalars['String']>;
  releaseOrder?: InputMaybe<Scalars['String']>;
  insuranceCertificate?: InputMaybe<Scalars['String']>;
  loanForeclosure?: InputMaybe<Scalars['String']>;
  registrationCertificate?: InputMaybe<Scalars['String']>;
  sellerAadharCard?: InputMaybe<Scalars['String']>;
  sellerPAN?: InputMaybe<Scalars['String']>;
}>;


export type UpdateDocumentsMutation = { __typename?: 'Mutation', updateLeadDocuments?: { __typename?: 'UpdateLeadDocumentsPayload', leadDocuments?: Array<{ __typename?: 'LeadDocuments', bankNOC?: string, form26?: string, form28?: string, form29?: string, form30?: string, form35?: string, form36?: string, form60?: string, indemnityBond?: string, releaseOrder?: string, insuranceCertificate?: string, loanForeclosure?: string, registrationCertificate?: string, sellerAadharCard?: string, sellerPAN?: string }> } };

export type GetLeadForSearchQueryVariables = Exact<{
  searchString?: InputMaybe<Scalars['String']>;
}>;


export type GetLeadForSearchQuery = { __typename?: 'Query', queryLead?: Array<{ __typename?: 'Lead', regNo: string }> };

export type LeadPreviewFragment = { __typename?: 'Lead', id: string, regNo: string, source?: LeadSource, finalBidAmount?: number, createdAt?: any, createdBy?: { __typename?: 'User', name: string }, deliveryCentre?: { __typename?: 'Centre', name: string }, centre?: { __typename?: 'Centre', name: string }, vehicle: { __typename?: 'Vehicle', id: string, manufacturingDate?: any, vehicleBrand?: { __typename?: 'Brand', name: string }, vehicleModel?: { __typename?: 'Model', name: string } }, statusEvents?: Array<{ __typename?: 'LeadStatusEvent', id: string, status: LeadStatus, metadata?: string, deviceType?: DeviceType, assignTaskTo?: UserRole, notifyTo?: Array<UserRole>, taskButtonTitle?: string, taskTitle?: string, createdAt: any, postTimeline?: string, isTaskCompleted?: boolean, preTimeline?: string, remarks?: string, createdBy: { __typename?: 'User', id: string, name: string } }> };

export type GetAllStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllStateQuery = { __typename?: 'Query', getStateInfo?: { __typename?: 'CenterlizeLocationStatesResponse', data?: Array<{ __typename?: 'CenterlizeLocationStates', state_id?: number, state_name?: string, tr_state_id?: number, state_code?: string }> } };

export type GetDistrictsByStateQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type GetDistrictsByStateQuery = { __typename?: 'Query', getDistrictByStateInfo?: { __typename?: 'CenterlizeLocationDistrcitsResponse', data?: Array<{ __typename?: 'CenterlizeLocationDistrict', district_name?: string, district_id?: number, state_name?: string }> } };

export type GetTehsilsByDistrictQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type GetTehsilsByDistrictQuery = { __typename?: 'Query', getTehsilByDistricts?: { __typename?: 'CenterlizeLocationTehsilResponse', data?: Array<{ __typename?: 'CenterlizeLocationTehsil', district_name?: string, district_id?: number, state_name?: string, tehsil_id?: number, tehsil_name?: string }> } };

export type CloseLeadsMutationVariables = Exact<{
  id: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type CloseLeadsMutation = { __typename?: 'Mutation', deleteLead?: { __typename?: 'DeleteLeadPayload', numUids?: number, msg?: string } };

export type CloseTaskListMutationVariables = Exact<{
  id: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type CloseTaskListMutation = { __typename?: 'Mutation', deleteLeadStatusEvent?: { __typename?: 'DeleteLeadStatusEventPayload', numUids?: number, msg?: string } };

export type AllLeadsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type AllLeadsQuery = { __typename?: 'Query', queryLead?: Array<{ __typename?: 'Lead', id: string, updatedAt?: any, regNo: string, source?: LeadSource, searchString?: string, finalBidAmount?: number, registrationState?: string, auctionByBank?: BankName, expectedPickupDate?: any, createdAt?: any, deliveryAmount?: number, vehicle: { __typename?: 'Vehicle', id: string, make?: VehicleMake, model?: string, manufacturingDate?: any, purchaseDate?: any, registrationDate?: any, repossessionDate?: any, isRcAvailable?: boolean, vehicleBrand?: { __typename?: 'Brand', id: string, brand_id: number, name: string }, vehicleModel?: { __typename?: 'Model', name: string, id: string, model_id: number } }, auctioningAgency?: { __typename?: 'Agency', id: string, name: string }, payments?: Array<{ __typename?: 'Payment', id: string, for: PaymentFor, createdAt: any, status: PaymentStatus }>, centre?: { __typename?: 'Centre', id: string, name: string }, deliveryCentre?: { __typename?: 'Centre', name: string }, pickup?: { __typename?: 'Pickup', id: string, by?: { __typename?: 'User', id: string, name: string } }, createdBy?: { __typename?: 'User', id: string, phoneNo?: string, name: string }, statusEvents?: Array<{ __typename?: 'LeadStatusEvent', id: string, status: LeadStatus, assignTaskTo?: UserRole, notifyTo?: Array<UserRole>, taskButtonTitle?: string, taskTitle?: string, createdAt: any, postTimeline?: string, preTimeline?: string, isTaskCompleted?: boolean, remarks?: string, createdBy: { __typename?: 'User', id: string, name: string } }> }> };

export type FilteredInventoryQueryVariables = Exact<{
  centreName?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  status?: InputMaybe<Array<InputMaybe<LeadStatus>> | InputMaybe<LeadStatus>>;
  sortByUpdatedAt?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type FilteredInventoryQuery = { __typename?: 'Query', filteredLeads?: Array<{ __typename?: 'Lead', id: string, regNo: string, registrationState?: string, finalBidAmount?: number, source?: LeadSource, status?: LeadBusinessStatus, deliveryAmount?: number, createdAt?: any, vehicle: { __typename?: 'Vehicle', id: string, registrationNumber?: string, make?: VehicleMake, model?: string, manufacturingDate?: any, price?: number, vehicleBrand?: { __typename?: 'Brand', name: string }, vehicleModel?: { __typename?: 'Model', name: string }, owner?: { __typename?: 'VehicleOwner', id: string, district?: string }, images?: Array<{ __typename?: 'VehicleImages', id: string, rightBodySide?: string, frontBodySide?: string }> }, createdBy?: { __typename?: 'User', id: string, phoneNo?: string, name: string }, auctioningAgency?: { __typename?: 'Agency', id: string, name: string, spocNo?: string }, dealer?: { __typename?: 'Dealer', id: string, phoneNo: string }, statusEvents?: Array<{ __typename?: 'LeadStatusEvent', id: string, status: LeadStatus, metadata?: string, deviceType?: DeviceType, assignTaskTo?: UserRole, notifyTo?: Array<UserRole>, taskButtonTitle?: string, taskTitle?: string, createdAt: any, postTimeline?: string, isTaskCompleted?: boolean, preTimeline?: string, remarks?: string, createdBy: { __typename?: 'User', id: string, name: string } }>, centre?: { __typename?: 'Centre', id: string, name: string }, deliveryCentre?: { __typename?: 'Centre', id: string, name: string } }> };

export type GetIdsByNameForListingQueryVariables = Exact<{
  model?: InputMaybe<Scalars['String']>;
  brand?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  tehsil?: InputMaybe<Scalars['String']>;
  env?: InputMaybe<Scalars['String']>;
  engine_hours?: InputMaybe<Scalars['Int']>;
  vehicle_registration_no?: InputMaybe<Scalars['String']>;
  manufacture_month?: InputMaybe<Scalars['String']>;
  manufacture_year?: InputMaybe<Scalars['Int']>;
  rc_available?: InputMaybe<Scalars['String']>;
  seller_name?: InputMaybe<Scalars['String']>;
  mobile_number?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['String']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetIdsByNameForListingQuery = { __typename?: 'Query', getIdsByNameForListing?: { __typename?: 'IdsByNameForListingReponse', status?: boolean, message?: string, data?: { __typename?: 'IdByName', brand_id?: number, district_id?: number, engine_capacity?: string, horse_power?: string, state_id?: number, tahsil_id?: number, model_id?: number } } };

export type MarkAndSoldQueryVariables = Exact<{
  regNo?: InputMaybe<Scalars['String']>;
  env: Scalars['String'];
}>;


export type MarkAndSoldQuery = { __typename?: 'Query', markTractorAsSoldWrapper?: { __typename?: 'MarkSoldResponse', status?: boolean, message?: string } };

export type UpdateImagesMutationVariables = Exact<{
  id?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  leadPatch?: InputMaybe<LeadPatch>;
}>;


export type UpdateImagesMutation = { __typename?: 'Mutation', updateLead?: { __typename?: 'UpdateLeadPayload', numUids?: number } };

export type IsUserRoleAdminQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type IsUserRoleAdminQuery = { __typename?: 'Query', queryUser?: Array<{ __typename?: 'User', name: string, role?: UserRole, email: string, id: string, hasAdminPanelAccess?: boolean, isActive?: boolean, centre?: { __typename?: 'Centre', id: string, name: string } }> };

export type UserStatusSubscriptionVariables = Exact<{
  userId?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type UserStatusSubscription = { __typename?: 'Subscription', queryUser?: Array<{ __typename?: 'User', id: string, name: string, role?: UserRole, isActive?: boolean }> };

export type GetUserQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetUserQuery = { __typename?: 'Query', queryUser?: Array<{ __typename?: 'User', name: string, role?: UserRole, email: string, id: string, hasAdminPanelAccess?: boolean, isActive?: boolean, centre?: { __typename?: 'Centre', name: string, id: string } }> };

export type LogTrackingQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type LogTrackingQuery = { __typename?: 'Query', queryLogTracking?: Array<{ __typename?: 'LogTracking', id: string, createdAt: any, actionType: ActionType, module: ModuleType, sourceUpdated: string, previousValue: string, updatedValue: string, source: DeviceType, status?: TaskStatus, taskPerformedBy: { __typename?: 'User', name: string, role?: UserRole } }> };

export type FilterlogQueryVariables = Exact<{
  filters?: InputMaybe<LogTrackingFilter>;
}>;


export type FilterlogQuery = { __typename?: 'Query', queryLogTracking?: Array<{ __typename?: 'LogTracking', module: ModuleType, actionType: ActionType, source: DeviceType, createdAt: any, id: string, previousValue: string, updatedValue: string, sourceUpdated: string, status?: TaskStatus, taskPerformedBy: { __typename?: 'User', role?: UserRole, name: string } }> };

export type NotificationDataQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationDataQuery = { __typename?: 'Query', queryDocumentsFollowups?: Array<{ __typename?: 'DocumentsFollowups', id: string, followupDate?: any, source?: string, documentName?: string, remarks?: string, nextFollowupDate?: any, lead: { __typename?: 'Lead', regNo: string, id: string } }> };

export type GetProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductsQuery = { __typename?: 'Query', queryProduct?: Array<{ __typename?: 'Product', name: string, variant?: string, id: string }> };

export type GetUsersQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type GetUsersQuery = { __typename?: 'Query', queryUser?: Array<{ __typename?: 'User', id: string, name: string, role?: UserRole, email: string, createdAt?: any, isActive?: boolean, updatedAt?: any, centre?: { __typename?: 'Centre', id: string, name: string, incharge?: { __typename?: 'User', id: string, email: string, name: string } } }> };

export type GetIssueItemDetailsQueryVariables = Exact<{
  purchaseId: Scalars['ID'];
}>;


export type GetIssueItemDetailsQuery = { __typename?: 'Query', getIssue?: { __typename?: 'Issue', status?: IssueStatus, id: string, createdAt: any, regNo?: string, madeBy: { __typename?: 'User', id: string, name: string }, centre: { __typename?: 'Centre', id: string, name: string }, items?: Array<{ __typename?: 'IssueItem', quantity?: number, description?: string, product: { __typename?: 'Product', id: string, name: string, description?: string, variant?: string } }> } };

export type GetPurchaseItemDetailsQueryVariables = Exact<{
  purchaseId: Scalars['ID'];
}>;


export type GetPurchaseItemDetailsQuery = { __typename?: 'Query', getPurchase?: { __typename?: 'Purchase', status?: PurchaseStatus, id: string, createdAt: any, madeBy: { __typename?: 'User', id: string, name: string }, centre: { __typename?: 'Centre', id: string, name: string }, items?: Array<{ __typename?: 'PurchaseItem', quantity?: number, description?: string, product: { __typename?: 'Product', id: string, name: string, description?: string, variant?: string } }> } };

export type UpdateListingPriceMutationVariables = Exact<{
  ListingPrice?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type UpdateListingPriceMutation = { __typename?: 'Mutation', updateLead?: { __typename?: 'UpdateLeadPayload', numUids?: number } };

export type GetUsersSecondQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type GetUsersSecondQuery = { __typename?: 'Query', queryUser?: Array<{ __typename?: 'User', id: string, name: string, role?: UserRole, email: string, createdAt?: any, isActive?: boolean, registrationState?: Array<string>, updatedAt?: any, reportingManager?: { __typename?: 'User', name: string }, centre?: { __typename?: 'Centre', id: string, name: string, incharge?: { __typename?: 'User', id: string, email: string, name: string } } }> };

export type AddUserMutationVariables = Exact<{
  UserPatch: AddUserInput;
}>;


export type AddUserMutation = { __typename?: 'Mutation', addUser?: { __typename?: 'AddUserPayload', user?: Array<{ __typename?: 'User', name: string, email: string, role?: UserRole, createdAt?: any, isActive?: boolean, registrationState?: Array<string>, reportingManager?: { __typename?: 'User', name: string, email: string }, centre?: { __typename?: 'Centre', name: string, id: string } }> } };

export type AddUserWithoutCentreMutationVariables = Exact<{
  name: Scalars['String'];
  email: Scalars['String'];
  role: UserRole;
}>;


export type AddUserWithoutCentreMutation = { __typename?: 'Mutation', addUser?: { __typename?: 'AddUserPayload', user?: Array<{ __typename?: 'User', name: string, email: string, role?: UserRole, centre?: { __typename?: 'Centre', name: string, id: string } }> } };

export type UpdateUserMutationVariables = Exact<{
  UserPatch?: InputMaybe<UserPatch>;
  email?: InputMaybe<Scalars['String']>;
  remove?: InputMaybe<UserPatch>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'UpdateUserPayload', user?: Array<{ __typename?: 'User', name: string, email: string, role?: UserRole, registrationState?: Array<string>, createdAt?: any, updatedAt?: any, isActive?: boolean, reportingManager?: { __typename?: 'User', name: string }, centre?: { __typename?: 'Centre', name: string, id: string } }> } };

export type RefurbishmentDetailsFragFragment = { __typename?: 'RefurbishmentDetails', id: string, isRequired?: boolean, requests?: Array<{ __typename?: 'RefurbishmentRequest', id: string, requestStatus?: RefurbishmentStatus, transportationCharge?: number, items?: Array<{ __typename?: 'RefurbishmentItem', id: string, price?: number, status?: RefurbishmentStatus, refurbishmentProofUrl?: string, quantity?: number, expectedBuyingPrice?: number, product: { __typename?: 'Product', id: string, name: string, variant?: string, description?: string } }>, issue?: { __typename?: 'Issue', id: string, status?: IssueStatus, items?: Array<{ __typename?: 'IssueItem', id: string, price?: number, requestedItemId?: string, quantity?: number, isApproved?: boolean, product: { __typename?: 'Product', id: string, name: string, variant?: string, description?: string } }> }, purchase?: { __typename?: 'Purchase', id: string, status?: PurchaseStatus, items?: Array<{ __typename?: 'PurchaseItem', id: string, price?: number, requestedItemId?: string, purchaseProofUrl?: string, approvedPriceLimit?: number, quantity?: number, description?: string, isApproved?: boolean, product: { __typename?: 'Product', id: string, name: string, variant?: string } }> } }> };

export type GetAllNewBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllNewBrandsQuery = { __typename?: 'Query', queryBrand?: Array<{ __typename?: 'Brand', id: string, name: string, brand_id: number }> };

export type GetAllNewModelsByMakeQueryVariables = Exact<{
  id: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetAllNewModelsByMakeQuery = { __typename?: 'Query', queryBrand?: Array<{ __typename?: 'Brand', models?: Array<{ __typename?: 'Model', id: string, name: string, model_id: number }> }> };

export type NumberOfPendingTasksQueryVariables = Exact<{
  myId: Scalars['ID'];
  role: UserRole;
}>;


export type NumberOfPendingTasksQuery = { __typename?: 'Query', numberOfPendingTasks: { __typename?: 'NumberOfPendingTasks', count: number } };

export type MyPendingTasksQueryVariables = Exact<{
  myId: Scalars['ID'];
  offset?: InputMaybe<Scalars['Int']>;
  role: UserRole;
  centreId?: InputMaybe<Scalars['ID']>;
}>;


export type MyPendingTasksQuery = { __typename?: 'Query', myPendingTasks?: Array<{ __typename?: 'LeadStatusEvent', id: string, createdAt: any, status: LeadStatus, assignTaskTo?: UserRole, notifyTo?: Array<UserRole>, taskTitle?: string, taskButtonTitle?: string, createdBy: { __typename?: 'User', id: string, name: string, email: string }, lead: { __typename?: 'Lead', id: string, regNo: string, centre?: { __typename?: 'Centre', id: string, name: string }, createdBy?: { __typename?: 'User', id: string }, vehicle: { __typename?: 'Vehicle', id: string, make?: VehicleMake, vehicleBrand?: { __typename?: 'Brand', name: string } } } }> };

export type LeadStatusFlowQueryVariables = Exact<{
  source?: InputMaybe<LeadSource>;
}>;


export type LeadStatusFlowQuery = { __typename?: 'Query', queryLeadStatusFlow?: Array<{ __typename?: 'LeadStatusFlow', notificationTitle?: string, notifyTo?: Array<UserRole>, taskTitle?: string, assignTaskTo?: UserRole, next?: LeadStatus, current?: LeadStatus, previous?: LeadStatus, taskButtonTitle?: string, taskFormActionTitle?: string, taskFormNegativeActionTitle?: string, isNegativeCase?: boolean, canGoBack?: boolean, desired?: LeadStatus, undesired?: LeadStatus, taskTitleWas?: string, cta?: string, taskPerformedBy?: UserRole, showPopup?: boolean, showPopupWithInputField?: boolean, popupTitle?: string, popupDescription?: string, hideForm?: boolean, showPopupRemark?: boolean, canGoForward?: boolean, source?: LeadSource, hideUndesiredButton?: boolean }> };

export type CreateFakeUserWithRoleMutationVariables = Exact<{
  role?: InputMaybe<UserRole>;
  fakeEmail: Scalars['String'];
  fakeName: Scalars['String'];
  pnsToken?: InputMaybe<Scalars['String']>;
  phoneNo: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  centre?: InputMaybe<CentreRef>;
}>;


export type CreateFakeUserWithRoleMutation = { __typename?: 'Mutation', addUser?: { __typename?: 'AddUserPayload', user?: Array<{ __typename?: 'User', id: string, name: string, email: string, expoPushNotificationAddress?: string, role?: UserRole, centre?: { __typename?: 'Centre', id: string, name: string } }> } };

export type CreateLeadStatusEventMutationVariables = Exact<{
  lead: LeadRef;
  status: LeadStatus;
  myId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  remarks?: InputMaybe<Scalars['String']>;
  assignTaskTo?: InputMaybe<UserRole>;
  notifyTo?: InputMaybe<Array<InputMaybe<UserRole>> | InputMaybe<UserRole>>;
  taskTitle?: InputMaybe<Scalars['String']>;
  taskButtonTitle?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['String']>;
}>;


export type CreateLeadStatusEventMutation = { __typename?: 'Mutation', addLeadStatusEvent?: { __typename?: 'AddLeadStatusEventPayload', leadStatusEvent?: Array<{ __typename?: 'LeadStatusEvent', id: string, status: LeadStatus, metadata?: string, deviceType?: DeviceType, assignTaskTo?: UserRole, notifyTo?: Array<UserRole>, taskButtonTitle?: string, taskTitle?: string, createdAt: any, postTimeline?: string, isTaskCompleted?: boolean, preTimeline?: string, remarks?: string, lead: { __typename?: 'Lead', id: string, regNo: string, expenses?: Array<{ __typename?: 'LeadExpense', category: ExpenseCategory }> }, createdBy: { __typename?: 'User', id: string, name: string } }> } };

export type UpdatesForMyRoleQueryVariables = Exact<{
  myRole?: InputMaybe<Array<UserRole> | UserRole>;
  offset?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type UpdatesForMyRoleQuery = { __typename?: 'Query', queryLeadStatusEvent?: Array<{ __typename?: 'LeadStatusEvent', id: string, createdAt: any, status: LeadStatus, remarks?: string, lead: { __typename?: 'Lead', id: string, regNo: string, vehicle: { __typename?: 'Vehicle', id: string, make?: VehicleMake, vehicleBrand?: { __typename?: 'Brand', name: string } } }, createdBy: { __typename?: 'User', id: string, name: string } }> };

export type DriversQueryVariables = Exact<{ [key: string]: never; }>;


export type DriversQuery = { __typename?: 'Query', queryUser?: Array<{ __typename?: 'User', id: string, name: string, phoneNo?: string, pickups?: Array<{ __typename?: 'Pickup', id: string, regNo: string }> }> };

export type GetLeadDealDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetLeadDealDetailsQuery = { __typename?: 'Query', getLead?: { __typename?: 'Lead', id: string, regNo: string, source?: LeadSource, auctionByBank?: BankName, demandAmount?: number, proposedDealAmount?: number, approvedDealAmount?: number, documentCharges?: number, tokenAmount?: number, holdbackAmount?: number, deliveryAmount?: number, loanAmount?: number, loanToBeClosedBy?: LoanToBeClosedBy, paymentType?: PaymentType, finalBidAmount?: number, proposedBidLimitAmount?: number, createdAt?: any, ownershipType?: Ownership, statusEvents?: Array<{ __typename?: 'LeadStatusEvent', id: string, status: LeadStatus, remarks?: string, createdAt: any }>, activeBooking?: { __typename?: 'Booking', id: string, isInsuranceReq?: boolean, isRCTransferReq?: boolean, bookingPayment?: { __typename?: 'BookingPayment', id: string, saleAmount: number, bookingType?: BookingType, bookingPaymentMode?: BookingType, totalSaleAmount?: number, rcTransferAmount?: number, insuranceAmount?: number, appliedLoanAmount?: number }, activeLoan?: { __typename?: 'Loan', id: string, appliedLoanAmount?: number, sanctionedLoanAmount?: number, createdAt?: any }, payments?: Array<{ __typename?: 'Payment', amount?: number, status: PaymentStatus, for: PaymentFor }> }, payments?: Array<{ __typename?: 'Payment', id: string, for: PaymentFor, status: PaymentStatus, amount?: number, receiptUrl?: string, type?: PaymentType, loanClosedBy?: LoanToBeClosedBy, mode?: PaymentMethod, parkingBeneficiary?: { __typename?: 'ParkingBeneficiary', id: string, accountHolderName: string, accountNumber: string, bankName?: BankName, ifscCode: string, upiId?: string, proofUrl?: string } }>, vehicle: { __typename?: 'Vehicle', id: string, manufacturingDate?: any, make?: VehicleMake, model?: string, engineNumber?: string, chassisNumber?: string, isVehicleInsured?: boolean, isRcAvailable?: boolean, hoursMeter?: number, isVehicleFinanced?: boolean, financingDetails?: { __typename?: 'VehicleFinancing', id: string, isLoanClosed?: boolean, pendingLoanAmount?: number, loanToBeClosedBy?: LoanToBeClosedBy, tempLoanToBeClosedBy?: LoanToBeClosedBy } }, refurbishmentDetails?: { __typename?: 'RefurbishmentDetails', requests?: Array<{ __typename?: 'RefurbishmentRequest', id: string, requestStatus?: RefurbishmentStatus, items?: Array<{ __typename?: 'RefurbishmentItem', id: string, status?: RefurbishmentStatus, installationProofUrl?: string, description?: string, product: { __typename?: 'Product', id: string, name: string } }>, issue?: { __typename?: 'Issue', items?: Array<{ __typename?: 'IssueItem', description?: string, product: { __typename?: 'Product', name: string } }> } }> } } };

export type GetLeadDealAmountsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetLeadDealAmountsQuery = { __typename?: 'Query', getLead?: { __typename?: 'Lead', id: string, regNo: string, source?: LeadSource, auctionByBank?: BankName, demandAmount?: number, proposedDealAmount?: number, approvedDealAmount?: number, documentCharges?: number, tokenAmount?: number, holdbackAmount?: number, deliveryAmount?: number, loanAmount?: number, finalBidAmount?: number, proposedBidLimitAmount?: number, createdAt?: any, ownershipType?: Ownership, activeBooking?: { __typename?: 'Booking', isInsuranceReq?: boolean, isRCTransferReq?: boolean, bookingPayment?: { __typename?: 'BookingPayment', saleAmount: number, totalSaleAmount?: number, bookingType?: BookingType, appliedLoanAmount?: number } } } };

export type GetYardDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetYardDetailsQuery = { __typename?: 'Query', getLead?: { __typename?: 'Lead', id: string, regNo: string, expectedPickupDate?: any, yardPerDayParkingCharges?: number, vehicle: { __typename?: 'Vehicle', repossessionDate?: any }, yard?: { __typename?: 'Yard', id: string, perDayParkingCharge?: number, name: string, spocName?: string, spocNo?: string, address?: string, city?: string, locationUrl?: string, tempPerDayParkingCharge?: number }, internalTransfers?: Array<{ __typename?: 'VehicleTransferLog', id: string, assignedTo?: { __typename?: 'User', name: string }, to?: { __typename?: 'Centre', id: string, name: string, location?: { __typename?: 'Point', latitude: number, longitude: number } }, from?: { __typename?: 'Centre', name: string, location?: { __typename?: 'Point', latitude: number, longitude: number } } }> } };

export type GetAllParkingBeneficiaryQueryVariables = Exact<{
  id?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type GetAllParkingBeneficiaryQuery = { __typename?: 'Query', queryParkingBeneficiary?: Array<{ __typename?: 'ParkingBeneficiary', id: string, accountHolderName: string, accountNumber: string, ifscCode: string, bankName?: BankName, proofUrl?: string }> };

export type GetDocumentDetailsFormQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetDocumentDetailsFormQuery = { __typename?: 'Query', getLead?: { __typename?: 'Lead', id: string, regNo: string, documentCharges?: number, holdbackAmount?: number, proposedDealAmount?: number, approvedDealAmount?: number, tokenAmount?: number, demandAmount?: number, ownershipType?: Ownership, dealerStance?: { __typename?: 'DealerStance', clearChallan?: boolean, clearHSRP?: boolean, clearBlackList?: boolean }, payments?: Array<{ __typename?: 'Payment', amount?: number, type?: PaymentType, loanClosedBy?: LoanToBeClosedBy, for: PaymentFor, status: PaymentStatus }>, statusEvents?: Array<{ __typename?: 'LeadStatusEvent', status: LeadStatus, remarks?: string }>, documentChecklist?: { __typename?: 'DocumentChecklist', bankNOC?: boolean, form26?: boolean, form28?: boolean, form29?: boolean, form30?: boolean, form35?: boolean, indemnityBond?: boolean, releaseOrder?: boolean, insuranceCertificate?: boolean, loanForeclosure?: boolean, registrationCertificate?: boolean, sellerAadharCard?: boolean, form36?: boolean, form60_sellerPan?: boolean, ownerAddressProof?: boolean }, dealershipDocuments?: { __typename?: 'DealershipDocument', bankNOC?: { __typename?: 'Document', isAvailable?: boolean, expectedDate?: any }, form26?: { __typename?: 'Document', isAvailable?: boolean, expectedDate?: any }, form28?: { __typename?: 'Document', isAvailable?: boolean, expectedDate?: any }, form29?: { __typename?: 'Document', isAvailable?: boolean, expectedDate?: any }, form30?: { __typename?: 'Document', isAvailable?: boolean, expectedDate?: any }, form35?: { __typename?: 'Document', isAvailable?: boolean, expectedDate?: any }, form60_sellerPan?: { __typename?: 'Document', isAvailable?: boolean, expectedDate?: any }, insuranceCertificate?: { __typename?: 'Document', isAvailable?: boolean, expectedDate?: any }, loanForeclosure?: { __typename?: 'Document', isAvailable?: boolean, expectedDate?: any }, registrationCertificate?: { __typename?: 'Document', isAvailable?: boolean, expectedDate?: any }, sellerAadharCard?: { __typename?: 'Document', isAvailable?: boolean, expectedDate?: any }, form36?: { __typename?: 'Document', isAvailable?: boolean, expectedDate?: any }, ownerAddressProof?: { __typename?: 'Document', isAvailable?: boolean, expectedDate?: any } }, vehicle: { __typename?: 'Vehicle', isVehicleFinanced?: boolean, isBlacklisted?: boolean, isHSRPAvailable?: boolean, isChallanAvailable?: boolean, manufacturingDate?: any, hoursMeter?: number, financingDetails?: { __typename?: 'VehicleFinancing', pendingLoanAmount?: number, isLoanClosed?: boolean, loanToBeClosedBy?: LoanToBeClosedBy }, vehicleBrand?: { __typename?: 'Brand', name: string }, vehicleModel?: { __typename?: 'Model', name: string } } } };

export type FinalCostQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FinalCostQuery = { __typename?: 'Query', getLead?: { __typename?: 'Lead', id: string, proposedBidLimitAmount?: number, finalBidAmount?: number, finalParkingCharges?: number, holdbackAmount?: number, documentCharges?: number, yardPerDayParkingCharges?: number, yardPerDayParkingChargesByDriver?: number, expectedPickupDate?: any, actualPickupDate?: any, tokenAmount?: number, estimatedParkingCharges?: number, actualParkingCharges?: number, dealerStance?: { __typename?: 'DealerStance', clearChallan?: boolean, clearBlackList?: boolean, clearHSRP?: boolean }, pickup?: { __typename?: 'Pickup', id: string, pickupStartTime?: any, pickEndTime?: any }, payments?: Array<{ __typename?: 'Payment', id: string, for: PaymentFor, status: PaymentStatus, amount?: number }>, yard?: { __typename?: 'Yard', id: string, tempPerDayParkingCharge?: number, perDayParkingCharge?: number }, vehicle: { __typename?: 'Vehicle', id: string, repossessionDate?: any, tempRepossessionDate?: any } } };

export type GetLeadDetailForAdminQueryVariables = Exact<{
  leadId: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetLeadDetailForAdminQuery = { __typename?: 'Query', queryLead?: Array<{ __typename?: 'Lead', id: string, regNo: string, finalBidAmount?: number, finalParkingCharges?: number, centre?: { __typename?: 'Centre', name: string }, expenses?: Array<{ __typename?: 'LeadExpense', spentAmount: string, paymentStatus?: PaymentStatus }>, statusEvents?: Array<{ __typename?: 'LeadStatusEvent', createdAt: any, status: LeadStatus, assignTaskTo?: UserRole, createdBy: { __typename?: 'User', name: string } }> }> };

export type GetDriverQueryVariables = Exact<{
  leadId: Scalars['ID'];
}>;


export type GetDriverQuery = { __typename?: 'Query', getLead?: { __typename?: 'Lead', id: string, yard?: { __typename?: 'Yard', id: string, locationUrl?: string, name: string, address?: string, location?: { __typename?: 'Point', longitude: number, latitude: number } }, centre?: { __typename?: 'Centre', id: string, name: string, address?: string, location?: { __typename?: 'Point', longitude: number, latitude: number } }, pickup?: { __typename?: 'Pickup', id: string, by?: { __typename?: 'User', id: string, name: string } } } };

export type LeadUpdateQueryVariables = Exact<{
  id: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type LeadUpdateQuery = { __typename?: 'Query', queryLead?: Array<{ __typename?: 'Lead', regNo: string, source?: LeadSource, status?: LeadBusinessStatus, demandAmount?: number, ownershipType?: Ownership, auctionByBank?: BankName, vehicle: { __typename?: 'Vehicle', hoursMeter?: number, engineNumber?: string, chassisNumber?: string, registrationNumber?: string, make?: VehicleMake, model?: string, manufacturingDate?: any, vehicleBrand?: { __typename?: 'Brand', id: string, name: string }, vehicleModel?: { __typename?: 'Model', id: string, name: string } } }> };

export type PopupDynamicValuesQueryVariables = Exact<{
  regNo: Scalars['String'];
  requestId?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type PopupDynamicValuesQuery = { __typename?: 'Query', getLead?: { __typename?: 'Lead', id: string, regNo: string, listingStatus?: ListingStatus, proposedBidLimitAmount?: number, demandAmount?: number, approvedDealAmount?: number, proposedDealAmount?: number, finalBidAmount?: number, deliveryAmount?: number, activeBooking?: { __typename?: 'Booking', isRCTransferReq?: boolean, isInsuranceReq?: boolean, id: string, activeLoan?: { __typename?: 'Loan', loginDate?: any, fieldInspectionDate?: any, fieldInspectionConfirmedDate?: any, id: string, sanctionedLoanAmount?: number }, payments?: Array<{ __typename?: 'Payment', id: string, for: PaymentFor, status: PaymentStatus, amount?: number }> }, payments?: Array<{ __typename?: 'Payment', id: string, status: PaymentStatus, amount?: number, for: PaymentFor }>, expenses?: Array<{ __typename?: 'LeadExpense', id: string, paymentStatus?: PaymentStatus, spentAmount: string }>, refurbishmentDetails?: { __typename?: 'RefurbishmentDetails', id: string, requests?: Array<{ __typename?: 'RefurbishmentRequest', id: string, transportationCharge?: number, items?: Array<{ __typename?: 'RefurbishmentItem', id: string, status?: RefurbishmentStatus, price?: number }>, purchase?: { __typename?: 'Purchase', id: string, status?: PurchaseStatus, items?: Array<{ __typename?: 'PurchaseItem', isApproved?: boolean, id: string, price?: number, approvedPriceLimit?: number, purchaseProofUrl?: string }> } }> }, pickup?: { __typename?: 'Pickup', id: string, by?: { __typename?: 'User', id: string, name: string } }, statusEventsAggregate?: { __typename?: 'LeadStatusEventAggregateResult', count?: number } } };

export type GetCenterFormLeadQueryVariables = Exact<{
  leadId: Scalars['ID'];
}>;


export type GetCenterFormLeadQuery = { __typename?: 'Query', getLead?: { __typename?: 'Lead', regNo: string, centre?: { __typename?: 'Centre', id: string, name: string } } };

export type RefurbishmentRequestDetailsQueryVariables = Exact<{
  leadId?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type RefurbishmentRequestDetailsQuery = { __typename?: 'Query', queryLead?: Array<{ __typename?: 'Lead', id: string, regNo: string, refurbishmentDetails?: { __typename?: 'RefurbishmentDetails', requests?: Array<{ __typename?: 'RefurbishmentRequest', id: string, items?: Array<{ __typename?: 'RefurbishmentItem', id: string, description?: string, price?: number, status?: RefurbishmentStatus, refurbishmentProofUrl?: string, product: { __typename?: 'Product', id: string, name: string } }> }> } }> };

export type GetLeadRefurbishmentDetailsQueryVariables = Exact<{
  leadId?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type GetLeadRefurbishmentDetailsQuery = { __typename?: 'Query', queryLead?: Array<{ __typename?: 'Lead', id: string, source?: LeadSource, refurbishmentDetails?: { __typename?: 'RefurbishmentDetails', id: string, isRequired?: boolean, requests?: Array<{ __typename?: 'RefurbishmentRequest', id: string, requestStatus?: RefurbishmentStatus, transportationCharge?: number, items?: Array<{ __typename?: 'RefurbishmentItem', id: string, price?: number, status?: RefurbishmentStatus, refurbishmentProofUrl?: string, quantity?: number, expectedBuyingPrice?: number, product: { __typename?: 'Product', id: string, name: string, variant?: string, description?: string } }>, issue?: { __typename?: 'Issue', id: string, status?: IssueStatus, items?: Array<{ __typename?: 'IssueItem', id: string, price?: number, requestedItemId?: string, quantity?: number, isApproved?: boolean, product: { __typename?: 'Product', id: string, name: string, variant?: string, description?: string } }> }, purchase?: { __typename?: 'Purchase', id: string, status?: PurchaseStatus, items?: Array<{ __typename?: 'PurchaseItem', id: string, price?: number, requestedItemId?: string, purchaseProofUrl?: string, approvedPriceLimit?: number, quantity?: number, description?: string, isApproved?: boolean, product: { __typename?: 'Product', id: string, name: string, variant?: string } }> } }> } }> };

export type ProcurementCostQueryVariables = Exact<{
  leadId?: InputMaybe<Scalars['ID']>;
  requestId?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type ProcurementCostQuery = { __typename?: 'Query', getLead?: { __typename?: 'Lead', id: string, regNo: string, source?: LeadSource, documentCharges?: number, sellingPrice?: number, vehicle: { __typename?: 'Vehicle', id: string, images?: Array<{ __typename?: 'VehicleImages', vehicleImagesId: string, frontBodySide?: string, backBodySide?: string, backLeftTyre?: string, backRightTyre?: string, leftBodySide?: string, rightBodySide?: string, chassisNumber?: string, engineNumber?: string, frontLeftTyre?: string, frontRightTyre?: string, fuelInjectionPumpPlate?: string, imagesTakenAtStage?: ImageStage, odometer?: string }> }, payments?: Array<{ __typename?: 'Payment', id: string, for: PaymentFor, status: PaymentStatus, amount?: number }>, refurbishmentDetails?: { __typename?: 'RefurbishmentDetails', id: string, requests?: Array<{ __typename?: 'RefurbishmentRequest', id: string, requestStatus?: RefurbishmentStatus, transportationCharge?: number, issue?: { __typename?: 'Issue', id: string, status?: IssueStatus, items?: Array<{ __typename?: 'IssueItem', id: string, price?: number, isApproved?: boolean, quantity?: number, product: { __typename?: 'Product', id: string, name: string, variant?: string } }> }, purchase?: { __typename?: 'Purchase', id: string, totalPrice?: number, items?: Array<{ __typename?: 'PurchaseItem', approvedPriceLimit?: number, description?: string, price?: number, product: { __typename?: 'Product', name: string } }>, payment?: { __typename?: 'Payment', amount?: number, status: PaymentStatus } } }> } } };

export type GetBookingPaymentForReviewQueryVariables = Exact<{
  leadId: Scalars['ID'];
}>;


export type GetBookingPaymentForReviewQuery = { __typename?: 'Query', getLead?: { __typename?: 'Lead', id: string, activeBooking?: { __typename?: 'Booking', id: string, payments?: Array<{ __typename?: 'Payment', id: string, for: PaymentFor, amount?: number, status: PaymentStatus, createdAt: any, mode?: PaymentMethod }> } } };

export type GetDeliveryPaymentQueryVariables = Exact<{
  leadId: Scalars['ID'];
}>;


export type GetDeliveryPaymentQuery = { __typename?: 'Query', getLead?: { __typename?: 'Lead', id: string, regNo: string, activeBooking?: { __typename?: 'Booking', isInsuranceReq?: boolean, isRCTransferReq?: boolean, payments?: Array<{ __typename?: 'Payment', amount?: number, status: PaymentStatus }>, activeLoan?: { __typename?: 'Loan', id: string, appliedLoanAmount?: number, sanctionedLoanAmount?: number, createdAt?: any }, bookingPayment?: { __typename?: 'BookingPayment', saleAmount: number, bookingType?: BookingType } } } };

export type GetPartPaymentQueryVariables = Exact<{
  regNo: Scalars['String'];
}>;


export type GetPartPaymentQuery = { __typename?: 'Query', getLead?: { __typename?: 'Lead', id: string, regNo: string, activeBooking?: { __typename?: 'Booking', isInsuranceReq?: boolean, isRCTransferReq?: boolean, payments?: Array<{ __typename?: 'Payment', amount?: number, status: PaymentStatus }>, activeLoan?: { __typename?: 'Loan', id: string, appliedLoanAmount?: number, sanctionedLoanAmount?: number, createdAt?: any }, bookingPayment?: { __typename?: 'BookingPayment', saleAmount: number, bookingType?: BookingType } } } };

export type GetBookingInforQueryVariables = Exact<{
  regNo: Scalars['String'];
}>;


export type GetBookingInforQuery = { __typename?: 'Query', getLead?: { __typename?: 'Lead', id: string, regNo: string, activeBooking?: { __typename?: 'Booking', vehicleTransferFormUrl?: string, isInsuranceReq?: boolean, isRCTransferReq?: boolean, customer: { __typename?: 'Customer', customerId?: CustomerId, name?: string, phoneNo: string, customerState?: { __typename?: 'StateCodeWithRegNumber', state: string, id: string }, customerDistrict?: { __typename?: 'District', name: string }, identificationDocuments?: { __typename?: 'IdentificationDocument', aadhaarBackPhotoUrl?: string, aadhaarFrontPhotoUrl?: string, aadhaarNumber?: string, voterIdPhotoUrl?: string, voterIdNumber?: string, panNumber?: string, panPhotoUrl?: string } }, payments?: Array<{ __typename?: 'Payment', amount?: number, status: PaymentStatus }>, activeLoan?: { __typename?: 'Loan', id: string, appliedLoanAmount?: number, sanctionedLoanAmount?: number, createdAt?: any }, bookingPayment?: { __typename?: 'BookingPayment', saleAmount: number, bookingType?: BookingType, createdAt?: any, appliedLoanAmount?: number } } } };

export type DropQueryVariables = Exact<{
  leadId: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DropQuery = { __typename?: 'Query', queryLead?: Array<{ __typename?: 'Lead', id: string, regNo: string, statusEvents?: Array<{ __typename?: 'LeadStatusEvent', status: LeadStatus, remarks?: string }> }> };

export type GetAllRefurbishmentBeneficiaryQueryVariables = Exact<{
  id?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type GetAllRefurbishmentBeneficiaryQuery = { __typename?: 'Query', queryRefurbishmentBeneficiary?: Array<{ __typename?: 'RefurbishmentBeneficiary', id: string, accountHolderName: string, accountNumber: string, ifscCode: string, bankName?: BankName, proofUrl?: string }> };

export type GetLeadDetailsQueryVariables = Exact<{
  regNo: Scalars['String'];
}>;


export type GetLeadDetailsQuery = { __typename?: 'Query', getLead?: { __typename?: 'Lead', statusEvents?: Array<{ __typename?: 'LeadStatusEvent', assignTaskTo?: UserRole, createdAt: any, id: string, isTaskCompleted?: boolean, taskTitle?: string, status: LeadStatus, createdBy: { __typename?: 'User', name: string }, task?: { __typename?: 'Task', id: string, title: string } }> } };

export type RefurbishmentRequestIdQueryVariables = Exact<{
  leadId?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type RefurbishmentRequestIdQuery = { __typename?: 'Query', queryLead?: Array<{ __typename?: 'Lead', regNo: string, listingStatus?: ListingStatus, statusEvents?: Array<{ __typename?: 'LeadStatusEvent', id: string, metadata?: string, status: LeadStatus }>, refurbishmentDetails?: { __typename?: 'RefurbishmentDetails', requests?: Array<{ __typename?: 'RefurbishmentRequest', id: string }> } }> };

export type GetTaskIdQueryVariables = Exact<{
  userId: Scalars['ID'];
  role: UserRole;
}>;


export type GetTaskIdQuery = { __typename?: 'Query', myPendingTasks?: Array<{ __typename?: 'LeadStatusEvent', id: string, createdAt: any, status: LeadStatus, assignTaskTo?: UserRole, createdBy: { __typename?: 'User', id: string, name: string, email: string }, lead: { __typename?: 'Lead', id: string, regNo: string, createdBy?: { __typename?: 'User', id: string } } }> };

export type AllCentresQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCentresQuery = { __typename?: 'Query', queryCentre?: Array<{ __typename?: 'Centre', id: string, name: string, location?: { __typename?: 'Point', longitude: number, latitude: number }, incharge?: { __typename?: 'User', id: string, name: string, email: string, centre?: { __typename?: 'Centre', id: string, name: string } } }> };

export type GetAllYardQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllYardQuery = { __typename?: 'Query', queryYard?: Array<{ __typename?: 'Yard', id: string, name: string, perDayParkingCharge?: number, tempPerDayParkingCharge?: number, address?: string, spocName?: string, spocNo?: string, city?: string, locationUrl?: string, location?: { __typename?: 'Point', longitude: number, latitude: number } }> };

export type UpdateLeadMutationVariables = Exact<{
  leadId: Scalars['ID'];
  leadPatch: LeadPatch;
  regNo: StringHashFilter_StringRegExpFilter_StringTermFilter;
}>;


export type UpdateLeadMutation = { __typename?: 'Mutation', updateLead?: { __typename?: 'UpdateLeadPayload', lead?: Array<{ __typename?: 'Lead', id: string, regNo: string, listingPrice?: number }> } };

export type UpdateListingStatusOnVmsMutationVariables = Exact<{
  leadId: Scalars['ID'];
  leadPatch: LeadPatch;
  regNo: StringHashFilter_StringRegExpFilter_StringTermFilter;
}>;


export type UpdateListingStatusOnVmsMutation = { __typename?: 'Mutation', updateLead?: { __typename?: 'UpdateLeadPayload', lead?: Array<{ __typename?: 'Lead', id: string, regNo: string, listingPrice?: number }> } };

export type AddLogsMutationVariables = Exact<{
  taskPerformedBy: UserRef;
  actionType: ActionType;
  createdAt: Scalars['DateTime'];
  module: ModuleType;
  sourceUpdated: Scalars['String'];
  updatedValue: Scalars['String'];
  previousValue: Scalars['String'];
  status?: InputMaybe<TaskStatus>;
}>;


export type AddLogsMutation = { __typename?: 'Mutation', addLogTracking?: { __typename?: 'AddLogTrackingPayload', numUids?: number } };

export type AddVehicleImagesMutationVariables = Exact<{
  input: AddVehicleImagesInput;
}>;


export type AddVehicleImagesMutation = { __typename?: 'Mutation', addVehicleImages?: { __typename?: 'AddVehicleImagesPayload', vehicleImages?: Array<{ __typename?: 'VehicleImages', id: string, backBodySide?: string, leftBodySide?: string, frontBodySide?: string, rightBodySide?: string, backRightTyre?: string, frontRightTyre?: string, fuelInjectionPumpPlate?: string, odometer?: string, inspectionVideoUrl?: string, backLeftTyre?: string, frontLeftTyre?: string, engineNumber?: string, chassisNumber?: string, imagesTakenAtStage?: ImageStage, vehicle: { __typename?: 'Vehicle', id: string } }> } };

export type YardlistQueryVariables = Exact<{ [key: string]: never; }>;


export type YardlistQuery = { __typename?: 'Query', queryYard?: Array<{ __typename?: 'Yard', name: string, city?: string, id: string, spocName?: string, locationUrl?: string, address?: string, spocNo?: string }> };

export type YardlistValueQueryVariables = Exact<{
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type YardlistValueQuery = { __typename?: 'Query', queryYard?: Array<{ __typename?: 'Yard', name: string, city?: string, id: string, spocName?: string, locationUrl?: string, address?: string, spocNo?: string }> };

export type FormDataQueryVariables = Exact<{
  regNo?: InputMaybe<Scalars['String']>;
}>;


export type FormDataQuery = { __typename?: 'Query', queryLead?: Array<{ __typename?: 'Lead', id: string, regNo: string, source?: LeadSource, ownershipType?: Ownership, demandAmount?: number, centre?: { __typename?: 'Centre', name: string, id: string }, vehicle: { __typename?: 'Vehicle', hoursMeter?: number, manufacturingDate?: any, vehicleBrand?: { __typename?: 'Brand', name: string }, vehicleModel?: { __typename?: 'Model', name: string }, images?: Array<{ __typename?: 'VehicleImages', id: string, inspectionVideoUrl?: string, frontLeftTyre?: string, frontRightTyre?: string, backRightTyre?: string, backLeftTyre?: string, odometer?: string, frontBodySide?: string, backBodySide?: string, leftBodySide?: string, rightBodySide?: string, fuelInjectionPumpPlate?: string, chassisNumber?: string, engineNumber?: string }> } }> };

export type CheckStatusQueryVariables = Exact<{
  status?: InputMaybe<Array<InputMaybe<LeadStatus>> | InputMaybe<LeadStatus>>;
}>;


export type CheckStatusQuery = { __typename?: 'Query', filteredLeads?: Array<{ __typename?: 'Lead', id: string, regNo: string }> };

export const CenterPreviewFragmentDoc = gql`
    fragment CenterPreview on Centre {
  id
  name
  leads @cascade(fields: ["statusEvents"]) {
    regNo
    statusEvents(filter: {status: {eq: VEHICLE_IN_STOCK}}) {
      id
    }
  }
  address
  name
  state
  pincode
  address
  city
  createdAt
  updatedAt
  status
  employees(filter: {role: {eq: CENTRE_MANAGER}}) {
    name
  }
  incharge {
    name
  }
}
    `;
export const LeadDocumentsDetailsFragmentDoc = gql`
    fragment LeadDocumentsDetails on LeadDocuments {
  id
  regNo
  registrationCertificate
  form26
  form30
  form29
  form36
  sellerPAN
  form60
  form60_sellerPan
  sellerAadharCard
  ownerAddressProof
  releaseOrder
  indemnityBond
  bankAccountProofUrl
  dealPaymentProofUrl
  parkingPaymentProofUrl
  loanForeclosure
  bankNOC
  form35
  insuranceCertificate
  form28
}
    `;
export const RefurbishmentRequestDetailsFragmentDoc = gql`
    fragment RefurbishmentRequestDetails on RefurbishmentDetails {
  isRequired
  requests {
    transportationCharge
    id
    requestStatus
    createdAt
    issue {
      id
      status
      items {
        id
        price
        isApproved
        quantity
        product {
          id
          name
          variant
        }
      }
    }
    purchase {
      id
      totalPrice
      createdAt
      items {
        id
        approvedPriceLimit
        purchaseProofUrl
        product {
          name
        }
        description
        price
      }
      payment {
        id
        for
        status
        amount
        createdAt
        paymentProcessedAt
        receiptUrl
        proofUrl
        mode
        modeFM
        source
        paymentTo
        accountHolderName
        bankName
        accountNo
        ifsc
        upiId
        refurbishmentBeneficiary {
          id
          accountHolderName
          accountNumber
          bankName
          ifscCode
          upiId
          proofUrl
        }
      }
    }
    items {
      id
      price
      refurbishmentProofUrl
      installationProofUrl
      status
      product {
        id
        name
      }
      description
    }
  }
}
    `;
export const ActiveLoanDetailsFragmentDoc = gql`
    fragment ActiveLoanDetails on Loan {
  id
  deliveryOrderDate
  loanStatus
  fieldInspectionConfirmedDate
  deliveryOrderValidity
  sanctionedLoanAmount
  deliveryOrderDocUrl
  createdAt
  updatedAt
  rejectedAt
  rejectionReason
  loginStatus
  fieldInspectionStatus
  deliveryOrderStatus
  appliedLoanAmount
  loanStage
  bankName
  loginDate
  loginApplicationFormUrl
  fieldInspectionDate
  loanCancelReason
}
    `;
export const ActiveBookingDetailsFragmentDoc = gql`
    fragment ActiveBookingDetails on Booking {
  id
  deliveryPhotoUrl
  createdAt
  updatedAt
  status
  isRCTransferReq
  isInsuranceReq
  loanCancellationReason
  isLoanDrop
  vehicleTransferFormUrl
  cheque
  cancelledChequeUrl
  deliveryForm
  archivedLoans(first: -1) {
    id
    rejectionReason
    loanStatus
    loanCancelReason
  }
  activeLoan {
    ...ActiveLoanDetails
  }
  payments {
    id
    for
    status
    mode
    amount
    createdAt
    proofUrl
    invoice {
      id
      GSTNumber
      invoiceId
    }
    paymentProcessedAt
    confirmedBy {
      id
      name
    }
    receiptUrl
    parkingBeneficiary {
      id
      accountHolderName
    }
  }
  bookingPayment {
    id
    saleAmount
    bookingType
    bookingPaymentMode
    totalSaleAmount
    rcTransferAmount
    insuranceAmount
    appliedLoanAmount
  }
  customer {
    id
    updatedAt
    name
    phoneNo
    state
    district
    customerId
    idNumber
    idProofUrl
    createdAt
    customerState {
      state
    }
    customerDistrict @cascade(fields: "name") {
      name
    }
    identificationDocuments {
      aadhaarNumber
      aadhaarFrontPhotoUrl
      aadhaarBackPhotoUrl
      panNumber
      panPhotoUrl
      voterIdNumber
      voterIdPhotoUrl
    }
    bookings {
      status
      deliveryForm
      cancelledChequeUrl
      isRCTransferReq
      isInsuranceReq
      vehicleTransferFormUrl
      cancellationReason
    }
  }
}
    ${ActiveLoanDetailsFragmentDoc}`;
export const VehicleImagesDetailsFragmentDoc = gql`
    fragment VehicleImagesDetails on VehicleImages {
  id
  backBodySide
  leftBodySide
  frontBodySide
  rightBodySide
  backRightTyre
  frontRightTyre
  backRightTyre
  fuelInjectionPumpPlate
  odometer
  inspectionVideoUrl
  backLeftTyre
  frontLeftTyre
  engineNumber
  backRightTyre
  chassisNumber
  imagesTakenAtStage
}
    `;
export const LeadStatusEventDetailsFragmentDoc = gql`
    fragment LeadStatusEventDetails on LeadStatusEvent {
  id
  status
  metadata
  deviceType
  assignTaskTo
  notifyTo
  taskButtonTitle
  taskTitle
  createdBy @cascade(fields: "id") {
    id
    name
  }
  createdAt
  postTimeline
  isTaskCompleted
  preTimeline
  remarks
}
    `;
export const LeadDetailsFragmentDoc = gql`
    fragment LeadDetails on Lead {
  id
  regNo
  yardPerDayParkingChargesByDriver
  approvedParkingChargesFor
  status
  yardPerDayParkingCharges
  auctionHistory {
    amount
    createdAt
    status
  }
  actualPickupDate
  accessories {
    id
    backLeftTyre
    backRightTyre
    stage
    regNo
    bumper
    hood
    battery
    drawbar
    toplink
    frontLeftTyre
    frontRightTyre
  }
  deliveredSelfieUrl
  registrationState
  listingPrice
  listingOnWebUpdatedAt
  listingStatus
  listingUpdatedBy {
    id
    name
  }
  dealer {
    id
    phoneNo
  }
  loanAmount
  source
  auctionByBank
  proposedBidLimitAmount
  finalBidAmount
  expectedPickupDate
  actualParkingCharges
  demandAmount
  ownershipType
  paymentType
  finalParkingCharges
  estimatedParkingCharges
  deliveryAmount
  documentCharges
  holdbackAmount
  tokenAmount
  loanToBeClosedBy
  approvedDealAmount
  proposedDealAmount
  sellingPrice
  listingPrice
  createdAt
  dealer {
    id
    name
  }
  documentChecklist {
    id
    form30
    sellerPAN
    form60
    form60_sellerPan
    sellerAadharCard
    ownerAddressProof
    releaseOrder
    indemnityBond
    registrationCertificate
    form26
    loanForeclosure
    bankNOC
    form35
    insuranceCertificate
    form28
    form29
    form36
  }
  documents {
    ...LeadDocumentsDetails
  }
  refurbishmentDetails {
    ...RefurbishmentRequestDetails
  }
  activeBooking {
    ...ActiveBookingDetails
  }
  archivedBookings {
    id
    status
    cancellationReason
    cancellationRemarks
    id
    deliveryPhotoUrl
    createdAt
    updatedAt
    status
    isRCTransferReq
    isInsuranceReq
    vehicleTransferFormUrl
    cheque
    cancelledChequeUrl
    deliveryForm
    archivedLoans(first: -1) {
      id
      rejectionReason
      loanStatus
      loanCancelReason
    }
    activeLoan {
      ...ActiveLoanDetails
    }
    payments {
      id
      for
      status
      mode
      amount
      createdAt
      proofUrl
      invoice {
        id
        GSTNumber
        invoiceId
      }
      paymentProcessedAt
      confirmedBy {
        id
        name
      }
      receiptUrl
      parkingBeneficiary {
        id
        accountHolderName
      }
    }
    bookingPayment {
      id
      saleAmount
      bookingType
      bookingPaymentMode
      totalSaleAmount
      rcTransferAmount
      insuranceAmount
      appliedLoanAmount
    }
    customer {
      id
      updatedAt
      name
      phoneNo
      state
      district
      customerId
      idNumber
      idProofUrl
      createdAt
      customerState {
        state
      }
      customerDistrict @cascade(fields: "name") {
        name
      }
      identificationDocuments {
        aadhaarNumber
        aadhaarFrontPhotoUrl
        aadhaarBackPhotoUrl
        panNumber
        panPhotoUrl
        voterIdNumber
        voterIdPhotoUrl
      }
      bookings {
        status
        deliveryForm
        cancelledChequeUrl
        isRCTransferReq
        isInsuranceReq
        vehicleTransferFormUrl
        cancellationReason
      }
    }
  }
  expensesCoveredIn {
    id
  }
  vehicle {
    id
    repossessionDate
    tempRepossessionDate
    isHypo
    isChallanAvailable
    isBlacklisted
    isHSRPAvailable
    registrationNumber
    fitnessValidUpto
    isRcAvailable
    isVehicleFinanced
    tempIsVehicleFinanced
    isVehicleInsured
    challanAmount
    engineNumber
    vehicleBrand {
      name
      id
    }
    vehicleModel {
      name
      id
    }
    tempVehicleBrand {
      name
    }
    tempVehicleModel {
      name
    }
    manufacturingDate
    registrationDate
    repossessionDate
    tempRepossessionDate
    tempModel
    tempMake
    tempChassisNumber
    tempEngineNumber
    tempRepossessionDate
    tempManufacturingDate
    hoursMeter
    documents {
      id
      registrationCertificateUrl
      approvalMailUrl
      hypothecationProofUrl
      rtoVerificationProofUrl
      hsrbProofUrl
      challanUrl
      blacklistProofUrl
      fitnessCertificateValidUpto
    }
    financingDetails {
      id
      isLoanClosed
      pendingLoanAmount
      loanToBeClosedBy
      tempLoanToBeClosedBy
      financerName
      tempFinancerName
    }
    insuranceDetails {
      id
      insurerName
      insuranceType
      policyNumber
      policyExpiryDate
    }
    chassisNumber
    typeCondition
    price
    owner {
      id
      district
    }
    images {
      ...VehicleImagesDetails
      vehicle {
        id
        registrationNumber
        regNo
      }
    }
  }
  auctioningAgency {
    id
    name
    spocNo
  }
  createdBy @cascade(fields: "id") {
    id
    phoneNo
    name
  }
  payments(order: {desc: createdAt}) {
    id
    for
    status
    amount
    createdAt
    mode
    proofUrl
    accountHolderName
    bankName
    ifsc
    accountNo
    upiId
    receiptUrl
    paymentProcessedAt
    amount
    type
    loanClosedBy
    parkingBeneficiary {
      id
      accountHolderName
      accountNumber
      bankName
      ifscCode
      upiId
      proofUrl
    }
    by {
      id
      name
    }
  }
  expenses {
    id
    description
    spentAmount
    category
    receiptUrl
    createdAt
    paymentStatus
  }
  deliveryCentre {
    name
  }
  centre {
    id
    name
    state
    district
    tehsil
    address
    phoneNumber
    location {
      longitude
      latitude
    }
  }
  yard {
    id
    name
    address
    locationUrl
    location {
      longitude
      latitude
    }
    perDayParkingCharge
    tempPerDayParkingCharge
    city
    address
    spocName
    spocNo
    locationUrl
  }
  demandAmount
  approvedDealAmount
  centre {
    id
    name
  }
  pickup @cascade(fields: "by") {
    id
    by @cascade(fields: "id") {
      id
      name
      phoneNo
      email
    }
  }
  parkingBeneficiary {
    id
    bankName
    accountHolderName
    accountNumber
    ifscCode
  }
  refurbishmentDetails {
    isRequired
    requests {
      id
      requestStatus
      createdAt
      issue {
        id
        status
        items {
          id
          price
          isApproved
          quantity
          product {
            id
            name
            variant
          }
        }
      }
      purchase {
        id
        totalPrice
        createdAt
        items {
          id
          purchaseProofUrl
        }
        payment {
          id
          for
          status
          amount
          createdAt
          paymentProcessedAt
          receiptUrl
          proofUrl
          mode
          modeFM
          source
          paymentTo
          accountHolderName
          bankName
          accountNo
          ifsc
          upiId
          refurbishmentBeneficiary {
            id
            accountHolderName
            accountNumber
            bankName
            ifscCode
            upiId
            proofUrl
          }
        }
      }
      items {
        id
        price
        refurbishmentProofUrl
        installationProofUrl
        status
        product {
          id
          name
          description
        }
      }
    }
  }
  statusEvents(order: {desc: createdAt}) @cascade(fields: "createdBy") {
    ...LeadStatusEventDetails
  }
  refurbishmentDetails {
    id
    requests {
      id
      purchase {
        id
        items {
          id
          purchaseProofUrl
        }
      }
    }
  }
  internalTransfers {
    id
    pickupDate
    selfieUrl
    deliveredOn
    requestedOn
    status
    from {
      id
      name
    }
    to {
      id
      name
    }
    assignedTo {
      id
      name
    }
  }
  activeBooking {
    id
    deliveryPhotoUrl
    activeLoan {
      id
      loginDate
      fieldInspectionDate
      fieldInspectionConfirmedDate
      deliveryOrderDate
    }
  }
}
    ${LeadDocumentsDetailsFragmentDoc}
${RefurbishmentRequestDetailsFragmentDoc}
${ActiveBookingDetailsFragmentDoc}
${ActiveLoanDetailsFragmentDoc}
${VehicleImagesDetailsFragmentDoc}
${LeadStatusEventDetailsFragmentDoc}`;
export const LeadPreviewFragmentDoc = gql`
    fragment LeadPreview on Lead {
  id
  regNo
  source
  finalBidAmount
  createdBy {
    name
  }
  deliveryCentre {
    name
  }
  centre {
    name
  }
  createdAt
  vehicle {
    id
    vehicleBrand {
      name
    }
    vehicleModel {
      name
    }
    manufacturingDate
  }
  statusEvents {
    ...LeadStatusEventDetails
  }
}
    ${LeadStatusEventDetailsFragmentDoc}`;
export const RefurbishmentDetailsFragFragmentDoc = gql`
    fragment RefurbishmentDetailsFrag on RefurbishmentDetails {
  id
  isRequired
  requests {
    id
    requestStatus
    transportationCharge
    items {
      id
      price
      status
      refurbishmentProofUrl
      quantity
      product {
        id
        name
        variant
        description
      }
      expectedBuyingPrice
    }
    issue {
      id
      status
      items {
        id
        price
        requestedItemId
        quantity
        product {
          id
          name
          variant
          description
        }
        quantity
        isApproved
      }
    }
    purchase {
      id
      status
      items {
        id
        price
        requestedItemId
        purchaseProofUrl
        approvedPriceLimit
        quantity
        product {
          id
          name
          variant
        }
        description
        quantity
        isApproved
      }
    }
  }
}
    `;
export const BookingsDocument = gql`
    query bookings($status: BookingStatus, $name: String, $phoneNo: String, $centre: String, $manufacturingDate: Int, $state: String, $districts: [String], $makes: [String], $models: [String], $listingPrice: PriceRange, $sellingPrice: PriceRange, $searchString: String, $purchaseType: String, $vehicleBrand: [Int], $vehicleModel: [Int], $offset: Int, $pageSize: Int) {
  filteredBookings(
    bookingFilters: {centre: $centre, state: $state, districts: $districts, makes: $makes, models: $models, manufacturingDate: $manufacturingDate, status: $status, listingPrice: $listingPrice, sellingPrice: $sellingPrice, searchString: $searchString, purchaseType: $purchaseType, vehicleBrand: $vehicleBrand, vehicleModel: $vehicleModel, offset: $offset, pageSize: $pageSize}
  ) @cascade(fields: ["customer"]) {
    id
    customer(filter: {name: {regexp: $name}, phoneNo: {regexp: $phoneNo}}) {
      name
      phoneNo
      customerDistrict @cascade(fields: ["name"]) {
        name
      }
      customerState {
        state
      }
    }
    status
    createdAt
    updatedAt
    payments {
      for
      amount
    }
    bookingPayment {
      id
      bookingType
      saleAmount
      booking {
        id
      }
    }
    activeLoan {
      id
      fieldInspectionDate
      loginDate
      deliveryOrderDate
      appliedLoanAmount
      createdAt
    }
    leadWithActiveBooking {
      regNo
      sellingPrice
      listingPrice
      centre {
        name
      }
      vehicle {
        vehicleBrand {
          name
        }
        vehicleModel {
          name
        }
        manufacturingDate
      }
    }
    leadWithArchivedBooking {
      regNo
      sellingPrice
      listingPrice
      centre {
        name
      }
      vehicle {
        vehicleBrand {
          name
        }
        vehicleModel {
          name
        }
        manufacturingDate
      }
    }
  }
}
    `;

/**
 * __useBookingsQuery__
 *
 * To run a query within a React component, call `useBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingsQuery({
 *   variables: {
 *      status: // value for 'status'
 *      name: // value for 'name'
 *      phoneNo: // value for 'phoneNo'
 *      centre: // value for 'centre'
 *      manufacturingDate: // value for 'manufacturingDate'
 *      state: // value for 'state'
 *      districts: // value for 'districts'
 *      makes: // value for 'makes'
 *      models: // value for 'models'
 *      listingPrice: // value for 'listingPrice'
 *      sellingPrice: // value for 'sellingPrice'
 *      searchString: // value for 'searchString'
 *      purchaseType: // value for 'purchaseType'
 *      vehicleBrand: // value for 'vehicleBrand'
 *      vehicleModel: // value for 'vehicleModel'
 *      offset: // value for 'offset'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useBookingsQuery(baseOptions?: Apollo.QueryHookOptions<BookingsQuery, BookingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingsQuery, BookingsQueryVariables>(BookingsDocument, options);
      }
export function useBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingsQuery, BookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingsQuery, BookingsQueryVariables>(BookingsDocument, options);
        }
export type BookingsQueryHookResult = ReturnType<typeof useBookingsQuery>;
export type BookingsLazyQueryHookResult = ReturnType<typeof useBookingsLazyQuery>;
export type BookingsQueryResult = Apollo.QueryResult<BookingsQuery, BookingsQueryVariables>;
export const GetBookingDocument = gql`
    query getBooking($id: [ID!]!) {
  queryBooking(filter: {id: $id}) {
    id
    customer {
      name
      phoneNo
    }
    bookingPayment {
      id
      saleAmount
      booking {
        id
      }
    }
    activeLoan {
      id
      fieldInspectionDate
      loginDate
      deliveryOrderDate
      appliedLoanAmount
      createdAt
      fieldInspectionConfirmedDate
    }
  }
}
    `;

/**
 * __useGetBookingQuery__
 *
 * To run a query within a React component, call `useGetBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBookingQuery(baseOptions: Apollo.QueryHookOptions<GetBookingQuery, GetBookingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingQuery, GetBookingQueryVariables>(GetBookingDocument, options);
      }
export function useGetBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingQuery, GetBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingQuery, GetBookingQueryVariables>(GetBookingDocument, options);
        }
export type GetBookingQueryHookResult = ReturnType<typeof useGetBookingQuery>;
export type GetBookingLazyQueryHookResult = ReturnType<typeof useGetBookingLazyQuery>;
export type GetBookingQueryResult = Apollo.QueryResult<GetBookingQuery, GetBookingQueryVariables>;
export const UpdateCenterInchargeDocument = gql`
    mutation updateCenterIncharge($id: [ID!], $inchargeId: ID) {
  updateCentre(input: {filter: {id: $id}, set: {incharge: {id: $inchargeId}}}) {
    numUids
    centre {
      id
      incharge {
        id
        name
        email
      }
    }
  }
}
    `;
export type UpdateCenterInchargeMutationFn = Apollo.MutationFunction<UpdateCenterInchargeMutation, UpdateCenterInchargeMutationVariables>;

/**
 * __useUpdateCenterInchargeMutation__
 *
 * To run a mutation, you first call `useUpdateCenterInchargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCenterInchargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCenterInchargeMutation, { data, loading, error }] = useUpdateCenterInchargeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      inchargeId: // value for 'inchargeId'
 *   },
 * });
 */
export function useUpdateCenterInchargeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCenterInchargeMutation, UpdateCenterInchargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCenterInchargeMutation, UpdateCenterInchargeMutationVariables>(UpdateCenterInchargeDocument, options);
      }
export type UpdateCenterInchargeMutationHookResult = ReturnType<typeof useUpdateCenterInchargeMutation>;
export type UpdateCenterInchargeMutationResult = Apollo.MutationResult<UpdateCenterInchargeMutation>;
export type UpdateCenterInchargeMutationOptions = Apollo.BaseMutationOptions<UpdateCenterInchargeMutation, UpdateCenterInchargeMutationVariables>;
export const GetCentreDocument = gql`
    query getCentre {
  queryCentre(filter: {status: {eq: ACTIVE}}) {
    id
    incharge {
      id
      name
      email
    }
  }
}
    `;

/**
 * __useGetCentreQuery__
 *
 * To run a query within a React component, call `useGetCentreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCentreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCentreQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCentreQuery(baseOptions?: Apollo.QueryHookOptions<GetCentreQuery, GetCentreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCentreQuery, GetCentreQueryVariables>(GetCentreDocument, options);
      }
export function useGetCentreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCentreQuery, GetCentreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCentreQuery, GetCentreQueryVariables>(GetCentreDocument, options);
        }
export type GetCentreQueryHookResult = ReturnType<typeof useGetCentreQuery>;
export type GetCentreLazyQueryHookResult = ReturnType<typeof useGetCentreLazyQuery>;
export type GetCentreQueryResult = Apollo.QueryResult<GetCentreQuery, GetCentreQueryVariables>;
export const UpdateActiveBookingSaleAmountDocument = gql`
    mutation updateActiveBookingSaleAmount($id: [ID!]!, $saleAmount: Int) {
  updateBookingPayment(input: {filter: {id: $id}, set: {saleAmount: $saleAmount}}) {
    bookingPayment {
      id
      saleAmount
    }
  }
}
    `;
export type UpdateActiveBookingSaleAmountMutationFn = Apollo.MutationFunction<UpdateActiveBookingSaleAmountMutation, UpdateActiveBookingSaleAmountMutationVariables>;

/**
 * __useUpdateActiveBookingSaleAmountMutation__
 *
 * To run a mutation, you first call `useUpdateActiveBookingSaleAmountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActiveBookingSaleAmountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActiveBookingSaleAmountMutation, { data, loading, error }] = useUpdateActiveBookingSaleAmountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      saleAmount: // value for 'saleAmount'
 *   },
 * });
 */
export function useUpdateActiveBookingSaleAmountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActiveBookingSaleAmountMutation, UpdateActiveBookingSaleAmountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActiveBookingSaleAmountMutation, UpdateActiveBookingSaleAmountMutationVariables>(UpdateActiveBookingSaleAmountDocument, options);
      }
export type UpdateActiveBookingSaleAmountMutationHookResult = ReturnType<typeof useUpdateActiveBookingSaleAmountMutation>;
export type UpdateActiveBookingSaleAmountMutationResult = Apollo.MutationResult<UpdateActiveBookingSaleAmountMutation>;
export type UpdateActiveBookingSaleAmountMutationOptions = Apollo.BaseMutationOptions<UpdateActiveBookingSaleAmountMutation, UpdateActiveBookingSaleAmountMutationVariables>;
export const UpdateLoanDocument = gql`
    mutation updateLoan($id: [ID!]!, $appliedLoanAmount: Int, $deliveryOrderDate: DateTime, $fieldInspectionDate: DateTime, $loginDate: DateTime, $fieldInspectionConfirmedDate: DateTime) {
  updateLoan(
    input: {filter: {id: $id}, set: {appliedLoanAmount: $appliedLoanAmount, deliveryOrderDate: $deliveryOrderDate, fieldInspectionDate: $fieldInspectionDate, loginDate: $loginDate, fieldInspectionConfirmedDate: $fieldInspectionConfirmedDate}}
  ) {
    loan {
      id
      fieldInspectionDate
      deliveryOrderDate
      appliedLoanAmount
      loginDate
      fieldInspectionConfirmedDate
    }
  }
}
    `;
export type UpdateLoanMutationFn = Apollo.MutationFunction<UpdateLoanMutation, UpdateLoanMutationVariables>;

/**
 * __useUpdateLoanMutation__
 *
 * To run a mutation, you first call `useUpdateLoanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLoanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLoanMutation, { data, loading, error }] = useUpdateLoanMutation({
 *   variables: {
 *      id: // value for 'id'
 *      appliedLoanAmount: // value for 'appliedLoanAmount'
 *      deliveryOrderDate: // value for 'deliveryOrderDate'
 *      fieldInspectionDate: // value for 'fieldInspectionDate'
 *      loginDate: // value for 'loginDate'
 *      fieldInspectionConfirmedDate: // value for 'fieldInspectionConfirmedDate'
 *   },
 * });
 */
export function useUpdateLoanMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLoanMutation, UpdateLoanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLoanMutation, UpdateLoanMutationVariables>(UpdateLoanDocument, options);
      }
export type UpdateLoanMutationHookResult = ReturnType<typeof useUpdateLoanMutation>;
export type UpdateLoanMutationResult = Apollo.MutationResult<UpdateLoanMutation>;
export type UpdateLoanMutationOptions = Apollo.BaseMutationOptions<UpdateLoanMutation, UpdateLoanMutationVariables>;
export const GetCentreListDocument = gql`
    query getCentreList {
  queryCentre(filter: {status: {eq: ACTIVE}}) {
    id
    name
  }
}
    `;

/**
 * __useGetCentreListQuery__
 *
 * To run a query within a React component, call `useGetCentreListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCentreListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCentreListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCentreListQuery(baseOptions?: Apollo.QueryHookOptions<GetCentreListQuery, GetCentreListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCentreListQuery, GetCentreListQueryVariables>(GetCentreListDocument, options);
      }
export function useGetCentreListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCentreListQuery, GetCentreListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCentreListQuery, GetCentreListQueryVariables>(GetCentreListDocument, options);
        }
export type GetCentreListQueryHookResult = ReturnType<typeof useGetCentreListQuery>;
export type GetCentreListLazyQueryHookResult = ReturnType<typeof useGetCentreListLazyQuery>;
export type GetCentreListQueryResult = Apollo.QueryResult<GetCentreListQuery, GetCentreListQueryVariables>;
export const GetModelByBrandIdDocument = gql`
    query GetModelByBrandId($brand_id: [Int]) {
  queryBrand(filter: {brand_id: {in: $brand_id}}) {
    models {
      model_id
      name
      id
      brand {
        brand_id
      }
    }
  }
}
    `;

/**
 * __useGetModelByBrandIdQuery__
 *
 * To run a query within a React component, call `useGetModelByBrandIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModelByBrandIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModelByBrandIdQuery({
 *   variables: {
 *      brand_id: // value for 'brand_id'
 *   },
 * });
 */
export function useGetModelByBrandIdQuery(baseOptions?: Apollo.QueryHookOptions<GetModelByBrandIdQuery, GetModelByBrandIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetModelByBrandIdQuery, GetModelByBrandIdQueryVariables>(GetModelByBrandIdDocument, options);
      }
export function useGetModelByBrandIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModelByBrandIdQuery, GetModelByBrandIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetModelByBrandIdQuery, GetModelByBrandIdQueryVariables>(GetModelByBrandIdDocument, options);
        }
export type GetModelByBrandIdQueryHookResult = ReturnType<typeof useGetModelByBrandIdQuery>;
export type GetModelByBrandIdLazyQueryHookResult = ReturnType<typeof useGetModelByBrandIdLazyQuery>;
export type GetModelByBrandIdQueryResult = Apollo.QueryResult<GetModelByBrandIdQuery, GetModelByBrandIdQueryVariables>;
export const GetPurchaseItemDocument = gql`
    query getPurchaseItem {
  queryPurchaseItem {
    id
    type
  }
}
    `;

/**
 * __useGetPurchaseItemQuery__
 *
 * To run a query within a React component, call `useGetPurchaseItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaseItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaseItemQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPurchaseItemQuery(baseOptions?: Apollo.QueryHookOptions<GetPurchaseItemQuery, GetPurchaseItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaseItemQuery, GetPurchaseItemQueryVariables>(GetPurchaseItemDocument, options);
      }
export function useGetPurchaseItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaseItemQuery, GetPurchaseItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaseItemQuery, GetPurchaseItemQueryVariables>(GetPurchaseItemDocument, options);
        }
export type GetPurchaseItemQueryHookResult = ReturnType<typeof useGetPurchaseItemQuery>;
export type GetPurchaseItemLazyQueryHookResult = ReturnType<typeof useGetPurchaseItemLazyQuery>;
export type GetPurchaseItemQueryResult = Apollo.QueryResult<GetPurchaseItemQuery, GetPurchaseItemQueryVariables>;
export const GetModelListDocument = gql`
    query getModelList {
  queryVehicle {
    id
    vehicleModel {
      name
    }
    manufacturingDate
  }
}
    `;

/**
 * __useGetModelListQuery__
 *
 * To run a query within a React component, call `useGetModelListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModelListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModelListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetModelListQuery(baseOptions?: Apollo.QueryHookOptions<GetModelListQuery, GetModelListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetModelListQuery, GetModelListQueryVariables>(GetModelListDocument, options);
      }
export function useGetModelListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModelListQuery, GetModelListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetModelListQuery, GetModelListQueryVariables>(GetModelListDocument, options);
        }
export type GetModelListQueryHookResult = ReturnType<typeof useGetModelListQuery>;
export type GetModelListLazyQueryHookResult = ReturnType<typeof useGetModelListLazyQuery>;
export type GetModelListQueryResult = Apollo.QueryResult<GetModelListQuery, GetModelListQueryVariables>;
export const GetDistrictListDocument = gql`
    query getDistrictList($state: String) {
  queryStateCodeWithRegNumber(filter: {state: {allofterms: $state}}) {
    id
    state
    districts {
      id
      name
    }
  }
}
    `;

/**
 * __useGetDistrictListQuery__
 *
 * To run a query within a React component, call `useGetDistrictListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistrictListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistrictListQuery({
 *   variables: {
 *      state: // value for 'state'
 *   },
 * });
 */
export function useGetDistrictListQuery(baseOptions?: Apollo.QueryHookOptions<GetDistrictListQuery, GetDistrictListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDistrictListQuery, GetDistrictListQueryVariables>(GetDistrictListDocument, options);
      }
export function useGetDistrictListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDistrictListQuery, GetDistrictListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDistrictListQuery, GetDistrictListQueryVariables>(GetDistrictListDocument, options);
        }
export type GetDistrictListQueryHookResult = ReturnType<typeof useGetDistrictListQuery>;
export type GetDistrictListLazyQueryHookResult = ReturnType<typeof useGetDistrictListLazyQuery>;
export type GetDistrictListQueryResult = Apollo.QueryResult<GetDistrictListQuery, GetDistrictListQueryVariables>;
export const CreateBulkLeadsDocument = gql`
    query CreateBulkLeads($userId: String!, $leads: [BulkLeadInput!]!) {
  createBulkLeads(userId: $userId, leads: $leads) {
    regNo
    status
    make
    model
    source
    status
    auctionByBank
    engineNumber
    chassisNumber
    ownershipType
    registrationState
    email
    hoursMeter
    demandAmount
    manufacturingDate
    remark
    processingStatus
    failureReason
  }
}
    `;

/**
 * __useCreateBulkLeadsQuery__
 *
 * To run a query within a React component, call `useCreateBulkLeadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateBulkLeadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateBulkLeadsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      leads: // value for 'leads'
 *   },
 * });
 */
export function useCreateBulkLeadsQuery(baseOptions: Apollo.QueryHookOptions<CreateBulkLeadsQuery, CreateBulkLeadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateBulkLeadsQuery, CreateBulkLeadsQueryVariables>(CreateBulkLeadsDocument, options);
      }
export function useCreateBulkLeadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateBulkLeadsQuery, CreateBulkLeadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateBulkLeadsQuery, CreateBulkLeadsQueryVariables>(CreateBulkLeadsDocument, options);
        }
export type CreateBulkLeadsQueryHookResult = ReturnType<typeof useCreateBulkLeadsQuery>;
export type CreateBulkLeadsLazyQueryHookResult = ReturnType<typeof useCreateBulkLeadsLazyQuery>;
export type CreateBulkLeadsQueryResult = Apollo.QueryResult<CreateBulkLeadsQuery, CreateBulkLeadsQueryVariables>;
export const LeadsForBulkApprovalDocument = gql`
    query LeadsForBulkApproval($leads: [BulkApprovalInput!]!, $createdBy: String!) {
  bulkApproval(leads: $leads, createById: $createdBy) {
    bidStatus
    source
    finalBidAmount
    proposedBidAmount
    processingStatus
    failureReason
    bankConfirmationStatus
    email
    regNo
  }
}
    `;

/**
 * __useLeadsForBulkApprovalQuery__
 *
 * To run a query within a React component, call `useLeadsForBulkApprovalQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadsForBulkApprovalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadsForBulkApprovalQuery({
 *   variables: {
 *      leads: // value for 'leads'
 *      createdBy: // value for 'createdBy'
 *   },
 * });
 */
export function useLeadsForBulkApprovalQuery(baseOptions: Apollo.QueryHookOptions<LeadsForBulkApprovalQuery, LeadsForBulkApprovalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeadsForBulkApprovalQuery, LeadsForBulkApprovalQueryVariables>(LeadsForBulkApprovalDocument, options);
      }
export function useLeadsForBulkApprovalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeadsForBulkApprovalQuery, LeadsForBulkApprovalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeadsForBulkApprovalQuery, LeadsForBulkApprovalQueryVariables>(LeadsForBulkApprovalDocument, options);
        }
export type LeadsForBulkApprovalQueryHookResult = ReturnType<typeof useLeadsForBulkApprovalQuery>;
export type LeadsForBulkApprovalLazyQueryHookResult = ReturnType<typeof useLeadsForBulkApprovalLazyQuery>;
export type LeadsForBulkApprovalQueryResult = Apollo.QueryResult<LeadsForBulkApprovalQuery, LeadsForBulkApprovalQueryVariables>;
export const LeadCountByStatusDocument = gql`
    query leadCountByStatus($start: DateTime, $end: DateTime, $regState: String) {
  leadCountsByStatus(start: $start, end: $end, regState: $regState) {
    count
    status
  }
}
    `;

/**
 * __useLeadCountByStatusQuery__
 *
 * To run a query within a React component, call `useLeadCountByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadCountByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadCountByStatusQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      regState: // value for 'regState'
 *   },
 * });
 */
export function useLeadCountByStatusQuery(baseOptions?: Apollo.QueryHookOptions<LeadCountByStatusQuery, LeadCountByStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeadCountByStatusQuery, LeadCountByStatusQueryVariables>(LeadCountByStatusDocument, options);
      }
export function useLeadCountByStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeadCountByStatusQuery, LeadCountByStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeadCountByStatusQuery, LeadCountByStatusQueryVariables>(LeadCountByStatusDocument, options);
        }
export type LeadCountByStatusQueryHookResult = ReturnType<typeof useLeadCountByStatusQuery>;
export type LeadCountByStatusLazyQueryHookResult = ReturnType<typeof useLeadCountByStatusLazyQuery>;
export type LeadCountByStatusQueryResult = Apollo.QueryResult<LeadCountByStatusQuery, LeadCountByStatusQueryVariables>;
export const DealershipLeadCountByPeNameDocument = gql`
    query DealershipLeadCountByPEName($start: DateTime, $end: DateTime, $regState: String) {
  dealershipLeadCountByPEName(start: $start, end: $end, regState: $regState) {
    userId
    name
    dealClosedCount
    leadCreatedCount
    priceRecivedCount
  }
}
    `;

/**
 * __useDealershipLeadCountByPeNameQuery__
 *
 * To run a query within a React component, call `useDealershipLeadCountByPeNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealershipLeadCountByPeNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealershipLeadCountByPeNameQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      regState: // value for 'regState'
 *   },
 * });
 */
export function useDealershipLeadCountByPeNameQuery(baseOptions?: Apollo.QueryHookOptions<DealershipLeadCountByPeNameQuery, DealershipLeadCountByPeNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DealershipLeadCountByPeNameQuery, DealershipLeadCountByPeNameQueryVariables>(DealershipLeadCountByPeNameDocument, options);
      }
export function useDealershipLeadCountByPeNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DealershipLeadCountByPeNameQuery, DealershipLeadCountByPeNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DealershipLeadCountByPeNameQuery, DealershipLeadCountByPeNameQueryVariables>(DealershipLeadCountByPeNameDocument, options);
        }
export type DealershipLeadCountByPeNameQueryHookResult = ReturnType<typeof useDealershipLeadCountByPeNameQuery>;
export type DealershipLeadCountByPeNameLazyQueryHookResult = ReturnType<typeof useDealershipLeadCountByPeNameLazyQuery>;
export type DealershipLeadCountByPeNameQueryResult = Apollo.QueryResult<DealershipLeadCountByPeNameQuery, DealershipLeadCountByPeNameQueryVariables>;
export const BankAuctionLeadCountByNameDocument = gql`
    query BankAuctionLeadCountByName($start: DateTime, $end: DateTime, $regState: String) {
  bankAuctionLeadCountByName(start: $start, end: $end, regState: $regState) {
    bankName
    vahanChecked
    vehicleInAuction
    approvalRecived
    wonInAuction
  }
}
    `;

/**
 * __useBankAuctionLeadCountByNameQuery__
 *
 * To run a query within a React component, call `useBankAuctionLeadCountByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankAuctionLeadCountByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankAuctionLeadCountByNameQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      regState: // value for 'regState'
 *   },
 * });
 */
export function useBankAuctionLeadCountByNameQuery(baseOptions?: Apollo.QueryHookOptions<BankAuctionLeadCountByNameQuery, BankAuctionLeadCountByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankAuctionLeadCountByNameQuery, BankAuctionLeadCountByNameQueryVariables>(BankAuctionLeadCountByNameDocument, options);
      }
export function useBankAuctionLeadCountByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankAuctionLeadCountByNameQuery, BankAuctionLeadCountByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankAuctionLeadCountByNameQuery, BankAuctionLeadCountByNameQueryVariables>(BankAuctionLeadCountByNameDocument, options);
        }
export type BankAuctionLeadCountByNameQueryHookResult = ReturnType<typeof useBankAuctionLeadCountByNameQuery>;
export type BankAuctionLeadCountByNameLazyQueryHookResult = ReturnType<typeof useBankAuctionLeadCountByNameLazyQuery>;
export type BankAuctionLeadCountByNameQueryResult = Apollo.QueryResult<BankAuctionLeadCountByNameQuery, BankAuctionLeadCountByNameQueryVariables>;
export const GetBookingAndProcurementDocument = gql`
    query GetBookingAndProcurement($regState: String, $end: DateTime!, $start: DateTime!) {
  queryLead(
    filter: {updatedAt: {between: {max: $end, min: $start}}, registrationState: {anyoftext: $regState}}
  ) @cascade(fields: ["activeBooking"]) {
    id
    regNo
    vehicle {
      make
      model
      vehicleBrand {
        name
      }
      vehicleModel {
        name
      }
    }
    activeBooking {
      id
      customer {
        id
        name
      }
      bookingPayment {
        saleAmount
      }
    }
    finalBidAmount
    finalParkingCharges
    approvedDealAmount
  }
}
    `;

/**
 * __useGetBookingAndProcurementQuery__
 *
 * To run a query within a React component, call `useGetBookingAndProcurementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingAndProcurementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingAndProcurementQuery({
 *   variables: {
 *      regState: // value for 'regState'
 *      end: // value for 'end'
 *      start: // value for 'start'
 *   },
 * });
 */
export function useGetBookingAndProcurementQuery(baseOptions: Apollo.QueryHookOptions<GetBookingAndProcurementQuery, GetBookingAndProcurementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingAndProcurementQuery, GetBookingAndProcurementQueryVariables>(GetBookingAndProcurementDocument, options);
      }
export function useGetBookingAndProcurementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingAndProcurementQuery, GetBookingAndProcurementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingAndProcurementQuery, GetBookingAndProcurementQueryVariables>(GetBookingAndProcurementDocument, options);
        }
export type GetBookingAndProcurementQueryHookResult = ReturnType<typeof useGetBookingAndProcurementQuery>;
export type GetBookingAndProcurementLazyQueryHookResult = ReturnType<typeof useGetBookingAndProcurementLazyQuery>;
export type GetBookingAndProcurementQueryResult = Apollo.QueryResult<GetBookingAndProcurementQuery, GetBookingAndProcurementQueryVariables>;
export const GetRtoStatsDocument = gql`
    query GetRtoStats($regState: String, $end: DateTime!, $start: DateTime!) {
  queryLead(
    filter: {updatedAt: {between: {max: $end, min: $start}}, registrationState: {anyoftext: $regState}}
  ) {
    regNo
    statusEvents(
      filter: {status: {in: [RTO_CONFIRMED, VEHICLE_DETAILS_UPDATED, LEAD_GENERATED]}}
    ) {
      status
    }
  }
}
    `;

/**
 * __useGetRtoStatsQuery__
 *
 * To run a query within a React component, call `useGetRtoStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRtoStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRtoStatsQuery({
 *   variables: {
 *      regState: // value for 'regState'
 *      end: // value for 'end'
 *      start: // value for 'start'
 *   },
 * });
 */
export function useGetRtoStatsQuery(baseOptions: Apollo.QueryHookOptions<GetRtoStatsQuery, GetRtoStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRtoStatsQuery, GetRtoStatsQueryVariables>(GetRtoStatsDocument, options);
      }
export function useGetRtoStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRtoStatsQuery, GetRtoStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRtoStatsQuery, GetRtoStatsQueryVariables>(GetRtoStatsDocument, options);
        }
export type GetRtoStatsQueryHookResult = ReturnType<typeof useGetRtoStatsQuery>;
export type GetRtoStatsLazyQueryHookResult = ReturnType<typeof useGetRtoStatsLazyQuery>;
export type GetRtoStatsQueryResult = Apollo.QueryResult<GetRtoStatsQuery, GetRtoStatsQueryVariables>;
export const GetDriverReportDocument = gql`
    query GetDriverReport($start: DateTime, $end: DateTime, $regState: String) {
  driverData(driverReportFilters: {start: $start, end: $end, regState: $regState}) {
    id
    driverName
    assignedPickupsCount
    assignedPickupsRejectedOrWithdrawnCount
    assignedPickupsAcceptedCount
    assignedPickupsInTransitCount
    assignedPickupsDeliveredCount
  }
}
    `;

/**
 * __useGetDriverReportQuery__
 *
 * To run a query within a React component, call `useGetDriverReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverReportQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      regState: // value for 'regState'
 *   },
 * });
 */
export function useGetDriverReportQuery(baseOptions?: Apollo.QueryHookOptions<GetDriverReportQuery, GetDriverReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverReportQuery, GetDriverReportQueryVariables>(GetDriverReportDocument, options);
      }
export function useGetDriverReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverReportQuery, GetDriverReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverReportQuery, GetDriverReportQueryVariables>(GetDriverReportDocument, options);
        }
export type GetDriverReportQueryHookResult = ReturnType<typeof useGetDriverReportQuery>;
export type GetDriverReportLazyQueryHookResult = ReturnType<typeof useGetDriverReportLazyQuery>;
export type GetDriverReportQueryResult = Apollo.QueryResult<GetDriverReportQuery, GetDriverReportQueryVariables>;
export const GetLogisticFunnelStatsDocument = gql`
    query GetLogisticFunnelStats($start: DateTime!, $end: DateTime!, $regState: String) {
  queryLead(
    filter: {has: pickup, updatedAt: {between: {max: $end, min: $start}}, registrationState: {alloftext: $regState}}
  ) {
    pickup {
      by {
        id
        name
      }
    }
    statusEvents(
      filter: {status: {in: [PICKUP_ASSIGNMENT_DETAILS_ADDED, PICKUP_YARD_DETAILS_ADDED, DELIVERY_STARTED, DELIVERY_COMPLETED]}}
    ) {
      status
    }
  }
}
    `;

/**
 * __useGetLogisticFunnelStatsQuery__
 *
 * To run a query within a React component, call `useGetLogisticFunnelStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLogisticFunnelStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLogisticFunnelStatsQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      regState: // value for 'regState'
 *   },
 * });
 */
export function useGetLogisticFunnelStatsQuery(baseOptions: Apollo.QueryHookOptions<GetLogisticFunnelStatsQuery, GetLogisticFunnelStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLogisticFunnelStatsQuery, GetLogisticFunnelStatsQueryVariables>(GetLogisticFunnelStatsDocument, options);
      }
export function useGetLogisticFunnelStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLogisticFunnelStatsQuery, GetLogisticFunnelStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLogisticFunnelStatsQuery, GetLogisticFunnelStatsQueryVariables>(GetLogisticFunnelStatsDocument, options);
        }
export type GetLogisticFunnelStatsQueryHookResult = ReturnType<typeof useGetLogisticFunnelStatsQuery>;
export type GetLogisticFunnelStatsLazyQueryHookResult = ReturnType<typeof useGetLogisticFunnelStatsLazyQuery>;
export type GetLogisticFunnelStatsQueryResult = Apollo.QueryResult<GetLogisticFunnelStatsQuery, GetLogisticFunnelStatsQueryVariables>;
export const GetCentreAggregatesDocument = gql`
    query getCentreAggregates($start: DateTime, $end: DateTime, $regState: String) {
  centreAggregatesData(
    centreReportFilters: {start: $start, end: $end, regState: $regState}
  ) {
    centreId
    centreName
    inStockVehiclesCount
    bookedVehiclesCount
    soldAndDeliveredVehicleCount
    totalInventory
  }
}
    `;

/**
 * __useGetCentreAggregatesQuery__
 *
 * To run a query within a React component, call `useGetCentreAggregatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCentreAggregatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCentreAggregatesQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      regState: // value for 'regState'
 *   },
 * });
 */
export function useGetCentreAggregatesQuery(baseOptions?: Apollo.QueryHookOptions<GetCentreAggregatesQuery, GetCentreAggregatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCentreAggregatesQuery, GetCentreAggregatesQueryVariables>(GetCentreAggregatesDocument, options);
      }
export function useGetCentreAggregatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCentreAggregatesQuery, GetCentreAggregatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCentreAggregatesQuery, GetCentreAggregatesQueryVariables>(GetCentreAggregatesDocument, options);
        }
export type GetCentreAggregatesQueryHookResult = ReturnType<typeof useGetCentreAggregatesQuery>;
export type GetCentreAggregatesLazyQueryHookResult = ReturnType<typeof useGetCentreAggregatesLazyQuery>;
export type GetCentreAggregatesQueryResult = Apollo.QueryResult<GetCentreAggregatesQuery, GetCentreAggregatesQueryVariables>;
export const GetAllEnquiriesDocument = gql`
    query getAllEnquiries {
  queryEnquiry {
    id
    customer {
      id
      name
      phoneNo
    }
    isClosed
    enquiryClosure {
      enquiryCloseReason
      remarks
    }
    createdAt
    updatedAt
    followups {
      id
      followupDate
      status
      followedUpBy {
        id
        name
        email
      }
      enquiry {
        id
      }
    }
    followupsAggregate {
      count
    }
    status
    centre {
      id
      name
    }
  }
}
    `;

/**
 * __useGetAllEnquiriesQuery__
 *
 * To run a query within a React component, call `useGetAllEnquiriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEnquiriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEnquiriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllEnquiriesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllEnquiriesQuery, GetAllEnquiriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEnquiriesQuery, GetAllEnquiriesQueryVariables>(GetAllEnquiriesDocument, options);
      }
export function useGetAllEnquiriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEnquiriesQuery, GetAllEnquiriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEnquiriesQuery, GetAllEnquiriesQueryVariables>(GetAllEnquiriesDocument, options);
        }
export type GetAllEnquiriesQueryHookResult = ReturnType<typeof useGetAllEnquiriesQuery>;
export type GetAllEnquiriesLazyQueryHookResult = ReturnType<typeof useGetAllEnquiriesLazyQuery>;
export type GetAllEnquiriesQueryResult = Apollo.QueryResult<GetAllEnquiriesQuery, GetAllEnquiriesQueryVariables>;
export const ExportEnquiriesDocument = gql`
    query ExportEnquiries {
  queryEnquiry {
    id
    isClosed
    createdAt
    lastVisitDate
    customer {
      customerState {
        state
      }
      customerDistrict {
        name
      }
      customerTehsil {
        name
      }
      name
      phoneNo
      state
      district
      tehsil
    }
    followups {
      nextFollowup {
        followupDate
      }
    }
    tentativePurchaseTime
    enquiryClosure {
      enquiryCloseReason
    }
    interestedIn {
      id
      name
      brand {
        name
      }
    }
    budget
    status
    updatedAt
    enquiryType
    centre {
      name
    }
    followupsAggregate {
      count
    }
    createdBy {
      createdAt
    }
  }
}
    `;

/**
 * __useExportEnquiriesQuery__
 *
 * To run a query within a React component, call `useExportEnquiriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportEnquiriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportEnquiriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useExportEnquiriesQuery(baseOptions?: Apollo.QueryHookOptions<ExportEnquiriesQuery, ExportEnquiriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportEnquiriesQuery, ExportEnquiriesQueryVariables>(ExportEnquiriesDocument, options);
      }
export function useExportEnquiriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportEnquiriesQuery, ExportEnquiriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportEnquiriesQuery, ExportEnquiriesQueryVariables>(ExportEnquiriesDocument, options);
        }
export type ExportEnquiriesQueryHookResult = ReturnType<typeof useExportEnquiriesQuery>;
export type ExportEnquiriesLazyQueryHookResult = ReturnType<typeof useExportEnquiriesLazyQuery>;
export type ExportEnquiriesQueryResult = Apollo.QueryResult<ExportEnquiriesQuery, ExportEnquiriesQueryVariables>;
export const GetEnquiriesDocument = gql`
    query getEnquiries($end: DateTime!, $start: DateTime!) {
  queryEnquiry(
    filter: {isClosed: true, updatedAt: {between: {max: $end, min: $start}}}
  ) {
    id
    status
    isClosed
    updatedAt
    enquiryClosure {
      remarks
      enquiryCloseReason
    }
  }
}
    `;

/**
 * __useGetEnquiriesQuery__
 *
 * To run a query within a React component, call `useGetEnquiriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnquiriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnquiriesQuery({
 *   variables: {
 *      end: // value for 'end'
 *      start: // value for 'start'
 *   },
 * });
 */
export function useGetEnquiriesQuery(baseOptions: Apollo.QueryHookOptions<GetEnquiriesQuery, GetEnquiriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnquiriesQuery, GetEnquiriesQueryVariables>(GetEnquiriesDocument, options);
      }
export function useGetEnquiriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnquiriesQuery, GetEnquiriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnquiriesQuery, GetEnquiriesQueryVariables>(GetEnquiriesDocument, options);
        }
export type GetEnquiriesQueryHookResult = ReturnType<typeof useGetEnquiriesQuery>;
export type GetEnquiriesLazyQueryHookResult = ReturnType<typeof useGetEnquiriesLazyQuery>;
export type GetEnquiriesQueryResult = Apollo.QueryResult<GetEnquiriesQuery, GetEnquiriesQueryVariables>;
export const GetDetailEnquiriesDocument = gql`
    query getDetailEnquiries($centre: String, $state: String, $districts: [String], $tehsils: [String], $makes: [String], $models: [String], $isClosed: Boolean, $status: EnquiryStatus, $type: EnquiryType, $dateType: SelectTypeOfDate, $start: DateTime, $end: DateTime, $search: String, $offset: Int, $pageSize: Int) {
  filteredEnquiry(
    enquiryFilters: {centre: $centre, state: $state, enquiryStatus: $status, districts: $districts, selectTypeOfDate: $dateType, isClosed: $isClosed, makes: $makes, models: $models, enquiryType: $type, from: $start, to: $end, tehsils: $tehsils, searchString: $search, offset: $offset, pageSize: $pageSize}
  ) {
    id
    searchString
    isClosed
    enquiryClosure {
      remarks
      enquiryCloseReason
    }
    createdAt
    lastVisitDate
    customer {
      customerState {
        state
      }
      customerDistrict {
        name
      }
      customerTehsil {
        name
      }
      name
      phoneNo
      state
      district
      tehsil
    }
    followups {
      id
      remarks
      followupDate
      nextFollowup {
        followupDate
      }
    }
    tentativePurchaseTime
    enquiryClosure {
      enquiryCloseReason
    }
    interestedIn {
      id
      name
      brand {
        name
      }
    }
    budget
    status
    updatedAt
    enquiryType
    centre {
      name
    }
    followupsAggregate {
      count
    }
    createdBy {
      name
      createdAt
    }
  }
}
    `;

/**
 * __useGetDetailEnquiriesQuery__
 *
 * To run a query within a React component, call `useGetDetailEnquiriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailEnquiriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailEnquiriesQuery({
 *   variables: {
 *      centre: // value for 'centre'
 *      state: // value for 'state'
 *      districts: // value for 'districts'
 *      tehsils: // value for 'tehsils'
 *      makes: // value for 'makes'
 *      models: // value for 'models'
 *      isClosed: // value for 'isClosed'
 *      status: // value for 'status'
 *      type: // value for 'type'
 *      dateType: // value for 'dateType'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      search: // value for 'search'
 *      offset: // value for 'offset'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetDetailEnquiriesQuery(baseOptions?: Apollo.QueryHookOptions<GetDetailEnquiriesQuery, GetDetailEnquiriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDetailEnquiriesQuery, GetDetailEnquiriesQueryVariables>(GetDetailEnquiriesDocument, options);
      }
export function useGetDetailEnquiriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDetailEnquiriesQuery, GetDetailEnquiriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDetailEnquiriesQuery, GetDetailEnquiriesQueryVariables>(GetDetailEnquiriesDocument, options);
        }
export type GetDetailEnquiriesQueryHookResult = ReturnType<typeof useGetDetailEnquiriesQuery>;
export type GetDetailEnquiriesLazyQueryHookResult = ReturnType<typeof useGetDetailEnquiriesLazyQuery>;
export type GetDetailEnquiriesQueryResult = Apollo.QueryResult<GetDetailEnquiriesQuery, GetDetailEnquiriesQueryVariables>;
export const EnquiryFilterDocument = gql`
    query enquiryFilter($id: [ID!]!) {
  queryEnquiry(filter: {id: $id}) {
    id
    isClosed
    lastVisitDate
    enquiryClosure {
      remarks
      enquiryCloseReason
    }
    createdAt
    customer {
      customerState {
        state
      }
      customerDistrict {
        name
      }
      customerTehsil {
        name
      }
      name
      phoneNo
      state
      district
      tehsil
    }
    tentativePurchaseTime
    enquiryClosure {
      enquiryCloseReason
    }
    interestedIn {
      id
      name
      brand {
        name
      }
    }
    followups {
      followupDate
      nextFollowup {
        followupDate
      }
    }
    budget
    status
    updatedAt
    enquiryType
    centre {
      name
    }
    followupsAggregate {
      count
    }
    createdBy {
      name
      createdAt
    }
  }
}
    `;

/**
 * __useEnquiryFilterQuery__
 *
 * To run a query within a React component, call `useEnquiryFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnquiryFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnquiryFilterQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnquiryFilterQuery(baseOptions: Apollo.QueryHookOptions<EnquiryFilterQuery, EnquiryFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnquiryFilterQuery, EnquiryFilterQueryVariables>(EnquiryFilterDocument, options);
      }
export function useEnquiryFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnquiryFilterQuery, EnquiryFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnquiryFilterQuery, EnquiryFilterQueryVariables>(EnquiryFilterDocument, options);
        }
export type EnquiryFilterQueryHookResult = ReturnType<typeof useEnquiryFilterQuery>;
export type EnquiryFilterLazyQueryHookResult = ReturnType<typeof useEnquiryFilterLazyQuery>;
export type EnquiryFilterQueryResult = Apollo.QueryResult<EnquiryFilterQuery, EnquiryFilterQueryVariables>;
export const GetTimeDocument = gql`
    query getTime($id: [ID!]!) {
  queryEnquiry(filter: {id: $id}) {
    id
    enquiryType
    enquiryClosure {
      remarks
      enquiryCloseReason
    }
    isClosed
    createdAt
    createdBy {
      name
      createdAt
    }
    status
    followups {
      id
      status
      followupDate
      remarks
      isWalkin
      followedUpBy {
        id
        name
      }
      nextFollowup {
        id
        followupDate
        status
        remarks
      }
    }
  }
}
    `;

/**
 * __useGetTimeQuery__
 *
 * To run a query within a React component, call `useGetTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTimeQuery(baseOptions: Apollo.QueryHookOptions<GetTimeQuery, GetTimeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimeQuery, GetTimeQueryVariables>(GetTimeDocument, options);
      }
export function useGetTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeQuery, GetTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimeQuery, GetTimeQueryVariables>(GetTimeDocument, options);
        }
export type GetTimeQueryHookResult = ReturnType<typeof useGetTimeQuery>;
export type GetTimeLazyQueryHookResult = ReturnType<typeof useGetTimeLazyQuery>;
export type GetTimeQueryResult = Apollo.QueryResult<GetTimeQuery, GetTimeQueryVariables>;
export const GetTehsilsDocument = gql`
    query getTehsils($districtId: [ID!]!) {
  queryDistrict(filter: {id: $districtId}) {
    id
    name
    code
    tehsils {
      id
      name
      stateId
      distId
    }
  }
}
    `;

/**
 * __useGetTehsilsQuery__
 *
 * To run a query within a React component, call `useGetTehsilsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTehsilsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTehsilsQuery({
 *   variables: {
 *      districtId: // value for 'districtId'
 *   },
 * });
 */
export function useGetTehsilsQuery(baseOptions: Apollo.QueryHookOptions<GetTehsilsQuery, GetTehsilsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTehsilsQuery, GetTehsilsQueryVariables>(GetTehsilsDocument, options);
      }
export function useGetTehsilsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTehsilsQuery, GetTehsilsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTehsilsQuery, GetTehsilsQueryVariables>(GetTehsilsDocument, options);
        }
export type GetTehsilsQueryHookResult = ReturnType<typeof useGetTehsilsQuery>;
export type GetTehsilsLazyQueryHookResult = ReturnType<typeof useGetTehsilsLazyQuery>;
export type GetTehsilsQueryResult = Apollo.QueryResult<GetTehsilsQuery, GetTehsilsQueryVariables>;
export const FilteredEnquiryDocument = gql`
    query filteredEnquiry($state: String, $districts: [String], $tehsils: [String], $makes: [String], $models: [String], $isClosed: Boolean, $status: EnquiryStatus, $type: EnquiryType, $dateType: SelectTypeOfDate, $start: DateTime, $end: DateTime, $offset: Int, $pageSize: Int) {
  filteredEnquiry(
    enquiryFilters: {state: $state, enquiryStatus: $status, districts: $districts, selectTypeOfDate: $dateType, isClosed: $isClosed, makes: $makes, models: $models, enquiryType: $type, from: $start, to: $end, tehsils: $tehsils, offset: $offset, pageSize: $pageSize}
  ) {
    id
    isClosed
    createdAt
    lastVisitDate
    enquiryClosure {
      remarks
      enquiryCloseReason
    }
    customer {
      customerState {
        state
      }
      customerDistrict {
        name
      }
      customerTehsil {
        name
      }
      name
      phoneNo
      state
      district
      tehsil
    }
    followups {
      nextFollowup {
        followupDate
      }
    }
    budget
    status
    updatedAt
    enquiryType
    centre {
      name
    }
    followupsAggregate {
      count
    }
    createdBy {
      name
      createdAt
    }
  }
}
    `;

/**
 * __useFilteredEnquiryQuery__
 *
 * To run a query within a React component, call `useFilteredEnquiryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredEnquiryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredEnquiryQuery({
 *   variables: {
 *      state: // value for 'state'
 *      districts: // value for 'districts'
 *      tehsils: // value for 'tehsils'
 *      makes: // value for 'makes'
 *      models: // value for 'models'
 *      isClosed: // value for 'isClosed'
 *      status: // value for 'status'
 *      type: // value for 'type'
 *      dateType: // value for 'dateType'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      offset: // value for 'offset'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useFilteredEnquiryQuery(baseOptions?: Apollo.QueryHookOptions<FilteredEnquiryQuery, FilteredEnquiryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredEnquiryQuery, FilteredEnquiryQueryVariables>(FilteredEnquiryDocument, options);
      }
export function useFilteredEnquiryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredEnquiryQuery, FilteredEnquiryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredEnquiryQuery, FilteredEnquiryQueryVariables>(FilteredEnquiryDocument, options);
        }
export type FilteredEnquiryQueryHookResult = ReturnType<typeof useFilteredEnquiryQuery>;
export type FilteredEnquiryLazyQueryHookResult = ReturnType<typeof useFilteredEnquiryLazyQuery>;
export type FilteredEnquiryQueryResult = Apollo.QueryResult<FilteredEnquiryQuery, FilteredEnquiryQueryVariables>;
export const EnquiryByCentreDocument = gql`
    query EnquiryByCentre($start: DateTime, $end: DateTime, $key: String) {
  enquiryAggrigateByCentre(dateRange: {start: $start, end: $end}, key: $key) {
    centre {
      id
      name
    }
    totalCold
    totalHot
    totalWarm
    hotEnquiryCloser {
      closed
      infollowUp
      notIntrested
      notResponding
      purchasedUsedTractor
      purchaseNewTractor
      tractorBooked
    }
    coldEnquiryCloser {
      closed
      infollowUp
      notIntrested
      notResponding
      purchasedUsedTractor
      purchaseNewTractor
      tractorBooked
    }
    warmEnquiryCloser {
      closed
      infollowUp
      notIntrested
      notResponding
      purchasedUsedTractor
      purchaseNewTractor
      tractorBooked
    }
  }
}
    `;

/**
 * __useEnquiryByCentreQuery__
 *
 * To run a query within a React component, call `useEnquiryByCentreQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnquiryByCentreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnquiryByCentreQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useEnquiryByCentreQuery(baseOptions?: Apollo.QueryHookOptions<EnquiryByCentreQuery, EnquiryByCentreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnquiryByCentreQuery, EnquiryByCentreQueryVariables>(EnquiryByCentreDocument, options);
      }
export function useEnquiryByCentreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnquiryByCentreQuery, EnquiryByCentreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnquiryByCentreQuery, EnquiryByCentreQueryVariables>(EnquiryByCentreDocument, options);
        }
export type EnquiryByCentreQueryHookResult = ReturnType<typeof useEnquiryByCentreQuery>;
export type EnquiryByCentreLazyQueryHookResult = ReturnType<typeof useEnquiryByCentreLazyQuery>;
export type EnquiryByCentreQueryResult = Apollo.QueryResult<EnquiryByCentreQuery, EnquiryByCentreQueryVariables>;
export const FollowupAdherenceDocument = gql`
    query FollowupAdherence($start: DateTime, $end: DateTime, $key: String) {
  enquiryFollowupAdderence(dateRange: {start: $start, end: $end}, key: $key) {
    centre {
      id
      name
    }
    AvgAging
    totalEnquiry
    totalOpen
    totalClosed
    totalFollowups
    closedFollowups
    AdhirenceRatio
  }
}
    `;

/**
 * __useFollowupAdherenceQuery__
 *
 * To run a query within a React component, call `useFollowupAdherenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useFollowupAdherenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFollowupAdherenceQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useFollowupAdherenceQuery(baseOptions?: Apollo.QueryHookOptions<FollowupAdherenceQuery, FollowupAdherenceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FollowupAdherenceQuery, FollowupAdherenceQueryVariables>(FollowupAdherenceDocument, options);
      }
export function useFollowupAdherenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FollowupAdherenceQuery, FollowupAdherenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FollowupAdherenceQuery, FollowupAdherenceQueryVariables>(FollowupAdherenceDocument, options);
        }
export type FollowupAdherenceQueryHookResult = ReturnType<typeof useFollowupAdherenceQuery>;
export type FollowupAdherenceLazyQueryHookResult = ReturnType<typeof useFollowupAdherenceLazyQuery>;
export type FollowupAdherenceQueryResult = Apollo.QueryResult<FollowupAdherenceQuery, FollowupAdherenceQueryVariables>;
export const EnquiryDashboardExportDocument = gql`
    query EnquiryDashboardExport {
  queryEnquiry {
    id
    followups(first: -1) {
      id
      nextFollowup {
        followupDate
      }
      followupDate
    }
    customer {
      name
      phoneNo
      customerDistrict {
        name
      }
      customerState {
        state
      }
    }
  }
}
    `;

/**
 * __useEnquiryDashboardExportQuery__
 *
 * To run a query within a React component, call `useEnquiryDashboardExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnquiryDashboardExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnquiryDashboardExportQuery({
 *   variables: {
 *   },
 * });
 */
export function useEnquiryDashboardExportQuery(baseOptions?: Apollo.QueryHookOptions<EnquiryDashboardExportQuery, EnquiryDashboardExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnquiryDashboardExportQuery, EnquiryDashboardExportQueryVariables>(EnquiryDashboardExportDocument, options);
      }
export function useEnquiryDashboardExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnquiryDashboardExportQuery, EnquiryDashboardExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnquiryDashboardExportQuery, EnquiryDashboardExportQueryVariables>(EnquiryDashboardExportDocument, options);
        }
export type EnquiryDashboardExportQueryHookResult = ReturnType<typeof useEnquiryDashboardExportQuery>;
export type EnquiryDashboardExportLazyQueryHookResult = ReturnType<typeof useEnquiryDashboardExportLazyQuery>;
export type EnquiryDashboardExportQueryResult = Apollo.QueryResult<EnquiryDashboardExportQuery, EnquiryDashboardExportQueryVariables>;
export const EnquiryDashboardListDocument = gql`
    query enquiryDashboardList($dateType: SelectTypeOfDate, $start: DateTime, $end: DateTime, $centreId: String) {
  filteredEnquiry(
    enquiryFilters: {selectTypeOfDate: $dateType, from: $start, to: $end, centreId: $centreId}
  ) {
    id
    isClosed
    createdAt
    lastVisitDate
    customer {
      customerState {
        state
      }
      customerDistrict {
        name
      }
      customerTehsil {
        name
      }
      name
      phoneNo
      state
      district
      tehsil
    }
    budget
    status
    updatedAt
    enquiryType
    centre {
      name
    }
    followupsAggregate {
      count
    }
    createdBy {
      name
      createdAt
    }
  }
}
    `;

/**
 * __useEnquiryDashboardListQuery__
 *
 * To run a query within a React component, call `useEnquiryDashboardListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnquiryDashboardListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnquiryDashboardListQuery({
 *   variables: {
 *      dateType: // value for 'dateType'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      centreId: // value for 'centreId'
 *   },
 * });
 */
export function useEnquiryDashboardListQuery(baseOptions?: Apollo.QueryHookOptions<EnquiryDashboardListQuery, EnquiryDashboardListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnquiryDashboardListQuery, EnquiryDashboardListQueryVariables>(EnquiryDashboardListDocument, options);
      }
export function useEnquiryDashboardListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnquiryDashboardListQuery, EnquiryDashboardListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnquiryDashboardListQuery, EnquiryDashboardListQueryVariables>(EnquiryDashboardListDocument, options);
        }
export type EnquiryDashboardListQueryHookResult = ReturnType<typeof useEnquiryDashboardListQuery>;
export type EnquiryDashboardListLazyQueryHookResult = ReturnType<typeof useEnquiryDashboardListLazyQuery>;
export type EnquiryDashboardListQueryResult = Apollo.QueryResult<EnquiryDashboardListQuery, EnquiryDashboardListQueryVariables>;
export const GetLeadFilterResultsDocument = gql`
    query getLeadFilterResults($statuses: [LeadStatus], $dealStatus: DealStatus, $bankConfirmationStatus: BankConfirmationStatus, $registrationState: [String], $makes: [VehicleMake], $models: [String], $purchaseYearsRange: DateRange, $auctioningAgencyName: [String], $sourcedBankName: [BankName], $repositionDateRange: DateRange, $pickupDateRange: DateRange, $driverName: [String], $centreName: [String], $paymentStatus: [PaymentStatus], $isRcAvailable: Boolean) {
  filteredLeads(
    leadFilters: {statuses: $statuses, dealStatus: $dealStatus, bankConfirmationStatus: $bankConfirmationStatus, registrationStates: $registrationState, makes: $makes, models: $models, purchaseYearsRange: $purchaseYearsRange, auctioningAgencyName: $auctioningAgencyName, sourcedBankName: $sourcedBankName, repositionDateRange: $repositionDateRange, pickupDateRange: $pickupDateRange, driverName: $driverName, centreName: $centreName, paymentStatus: $paymentStatus, isRcAvailable: $isRcAvailable}
  ) {
    ...LeadPreview
  }
}
    ${LeadPreviewFragmentDoc}`;

/**
 * __useGetLeadFilterResultsQuery__
 *
 * To run a query within a React component, call `useGetLeadFilterResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadFilterResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadFilterResultsQuery({
 *   variables: {
 *      statuses: // value for 'statuses'
 *      dealStatus: // value for 'dealStatus'
 *      bankConfirmationStatus: // value for 'bankConfirmationStatus'
 *      registrationState: // value for 'registrationState'
 *      makes: // value for 'makes'
 *      models: // value for 'models'
 *      purchaseYearsRange: // value for 'purchaseYearsRange'
 *      auctioningAgencyName: // value for 'auctioningAgencyName'
 *      sourcedBankName: // value for 'sourcedBankName'
 *      repositionDateRange: // value for 'repositionDateRange'
 *      pickupDateRange: // value for 'pickupDateRange'
 *      driverName: // value for 'driverName'
 *      centreName: // value for 'centreName'
 *      paymentStatus: // value for 'paymentStatus'
 *      isRcAvailable: // value for 'isRcAvailable'
 *   },
 * });
 */
export function useGetLeadFilterResultsQuery(baseOptions?: Apollo.QueryHookOptions<GetLeadFilterResultsQuery, GetLeadFilterResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadFilterResultsQuery, GetLeadFilterResultsQueryVariables>(GetLeadFilterResultsDocument, options);
      }
export function useGetLeadFilterResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadFilterResultsQuery, GetLeadFilterResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadFilterResultsQuery, GetLeadFilterResultsQueryVariables>(GetLeadFilterResultsDocument, options);
        }
export type GetLeadFilterResultsQueryHookResult = ReturnType<typeof useGetLeadFilterResultsQuery>;
export type GetLeadFilterResultsLazyQueryHookResult = ReturnType<typeof useGetLeadFilterResultsLazyQuery>;
export type GetLeadFilterResultsQueryResult = Apollo.QueryResult<GetLeadFilterResultsQuery, GetLeadFilterResultsQueryVariables>;
export const ModelbyMakeDocument = gql`
    query modelbyMake($make: String) {
  queryModelByMake(filter: {make: {alloftext: $make}}) {
    model
  }
}
    `;

/**
 * __useModelbyMakeQuery__
 *
 * To run a query within a React component, call `useModelbyMakeQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelbyMakeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelbyMakeQuery({
 *   variables: {
 *      make: // value for 'make'
 *   },
 * });
 */
export function useModelbyMakeQuery(baseOptions?: Apollo.QueryHookOptions<ModelbyMakeQuery, ModelbyMakeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelbyMakeQuery, ModelbyMakeQueryVariables>(ModelbyMakeDocument, options);
      }
export function useModelbyMakeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelbyMakeQuery, ModelbyMakeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelbyMakeQuery, ModelbyMakeQueryVariables>(ModelbyMakeDocument, options);
        }
export type ModelbyMakeQueryHookResult = ReturnType<typeof useModelbyMakeQuery>;
export type ModelbyMakeLazyQueryHookResult = ReturnType<typeof useModelbyMakeLazyQuery>;
export type ModelbyMakeQueryResult = Apollo.QueryResult<ModelbyMakeQuery, ModelbyMakeQueryVariables>;
export const AddFollowupsDocument = gql`
    mutation AddFollowups($regNo: String, $comments: String, $documentName: String, $updatedBy: ID, $followupDate: DateTime, $nextFollowupDate: DateTime, $actionType: ActionType, $source: String) {
  updateLead(
    input: {filter: {regNo: {allofterms: $regNo}}, set: {documentsFollowups: {lead: {regNo: $regNo}, remarks: $comments, followedUpBy: {id: $updatedBy}, nextFollowupDate: $nextFollowupDate, followupDate: $followupDate, documentName: $documentName, actionType: $actionType, source: $source}}}
  ) {
    lead {
      documentsFollowups {
        id
      }
    }
  }
}
    `;
export type AddFollowupsMutationFn = Apollo.MutationFunction<AddFollowupsMutation, AddFollowupsMutationVariables>;

/**
 * __useAddFollowupsMutation__
 *
 * To run a mutation, you first call `useAddFollowupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFollowupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFollowupsMutation, { data, loading, error }] = useAddFollowupsMutation({
 *   variables: {
 *      regNo: // value for 'regNo'
 *      comments: // value for 'comments'
 *      documentName: // value for 'documentName'
 *      updatedBy: // value for 'updatedBy'
 *      followupDate: // value for 'followupDate'
 *      nextFollowupDate: // value for 'nextFollowupDate'
 *      actionType: // value for 'actionType'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useAddFollowupsMutation(baseOptions?: Apollo.MutationHookOptions<AddFollowupsMutation, AddFollowupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFollowupsMutation, AddFollowupsMutationVariables>(AddFollowupsDocument, options);
      }
export type AddFollowupsMutationHookResult = ReturnType<typeof useAddFollowupsMutation>;
export type AddFollowupsMutationResult = Apollo.MutationResult<AddFollowupsMutation>;
export type AddFollowupsMutationOptions = Apollo.BaseMutationOptions<AddFollowupsMutation, AddFollowupsMutationVariables>;
export const DocumentRequiredDocument = gql`
    mutation documentRequired($checklistPatch: [AddDocumentChecklistInput!]!) {
  addDocumentChecklist(input: $checklistPatch, upsert: true) {
    documentChecklist {
      id
    }
  }
}
    `;
export type DocumentRequiredMutationFn = Apollo.MutationFunction<DocumentRequiredMutation, DocumentRequiredMutationVariables>;

/**
 * __useDocumentRequiredMutation__
 *
 * To run a mutation, you first call `useDocumentRequiredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocumentRequiredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [documentRequiredMutation, { data, loading, error }] = useDocumentRequiredMutation({
 *   variables: {
 *      checklistPatch: // value for 'checklistPatch'
 *   },
 * });
 */
export function useDocumentRequiredMutation(baseOptions?: Apollo.MutationHookOptions<DocumentRequiredMutation, DocumentRequiredMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DocumentRequiredMutation, DocumentRequiredMutationVariables>(DocumentRequiredDocument, options);
      }
export type DocumentRequiredMutationHookResult = ReturnType<typeof useDocumentRequiredMutation>;
export type DocumentRequiredMutationResult = Apollo.MutationResult<DocumentRequiredMutation>;
export type DocumentRequiredMutationOptions = Apollo.BaseMutationOptions<DocumentRequiredMutation, DocumentRequiredMutationVariables>;
export const AddDocumentsDocument = gql`
    mutation addDocuments($addLeadDocuments: [AddLeadDocumentsInput!]!) {
  addLeadDocuments(input: $addLeadDocuments, upsert: true) {
    leadDocuments {
      form26
    }
  }
}
    `;
export type AddDocumentsMutationFn = Apollo.MutationFunction<AddDocumentsMutation, AddDocumentsMutationVariables>;

/**
 * __useAddDocumentsMutation__
 *
 * To run a mutation, you first call `useAddDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDocumentsMutation, { data, loading, error }] = useAddDocumentsMutation({
 *   variables: {
 *      addLeadDocuments: // value for 'addLeadDocuments'
 *   },
 * });
 */
export function useAddDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<AddDocumentsMutation, AddDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDocumentsMutation, AddDocumentsMutationVariables>(AddDocumentsDocument, options);
      }
export type AddDocumentsMutationHookResult = ReturnType<typeof useAddDocumentsMutation>;
export type AddDocumentsMutationResult = Apollo.MutationResult<AddDocumentsMutation>;
export type AddDocumentsMutationOptions = Apollo.BaseMutationOptions<AddDocumentsMutation, AddDocumentsMutationVariables>;
export const GetAllCenterDocument = gql`
    query GetAllCenter {
  queryCentre {
    ...CenterPreview
  }
}
    ${CenterPreviewFragmentDoc}`;

/**
 * __useGetAllCenterQuery__
 *
 * To run a query within a React component, call `useGetAllCenterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCenterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCenterQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCenterQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCenterQuery, GetAllCenterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCenterQuery, GetAllCenterQueryVariables>(GetAllCenterDocument, options);
      }
export function useGetAllCenterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCenterQuery, GetAllCenterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCenterQuery, GetAllCenterQueryVariables>(GetAllCenterDocument, options);
        }
export type GetAllCenterQueryHookResult = ReturnType<typeof useGetAllCenterQuery>;
export type GetAllCenterLazyQueryHookResult = ReturnType<typeof useGetAllCenterLazyQuery>;
export type GetAllCenterQueryResult = Apollo.QueryResult<GetAllCenterQuery, GetAllCenterQueryVariables>;
export const GetCentreDataFromTjDocument = gql`
    query GetCentreDataFromTJ {
  getCentreDataFromTJ {
    ...CenterPreview
  }
}
    ${CenterPreviewFragmentDoc}`;

/**
 * __useGetCentreDataFromTjQuery__
 *
 * To run a query within a React component, call `useGetCentreDataFromTjQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCentreDataFromTjQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCentreDataFromTjQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCentreDataFromTjQuery(baseOptions?: Apollo.QueryHookOptions<GetCentreDataFromTjQuery, GetCentreDataFromTjQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCentreDataFromTjQuery, GetCentreDataFromTjQueryVariables>(GetCentreDataFromTjDocument, options);
      }
export function useGetCentreDataFromTjLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCentreDataFromTjQuery, GetCentreDataFromTjQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCentreDataFromTjQuery, GetCentreDataFromTjQueryVariables>(GetCentreDataFromTjDocument, options);
        }
export type GetCentreDataFromTjQueryHookResult = ReturnType<typeof useGetCentreDataFromTjQuery>;
export type GetCentreDataFromTjLazyQueryHookResult = ReturnType<typeof useGetCentreDataFromTjLazyQuery>;
export type GetCentreDataFromTjQueryResult = Apollo.QueryResult<GetCentreDataFromTjQuery, GetCentreDataFromTjQueryVariables>;
export const GetStateWithGstinDocument = gql`
    query getStateWithGSTIN {
  queryActiveStateWithGSTN(order: {desc: updatedAt}) {
    id
    GSTNumber
    active
    state
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetStateWithGstinQuery__
 *
 * To run a query within a React component, call `useGetStateWithGstinQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStateWithGstinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStateWithGstinQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStateWithGstinQuery(baseOptions?: Apollo.QueryHookOptions<GetStateWithGstinQuery, GetStateWithGstinQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStateWithGstinQuery, GetStateWithGstinQueryVariables>(GetStateWithGstinDocument, options);
      }
export function useGetStateWithGstinLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStateWithGstinQuery, GetStateWithGstinQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStateWithGstinQuery, GetStateWithGstinQueryVariables>(GetStateWithGstinDocument, options);
        }
export type GetStateWithGstinQueryHookResult = ReturnType<typeof useGetStateWithGstinQuery>;
export type GetStateWithGstinLazyQueryHookResult = ReturnType<typeof useGetStateWithGstinLazyQuery>;
export type GetStateWithGstinQueryResult = Apollo.QueryResult<GetStateWithGstinQuery, GetStateWithGstinQueryVariables>;
export const GetStateWithGstinForUpdateDocument = gql`
    query getStateWithGSTINForUpdate($id: [ID!]!) {
  queryActiveStateWithGSTN(filter: {id: $id}) {
    id
    GSTNumber
    active
    state
  }
}
    `;

/**
 * __useGetStateWithGstinForUpdateQuery__
 *
 * To run a query within a React component, call `useGetStateWithGstinForUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStateWithGstinForUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStateWithGstinForUpdateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStateWithGstinForUpdateQuery(baseOptions: Apollo.QueryHookOptions<GetStateWithGstinForUpdateQuery, GetStateWithGstinForUpdateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStateWithGstinForUpdateQuery, GetStateWithGstinForUpdateQueryVariables>(GetStateWithGstinForUpdateDocument, options);
      }
export function useGetStateWithGstinForUpdateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStateWithGstinForUpdateQuery, GetStateWithGstinForUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStateWithGstinForUpdateQuery, GetStateWithGstinForUpdateQueryVariables>(GetStateWithGstinForUpdateDocument, options);
        }
export type GetStateWithGstinForUpdateQueryHookResult = ReturnType<typeof useGetStateWithGstinForUpdateQuery>;
export type GetStateWithGstinForUpdateLazyQueryHookResult = ReturnType<typeof useGetStateWithGstinForUpdateLazyQuery>;
export type GetStateWithGstinForUpdateQueryResult = Apollo.QueryResult<GetStateWithGstinForUpdateQuery, GetStateWithGstinForUpdateQueryVariables>;
export const AddStateWithGstnDocument = gql`
    mutation AddStateWithGSTN($active: Boolean, $GSTNumber: String, $state: String!, $createdAt: DateTime, $updatedAt: DateTime) {
  addActiveStateWithGSTN(
    input: {active: $active, GSTNumber: $GSTNumber, state: $state, createdAt: $createdAt, updatedAt: $updatedAt}
  ) {
    activeStateWithGSTN {
      active
      GSTNumber
      state
    }
  }
}
    `;
export type AddStateWithGstnMutationFn = Apollo.MutationFunction<AddStateWithGstnMutation, AddStateWithGstnMutationVariables>;

/**
 * __useAddStateWithGstnMutation__
 *
 * To run a mutation, you first call `useAddStateWithGstnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStateWithGstnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStateWithGstnMutation, { data, loading, error }] = useAddStateWithGstnMutation({
 *   variables: {
 *      active: // value for 'active'
 *      GSTNumber: // value for 'GSTNumber'
 *      state: // value for 'state'
 *      createdAt: // value for 'createdAt'
 *      updatedAt: // value for 'updatedAt'
 *   },
 * });
 */
export function useAddStateWithGstnMutation(baseOptions?: Apollo.MutationHookOptions<AddStateWithGstnMutation, AddStateWithGstnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddStateWithGstnMutation, AddStateWithGstnMutationVariables>(AddStateWithGstnDocument, options);
      }
export type AddStateWithGstnMutationHookResult = ReturnType<typeof useAddStateWithGstnMutation>;
export type AddStateWithGstnMutationResult = Apollo.MutationResult<AddStateWithGstnMutation>;
export type AddStateWithGstnMutationOptions = Apollo.BaseMutationOptions<AddStateWithGstnMutation, AddStateWithGstnMutationVariables>;
export const UpdateActiveStateWithGstnDocument = gql`
    mutation updateActiveStateWithGSTN($active: Boolean, $GSTNumber: String, $state: String!, $updatedAt: DateTime!) {
  updateActiveStateWithGSTN(
    input: {filter: {state: {eq: $state}}, set: {active: $active, GSTNumber: $GSTNumber, updatedAt: $updatedAt}}
  ) {
    activeStateWithGSTN {
      active
      GSTNumber
      RTOCode
    }
  }
}
    `;
export type UpdateActiveStateWithGstnMutationFn = Apollo.MutationFunction<UpdateActiveStateWithGstnMutation, UpdateActiveStateWithGstnMutationVariables>;

/**
 * __useUpdateActiveStateWithGstnMutation__
 *
 * To run a mutation, you first call `useUpdateActiveStateWithGstnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActiveStateWithGstnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActiveStateWithGstnMutation, { data, loading, error }] = useUpdateActiveStateWithGstnMutation({
 *   variables: {
 *      active: // value for 'active'
 *      GSTNumber: // value for 'GSTNumber'
 *      state: // value for 'state'
 *      updatedAt: // value for 'updatedAt'
 *   },
 * });
 */
export function useUpdateActiveStateWithGstnMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActiveStateWithGstnMutation, UpdateActiveStateWithGstnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActiveStateWithGstnMutation, UpdateActiveStateWithGstnMutationVariables>(UpdateActiveStateWithGstnDocument, options);
      }
export type UpdateActiveStateWithGstnMutationHookResult = ReturnType<typeof useUpdateActiveStateWithGstnMutation>;
export type UpdateActiveStateWithGstnMutationResult = Apollo.MutationResult<UpdateActiveStateWithGstnMutation>;
export type UpdateActiveStateWithGstnMutationOptions = Apollo.BaseMutationOptions<UpdateActiveStateWithGstnMutation, UpdateActiveStateWithGstnMutationVariables>;
export const GetAllActiveStateDocument = gql`
    query getAllActiveState {
  getStateInfo(activeState: true) {
    data {
      state_id
      state_name
      tr_state_id
    }
  }
}
    `;

/**
 * __useGetAllActiveStateQuery__
 *
 * To run a query within a React component, call `useGetAllActiveStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllActiveStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllActiveStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllActiveStateQuery(baseOptions?: Apollo.QueryHookOptions<GetAllActiveStateQuery, GetAllActiveStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllActiveStateQuery, GetAllActiveStateQueryVariables>(GetAllActiveStateDocument, options);
      }
export function useGetAllActiveStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllActiveStateQuery, GetAllActiveStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllActiveStateQuery, GetAllActiveStateQueryVariables>(GetAllActiveStateDocument, options);
        }
export type GetAllActiveStateQueryHookResult = ReturnType<typeof useGetAllActiveStateQuery>;
export type GetAllActiveStateLazyQueryHookResult = ReturnType<typeof useGetAllActiveStateLazyQuery>;
export type GetAllActiveStateQueryResult = Apollo.QueryResult<GetAllActiveStateQuery, GetAllActiveStateQueryVariables>;
export const GetAllActiveStateListDocument = gql`
    query getAllActiveStateList {
  getStateInfo {
    data {
      state_id
      state_name
      tr_state_id
    }
  }
}
    `;

/**
 * __useGetAllActiveStateListQuery__
 *
 * To run a query within a React component, call `useGetAllActiveStateListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllActiveStateListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllActiveStateListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllActiveStateListQuery(baseOptions?: Apollo.QueryHookOptions<GetAllActiveStateListQuery, GetAllActiveStateListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllActiveStateListQuery, GetAllActiveStateListQueryVariables>(GetAllActiveStateListDocument, options);
      }
export function useGetAllActiveStateListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllActiveStateListQuery, GetAllActiveStateListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllActiveStateListQuery, GetAllActiveStateListQueryVariables>(GetAllActiveStateListDocument, options);
        }
export type GetAllActiveStateListQueryHookResult = ReturnType<typeof useGetAllActiveStateListQuery>;
export type GetAllActiveStateListLazyQueryHookResult = ReturnType<typeof useGetAllActiveStateListLazyQuery>;
export type GetAllActiveStateListQueryResult = Apollo.QueryResult<GetAllActiveStateListQuery, GetAllActiveStateListQueryVariables>;
export const GetCenterDetailsDocument = gql`
    query GetCenterDetails($id: ID!) {
  getCentre(id: $id) {
    name
    id
    address
    pincode
    state
    city
    capacity
    createdAt
    updatedAt
    status
    incharge {
      name
      phoneNo
      email
    }
    leads @cascade(fields: ["statusEvents"]) {
      regNo
      centre {
        name
      }
      statusEvents(filter: {status: {eq: VEHICLE_IN_STOCK}}) {
        id
      }
    }
    location {
      latitude
      longitude
    }
  }
}
    `;

/**
 * __useGetCenterDetailsQuery__
 *
 * To run a query within a React component, call `useGetCenterDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCenterDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCenterDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCenterDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetCenterDetailsQuery, GetCenterDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCenterDetailsQuery, GetCenterDetailsQueryVariables>(GetCenterDetailsDocument, options);
      }
export function useGetCenterDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCenterDetailsQuery, GetCenterDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCenterDetailsQuery, GetCenterDetailsQueryVariables>(GetCenterDetailsDocument, options);
        }
export type GetCenterDetailsQueryHookResult = ReturnType<typeof useGetCenterDetailsQuery>;
export type GetCenterDetailsLazyQueryHookResult = ReturnType<typeof useGetCenterDetailsLazyQuery>;
export type GetCenterDetailsQueryResult = Apollo.QueryResult<GetCenterDetailsQuery, GetCenterDetailsQueryVariables>;
export const GetCentrePurchaseAndIssuesDocument = gql`
    query GetCentrePurchaseAndIssues($centreId: ID!, $productId: [ID!]!) {
  getCentre(id: $centreId) {
    issues @cascade(fields: ["items"]) {
      id
      status
      regNo
      centre {
        id
        name
      }
      madeBy {
        id
        name
      }
      createdAt
      items @cascade(fields: ["product"]) {
        id
        price
        quantity
        product(filter: {id: $productId}) {
          name
          id
        }
      }
    }
    purchases(order: {desc: createdAt}) @cascade(fields: ["items"]) {
      id
      status
      invoiceUrl
      centre {
        id
        name
      }
      madeBy {
        id
        name
      }
      createdAt
      items @cascade(fields: ["product"]) {
        id
        price
        quantity
        product(filter: {id: $productId}) {
          name
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetCentrePurchaseAndIssuesQuery__
 *
 * To run a query within a React component, call `useGetCentrePurchaseAndIssuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCentrePurchaseAndIssuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCentrePurchaseAndIssuesQuery({
 *   variables: {
 *      centreId: // value for 'centreId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetCentrePurchaseAndIssuesQuery(baseOptions: Apollo.QueryHookOptions<GetCentrePurchaseAndIssuesQuery, GetCentrePurchaseAndIssuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCentrePurchaseAndIssuesQuery, GetCentrePurchaseAndIssuesQueryVariables>(GetCentrePurchaseAndIssuesDocument, options);
      }
export function useGetCentrePurchaseAndIssuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCentrePurchaseAndIssuesQuery, GetCentrePurchaseAndIssuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCentrePurchaseAndIssuesQuery, GetCentrePurchaseAndIssuesQueryVariables>(GetCentrePurchaseAndIssuesDocument, options);
        }
export type GetCentrePurchaseAndIssuesQueryHookResult = ReturnType<typeof useGetCentrePurchaseAndIssuesQuery>;
export type GetCentrePurchaseAndIssuesLazyQueryHookResult = ReturnType<typeof useGetCentrePurchaseAndIssuesLazyQuery>;
export type GetCentrePurchaseAndIssuesQueryResult = Apollo.QueryResult<GetCentrePurchaseAndIssuesQuery, GetCentrePurchaseAndIssuesQueryVariables>;
export const AddStocksDocument = gql`
    mutation AddStocks($centreId: ID!, $items: [PurchaseItemRef], $madeById: ID!, $createdAt: DateTime!, $status: PurchaseStatus!, $invoiceUrl: String) {
  addPurchase(
    input: {centre: {id: $centreId}, items: $items, madeBy: {id: $madeById}, createdAt: $createdAt, status: $status, invoiceUrl: $invoiceUrl}
  ) {
    purchase {
      id
      invoiceUrl
      centre {
        id
        name
      }
      items {
        id
        product {
          id
          name
          variant
        }
      }
    }
  }
}
    `;
export type AddStocksMutationFn = Apollo.MutationFunction<AddStocksMutation, AddStocksMutationVariables>;

/**
 * __useAddStocksMutation__
 *
 * To run a mutation, you first call `useAddStocksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStocksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStocksMutation, { data, loading, error }] = useAddStocksMutation({
 *   variables: {
 *      centreId: // value for 'centreId'
 *      items: // value for 'items'
 *      madeById: // value for 'madeById'
 *      createdAt: // value for 'createdAt'
 *      status: // value for 'status'
 *      invoiceUrl: // value for 'invoiceUrl'
 *   },
 * });
 */
export function useAddStocksMutation(baseOptions?: Apollo.MutationHookOptions<AddStocksMutation, AddStocksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddStocksMutation, AddStocksMutationVariables>(AddStocksDocument, options);
      }
export type AddStocksMutationHookResult = ReturnType<typeof useAddStocksMutation>;
export type AddStocksMutationResult = Apollo.MutationResult<AddStocksMutation>;
export type AddStocksMutationOptions = Apollo.BaseMutationOptions<AddStocksMutation, AddStocksMutationVariables>;
export const AddIssueStocksDocument = gql`
    mutation AddIssueStocks($centreId: ID!, $items: [IssueItemRef], $madeById: ID!, $createdAt: DateTime!, $status: IssueStatus!) {
  addIssue(
    input: {centre: {id: $centreId}, items: $items, madeBy: {id: $madeById}, createdAt: $createdAt, status: $status}
  ) {
    issue {
      id
      centre {
        id
        name
      }
      items {
        id
        product {
          id
          name
          variant
        }
      }
    }
  }
}
    `;
export type AddIssueStocksMutationFn = Apollo.MutationFunction<AddIssueStocksMutation, AddIssueStocksMutationVariables>;

/**
 * __useAddIssueStocksMutation__
 *
 * To run a mutation, you first call `useAddIssueStocksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddIssueStocksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addIssueStocksMutation, { data, loading, error }] = useAddIssueStocksMutation({
 *   variables: {
 *      centreId: // value for 'centreId'
 *      items: // value for 'items'
 *      madeById: // value for 'madeById'
 *      createdAt: // value for 'createdAt'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useAddIssueStocksMutation(baseOptions?: Apollo.MutationHookOptions<AddIssueStocksMutation, AddIssueStocksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddIssueStocksMutation, AddIssueStocksMutationVariables>(AddIssueStocksDocument, options);
      }
export type AddIssueStocksMutationHookResult = ReturnType<typeof useAddIssueStocksMutation>;
export type AddIssueStocksMutationResult = Apollo.MutationResult<AddIssueStocksMutation>;
export type AddIssueStocksMutationOptions = Apollo.BaseMutationOptions<AddIssueStocksMutation, AddIssueStocksMutationVariables>;
export const GetStocksDetailsDocument = gql`
    query GetStocksDetails($centreId: ID) {
  inventoryDetails(centreId: $centreId) {
    items {
      availableInStock
      avgUnitPrice
      consumed
      createdAt
      id
      totalPurchase
      totalPrice
      purchaseQueue
      product {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetStocksDetailsQuery__
 *
 * To run a query within a React component, call `useGetStocksDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStocksDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStocksDetailsQuery({
 *   variables: {
 *      centreId: // value for 'centreId'
 *   },
 * });
 */
export function useGetStocksDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetStocksDetailsQuery, GetStocksDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStocksDetailsQuery, GetStocksDetailsQueryVariables>(GetStocksDetailsDocument, options);
      }
export function useGetStocksDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStocksDetailsQuery, GetStocksDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStocksDetailsQuery, GetStocksDetailsQueryVariables>(GetStocksDetailsDocument, options);
        }
export type GetStocksDetailsQueryHookResult = ReturnType<typeof useGetStocksDetailsQuery>;
export type GetStocksDetailsLazyQueryHookResult = ReturnType<typeof useGetStocksDetailsLazyQuery>;
export type GetStocksDetailsQueryResult = Apollo.QueryResult<GetStocksDetailsQuery, GetStocksDetailsQueryVariables>;
export const GetStocksIndividualDocument = gql`
    query GetStocksIndividual($centreId: ID, $id: String) {
  inventoryDetails(centreId: $centreId) {
    items(filter: {id: {eq: $id}}) {
      availableInStock
      avgUnitPrice
      consumed
      issueQueue
      createdAt
      id
      totalPurchase
      totalPrice
      purchaseQueue
      product {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetStocksIndividualQuery__
 *
 * To run a query within a React component, call `useGetStocksIndividualQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStocksIndividualQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStocksIndividualQuery({
 *   variables: {
 *      centreId: // value for 'centreId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStocksIndividualQuery(baseOptions?: Apollo.QueryHookOptions<GetStocksIndividualQuery, GetStocksIndividualQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStocksIndividualQuery, GetStocksIndividualQueryVariables>(GetStocksIndividualDocument, options);
      }
export function useGetStocksIndividualLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStocksIndividualQuery, GetStocksIndividualQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStocksIndividualQuery, GetStocksIndividualQueryVariables>(GetStocksIndividualDocument, options);
        }
export type GetStocksIndividualQueryHookResult = ReturnType<typeof useGetStocksIndividualQuery>;
export type GetStocksIndividualLazyQueryHookResult = ReturnType<typeof useGetStocksIndividualLazyQuery>;
export type GetStocksIndividualQueryResult = Apollo.QueryResult<GetStocksIndividualQuery, GetStocksIndividualQueryVariables>;
export const CheckDuplicateCenterDocument = gql`
    query CheckDuplicateCenter($name: String) {
  queryCentre(filter: {name: {regexp: $name}}) {
    name
  }
}
    `;

/**
 * __useCheckDuplicateCenterQuery__
 *
 * To run a query within a React component, call `useCheckDuplicateCenterQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckDuplicateCenterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckDuplicateCenterQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCheckDuplicateCenterQuery(baseOptions?: Apollo.QueryHookOptions<CheckDuplicateCenterQuery, CheckDuplicateCenterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckDuplicateCenterQuery, CheckDuplicateCenterQueryVariables>(CheckDuplicateCenterDocument, options);
      }
export function useCheckDuplicateCenterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckDuplicateCenterQuery, CheckDuplicateCenterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckDuplicateCenterQuery, CheckDuplicateCenterQueryVariables>(CheckDuplicateCenterDocument, options);
        }
export type CheckDuplicateCenterQueryHookResult = ReturnType<typeof useCheckDuplicateCenterQuery>;
export type CheckDuplicateCenterLazyQueryHookResult = ReturnType<typeof useCheckDuplicateCenterLazyQuery>;
export type CheckDuplicateCenterQueryResult = Apollo.QueryResult<CheckDuplicateCenterQuery, CheckDuplicateCenterQueryVariables>;
export const StockLeadsDocument = gql`
    query stockLeads($centerName: String, $status: LeadStatus) {
  filteredLeads(leadFilters: {hasStatus: [$status], centreName: [$centerName]}) {
    id
    regNo
    vehicle {
      make
      model
      manufacturingDate
      vehicleBrand {
        name
      }
      vehicleModel {
        name
      }
    }
    statusEvents {
      status
      assignTaskTo
      createdAt
    }
    source
    createdAt
    updatedAt
    createdBy {
      name
    }
    centre {
      id
      name
    }
    deliveryCentre {
      name
    }
  }
}
    `;

/**
 * __useStockLeadsQuery__
 *
 * To run a query within a React component, call `useStockLeadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockLeadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockLeadsQuery({
 *   variables: {
 *      centerName: // value for 'centerName'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useStockLeadsQuery(baseOptions?: Apollo.QueryHookOptions<StockLeadsQuery, StockLeadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StockLeadsQuery, StockLeadsQueryVariables>(StockLeadsDocument, options);
      }
export function useStockLeadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StockLeadsQuery, StockLeadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StockLeadsQuery, StockLeadsQueryVariables>(StockLeadsDocument, options);
        }
export type StockLeadsQueryHookResult = ReturnType<typeof useStockLeadsQuery>;
export type StockLeadsLazyQueryHookResult = ReturnType<typeof useStockLeadsLazyQuery>;
export type StockLeadsQueryResult = Apollo.QueryResult<StockLeadsQuery, StockLeadsQueryVariables>;
export const CenterDetailsDocument = gql`
    query CenterDetails($id: ID!) {
  getCentre(id: $id) {
    id
    name
    location {
      longitude
      latitude
    }
    pincode
    city
    status
    updatedAt
    state
    incharge {
      name
      email
      phoneNo
    }
  }
}
    `;

/**
 * __useCenterDetailsQuery__
 *
 * To run a query within a React component, call `useCenterDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCenterDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCenterDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCenterDetailsQuery(baseOptions: Apollo.QueryHookOptions<CenterDetailsQuery, CenterDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CenterDetailsQuery, CenterDetailsQueryVariables>(CenterDetailsDocument, options);
      }
export function useCenterDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CenterDetailsQuery, CenterDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CenterDetailsQuery, CenterDetailsQueryVariables>(CenterDetailsDocument, options);
        }
export type CenterDetailsQueryHookResult = ReturnType<typeof useCenterDetailsQuery>;
export type CenterDetailsLazyQueryHookResult = ReturnType<typeof useCenterDetailsLazyQuery>;
export type CenterDetailsQueryResult = Apollo.QueryResult<CenterDetailsQuery, CenterDetailsQueryVariables>;
export const AddInventoryCentreDocument = gql`
    mutation AddInventoryCentre($name: String!, $state: String, $pincode: Int, $status: CenterStatus, $lat: Float!, $long: Float!, $city: String, $createdAt: DateTime!, $updatedAt: DateTime!, $email: String!) {
  addCentre(
    input: {name: $name, state: $state, pincode: $pincode, status: $status, location: {latitude: $lat, longitude: $long}, city: $city, createdAt: $createdAt, updatedAt: $updatedAt, incharge: {email: $email}}
    upsert: true
  ) {
    centre {
      name
      pincode
      state
      location {
        latitude
        longitude
      }
      city
      status
      createdAt
      updatedAt
      incharge {
        name
        email
        phoneNo
      }
    }
  }
}
    `;
export type AddInventoryCentreMutationFn = Apollo.MutationFunction<AddInventoryCentreMutation, AddInventoryCentreMutationVariables>;

/**
 * __useAddInventoryCentreMutation__
 *
 * To run a mutation, you first call `useAddInventoryCentreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInventoryCentreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInventoryCentreMutation, { data, loading, error }] = useAddInventoryCentreMutation({
 *   variables: {
 *      name: // value for 'name'
 *      state: // value for 'state'
 *      pincode: // value for 'pincode'
 *      status: // value for 'status'
 *      lat: // value for 'lat'
 *      long: // value for 'long'
 *      city: // value for 'city'
 *      createdAt: // value for 'createdAt'
 *      updatedAt: // value for 'updatedAt'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useAddInventoryCentreMutation(baseOptions?: Apollo.MutationHookOptions<AddInventoryCentreMutation, AddInventoryCentreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddInventoryCentreMutation, AddInventoryCentreMutationVariables>(AddInventoryCentreDocument, options);
      }
export type AddInventoryCentreMutationHookResult = ReturnType<typeof useAddInventoryCentreMutation>;
export type AddInventoryCentreMutationResult = Apollo.MutationResult<AddInventoryCentreMutation>;
export type AddInventoryCentreMutationOptions = Apollo.BaseMutationOptions<AddInventoryCentreMutation, AddInventoryCentreMutationVariables>;
export const CenterUpdateDocument = gql`
    mutation centerUpdate($id: [ID!], $city: String, $state: String, $lat: Float!, $long: Float!, $pincode: Int, $status: CenterStatus, $updatedAt: DateTime!, $name: String, $email: String!, $phoneNo: String) {
  updateCentre(
    input: {filter: {id: $id}, set: {city: $city, state: $state, location: {latitude: $lat, longitude: $long}, pincode: $pincode, status: $status, updatedAt: $updatedAt, incharge: {name: $name, email: $email, phoneNo: $phoneNo}}}
  ) {
    centre {
      id
      name
      pincode
      state
      city
      status
      updatedAt
      incharge {
        name
        email
        phoneNo
      }
    }
    numUids
  }
}
    `;
export type CenterUpdateMutationFn = Apollo.MutationFunction<CenterUpdateMutation, CenterUpdateMutationVariables>;

/**
 * __useCenterUpdateMutation__
 *
 * To run a mutation, you first call `useCenterUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCenterUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [centerUpdateMutation, { data, loading, error }] = useCenterUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      lat: // value for 'lat'
 *      long: // value for 'long'
 *      pincode: // value for 'pincode'
 *      status: // value for 'status'
 *      updatedAt: // value for 'updatedAt'
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      phoneNo: // value for 'phoneNo'
 *   },
 * });
 */
export function useCenterUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CenterUpdateMutation, CenterUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CenterUpdateMutation, CenterUpdateMutationVariables>(CenterUpdateDocument, options);
      }
export type CenterUpdateMutationHookResult = ReturnType<typeof useCenterUpdateMutation>;
export type CenterUpdateMutationResult = Apollo.MutationResult<CenterUpdateMutation>;
export type CenterUpdateMutationOptions = Apollo.BaseMutationOptions<CenterUpdateMutation, CenterUpdateMutationVariables>;
export const GetCenterUserDocument = gql`
    query getCenterUser {
  queryUser(filter: {role: {eq: CENTRE_MANAGER}}) {
    email
    name
    phoneNo
  }
}
    `;

/**
 * __useGetCenterUserQuery__
 *
 * To run a query within a React component, call `useGetCenterUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCenterUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCenterUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCenterUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCenterUserQuery, GetCenterUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCenterUserQuery, GetCenterUserQueryVariables>(GetCenterUserDocument, options);
      }
export function useGetCenterUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCenterUserQuery, GetCenterUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCenterUserQuery, GetCenterUserQueryVariables>(GetCenterUserDocument, options);
        }
export type GetCenterUserQueryHookResult = ReturnType<typeof useGetCenterUserQuery>;
export type GetCenterUserLazyQueryHookResult = ReturnType<typeof useGetCenterUserLazyQuery>;
export type GetCenterUserQueryResult = Apollo.QueryResult<GetCenterUserQuery, GetCenterUserQueryVariables>;
export const GetUserforUserDocument = gql`
    query getUserforUser {
  queryUser {
    name
    id
    registrationState
    email
    role
    isActive
    centre {
      id
      name
    }
    reportingManager {
      name
      email
      role
    }
  }
}
    `;

/**
 * __useGetUserforUserQuery__
 *
 * To run a query within a React component, call `useGetUserforUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserforUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserforUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserforUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserforUserQuery, GetUserforUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserforUserQuery, GetUserforUserQueryVariables>(GetUserforUserDocument, options);
      }
export function useGetUserforUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserforUserQuery, GetUserforUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserforUserQuery, GetUserforUserQueryVariables>(GetUserforUserDocument, options);
        }
export type GetUserforUserQueryHookResult = ReturnType<typeof useGetUserforUserQuery>;
export type GetUserforUserLazyQueryHookResult = ReturnType<typeof useGetUserforUserLazyQuery>;
export type GetUserforUserQueryResult = Apollo.QueryResult<GetUserforUserQuery, GetUserforUserQueryVariables>;
export const GetUserEmailDocument = gql`
    query getUserEmail($id: [ID!]!) {
  queryUser(filter: {id: $id}, order: {desc: updatedAt}) {
    id
    name
    role
    email
    createdAt
    isActive
    registrationState
    reportingManager {
      name
      id
      email
    }
    updatedAt
    centre {
      id
      name
      incharge {
        id
        email
        name
      }
    }
  }
}
    `;

/**
 * __useGetUserEmailQuery__
 *
 * To run a query within a React component, call `useGetUserEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserEmailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserEmailQuery(baseOptions: Apollo.QueryHookOptions<GetUserEmailQuery, GetUserEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserEmailQuery, GetUserEmailQueryVariables>(GetUserEmailDocument, options);
      }
export function useGetUserEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserEmailQuery, GetUserEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserEmailQuery, GetUserEmailQueryVariables>(GetUserEmailDocument, options);
        }
export type GetUserEmailQueryHookResult = ReturnType<typeof useGetUserEmailQuery>;
export type GetUserEmailLazyQueryHookResult = ReturnType<typeof useGetUserEmailLazyQuery>;
export type GetUserEmailQueryResult = Apollo.QueryResult<GetUserEmailQuery, GetUserEmailQueryVariables>;
export const GenerateInvoiceDocument = gql`
    mutation GenerateInvoice($invoicePatch: [AddPaymentInvoicesInput!]!) {
  addPaymentInvoices(input: $invoicePatch) {
    paymentInvoices {
      id
      lead {
        id
      }
      payment {
        id
      }
      GSTNumber
    }
  }
}
    `;
export type GenerateInvoiceMutationFn = Apollo.MutationFunction<GenerateInvoiceMutation, GenerateInvoiceMutationVariables>;

/**
 * __useGenerateInvoiceMutation__
 *
 * To run a mutation, you first call `useGenerateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateInvoiceMutation, { data, loading, error }] = useGenerateInvoiceMutation({
 *   variables: {
 *      invoicePatch: // value for 'invoicePatch'
 *   },
 * });
 */
export function useGenerateInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<GenerateInvoiceMutation, GenerateInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateInvoiceMutation, GenerateInvoiceMutationVariables>(GenerateInvoiceDocument, options);
      }
export type GenerateInvoiceMutationHookResult = ReturnType<typeof useGenerateInvoiceMutation>;
export type GenerateInvoiceMutationResult = Apollo.MutationResult<GenerateInvoiceMutation>;
export type GenerateInvoiceMutationOptions = Apollo.BaseMutationOptions<GenerateInvoiceMutation, GenerateInvoiceMutationVariables>;
export const GetGsTforinvoiceDocument = gql`
    query getGSTforinvoice($state: String) {
  queryActiveStateWithGSTN(filter: {state: {regexp: $state}}) {
    GSTNumber
  }
}
    `;

/**
 * __useGetGsTforinvoiceQuery__
 *
 * To run a query within a React component, call `useGetGsTforinvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGsTforinvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGsTforinvoiceQuery({
 *   variables: {
 *      state: // value for 'state'
 *   },
 * });
 */
export function useGetGsTforinvoiceQuery(baseOptions?: Apollo.QueryHookOptions<GetGsTforinvoiceQuery, GetGsTforinvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGsTforinvoiceQuery, GetGsTforinvoiceQueryVariables>(GetGsTforinvoiceDocument, options);
      }
export function useGetGsTforinvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGsTforinvoiceQuery, GetGsTforinvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGsTforinvoiceQuery, GetGsTforinvoiceQueryVariables>(GetGsTforinvoiceDocument, options);
        }
export type GetGsTforinvoiceQueryHookResult = ReturnType<typeof useGetGsTforinvoiceQuery>;
export type GetGsTforinvoiceLazyQueryHookResult = ReturnType<typeof useGetGsTforinvoiceLazyQuery>;
export type GetGsTforinvoiceQueryResult = Apollo.QueryResult<GetGsTforinvoiceQuery, GetGsTforinvoiceQueryVariables>;
export const UpdateLeadPaymentInvoiceDocument = gql`
    mutation updateLeadPaymentInvoice($paymentId: [ID!]!, $invoiceId: ID) {
  updatePayment(
    input: {filter: {id: $paymentId}, set: {invoice: {id: $invoiceId}}}
  ) {
    payment {
      invoice {
        id
      }
    }
  }
}
    `;
export type UpdateLeadPaymentInvoiceMutationFn = Apollo.MutationFunction<UpdateLeadPaymentInvoiceMutation, UpdateLeadPaymentInvoiceMutationVariables>;

/**
 * __useUpdateLeadPaymentInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdateLeadPaymentInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeadPaymentInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeadPaymentInvoiceMutation, { data, loading, error }] = useUpdateLeadPaymentInvoiceMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useUpdateLeadPaymentInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeadPaymentInvoiceMutation, UpdateLeadPaymentInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeadPaymentInvoiceMutation, UpdateLeadPaymentInvoiceMutationVariables>(UpdateLeadPaymentInvoiceDocument, options);
      }
export type UpdateLeadPaymentInvoiceMutationHookResult = ReturnType<typeof useUpdateLeadPaymentInvoiceMutation>;
export type UpdateLeadPaymentInvoiceMutationResult = Apollo.MutationResult<UpdateLeadPaymentInvoiceMutation>;
export type UpdateLeadPaymentInvoiceMutationOptions = Apollo.BaseMutationOptions<UpdateLeadPaymentInvoiceMutation, UpdateLeadPaymentInvoiceMutationVariables>;
export const InvoiceDetailsDocument = gql`
    query InvoiceDetails($id: [ID!]!) {
  queryPaymentInvoices(filter: {id: $id}) {
    id
    GSTNumber
    serialNo
    customerName
    customerNumber
    payment {
      amount
      accountHolderName
      accountNo
      bankName
      mode
      ifsc
      createdAt
    }
    lead {
      regNo
      activeBooking {
        isInsuranceReq
        isRCTransferReq
        bookingPayment {
          saleAmount
          rcTransferAmount
          insuranceAmount
        }
      }
      vehicle {
        manufacturingDate
        vehicleBrand {
          name
        }
        vehicleModel {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useInvoiceDetailsQuery__
 *
 * To run a query within a React component, call `useInvoiceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoiceDetailsQuery(baseOptions: Apollo.QueryHookOptions<InvoiceDetailsQuery, InvoiceDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceDetailsQuery, InvoiceDetailsQueryVariables>(InvoiceDetailsDocument, options);
      }
export function useInvoiceDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceDetailsQuery, InvoiceDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceDetailsQuery, InvoiceDetailsQueryVariables>(InvoiceDetailsDocument, options);
        }
export type InvoiceDetailsQueryHookResult = ReturnType<typeof useInvoiceDetailsQuery>;
export type InvoiceDetailsLazyQueryHookResult = ReturnType<typeof useInvoiceDetailsLazyQuery>;
export type InvoiceDetailsQueryResult = Apollo.QueryResult<InvoiceDetailsQuery, InvoiceDetailsQueryVariables>;
export const GetInvoiceDocument = gql`
    query GetInvoice($id: ID!) {
  getLead(id: $id) {
    activeBooking {
      customer {
        name
        phoneNo
      }
      payments {
        id
        accountHolderName
        receiptUrl
        invoice {
          id
          GSTNumber
          invoiceId
        }
        accountNo
        amount
        for
      }
    }
  }
}
    `;

/**
 * __useGetInvoiceQuery__
 *
 * To run a query within a React component, call `useGetInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInvoiceQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceQuery, GetInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceQuery, GetInvoiceQueryVariables>(GetInvoiceDocument, options);
      }
export function useGetInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceQuery, GetInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceQuery, GetInvoiceQueryVariables>(GetInvoiceDocument, options);
        }
export type GetInvoiceQueryHookResult = ReturnType<typeof useGetInvoiceQuery>;
export type GetInvoiceLazyQueryHookResult = ReturnType<typeof useGetInvoiceLazyQuery>;
export type GetInvoiceQueryResult = Apollo.QueryResult<GetInvoiceQuery, GetInvoiceQueryVariables>;
export const GetLeadsForGridDocument = gql`
    query getLeadsForGrid($offset: Int, $first: Int) {
  queryLead(offset: $offset, first: $first) {
    ...LeadPreview
  }
}
    ${LeadPreviewFragmentDoc}`;

/**
 * __useGetLeadsForGridQuery__
 *
 * To run a query within a React component, call `useGetLeadsForGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadsForGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadsForGridQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetLeadsForGridQuery(baseOptions?: Apollo.QueryHookOptions<GetLeadsForGridQuery, GetLeadsForGridQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadsForGridQuery, GetLeadsForGridQueryVariables>(GetLeadsForGridDocument, options);
      }
export function useGetLeadsForGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadsForGridQuery, GetLeadsForGridQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadsForGridQuery, GetLeadsForGridQueryVariables>(GetLeadsForGridDocument, options);
        }
export type GetLeadsForGridQueryHookResult = ReturnType<typeof useGetLeadsForGridQuery>;
export type GetLeadsForGridLazyQueryHookResult = ReturnType<typeof useGetLeadsForGridLazyQuery>;
export type GetLeadsForGridQueryResult = Apollo.QueryResult<GetLeadsForGridQuery, GetLeadsForGridQueryVariables>;
export const LeadListFilterQueryDocument = gql`
    query LeadListFilterQuery($regState: String, $make: [VehicleMake], $model: String, $isRcAvailable: Boolean, $sourceBank: BankName, $centerName: String, $agencyName: [String], $driverName: String, $leadCascade: [String]) {
  queryLead(
    filter: {registrationState: {anyoftext: $regState}, auctionByBank: {eq: $sourceBank}}
  ) @cascade(fields: $leadCascade) {
    id
    regNo
    registrationState
    auctioningAgency(filter: {name: {in: $agencyName}}) {
      name
    }
    auctionByBank
    vehicle(
      filter: {make: {in: $make}, model: {alloftext: $model}, isRcAvailable: $isRcAvailable}
    ) {
      id
      vehicleBrand {
        name
      }
      vehicleModel {
        name
      }
      manufacturingDate
      registrationDate
      engineNumber
      isRcAvailable
      chassisNumber
    }
    pickup {
      by(filter: {name: {allofterms: $driverName}}) {
        name
      }
    }
    centre(filter: {name: {allofterms: $centerName}}) {
      name
    }
  }
}
    `;

/**
 * __useLeadListFilterQueryQuery__
 *
 * To run a query within a React component, call `useLeadListFilterQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadListFilterQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadListFilterQueryQuery({
 *   variables: {
 *      regState: // value for 'regState'
 *      make: // value for 'make'
 *      model: // value for 'model'
 *      isRcAvailable: // value for 'isRcAvailable'
 *      sourceBank: // value for 'sourceBank'
 *      centerName: // value for 'centerName'
 *      agencyName: // value for 'agencyName'
 *      driverName: // value for 'driverName'
 *      leadCascade: // value for 'leadCascade'
 *   },
 * });
 */
export function useLeadListFilterQueryQuery(baseOptions?: Apollo.QueryHookOptions<LeadListFilterQueryQuery, LeadListFilterQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeadListFilterQueryQuery, LeadListFilterQueryQueryVariables>(LeadListFilterQueryDocument, options);
      }
export function useLeadListFilterQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeadListFilterQueryQuery, LeadListFilterQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeadListFilterQueryQuery, LeadListFilterQueryQueryVariables>(LeadListFilterQueryDocument, options);
        }
export type LeadListFilterQueryQueryHookResult = ReturnType<typeof useLeadListFilterQueryQuery>;
export type LeadListFilterQueryLazyQueryHookResult = ReturnType<typeof useLeadListFilterQueryLazyQuery>;
export type LeadListFilterQueryQueryResult = Apollo.QueryResult<LeadListFilterQueryQuery, LeadListFilterQueryQueryVariables>;
export const GetLeadDetailDocument = gql`
    query getLeadDetail($regNo: String) {
  getLead(regNo: $regNo) @cascade(fields: "createdBy") {
    ...LeadDetails
  }
}
    ${LeadDetailsFragmentDoc}`;

/**
 * __useGetLeadDetailQuery__
 *
 * To run a query within a React component, call `useGetLeadDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadDetailQuery({
 *   variables: {
 *      regNo: // value for 'regNo'
 *   },
 * });
 */
export function useGetLeadDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetLeadDetailQuery, GetLeadDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadDetailQuery, GetLeadDetailQueryVariables>(GetLeadDetailDocument, options);
      }
export function useGetLeadDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadDetailQuery, GetLeadDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadDetailQuery, GetLeadDetailQueryVariables>(GetLeadDetailDocument, options);
        }
export type GetLeadDetailQueryHookResult = ReturnType<typeof useGetLeadDetailQuery>;
export type GetLeadDetailLazyQueryHookResult = ReturnType<typeof useGetLeadDetailLazyQuery>;
export type GetLeadDetailQueryResult = Apollo.QueryResult<GetLeadDetailQuery, GetLeadDetailQueryVariables>;
export const ModelByMakeDocument = gql`
    query ModelByMake($make: String) {
  queryModelByMake(filter: {make: {alloftext: $make}}) {
    model
  }
}
    `;

/**
 * __useModelByMakeQuery__
 *
 * To run a query within a React component, call `useModelByMakeQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelByMakeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelByMakeQuery({
 *   variables: {
 *      make: // value for 'make'
 *   },
 * });
 */
export function useModelByMakeQuery(baseOptions?: Apollo.QueryHookOptions<ModelByMakeQuery, ModelByMakeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelByMakeQuery, ModelByMakeQueryVariables>(ModelByMakeDocument, options);
      }
export function useModelByMakeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelByMakeQuery, ModelByMakeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelByMakeQuery, ModelByMakeQueryVariables>(ModelByMakeDocument, options);
        }
export type ModelByMakeQueryHookResult = ReturnType<typeof useModelByMakeQuery>;
export type ModelByMakeLazyQueryHookResult = ReturnType<typeof useModelByMakeLazyQuery>;
export type ModelByMakeQueryResult = Apollo.QueryResult<ModelByMakeQuery, ModelByMakeQueryVariables>;
export const GetUserByRoleDocument = gql`
    query getUserByRole($role: UserRole) {
  queryUser(filter: {role: {eq: $role}}) {
    id
    name
    role
    email
  }
}
    `;

/**
 * __useGetUserByRoleQuery__
 *
 * To run a query within a React component, call `useGetUserByRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByRoleQuery({
 *   variables: {
 *      role: // value for 'role'
 *   },
 * });
 */
export function useGetUserByRoleQuery(baseOptions?: Apollo.QueryHookOptions<GetUserByRoleQuery, GetUserByRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByRoleQuery, GetUserByRoleQueryVariables>(GetUserByRoleDocument, options);
      }
export function useGetUserByRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByRoleQuery, GetUserByRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByRoleQuery, GetUserByRoleQueryVariables>(GetUserByRoleDocument, options);
        }
export type GetUserByRoleQueryHookResult = ReturnType<typeof useGetUserByRoleQuery>;
export type GetUserByRoleLazyQueryHookResult = ReturnType<typeof useGetUserByRoleLazyQuery>;
export type GetUserByRoleQueryResult = Apollo.QueryResult<GetUserByRoleQuery, GetUserByRoleQueryVariables>;
export const GetBanklistDocument = gql`
    query getBanklist {
  queryAgency {
    id
    name
  }
}
    `;

/**
 * __useGetBanklistQuery__
 *
 * To run a query within a React component, call `useGetBanklistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBanklistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBanklistQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBanklistQuery(baseOptions?: Apollo.QueryHookOptions<GetBanklistQuery, GetBanklistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBanklistQuery, GetBanklistQueryVariables>(GetBanklistDocument, options);
      }
export function useGetBanklistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBanklistQuery, GetBanklistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBanklistQuery, GetBanklistQueryVariables>(GetBanklistDocument, options);
        }
export type GetBanklistQueryHookResult = ReturnType<typeof useGetBanklistQuery>;
export type GetBanklistLazyQueryHookResult = ReturnType<typeof useGetBanklistLazyQuery>;
export type GetBanklistQueryResult = Apollo.QueryResult<GetBanklistQuery, GetBanklistQueryVariables>;
export const GetmodelListDocument = gql`
    query getmodelList {
  queryVehicle {
    id
    model
  }
}
    `;

/**
 * __useGetmodelListQuery__
 *
 * To run a query within a React component, call `useGetmodelListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetmodelListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetmodelListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetmodelListQuery(baseOptions?: Apollo.QueryHookOptions<GetmodelListQuery, GetmodelListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetmodelListQuery, GetmodelListQueryVariables>(GetmodelListDocument, options);
      }
export function useGetmodelListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetmodelListQuery, GetmodelListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetmodelListQuery, GetmodelListQueryVariables>(GetmodelListDocument, options);
        }
export type GetmodelListQueryHookResult = ReturnType<typeof useGetmodelListQuery>;
export type GetmodelListLazyQueryHookResult = ReturnType<typeof useGetmodelListLazyQuery>;
export type GetmodelListQueryResult = Apollo.QueryResult<GetmodelListQuery, GetmodelListQueryVariables>;
export const GetStateListDocument = gql`
    query getStateList {
  queryStateCodeWithRegNumber {
    id
    state
  }
}
    `;

/**
 * __useGetStateListQuery__
 *
 * To run a query within a React component, call `useGetStateListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStateListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStateListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStateListQuery(baseOptions?: Apollo.QueryHookOptions<GetStateListQuery, GetStateListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStateListQuery, GetStateListQueryVariables>(GetStateListDocument, options);
      }
export function useGetStateListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStateListQuery, GetStateListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStateListQuery, GetStateListQueryVariables>(GetStateListDocument, options);
        }
export type GetStateListQueryHookResult = ReturnType<typeof useGetStateListQuery>;
export type GetStateListLazyQueryHookResult = ReturnType<typeof useGetStateListLazyQuery>;
export type GetStateListQueryResult = Apollo.QueryResult<GetStateListQuery, GetStateListQueryVariables>;
export const SendDocument = gql`
    query send($id: String, $env: String) {
  sendSmsToCustomer(invoiceId: $id, env: $env) {
    invoice {
      id
    }
    message
    success
  }
}
    `;

/**
 * __useSendQuery__
 *
 * To run a query within a React component, call `useSendQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendQuery({
 *   variables: {
 *      id: // value for 'id'
 *      env: // value for 'env'
 *   },
 * });
 */
export function useSendQuery(baseOptions?: Apollo.QueryHookOptions<SendQuery, SendQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SendQuery, SendQueryVariables>(SendDocument, options);
      }
export function useSendLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SendQuery, SendQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SendQuery, SendQueryVariables>(SendDocument, options);
        }
export type SendQueryHookResult = ReturnType<typeof useSendQuery>;
export type SendLazyQueryHookResult = ReturnType<typeof useSendLazyQuery>;
export type SendQueryResult = Apollo.QueryResult<SendQuery, SendQueryVariables>;
export const LeadDocumentCountDocument = gql`
    query leadDocumentCount($regNo: String) {
  queryLead(filter: {regNo: {anyofterms: $regNo}}) {
    regNo
    source
    documentChecklist {
      bankNOC
      form26
      form28
      form29
      form30
      form35
      indemnityBond
      releaseOrder
      insuranceCertificate
      loanForeclosure
      registrationCertificate
      sellerAadharCard
      form36
      form60_sellerPan
      ownerAddressProof
    }
    documents {
      bankNOC
      form26
      form28
      form29
      form30
      form35
      indemnityBond
      releaseOrder
      insuranceCertificate
      loanForeclosure
      registrationCertificate
      sellerAadharCard
      form36
      form60_sellerPan
      ownerAddressProof
    }
    documentsFollowups {
      id
      lead {
        regNo
      }
      source
      followupDate
      documentName
      actionType
      followedUpBy {
        name
      }
      remarks
      nextFollowupDate
    }
  }
}
    `;

/**
 * __useLeadDocumentCountQuery__
 *
 * To run a query within a React component, call `useLeadDocumentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadDocumentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadDocumentCountQuery({
 *   variables: {
 *      regNo: // value for 'regNo'
 *   },
 * });
 */
export function useLeadDocumentCountQuery(baseOptions?: Apollo.QueryHookOptions<LeadDocumentCountQuery, LeadDocumentCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeadDocumentCountQuery, LeadDocumentCountQueryVariables>(LeadDocumentCountDocument, options);
      }
export function useLeadDocumentCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeadDocumentCountQuery, LeadDocumentCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeadDocumentCountQuery, LeadDocumentCountQueryVariables>(LeadDocumentCountDocument, options);
        }
export type LeadDocumentCountQueryHookResult = ReturnType<typeof useLeadDocumentCountQuery>;
export type LeadDocumentCountLazyQueryHookResult = ReturnType<typeof useLeadDocumentCountLazyQuery>;
export type LeadDocumentCountQueryResult = Apollo.QueryResult<LeadDocumentCountQuery, LeadDocumentCountQueryVariables>;
export const AggregatesCountDocumentDocument = gql`
    query aggregatesCountDocument($source: LeadSource, $start: DateTime!, $end: DateTime!, $docStatus: DocumentStatus, $regState: String, $offset: Int, $pageSize: Int) {
  documentsAggregatesData(
    filters: {source: $source, createdAt: {start: $start, end: $end}, docStatus: $docStatus, regState: $regState, offset: $offset, pageSize: $pageSize}
  ) {
    documentsCount {
      pending
      received
      required
    }
    leads {
      id
      source
      registrationState
      createdAt
      updatedAt
      regNo
      documentsFollowups {
        nextFollowupDate
      }
      documentChecklist {
        bankNOC
        form26
        form28
        form29
        form30
        form35
        indemnityBond
        releaseOrder
        insuranceCertificate
        loanForeclosure
        registrationCertificate
        sellerAadharCard
        form36
        form60_sellerPan
        ownerAddressProof
      }
      documents {
        bankNOC
        form26
        form28
        form29
        form30
        form35
        indemnityBond
        releaseOrder
        insuranceCertificate
        loanForeclosure
        registrationCertificate
        sellerAadharCard
        form36
        form60_sellerPan
        ownerAddressProof
      }
      vehicle {
        id
        vehicleBrand {
          name
        }
        vehicleModel {
          name
        }
        manufacturingDate
      }
      statusEvents {
        id
        status
        assignTaskTo
        notifyTo
        taskButtonTitle
        taskTitle
        createdBy {
          id
          name
        }
        createdAt
        postTimeline
        isTaskCompleted
        preTimeline
        remarks
      }
    }
  }
}
    `;

/**
 * __useAggregatesCountDocumentQuery__
 *
 * To run a query within a React component, call `useAggregatesCountDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAggregatesCountDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAggregatesCountDocumentQuery({
 *   variables: {
 *      source: // value for 'source'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      docStatus: // value for 'docStatus'
 *      regState: // value for 'regState'
 *      offset: // value for 'offset'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useAggregatesCountDocumentQuery(baseOptions: Apollo.QueryHookOptions<AggregatesCountDocumentQuery, AggregatesCountDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AggregatesCountDocumentQuery, AggregatesCountDocumentQueryVariables>(AggregatesCountDocumentDocument, options);
      }
export function useAggregatesCountDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AggregatesCountDocumentQuery, AggregatesCountDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AggregatesCountDocumentQuery, AggregatesCountDocumentQueryVariables>(AggregatesCountDocumentDocument, options);
        }
export type AggregatesCountDocumentQueryHookResult = ReturnType<typeof useAggregatesCountDocumentQuery>;
export type AggregatesCountDocumentLazyQueryHookResult = ReturnType<typeof useAggregatesCountDocumentLazyQuery>;
export type AggregatesCountDocumentQueryResult = Apollo.QueryResult<AggregatesCountDocumentQuery, AggregatesCountDocumentQueryVariables>;
export const GetFilteredLeadsDocument = gql`
    query GetFilteredLeads($statuses: [LeadStatus], $dealStatus: DealStatus, $bankConfirmationStatus: BankConfirmationStatus, $registrationState: [String], $makes: [VehicleMake], $models: [String], $vehicleBrand: [Int], $vehicleModel: [Int], $purchaseYearsRange: DateRange, $auctioningAgencyName: [String], $sourcedBankName: [BankName], $repositionDateRange: DateRange, $pickupDateRange: DateRange, $driverName: [String], $driverId: [String], $centreName: [String], $paymentStatus: [PaymentStatus], $isRcAvailable: Boolean, $source: LeadSource, $createdAtDateRange: DateRange, $createdBy: String, $hasStatus: [LeadStatus], $offset: Int) {
  filteredLeads(
    leadFilters: {statuses: $statuses, dealStatus: $dealStatus, bankConfirmationStatus: $bankConfirmationStatus, registrationStates: $registrationState, makes: $makes, models: $models, vehicleBrand: $vehicleBrand, vehicleModel: $vehicleModel, purchaseYearsRange: $purchaseYearsRange, auctioningAgencyName: $auctioningAgencyName, sourcedBankName: $sourcedBankName, repositionDateRange: $repositionDateRange, pickupDateRange: $pickupDateRange, driverName: $driverName, centreName: $centreName, paymentStatus: $paymentStatus, source: $source, isRcAvailable: $isRcAvailable, createdAtDateRange: $createdAtDateRange, createdBy: $createdBy, hasStatus: $hasStatus, driverId: $driverId, offset: $offset, pageSize: 20}
  ) {
    ...LeadPreview
  }
}
    ${LeadPreviewFragmentDoc}`;

/**
 * __useGetFilteredLeadsQuery__
 *
 * To run a query within a React component, call `useGetFilteredLeadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilteredLeadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilteredLeadsQuery({
 *   variables: {
 *      statuses: // value for 'statuses'
 *      dealStatus: // value for 'dealStatus'
 *      bankConfirmationStatus: // value for 'bankConfirmationStatus'
 *      registrationState: // value for 'registrationState'
 *      makes: // value for 'makes'
 *      models: // value for 'models'
 *      vehicleBrand: // value for 'vehicleBrand'
 *      vehicleModel: // value for 'vehicleModel'
 *      purchaseYearsRange: // value for 'purchaseYearsRange'
 *      auctioningAgencyName: // value for 'auctioningAgencyName'
 *      sourcedBankName: // value for 'sourcedBankName'
 *      repositionDateRange: // value for 'repositionDateRange'
 *      pickupDateRange: // value for 'pickupDateRange'
 *      driverName: // value for 'driverName'
 *      driverId: // value for 'driverId'
 *      centreName: // value for 'centreName'
 *      paymentStatus: // value for 'paymentStatus'
 *      isRcAvailable: // value for 'isRcAvailable'
 *      source: // value for 'source'
 *      createdAtDateRange: // value for 'createdAtDateRange'
 *      createdBy: // value for 'createdBy'
 *      hasStatus: // value for 'hasStatus'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetFilteredLeadsQuery(baseOptions?: Apollo.QueryHookOptions<GetFilteredLeadsQuery, GetFilteredLeadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilteredLeadsQuery, GetFilteredLeadsQueryVariables>(GetFilteredLeadsDocument, options);
      }
export function useGetFilteredLeadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilteredLeadsQuery, GetFilteredLeadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilteredLeadsQuery, GetFilteredLeadsQueryVariables>(GetFilteredLeadsDocument, options);
        }
export type GetFilteredLeadsQueryHookResult = ReturnType<typeof useGetFilteredLeadsQuery>;
export type GetFilteredLeadsLazyQueryHookResult = ReturnType<typeof useGetFilteredLeadsLazyQuery>;
export type GetFilteredLeadsQueryResult = Apollo.QueryResult<GetFilteredLeadsQuery, GetFilteredLeadsQueryVariables>;
export const UpdateBidAmountDocument = gql`
    mutation UpdateBidAmount($regNo: String!, $proposedBidLimitAmount: Int, $finalBidAmount: Int) {
  updateLead(
    input: {filter: {regNo: {allofterms: $regNo}}, set: {proposedBidLimitAmount: $proposedBidLimitAmount, finalBidAmount: $finalBidAmount}}
  ) {
    lead {
      id
      proposedBidLimitAmount
      finalBidAmount
      expectedPickupDate
      auctionByBank
    }
  }
}
    `;
export type UpdateBidAmountMutationFn = Apollo.MutationFunction<UpdateBidAmountMutation, UpdateBidAmountMutationVariables>;

/**
 * __useUpdateBidAmountMutation__
 *
 * To run a mutation, you first call `useUpdateBidAmountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBidAmountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBidAmountMutation, { data, loading, error }] = useUpdateBidAmountMutation({
 *   variables: {
 *      regNo: // value for 'regNo'
 *      proposedBidLimitAmount: // value for 'proposedBidLimitAmount'
 *      finalBidAmount: // value for 'finalBidAmount'
 *   },
 * });
 */
export function useUpdateBidAmountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBidAmountMutation, UpdateBidAmountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBidAmountMutation, UpdateBidAmountMutationVariables>(UpdateBidAmountDocument, options);
      }
export type UpdateBidAmountMutationHookResult = ReturnType<typeof useUpdateBidAmountMutation>;
export type UpdateBidAmountMutationResult = Apollo.MutationResult<UpdateBidAmountMutation>;
export type UpdateBidAmountMutationOptions = Apollo.BaseMutationOptions<UpdateBidAmountMutation, UpdateBidAmountMutationVariables>;
export const GetYardListDocument = gql`
    query getYardList {
  queryYard {
    id
    address
    locationUrl
    spocName
    name
    spocNo
  }
}
    `;

/**
 * __useGetYardListQuery__
 *
 * To run a query within a React component, call `useGetYardListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetYardListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetYardListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetYardListQuery(baseOptions?: Apollo.QueryHookOptions<GetYardListQuery, GetYardListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetYardListQuery, GetYardListQueryVariables>(GetYardListDocument, options);
      }
export function useGetYardListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetYardListQuery, GetYardListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetYardListQuery, GetYardListQueryVariables>(GetYardListDocument, options);
        }
export type GetYardListQueryHookResult = ReturnType<typeof useGetYardListQuery>;
export type GetYardListLazyQueryHookResult = ReturnType<typeof useGetYardListLazyQuery>;
export type GetYardListQueryResult = Apollo.QueryResult<GetYardListQuery, GetYardListQueryVariables>;
export const UpdateYardDetailsDocument = gql`
    mutation UpdateYardDetails($name: String!, $address: String, $locationURL: String, $spocName: String, $spocMobile: String) {
  addYard(
    input: {name: $name, locationUrl: $locationURL, spocName: $spocName, spocNo: $spocMobile, address: $address}
    upsert: true
  ) {
    yard {
      name
      spocNo
      spocName
      address
      locationUrl
    }
  }
}
    `;
export type UpdateYardDetailsMutationFn = Apollo.MutationFunction<UpdateYardDetailsMutation, UpdateYardDetailsMutationVariables>;

/**
 * __useUpdateYardDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateYardDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateYardDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateYardDetailsMutation, { data, loading, error }] = useUpdateYardDetailsMutation({
 *   variables: {
 *      name: // value for 'name'
 *      address: // value for 'address'
 *      locationURL: // value for 'locationURL'
 *      spocName: // value for 'spocName'
 *      spocMobile: // value for 'spocMobile'
 *   },
 * });
 */
export function useUpdateYardDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateYardDetailsMutation, UpdateYardDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateYardDetailsMutation, UpdateYardDetailsMutationVariables>(UpdateYardDetailsDocument, options);
      }
export type UpdateYardDetailsMutationHookResult = ReturnType<typeof useUpdateYardDetailsMutation>;
export type UpdateYardDetailsMutationResult = Apollo.MutationResult<UpdateYardDetailsMutation>;
export type UpdateYardDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateYardDetailsMutation, UpdateYardDetailsMutationVariables>;
export const UpdateLeadDetailsDocument = gql`
    mutation UpdateLeadDetails($regNo: String!, $proposedBidLimitAmount: Int, $finalBidAmount: Int, $finalParkingCharges: Int, $sellingprice: Int, $listingPrice: Int, $demandAmount: Int, $approvedDealAmount: Int, $expectedPickupDate: DateTime) {
  updateLead(
    input: {filter: {regNo: {allofterms: $regNo}}, set: {proposedBidLimitAmount: $proposedBidLimitAmount, finalBidAmount: $finalBidAmount, finalParkingCharges: $finalParkingCharges, sellingPrice: $sellingprice, listingPrice: $listingPrice, demandAmount: $demandAmount, approvedDealAmount: $approvedDealAmount, expectedPickupDate: $expectedPickupDate}}
  ) {
    lead {
      regNo
      id
      tokenAmount
      proposedBidLimitAmount
      sellingPrice
      approvedDealAmount
      demandAmount
    }
  }
}
    `;
export type UpdateLeadDetailsMutationFn = Apollo.MutationFunction<UpdateLeadDetailsMutation, UpdateLeadDetailsMutationVariables>;

/**
 * __useUpdateLeadDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateLeadDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeadDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeadDetailsMutation, { data, loading, error }] = useUpdateLeadDetailsMutation({
 *   variables: {
 *      regNo: // value for 'regNo'
 *      proposedBidLimitAmount: // value for 'proposedBidLimitAmount'
 *      finalBidAmount: // value for 'finalBidAmount'
 *      finalParkingCharges: // value for 'finalParkingCharges'
 *      sellingprice: // value for 'sellingprice'
 *      listingPrice: // value for 'listingPrice'
 *      demandAmount: // value for 'demandAmount'
 *      approvedDealAmount: // value for 'approvedDealAmount'
 *      expectedPickupDate: // value for 'expectedPickupDate'
 *   },
 * });
 */
export function useUpdateLeadDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeadDetailsMutation, UpdateLeadDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeadDetailsMutation, UpdateLeadDetailsMutationVariables>(UpdateLeadDetailsDocument, options);
      }
export type UpdateLeadDetailsMutationHookResult = ReturnType<typeof useUpdateLeadDetailsMutation>;
export type UpdateLeadDetailsMutationResult = Apollo.MutationResult<UpdateLeadDetailsMutation>;
export type UpdateLeadDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateLeadDetailsMutation, UpdateLeadDetailsMutationVariables>;
export const UpdateLeadCenterDocument = gql`
    mutation UpdateLeadCenter($regNo: String!, $centerName: String!) {
  updateLead(
    input: {filter: {regNo: {allofterms: $regNo}}, set: {centre: {name: $centerName}}}
  ) {
    lead {
      regNo
      centre {
        id
        name
        regNo
      }
    }
  }
}
    `;
export type UpdateLeadCenterMutationFn = Apollo.MutationFunction<UpdateLeadCenterMutation, UpdateLeadCenterMutationVariables>;

/**
 * __useUpdateLeadCenterMutation__
 *
 * To run a mutation, you first call `useUpdateLeadCenterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeadCenterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeadCenterMutation, { data, loading, error }] = useUpdateLeadCenterMutation({
 *   variables: {
 *      regNo: // value for 'regNo'
 *      centerName: // value for 'centerName'
 *   },
 * });
 */
export function useUpdateLeadCenterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeadCenterMutation, UpdateLeadCenterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeadCenterMutation, UpdateLeadCenterMutationVariables>(UpdateLeadCenterDocument, options);
      }
export type UpdateLeadCenterMutationHookResult = ReturnType<typeof useUpdateLeadCenterMutation>;
export type UpdateLeadCenterMutationResult = Apollo.MutationResult<UpdateLeadCenterMutation>;
export type UpdateLeadCenterMutationOptions = Apollo.BaseMutationOptions<UpdateLeadCenterMutation, UpdateLeadCenterMutationVariables>;
export const UpdateLeadVehicleDetailsDocument = gql`
    mutation UpdateLeadVehicleDetails($regNo: String!, $model_id: ID, $brand_id: ID, $manufacturingDate: DateTime, $repossesionDateByDriver: DateTime, $repossesionDateByPE: DateTime) {
  updateVehicle(
    input: {filter: {regNo: {eq: $regNo}}, set: {vehicleBrand: {id: $brand_id}, vehicleModel: {id: $model_id}, manufacturingDate: $manufacturingDate, repossessionDate: $repossesionDateByDriver, tempRepossessionDate: $repossesionDateByPE}}
  ) {
    vehicle {
      id
      manufacturingDate
      make
      model
      engineNumber
      chassisNumber
      registrationDate
      repossessionDate
      isVehicleInsured
      fitnessValidUpto
    }
  }
}
    `;
export type UpdateLeadVehicleDetailsMutationFn = Apollo.MutationFunction<UpdateLeadVehicleDetailsMutation, UpdateLeadVehicleDetailsMutationVariables>;

/**
 * __useUpdateLeadVehicleDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateLeadVehicleDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeadVehicleDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeadVehicleDetailsMutation, { data, loading, error }] = useUpdateLeadVehicleDetailsMutation({
 *   variables: {
 *      regNo: // value for 'regNo'
 *      model_id: // value for 'model_id'
 *      brand_id: // value for 'brand_id'
 *      manufacturingDate: // value for 'manufacturingDate'
 *      repossesionDateByDriver: // value for 'repossesionDateByDriver'
 *      repossesionDateByPE: // value for 'repossesionDateByPE'
 *   },
 * });
 */
export function useUpdateLeadVehicleDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeadVehicleDetailsMutation, UpdateLeadVehicleDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeadVehicleDetailsMutation, UpdateLeadVehicleDetailsMutationVariables>(UpdateLeadVehicleDetailsDocument, options);
      }
export type UpdateLeadVehicleDetailsMutationHookResult = ReturnType<typeof useUpdateLeadVehicleDetailsMutation>;
export type UpdateLeadVehicleDetailsMutationResult = Apollo.MutationResult<UpdateLeadVehicleDetailsMutation>;
export type UpdateLeadVehicleDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateLeadVehicleDetailsMutation, UpdateLeadVehicleDetailsMutationVariables>;
export const UpdatePickupDetailsDocument = gql`
    mutation UpdatePickupDetails($regNo: String, $driverEmail: String, $driverName: String) {
  updatePickup(
    input: {filter: {regNo: {eq: $regNo}}, set: {by: {email: $driverEmail, name: $driverName}}}
  ) {
    pickup {
      by {
        name
        email
      }
    }
  }
}
    `;
export type UpdatePickupDetailsMutationFn = Apollo.MutationFunction<UpdatePickupDetailsMutation, UpdatePickupDetailsMutationVariables>;

/**
 * __useUpdatePickupDetailsMutation__
 *
 * To run a mutation, you first call `useUpdatePickupDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePickupDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePickupDetailsMutation, { data, loading, error }] = useUpdatePickupDetailsMutation({
 *   variables: {
 *      regNo: // value for 'regNo'
 *      driverEmail: // value for 'driverEmail'
 *      driverName: // value for 'driverName'
 *   },
 * });
 */
export function useUpdatePickupDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePickupDetailsMutation, UpdatePickupDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePickupDetailsMutation, UpdatePickupDetailsMutationVariables>(UpdatePickupDetailsDocument, options);
      }
export type UpdatePickupDetailsMutationHookResult = ReturnType<typeof useUpdatePickupDetailsMutation>;
export type UpdatePickupDetailsMutationResult = Apollo.MutationResult<UpdatePickupDetailsMutation>;
export type UpdatePickupDetailsMutationOptions = Apollo.BaseMutationOptions<UpdatePickupDetailsMutation, UpdatePickupDetailsMutationVariables>;
export const UpdateLeadDocumentsCheckListDocument = gql`
    mutation updateLeadDocumentsCheckList($regNo: String!, $registrationCertificate: Boolean, $form26: Boolean, $loanForeclosure: Boolean, $bankNOC: Boolean, $form35: Boolean, $insuranceCertificate: Boolean, $form28: Boolean, $form29: Boolean, $from30: Boolean, $sellerPAN: Boolean, $form60: Boolean, $form36: Boolean, $sellerAadharCard: Boolean, $releaseOrder: Boolean, $indemnityBond: Boolean) {
  updateDocumentChecklist(
    input: {filter: {regNo: {eq: $regNo}}, set: {registrationCertificate: $registrationCertificate, form26: $form26, loanForeclosure: $loanForeclosure, bankNOC: $bankNOC, form35: $form35, insuranceCertificate: $insuranceCertificate, form28: $form28, form29: $form29, form30: $from30, sellerPAN: $sellerPAN, form60: $form60, form36: $form36, sellerAadharCard: $sellerAadharCard, releaseOrder: $releaseOrder, indemnityBond: $indemnityBond}}
  ) {
    documentChecklist {
      registrationCertificate
      form26
      loanForeclosure
      bankNOC
      form35
      insuranceCertificate
      form28
      form29
      form30
      sellerPAN
      form36
      form60
      form36
      sellerAadharCard
      releaseOrder
      indemnityBond
    }
  }
}
    `;
export type UpdateLeadDocumentsCheckListMutationFn = Apollo.MutationFunction<UpdateLeadDocumentsCheckListMutation, UpdateLeadDocumentsCheckListMutationVariables>;

/**
 * __useUpdateLeadDocumentsCheckListMutation__
 *
 * To run a mutation, you first call `useUpdateLeadDocumentsCheckListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeadDocumentsCheckListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeadDocumentsCheckListMutation, { data, loading, error }] = useUpdateLeadDocumentsCheckListMutation({
 *   variables: {
 *      regNo: // value for 'regNo'
 *      registrationCertificate: // value for 'registrationCertificate'
 *      form26: // value for 'form26'
 *      loanForeclosure: // value for 'loanForeclosure'
 *      bankNOC: // value for 'bankNOC'
 *      form35: // value for 'form35'
 *      insuranceCertificate: // value for 'insuranceCertificate'
 *      form28: // value for 'form28'
 *      form29: // value for 'form29'
 *      from30: // value for 'from30'
 *      sellerPAN: // value for 'sellerPAN'
 *      form60: // value for 'form60'
 *      form36: // value for 'form36'
 *      sellerAadharCard: // value for 'sellerAadharCard'
 *      releaseOrder: // value for 'releaseOrder'
 *      indemnityBond: // value for 'indemnityBond'
 *   },
 * });
 */
export function useUpdateLeadDocumentsCheckListMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeadDocumentsCheckListMutation, UpdateLeadDocumentsCheckListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeadDocumentsCheckListMutation, UpdateLeadDocumentsCheckListMutationVariables>(UpdateLeadDocumentsCheckListDocument, options);
      }
export type UpdateLeadDocumentsCheckListMutationHookResult = ReturnType<typeof useUpdateLeadDocumentsCheckListMutation>;
export type UpdateLeadDocumentsCheckListMutationResult = Apollo.MutationResult<UpdateLeadDocumentsCheckListMutation>;
export type UpdateLeadDocumentsCheckListMutationOptions = Apollo.BaseMutationOptions<UpdateLeadDocumentsCheckListMutation, UpdateLeadDocumentsCheckListMutationVariables>;
export const UpdateRtoDocumentsDocument = gql`
    mutation UpdateRtoDocuments($regNo: String!, $rtoVerificationProofUrl: String, $hypothecationProofUrl: String, $challanUrl: String, $hsrbProofUrl: String, $approvalMailUrl: String, $blacklistProofUrl: String) {
  updateVehicleDocuments(
    input: {filter: {regNo: {eq: $regNo}}, set: {rtoVerificationProofUrl: $rtoVerificationProofUrl, hypothecationProofUrl: $hypothecationProofUrl, challanUrl: $challanUrl, hsrbProofUrl: $hsrbProofUrl, approvalMailUrl: $approvalMailUrl, blacklistProofUrl: $blacklistProofUrl}}
  ) {
    vehicleDocuments {
      id
      regNo
      rtoVerificationProofUrl
      hypothecationProofUrl
      challanUrl
      hsrbProofUrl
      approvalMailUrl
      blacklistProofUrl
    }
    numUids
  }
}
    `;
export type UpdateRtoDocumentsMutationFn = Apollo.MutationFunction<UpdateRtoDocumentsMutation, UpdateRtoDocumentsMutationVariables>;

/**
 * __useUpdateRtoDocumentsMutation__
 *
 * To run a mutation, you first call `useUpdateRtoDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRtoDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRtoDocumentsMutation, { data, loading, error }] = useUpdateRtoDocumentsMutation({
 *   variables: {
 *      regNo: // value for 'regNo'
 *      rtoVerificationProofUrl: // value for 'rtoVerificationProofUrl'
 *      hypothecationProofUrl: // value for 'hypothecationProofUrl'
 *      challanUrl: // value for 'challanUrl'
 *      hsrbProofUrl: // value for 'hsrbProofUrl'
 *      approvalMailUrl: // value for 'approvalMailUrl'
 *      blacklistProofUrl: // value for 'blacklistProofUrl'
 *   },
 * });
 */
export function useUpdateRtoDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRtoDocumentsMutation, UpdateRtoDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRtoDocumentsMutation, UpdateRtoDocumentsMutationVariables>(UpdateRtoDocumentsDocument, options);
      }
export type UpdateRtoDocumentsMutationHookResult = ReturnType<typeof useUpdateRtoDocumentsMutation>;
export type UpdateRtoDocumentsMutationResult = Apollo.MutationResult<UpdateRtoDocumentsMutation>;
export type UpdateRtoDocumentsMutationOptions = Apollo.BaseMutationOptions<UpdateRtoDocumentsMutation, UpdateRtoDocumentsMutationVariables>;
export const UpdateVehicleDetailDocument = gql`
    mutation UpdateVehicleDetail($id: [ID!]!, $regNo: String!, $name: String!, $spocNo: String, $registrationDate: DateTime, $repossessionDate: DateTime, $fitnessValidUpto: DateTime, $isVehicleInsured: Boolean, $insurerName: InsurerName, $insuranceType: InsuranceType, $policyNumber: String, $policyExpiryDate: DateTime, $registrationCertificateUrl: String) {
  updateAgency(input: {filter: {name: {eq: $name}}, set: {spocNo: $spocNo}}) {
    agency {
      name
      spocNo
    }
  }
  updateVehicle(
    input: {filter: {regNo: {eq: $regNo}}, set: {registrationDate: $registrationDate, repossessionDate: $repossessionDate, fitnessValidUpto: $fitnessValidUpto, isVehicleInsured: $isVehicleInsured}}
  ) {
    vehicle {
      regNo
      registrationDate
      repossessionDate
      fitnessValidUpto
      isVehicleInsured
    }
  }
  updateVehicleInsurance(
    input: {filter: {id: $id}, set: {insurerName: $insurerName, insuranceType: $insuranceType, policyNumber: $policyNumber, policyExpiryDate: $policyExpiryDate}}
  ) {
    vehicleInsurance {
      vehicle {
        regNo
        insuranceDetails {
          insurerName
        }
      }
      insurerName
      insuranceType
      policyNumber
      policyExpiryDate
    }
  }
  updateVehicleDocuments(
    input: {filter: {regNo: {eq: $regNo}}, set: {registrationCertificateUrl: $registrationCertificateUrl}}
  ) {
    vehicleDocuments {
      id
      registrationCertificateUrl
    }
  }
}
    `;
export type UpdateVehicleDetailMutationFn = Apollo.MutationFunction<UpdateVehicleDetailMutation, UpdateVehicleDetailMutationVariables>;

/**
 * __useUpdateVehicleDetailMutation__
 *
 * To run a mutation, you first call `useUpdateVehicleDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVehicleDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVehicleDetailMutation, { data, loading, error }] = useUpdateVehicleDetailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      regNo: // value for 'regNo'
 *      name: // value for 'name'
 *      spocNo: // value for 'spocNo'
 *      registrationDate: // value for 'registrationDate'
 *      repossessionDate: // value for 'repossessionDate'
 *      fitnessValidUpto: // value for 'fitnessValidUpto'
 *      isVehicleInsured: // value for 'isVehicleInsured'
 *      insurerName: // value for 'insurerName'
 *      insuranceType: // value for 'insuranceType'
 *      policyNumber: // value for 'policyNumber'
 *      policyExpiryDate: // value for 'policyExpiryDate'
 *      registrationCertificateUrl: // value for 'registrationCertificateUrl'
 *   },
 * });
 */
export function useUpdateVehicleDetailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVehicleDetailMutation, UpdateVehicleDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVehicleDetailMutation, UpdateVehicleDetailMutationVariables>(UpdateVehicleDetailDocument, options);
      }
export type UpdateVehicleDetailMutationHookResult = ReturnType<typeof useUpdateVehicleDetailMutation>;
export type UpdateVehicleDetailMutationResult = Apollo.MutationResult<UpdateVehicleDetailMutation>;
export type UpdateVehicleDetailMutationOptions = Apollo.BaseMutationOptions<UpdateVehicleDetailMutation, UpdateVehicleDetailMutationVariables>;
export const UpdateDealPaymentDocument = gql`
    mutation updateDealPayment($id: [ID!]!, $name: String, $accntno: String, $bank: BankName, $ifsc: String, $proof: String) {
  updatePayment(
    input: {filter: {id: $id}, set: {accountHolderName: $name, accountNo: $accntno, bankName: $bank, ifsc: $ifsc, proofUrl: $proof}}
  ) {
    payment {
      id
      bankName
      accountHolderName
      accountNo
      ifsc
      proofUrl
    }
  }
}
    `;
export type UpdateDealPaymentMutationFn = Apollo.MutationFunction<UpdateDealPaymentMutation, UpdateDealPaymentMutationVariables>;

/**
 * __useUpdateDealPaymentMutation__
 *
 * To run a mutation, you first call `useUpdateDealPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDealPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDealPaymentMutation, { data, loading, error }] = useUpdateDealPaymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      accntno: // value for 'accntno'
 *      bank: // value for 'bank'
 *      ifsc: // value for 'ifsc'
 *      proof: // value for 'proof'
 *   },
 * });
 */
export function useUpdateDealPaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDealPaymentMutation, UpdateDealPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDealPaymentMutation, UpdateDealPaymentMutationVariables>(UpdateDealPaymentDocument, options);
      }
export type UpdateDealPaymentMutationHookResult = ReturnType<typeof useUpdateDealPaymentMutation>;
export type UpdateDealPaymentMutationResult = Apollo.MutationResult<UpdateDealPaymentMutation>;
export type UpdateDealPaymentMutationOptions = Apollo.BaseMutationOptions<UpdateDealPaymentMutation, UpdateDealPaymentMutationVariables>;
export const UpdateDocumentsDocument = gql`
    mutation updateDocuments($id: [ID!]!, $bankNOC: String, $form26: String, $form28: String, $form29: String, $form30: String, $form35: String, $form36: String, $form60: String, $indemnityBond: String, $releaseOrder: String, $insuranceCertificate: String, $loanForeclosure: String, $registrationCertificate: String, $sellerAadharCard: String, $sellerPAN: String) {
  updateLeadDocuments(
    input: {filter: {id: $id}, set: {bankNOC: $bankNOC, form26: $form26, form28: $form28, form29: $form29, form30: $form30, form35: $form35, form36: $form36, form60: $form60, indemnityBond: $indemnityBond, releaseOrder: $releaseOrder, insuranceCertificate: $insuranceCertificate, loanForeclosure: $loanForeclosure, registrationCertificate: $registrationCertificate, sellerAadharCard: $sellerAadharCard, sellerPAN: $sellerPAN}}
  ) {
    leadDocuments {
      bankNOC
      form26
      form28
      form29
      form30
      form35
      form36
      form60
      indemnityBond
      releaseOrder
      insuranceCertificate
      loanForeclosure
      registrationCertificate
      sellerAadharCard
      sellerPAN
    }
  }
}
    `;
export type UpdateDocumentsMutationFn = Apollo.MutationFunction<UpdateDocumentsMutation, UpdateDocumentsMutationVariables>;

/**
 * __useUpdateDocumentsMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentsMutation, { data, loading, error }] = useUpdateDocumentsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      bankNOC: // value for 'bankNOC'
 *      form26: // value for 'form26'
 *      form28: // value for 'form28'
 *      form29: // value for 'form29'
 *      form30: // value for 'form30'
 *      form35: // value for 'form35'
 *      form36: // value for 'form36'
 *      form60: // value for 'form60'
 *      indemnityBond: // value for 'indemnityBond'
 *      releaseOrder: // value for 'releaseOrder'
 *      insuranceCertificate: // value for 'insuranceCertificate'
 *      loanForeclosure: // value for 'loanForeclosure'
 *      registrationCertificate: // value for 'registrationCertificate'
 *      sellerAadharCard: // value for 'sellerAadharCard'
 *      sellerPAN: // value for 'sellerPAN'
 *   },
 * });
 */
export function useUpdateDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentsMutation, UpdateDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentsMutation, UpdateDocumentsMutationVariables>(UpdateDocumentsDocument, options);
      }
export type UpdateDocumentsMutationHookResult = ReturnType<typeof useUpdateDocumentsMutation>;
export type UpdateDocumentsMutationResult = Apollo.MutationResult<UpdateDocumentsMutation>;
export type UpdateDocumentsMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentsMutation, UpdateDocumentsMutationVariables>;
export const GetLeadForSearchDocument = gql`
    query getLeadForSearch($searchString: String) {
  queryLead(filter: {searchString: {regexp: $searchString}}) {
    regNo
  }
}
    `;

/**
 * __useGetLeadForSearchQuery__
 *
 * To run a query within a React component, call `useGetLeadForSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadForSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadForSearchQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *   },
 * });
 */
export function useGetLeadForSearchQuery(baseOptions?: Apollo.QueryHookOptions<GetLeadForSearchQuery, GetLeadForSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadForSearchQuery, GetLeadForSearchQueryVariables>(GetLeadForSearchDocument, options);
      }
export function useGetLeadForSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadForSearchQuery, GetLeadForSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadForSearchQuery, GetLeadForSearchQueryVariables>(GetLeadForSearchDocument, options);
        }
export type GetLeadForSearchQueryHookResult = ReturnType<typeof useGetLeadForSearchQuery>;
export type GetLeadForSearchLazyQueryHookResult = ReturnType<typeof useGetLeadForSearchLazyQuery>;
export type GetLeadForSearchQueryResult = Apollo.QueryResult<GetLeadForSearchQuery, GetLeadForSearchQueryVariables>;
export const GetAllStateDocument = gql`
    query getAllState {
  getStateInfo {
    data {
      state_id
      state_name
      tr_state_id
      state_code
    }
  }
}
    `;

/**
 * __useGetAllStateQuery__
 *
 * To run a query within a React component, call `useGetAllStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllStateQuery(baseOptions?: Apollo.QueryHookOptions<GetAllStateQuery, GetAllStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllStateQuery, GetAllStateQueryVariables>(GetAllStateDocument, options);
      }
export function useGetAllStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllStateQuery, GetAllStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllStateQuery, GetAllStateQueryVariables>(GetAllStateDocument, options);
        }
export type GetAllStateQueryHookResult = ReturnType<typeof useGetAllStateQuery>;
export type GetAllStateLazyQueryHookResult = ReturnType<typeof useGetAllStateLazyQuery>;
export type GetAllStateQueryResult = Apollo.QueryResult<GetAllStateQuery, GetAllStateQueryVariables>;
export const GetDistrictsByStateDocument = gql`
    query getDistrictsByState($id: Int) {
  getDistrictByStateInfo(state_id: $id) {
    data {
      district_name
      district_id
      state_name
    }
  }
}
    `;

/**
 * __useGetDistrictsByStateQuery__
 *
 * To run a query within a React component, call `useGetDistrictsByStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistrictsByStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistrictsByStateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDistrictsByStateQuery(baseOptions?: Apollo.QueryHookOptions<GetDistrictsByStateQuery, GetDistrictsByStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDistrictsByStateQuery, GetDistrictsByStateQueryVariables>(GetDistrictsByStateDocument, options);
      }
export function useGetDistrictsByStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDistrictsByStateQuery, GetDistrictsByStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDistrictsByStateQuery, GetDistrictsByStateQueryVariables>(GetDistrictsByStateDocument, options);
        }
export type GetDistrictsByStateQueryHookResult = ReturnType<typeof useGetDistrictsByStateQuery>;
export type GetDistrictsByStateLazyQueryHookResult = ReturnType<typeof useGetDistrictsByStateLazyQuery>;
export type GetDistrictsByStateQueryResult = Apollo.QueryResult<GetDistrictsByStateQuery, GetDistrictsByStateQueryVariables>;
export const GetTehsilsByDistrictDocument = gql`
    query getTehsilsByDistrict($id: Int) {
  getTehsilByDistricts(district_idd: [$id]) {
    data {
      district_name
      district_id
      state_name
      tehsil_id
      tehsil_name
    }
  }
}
    `;

/**
 * __useGetTehsilsByDistrictQuery__
 *
 * To run a query within a React component, call `useGetTehsilsByDistrictQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTehsilsByDistrictQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTehsilsByDistrictQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTehsilsByDistrictQuery(baseOptions?: Apollo.QueryHookOptions<GetTehsilsByDistrictQuery, GetTehsilsByDistrictQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTehsilsByDistrictQuery, GetTehsilsByDistrictQueryVariables>(GetTehsilsByDistrictDocument, options);
      }
export function useGetTehsilsByDistrictLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTehsilsByDistrictQuery, GetTehsilsByDistrictQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTehsilsByDistrictQuery, GetTehsilsByDistrictQueryVariables>(GetTehsilsByDistrictDocument, options);
        }
export type GetTehsilsByDistrictQueryHookResult = ReturnType<typeof useGetTehsilsByDistrictQuery>;
export type GetTehsilsByDistrictLazyQueryHookResult = ReturnType<typeof useGetTehsilsByDistrictLazyQuery>;
export type GetTehsilsByDistrictQueryResult = Apollo.QueryResult<GetTehsilsByDistrictQuery, GetTehsilsByDistrictQueryVariables>;
export const CloseLeadsDocument = gql`
    mutation CloseLeads($id: [ID!]!) {
  deleteLead(filter: {id: $id}) {
    numUids
    msg
  }
}
    `;
export type CloseLeadsMutationFn = Apollo.MutationFunction<CloseLeadsMutation, CloseLeadsMutationVariables>;

/**
 * __useCloseLeadsMutation__
 *
 * To run a mutation, you first call `useCloseLeadsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseLeadsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeLeadsMutation, { data, loading, error }] = useCloseLeadsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCloseLeadsMutation(baseOptions?: Apollo.MutationHookOptions<CloseLeadsMutation, CloseLeadsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseLeadsMutation, CloseLeadsMutationVariables>(CloseLeadsDocument, options);
      }
export type CloseLeadsMutationHookResult = ReturnType<typeof useCloseLeadsMutation>;
export type CloseLeadsMutationResult = Apollo.MutationResult<CloseLeadsMutation>;
export type CloseLeadsMutationOptions = Apollo.BaseMutationOptions<CloseLeadsMutation, CloseLeadsMutationVariables>;
export const CloseTaskListDocument = gql`
    mutation CloseTaskList($id: [ID!]!) {
  deleteLeadStatusEvent(filter: {id: $id}) {
    numUids
    msg
  }
}
    `;
export type CloseTaskListMutationFn = Apollo.MutationFunction<CloseTaskListMutation, CloseTaskListMutationVariables>;

/**
 * __useCloseTaskListMutation__
 *
 * To run a mutation, you first call `useCloseTaskListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseTaskListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeTaskListMutation, { data, loading, error }] = useCloseTaskListMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCloseTaskListMutation(baseOptions?: Apollo.MutationHookOptions<CloseTaskListMutation, CloseTaskListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseTaskListMutation, CloseTaskListMutationVariables>(CloseTaskListDocument, options);
      }
export type CloseTaskListMutationHookResult = ReturnType<typeof useCloseTaskListMutation>;
export type CloseTaskListMutationResult = Apollo.MutationResult<CloseTaskListMutation>;
export type CloseTaskListMutationOptions = Apollo.BaseMutationOptions<CloseTaskListMutation, CloseTaskListMutationVariables>;
export const AllLeadsDocument = gql`
    query allLeads($offset: Int) {
  queryLead(order: {desc: createdAt}, offset: $offset, first: 20) {
    id
    updatedAt
    regNo
    source
    searchString
    finalBidAmount
    registrationState
    auctionByBank
    expectedPickupDate
    createdAt
    vehicle {
      id
      make
      model
      manufacturingDate
      vehicleBrand {
        id
        brand_id
        name
      }
      vehicleModel {
        name
        id
        model_id
      }
      purchaseDate
      registrationDate
      repossessionDate
      isRcAvailable
    }
    auctioningAgency {
      id
      name
    }
    payments {
      id
      for
      createdAt
      status
    }
    centre {
      id
      name
    }
    deliveryCentre {
      name
    }
    pickup {
      id
      by {
        id
        name
      }
    }
    createdBy {
      id
      phoneNo
      name
    }
    deliveryAmount
    statusEvents(order: {desc: createdAt}) @cascade(fields: ["createdBy"]) {
      id
      status
      assignTaskTo
      notifyTo
      taskButtonTitle
      taskTitle
      createdBy {
        id
        name
      }
      createdAt
      postTimeline
      preTimeline
      isTaskCompleted
      remarks
    }
  }
}
    `;

/**
 * __useAllLeadsQuery__
 *
 * To run a query within a React component, call `useAllLeadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLeadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLeadsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useAllLeadsQuery(baseOptions?: Apollo.QueryHookOptions<AllLeadsQuery, AllLeadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllLeadsQuery, AllLeadsQueryVariables>(AllLeadsDocument, options);
      }
export function useAllLeadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllLeadsQuery, AllLeadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllLeadsQuery, AllLeadsQueryVariables>(AllLeadsDocument, options);
        }
export type AllLeadsQueryHookResult = ReturnType<typeof useAllLeadsQuery>;
export type AllLeadsLazyQueryHookResult = ReturnType<typeof useAllLeadsLazyQuery>;
export type AllLeadsQueryResult = Apollo.QueryResult<AllLeadsQuery, AllLeadsQueryVariables>;
export const FilteredInventoryDocument = gql`
    query FilteredInventory($centreName: [String!], $status: [LeadStatus], $sortByUpdatedAt: Boolean, $offset: Int) {
  filteredLeads(
    leadFilters: {hasStatus: $status, centreName: $centreName, sortByUpdatedAt: $sortByUpdatedAt, pageSize: 20, offset: $offset}
  ) @cascade(fields: ["centre"]) {
    id
    regNo
    registrationState
    finalBidAmount
    source
    status
    vehicle {
      vehicleBrand {
        name
      }
      vehicleModel {
        name
      }
      id
      registrationNumber
      make
      model
      manufacturingDate
      price
      owner {
        id
        district
      }
      images(first: 1) {
        id
        rightBodySide
        frontBodySide
      }
    }
    deliveryAmount
    createdBy {
      id
      phoneNo
      name
    }
    auctioningAgency {
      id
      name
      spocNo
    }
    dealer {
      id
      phoneNo
    }
    statusEvents(first: -1) {
      ...LeadStatusEventDetails
    }
    centre {
      id
      name
    }
    deliveryCentre {
      id
      name
    }
    createdAt
  }
}
    ${LeadStatusEventDetailsFragmentDoc}`;

/**
 * __useFilteredInventoryQuery__
 *
 * To run a query within a React component, call `useFilteredInventoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredInventoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredInventoryQuery({
 *   variables: {
 *      centreName: // value for 'centreName'
 *      status: // value for 'status'
 *      sortByUpdatedAt: // value for 'sortByUpdatedAt'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useFilteredInventoryQuery(baseOptions?: Apollo.QueryHookOptions<FilteredInventoryQuery, FilteredInventoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredInventoryQuery, FilteredInventoryQueryVariables>(FilteredInventoryDocument, options);
      }
export function useFilteredInventoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredInventoryQuery, FilteredInventoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredInventoryQuery, FilteredInventoryQueryVariables>(FilteredInventoryDocument, options);
        }
export type FilteredInventoryQueryHookResult = ReturnType<typeof useFilteredInventoryQuery>;
export type FilteredInventoryLazyQueryHookResult = ReturnType<typeof useFilteredInventoryLazyQuery>;
export type FilteredInventoryQueryResult = Apollo.QueryResult<FilteredInventoryQuery, FilteredInventoryQueryVariables>;
export const GetIdsByNameForListingDocument = gql`
    query GetIdsByNameForListing($model: String, $brand: String, $state: String, $district: String, $tehsil: String, $env: String, $engine_hours: Int, $vehicle_registration_no: String, $manufacture_month: String, $manufacture_year: Int, $rc_available: String, $seller_name: String, $mobile_number: String, $price: String, $images: [String]) {
  getIdsByNameForListing(
    IdsByNameForListingInput: {brand: $brand, model: $model, state: $state, district: $district, tehsil: $tehsil, env: $env, engine_hours: $engine_hours, vehicle_registration_no: $vehicle_registration_no, manufacture_month: $manufacture_month, manufacture_year: $manufacture_year, rc_available: $rc_available, seller_name: $seller_name, mobile_number: $mobile_number, price: $price, images: $images}
  ) {
    status
    message
    data {
      brand_id
      district_id
      engine_capacity
      horse_power
      state_id
      tahsil_id
      model_id
    }
  }
}
    `;

/**
 * __useGetIdsByNameForListingQuery__
 *
 * To run a query within a React component, call `useGetIdsByNameForListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIdsByNameForListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIdsByNameForListingQuery({
 *   variables: {
 *      model: // value for 'model'
 *      brand: // value for 'brand'
 *      state: // value for 'state'
 *      district: // value for 'district'
 *      tehsil: // value for 'tehsil'
 *      env: // value for 'env'
 *      engine_hours: // value for 'engine_hours'
 *      vehicle_registration_no: // value for 'vehicle_registration_no'
 *      manufacture_month: // value for 'manufacture_month'
 *      manufacture_year: // value for 'manufacture_year'
 *      rc_available: // value for 'rc_available'
 *      seller_name: // value for 'seller_name'
 *      mobile_number: // value for 'mobile_number'
 *      price: // value for 'price'
 *      images: // value for 'images'
 *   },
 * });
 */
export function useGetIdsByNameForListingQuery(baseOptions?: Apollo.QueryHookOptions<GetIdsByNameForListingQuery, GetIdsByNameForListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIdsByNameForListingQuery, GetIdsByNameForListingQueryVariables>(GetIdsByNameForListingDocument, options);
      }
export function useGetIdsByNameForListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIdsByNameForListingQuery, GetIdsByNameForListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIdsByNameForListingQuery, GetIdsByNameForListingQueryVariables>(GetIdsByNameForListingDocument, options);
        }
export type GetIdsByNameForListingQueryHookResult = ReturnType<typeof useGetIdsByNameForListingQuery>;
export type GetIdsByNameForListingLazyQueryHookResult = ReturnType<typeof useGetIdsByNameForListingLazyQuery>;
export type GetIdsByNameForListingQueryResult = Apollo.QueryResult<GetIdsByNameForListingQuery, GetIdsByNameForListingQueryVariables>;
export const MarkAndSoldDocument = gql`
    query markAndSold($regNo: String, $env: String!) {
  markTractorAsSoldWrapper(markSoldInput: {regNo: $regNo, env: $env}) {
    status
    message
  }
}
    `;

/**
 * __useMarkAndSoldQuery__
 *
 * To run a query within a React component, call `useMarkAndSoldQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarkAndSoldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarkAndSoldQuery({
 *   variables: {
 *      regNo: // value for 'regNo'
 *      env: // value for 'env'
 *   },
 * });
 */
export function useMarkAndSoldQuery(baseOptions: Apollo.QueryHookOptions<MarkAndSoldQuery, MarkAndSoldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarkAndSoldQuery, MarkAndSoldQueryVariables>(MarkAndSoldDocument, options);
      }
export function useMarkAndSoldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarkAndSoldQuery, MarkAndSoldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarkAndSoldQuery, MarkAndSoldQueryVariables>(MarkAndSoldDocument, options);
        }
export type MarkAndSoldQueryHookResult = ReturnType<typeof useMarkAndSoldQuery>;
export type MarkAndSoldLazyQueryHookResult = ReturnType<typeof useMarkAndSoldLazyQuery>;
export type MarkAndSoldQueryResult = Apollo.QueryResult<MarkAndSoldQuery, MarkAndSoldQueryVariables>;
export const UpdateImagesDocument = gql`
    mutation updateImages($id: [ID!], $leadPatch: LeadPatch) {
  updateLead(input: {filter: {id: $id}, set: $leadPatch}) {
    numUids
  }
}
    `;
export type UpdateImagesMutationFn = Apollo.MutationFunction<UpdateImagesMutation, UpdateImagesMutationVariables>;

/**
 * __useUpdateImagesMutation__
 *
 * To run a mutation, you first call `useUpdateImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImagesMutation, { data, loading, error }] = useUpdateImagesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      leadPatch: // value for 'leadPatch'
 *   },
 * });
 */
export function useUpdateImagesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateImagesMutation, UpdateImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateImagesMutation, UpdateImagesMutationVariables>(UpdateImagesDocument, options);
      }
export type UpdateImagesMutationHookResult = ReturnType<typeof useUpdateImagesMutation>;
export type UpdateImagesMutationResult = Apollo.MutationResult<UpdateImagesMutation>;
export type UpdateImagesMutationOptions = Apollo.BaseMutationOptions<UpdateImagesMutation, UpdateImagesMutationVariables>;
export const IsUserRoleAdminDocument = gql`
    query IsUserRoleAdmin($email: String!) {
  queryUser(filter: {email: {eq: $email}}) {
    name
    role
    email
    id
    hasAdminPanelAccess
    isActive
    centre {
      id
      name
    }
  }
}
    `;

/**
 * __useIsUserRoleAdminQuery__
 *
 * To run a query within a React component, call `useIsUserRoleAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsUserRoleAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsUserRoleAdminQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useIsUserRoleAdminQuery(baseOptions: Apollo.QueryHookOptions<IsUserRoleAdminQuery, IsUserRoleAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsUserRoleAdminQuery, IsUserRoleAdminQueryVariables>(IsUserRoleAdminDocument, options);
      }
export function useIsUserRoleAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsUserRoleAdminQuery, IsUserRoleAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsUserRoleAdminQuery, IsUserRoleAdminQueryVariables>(IsUserRoleAdminDocument, options);
        }
export type IsUserRoleAdminQueryHookResult = ReturnType<typeof useIsUserRoleAdminQuery>;
export type IsUserRoleAdminLazyQueryHookResult = ReturnType<typeof useIsUserRoleAdminLazyQuery>;
export type IsUserRoleAdminQueryResult = Apollo.QueryResult<IsUserRoleAdminQuery, IsUserRoleAdminQueryVariables>;
export const UserStatusDocument = gql`
    subscription userStatus($userId: [ID!]) {
  queryUser(filter: {id: $userId}) {
    id
    name
    role
    isActive
  }
}
    `;

/**
 * __useUserStatusSubscription__
 *
 * To run a query within a React component, call `useUserStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserStatusSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserStatusSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UserStatusSubscription, UserStatusSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UserStatusSubscription, UserStatusSubscriptionVariables>(UserStatusDocument, options);
      }
export type UserStatusSubscriptionHookResult = ReturnType<typeof useUserStatusSubscription>;
export type UserStatusSubscriptionResult = Apollo.SubscriptionResult<UserStatusSubscription>;
export const GetUserDocument = gql`
    query getUser($email: String!) {
  queryUser(filter: {email: {eq: $email}}) {
    name
    role
    email
    id
    hasAdminPanelAccess
    isActive
    centre {
      name
      id
    }
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const LogTrackingDocument = gql`
    query logTracking($offset: Int = 0, $first: Int = 6) {
  queryLogTracking(offset: $offset, first: $first, order: {desc: createdAt}) {
    id
    createdAt
    actionType
    module
    sourceUpdated
    previousValue
    updatedValue
    sourceUpdated
    taskPerformedBy {
      name
      role
    }
    source
    status
  }
}
    `;

/**
 * __useLogTrackingQuery__
 *
 * To run a query within a React component, call `useLogTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogTrackingQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useLogTrackingQuery(baseOptions?: Apollo.QueryHookOptions<LogTrackingQuery, LogTrackingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LogTrackingQuery, LogTrackingQueryVariables>(LogTrackingDocument, options);
      }
export function useLogTrackingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LogTrackingQuery, LogTrackingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LogTrackingQuery, LogTrackingQueryVariables>(LogTrackingDocument, options);
        }
export type LogTrackingQueryHookResult = ReturnType<typeof useLogTrackingQuery>;
export type LogTrackingLazyQueryHookResult = ReturnType<typeof useLogTrackingLazyQuery>;
export type LogTrackingQueryResult = Apollo.QueryResult<LogTrackingQuery, LogTrackingQueryVariables>;
export const FilterlogDocument = gql`
    query filterlog($filters: LogTrackingFilter) {
  queryLogTracking(filter: $filters, offset: 0, order: {desc: createdAt}) {
    module
    actionType
    source
    createdAt
    id
    previousValue
    updatedValue
    taskPerformedBy {
      role
      name
    }
    sourceUpdated
    status
    source
  }
}
    `;

/**
 * __useFilterlogQuery__
 *
 * To run a query within a React component, call `useFilterlogQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterlogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterlogQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFilterlogQuery(baseOptions?: Apollo.QueryHookOptions<FilterlogQuery, FilterlogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterlogQuery, FilterlogQueryVariables>(FilterlogDocument, options);
      }
export function useFilterlogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterlogQuery, FilterlogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterlogQuery, FilterlogQueryVariables>(FilterlogDocument, options);
        }
export type FilterlogQueryHookResult = ReturnType<typeof useFilterlogQuery>;
export type FilterlogLazyQueryHookResult = ReturnType<typeof useFilterlogLazyQuery>;
export type FilterlogQueryResult = Apollo.QueryResult<FilterlogQuery, FilterlogQueryVariables>;
export const NotificationDataDocument = gql`
    query notificationData {
  queryDocumentsFollowups(filter: {has: nextFollowupDate}) {
    id
    followupDate
    source
    documentName
    remarks
    nextFollowupDate
    lead {
      regNo
      id
    }
  }
}
    `;

/**
 * __useNotificationDataQuery__
 *
 * To run a query within a React component, call `useNotificationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationDataQuery(baseOptions?: Apollo.QueryHookOptions<NotificationDataQuery, NotificationDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationDataQuery, NotificationDataQueryVariables>(NotificationDataDocument, options);
      }
export function useNotificationDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationDataQuery, NotificationDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationDataQuery, NotificationDataQueryVariables>(NotificationDataDocument, options);
        }
export type NotificationDataQueryHookResult = ReturnType<typeof useNotificationDataQuery>;
export type NotificationDataLazyQueryHookResult = ReturnType<typeof useNotificationDataLazyQuery>;
export type NotificationDataQueryResult = Apollo.QueryResult<NotificationDataQuery, NotificationDataQueryVariables>;
export const GetProductsDocument = gql`
    query GetProducts {
  queryProduct {
    name
    variant
    id
  }
}
    `;

/**
 * __useGetProductsQuery__
 *
 * To run a query within a React component, call `useGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
      }
export function useGetProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export type GetProductsQueryHookResult = ReturnType<typeof useGetProductsQuery>;
export type GetProductsLazyQueryHookResult = ReturnType<typeof useGetProductsLazyQuery>;
export type GetProductsQueryResult = Apollo.QueryResult<GetProductsQuery, GetProductsQueryVariables>;
export const GetUsersDocument = gql`
    query getUsers($name: String) {
  queryUser(filter: {name: {regexp: $name}}, order: {desc: updatedAt}) {
    id
    name
    role
    email
    createdAt
    isActive
    updatedAt
    centre {
      id
      name
      incharge {
        id
        email
        name
      }
    }
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetIssueItemDetailsDocument = gql`
    query GetIssueItemDetails($purchaseId: ID!) {
  getIssue(id: $purchaseId) {
    status
    id
    madeBy {
      id
      name
    }
    centre {
      id
      name
    }
    createdAt
    regNo
    items {
      quantity
      description
      product {
        id
        name
        description
        variant
      }
    }
  }
}
    `;

/**
 * __useGetIssueItemDetailsQuery__
 *
 * To run a query within a React component, call `useGetIssueItemDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIssueItemDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIssueItemDetailsQuery({
 *   variables: {
 *      purchaseId: // value for 'purchaseId'
 *   },
 * });
 */
export function useGetIssueItemDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetIssueItemDetailsQuery, GetIssueItemDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIssueItemDetailsQuery, GetIssueItemDetailsQueryVariables>(GetIssueItemDetailsDocument, options);
      }
export function useGetIssueItemDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIssueItemDetailsQuery, GetIssueItemDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIssueItemDetailsQuery, GetIssueItemDetailsQueryVariables>(GetIssueItemDetailsDocument, options);
        }
export type GetIssueItemDetailsQueryHookResult = ReturnType<typeof useGetIssueItemDetailsQuery>;
export type GetIssueItemDetailsLazyQueryHookResult = ReturnType<typeof useGetIssueItemDetailsLazyQuery>;
export type GetIssueItemDetailsQueryResult = Apollo.QueryResult<GetIssueItemDetailsQuery, GetIssueItemDetailsQueryVariables>;
export const GetPurchaseItemDetailsDocument = gql`
    query GetPurchaseItemDetails($purchaseId: ID!) {
  getPurchase(id: $purchaseId) {
    status
    id
    madeBy {
      id
      name
    }
    centre {
      id
      name
    }
    createdAt
    items {
      quantity
      description
      product {
        id
        name
        description
        variant
      }
    }
  }
}
    `;

/**
 * __useGetPurchaseItemDetailsQuery__
 *
 * To run a query within a React component, call `useGetPurchaseItemDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaseItemDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaseItemDetailsQuery({
 *   variables: {
 *      purchaseId: // value for 'purchaseId'
 *   },
 * });
 */
export function useGetPurchaseItemDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetPurchaseItemDetailsQuery, GetPurchaseItemDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaseItemDetailsQuery, GetPurchaseItemDetailsQueryVariables>(GetPurchaseItemDetailsDocument, options);
      }
export function useGetPurchaseItemDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaseItemDetailsQuery, GetPurchaseItemDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaseItemDetailsQuery, GetPurchaseItemDetailsQueryVariables>(GetPurchaseItemDetailsDocument, options);
        }
export type GetPurchaseItemDetailsQueryHookResult = ReturnType<typeof useGetPurchaseItemDetailsQuery>;
export type GetPurchaseItemDetailsLazyQueryHookResult = ReturnType<typeof useGetPurchaseItemDetailsLazyQuery>;
export type GetPurchaseItemDetailsQueryResult = Apollo.QueryResult<GetPurchaseItemDetailsQuery, GetPurchaseItemDetailsQueryVariables>;
export const UpdateListingPriceDocument = gql`
    mutation updateListingPrice($ListingPrice: Int, $id: [ID!]) {
  updateLead(input: {filter: {id: $id}, set: {listingPrice: $ListingPrice}}) {
    numUids
  }
}
    `;
export type UpdateListingPriceMutationFn = Apollo.MutationFunction<UpdateListingPriceMutation, UpdateListingPriceMutationVariables>;

/**
 * __useUpdateListingPriceMutation__
 *
 * To run a mutation, you first call `useUpdateListingPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListingPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListingPriceMutation, { data, loading, error }] = useUpdateListingPriceMutation({
 *   variables: {
 *      ListingPrice: // value for 'ListingPrice'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateListingPriceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListingPriceMutation, UpdateListingPriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListingPriceMutation, UpdateListingPriceMutationVariables>(UpdateListingPriceDocument, options);
      }
export type UpdateListingPriceMutationHookResult = ReturnType<typeof useUpdateListingPriceMutation>;
export type UpdateListingPriceMutationResult = Apollo.MutationResult<UpdateListingPriceMutation>;
export type UpdateListingPriceMutationOptions = Apollo.BaseMutationOptions<UpdateListingPriceMutation, UpdateListingPriceMutationVariables>;
export const GetUsersSecondDocument = gql`
    query getUsersSecond($name: String) {
  queryUser(filter: {name: {regexp: $name}}, order: {desc: updatedAt}) {
    id
    name
    role
    email
    createdAt
    isActive
    registrationState
    reportingManager {
      name
    }
    updatedAt
    centre {
      id
      name
      incharge {
        id
        email
        name
      }
    }
  }
}
    `;

/**
 * __useGetUsersSecondQuery__
 *
 * To run a query within a React component, call `useGetUsersSecondQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersSecondQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersSecondQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetUsersSecondQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersSecondQuery, GetUsersSecondQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersSecondQuery, GetUsersSecondQueryVariables>(GetUsersSecondDocument, options);
      }
export function useGetUsersSecondLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersSecondQuery, GetUsersSecondQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersSecondQuery, GetUsersSecondQueryVariables>(GetUsersSecondDocument, options);
        }
export type GetUsersSecondQueryHookResult = ReturnType<typeof useGetUsersSecondQuery>;
export type GetUsersSecondLazyQueryHookResult = ReturnType<typeof useGetUsersSecondLazyQuery>;
export type GetUsersSecondQueryResult = Apollo.QueryResult<GetUsersSecondQuery, GetUsersSecondQueryVariables>;
export const AddUserDocument = gql`
    mutation addUser($UserPatch: AddUserInput!) {
  addUser(input: [$UserPatch], upsert: true) {
    user {
      name
      email
      role
      createdAt
      isActive
      reportingManager {
        name
        email
      }
      registrationState
      centre {
        name
        id
      }
    }
  }
}
    `;
export type AddUserMutationFn = Apollo.MutationFunction<AddUserMutation, AddUserMutationVariables>;

/**
 * __useAddUserMutation__
 *
 * To run a mutation, you first call `useAddUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserMutation, { data, loading, error }] = useAddUserMutation({
 *   variables: {
 *      UserPatch: // value for 'UserPatch'
 *   },
 * });
 */
export function useAddUserMutation(baseOptions?: Apollo.MutationHookOptions<AddUserMutation, AddUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserMutation, AddUserMutationVariables>(AddUserDocument, options);
      }
export type AddUserMutationHookResult = ReturnType<typeof useAddUserMutation>;
export type AddUserMutationResult = Apollo.MutationResult<AddUserMutation>;
export type AddUserMutationOptions = Apollo.BaseMutationOptions<AddUserMutation, AddUserMutationVariables>;
export const AddUserWithoutCentreDocument = gql`
    mutation addUserWithoutCentre($name: String!, $email: String!, $role: UserRole!) {
  addUser(input: {name: $name, email: $email, role: $role}) {
    user {
      name
      email
      role
      centre {
        name
        id
      }
    }
  }
}
    `;
export type AddUserWithoutCentreMutationFn = Apollo.MutationFunction<AddUserWithoutCentreMutation, AddUserWithoutCentreMutationVariables>;

/**
 * __useAddUserWithoutCentreMutation__
 *
 * To run a mutation, you first call `useAddUserWithoutCentreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserWithoutCentreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserWithoutCentreMutation, { data, loading, error }] = useAddUserWithoutCentreMutation({
 *   variables: {
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useAddUserWithoutCentreMutation(baseOptions?: Apollo.MutationHookOptions<AddUserWithoutCentreMutation, AddUserWithoutCentreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserWithoutCentreMutation, AddUserWithoutCentreMutationVariables>(AddUserWithoutCentreDocument, options);
      }
export type AddUserWithoutCentreMutationHookResult = ReturnType<typeof useAddUserWithoutCentreMutation>;
export type AddUserWithoutCentreMutationResult = Apollo.MutationResult<AddUserWithoutCentreMutation>;
export type AddUserWithoutCentreMutationOptions = Apollo.BaseMutationOptions<AddUserWithoutCentreMutation, AddUserWithoutCentreMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($UserPatch: UserPatch, $email: String, $remove: UserPatch) {
  updateUser(
    input: {filter: {email: {eq: $email}}, set: $UserPatch, remove: $remove}
  ) {
    user {
      name
      email
      role
      registrationState
      reportingManager {
        name
      }
      createdAt
      updatedAt
      isActive
      centre {
        name
        id
      }
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      UserPatch: // value for 'UserPatch'
 *      email: // value for 'email'
 *      remove: // value for 'remove'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const GetAllNewBrandsDocument = gql`
    query GetAllNewBrands {
  queryBrand {
    id
    name
    brand_id
  }
}
    `;

/**
 * __useGetAllNewBrandsQuery__
 *
 * To run a query within a React component, call `useGetAllNewBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllNewBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllNewBrandsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllNewBrandsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllNewBrandsQuery, GetAllNewBrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllNewBrandsQuery, GetAllNewBrandsQueryVariables>(GetAllNewBrandsDocument, options);
      }
export function useGetAllNewBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllNewBrandsQuery, GetAllNewBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllNewBrandsQuery, GetAllNewBrandsQueryVariables>(GetAllNewBrandsDocument, options);
        }
export type GetAllNewBrandsQueryHookResult = ReturnType<typeof useGetAllNewBrandsQuery>;
export type GetAllNewBrandsLazyQueryHookResult = ReturnType<typeof useGetAllNewBrandsLazyQuery>;
export type GetAllNewBrandsQueryResult = Apollo.QueryResult<GetAllNewBrandsQuery, GetAllNewBrandsQueryVariables>;
export const GetAllNewModelsByMakeDocument = gql`
    query GetAllNewModelsByMake($id: [ID!]!) {
  queryBrand(filter: {id: $id}) {
    models {
      id
      name
      model_id
    }
  }
}
    `;

/**
 * __useGetAllNewModelsByMakeQuery__
 *
 * To run a query within a React component, call `useGetAllNewModelsByMakeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllNewModelsByMakeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllNewModelsByMakeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAllNewModelsByMakeQuery(baseOptions: Apollo.QueryHookOptions<GetAllNewModelsByMakeQuery, GetAllNewModelsByMakeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllNewModelsByMakeQuery, GetAllNewModelsByMakeQueryVariables>(GetAllNewModelsByMakeDocument, options);
      }
export function useGetAllNewModelsByMakeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllNewModelsByMakeQuery, GetAllNewModelsByMakeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllNewModelsByMakeQuery, GetAllNewModelsByMakeQueryVariables>(GetAllNewModelsByMakeDocument, options);
        }
export type GetAllNewModelsByMakeQueryHookResult = ReturnType<typeof useGetAllNewModelsByMakeQuery>;
export type GetAllNewModelsByMakeLazyQueryHookResult = ReturnType<typeof useGetAllNewModelsByMakeLazyQuery>;
export type GetAllNewModelsByMakeQueryResult = Apollo.QueryResult<GetAllNewModelsByMakeQuery, GetAllNewModelsByMakeQueryVariables>;
export const NumberOfPendingTasksDocument = gql`
    query NumberOfPendingTasks($myId: ID!, $role: UserRole!) {
  numberOfPendingTasks(userId: $myId, role: $role) {
    count
  }
}
    `;

/**
 * __useNumberOfPendingTasksQuery__
 *
 * To run a query within a React component, call `useNumberOfPendingTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useNumberOfPendingTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNumberOfPendingTasksQuery({
 *   variables: {
 *      myId: // value for 'myId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useNumberOfPendingTasksQuery(baseOptions: Apollo.QueryHookOptions<NumberOfPendingTasksQuery, NumberOfPendingTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NumberOfPendingTasksQuery, NumberOfPendingTasksQueryVariables>(NumberOfPendingTasksDocument, options);
      }
export function useNumberOfPendingTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NumberOfPendingTasksQuery, NumberOfPendingTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NumberOfPendingTasksQuery, NumberOfPendingTasksQueryVariables>(NumberOfPendingTasksDocument, options);
        }
export type NumberOfPendingTasksQueryHookResult = ReturnType<typeof useNumberOfPendingTasksQuery>;
export type NumberOfPendingTasksLazyQueryHookResult = ReturnType<typeof useNumberOfPendingTasksLazyQuery>;
export type NumberOfPendingTasksQueryResult = Apollo.QueryResult<NumberOfPendingTasksQuery, NumberOfPendingTasksQueryVariables>;
export const MyPendingTasksDocument = gql`
    query MyPendingTasks($myId: ID!, $offset: Int = 0, $role: UserRole!, $centreId: ID) {
  myPendingTasks(userId: $myId, role: $role, offset: $offset, centreId: $centreId) {
    id
    createdAt
    createdBy {
      id
      name
      email
    }
    status
    assignTaskTo
    notifyTo
    taskTitle
    taskButtonTitle
    lead {
      id
      regNo
      centre {
        id
        name
      }
      createdBy {
        id
      }
      vehicle {
        id
        make
        vehicleBrand {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useMyPendingTasksQuery__
 *
 * To run a query within a React component, call `useMyPendingTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPendingTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPendingTasksQuery({
 *   variables: {
 *      myId: // value for 'myId'
 *      offset: // value for 'offset'
 *      role: // value for 'role'
 *      centreId: // value for 'centreId'
 *   },
 * });
 */
export function useMyPendingTasksQuery(baseOptions: Apollo.QueryHookOptions<MyPendingTasksQuery, MyPendingTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPendingTasksQuery, MyPendingTasksQueryVariables>(MyPendingTasksDocument, options);
      }
export function useMyPendingTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPendingTasksQuery, MyPendingTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPendingTasksQuery, MyPendingTasksQueryVariables>(MyPendingTasksDocument, options);
        }
export type MyPendingTasksQueryHookResult = ReturnType<typeof useMyPendingTasksQuery>;
export type MyPendingTasksLazyQueryHookResult = ReturnType<typeof useMyPendingTasksLazyQuery>;
export type MyPendingTasksQueryResult = Apollo.QueryResult<MyPendingTasksQuery, MyPendingTasksQueryVariables>;
export const LeadStatusFlowDocument = gql`
    query LeadStatusFlow($source: LeadSource) {
  queryLeadStatusFlow(filter: {source: {eq: $source}}) {
    notificationTitle
    notifyTo
    taskTitle
    assignTaskTo
    next
    current
    previous
    taskButtonTitle
    taskFormActionTitle
    taskFormNegativeActionTitle
    isNegativeCase
    canGoBack
    desired
    undesired
    taskTitleWas
    cta
    taskPerformedBy
    showPopup
    showPopupWithInputField
    popupTitle
    popupDescription
    hideForm
    showPopupRemark
    canGoForward
    source
    hideUndesiredButton
  }
}
    `;

/**
 * __useLeadStatusFlowQuery__
 *
 * To run a query within a React component, call `useLeadStatusFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadStatusFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadStatusFlowQuery({
 *   variables: {
 *      source: // value for 'source'
 *   },
 * });
 */
export function useLeadStatusFlowQuery(baseOptions?: Apollo.QueryHookOptions<LeadStatusFlowQuery, LeadStatusFlowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeadStatusFlowQuery, LeadStatusFlowQueryVariables>(LeadStatusFlowDocument, options);
      }
export function useLeadStatusFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeadStatusFlowQuery, LeadStatusFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeadStatusFlowQuery, LeadStatusFlowQueryVariables>(LeadStatusFlowDocument, options);
        }
export type LeadStatusFlowQueryHookResult = ReturnType<typeof useLeadStatusFlowQuery>;
export type LeadStatusFlowLazyQueryHookResult = ReturnType<typeof useLeadStatusFlowLazyQuery>;
export type LeadStatusFlowQueryResult = Apollo.QueryResult<LeadStatusFlowQuery, LeadStatusFlowQueryVariables>;
export const CreateFakeUserWithRoleDocument = gql`
    mutation CreateFakeUserWithRole($role: UserRole, $fakeEmail: String!, $fakeName: String!, $pnsToken: String, $phoneNo: String!, $createdAt: DateTime, $centre: CentreRef) {
  addUser(
    upsert: true
    input: {email: $fakeEmail, name: $fakeName, role: $role, expoPushNotificationAddress: $pnsToken, phoneNo: $phoneNo, isActive: true, createdAt: $createdAt, centre: $centre}
  ) {
    user {
      id
      name
      email
      expoPushNotificationAddress
      role
      centre {
        id
        name
      }
    }
  }
}
    `;
export type CreateFakeUserWithRoleMutationFn = Apollo.MutationFunction<CreateFakeUserWithRoleMutation, CreateFakeUserWithRoleMutationVariables>;

/**
 * __useCreateFakeUserWithRoleMutation__
 *
 * To run a mutation, you first call `useCreateFakeUserWithRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFakeUserWithRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFakeUserWithRoleMutation, { data, loading, error }] = useCreateFakeUserWithRoleMutation({
 *   variables: {
 *      role: // value for 'role'
 *      fakeEmail: // value for 'fakeEmail'
 *      fakeName: // value for 'fakeName'
 *      pnsToken: // value for 'pnsToken'
 *      phoneNo: // value for 'phoneNo'
 *      createdAt: // value for 'createdAt'
 *      centre: // value for 'centre'
 *   },
 * });
 */
export function useCreateFakeUserWithRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateFakeUserWithRoleMutation, CreateFakeUserWithRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFakeUserWithRoleMutation, CreateFakeUserWithRoleMutationVariables>(CreateFakeUserWithRoleDocument, options);
      }
export type CreateFakeUserWithRoleMutationHookResult = ReturnType<typeof useCreateFakeUserWithRoleMutation>;
export type CreateFakeUserWithRoleMutationResult = Apollo.MutationResult<CreateFakeUserWithRoleMutation>;
export type CreateFakeUserWithRoleMutationOptions = Apollo.BaseMutationOptions<CreateFakeUserWithRoleMutation, CreateFakeUserWithRoleMutationVariables>;
export const CreateLeadStatusEventDocument = gql`
    mutation CreateLeadStatusEvent($lead: LeadRef!, $status: LeadStatus!, $myId: ID!, $createdAt: DateTime!, $remarks: String, $assignTaskTo: UserRole, $notifyTo: [UserRole], $taskTitle: String, $taskButtonTitle: String, $metadata: String) {
  addLeadStatusEvent(
    input: {lead: $lead, status: $status, assignTaskTo: $assignTaskTo, notifyTo: $notifyTo, taskTitle: $taskTitle, taskButtonTitle: $taskButtonTitle, createdBy: {id: $myId}, createdAt: $createdAt, remarks: $remarks, metadata: $metadata, deviceType: ADMIN_PANEL}
  ) {
    leadStatusEvent {
      lead {
        id
        regNo
        expenses {
          category
        }
      }
      ...LeadStatusEventDetails
    }
  }
}
    ${LeadStatusEventDetailsFragmentDoc}`;
export type CreateLeadStatusEventMutationFn = Apollo.MutationFunction<CreateLeadStatusEventMutation, CreateLeadStatusEventMutationVariables>;

/**
 * __useCreateLeadStatusEventMutation__
 *
 * To run a mutation, you first call `useCreateLeadStatusEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLeadStatusEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLeadStatusEventMutation, { data, loading, error }] = useCreateLeadStatusEventMutation({
 *   variables: {
 *      lead: // value for 'lead'
 *      status: // value for 'status'
 *      myId: // value for 'myId'
 *      createdAt: // value for 'createdAt'
 *      remarks: // value for 'remarks'
 *      assignTaskTo: // value for 'assignTaskTo'
 *      notifyTo: // value for 'notifyTo'
 *      taskTitle: // value for 'taskTitle'
 *      taskButtonTitle: // value for 'taskButtonTitle'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useCreateLeadStatusEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateLeadStatusEventMutation, CreateLeadStatusEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLeadStatusEventMutation, CreateLeadStatusEventMutationVariables>(CreateLeadStatusEventDocument, options);
      }
export type CreateLeadStatusEventMutationHookResult = ReturnType<typeof useCreateLeadStatusEventMutation>;
export type CreateLeadStatusEventMutationResult = Apollo.MutationResult<CreateLeadStatusEventMutation>;
export type CreateLeadStatusEventMutationOptions = Apollo.BaseMutationOptions<CreateLeadStatusEventMutation, CreateLeadStatusEventMutationVariables>;
export const UpdatesForMyRoleDocument = gql`
    query UpdatesForMyRole($myRole: [UserRole!], $offset: Int = 0, $first: Int = 10) {
  queryLeadStatusEvent(
    order: {desc: createdAt}
    filter: {notifyTo: {in: $myRole}}
    first: $first
    offset: $offset
  ) {
    id
    createdAt
    lead {
      id
      regNo
      vehicle {
        id
        make
        vehicleBrand {
          name
        }
      }
    }
    createdBy {
      id
      name
    }
    status
    remarks
  }
}
    `;

/**
 * __useUpdatesForMyRoleQuery__
 *
 * To run a query within a React component, call `useUpdatesForMyRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdatesForMyRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatesForMyRoleQuery({
 *   variables: {
 *      myRole: // value for 'myRole'
 *      offset: // value for 'offset'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useUpdatesForMyRoleQuery(baseOptions?: Apollo.QueryHookOptions<UpdatesForMyRoleQuery, UpdatesForMyRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpdatesForMyRoleQuery, UpdatesForMyRoleQueryVariables>(UpdatesForMyRoleDocument, options);
      }
export function useUpdatesForMyRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpdatesForMyRoleQuery, UpdatesForMyRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpdatesForMyRoleQuery, UpdatesForMyRoleQueryVariables>(UpdatesForMyRoleDocument, options);
        }
export type UpdatesForMyRoleQueryHookResult = ReturnType<typeof useUpdatesForMyRoleQuery>;
export type UpdatesForMyRoleLazyQueryHookResult = ReturnType<typeof useUpdatesForMyRoleLazyQuery>;
export type UpdatesForMyRoleQueryResult = Apollo.QueryResult<UpdatesForMyRoleQuery, UpdatesForMyRoleQueryVariables>;
export const DriversDocument = gql`
    query Drivers {
  queryUser(filter: {role: {eq: DRIVER}}) {
    id
    name
    pickups {
      id
      regNo
    }
    phoneNo
  }
}
    `;

/**
 * __useDriversQuery__
 *
 * To run a query within a React component, call `useDriversQuery` and pass it any options that fit your needs.
 * When your component renders, `useDriversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDriversQuery({
 *   variables: {
 *   },
 * });
 */
export function useDriversQuery(baseOptions?: Apollo.QueryHookOptions<DriversQuery, DriversQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DriversQuery, DriversQueryVariables>(DriversDocument, options);
      }
export function useDriversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DriversQuery, DriversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DriversQuery, DriversQueryVariables>(DriversDocument, options);
        }
export type DriversQueryHookResult = ReturnType<typeof useDriversQuery>;
export type DriversLazyQueryHookResult = ReturnType<typeof useDriversLazyQuery>;
export type DriversQueryResult = Apollo.QueryResult<DriversQuery, DriversQueryVariables>;
export const GetLeadDealDetailsDocument = gql`
    query GetLeadDealDetails($id: ID!) {
  getLead(id: $id) {
    id
    regNo
    source
    auctionByBank
    demandAmount
    proposedDealAmount
    approvedDealAmount
    documentCharges
    tokenAmount
    holdbackAmount
    deliveryAmount
    loanAmount
    loanToBeClosedBy
    paymentType
    statusEvents {
      id
      status
      remarks
      createdAt
    }
    activeBooking {
      id
      isInsuranceReq
      isRCTransferReq
      bookingPayment {
        id
        saleAmount
        bookingType
        bookingPaymentMode
        totalSaleAmount
        rcTransferAmount
        insuranceAmount
        appliedLoanAmount
      }
      activeLoan {
        id
        appliedLoanAmount
        sanctionedLoanAmount
        createdAt
      }
      payments {
        amount
        status
        for
      }
    }
    payments {
      id
      for
      status
      amount
      receiptUrl
      type
      loanClosedBy
      mode
      parkingBeneficiary {
        id
        accountHolderName
        accountNumber
        bankName
        ifscCode
        upiId
        proofUrl
      }
    }
    vehicle {
      id
      manufacturingDate
      make
      model
      engineNumber
      chassisNumber
      isVehicleInsured
      isRcAvailable
      hoursMeter
      isVehicleFinanced
      financingDetails {
        id
        isLoanClosed
        pendingLoanAmount
        loanToBeClosedBy
        tempLoanToBeClosedBy
      }
    }
    finalBidAmount
    proposedBidLimitAmount
    createdAt
    ownershipType
    statusEvents {
      id
      status
      remarks
    }
    refurbishmentDetails {
      requests {
        id
        requestStatus
        items {
          id
          status
          installationProofUrl
          product {
            id
            name
          }
          description
        }
        issue {
          items {
            description
            product {
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetLeadDealDetailsQuery__
 *
 * To run a query within a React component, call `useGetLeadDealDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadDealDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadDealDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLeadDealDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetLeadDealDetailsQuery, GetLeadDealDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadDealDetailsQuery, GetLeadDealDetailsQueryVariables>(GetLeadDealDetailsDocument, options);
      }
export function useGetLeadDealDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadDealDetailsQuery, GetLeadDealDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadDealDetailsQuery, GetLeadDealDetailsQueryVariables>(GetLeadDealDetailsDocument, options);
        }
export type GetLeadDealDetailsQueryHookResult = ReturnType<typeof useGetLeadDealDetailsQuery>;
export type GetLeadDealDetailsLazyQueryHookResult = ReturnType<typeof useGetLeadDealDetailsLazyQuery>;
export type GetLeadDealDetailsQueryResult = Apollo.QueryResult<GetLeadDealDetailsQuery, GetLeadDealDetailsQueryVariables>;
export const GetLeadDealAmountsDocument = gql`
    query GetLeadDealAmounts($id: ID!) {
  getLead(id: $id) {
    id
    regNo
    source
    auctionByBank
    demandAmount
    proposedDealAmount
    approvedDealAmount
    documentCharges
    tokenAmount
    holdbackAmount
    deliveryAmount
    loanAmount
    finalBidAmount
    proposedBidLimitAmount
    createdAt
    ownershipType
    activeBooking {
      bookingPayment {
        saleAmount
        totalSaleAmount
        bookingType
        appliedLoanAmount
      }
      isInsuranceReq
      isRCTransferReq
    }
  }
}
    `;

/**
 * __useGetLeadDealAmountsQuery__
 *
 * To run a query within a React component, call `useGetLeadDealAmountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadDealAmountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadDealAmountsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLeadDealAmountsQuery(baseOptions: Apollo.QueryHookOptions<GetLeadDealAmountsQuery, GetLeadDealAmountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadDealAmountsQuery, GetLeadDealAmountsQueryVariables>(GetLeadDealAmountsDocument, options);
      }
export function useGetLeadDealAmountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadDealAmountsQuery, GetLeadDealAmountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadDealAmountsQuery, GetLeadDealAmountsQueryVariables>(GetLeadDealAmountsDocument, options);
        }
export type GetLeadDealAmountsQueryHookResult = ReturnType<typeof useGetLeadDealAmountsQuery>;
export type GetLeadDealAmountsLazyQueryHookResult = ReturnType<typeof useGetLeadDealAmountsLazyQuery>;
export type GetLeadDealAmountsQueryResult = Apollo.QueryResult<GetLeadDealAmountsQuery, GetLeadDealAmountsQueryVariables>;
export const GetYardDetailsDocument = gql`
    query getYardDetails($id: ID!) {
  getLead(id: $id) {
    id
    regNo
    expectedPickupDate
    yardPerDayParkingCharges
    vehicle {
      repossessionDate
    }
    yard {
      id
      perDayParkingCharge
      name
      spocName
      spocNo
      address
      city
      locationUrl
      tempPerDayParkingCharge
    }
    internalTransfers {
      id
      assignedTo {
        name
      }
      to {
        id
        name
        location {
          latitude
          longitude
        }
      }
      from {
        name
        location {
          latitude
          longitude
        }
      }
    }
  }
}
    `;

/**
 * __useGetYardDetailsQuery__
 *
 * To run a query within a React component, call `useGetYardDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetYardDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetYardDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetYardDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetYardDetailsQuery, GetYardDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetYardDetailsQuery, GetYardDetailsQueryVariables>(GetYardDetailsDocument, options);
      }
export function useGetYardDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetYardDetailsQuery, GetYardDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetYardDetailsQuery, GetYardDetailsQueryVariables>(GetYardDetailsDocument, options);
        }
export type GetYardDetailsQueryHookResult = ReturnType<typeof useGetYardDetailsQuery>;
export type GetYardDetailsLazyQueryHookResult = ReturnType<typeof useGetYardDetailsLazyQuery>;
export type GetYardDetailsQueryResult = Apollo.QueryResult<GetYardDetailsQuery, GetYardDetailsQueryVariables>;
export const GetAllParkingBeneficiaryDocument = gql`
    query getAllParkingBeneficiary($id: [ID!]) {
  queryParkingBeneficiary(filter: {id: $id}) @cascade(fields: "accountHolderName") {
    id
    accountHolderName
    accountNumber
    ifscCode
    bankName
    proofUrl
  }
}
    `;

/**
 * __useGetAllParkingBeneficiaryQuery__
 *
 * To run a query within a React component, call `useGetAllParkingBeneficiaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllParkingBeneficiaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllParkingBeneficiaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAllParkingBeneficiaryQuery(baseOptions?: Apollo.QueryHookOptions<GetAllParkingBeneficiaryQuery, GetAllParkingBeneficiaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllParkingBeneficiaryQuery, GetAllParkingBeneficiaryQueryVariables>(GetAllParkingBeneficiaryDocument, options);
      }
export function useGetAllParkingBeneficiaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllParkingBeneficiaryQuery, GetAllParkingBeneficiaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllParkingBeneficiaryQuery, GetAllParkingBeneficiaryQueryVariables>(GetAllParkingBeneficiaryDocument, options);
        }
export type GetAllParkingBeneficiaryQueryHookResult = ReturnType<typeof useGetAllParkingBeneficiaryQuery>;
export type GetAllParkingBeneficiaryLazyQueryHookResult = ReturnType<typeof useGetAllParkingBeneficiaryLazyQuery>;
export type GetAllParkingBeneficiaryQueryResult = Apollo.QueryResult<GetAllParkingBeneficiaryQuery, GetAllParkingBeneficiaryQueryVariables>;
export const GetDocumentDetailsFormDocument = gql`
    query getDocumentDetailsForm($id: ID!) {
  getLead(id: $id) {
    id
    regNo
    dealerStance {
      clearChallan
      clearHSRP
      clearBlackList
    }
    payments {
      amount
      type
      loanClosedBy
      for
      status
    }
    statusEvents {
      status
      remarks
    }
    documentCharges
    holdbackAmount
    proposedDealAmount
    approvedDealAmount
    tokenAmount
    demandAmount
    ownershipType
    documentChecklist {
      bankNOC
      form26
      form28
      form29
      form30
      form35
      indemnityBond
      releaseOrder
      insuranceCertificate
      loanForeclosure
      registrationCertificate
      sellerAadharCard
      form36
      form60_sellerPan
      ownerAddressProof
    }
    dealershipDocuments {
      bankNOC {
        isAvailable
        expectedDate
      }
      form26 {
        isAvailable
        expectedDate
      }
      form28 {
        isAvailable
        expectedDate
      }
      form29 {
        isAvailable
        expectedDate
      }
      form30 {
        isAvailable
        expectedDate
      }
      form35 {
        isAvailable
        expectedDate
      }
      form60_sellerPan {
        isAvailable
        expectedDate
      }
      insuranceCertificate {
        isAvailable
        expectedDate
      }
      loanForeclosure {
        isAvailable
        expectedDate
      }
      registrationCertificate {
        isAvailable
        expectedDate
      }
      sellerAadharCard {
        isAvailable
        expectedDate
      }
      form36 {
        isAvailable
        expectedDate
      }
      ownerAddressProof {
        isAvailable
        expectedDate
      }
    }
    vehicle {
      isVehicleFinanced
      isBlacklisted
      isHSRPAvailable
      isChallanAvailable
      financingDetails {
        pendingLoanAmount
        isLoanClosed
        loanToBeClosedBy
      }
      vehicleBrand {
        name
      }
      vehicleModel {
        name
      }
      manufacturingDate
      hoursMeter
    }
  }
}
    `;

/**
 * __useGetDocumentDetailsFormQuery__
 *
 * To run a query within a React component, call `useGetDocumentDetailsFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentDetailsFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentDetailsFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDocumentDetailsFormQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentDetailsFormQuery, GetDocumentDetailsFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentDetailsFormQuery, GetDocumentDetailsFormQueryVariables>(GetDocumentDetailsFormDocument, options);
      }
export function useGetDocumentDetailsFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentDetailsFormQuery, GetDocumentDetailsFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentDetailsFormQuery, GetDocumentDetailsFormQueryVariables>(GetDocumentDetailsFormDocument, options);
        }
export type GetDocumentDetailsFormQueryHookResult = ReturnType<typeof useGetDocumentDetailsFormQuery>;
export type GetDocumentDetailsFormLazyQueryHookResult = ReturnType<typeof useGetDocumentDetailsFormLazyQuery>;
export type GetDocumentDetailsFormQueryResult = Apollo.QueryResult<GetDocumentDetailsFormQuery, GetDocumentDetailsFormQueryVariables>;
export const FinalCostDocument = gql`
    query FinalCost($id: ID!) {
  getLead(id: $id) {
    id
    proposedBidLimitAmount
    finalBidAmount
    finalParkingCharges
    holdbackAmount
    documentCharges
    yardPerDayParkingCharges
    yardPerDayParkingChargesByDriver
    dealerStance {
      clearChallan
      clearBlackList
      clearHSRP
    }
    expectedPickupDate
    actualPickupDate
    tokenAmount
    pickup {
      id
      pickupStartTime
      pickEndTime
    }
    payments {
      id
      for
      status
      amount
    }
    yard {
      id
      tempPerDayParkingCharge
      perDayParkingCharge
    }
    estimatedParkingCharges
    actualParkingCharges
    vehicle {
      id
      repossessionDate
      tempRepossessionDate
    }
  }
}
    `;

/**
 * __useFinalCostQuery__
 *
 * To run a query within a React component, call `useFinalCostQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinalCostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinalCostQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFinalCostQuery(baseOptions: Apollo.QueryHookOptions<FinalCostQuery, FinalCostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinalCostQuery, FinalCostQueryVariables>(FinalCostDocument, options);
      }
export function useFinalCostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinalCostQuery, FinalCostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinalCostQuery, FinalCostQueryVariables>(FinalCostDocument, options);
        }
export type FinalCostQueryHookResult = ReturnType<typeof useFinalCostQuery>;
export type FinalCostLazyQueryHookResult = ReturnType<typeof useFinalCostLazyQuery>;
export type FinalCostQueryResult = Apollo.QueryResult<FinalCostQuery, FinalCostQueryVariables>;
export const GetLeadDetailForAdminDocument = gql`
    query getLeadDetailForAdmin($leadId: [ID!]!) {
  queryLead(filter: {id: $leadId}) {
    id
    regNo
    centre {
      name
    }
    finalBidAmount
    finalParkingCharges
    expenses {
      spentAmount
      paymentStatus
    }
    statusEvents {
      createdAt
      status
      createdBy {
        name
      }
      assignTaskTo
    }
  }
}
    `;

/**
 * __useGetLeadDetailForAdminQuery__
 *
 * To run a query within a React component, call `useGetLeadDetailForAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadDetailForAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadDetailForAdminQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */
export function useGetLeadDetailForAdminQuery(baseOptions: Apollo.QueryHookOptions<GetLeadDetailForAdminQuery, GetLeadDetailForAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadDetailForAdminQuery, GetLeadDetailForAdminQueryVariables>(GetLeadDetailForAdminDocument, options);
      }
export function useGetLeadDetailForAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadDetailForAdminQuery, GetLeadDetailForAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadDetailForAdminQuery, GetLeadDetailForAdminQueryVariables>(GetLeadDetailForAdminDocument, options);
        }
export type GetLeadDetailForAdminQueryHookResult = ReturnType<typeof useGetLeadDetailForAdminQuery>;
export type GetLeadDetailForAdminLazyQueryHookResult = ReturnType<typeof useGetLeadDetailForAdminLazyQuery>;
export type GetLeadDetailForAdminQueryResult = Apollo.QueryResult<GetLeadDetailForAdminQuery, GetLeadDetailForAdminQueryVariables>;
export const GetDriverDocument = gql`
    query GetDriver($leadId: ID!) {
  getLead(id: $leadId) {
    id
    yard {
      id
      locationUrl
      name
      address
      location {
        longitude
        latitude
      }
    }
    centre {
      id
      name
      address
      location {
        longitude
        latitude
      }
    }
    pickup {
      id
      by {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetDriverQuery__
 *
 * To run a query within a React component, call `useGetDriverQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */
export function useGetDriverQuery(baseOptions: Apollo.QueryHookOptions<GetDriverQuery, GetDriverQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverQuery, GetDriverQueryVariables>(GetDriverDocument, options);
      }
export function useGetDriverLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverQuery, GetDriverQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverQuery, GetDriverQueryVariables>(GetDriverDocument, options);
        }
export type GetDriverQueryHookResult = ReturnType<typeof useGetDriverQuery>;
export type GetDriverLazyQueryHookResult = ReturnType<typeof useGetDriverLazyQuery>;
export type GetDriverQueryResult = Apollo.QueryResult<GetDriverQuery, GetDriverQueryVariables>;
export const LeadUpdateDocument = gql`
    query LeadUpdate($id: [ID!]!) {
  queryLead(filter: {id: $id}) {
    regNo
    source
    status
    demandAmount
    ownershipType
    auctionByBank
    vehicle {
      hoursMeter
      vehicleBrand {
        id
        name
      }
      vehicleModel {
        id
        name
      }
      engineNumber
      chassisNumber
      registrationNumber
      make
      model
      manufacturingDate
    }
  }
}
    `;

/**
 * __useLeadUpdateQuery__
 *
 * To run a query within a React component, call `useLeadUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadUpdateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLeadUpdateQuery(baseOptions: Apollo.QueryHookOptions<LeadUpdateQuery, LeadUpdateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeadUpdateQuery, LeadUpdateQueryVariables>(LeadUpdateDocument, options);
      }
export function useLeadUpdateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeadUpdateQuery, LeadUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeadUpdateQuery, LeadUpdateQueryVariables>(LeadUpdateDocument, options);
        }
export type LeadUpdateQueryHookResult = ReturnType<typeof useLeadUpdateQuery>;
export type LeadUpdateLazyQueryHookResult = ReturnType<typeof useLeadUpdateLazyQuery>;
export type LeadUpdateQueryResult = Apollo.QueryResult<LeadUpdateQuery, LeadUpdateQueryVariables>;
export const PopupDynamicValuesDocument = gql`
    query popupDynamicValues($regNo: String!, $requestId: [ID!]) {
  getLead(regNo: $regNo) {
    id
    regNo
    listingStatus
    activeBooking {
      activeLoan {
        loginDate
        fieldInspectionDate
        fieldInspectionConfirmedDate
      }
    }
    payments {
      id
      status
      amount
      for
    }
    activeBooking {
      isRCTransferReq
      isInsuranceReq
      id
      payments {
        id
        for
        status
        amount
      }
      activeLoan {
        id
        sanctionedLoanAmount
      }
    }
    proposedBidLimitAmount
    demandAmount
    approvedDealAmount
    proposedDealAmount
    expenses {
      id
      paymentStatus
      spentAmount
    }
    refurbishmentDetails {
      id
      requests(filter: {id: $requestId}) {
        id
        transportationCharge
        items {
          id
          status
          price
        }
        purchase {
          id
          status
          items {
            isApproved
            id
            price
            approvedPriceLimit
            purchaseProofUrl
          }
        }
      }
    }
    finalBidAmount
    pickup {
      id
      by {
        id
        name
      }
    }
    statusEventsAggregate {
      count
    }
    deliveryAmount
  }
}
    `;

/**
 * __usePopupDynamicValuesQuery__
 *
 * To run a query within a React component, call `usePopupDynamicValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePopupDynamicValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePopupDynamicValuesQuery({
 *   variables: {
 *      regNo: // value for 'regNo'
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function usePopupDynamicValuesQuery(baseOptions: Apollo.QueryHookOptions<PopupDynamicValuesQuery, PopupDynamicValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PopupDynamicValuesQuery, PopupDynamicValuesQueryVariables>(PopupDynamicValuesDocument, options);
      }
export function usePopupDynamicValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PopupDynamicValuesQuery, PopupDynamicValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PopupDynamicValuesQuery, PopupDynamicValuesQueryVariables>(PopupDynamicValuesDocument, options);
        }
export type PopupDynamicValuesQueryHookResult = ReturnType<typeof usePopupDynamicValuesQuery>;
export type PopupDynamicValuesLazyQueryHookResult = ReturnType<typeof usePopupDynamicValuesLazyQuery>;
export type PopupDynamicValuesQueryResult = Apollo.QueryResult<PopupDynamicValuesQuery, PopupDynamicValuesQueryVariables>;
export const GetCenterFormLeadDocument = gql`
    query getCenterFormLead($leadId: ID!) {
  getLead(id: $leadId) {
    regNo
    centre {
      id
      name
    }
  }
}
    `;

/**
 * __useGetCenterFormLeadQuery__
 *
 * To run a query within a React component, call `useGetCenterFormLeadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCenterFormLeadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCenterFormLeadQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */
export function useGetCenterFormLeadQuery(baseOptions: Apollo.QueryHookOptions<GetCenterFormLeadQuery, GetCenterFormLeadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCenterFormLeadQuery, GetCenterFormLeadQueryVariables>(GetCenterFormLeadDocument, options);
      }
export function useGetCenterFormLeadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCenterFormLeadQuery, GetCenterFormLeadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCenterFormLeadQuery, GetCenterFormLeadQueryVariables>(GetCenterFormLeadDocument, options);
        }
export type GetCenterFormLeadQueryHookResult = ReturnType<typeof useGetCenterFormLeadQuery>;
export type GetCenterFormLeadLazyQueryHookResult = ReturnType<typeof useGetCenterFormLeadLazyQuery>;
export type GetCenterFormLeadQueryResult = Apollo.QueryResult<GetCenterFormLeadQuery, GetCenterFormLeadQueryVariables>;
export const RefurbishmentRequestDetailsDocument = gql`
    query RefurbishmentRequestDetails($leadId: [ID!]) {
  queryLead(filter: {id: $leadId}) {
    id
    regNo
    refurbishmentDetails {
      requests {
        id
        items {
          id
          product {
            id
            name
          }
          description
          price
          status
          refurbishmentProofUrl
        }
      }
    }
  }
}
    `;

/**
 * __useRefurbishmentRequestDetailsQuery__
 *
 * To run a query within a React component, call `useRefurbishmentRequestDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefurbishmentRequestDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefurbishmentRequestDetailsQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */
export function useRefurbishmentRequestDetailsQuery(baseOptions?: Apollo.QueryHookOptions<RefurbishmentRequestDetailsQuery, RefurbishmentRequestDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RefurbishmentRequestDetailsQuery, RefurbishmentRequestDetailsQueryVariables>(RefurbishmentRequestDetailsDocument, options);
      }
export function useRefurbishmentRequestDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RefurbishmentRequestDetailsQuery, RefurbishmentRequestDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RefurbishmentRequestDetailsQuery, RefurbishmentRequestDetailsQueryVariables>(RefurbishmentRequestDetailsDocument, options);
        }
export type RefurbishmentRequestDetailsQueryHookResult = ReturnType<typeof useRefurbishmentRequestDetailsQuery>;
export type RefurbishmentRequestDetailsLazyQueryHookResult = ReturnType<typeof useRefurbishmentRequestDetailsLazyQuery>;
export type RefurbishmentRequestDetailsQueryResult = Apollo.QueryResult<RefurbishmentRequestDetailsQuery, RefurbishmentRequestDetailsQueryVariables>;
export const GetLeadRefurbishmentDetailsDocument = gql`
    query GetLeadRefurbishmentDetails($leadId: [ID!]) {
  queryLead(filter: {id: $leadId}) {
    id
    source
    refurbishmentDetails {
      ...RefurbishmentDetailsFrag
    }
  }
}
    ${RefurbishmentDetailsFragFragmentDoc}`;

/**
 * __useGetLeadRefurbishmentDetailsQuery__
 *
 * To run a query within a React component, call `useGetLeadRefurbishmentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadRefurbishmentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadRefurbishmentDetailsQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */
export function useGetLeadRefurbishmentDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetLeadRefurbishmentDetailsQuery, GetLeadRefurbishmentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadRefurbishmentDetailsQuery, GetLeadRefurbishmentDetailsQueryVariables>(GetLeadRefurbishmentDetailsDocument, options);
      }
export function useGetLeadRefurbishmentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadRefurbishmentDetailsQuery, GetLeadRefurbishmentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadRefurbishmentDetailsQuery, GetLeadRefurbishmentDetailsQueryVariables>(GetLeadRefurbishmentDetailsDocument, options);
        }
export type GetLeadRefurbishmentDetailsQueryHookResult = ReturnType<typeof useGetLeadRefurbishmentDetailsQuery>;
export type GetLeadRefurbishmentDetailsLazyQueryHookResult = ReturnType<typeof useGetLeadRefurbishmentDetailsLazyQuery>;
export type GetLeadRefurbishmentDetailsQueryResult = Apollo.QueryResult<GetLeadRefurbishmentDetailsQuery, GetLeadRefurbishmentDetailsQueryVariables>;
export const ProcurementCostDocument = gql`
    query ProcurementCost($leadId: ID, $requestId: [ID!]) {
  getLead(id: $leadId) {
    id
    regNo
    source
    documentCharges
    sellingPrice
    vehicle {
      id
      images {
        vehicleImagesId
        frontBodySide
        backBodySide
        backLeftTyre
        backRightTyre
        leftBodySide
        rightBodySide
        chassisNumber
        engineNumber
        frontLeftTyre
        frontRightTyre
        fuelInjectionPumpPlate
        imagesTakenAtStage
        odometer
      }
    }
    payments {
      id
      for
      status
      amount
    }
    refurbishmentDetails {
      id
      requests(filter: {id: $requestId}) {
        id
        requestStatus
        transportationCharge
        issue {
          id
          status
          items {
            id
            price
            isApproved
            quantity
            product {
              id
              name
              variant
            }
          }
        }
        purchase {
          id
          totalPrice
          items {
            approvedPriceLimit
            product {
              name
            }
            description
            price
          }
          payment {
            amount
            status
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProcurementCostQuery__
 *
 * To run a query within a React component, call `useProcurementCostQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcurementCostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcurementCostQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useProcurementCostQuery(baseOptions?: Apollo.QueryHookOptions<ProcurementCostQuery, ProcurementCostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcurementCostQuery, ProcurementCostQueryVariables>(ProcurementCostDocument, options);
      }
export function useProcurementCostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcurementCostQuery, ProcurementCostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcurementCostQuery, ProcurementCostQueryVariables>(ProcurementCostDocument, options);
        }
export type ProcurementCostQueryHookResult = ReturnType<typeof useProcurementCostQuery>;
export type ProcurementCostLazyQueryHookResult = ReturnType<typeof useProcurementCostLazyQuery>;
export type ProcurementCostQueryResult = Apollo.QueryResult<ProcurementCostQuery, ProcurementCostQueryVariables>;
export const GetBookingPaymentForReviewDocument = gql`
    query getBookingPaymentForReview($leadId: ID!) {
  getLead(id: $leadId) {
    id
    activeBooking {
      id
      payments {
        id
        for
        amount
        status
        createdAt
        mode
      }
    }
  }
}
    `;

/**
 * __useGetBookingPaymentForReviewQuery__
 *
 * To run a query within a React component, call `useGetBookingPaymentForReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingPaymentForReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingPaymentForReviewQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */
export function useGetBookingPaymentForReviewQuery(baseOptions: Apollo.QueryHookOptions<GetBookingPaymentForReviewQuery, GetBookingPaymentForReviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingPaymentForReviewQuery, GetBookingPaymentForReviewQueryVariables>(GetBookingPaymentForReviewDocument, options);
      }
export function useGetBookingPaymentForReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingPaymentForReviewQuery, GetBookingPaymentForReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingPaymentForReviewQuery, GetBookingPaymentForReviewQueryVariables>(GetBookingPaymentForReviewDocument, options);
        }
export type GetBookingPaymentForReviewQueryHookResult = ReturnType<typeof useGetBookingPaymentForReviewQuery>;
export type GetBookingPaymentForReviewLazyQueryHookResult = ReturnType<typeof useGetBookingPaymentForReviewLazyQuery>;
export type GetBookingPaymentForReviewQueryResult = Apollo.QueryResult<GetBookingPaymentForReviewQuery, GetBookingPaymentForReviewQueryVariables>;
export const GetDeliveryPaymentDocument = gql`
    query getDeliveryPayment($leadId: ID!) {
  getLead(id: $leadId) {
    id
    regNo
    activeBooking {
      payments {
        amount
        status
      }
      activeLoan {
        id
        appliedLoanAmount
        sanctionedLoanAmount
        createdAt
      }
      isInsuranceReq
      isRCTransferReq
      bookingPayment {
        saleAmount
        bookingType
      }
    }
  }
}
    `;

/**
 * __useGetDeliveryPaymentQuery__
 *
 * To run a query within a React component, call `useGetDeliveryPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveryPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveryPaymentQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */
export function useGetDeliveryPaymentQuery(baseOptions: Apollo.QueryHookOptions<GetDeliveryPaymentQuery, GetDeliveryPaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliveryPaymentQuery, GetDeliveryPaymentQueryVariables>(GetDeliveryPaymentDocument, options);
      }
export function useGetDeliveryPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliveryPaymentQuery, GetDeliveryPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliveryPaymentQuery, GetDeliveryPaymentQueryVariables>(GetDeliveryPaymentDocument, options);
        }
export type GetDeliveryPaymentQueryHookResult = ReturnType<typeof useGetDeliveryPaymentQuery>;
export type GetDeliveryPaymentLazyQueryHookResult = ReturnType<typeof useGetDeliveryPaymentLazyQuery>;
export type GetDeliveryPaymentQueryResult = Apollo.QueryResult<GetDeliveryPaymentQuery, GetDeliveryPaymentQueryVariables>;
export const GetPartPaymentDocument = gql`
    query getPartPayment($regNo: String!) {
  getLead(regNo: $regNo) {
    id
    regNo
    activeBooking {
      payments {
        amount
        status
      }
      activeLoan {
        id
        appliedLoanAmount
        sanctionedLoanAmount
        createdAt
      }
      isInsuranceReq
      isRCTransferReq
      bookingPayment {
        saleAmount
        bookingType
      }
    }
  }
}
    `;

/**
 * __useGetPartPaymentQuery__
 *
 * To run a query within a React component, call `useGetPartPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartPaymentQuery({
 *   variables: {
 *      regNo: // value for 'regNo'
 *   },
 * });
 */
export function useGetPartPaymentQuery(baseOptions: Apollo.QueryHookOptions<GetPartPaymentQuery, GetPartPaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartPaymentQuery, GetPartPaymentQueryVariables>(GetPartPaymentDocument, options);
      }
export function useGetPartPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartPaymentQuery, GetPartPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartPaymentQuery, GetPartPaymentQueryVariables>(GetPartPaymentDocument, options);
        }
export type GetPartPaymentQueryHookResult = ReturnType<typeof useGetPartPaymentQuery>;
export type GetPartPaymentLazyQueryHookResult = ReturnType<typeof useGetPartPaymentLazyQuery>;
export type GetPartPaymentQueryResult = Apollo.QueryResult<GetPartPaymentQuery, GetPartPaymentQueryVariables>;
export const GetBookingInforDocument = gql`
    query getBookingInfor($regNo: String!) {
  getLead(regNo: $regNo) {
    id
    regNo
    activeBooking {
      vehicleTransferFormUrl
      customer {
        customerId
        name
        phoneNo
        customerState {
          state
          id
        }
        customerDistrict @cascade(fields: "name") {
          name
        }
        identificationDocuments {
          aadhaarBackPhotoUrl
          aadhaarFrontPhotoUrl
          aadhaarNumber
          voterIdPhotoUrl
          voterIdNumber
          panNumber
          panPhotoUrl
        }
      }
      payments {
        amount
        status
      }
      activeLoan {
        id
        appliedLoanAmount
        sanctionedLoanAmount
        createdAt
      }
      isInsuranceReq
      isRCTransferReq
      bookingPayment {
        saleAmount
        bookingType
        createdAt
        appliedLoanAmount
      }
    }
  }
}
    `;

/**
 * __useGetBookingInforQuery__
 *
 * To run a query within a React component, call `useGetBookingInforQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingInforQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingInforQuery({
 *   variables: {
 *      regNo: // value for 'regNo'
 *   },
 * });
 */
export function useGetBookingInforQuery(baseOptions: Apollo.QueryHookOptions<GetBookingInforQuery, GetBookingInforQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingInforQuery, GetBookingInforQueryVariables>(GetBookingInforDocument, options);
      }
export function useGetBookingInforLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingInforQuery, GetBookingInforQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingInforQuery, GetBookingInforQueryVariables>(GetBookingInforDocument, options);
        }
export type GetBookingInforQueryHookResult = ReturnType<typeof useGetBookingInforQuery>;
export type GetBookingInforLazyQueryHookResult = ReturnType<typeof useGetBookingInforLazyQuery>;
export type GetBookingInforQueryResult = Apollo.QueryResult<GetBookingInforQuery, GetBookingInforQueryVariables>;
export const DropDocument = gql`
    query Drop($leadId: [ID!]!) {
  queryLead(filter: {id: $leadId}) {
    id
    regNo
    statusEvents(first: -1) {
      status
      remarks
    }
  }
}
    `;

/**
 * __useDropQuery__
 *
 * To run a query within a React component, call `useDropQuery` and pass it any options that fit your needs.
 * When your component renders, `useDropQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDropQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */
export function useDropQuery(baseOptions: Apollo.QueryHookOptions<DropQuery, DropQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DropQuery, DropQueryVariables>(DropDocument, options);
      }
export function useDropLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DropQuery, DropQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DropQuery, DropQueryVariables>(DropDocument, options);
        }
export type DropQueryHookResult = ReturnType<typeof useDropQuery>;
export type DropLazyQueryHookResult = ReturnType<typeof useDropLazyQuery>;
export type DropQueryResult = Apollo.QueryResult<DropQuery, DropQueryVariables>;
export const GetAllRefurbishmentBeneficiaryDocument = gql`
    query GetAllRefurbishmentBeneficiary($id: [ID!]) {
  queryRefurbishmentBeneficiary(filter: {id: $id}) {
    id
    accountHolderName
    accountNumber
    ifscCode
    bankName
    proofUrl
  }
}
    `;

/**
 * __useGetAllRefurbishmentBeneficiaryQuery__
 *
 * To run a query within a React component, call `useGetAllRefurbishmentBeneficiaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRefurbishmentBeneficiaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRefurbishmentBeneficiaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAllRefurbishmentBeneficiaryQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRefurbishmentBeneficiaryQuery, GetAllRefurbishmentBeneficiaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRefurbishmentBeneficiaryQuery, GetAllRefurbishmentBeneficiaryQueryVariables>(GetAllRefurbishmentBeneficiaryDocument, options);
      }
export function useGetAllRefurbishmentBeneficiaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRefurbishmentBeneficiaryQuery, GetAllRefurbishmentBeneficiaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRefurbishmentBeneficiaryQuery, GetAllRefurbishmentBeneficiaryQueryVariables>(GetAllRefurbishmentBeneficiaryDocument, options);
        }
export type GetAllRefurbishmentBeneficiaryQueryHookResult = ReturnType<typeof useGetAllRefurbishmentBeneficiaryQuery>;
export type GetAllRefurbishmentBeneficiaryLazyQueryHookResult = ReturnType<typeof useGetAllRefurbishmentBeneficiaryLazyQuery>;
export type GetAllRefurbishmentBeneficiaryQueryResult = Apollo.QueryResult<GetAllRefurbishmentBeneficiaryQuery, GetAllRefurbishmentBeneficiaryQueryVariables>;
export const GetLeadDetailsDocument = gql`
    query GetLeadDetails($regNo: String!) {
  getLead(regNo: $regNo) {
    statusEvents {
      assignTaskTo
      createdAt
      createdBy {
        name
      }
      id
      isTaskCompleted
      taskTitle
      task {
        id
        title
      }
      status
      assignTaskTo
    }
  }
}
    `;

/**
 * __useGetLeadDetailsQuery__
 *
 * To run a query within a React component, call `useGetLeadDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadDetailsQuery({
 *   variables: {
 *      regNo: // value for 'regNo'
 *   },
 * });
 */
export function useGetLeadDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetLeadDetailsQuery, GetLeadDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadDetailsQuery, GetLeadDetailsQueryVariables>(GetLeadDetailsDocument, options);
      }
export function useGetLeadDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadDetailsQuery, GetLeadDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadDetailsQuery, GetLeadDetailsQueryVariables>(GetLeadDetailsDocument, options);
        }
export type GetLeadDetailsQueryHookResult = ReturnType<typeof useGetLeadDetailsQuery>;
export type GetLeadDetailsLazyQueryHookResult = ReturnType<typeof useGetLeadDetailsLazyQuery>;
export type GetLeadDetailsQueryResult = Apollo.QueryResult<GetLeadDetailsQuery, GetLeadDetailsQueryVariables>;
export const RefurbishmentRequestIdDocument = gql`
    query RefurbishmentRequestId($leadId: [ID!]) {
  queryLead(filter: {id: $leadId}) {
    regNo
    listingStatus
    statusEvents {
      id
      metadata
      status
    }
    refurbishmentDetails {
      requests {
        id
      }
    }
  }
}
    `;

/**
 * __useRefurbishmentRequestIdQuery__
 *
 * To run a query within a React component, call `useRefurbishmentRequestIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefurbishmentRequestIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefurbishmentRequestIdQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */
export function useRefurbishmentRequestIdQuery(baseOptions?: Apollo.QueryHookOptions<RefurbishmentRequestIdQuery, RefurbishmentRequestIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RefurbishmentRequestIdQuery, RefurbishmentRequestIdQueryVariables>(RefurbishmentRequestIdDocument, options);
      }
export function useRefurbishmentRequestIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RefurbishmentRequestIdQuery, RefurbishmentRequestIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RefurbishmentRequestIdQuery, RefurbishmentRequestIdQueryVariables>(RefurbishmentRequestIdDocument, options);
        }
export type RefurbishmentRequestIdQueryHookResult = ReturnType<typeof useRefurbishmentRequestIdQuery>;
export type RefurbishmentRequestIdLazyQueryHookResult = ReturnType<typeof useRefurbishmentRequestIdLazyQuery>;
export type RefurbishmentRequestIdQueryResult = Apollo.QueryResult<RefurbishmentRequestIdQuery, RefurbishmentRequestIdQueryVariables>;
export const GetTaskIdDocument = gql`
    query getTaskId($userId: ID!, $role: UserRole!) {
  myPendingTasks(userId: $userId, role: $role) {
    id
    createdAt
    createdBy {
      id
      name
      email
    }
    status
    assignTaskTo
    lead {
      id
      regNo
      createdBy {
        id
      }
    }
  }
}
    `;

/**
 * __useGetTaskIdQuery__
 *
 * To run a query within a React component, call `useGetTaskIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useGetTaskIdQuery(baseOptions: Apollo.QueryHookOptions<GetTaskIdQuery, GetTaskIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskIdQuery, GetTaskIdQueryVariables>(GetTaskIdDocument, options);
      }
export function useGetTaskIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskIdQuery, GetTaskIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskIdQuery, GetTaskIdQueryVariables>(GetTaskIdDocument, options);
        }
export type GetTaskIdQueryHookResult = ReturnType<typeof useGetTaskIdQuery>;
export type GetTaskIdLazyQueryHookResult = ReturnType<typeof useGetTaskIdLazyQuery>;
export type GetTaskIdQueryResult = Apollo.QueryResult<GetTaskIdQuery, GetTaskIdQueryVariables>;
export const AllCentresDocument = gql`
    query AllCentres {
  queryCentre(filter: {status: {eq: ACTIVE}}) {
    id
    name
    location {
      longitude
      latitude
    }
    incharge {
      id
      name
      email
      centre {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useAllCentresQuery__
 *
 * To run a query within a React component, call `useAllCentresQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCentresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCentresQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllCentresQuery(baseOptions?: Apollo.QueryHookOptions<AllCentresQuery, AllCentresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCentresQuery, AllCentresQueryVariables>(AllCentresDocument, options);
      }
export function useAllCentresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCentresQuery, AllCentresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCentresQuery, AllCentresQueryVariables>(AllCentresDocument, options);
        }
export type AllCentresQueryHookResult = ReturnType<typeof useAllCentresQuery>;
export type AllCentresLazyQueryHookResult = ReturnType<typeof useAllCentresLazyQuery>;
export type AllCentresQueryResult = Apollo.QueryResult<AllCentresQuery, AllCentresQueryVariables>;
export const GetAllYardDocument = gql`
    query GetAllYard {
  queryYard(filter: {has: name}) {
    id
    name
    perDayParkingCharge
    tempPerDayParkingCharge
    address
    spocName
    spocNo
    city
    locationUrl
    location {
      longitude
      latitude
    }
  }
}
    `;

/**
 * __useGetAllYardQuery__
 *
 * To run a query within a React component, call `useGetAllYardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllYardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllYardQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllYardQuery(baseOptions?: Apollo.QueryHookOptions<GetAllYardQuery, GetAllYardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllYardQuery, GetAllYardQueryVariables>(GetAllYardDocument, options);
      }
export function useGetAllYardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllYardQuery, GetAllYardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllYardQuery, GetAllYardQueryVariables>(GetAllYardDocument, options);
        }
export type GetAllYardQueryHookResult = ReturnType<typeof useGetAllYardQuery>;
export type GetAllYardLazyQueryHookResult = ReturnType<typeof useGetAllYardLazyQuery>;
export type GetAllYardQueryResult = Apollo.QueryResult<GetAllYardQuery, GetAllYardQueryVariables>;
export const UpdateLeadDocument = gql`
    mutation updateLead($leadId: ID!, $leadPatch: LeadPatch!, $regNo: StringHashFilter_StringRegExpFilter_StringTermFilter!) {
  updateLead(input: {filter: {id: [$leadId]}, set: $leadPatch}) {
    lead(filter: {regNo: $regNo}) {
      id
      regNo
      listingPrice
    }
  }
}
    `;
export type UpdateLeadMutationFn = Apollo.MutationFunction<UpdateLeadMutation, UpdateLeadMutationVariables>;

/**
 * __useUpdateLeadMutation__
 *
 * To run a mutation, you first call `useUpdateLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeadMutation, { data, loading, error }] = useUpdateLeadMutation({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      leadPatch: // value for 'leadPatch'
 *      regNo: // value for 'regNo'
 *   },
 * });
 */
export function useUpdateLeadMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeadMutation, UpdateLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeadMutation, UpdateLeadMutationVariables>(UpdateLeadDocument, options);
      }
export type UpdateLeadMutationHookResult = ReturnType<typeof useUpdateLeadMutation>;
export type UpdateLeadMutationResult = Apollo.MutationResult<UpdateLeadMutation>;
export type UpdateLeadMutationOptions = Apollo.BaseMutationOptions<UpdateLeadMutation, UpdateLeadMutationVariables>;
export const UpdateListingStatusOnVmsDocument = gql`
    mutation updateListingStatusOnVMS($leadId: ID!, $leadPatch: LeadPatch!, $regNo: StringHashFilter_StringRegExpFilter_StringTermFilter!) {
  updateLead(input: {filter: {id: [$leadId]}, set: $leadPatch}) {
    lead(filter: {regNo: $regNo}) {
      id
      regNo
      listingPrice
    }
  }
}
    `;
export type UpdateListingStatusOnVmsMutationFn = Apollo.MutationFunction<UpdateListingStatusOnVmsMutation, UpdateListingStatusOnVmsMutationVariables>;

/**
 * __useUpdateListingStatusOnVmsMutation__
 *
 * To run a mutation, you first call `useUpdateListingStatusOnVmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListingStatusOnVmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListingStatusOnVmsMutation, { data, loading, error }] = useUpdateListingStatusOnVmsMutation({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      leadPatch: // value for 'leadPatch'
 *      regNo: // value for 'regNo'
 *   },
 * });
 */
export function useUpdateListingStatusOnVmsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListingStatusOnVmsMutation, UpdateListingStatusOnVmsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListingStatusOnVmsMutation, UpdateListingStatusOnVmsMutationVariables>(UpdateListingStatusOnVmsDocument, options);
      }
export type UpdateListingStatusOnVmsMutationHookResult = ReturnType<typeof useUpdateListingStatusOnVmsMutation>;
export type UpdateListingStatusOnVmsMutationResult = Apollo.MutationResult<UpdateListingStatusOnVmsMutation>;
export type UpdateListingStatusOnVmsMutationOptions = Apollo.BaseMutationOptions<UpdateListingStatusOnVmsMutation, UpdateListingStatusOnVmsMutationVariables>;
export const AddLogsDocument = gql`
    mutation addLogs($taskPerformedBy: UserRef!, $actionType: ActionType!, $createdAt: DateTime!, $module: ModuleType!, $sourceUpdated: String!, $updatedValue: String!, $previousValue: String!, $status: TaskStatus) {
  addLogTracking(
    input: {taskPerformedBy: $taskPerformedBy, actionType: $actionType, createdAt: $createdAt, source: ADMIN_PANEL, module: $module, sourceUpdated: $sourceUpdated, updatedValue: $updatedValue, previousValue: $previousValue, status: $status}
  ) {
    numUids
  }
}
    `;
export type AddLogsMutationFn = Apollo.MutationFunction<AddLogsMutation, AddLogsMutationVariables>;

/**
 * __useAddLogsMutation__
 *
 * To run a mutation, you first call `useAddLogsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLogsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLogsMutation, { data, loading, error }] = useAddLogsMutation({
 *   variables: {
 *      taskPerformedBy: // value for 'taskPerformedBy'
 *      actionType: // value for 'actionType'
 *      createdAt: // value for 'createdAt'
 *      module: // value for 'module'
 *      sourceUpdated: // value for 'sourceUpdated'
 *      updatedValue: // value for 'updatedValue'
 *      previousValue: // value for 'previousValue'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useAddLogsMutation(baseOptions?: Apollo.MutationHookOptions<AddLogsMutation, AddLogsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLogsMutation, AddLogsMutationVariables>(AddLogsDocument, options);
      }
export type AddLogsMutationHookResult = ReturnType<typeof useAddLogsMutation>;
export type AddLogsMutationResult = Apollo.MutationResult<AddLogsMutation>;
export type AddLogsMutationOptions = Apollo.BaseMutationOptions<AddLogsMutation, AddLogsMutationVariables>;
export const AddVehicleImagesDocument = gql`
    mutation AddVehicleImages($input: AddVehicleImagesInput!) {
  addVehicleImages(input: [$input], upsert: true) {
    vehicleImages {
      ...VehicleImagesDetails
      vehicle {
        id
      }
    }
  }
}
    ${VehicleImagesDetailsFragmentDoc}`;
export type AddVehicleImagesMutationFn = Apollo.MutationFunction<AddVehicleImagesMutation, AddVehicleImagesMutationVariables>;

/**
 * __useAddVehicleImagesMutation__
 *
 * To run a mutation, you first call `useAddVehicleImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVehicleImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVehicleImagesMutation, { data, loading, error }] = useAddVehicleImagesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddVehicleImagesMutation(baseOptions?: Apollo.MutationHookOptions<AddVehicleImagesMutation, AddVehicleImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddVehicleImagesMutation, AddVehicleImagesMutationVariables>(AddVehicleImagesDocument, options);
      }
export type AddVehicleImagesMutationHookResult = ReturnType<typeof useAddVehicleImagesMutation>;
export type AddVehicleImagesMutationResult = Apollo.MutationResult<AddVehicleImagesMutation>;
export type AddVehicleImagesMutationOptions = Apollo.BaseMutationOptions<AddVehicleImagesMutation, AddVehicleImagesMutationVariables>;
export const YardlistDocument = gql`
    query yardlist {
  queryYard {
    name
    city
    id
    spocName
    locationUrl
    address
    spocNo
  }
}
    `;

/**
 * __useYardlistQuery__
 *
 * To run a query within a React component, call `useYardlistQuery` and pass it any options that fit your needs.
 * When your component renders, `useYardlistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useYardlistQuery({
 *   variables: {
 *   },
 * });
 */
export function useYardlistQuery(baseOptions?: Apollo.QueryHookOptions<YardlistQuery, YardlistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<YardlistQuery, YardlistQueryVariables>(YardlistDocument, options);
      }
export function useYardlistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<YardlistQuery, YardlistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<YardlistQuery, YardlistQueryVariables>(YardlistDocument, options);
        }
export type YardlistQueryHookResult = ReturnType<typeof useYardlistQuery>;
export type YardlistLazyQueryHookResult = ReturnType<typeof useYardlistLazyQuery>;
export type YardlistQueryResult = Apollo.QueryResult<YardlistQuery, YardlistQueryVariables>;
export const YardlistValueDocument = gql`
    query yardlistValue($name: [String]) {
  queryYard(filter: {name: {in: $name}}) {
    name
    city
    id
    spocName
    locationUrl
    address
    spocNo
  }
}
    `;

/**
 * __useYardlistValueQuery__
 *
 * To run a query within a React component, call `useYardlistValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useYardlistValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useYardlistValueQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useYardlistValueQuery(baseOptions?: Apollo.QueryHookOptions<YardlistValueQuery, YardlistValueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<YardlistValueQuery, YardlistValueQueryVariables>(YardlistValueDocument, options);
      }
export function useYardlistValueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<YardlistValueQuery, YardlistValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<YardlistValueQuery, YardlistValueQueryVariables>(YardlistValueDocument, options);
        }
export type YardlistValueQueryHookResult = ReturnType<typeof useYardlistValueQuery>;
export type YardlistValueLazyQueryHookResult = ReturnType<typeof useYardlistValueLazyQuery>;
export type YardlistValueQueryResult = Apollo.QueryResult<YardlistValueQuery, YardlistValueQueryVariables>;
export const FormDataDocument = gql`
    query formData($regNo: String) {
  queryLead(filter: {regNo: {allofterms: $regNo}}) {
    id
    centre {
      name
      id
    }
    regNo
    source
    ownershipType
    demandAmount
    vehicle {
      hoursMeter
      vehicleBrand {
        name
      }
      vehicleModel {
        name
      }
      manufacturingDate
      images {
        id
        inspectionVideoUrl
        frontLeftTyre
        frontRightTyre
        backRightTyre
        backLeftTyre
        odometer
        frontBodySide
        backBodySide
        leftBodySide
        rightBodySide
        fuelInjectionPumpPlate
        odometer
        chassisNumber
        engineNumber
      }
    }
  }
}
    `;

/**
 * __useFormDataQuery__
 *
 * To run a query within a React component, call `useFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormDataQuery({
 *   variables: {
 *      regNo: // value for 'regNo'
 *   },
 * });
 */
export function useFormDataQuery(baseOptions?: Apollo.QueryHookOptions<FormDataQuery, FormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormDataQuery, FormDataQueryVariables>(FormDataDocument, options);
      }
export function useFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormDataQuery, FormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormDataQuery, FormDataQueryVariables>(FormDataDocument, options);
        }
export type FormDataQueryHookResult = ReturnType<typeof useFormDataQuery>;
export type FormDataLazyQueryHookResult = ReturnType<typeof useFormDataLazyQuery>;
export type FormDataQueryResult = Apollo.QueryResult<FormDataQuery, FormDataQueryVariables>;
export const CheckStatusDocument = gql`
    query checkStatus($status: [LeadStatus]) {
  filteredLeads(leadFilters: {hasStatus: $status}) {
    id
    regNo
  }
}
    `;

/**
 * __useCheckStatusQuery__
 *
 * To run a query within a React component, call `useCheckStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckStatusQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useCheckStatusQuery(baseOptions?: Apollo.QueryHookOptions<CheckStatusQuery, CheckStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckStatusQuery, CheckStatusQueryVariables>(CheckStatusDocument, options);
      }
export function useCheckStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckStatusQuery, CheckStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckStatusQuery, CheckStatusQueryVariables>(CheckStatusDocument, options);
        }
export type CheckStatusQueryHookResult = ReturnType<typeof useCheckStatusQuery>;
export type CheckStatusLazyQueryHookResult = ReturnType<typeof useCheckStatusLazyQuery>;
export type CheckStatusQueryResult = Apollo.QueryResult<CheckStatusQuery, CheckStatusQueryVariables>;